import { openBlock as N, createElementBlock as j, createElementVNode as _, defineComponent as vr, inject as ke, reactive as Kn, ref as Ee, h as Kt, provide as Ge, onMounted as pi, nextTick as ao, onUnmounted as Do, computed as Y, watch as qr, cloneVNode as Pu, Fragment as De, normalizeStyle as qe, unref as m, createVNode as ae, createCommentVNode as se, renderList as wt, withCtx as Se, createBlock as Ne, normalizeClass as Pe, toDisplayString as he, renderSlot as an, getCurrentScope as Kx, onScopeDispose as Yx, withKeys as Us, useSlots as qx, createTextVNode as Ea, Transition as br, withDirectives as Ke, vShow as tt, resolveComponent as Pt, withModifiers as q1, watchEffect as Ll, defineAsyncComponent as Z1, createStaticVNode as Fo, TransitionGroup as J1, getCurrentInstance as Bd, shallowRef as Zx, onBeforeMount as Jx, Text as Xx, isRef as Qo, vModelSelect as el, Teleport as x0, pushScopeId as Qx, popScopeId as eb } from "vue";
import tb from "./assets/4d1aa2eb809db2c6.jpg";
import rb from "./assets/75e537293afdf3a8.jpeg";
import nb from "./assets/4c747951540ee722.jpeg";
import ib from "./assets/63de25d2af06e6a7.jpeg";
import sb from "./assets/beb43cb85f0ca980.jpeg";
import ab from "./assets/3b0f3093a6354eee.jpeg";
function ob(r, e) {
  for (var t = 0; t < e.length; t++) {
    const n = e[t];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in r)) {
          const s = Object.getOwnPropertyDescriptor(n, i);
          s && Object.defineProperty(r, i, s.get ? s : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }));
}
function lb(r, e) {
  return N(), j("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z",
      "clip-rule": "evenodd"
    })
  ]);
}
/**
 * Vue 3 Carousel 0.3.1
 * (c) 2023
 * @license MIT
 */
const or = {
  itemsToShow: 1,
  itemsToScroll: 1,
  modelValue: 0,
  transition: 300,
  autoplay: 0,
  snapAlign: "center",
  wrapAround: !1,
  throttle: 16,
  pauseAutoplayOnHover: !1,
  mouseDrag: !0,
  touchDrag: !0,
  dir: "ltr",
  breakpoints: void 0,
  i18n: {
    ariaNextSlide: "Navigate to next slide",
    ariaPreviousSlide: "Navigate to previous slide",
    ariaNavigateToSlide: "Navigate to slide {slideNumber}",
    ariaGallery: "Gallery",
    itemXofY: "Item {currentSlide} of {slidesCount}",
    iconArrowUp: "Arrow pointing upwards",
    iconArrowDown: "Arrow pointing downwards",
    iconArrowRight: "Arrow pointing to the right",
    iconArrowLeft: "Arrow pointing to the left"
  }
}, b0 = {
  // count of items to showed per view
  itemsToShow: {
    default: or.itemsToShow,
    type: Number
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: or.itemsToScroll,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: or.wrapAround,
    type: Boolean
  },
  // control max drag
  throttle: {
    default: or.throttle,
    type: Number
  },
  // control snap position alignment
  snapAlign: {
    default: or.snapAlign,
    validator(r) {
      return ["start", "end", "center", "center-even", "center-odd"].includes(r);
    }
  },
  // sliding transition time in ms
  transition: {
    default: or.transition,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: or.breakpoints,
    type: Object
  },
  // time to auto advance slides in ms
  autoplay: {
    default: or.autoplay,
    type: Number
  },
  // pause autoplay when mouse hover over the carousel
  pauseAutoplayOnHover: {
    default: or.pauseAutoplayOnHover,
    type: Boolean
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging.
  mouseDrag: {
    default: or.mouseDrag,
    type: Boolean
  },
  // toggle mouse dragging.
  touchDrag: {
    default: or.touchDrag,
    type: Boolean
  },
  // control snap position alignment
  dir: {
    default: or.dir,
    validator(r) {
      return ["rtl", "ltr"].includes(r);
    }
  },
  // aria-labels and additional text labels
  i18n: {
    default: or.i18n,
    type: Object
  },
  // an object to pass all settings
  settings: {
    default() {
      return {};
    },
    type: Object
  }
};
function cb({ config: r, slidesCount: e }) {
  const { snapAlign: t, wrapAround: n, itemsToShow: i = 1 } = r;
  if (n)
    return Math.max(e - 1, 0);
  let s;
  switch (t) {
    case "start":
      s = e - i;
      break;
    case "end":
      s = e - 1;
      break;
    case "center":
    case "center-odd":
      s = e - Math.ceil((i - 0.5) / 2);
      break;
    case "center-even":
      s = e - Math.ceil(i / 2);
      break;
    default:
      s = 0;
      break;
  }
  return Math.max(s, 0);
}
function ub({ config: r, slidesCount: e }) {
  const { wrapAround: t, snapAlign: n, itemsToShow: i = 1 } = r;
  let s = 0;
  if (t || i > e)
    return s;
  switch (n) {
    case "start":
      s = 0;
      break;
    case "end":
      s = i - 1;
      break;
    case "center":
    case "center-odd":
      s = Math.floor((i - 1) / 2);
      break;
    case "center-even":
      s = Math.floor((i - 2) / 2);
      break;
    default:
      s = 0;
      break;
  }
  return s;
}
function ku({ val: r, max: e, min: t }) {
  return e < t ? r : Math.min(Math.max(r, t), e);
}
function db({ config: r, currentSlide: e, slidesCount: t }) {
  const { snapAlign: n, wrapAround: i, itemsToShow: s = 1 } = r;
  let a = e;
  switch (n) {
    case "center":
    case "center-odd":
      a -= (s - 1) / 2;
      break;
    case "center-even":
      a -= (s - 2) / 2;
      break;
    case "end":
      a -= s - 1;
      break;
  }
  return i ? a : ku({
    val: a,
    max: t - s,
    min: 0
  });
}
function X1(r) {
  return r ? r.reduce((e, t) => {
    var n;
    return t.type === De ? [...e, ...X1(t.children)] : ((n = t.type) === null || n === void 0 ? void 0 : n.name) === "CarouselSlide" ? [...e, t] : e;
  }, []) : [];
}
function Dl({ val: r, max: e, min: t = 0 }) {
  return r > e ? Dl({ val: r - (e + 1), max: e, min: t }) : r < t ? Dl({ val: r + (e + 1), max: e, min: t }) : r;
}
function fb(r, e) {
  let t;
  return e ? function(...n) {
    const i = this;
    t || (r.apply(i, n), t = !0, setTimeout(() => t = !1, e));
  } : r;
}
function hb(r, e) {
  let t;
  return function(...n) {
    t && clearTimeout(t), t = setTimeout(() => {
      r(...n), t = null;
    }, e);
  };
}
function Q1(r = "", e = {}) {
  return Object.entries(e).reduce((t, [n, i]) => t.replace(`{${n}}`, String(i)), r);
}
var pb = vr({
  name: "ARIA",
  setup() {
    const r = ke("config", Kn(Object.assign({}, or))), e = ke("currentSlide", Ee(0)), t = ke("slidesCount", Ee(0));
    return () => Kt("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, Q1(r.i18n.itemXofY, {
      currentSlide: e.value + 1,
      slidesCount: t.value
    }));
  }
}), mb = vr({
  name: "Carousel",
  props: b0,
  setup(r, { slots: e, emit: t, expose: n }) {
    var i;
    const s = Ee(null), a = Ee([]), o = Ee(0), l = Ee(0), c = Kn(Object.assign({}, or));
    let u = Object.assign({}, or), f;
    const p = Ee((i = r.modelValue) !== null && i !== void 0 ? i : 0), x = Ee(0), T = Ee(0), v = Ee(0), w = Ee(0);
    let E, C;
    Ge("config", c), Ge("slidesCount", l), Ge("currentSlide", p), Ge("maxSlide", v), Ge("minSlide", w), Ge("slideWidth", o);
    function P() {
      f = Object.assign({}, r.breakpoints), u = Object.assign(Object.assign(Object.assign({}, u), r), { i18n: Object.assign(Object.assign({}, u.i18n), r.i18n), breakpoints: void 0 }), k(u);
    }
    function F() {
      if (!f || !Object.keys(f).length)
        return;
      const A = Object.keys(f).map((de) => Number(de)).sort((de, xe) => +xe - +de);
      let $ = Object.assign({}, u);
      A.some((de) => {
        const xe = window.matchMedia(`(min-width: ${de}px)`).matches;
        return xe && ($ = Object.assign(Object.assign({}, $), f[de])), xe;
      }), k($);
    }
    function k(A) {
      Object.entries(A).forEach(([$, de]) => c[$] = de);
    }
    const K = hb(() => {
      F(), Z();
    }, 16);
    function Z() {
      if (!s.value)
        return;
      const A = s.value.getBoundingClientRect();
      o.value = A.width / c.itemsToShow;
    }
    function ne() {
      l.value <= 0 || (T.value = Math.ceil((l.value - 1) / 2), v.value = cb({ config: c, slidesCount: l.value }), w.value = ub({ config: c, slidesCount: l.value }), c.wrapAround || (p.value = ku({
        val: p.value,
        max: v.value,
        min: w.value
      })));
    }
    pi(() => {
      ao(() => Z()), setTimeout(() => Z(), 1e3), F(), q(), window.addEventListener("resize", K, { passive: !0 }), t("init");
    }), Do(() => {
      C && clearTimeout(C), E && clearInterval(E), window.removeEventListener("resize", K, {
        passive: !0
      });
    });
    let le = !1;
    const ye = { x: 0, y: 0 }, ge = { x: 0, y: 0 }, _e = Kn({ x: 0, y: 0 }), L = Ee(!1), d = Ee(!1), b = () => {
      L.value = !0;
    }, S = () => {
      L.value = !1;
    };
    function R(A) {
      ["INPUT", "TEXTAREA", "SELECT"].includes(A.target.tagName) || (le = A.type === "touchstart", le || A.preventDefault(), !(!le && A.button !== 0 || h.value) && (ye.x = le ? A.touches[0].clientX : A.clientX, ye.y = le ? A.touches[0].clientY : A.clientY, document.addEventListener(le ? "touchmove" : "mousemove", D, !0), document.addEventListener(le ? "touchend" : "mouseup", z, !0)));
    }
    const D = fb((A) => {
      d.value = !0, ge.x = le ? A.touches[0].clientX : A.clientX, ge.y = le ? A.touches[0].clientY : A.clientY;
      const $ = ge.x - ye.x, de = ge.y - ye.y;
      _e.y = de, _e.x = $;
    }, c.throttle);
    function z() {
      const A = c.dir === "rtl" ? -1 : 1, $ = Math.sign(_e.x) * 0.4, de = Math.round(_e.x / o.value + $) * A;
      if (de && !le) {
        const xe = (Ae) => {
          Ae.stopPropagation(), window.removeEventListener("click", xe, !0);
        };
        window.addEventListener("click", xe, !0);
      }
      I(p.value - de), _e.x = 0, _e.y = 0, d.value = !1, document.removeEventListener(le ? "touchmove" : "mousemove", D, !0), document.removeEventListener(le ? "touchend" : "mouseup", z, !0);
    }
    function q() {
      !c.autoplay || c.autoplay <= 0 || (E = setInterval(() => {
        c.pauseAutoplayOnHover && L.value || V();
      }, c.autoplay));
    }
    function y() {
      E && (clearInterval(E), E = null), q();
    }
    const h = Ee(!1);
    function I(A) {
      const $ = c.wrapAround ? A : ku({
        val: A,
        max: v.value,
        min: w.value
      });
      p.value === $ || h.value || (t("slide-start", {
        slidingToIndex: A,
        currentSlideIndex: p.value,
        prevSlideIndex: x.value,
        slidesCount: l.value
      }), h.value = !0, x.value = p.value, p.value = $, C = setTimeout(() => {
        if (c.wrapAround) {
          const de = Dl({
            val: $,
            max: v.value,
            min: 0
          });
          de !== p.value && (p.value = de, t("loop", {
            currentSlideIndex: p.value,
            slidingToIndex: A
          }));
        }
        t("update:modelValue", p.value), t("slide-end", {
          currentSlideIndex: p.value,
          prevSlideIndex: x.value,
          slidesCount: l.value
        }), h.value = !1, y();
      }, c.transition));
    }
    function V() {
      I(p.value + c.itemsToScroll);
    }
    function g() {
      I(p.value - c.itemsToScroll);
    }
    const G = { slideTo: I, next: V, prev: g };
    Ge("nav", G), Ge("isSliding", h);
    const Q = Y(() => db({
      config: c,
      currentSlide: p.value,
      slidesCount: l.value
    }));
    Ge("slidesToScroll", Q);
    const J = Y(() => {
      const A = c.dir === "rtl" ? -1 : 1, $ = Q.value * o.value * A;
      return {
        transform: `translateX(${_e.x - $}px)`,
        transition: `${h.value ? c.transition : 0}ms`,
        margin: c.wrapAround ? `0 -${l.value * o.value}px` : "",
        width: "100%"
      };
    });
    function X() {
      P(), F(), ne(), Z(), y();
    }
    Object.keys(b0).forEach((A) => {
      ["modelValue"].includes(A) || qr(() => r[A], X);
    }), qr(() => r.modelValue, (A) => {
      A !== p.value && I(Number(A));
    }), qr(l, ne), t("before-init"), P();
    const pe = {
      config: c,
      slidesCount: l,
      slideWidth: o,
      next: V,
      prev: g,
      slideTo: I,
      currentSlide: p,
      maxSlide: v,
      minSlide: w,
      middleSlide: T
    };
    n({
      updateBreakpointsConfigs: F,
      updateSlidesData: ne,
      updateSlideWidth: Z,
      initDefaultConfigs: P,
      restartCarousel: X,
      slideTo: I,
      next: V,
      prev: g,
      nav: G,
      data: pe
    });
    const ce = e.default || e.slides, ue = e.addons, B = Kn(pe);
    return () => {
      const A = X1(ce == null ? void 0 : ce(B)), $ = (ue == null ? void 0 : ue(B)) || [];
      A.forEach((ut, Le) => ut.props.index = Le);
      let de = A;
      if (c.wrapAround) {
        const ut = A.map((Re, Me) => Pu(Re, {
          index: -A.length + Me,
          isClone: !0,
          key: `clone-before-${Me}`
        })), Le = A.map((Re, Me) => Pu(Re, {
          index: A.length + Me,
          isClone: !0,
          key: `clone-after-${Me}`
        }));
        de = [...ut, ...A, ...Le];
      }
      a.value = A, l.value = Math.max(A.length, 1);
      const xe = Kt("ol", {
        class: "carousel__track",
        style: J.value,
        onMousedownCapture: c.mouseDrag ? R : null,
        onTouchstartPassiveCapture: c.touchDrag ? R : null
      }, de), Ae = Kt("div", { class: "carousel__viewport" }, xe);
      return Kt("section", {
        ref: s,
        class: {
          carousel: !0,
          "is-sliding": h.value,
          "is-dragging": d.value,
          "is-hover": L.value,
          "carousel--rtl": c.dir === "rtl"
        },
        dir: c.dir,
        "aria-label": c.i18n.ariaGallery,
        tabindex: "0",
        onMouseenter: b,
        onMouseleave: S
      }, [Ae, $, Kt(pb)]);
    };
  }
}), Ou;
(function(r) {
  r.arrowUp = "arrowUp", r.arrowDown = "arrowDown", r.arrowRight = "arrowRight", r.arrowLeft = "arrowLeft";
})(Ou || (Ou = {}));
const gb = {
  arrowUp: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z",
  arrowDown: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
  arrowRight: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z",
  arrowLeft: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
};
function xb(r) {
  return r in Ou;
}
const Nu = (r) => {
  const e = ke("config", Kn(Object.assign({}, or))), t = String(r.name), n = `icon${t.charAt(0).toUpperCase() + t.slice(1)}`;
  if (!t || typeof t != "string" || !xb(t))
    return;
  const i = gb[t], s = Kt("path", { d: i }), a = e.i18n[n] || r.title || t, o = Kt("title", a);
  return Kt("svg", {
    class: "carousel__icon",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": a
  }, [o, s]);
};
Nu.props = { name: String, title: String };
const bb = (r, { slots: e, attrs: t }) => {
  const { next: n, prev: i } = e || {}, s = ke("config", Kn(Object.assign({}, or))), a = ke("maxSlide", Ee(1)), o = ke("minSlide", Ee(1)), l = ke("currentSlide", Ee(1)), c = ke("nav", {}), { dir: u, wrapAround: f, i18n: p } = s, x = u === "rtl", T = Kt("button", {
    type: "button",
    class: [
      "carousel__prev",
      !f && l.value <= o.value && "carousel__prev--disabled",
      t == null ? void 0 : t.class
    ],
    "aria-label": p.ariaPreviousSlide,
    onClick: c.prev
  }, (i == null ? void 0 : i()) || Kt(Nu, { name: x ? "arrowRight" : "arrowLeft" })), v = Kt("button", {
    type: "button",
    class: [
      "carousel__next",
      !f && l.value >= a.value && "carousel__next--disabled",
      t == null ? void 0 : t.class
    ],
    "aria-label": p.ariaNextSlide,
    onClick: c.next
  }, (n == null ? void 0 : n()) || Kt(Nu, { name: x ? "arrowLeft" : "arrowRight" }));
  return [T, v];
}, vb = () => {
  const r = ke("config", Kn(Object.assign({}, or))), e = ke("maxSlide", Ee(1)), t = ke("minSlide", Ee(1)), n = ke("currentSlide", Ee(1)), i = ke("nav", {}), s = (o) => Dl({
    val: n.value,
    max: e.value,
    min: 0
  }) === o, a = [];
  for (let o = t.value; o < e.value + 1; o++) {
    const l = Kt("button", {
      type: "button",
      class: {
        "carousel__pagination-button": !0,
        "carousel__pagination-button--active": s(o)
      },
      "aria-label": Q1(r.i18n.ariaNavigateToSlide, {
        slideNumber: o + 1
      }),
      onClick: () => i.slideTo(o)
    }), c = Kt("li", { class: "carousel__pagination-item", key: o }, l);
    a.push(c);
  }
  return Kt("ol", { class: "carousel__pagination" }, a);
};
var Dc = vr({
  name: "CarouselSlide",
  props: {
    index: {
      type: Number,
      default: 1
    },
    isClone: {
      type: Boolean,
      default: !1
    }
  },
  setup(r, { slots: e }) {
    const t = ke("config", Kn(Object.assign({}, or))), n = ke("currentSlide", Ee(0)), i = ke("slidesToScroll", Ee(0)), s = ke("isSliding", Ee(!1)), a = () => r.index === n.value, o = () => r.index === n.value - 1, l = () => r.index === n.value + 1, c = () => {
      const u = Math.floor(i.value), f = Math.ceil(i.value + t.itemsToShow - 1);
      return r.index >= u && r.index <= f;
    };
    return () => {
      var u;
      return Kt("li", {
        style: { width: `${100 / t.itemsToShow}%` },
        class: {
          carousel__slide: !0,
          "carousel__slide--clone": r.isClone,
          "carousel__slide--visible": c(),
          "carousel__slide--active": a(),
          "carousel__slide--prev": o(),
          "carousel__slide--next": l(),
          "carousel__slide--sliding": s.value
        },
        "aria-hidden": !c()
      }, (u = e.default) === null || u === void 0 ? void 0 : u.call(e));
    };
  }
});
const Vt = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [n, i] of e)
    t[n] = i;
  return t;
}, yb = {}, wb = {
  class: "spinner",
  viewBox: "0 0 50 50"
}, _b = /* @__PURE__ */ _("circle", {
  class: "path",
  cx: "25",
  cy: "25",
  r: "15",
  fill: "none",
  "stroke-width": "4"
}, null, -1), Eb = [
  _b
];
function Ab(r, e) {
  return N(), j("svg", wb, Eb);
}
const Cn = /* @__PURE__ */ Vt(yb, [["render", Ab]]), Sb = {
  key: 0,
  class: "absolute h-full w-full top-0 left-0 z-10 bg-white flex items-center justify-center opacity-75",
  style: { "{min-height": "60px" }
}, Tb = ["src"], v0 = /* @__PURE__ */ vr({
  __name: "Renderer",
  props: {
    previewUrl: {
      type: String,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    isThumbnail: {
      type: Boolean,
      default: !1
    }
  },
  setup(r) {
    const e = r, { renderIsLoading: t } = ke("renderer"), n = Y(() => [{ "max-height": e.isMobile ? "250px" : "500px" }]), i = Y(() => [{ "min-height": e.isThumbnail ? "none" : e.isMobile ? "250px" : "500px" }]);
    return (s, a) => (N(), j("div", {
      class: "relative flex items-center",
      style: qe(m(i))
    }, [
      m(t) ? (N(), j("div", Sb, [
        ae(m(Cn), { style: {
          position: "absolute",
          top: "50%",
          left: "50%",
          margin: "-25px 0 0 -25px",
          width: "50px",
          height: "50px"
        } })
      ])) : se("", !0),
      _("img", {
        class: "h-auto w-auto max-w-full m-auto",
        style: qe(m(n)),
        src: r.previewUrl,
        onLoad: a[0] || (a[0] = (o) => t.value = !1)
      }, null, 44, Tb)
    ], 4));
  }
}), ep = "T", Mb = "CSCP", Ib = "CFPP", Cb = "PP", Pb = "INCP", On = "PFFP", jr = "PFS", nn = "PFRM", _o = "PFMP", Eo = "PFWP", ks = "PFAP", Aa = "PFPP", Cr = 1, ba = 2, Fl = 3, kb = { class: "grid grid-cols-12 md:gap-x-4" }, Ob = { class: "hidden md:block md:col-span-1" }, Nb = { class: "flex flex-col relative cursor-pointer" }, Rb = ["onClick"], Lb = { class: "mb-3 w-full pt-full" }, Db = ["alt", "src"], Fb = { class: "mb-3 w-full" }, Bb = { class: "mb-3 w-full pt-full" }, jb = ["src"], Ub = { class: "col-span-12 md:col-span-11" }, zb = { class: "carousel__item" }, Wb = ["alt", "src"], Hb = { class: "carousel__item relative flex justify-center items-center" }, Vb = ["src"], $b = { class: "hidden md:block" }, Gb = /* @__PURE__ */ vr({
  __name: "Carousel",
  props: {
    images: {
      type: Object,
      default: null
    },
    selectedImages: {
      type: Object,
      default: null
    },
    selectedPrintOption: {
      type: Number,
      default: null
    },
    frame: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    previewUrl: {
      type: String,
      default: null
    },
    productSlug: {
      type: String,
      default: null
    },
    finishKit: {
      type: String,
      default: null
    },
    isReadyMadeProduct: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    isEcommerce: {
      type: Boolean,
      default: !1
    }
  },
  setup(r) {
    const e = r;
    Ee({});
    const t = Ee(0);
    e.images && !e.isEcommerce && (t.value = Object.keys(e.images).length);
    const n = (f) => {
      t.value = f;
    }, i = Ee(!1);
    qr(() => e.selectedPrintOption, (f, p) => {
      i.value = !1, ao(() => {
        i.value = !0;
      });
    });
    const s = Y(() => {
      const f = e.selectedImages.pane_1.width, p = e.selectedImages.pane_1.height;
      let x;
      return f > p ? "text-3xl" : (x = p / f, x <= 1 ? "text-5xl" : x <= 2 ? "text-3xl" : "text-lg");
    }), a = Y(() => {
      switch (e.productSlug) {
        case jr:
        default:
          return tb;
        case _o:
          return rb;
        case Eo:
          return nb;
        case Aa:
          return ib;
        case ks:
          return e.finishKit === "CLAP1" ? sb : ab;
      }
    }), o = Y(() => e.selectedImages !== null && !l.value && e.selectedPrintOption === Cr && !c.value && !u.value), { renderIsLoading: l } = ke("renderer"), c = ke("substrateOnlyProduct"), u = ke("isCanvasProductWithoutFrame");
    return (f, p) => (N(), j("div", kb, [
      _("div", Ob, [
        _("div", Nb, [
          (N(!0), j(De, null, wt(r.images, (x, T) => (N(), j("div", {
            class: "relative",
            onClick: (v) => n(T)
          }, [
            _("div", Lb, [
              _("img", {
                class: "w-full h-auto absolute inset-0 m-auto",
                alt: x.altText,
                src: x.path
              }, null, 8, Db)
            ])
          ], 8, Rb))), 256)),
          r.previewUrl && !r.isReadyMadeProduct ? (N(), j("div", {
            key: 0,
            class: "relative",
            onClick: p[0] || (p[0] = (x) => t.value = r.frame ? Object.keys(r.images).length : 0)
          }, [
            _("div", Fb, [
              ae(m(v0), {
                previewUrl: r.previewUrl,
                isThumbnail: !0
              }, null, 8, ["previewUrl"])
            ])
          ])) : se("", !0),
          r.frame ? se("", !0) : (N(), j("div", {
            key: 1,
            class: "relative",
            onClick: p[1] || (p[1] = (x) => t.value = 1)
          }, [
            _("div", Bb, [
              _("img", {
                class: "w-full h-auto absolute inset-0 m-auto",
                alt: "Canvas Print",
                src: m(a)
              }, null, 8, jb)
            ])
          ]))
        ])
      ]),
      _("div", Ub, [
        ae(m(mb), {
          "wrap-around": !0,
          modelValue: t.value,
          "onUpdate:modelValue": p[2] || (p[2] = (x) => t.value = x)
        }, {
          addons: Se(() => [
            _("div", $b, [
              ae(m(bb))
            ]),
            ae(m(vb))
          ]),
          default: Se(() => [
            (N(!0), j(De, null, wt(r.images, (x) => (N(), Ne(m(Dc), {
              key: x.path
            }, {
              default: Se(() => [
                _("div", zb, [
                  _("img", {
                    class: "h-auto w-auto max-w-full m-auto",
                    style: qe([{ "max-height": r.isMobile ? "250px" : "500px" }]),
                    alt: x.altText,
                    src: x.path
                  }, null, 12, Wb)
                ])
              ]),
              _: 2
            }, 1024))), 128)),
            (r.previewUrl || m(l)) && !r.isReadyMadeProduct ? (N(), Ne(m(Dc), {
              key: "render-" + r.previewUrl
            }, {
              default: Se(() => [
                _("div", Hb, [
                  m(o) ? (N(), j("div", {
                    key: 0,
                    class: Pe(["absolute text-center text-white font-bold w-full h-full text-shadow-xl p-4 z-50 flex flex-col justify-center items-center", m(s)]),
                    style: qe({
                      textShadow: "1px 1px 3px #000, 0 0 5px #000",
                      opacity: 0.6
                    })
                  }, [
                    _("p", null, he(f.$t("message.customizer.carousel.preview")), 1),
                    _("p", null, he(f.$t("message.customizer.carousel.only")), 1)
                  ], 6)) : se("", !0),
                  ae(m(v0), {
                    previewUrl: r.previewUrl,
                    isMobile: r.isMobile
                  }, null, 8, ["previewUrl", "isMobile"])
                ])
              ]),
              _: 1
            })) : se("", !0),
            r.frame ? se("", !0) : (N(), Ne(m(Dc), { key: 1 }, {
              default: Se(() => [
                _("img", {
                  class: "h-full w-auto max-w-full m-auto",
                  style: qe([{ "max-height": r.isMobile ? "250px" : "500px" }]),
                  alt: "Canvas Print",
                  src: m(a)
                }, null, 12, Vb)
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        an(f.$slots, "default")
      ])
    ]));
  }
});
var jd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function zi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Kb(r) {
  if (r.__esModule)
    return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Ud = { exports: {} }, tp = function(e, t) {
  return function() {
    for (var i = new Array(arguments.length), s = 0; s < i.length; s++)
      i[s] = arguments[s];
    return e.apply(t, i);
  };
}, Yb = tp, zd = Object.prototype.toString, Wd = function(r) {
  return function(e) {
    var t = zd.call(e);
    return r[t] || (r[t] = t.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function zs(r) {
  return r = r.toLowerCase(), function(t) {
    return Wd(t) === r;
  };
}
function Hd(r) {
  return Array.isArray(r);
}
function Bl(r) {
  return typeof r > "u";
}
function qb(r) {
  return r !== null && !Bl(r) && r.constructor !== null && !Bl(r.constructor) && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
var rp = zs("ArrayBuffer");
function Zb(r) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && rp(r.buffer), e;
}
function Jb(r) {
  return typeof r == "string";
}
function Xb(r) {
  return typeof r == "number";
}
function np(r) {
  return r !== null && typeof r == "object";
}
function wl(r) {
  if (Wd(r) !== "object")
    return !1;
  var e = Object.getPrototypeOf(r);
  return e === null || e === Object.prototype;
}
var Qb = zs("Date"), ev = zs("File"), tv = zs("Blob"), rv = zs("FileList");
function Vd(r) {
  return zd.call(r) === "[object Function]";
}
function nv(r) {
  return np(r) && Vd(r.pipe);
}
function iv(r) {
  var e = "[object FormData]";
  return r && (typeof FormData == "function" && r instanceof FormData || zd.call(r) === e || Vd(r.toString) && r.toString() === e);
}
var sv = zs("URLSearchParams");
function av(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function ov() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function $d(r, e) {
  if (!(r === null || typeof r > "u"))
    if (typeof r != "object" && (r = [r]), Hd(r))
      for (var t = 0, n = r.length; t < n; t++)
        e.call(null, r[t], t, r);
    else
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && e.call(null, r[i], i, r);
}
function Ru() {
  var r = {};
  function e(i, s) {
    wl(r[s]) && wl(i) ? r[s] = Ru(r[s], i) : wl(i) ? r[s] = Ru({}, i) : Hd(i) ? r[s] = i.slice() : r[s] = i;
  }
  for (var t = 0, n = arguments.length; t < n; t++)
    $d(arguments[t], e);
  return r;
}
function lv(r, e, t) {
  return $d(e, function(i, s) {
    t && typeof i == "function" ? r[s] = Yb(i, t) : r[s] = i;
  }), r;
}
function cv(r) {
  return r.charCodeAt(0) === 65279 && (r = r.slice(1)), r;
}
function uv(r, e, t, n) {
  r.prototype = Object.create(e.prototype, n), r.prototype.constructor = r, t && Object.assign(r.prototype, t);
}
function dv(r, e, t) {
  var n, i, s, a = {};
  e = e || {};
  do {
    for (n = Object.getOwnPropertyNames(r), i = n.length; i-- > 0; )
      s = n[i], a[s] || (e[s] = r[s], a[s] = !0);
    r = Object.getPrototypeOf(r);
  } while (r && (!t || t(r, e)) && r !== Object.prototype);
  return e;
}
function fv(r, e, t) {
  r = String(r), (t === void 0 || t > r.length) && (t = r.length), t -= e.length;
  var n = r.indexOf(e, t);
  return n !== -1 && n === t;
}
function hv(r) {
  if (!r)
    return null;
  var e = r.length;
  if (Bl(e))
    return null;
  for (var t = new Array(e); e-- > 0; )
    t[e] = r[e];
  return t;
}
var pv = function(r) {
  return function(e) {
    return r && e instanceof r;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), Nr = {
  isArray: Hd,
  isArrayBuffer: rp,
  isBuffer: qb,
  isFormData: iv,
  isArrayBufferView: Zb,
  isString: Jb,
  isNumber: Xb,
  isObject: np,
  isPlainObject: wl,
  isUndefined: Bl,
  isDate: Qb,
  isFile: ev,
  isBlob: tv,
  isFunction: Vd,
  isStream: nv,
  isURLSearchParams: sv,
  isStandardBrowserEnv: ov,
  forEach: $d,
  merge: Ru,
  extend: lv,
  trim: av,
  stripBOM: cv,
  inherits: uv,
  toFlatObject: dv,
  kindOf: Wd,
  kindOfTest: zs,
  endsWith: fv,
  toArray: hv,
  isTypedArray: pv,
  isFileList: rv
}, Qs = Nr;
function y0(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var ip = function(e, t, n) {
  if (!t)
    return e;
  var i;
  if (n)
    i = n(t);
  else if (Qs.isURLSearchParams(t))
    i = t.toString();
  else {
    var s = [];
    Qs.forEach(t, function(l, c) {
      l === null || typeof l > "u" || (Qs.isArray(l) ? c = c + "[]" : l = [l], Qs.forEach(l, function(f) {
        Qs.isDate(f) ? f = f.toISOString() : Qs.isObject(f) && (f = JSON.stringify(f)), s.push(y0(c) + "=" + y0(f));
      }));
    }), i = s.join("&");
  }
  if (i) {
    var a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}, mv = Nr;
function nc() {
  this.handlers = [];
}
nc.prototype.use = function(e, t, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
nc.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
nc.prototype.forEach = function(e) {
  mv.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var gv = nc, xv = Nr, bv = function(e, t) {
  xv.forEach(e, function(i, s) {
    s !== t && s.toUpperCase() === t.toUpperCase() && (e[t] = i, delete e[s]);
  });
}, sp = Nr;
function Sa(r, e, t, n, i) {
  Error.call(this), this.message = r, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), n && (this.request = n), i && (this.response = i);
}
sp.inherits(Sa, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var ap = Sa.prototype, op = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(r) {
  op[r] = { value: r };
});
Object.defineProperties(Sa, op);
Object.defineProperty(ap, "isAxiosError", { value: !0 });
Sa.from = function(r, e, t, n, i, s) {
  var a = Object.create(ap);
  return sp.toFlatObject(r, a, function(l) {
    return l !== Error.prototype;
  }), Sa.call(a, r.message, e, t, n, i), a.name = r.name, s && Object.assign(a, s), a;
};
var Fa = Sa, lp = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, jn = Nr;
function vv(r, e) {
  e = e || new FormData();
  var t = [];
  function n(s) {
    return s === null ? "" : jn.isDate(s) ? s.toISOString() : jn.isArrayBuffer(s) || jn.isTypedArray(s) ? typeof Blob == "function" ? new Blob([s]) : Buffer.from(s) : s;
  }
  function i(s, a) {
    if (jn.isPlainObject(s) || jn.isArray(s)) {
      if (t.indexOf(s) !== -1)
        throw Error("Circular reference detected in " + a);
      t.push(s), jn.forEach(s, function(l, c) {
        if (!jn.isUndefined(l)) {
          var u = a ? a + "." + c : c, f;
          if (l && !a && typeof l == "object") {
            if (jn.endsWith(c, "{}"))
              l = JSON.stringify(l);
            else if (jn.endsWith(c, "[]") && (f = jn.toArray(l))) {
              f.forEach(function(p) {
                !jn.isUndefined(p) && e.append(u, n(p));
              });
              return;
            }
          }
          i(l, u);
        }
      }), t.pop();
    } else
      e.append(a, n(s));
  }
  return i(r), e;
}
var cp = vv, Fc, w0;
function yv() {
  if (w0)
    return Fc;
  w0 = 1;
  var r = Fa;
  return Fc = function(t, n, i) {
    var s = i.config.validateStatus;
    !i.status || !s || s(i.status) ? t(i) : n(new r(
      "Request failed with status code " + i.status,
      [r.ERR_BAD_REQUEST, r.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
      i.config,
      i.request,
      i
    ));
  }, Fc;
}
var Bc, _0;
function wv() {
  if (_0)
    return Bc;
  _0 = 1;
  var r = Nr;
  return Bc = r.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, i, s, a, o, l) {
          var c = [];
          c.push(n + "=" + encodeURIComponent(i)), r.isNumber(s) && c.push("expires=" + new Date(s).toGMTString()), r.isString(a) && c.push("path=" + a), r.isString(o) && c.push("domain=" + o), l === !0 && c.push("secure"), document.cookie = c.join("; ");
        },
        read: function(n) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Bc;
}
var _v = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, Ev = function(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}, Av = _v, Sv = Ev, up = function(e, t) {
  return e && !Av(t) ? Sv(e, t) : t;
}, jc, E0;
function Tv() {
  if (E0)
    return jc;
  E0 = 1;
  var r = Nr, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return jc = function(n) {
    var i = {}, s, a, o;
    return n && r.forEach(n.split(`
`), function(c) {
      if (o = c.indexOf(":"), s = r.trim(c.substr(0, o)).toLowerCase(), a = r.trim(c.substr(o + 1)), s) {
        if (i[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? i[s] = (i[s] ? i[s] : []).concat([a]) : i[s] = i[s] ? i[s] + ", " + a : a;
      }
    }), i;
  }, jc;
}
var Uc, A0;
function Mv() {
  if (A0)
    return Uc;
  A0 = 1;
  var r = Nr;
  return Uc = r.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), i;
      function s(a) {
        var o = a;
        return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return i = s(window.location.href), function(o) {
        var l = r.isString(o) ? s(o) : o;
        return l.protocol === i.protocol && l.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), Uc;
}
var zc, S0;
function ic() {
  if (S0)
    return zc;
  S0 = 1;
  var r = Fa, e = Nr;
  function t(n) {
    r.call(this, n ?? "canceled", r.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(t, r, {
    __CANCEL__: !0
  }), zc = t, zc;
}
var Wc, T0;
function Iv() {
  return T0 || (T0 = 1, Wc = function(e) {
    var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
  }), Wc;
}
var Hc, M0;
function I0() {
  if (M0)
    return Hc;
  M0 = 1;
  var r = Nr, e = yv(), t = wv(), n = ip, i = up, s = Tv(), a = Mv(), o = lp, l = Fa, c = ic(), u = Iv();
  return Hc = function(p) {
    return new Promise(function(T, v) {
      var w = p.data, E = p.headers, C = p.responseType, P;
      function F() {
        p.cancelToken && p.cancelToken.unsubscribe(P), p.signal && p.signal.removeEventListener("abort", P);
      }
      r.isFormData(w) && r.isStandardBrowserEnv() && delete E["Content-Type"];
      var k = new XMLHttpRequest();
      if (p.auth) {
        var K = p.auth.username || "", Z = p.auth.password ? unescape(encodeURIComponent(p.auth.password)) : "";
        E.Authorization = "Basic " + btoa(K + ":" + Z);
      }
      var ne = i(p.baseURL, p.url);
      k.open(p.method.toUpperCase(), n(ne, p.params, p.paramsSerializer), !0), k.timeout = p.timeout;
      function le() {
        if (k) {
          var _e = "getAllResponseHeaders" in k ? s(k.getAllResponseHeaders()) : null, L = !C || C === "text" || C === "json" ? k.responseText : k.response, d = {
            data: L,
            status: k.status,
            statusText: k.statusText,
            headers: _e,
            config: p,
            request: k
          };
          e(function(S) {
            T(S), F();
          }, function(S) {
            v(S), F();
          }, d), k = null;
        }
      }
      if ("onloadend" in k ? k.onloadend = le : k.onreadystatechange = function() {
        !k || k.readyState !== 4 || k.status === 0 && !(k.responseURL && k.responseURL.indexOf("file:") === 0) || setTimeout(le);
      }, k.onabort = function() {
        k && (v(new l("Request aborted", l.ECONNABORTED, p, k)), k = null);
      }, k.onerror = function() {
        v(new l("Network Error", l.ERR_NETWORK, p, k, k)), k = null;
      }, k.ontimeout = function() {
        var L = p.timeout ? "timeout of " + p.timeout + "ms exceeded" : "timeout exceeded", d = p.transitional || o;
        p.timeoutErrorMessage && (L = p.timeoutErrorMessage), v(new l(
          L,
          d.clarifyTimeoutError ? l.ETIMEDOUT : l.ECONNABORTED,
          p,
          k
        )), k = null;
      }, r.isStandardBrowserEnv()) {
        var ye = (p.withCredentials || a(ne)) && p.xsrfCookieName ? t.read(p.xsrfCookieName) : void 0;
        ye && (E[p.xsrfHeaderName] = ye);
      }
      "setRequestHeader" in k && r.forEach(E, function(L, d) {
        typeof w > "u" && d.toLowerCase() === "content-type" ? delete E[d] : k.setRequestHeader(d, L);
      }), r.isUndefined(p.withCredentials) || (k.withCredentials = !!p.withCredentials), C && C !== "json" && (k.responseType = p.responseType), typeof p.onDownloadProgress == "function" && k.addEventListener("progress", p.onDownloadProgress), typeof p.onUploadProgress == "function" && k.upload && k.upload.addEventListener("progress", p.onUploadProgress), (p.cancelToken || p.signal) && (P = function(_e) {
        k && (v(!_e || _e && _e.type ? new c() : _e), k.abort(), k = null);
      }, p.cancelToken && p.cancelToken.subscribe(P), p.signal && (p.signal.aborted ? P() : p.signal.addEventListener("abort", P))), w || (w = null);
      var ge = u(ne);
      if (ge && ["http", "https", "file"].indexOf(ge) === -1) {
        v(new l("Unsupported protocol " + ge + ":", l.ERR_BAD_REQUEST, p));
        return;
      }
      k.send(w);
    });
  }, Hc;
}
var Vc, C0;
function Cv() {
  return C0 || (C0 = 1, Vc = null), Vc;
}
var Er = Nr, P0 = bv, k0 = Fa, Pv = lp, kv = cp, Ov = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function O0(r, e) {
  !Er.isUndefined(r) && Er.isUndefined(r["Content-Type"]) && (r["Content-Type"] = e);
}
function Nv() {
  var r;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (r = I0()), r;
}
function Rv(r, e, t) {
  if (Er.isString(r))
    try {
      return (e || JSON.parse)(r), Er.trim(r);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(r);
}
var sc = {
  transitional: Pv,
  adapter: Nv(),
  transformRequest: [function(e, t) {
    if (P0(t, "Accept"), P0(t, "Content-Type"), Er.isFormData(e) || Er.isArrayBuffer(e) || Er.isBuffer(e) || Er.isStream(e) || Er.isFile(e) || Er.isBlob(e))
      return e;
    if (Er.isArrayBufferView(e))
      return e.buffer;
    if (Er.isURLSearchParams(e))
      return O0(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var n = Er.isObject(e), i = t && t["Content-Type"], s;
    if ((s = Er.isFileList(e)) || n && i === "multipart/form-data") {
      var a = this.env && this.env.FormData;
      return kv(s ? { "files[]": e } : e, a && new a());
    } else if (n || i === "application/json")
      return O0(t, "application/json"), Rv(e);
    return e;
  }],
  transformResponse: [function(e) {
    var t = this.transitional || sc.transitional, n = t && t.silentJSONParsing, i = t && t.forcedJSONParsing, s = !n && this.responseType === "json";
    if (s || i && Er.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? k0.from(a, k0.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Cv()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Er.forEach(["delete", "get", "head"], function(e) {
  sc.headers[e] = {};
});
Er.forEach(["post", "put", "patch"], function(e) {
  sc.headers[e] = Er.merge(Ov);
});
var Gd = sc, Lv = Nr, Dv = Gd, Fv = function(e, t, n) {
  var i = this || Dv;
  return Lv.forEach(n, function(a) {
    e = a.call(i, e, t);
  }), e;
}, $c, N0;
function dp() {
  return N0 || (N0 = 1, $c = function(e) {
    return !!(e && e.__CANCEL__);
  }), $c;
}
var R0 = Nr, Gc = Fv, Bv = dp(), jv = Gd, Uv = ic();
function Kc(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new Uv();
}
var zv = function(e) {
  Kc(e), e.headers = e.headers || {}, e.data = Gc.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = R0.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), R0.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete e.headers[i];
    }
  );
  var t = e.adapter || jv.adapter;
  return t(e).then(function(i) {
    return Kc(e), i.data = Gc.call(
      e,
      i.data,
      i.headers,
      e.transformResponse
    ), i;
  }, function(i) {
    return Bv(i) || (Kc(e), i && i.response && (i.response.data = Gc.call(
      e,
      i.response.data,
      i.response.headers,
      e.transformResponse
    ))), Promise.reject(i);
  });
}, pn = Nr, fp = function(e, t) {
  t = t || {};
  var n = {};
  function i(u, f) {
    return pn.isPlainObject(u) && pn.isPlainObject(f) ? pn.merge(u, f) : pn.isPlainObject(f) ? pn.merge({}, f) : pn.isArray(f) ? f.slice() : f;
  }
  function s(u) {
    if (pn.isUndefined(t[u])) {
      if (!pn.isUndefined(e[u]))
        return i(void 0, e[u]);
    } else
      return i(e[u], t[u]);
  }
  function a(u) {
    if (!pn.isUndefined(t[u]))
      return i(void 0, t[u]);
  }
  function o(u) {
    if (pn.isUndefined(t[u])) {
      if (!pn.isUndefined(e[u]))
        return i(void 0, e[u]);
    } else
      return i(void 0, t[u]);
  }
  function l(u) {
    if (u in t)
      return i(e[u], t[u]);
    if (u in e)
      return i(void 0, e[u]);
  }
  var c = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: l
  };
  return pn.forEach(Object.keys(e).concat(Object.keys(t)), function(f) {
    var p = c[f] || s, x = p(f);
    pn.isUndefined(x) && p !== l || (n[f] = x);
  }), n;
}, Yc, L0;
function hp() {
  return L0 || (L0 = 1, Yc = {
    version: "0.27.2"
  }), Yc;
}
var Wv = hp().version, is = Fa, Kd = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(r, e) {
  Kd[r] = function(n) {
    return typeof n === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
var D0 = {};
Kd.transitional = function(e, t, n) {
  function i(s, a) {
    return "[Axios v" + Wv + "] Transitional option '" + s + "'" + a + (n ? ". " + n : "");
  }
  return function(s, a, o) {
    if (e === !1)
      throw new is(
        i(a, " has been removed" + (t ? " in " + t : "")),
        is.ERR_DEPRECATED
      );
    return t && !D0[a] && (D0[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(s, a, o) : !0;
  };
};
function Hv(r, e, t) {
  if (typeof r != "object")
    throw new is("options must be an object", is.ERR_BAD_OPTION_VALUE);
  for (var n = Object.keys(r), i = n.length; i-- > 0; ) {
    var s = n[i], a = e[s];
    if (a) {
      var o = r[s], l = o === void 0 || a(o, s, r);
      if (l !== !0)
        throw new is("option " + s + " must be " + l, is.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new is("Unknown option " + s, is.ERR_BAD_OPTION);
  }
}
var Vv = {
  assertOptions: Hv,
  validators: Kd
}, pp = Nr, $v = ip, F0 = gv, B0 = zv, ac = fp, Gv = up, mp = Vv, ea = mp.validators;
function Ta(r) {
  this.defaults = r, this.interceptors = {
    request: new F0(),
    response: new F0()
  };
}
Ta.prototype.request = function(e, t) {
  typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = ac(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var n = t.transitional;
  n !== void 0 && mp.assertOptions(n, {
    silentJSONParsing: ea.transitional(ea.boolean),
    forcedJSONParsing: ea.transitional(ea.boolean),
    clarifyTimeoutError: ea.transitional(ea.boolean)
  }, !1);
  var i = [], s = !0;
  this.interceptors.request.forEach(function(x) {
    typeof x.runWhen == "function" && x.runWhen(t) === !1 || (s = s && x.synchronous, i.unshift(x.fulfilled, x.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(x) {
    a.push(x.fulfilled, x.rejected);
  });
  var o;
  if (!s) {
    var l = [B0, void 0];
    for (Array.prototype.unshift.apply(l, i), l = l.concat(a), o = Promise.resolve(t); l.length; )
      o = o.then(l.shift(), l.shift());
    return o;
  }
  for (var c = t; i.length; ) {
    var u = i.shift(), f = i.shift();
    try {
      c = u(c);
    } catch (p) {
      f(p);
      break;
    }
  }
  try {
    o = B0(c);
  } catch (p) {
    return Promise.reject(p);
  }
  for (; a.length; )
    o = o.then(a.shift(), a.shift());
  return o;
};
Ta.prototype.getUri = function(e) {
  e = ac(this.defaults, e);
  var t = Gv(e.baseURL, e.url);
  return $v(t, e.params, e.paramsSerializer);
};
pp.forEach(["delete", "get", "head", "options"], function(e) {
  Ta.prototype[e] = function(t, n) {
    return this.request(ac(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
pp.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(s, a, o) {
      return this.request(ac(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    };
  }
  Ta.prototype[e] = t(), Ta.prototype[e + "Form"] = t(!0);
});
var Kv = Ta, qc, j0;
function Yv() {
  if (j0)
    return qc;
  j0 = 1;
  var r = ic();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    var i = this;
    this.promise.then(function(s) {
      if (i._listeners) {
        var a, o = i._listeners.length;
        for (a = 0; a < o; a++)
          i._listeners[a](s);
        i._listeners = null;
      }
    }), this.promise.then = function(s) {
      var a, o = new Promise(function(l) {
        i.subscribe(l), a = l;
      }).then(s);
      return o.cancel = function() {
        i.unsubscribe(a);
      }, o;
    }, t(function(a) {
      i.reason || (i.reason = new r(a), n(i.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var i = this._listeners.indexOf(n);
      i !== -1 && this._listeners.splice(i, 1);
    }
  }, e.source = function() {
    var n, i = new e(function(a) {
      n = a;
    });
    return {
      token: i,
      cancel: n
    };
  }, qc = e, qc;
}
var Zc, U0;
function qv() {
  return U0 || (U0 = 1, Zc = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), Zc;
}
var Jc, z0;
function Zv() {
  if (z0)
    return Jc;
  z0 = 1;
  var r = Nr;
  return Jc = function(t) {
    return r.isObject(t) && t.isAxiosError === !0;
  }, Jc;
}
var W0 = Nr, Jv = tp, _l = Kv, Xv = fp, Qv = Gd;
function gp(r) {
  var e = new _l(r), t = Jv(_l.prototype.request, e);
  return W0.extend(t, _l.prototype, e), W0.extend(t, e), t.create = function(i) {
    return gp(Xv(r, i));
  }, t;
}
var on = gp(Qv);
on.Axios = _l;
on.CanceledError = ic();
on.CancelToken = Yv();
on.isCancel = dp();
on.VERSION = hp().version;
on.toFormData = cp;
on.AxiosError = Fa;
on.Cancel = on.CanceledError;
on.all = function(e) {
  return Promise.all(e);
};
on.spread = qv();
on.isAxiosError = Zv();
Ud.exports = on;
Ud.exports.default = on;
var ey = Ud.exports, ty = ey;
const Di = /* @__PURE__ */ zi(ty), ry = "/customizer/api/add", ny = "/customizer/api/update", Lu = "/customizer/api/product", iy = "/customizer/api/lineitem", Nn = Di.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
}), xp = Di.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json"
  }
});
Di.create({
  baseURL: "/cart",
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
const sy = (r) => Nn.post(ry, r), ay = (r, e) => Nn.post(`/api/orders/order/${e}/add`, r), oy = (r) => Nn.post(ny, r), ly = (r, e) => Nn.post(`/api/orders/order/${e}/update`, r), cy = async (r, e) => e ? Nn.get(`${Lu}/${r}/frame/${e}/new`) : Nn.get(`${Lu}/${r}/new`), uy = async (r, e, t, n, i) => {
  const s = e && t ? `/${e}/${t}` : "";
  let a = [];
  a.push(`/api/orders/order/${n}/product/${r}`), i && a.push(`/frame/${i}`), a.push(`/new${s}`);
  const o = a.join("");
  return Nn.get(o);
}, dy = async (r) => Nn.get(`${iy}/${r}`), fy = async (r, e) => Nn.get(`/api/orders/order/${r}/lineitem/${e}`), hy = (r) => xp.post("https://ifs3.graphikservices.com/pf/renderUrl", r), py = async (r, e, t, n) => {
  let i = [];
  i.push(`/customizer/api/product/${r}`), n && i.push(`/frame/${n}`), i.push(`/size/${e}/${t}`);
  const s = i.join("");
  return Nn.get(s);
}, my = async (r, e, t, n, i) => {
  let s = [];
  s.push(`/api/orders/order/${n}/product/${r}`), i && s.push(`/frame/${i}`), s.push(`/size/${e}/${t}`);
  const a = s.join("");
  return Nn.get(a);
}, gy = async (r, e, t, n) => Nn.get(`${Lu}/${r}/collection/${e}`), xy = async (r) => {
  const e = {
    svg: r,
    preview: !0
  };
  return xp.post("https://sprout.pictureframes.com/capture", e);
}, by = (r, e, t, n, i, s, a, o = 0, l = 0, c = 0, u, f, p, x) => new Promise(async (T, v) => {
  const w = "";
  let E = null, C = "";
  if (t) {
    const ne = await xy(t);
    ne && (C = ne.request.responseURL);
  }
  const P = (ne, le, ye, ge, _e, L = 0, d) => {
    let b = {
      part: {
        sku: ne,
        partType: le,
        partSubType: w
      },
      dimension: {
        height: ye + _e * 2,
        width: ge + _e * 2,
        dimensionType: "External",
        border: {
          top: _e,
          bottom: _e,
          left: _e,
          right: _e
        }
      },
      zIndex: L
    };
    return d && (b.finishingOptions = d), b;
  }, F = (ne = "ImagePreview", le) => {
    let ye = {
      sku: ne,
      dimension: {
        height: r,
        width: e,
        dimensionType: "External"
      },
      additionalProperties: null
    };
    return le && (ye.additionalProperties = {
      url: le
    }), [ye];
  };
  let k = "", K = "";
  K = p === On ? "crop" : "stretch";
  const Z = async () => {
    E = {
      gdRenderPackage: {
        returnFormat: "jpeg",
        crop: {
          type: K
        },
        restrictiveDimension: "both",
        returnWidth: 500,
        returnHeight: 500,
        gdPackage: {
          parts: [
            {
              dimension: {
                height: r,
                width: e,
                dimensionType: "Internal"
              }
            }
          ],
          additionalProperties: {
            externalDimensions: "Width 11 1/2&rdquo; x Height 9 1/2&rdquo;",
            externalDimensionWidth: "11 1/2",
            externalDimensionHeight: "9 1/2",
            opening: "Width 8&rdquo; x Height 6&rdquo;"
          }
        }
      }
    };
    let ne = E.gdRenderPackage.gdPackage, le = ne.parts;
    if (a) {
      const ye = o ? o + c : c;
      le.push(P(a, "Mat", r, e, ye, 0));
    }
    if (i && le.push(P(i, "Mat", r, e, o, 0)), n && le.push(P(n, "Frame", r, e, f, null)), u) {
      const ye = e + f * 2, ge = r + f * 2;
      let _e = null;
      (f || p === Eo || p === ks || p === Aa || p === _o) && (_e = F("Image", C)), le.push(P(u, "Substrate", ge, ye, f, null, _e));
    }
    C && !f && p !== Eo && p !== ks && p !== _o && (ne.finishingOptions = F("ImagePreview", C)), p === ks && x === "LAS" && (ne.finishingOptions = F("SOH"));
    try {
      k = (await hy(E)).data.renderUrl, T(k);
    } catch (ye) {
      v(ye);
    }
  };
  if (n || C && !n)
    try {
      await Z();
    } catch (ne) {
      v(ne);
    }
  else
    T(null);
});
var H0;
const bp = typeof window < "u", vy = (r) => typeof r == "string", vp = () => {
};
bp && ((H0 = window == null ? void 0 : window.navigator) != null && H0.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function yp(r) {
  return typeof r == "function" ? r() : m(r);
}
function yy(r) {
  return r;
}
function wy(r) {
  return Kx() ? (Yx(r), !0) : !1;
}
function _y(r) {
  var e;
  const t = yp(r);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const wp = bp ? window : void 0;
function tl(...r) {
  let e, t, n, i;
  if (vy(r[0]) || Array.isArray(r[0]) ? ([t, n, i] = r, e = wp) : [e, t, n, i] = r, !e)
    return vp;
  Array.isArray(t) || (t = [t]), Array.isArray(n) || (n = [n]);
  const s = [], a = () => {
    s.forEach((u) => u()), s.length = 0;
  }, o = (u, f, p, x) => (u.addEventListener(f, p, x), () => u.removeEventListener(f, p, x)), l = qr(() => [_y(e), yp(i)], ([u, f]) => {
    a(), u && s.push(...t.flatMap((p) => n.map((x) => o(u, p, x, f))));
  }, { immediate: !0, flush: "post" }), c = () => {
    l(), a();
  };
  return wy(c), c;
}
const V0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, $0 = "__vueuse_ssr_handlers__";
V0[$0] = V0[$0] || {};
const Ey = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function Ay(r = {}) {
  const {
    reactive: e = !1,
    target: t = wp,
    aliasMap: n = Ey,
    passive: i = !0,
    onEventFired: s = vp
  } = r, a = Kn(/* @__PURE__ */ new Set()), o = {
    toJSON() {
      return {};
    },
    current: a
  }, l = e ? Kn(o) : o, c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
  function f(v, w) {
    v in l && (e ? l[v] = w : l[v].value = w);
  }
  function p() {
    a.clear();
    for (const v of u)
      f(v, !1);
  }
  function x(v, w) {
    var E, C;
    const P = (E = v.key) == null ? void 0 : E.toLowerCase(), k = [(C = v.code) == null ? void 0 : C.toLowerCase(), P].filter(Boolean);
    P && (w ? a.add(P) : a.delete(P));
    for (const K of k)
      u.add(K), f(K, w);
    P === "meta" && !w ? (c.forEach((K) => {
      a.delete(K), f(K, !1);
    }), c.clear()) : typeof v.getModifierState == "function" && v.getModifierState("Meta") && w && [...a, ...k].forEach((K) => c.add(K));
  }
  tl(t, "keydown", (v) => (x(v, !0), s(v)), { passive: i }), tl(t, "keyup", (v) => (x(v, !1), s(v)), { passive: i }), tl("blur", p, { passive: !0 }), tl("focus", p, { passive: !0 });
  const T = new Proxy(l, {
    get(v, w, E) {
      if (typeof w != "string")
        return Reflect.get(v, w, E);
      if (w = w.toLowerCase(), w in n && (w = n[w]), !(w in l))
        if (/[+_-]/.test(w)) {
          const P = w.split(/[+_-]/g).map((F) => F.trim());
          l[w] = Y(() => P.every((F) => m(T[F])));
        } else
          l[w] = Ee(!1);
      const C = Reflect.get(v, w, E);
      return e ? m(C) : C;
    }
  });
  return T;
}
var G0;
(function(r) {
  r.UP = "UP", r.RIGHT = "RIGHT", r.DOWN = "DOWN", r.LEFT = "LEFT", r.NONE = "NONE";
})(G0 || (G0 = {}));
var Sy = Object.defineProperty, K0 = Object.getOwnPropertySymbols, Ty = Object.prototype.hasOwnProperty, My = Object.prototype.propertyIsEnumerable, Y0 = (r, e, t) => e in r ? Sy(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, Iy = (r, e) => {
  for (var t in e || (e = {}))
    Ty.call(e, t) && Y0(r, t, e[t]);
  if (K0)
    for (var t of K0(e))
      My.call(e, t) && Y0(r, t, e[t]);
  return r;
};
const Cy = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Iy({
  linear: yy
}, Cy);
function Py() {
  return _p().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function _p() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const ky = typeof Proxy == "function", Oy = "devtools-plugin:setup", Ny = "plugin:settings:set";
let ta, Du;
function Ry() {
  var r;
  return ta !== void 0 || (typeof window < "u" && window.performance ? (ta = !0, Du = window.performance) : typeof global < "u" && (!((r = global.perf_hooks) === null || r === void 0) && r.performance) ? (ta = !0, Du = global.perf_hooks.performance) : ta = !1), ta;
}
function Ly() {
  return Ry() ? Du.now() : Date.now();
}
class Dy {
  constructor(e, t) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = t;
    const n = {};
    if (e.settings)
      for (const a in e.settings) {
        const o = e.settings[a];
        n[a] = o.defaultValue;
      }
    const i = `__vue-devtools-plugin-settings__${e.id}`;
    let s = Object.assign({}, n);
    try {
      const a = localStorage.getItem(i), o = JSON.parse(a);
      Object.assign(s, o);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return s;
      },
      setSettings(a) {
        try {
          localStorage.setItem(i, JSON.stringify(a));
        } catch {
        }
        s = a;
      },
      now() {
        return Ly();
      }
    }, t && t.on(Ny, (a, o) => {
      a === this.plugin.id && this.fallbacks.setSettings(o);
    }), this.proxiedOn = new Proxy({}, {
      get: (a, o) => this.target ? this.target.on[o] : (...l) => {
        this.onQueue.push({
          method: o,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (a, o) => this.target ? this.target[o] : o === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(o) ? (...l) => (this.targetQueue.push({
        method: o,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[o](...l)) : (...l) => new Promise((c) => {
        this.targetQueue.push({
          method: o,
          args: l,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const t of this.onQueue)
      this.target.on[t.method](...t.args);
    for (const t of this.targetQueue)
      t.resolve(await this.target[t.method](...t.args));
  }
}
function Fy(r, e) {
  const t = r, n = _p(), i = Py(), s = ky && t.enableEarlyProxy;
  if (i && (n.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !s))
    i.emit(Oy, r, e);
  else {
    const a = s ? new Dy(t, i) : null;
    (n.__VUE_DEVTOOLS_PLUGINS__ = n.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: t,
      setupFn: e,
      proxy: a
    }), a && e(a.proxiedTarget);
  }
}
/*!
 * vuex v4.0.2
 * (c) 2021 Evan You
 * @license MIT
 */
var Ep = "store";
function By(r) {
  return r === void 0 && (r = null), ke(r !== null ? r : Ep);
}
function Ws(r, e) {
  Object.keys(r).forEach(function(t) {
    return e(r[t], t);
  });
}
function Ap(r) {
  return r !== null && typeof r == "object";
}
function jy(r) {
  return r && typeof r.then == "function";
}
function Yn(r, e) {
  if (!r)
    throw new Error("[vuex] " + e);
}
function Uy(r, e) {
  return function() {
    return r(e);
  };
}
function Sp(r, e, t) {
  return e.indexOf(r) < 0 && (t && t.prepend ? e.unshift(r) : e.push(r)), function() {
    var n = e.indexOf(r);
    n > -1 && e.splice(n, 1);
  };
}
function Tp(r, e) {
  r._actions = /* @__PURE__ */ Object.create(null), r._mutations = /* @__PURE__ */ Object.create(null), r._wrappedGetters = /* @__PURE__ */ Object.create(null), r._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var t = r.state;
  oc(r, t, [], r._modules.root, !0), Yd(r, t, e);
}
function Yd(r, e, t) {
  var n = r._state;
  r.getters = {}, r._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var i = r._wrappedGetters, s = {};
  Ws(i, function(a, o) {
    s[o] = Uy(a, r), Object.defineProperty(r.getters, o, {
      // TODO: use `computed` when it's possible. at the moment we can't due to
      // https://github.com/vuejs/vuex/pull/1883
      get: function() {
        return s[o]();
      },
      enumerable: !0
      // for local getters
    });
  }), r._state = Kn({
    data: e
  }), r.strict && $y(r), n && t && r._withCommit(function() {
    n.data = null;
  });
}
function oc(r, e, t, n, i) {
  var s = !t.length, a = r._modules.getNamespace(t);
  if (n.namespaced && (r._modulesNamespaceMap[a] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + a + " for the namespaced module " + t.join("/")), r._modulesNamespaceMap[a] = n), !s && !i) {
    var o = qd(e, t.slice(0, -1)), l = t[t.length - 1];
    r._withCommit(function() {
      process.env.NODE_ENV !== "production" && l in o && console.warn(
        '[vuex] state field "' + l + '" was overridden by a module with the same name at "' + t.join(".") + '"'
      ), o[l] = n.state;
    });
  }
  var c = n.context = zy(r, a, t);
  n.forEachMutation(function(u, f) {
    var p = a + f;
    Wy(r, p, u, c);
  }), n.forEachAction(function(u, f) {
    var p = u.root ? f : a + f, x = u.handler || u;
    Hy(r, p, x, c);
  }), n.forEachGetter(function(u, f) {
    var p = a + f;
    Vy(r, p, u, c);
  }), n.forEachChild(function(u, f) {
    oc(r, e, t.concat(f), u, i);
  });
}
function zy(r, e, t) {
  var n = e === "", i = {
    dispatch: n ? r.dispatch : function(s, a, o) {
      var l = jl(s, a, o), c = l.payload, u = l.options, f = l.type;
      if ((!u || !u.root) && (f = e + f, process.env.NODE_ENV !== "production" && !r._actions[f])) {
        console.error("[vuex] unknown local action type: " + l.type + ", global type: " + f);
        return;
      }
      return r.dispatch(f, c);
    },
    commit: n ? r.commit : function(s, a, o) {
      var l = jl(s, a, o), c = l.payload, u = l.options, f = l.type;
      if ((!u || !u.root) && (f = e + f, process.env.NODE_ENV !== "production" && !r._mutations[f])) {
        console.error("[vuex] unknown local mutation type: " + l.type + ", global type: " + f);
        return;
      }
      r.commit(f, c, u);
    }
  };
  return Object.defineProperties(i, {
    getters: {
      get: n ? function() {
        return r.getters;
      } : function() {
        return Mp(r, e);
      }
    },
    state: {
      get: function() {
        return qd(r.state, t);
      }
    }
  }), i;
}
function Mp(r, e) {
  if (!r._makeLocalGettersCache[e]) {
    var t = {}, n = e.length;
    Object.keys(r.getters).forEach(function(i) {
      if (i.slice(0, n) === e) {
        var s = i.slice(n);
        Object.defineProperty(t, s, {
          get: function() {
            return r.getters[i];
          },
          enumerable: !0
        });
      }
    }), r._makeLocalGettersCache[e] = t;
  }
  return r._makeLocalGettersCache[e];
}
function Wy(r, e, t, n) {
  var i = r._mutations[e] || (r._mutations[e] = []);
  i.push(function(a) {
    t.call(r, n.state, a);
  });
}
function Hy(r, e, t, n) {
  var i = r._actions[e] || (r._actions[e] = []);
  i.push(function(a) {
    var o = t.call(r, {
      dispatch: n.dispatch,
      commit: n.commit,
      getters: n.getters,
      state: n.state,
      rootGetters: r.getters,
      rootState: r.state
    }, a);
    return jy(o) || (o = Promise.resolve(o)), r._devtoolHook ? o.catch(function(l) {
      throw r._devtoolHook.emit("vuex:error", l), l;
    }) : o;
  });
}
function Vy(r, e, t, n) {
  if (r._wrappedGetters[e]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + e);
    return;
  }
  r._wrappedGetters[e] = function(s) {
    return t(
      n.state,
      // local state
      n.getters,
      // local getters
      s.state,
      // root state
      s.getters
      // root getters
    );
  };
}
function $y(r) {
  qr(function() {
    return r._state.data;
  }, function() {
    process.env.NODE_ENV !== "production" && Yn(r._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, flush: "sync" });
}
function qd(r, e) {
  return e.reduce(function(t, n) {
    return t[n];
  }, r);
}
function jl(r, e, t) {
  return Ap(r) && r.type && (t = e, e = r, r = r.type), process.env.NODE_ENV !== "production" && Yn(typeof r == "string", "expects string as the type, but found " + typeof r + "."), { type: r, payload: e, options: t };
}
var Gy = "vuex bindings", q0 = "vuex:mutations", Xc = "vuex:actions", ra = "vuex", Ky = 0;
function Yy(r, e) {
  Fy(
    {
      id: "org.vuejs.vuex",
      app: r,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [Gy]
    },
    function(t) {
      t.addTimelineLayer({
        id: q0,
        label: "Vuex Mutations",
        color: Z0
      }), t.addTimelineLayer({
        id: Xc,
        label: "Vuex Actions",
        color: Z0
      }), t.addInspector({
        id: ra,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), t.on.getInspectorTree(function(n) {
        if (n.app === r && n.inspectorId === ra)
          if (n.filter) {
            var i = [];
            kp(i, e._modules.root, n.filter, ""), n.rootNodes = i;
          } else
            n.rootNodes = [
              Pp(e._modules.root, "")
            ];
      }), t.on.getInspectorState(function(n) {
        if (n.app === r && n.inspectorId === ra) {
          var i = n.nodeId;
          Mp(e, i), n.state = Jy(
            Qy(e._modules, i),
            i === "root" ? e.getters : e._makeLocalGettersCache,
            i
          );
        }
      }), t.on.editInspectorState(function(n) {
        if (n.app === r && n.inspectorId === ra) {
          var i = n.nodeId, s = n.path;
          i !== "root" && (s = i.split("/").filter(Boolean).concat(s)), e._withCommit(function() {
            n.set(e._state.data, s, n.state.value);
          });
        }
      }), e.subscribe(function(n, i) {
        var s = {};
        n.payload && (s.payload = n.payload), s.state = i, t.notifyComponentUpdate(), t.sendInspectorTree(ra), t.sendInspectorState(ra), t.addTimelineEvent({
          layerId: q0,
          event: {
            time: Date.now(),
            title: n.type,
            data: s
          }
        });
      }), e.subscribeAction({
        before: function(n, i) {
          var s = {};
          n.payload && (s.payload = n.payload), n._id = Ky++, n._time = Date.now(), s.state = i, t.addTimelineEvent({
            layerId: Xc,
            event: {
              time: n._time,
              title: n.type,
              groupId: n._id,
              subtitle: "start",
              data: s
            }
          });
        },
        after: function(n, i) {
          var s = {}, a = Date.now() - n._time;
          s.duration = {
            _custom: {
              type: "duration",
              display: a + "ms",
              tooltip: "Action duration",
              value: a
            }
          }, n.payload && (s.payload = n.payload), s.state = i, t.addTimelineEvent({
            layerId: Xc,
            event: {
              time: Date.now(),
              title: n.type,
              groupId: n._id,
              subtitle: "end",
              data: s
            }
          });
        }
      });
    }
  );
}
var Z0 = 8702998, qy = 6710886, Zy = 16777215, Ip = {
  label: "namespaced",
  textColor: Zy,
  backgroundColor: qy
};
function Cp(r) {
  return r && r !== "root" ? r.split("/").slice(-2, -1)[0] : "Root";
}
function Pp(r, e) {
  return {
    id: e || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: Cp(e),
    tags: r.namespaced ? [Ip] : [],
    children: Object.keys(r._children).map(
      function(t) {
        return Pp(
          r._children[t],
          e + t + "/"
        );
      }
    )
  };
}
function kp(r, e, t, n) {
  n.includes(t) && r.push({
    id: n || "root",
    label: n.endsWith("/") ? n.slice(0, n.length - 1) : n || "Root",
    tags: e.namespaced ? [Ip] : []
  }), Object.keys(e._children).forEach(function(i) {
    kp(r, e._children[i], t, n + i + "/");
  });
}
function Jy(r, e, t) {
  e = t === "root" ? e : e[t];
  var n = Object.keys(e), i = {
    state: Object.keys(r.state).map(function(a) {
      return {
        key: a,
        editable: !0,
        value: r.state[a]
      };
    })
  };
  if (n.length) {
    var s = Xy(e);
    i.getters = Object.keys(s).map(function(a) {
      return {
        key: a.endsWith("/") ? Cp(a) : a,
        editable: !1,
        value: Fu(function() {
          return s[a];
        })
      };
    });
  }
  return i;
}
function Xy(r) {
  var e = {};
  return Object.keys(r).forEach(function(t) {
    var n = t.split("/");
    if (n.length > 1) {
      var i = e, s = n.pop();
      n.forEach(function(a) {
        i[a] || (i[a] = {
          _custom: {
            value: {},
            display: a,
            tooltip: "Module",
            abstract: !0
          }
        }), i = i[a]._custom.value;
      }), i[s] = Fu(function() {
        return r[t];
      });
    } else
      e[t] = Fu(function() {
        return r[t];
      });
  }), e;
}
function Qy(r, e) {
  var t = e.split("/").filter(function(n) {
    return n;
  });
  return t.reduce(
    function(n, i, s) {
      var a = n[i];
      if (!a)
        throw new Error('Missing module "' + i + '" for path "' + e + '".');
      return s === t.length - 1 ? a : a._children;
    },
    e === "root" ? r : r.root._children
  );
}
function Fu(r) {
  try {
    return r();
  } catch (e) {
    return e;
  }
}
var Zn = function(e, t) {
  this.runtime = t, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = e;
  var n = e.state;
  this.state = (typeof n == "function" ? n() : n) || {};
}, Op = { namespaced: { configurable: !0 } };
Op.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
Zn.prototype.addChild = function(e, t) {
  this._children[e] = t;
};
Zn.prototype.removeChild = function(e) {
  delete this._children[e];
};
Zn.prototype.getChild = function(e) {
  return this._children[e];
};
Zn.prototype.hasChild = function(e) {
  return e in this._children;
};
Zn.prototype.update = function(e) {
  this._rawModule.namespaced = e.namespaced, e.actions && (this._rawModule.actions = e.actions), e.mutations && (this._rawModule.mutations = e.mutations), e.getters && (this._rawModule.getters = e.getters);
};
Zn.prototype.forEachChild = function(e) {
  Ws(this._children, e);
};
Zn.prototype.forEachGetter = function(e) {
  this._rawModule.getters && Ws(this._rawModule.getters, e);
};
Zn.prototype.forEachAction = function(e) {
  this._rawModule.actions && Ws(this._rawModule.actions, e);
};
Zn.prototype.forEachMutation = function(e) {
  this._rawModule.mutations && Ws(this._rawModule.mutations, e);
};
Object.defineProperties(Zn.prototype, Op);
var Hs = function(e) {
  this.register([], e, !1);
};
Hs.prototype.get = function(e) {
  return e.reduce(function(t, n) {
    return t.getChild(n);
  }, this.root);
};
Hs.prototype.getNamespace = function(e) {
  var t = this.root;
  return e.reduce(function(n, i) {
    return t = t.getChild(i), n + (t.namespaced ? i + "/" : "");
  }, "");
};
Hs.prototype.update = function(e) {
  Np([], this.root, e);
};
Hs.prototype.register = function(e, t, n) {
  var i = this;
  n === void 0 && (n = !0), process.env.NODE_ENV !== "production" && Rp(e, t);
  var s = new Zn(t, n);
  if (e.length === 0)
    this.root = s;
  else {
    var a = this.get(e.slice(0, -1));
    a.addChild(e[e.length - 1], s);
  }
  t.modules && Ws(t.modules, function(o, l) {
    i.register(e.concat(l), o, n);
  });
};
Hs.prototype.unregister = function(e) {
  var t = this.get(e.slice(0, -1)), n = e[e.length - 1], i = t.getChild(n);
  if (!i) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + n + "', which is not registered"
    );
    return;
  }
  i.runtime && t.removeChild(n);
};
Hs.prototype.isRegistered = function(e) {
  var t = this.get(e.slice(0, -1)), n = e[e.length - 1];
  return t ? t.hasChild(n) : !1;
};
function Np(r, e, t) {
  if (process.env.NODE_ENV !== "production" && Rp(r, t), e.update(t), t.modules)
    for (var n in t.modules) {
      if (!e.getChild(n)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + n + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      Np(
        r.concat(n),
        e.getChild(n),
        t.modules[n]
      );
    }
}
var J0 = {
  assert: function(r) {
    return typeof r == "function";
  },
  expected: "function"
}, e3 = {
  assert: function(r) {
    return typeof r == "function" || typeof r == "object" && typeof r.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, X0 = {
  getters: J0,
  mutations: J0,
  actions: e3
};
function Rp(r, e) {
  Object.keys(X0).forEach(function(t) {
    if (e[t]) {
      var n = X0[t];
      Ws(e[t], function(i, s) {
        Yn(
          n.assert(i),
          t3(r, t, s, i, n.expected)
        );
      });
    }
  });
}
function t3(r, e, t, n, i) {
  var s = e + " should be " + i + ' but "' + e + "." + t + '"';
  return r.length > 0 && (s += ' in module "' + r.join(".") + '"'), s += " is " + JSON.stringify(n) + ".", s;
}
var wn = function r(e) {
  var t = this;
  e === void 0 && (e = {}), process.env.NODE_ENV !== "production" && (Yn(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), Yn(this instanceof r, "store must be called with the new operator."));
  var n = e.plugins;
  n === void 0 && (n = []);
  var i = e.strict;
  i === void 0 && (i = !1);
  var s = e.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new Hs(e), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._devtools = s;
  var a = this, o = this, l = o.dispatch, c = o.commit;
  this.dispatch = function(p, x) {
    return l.call(a, p, x);
  }, this.commit = function(p, x, T) {
    return c.call(a, p, x, T);
  }, this.strict = i;
  var u = this._modules.root.state;
  oc(this, u, [], this._modules.root), Yd(this, u), n.forEach(function(f) {
    return f(t);
  });
}, Zd = { state: { configurable: !0 } };
wn.prototype.install = function(e, t) {
  e.provide(t || Ep, this), e.config.globalProperties.$store = this;
  var n = this._devtools !== void 0 ? this._devtools : process.env.NODE_ENV !== "production" || !1;
  n && Yy(e, this);
};
Zd.state.get = function() {
  return this._state.data;
};
Zd.state.set = function(r) {
  process.env.NODE_ENV !== "production" && Yn(!1, "use store.replaceState() to explicit replace store state.");
};
wn.prototype.commit = function(e, t, n) {
  var i = this, s = jl(e, t, n), a = s.type, o = s.payload, l = s.options, c = { type: a, payload: o }, u = this._mutations[a];
  if (!u) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + a);
    return;
  }
  this._withCommit(function() {
    u.forEach(function(p) {
      p(o);
    });
  }), this._subscribers.slice().forEach(function(f) {
    return f(c, i.state);
  }), process.env.NODE_ENV !== "production" && l && l.silent && console.warn(
    "[vuex] mutation type: " + a + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
wn.prototype.dispatch = function(e, t) {
  var n = this, i = jl(e, t), s = i.type, a = i.payload, o = { type: s, payload: a }, l = this._actions[s];
  if (!l) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + s);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(u) {
      return u.before;
    }).forEach(function(u) {
      return u.before(o, n.state);
    });
  } catch (u) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(u));
  }
  var c = l.length > 1 ? Promise.all(l.map(function(u) {
    return u(a);
  })) : l[0](a);
  return new Promise(function(u, f) {
    c.then(function(p) {
      try {
        n._actionSubscribers.filter(function(x) {
          return x.after;
        }).forEach(function(x) {
          return x.after(o, n.state);
        });
      } catch (x) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(x));
      }
      u(p);
    }, function(p) {
      try {
        n._actionSubscribers.filter(function(x) {
          return x.error;
        }).forEach(function(x) {
          return x.error(o, n.state, p);
        });
      } catch (x) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(x));
      }
      f(p);
    });
  });
};
wn.prototype.subscribe = function(e, t) {
  return Sp(e, this._subscribers, t);
};
wn.prototype.subscribeAction = function(e, t) {
  var n = typeof e == "function" ? { before: e } : e;
  return Sp(n, this._actionSubscribers, t);
};
wn.prototype.watch = function(e, t, n) {
  var i = this;
  return process.env.NODE_ENV !== "production" && Yn(typeof e == "function", "store.watch only accepts a function."), qr(function() {
    return e(i.state, i.getters);
  }, t, Object.assign({}, n));
};
wn.prototype.replaceState = function(e) {
  var t = this;
  this._withCommit(function() {
    t._state.data = e;
  });
};
wn.prototype.registerModule = function(e, t, n) {
  n === void 0 && (n = {}), typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && (Yn(Array.isArray(e), "module path must be a string or an Array."), Yn(e.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(e, t), oc(this, this.state, e, this._modules.get(e), n.preserveState), Yd(this, this.state);
};
wn.prototype.unregisterModule = function(e) {
  var t = this;
  typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && Yn(Array.isArray(e), "module path must be a string or an Array."), this._modules.unregister(e), this._withCommit(function() {
    var n = qd(t.state, e.slice(0, -1));
    delete n[e[e.length - 1]];
  }), Tp(this);
};
wn.prototype.hasModule = function(e) {
  return typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && Yn(Array.isArray(e), "module path must be a string or an Array."), this._modules.isRegistered(e);
};
wn.prototype.hotUpdate = function(e) {
  this._modules.update(e), Tp(this, !0);
};
wn.prototype._withCommit = function(e) {
  var t = this._committing;
  this._committing = !0, e(), this._committing = t;
};
Object.defineProperties(wn.prototype, Zd);
var Lp = Bp(function(r, e) {
  var t = {};
  return process.env.NODE_ENV !== "production" && !Jd(e) && console.error("[vuex] mapGetters: mapper parameter must be either an Array or an Object"), Fp(e).forEach(function(n) {
    var i = n.key, s = n.val;
    s = r + s, t[i] = function() {
      if (!(r && !jp(this.$store, "mapGetters", r))) {
        if (process.env.NODE_ENV !== "production" && !(s in this.$store.getters)) {
          console.error("[vuex] unknown getter: " + s);
          return;
        }
        return this.$store.getters[s];
      }
    }, t[i].vuex = !0;
  }), t;
}), Dp = Bp(function(r, e) {
  var t = {};
  return process.env.NODE_ENV !== "production" && !Jd(e) && console.error("[vuex] mapActions: mapper parameter must be either an Array or an Object"), Fp(e).forEach(function(n) {
    var i = n.key, s = n.val;
    t[i] = function() {
      for (var o = [], l = arguments.length; l--; )
        o[l] = arguments[l];
      var c = this.$store.dispatch;
      if (r) {
        var u = jp(this.$store, "mapActions", r);
        if (!u)
          return;
        c = u.context.dispatch;
      }
      return typeof s == "function" ? s.apply(this, [c].concat(o)) : c.apply(this.$store, [s].concat(o));
    };
  }), t;
});
function Fp(r) {
  return Jd(r) ? Array.isArray(r) ? r.map(function(e) {
    return { key: e, val: e };
  }) : Object.keys(r).map(function(e) {
    return { key: e, val: r[e] };
  }) : [];
}
function Jd(r) {
  return Array.isArray(r) || Ap(r);
}
function Bp(r) {
  return function(e, t) {
    return typeof e != "string" ? (t = e, e = "") : e.charAt(e.length - 1) !== "/" && (e += "/"), r(e, t);
  };
}
function jp(r, e, t) {
  var n = r._modulesNamespaceMap[t];
  return process.env.NODE_ENV !== "production" && !n && console.error("[vuex] module namespace not found in " + e + "(): " + t), n;
}
var Up = { exports: {} };
(function(r, e) {
  (function(n, i) {
    r.exports = i();
  })(typeof self < "u" ? self : jd, function() {
    return (
      /******/
      function(t) {
        var n = {};
        function i(s) {
          if (n[s])
            return n[s].exports;
          var a = n[s] = {
            /******/
            i: s,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return t[s].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
        }
        return i.m = t, i.c = n, i.d = function(s, a, o) {
          i.o(s, a) || Object.defineProperty(s, a, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: o
            /******/
          });
        }, i.r = function(s) {
          Object.defineProperty(s, "__esModule", { value: !0 });
        }, i.n = function(s) {
          var a = s && s.__esModule ? (
            /******/
            function() {
              return s.default;
            }
          ) : (
            /******/
            function() {
              return s;
            }
          );
          return i.d(a, "a", a), a;
        }, i.o = function(s, a) {
          return Object.prototype.hasOwnProperty.call(s, a);
        }, i.p = "", i(i.s = 0);
      }({
        /***/
        "./dist/icons.json": (
          /*!*************************!*\
            !*** ./dist/icons.json ***!
            \*************************/
          /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, aperture, archive, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, award, bar-chart-2, bar-chart, battery-charging, battery, bell-off, bell, bluetooth, bold, book-open, book, bookmark, box, briefcase, calendar, camera-off, camera, cast, check-circle, check-square, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, chrome, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-off, cloud-rain, cloud-snow, cloud, code, codepen, codesandbox, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, divide-circle, divide-square, divide, dollar-sign, download-cloud, download, dribbble, droplet, edit-2, edit-3, edit, external-link, eye-off, eye, facebook, fast-forward, feather, figma, file-minus, file-plus, file-text, file, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, grid, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, info, instagram, italic, key, layers, layout, life-buoy, link-2, link, linkedin, list, loader, lock, log-in, log-out, mail, map-pin, map, maximize-2, maximize, meh, menu, message-circle, message-square, mic-off, mic, minimize-2, minimize, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation-2, navigation, octagon, package, paperclip, pause-circle, pause, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, pie-chart, play-circle, play, plus-circle, plus-square, plus, pocket, power, printer, radio, refresh-ccw, refresh-cw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, server, settings, share-2, share, shield-off, shield, shopping-bag, shopping-cart, shuffle, sidebar, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, square, star, stop-circle, sun, sunrise, sunset, table, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash-2, trash, trello, trending-down, trending-up, triangle, truck, tv, twitch, twitter, type, umbrella, underline, unlock, upload-cloud, upload, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume-1, volume-2, volume-x, volume, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
          /***/
          function(t) {
            t.exports = { activity: '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>', airplay: '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>', "alert-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>', "alert-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>', "alert-triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>', "align-center": '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>', "align-justify": '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>', "align-left": '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>', "align-right": '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>', anchor: '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>', aperture: '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>', archive: '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>', "arrow-down-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>', "arrow-down-left": '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>', "arrow-down-right": '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>', "arrow-down": '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>', "arrow-left-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>', "arrow-left": '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>', "arrow-right-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>', "arrow-right": '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>', "arrow-up-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>', "arrow-up-left": '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>', "arrow-up-right": '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>', "arrow-up": '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>', "at-sign": '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>', award: '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>', "bar-chart-2": '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>', "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>', "battery-charging": '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>', battery: '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>', "bell-off": '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>', bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>', bluetooth: '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>', bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>', "book-open": '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>', book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>', bookmark: '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>', box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', briefcase: '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>', calendar: '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>', "camera-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>', camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>', cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>', "check-circle": '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>', "check-square": '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>', check: '<polyline points="20 6 9 17 4 12"></polyline>', "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>', "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>', "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>', "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>', "chevrons-down": '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>', "chevrons-left": '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>', "chevrons-right": '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>', "chevrons-up": '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>', chrome: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>', circle: '<circle cx="12" cy="12" r="10"></circle>', clipboard: '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>', clock: '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>', "cloud-drizzle": '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>', "cloud-lightning": '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>', "cloud-off": '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>', "cloud-rain": '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>', "cloud-snow": '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>', cloud: '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>', code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>', codepen: '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>', codesandbox: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', coffee: '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>', columns: '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>', command: '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>', compass: '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>', copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>', "corner-down-left": '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>', "corner-down-right": '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>', "corner-left-down": '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>', "corner-left-up": '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>', "corner-right-down": '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>', "corner-right-up": '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>', "corner-up-left": '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>', "corner-up-right": '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>', cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>', "credit-card": '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>', crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>', crosshair: '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>', database: '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>', delete: '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>', disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>', "divide-circle": '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>', "divide-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>', divide: '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>', "dollar-sign": '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>', "download-cloud": '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>', download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>', dribbble: '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>', droplet: '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>', "edit-2": '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>', "edit-3": '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>', edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>', "external-link": '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>', "eye-off": '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>', eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>', facebook: '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>', "fast-forward": '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>', feather: '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>', figma: '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>', "file-minus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>', "file-plus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>', "file-text": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>', file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>', film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>', filter: '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>', flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>', "folder-minus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>', "folder-plus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>', folder: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>', framer: '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>', frown: '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>', "git-branch": '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>', "git-commit": '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>', "git-merge": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>', "git-pull-request": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>', github: '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>', gitlab: '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>', globe: '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>', grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>', "hard-drive": '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>', hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>', headphones: '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>', heart: '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>', "help-circle": '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>', hexagon: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>', home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>', image: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>', inbox: '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>', info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>', instagram: '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>', italic: '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>', key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>', layers: '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>', layout: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>', "life-buoy": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>', "link-2": '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>', link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>', linkedin: '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>', list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>', loader: '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>', lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>', "log-in": '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>', "log-out": '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>', mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>', "map-pin": '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>', map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>', "maximize-2": '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>', maximize: '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>', meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>', "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>', "message-square": '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>', "mic-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', "minimize-2": '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>', minimize: '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>', "minus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>', "minus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>', minus: '<line x1="5" y1="12" x2="19" y2="12"></line>', monitor: '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>', moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>', "more-horizontal": '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>', "more-vertical": '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>', "mouse-pointer": '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>', move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>', music: '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>', "navigation-2": '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>', navigation: '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>', octagon: '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>', package: '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', paperclip: '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>', "pause-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>', pause: '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>', "pen-tool": '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>', percent: '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>', "phone-call": '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-forwarded": '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-incoming": '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-missed": '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-off": '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>', "phone-outgoing": '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "pie-chart": '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>', "play-circle": '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>', play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>', "plus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>', "plus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>', plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>', pocket: '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>', power: '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>', printer: '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>', radio: '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>', "refresh-ccw": '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>', "refresh-cw": '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>', repeat: '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>', rewind: '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>', "rotate-ccw": '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>', "rotate-cw": '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>', rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>', save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>', scissors: '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>', search: '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>', send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>', server: '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>', settings: '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>', "share-2": '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>', share: '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>', "shield-off": '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>', shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>', "shopping-bag": '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>', "shopping-cart": '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>', shuffle: '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>', sidebar: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>', "skip-back": '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>', "skip-forward": '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>', slack: '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>', slash: '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>', sliders: '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>', smartphone: '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>', smile: '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', speaker: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>', square: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>', star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>', "stop-circle": '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>', sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>', sunrise: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>', sunset: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>', table: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path>', tablet: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>', tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>', target: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>', terminal: '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>', thermometer: '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>', "thumbs-down": '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>', "thumbs-up": '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>', "toggle-left": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>', "toggle-right": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>', tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>', "trash-2": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>', trash: '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>', trello: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>', "trending-down": '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>', "trending-up": '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>', triangle: '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>', truck: '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>', tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>', twitch: '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>', twitter: '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>', type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>', umbrella: '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>', underline: '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>', unlock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>', "upload-cloud": '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>', upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>', "user-check": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>', "user-minus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>', "user-plus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>', "user-x": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>', user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>', users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>', "video-off": '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>', video: '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>', voicemail: '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>', "volume-1": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>', "volume-2": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>', "volume-x": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>', volume: '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>', watch: '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>', "wifi-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>', wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>', wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>', "x-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>', "x-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>', "x-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>', x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>', youtube: '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>', "zap-off": '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>', zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>', "zoom-in": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>', "zoom-out": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>' };
          }
        ),
        /***/
        "./node_modules/classnames/dedupe.js": (
          /*!*******************************************!*\
            !*** ./node_modules/classnames/dedupe.js ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s, a;
            /*!
              Copyright (c) 2016 Jed Watson.
              Licensed under the MIT License (MIT), see
              http://jedwatson.github.io/classnames
            */
            (function() {
              var o = function() {
                function l() {
                }
                l.prototype = /* @__PURE__ */ Object.create(null);
                function c(E, C) {
                  for (var P = C.length, F = 0; F < P; ++F)
                    v(E, C[F]);
                }
                var u = {}.hasOwnProperty;
                function f(E, C) {
                  E[C] = !0;
                }
                function p(E, C) {
                  for (var P in C)
                    u.call(C, P) && (E[P] = !!C[P]);
                }
                var x = /\s+/;
                function T(E, C) {
                  for (var P = C.split(x), F = P.length, k = 0; k < F; ++k)
                    E[P[k]] = !0;
                }
                function v(E, C) {
                  if (C) {
                    var P = typeof C;
                    P === "string" ? T(E, C) : Array.isArray(C) ? c(E, C) : P === "object" ? p(E, C) : P === "number" && f(E, C);
                  }
                }
                function w() {
                  for (var E = arguments.length, C = Array(E), P = 0; P < E; P++)
                    C[P] = arguments[P];
                  var F = new l();
                  c(F, C);
                  var k = [];
                  for (var K in F)
                    F[K] && k.push(K);
                  return k.join(" ");
                }
                return w;
              }();
              typeof t < "u" && t.exports ? t.exports = o : (s = [], a = (function() {
                return o;
              }).apply(n, s), a !== void 0 && (t.exports = a));
            })();
          }
        ),
        /***/
        "./node_modules/core-js/es/array/from.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/es/array/from.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            i(
              /*! ../../modules/es.string.iterator */
              "./node_modules/core-js/modules/es.string.iterator.js"
            ), i(
              /*! ../../modules/es.array.from */
              "./node_modules/core-js/modules/es.array.from.js"
            );
            var s = i(
              /*! ../../internals/path */
              "./node_modules/core-js/internals/path.js"
            );
            t.exports = s.Array.from;
          }
        ),
        /***/
        "./node_modules/core-js/internals/a-function.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/a-function.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = function(i) {
              if (typeof i != "function")
                throw TypeError(String(i) + " is not a function");
              return i;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/an-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/an-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            );
            t.exports = function(a) {
              if (!s(a))
                throw TypeError(String(a) + " is not an object");
              return a;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/array-from.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/array-from.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/bind-context */
              "./node_modules/core-js/internals/bind-context.js"
            ), a = i(
              /*! ../internals/to-object */
              "./node_modules/core-js/internals/to-object.js"
            ), o = i(
              /*! ../internals/call-with-safe-iteration-closing */
              "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
            ), l = i(
              /*! ../internals/is-array-iterator-method */
              "./node_modules/core-js/internals/is-array-iterator-method.js"
            ), c = i(
              /*! ../internals/to-length */
              "./node_modules/core-js/internals/to-length.js"
            ), u = i(
              /*! ../internals/create-property */
              "./node_modules/core-js/internals/create-property.js"
            ), f = i(
              /*! ../internals/get-iterator-method */
              "./node_modules/core-js/internals/get-iterator-method.js"
            );
            t.exports = function(x) {
              var T = a(x), v = typeof this == "function" ? this : Array, w = arguments.length, E = w > 1 ? arguments[1] : void 0, C = E !== void 0, P = 0, F = f(T), k, K, Z, ne;
              if (C && (E = s(E, w > 2 ? arguments[2] : void 0, 2)), F != null && !(v == Array && l(F)))
                for (ne = F.call(T), K = new v(); !(Z = ne.next()).done; P++)
                  u(
                    K,
                    P,
                    C ? o(ne, E, [Z.value, P], !0) : Z.value
                  );
              else
                for (k = c(T.length), K = new v(k); k > P; P++)
                  u(K, P, C ? E(T[P], P) : T[P]);
              return K.length = P, K;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/array-includes.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/array-includes.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), a = i(
              /*! ../internals/to-length */
              "./node_modules/core-js/internals/to-length.js"
            ), o = i(
              /*! ../internals/to-absolute-index */
              "./node_modules/core-js/internals/to-absolute-index.js"
            );
            t.exports = function(l) {
              return function(c, u, f) {
                var p = s(c), x = a(p.length), T = o(f, x), v;
                if (l && u != u) {
                  for (; x > T; )
                    if (v = p[T++], v != v)
                      return !0;
                } else
                  for (; x > T; T++)
                    if ((l || T in p) && p[T] === u)
                      return l || T || 0;
                return !l && -1;
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/bind-context.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/internals/bind-context.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/a-function */
              "./node_modules/core-js/internals/a-function.js"
            );
            t.exports = function(a, o, l) {
              if (s(a), o === void 0)
                return a;
              switch (l) {
                case 0:
                  return function() {
                    return a.call(o);
                  };
                case 1:
                  return function(c) {
                    return a.call(o, c);
                  };
                case 2:
                  return function(c, u) {
                    return a.call(o, c, u);
                  };
                case 3:
                  return function(c, u, f) {
                    return a.call(o, c, u, f);
                  };
              }
              return function() {
                return a.apply(o, arguments);
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/call-with-safe-iteration-closing.js": (
          /*!****************************************************************************!*\
            !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
            \****************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            );
            t.exports = function(a, o, l, c) {
              try {
                return c ? o(s(l)[0], l[1]) : o(l);
              } catch (f) {
                var u = a.return;
                throw u !== void 0 && s(u.call(a)), f;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/check-correctness-of-iteration.js": (
          /*!**************************************************************************!*\
            !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
            \**************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), a = s("iterator"), o = !1;
            try {
              var l = 0, c = {
                next: function() {
                  return { done: !!l++ };
                },
                return: function() {
                  o = !0;
                }
              };
              c[a] = function() {
                return this;
              }, Array.from(c, function() {
                throw 2;
              });
            } catch {
            }
            t.exports = function(u, f) {
              if (!f && !o)
                return !1;
              var p = !1;
              try {
                var x = {};
                x[a] = function() {
                  return {
                    next: function() {
                      return { done: p = !0 };
                    }
                  };
                }, u(x);
              } catch {
              }
              return p;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/classof-raw.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/classof-raw.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            var i = {}.toString;
            t.exports = function(s) {
              return i.call(s).slice(8, -1);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/classof.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/internals/classof.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/classof-raw */
              "./node_modules/core-js/internals/classof-raw.js"
            ), a = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), o = a("toStringTag"), l = s(function() {
              return arguments;
            }()) == "Arguments", c = function(u, f) {
              try {
                return u[f];
              } catch {
              }
            };
            t.exports = function(u) {
              var f, p, x;
              return u === void 0 ? "Undefined" : u === null ? "Null" : typeof (p = c(f = Object(u), o)) == "string" ? p : l ? s(f) : (x = s(f)) == "Object" && typeof f.callee == "function" ? "Arguments" : x;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/copy-constructor-properties.js": (
          /*!***********************************************************************!*\
            !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
            \***********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), a = i(
              /*! ../internals/own-keys */
              "./node_modules/core-js/internals/own-keys.js"
            ), o = i(
              /*! ../internals/object-get-own-property-descriptor */
              "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
            ), l = i(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            );
            t.exports = function(c, u) {
              for (var f = a(u), p = l.f, x = o.f, T = 0; T < f.length; T++) {
                var v = f[T];
                s(c, v) || p(c, v, x(u, v));
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/correct-prototype-getter.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            t.exports = !s(function() {
              function a() {
              }
              return a.prototype.constructor = null, Object.getPrototypeOf(new a()) !== a.prototype;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-iterator-constructor.js": (
          /*!***********************************************************************!*\
            !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
            \***********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/iterators-core */
              "./node_modules/core-js/internals/iterators-core.js"
            ).IteratorPrototype, a = i(
              /*! ../internals/object-create */
              "./node_modules/core-js/internals/object-create.js"
            ), o = i(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            ), l = i(
              /*! ../internals/set-to-string-tag */
              "./node_modules/core-js/internals/set-to-string-tag.js"
            ), c = i(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), u = function() {
              return this;
            };
            t.exports = function(f, p, x) {
              var T = p + " Iterator";
              return f.prototype = a(s, { next: o(1, x) }), l(f, T, !1, !0), c[T] = u, f;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-property-descriptor.js": (
          /*!**********************************************************************!*\
            !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
            \**********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = function(i, s) {
              return {
                enumerable: !(i & 1),
                configurable: !(i & 2),
                writable: !(i & 4),
                value: s
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-property.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/create-property.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), a = i(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = i(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            );
            t.exports = function(l, c, u) {
              var f = s(c);
              f in l ? a.f(l, f, o(0, u)) : l[f] = u;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/define-iterator.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/define-iterator.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/export */
              "./node_modules/core-js/internals/export.js"
            ), a = i(
              /*! ../internals/create-iterator-constructor */
              "./node_modules/core-js/internals/create-iterator-constructor.js"
            ), o = i(
              /*! ../internals/object-get-prototype-of */
              "./node_modules/core-js/internals/object-get-prototype-of.js"
            ), l = i(
              /*! ../internals/object-set-prototype-of */
              "./node_modules/core-js/internals/object-set-prototype-of.js"
            ), c = i(
              /*! ../internals/set-to-string-tag */
              "./node_modules/core-js/internals/set-to-string-tag.js"
            ), u = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), f = i(
              /*! ../internals/redefine */
              "./node_modules/core-js/internals/redefine.js"
            ), p = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), x = i(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), T = i(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), v = i(
              /*! ../internals/iterators-core */
              "./node_modules/core-js/internals/iterators-core.js"
            ), w = v.IteratorPrototype, E = v.BUGGY_SAFARI_ITERATORS, C = p("iterator"), P = "keys", F = "values", k = "entries", K = function() {
              return this;
            };
            t.exports = function(Z, ne, le, ye, ge, _e, L) {
              a(le, ne, ye);
              var d = function(V) {
                if (V === ge && z)
                  return z;
                if (!E && V in R)
                  return R[V];
                switch (V) {
                  case P:
                    return function() {
                      return new le(this, V);
                    };
                  case F:
                    return function() {
                      return new le(this, V);
                    };
                  case k:
                    return function() {
                      return new le(this, V);
                    };
                }
                return function() {
                  return new le(this);
                };
              }, b = ne + " Iterator", S = !1, R = Z.prototype, D = R[C] || R["@@iterator"] || ge && R[ge], z = !E && D || d(ge), q = ne == "Array" && R.entries || D, y, h, I;
              if (q && (y = o(q.call(new Z())), w !== Object.prototype && y.next && (!x && o(y) !== w && (l ? l(y, w) : typeof y[C] != "function" && u(y, C, K)), c(y, b, !0, !0), x && (T[b] = K))), ge == F && D && D.name !== F && (S = !0, z = function() {
                return D.call(this);
              }), (!x || L) && R[C] !== z && u(R, C, z), T[ne] = z, ge)
                if (h = {
                  values: d(F),
                  keys: _e ? z : d(P),
                  entries: d(k)
                }, L)
                  for (I in h)
                    (E || S || !(I in R)) && f(R, I, h[I]);
                else
                  s({ target: ne, proto: !0, forced: E || S }, h);
              return h;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/descriptors.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/descriptors.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            t.exports = !s(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/document-create-element.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/document-create-element.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), o = s.document, l = a(o) && a(o.createElement);
            t.exports = function(c) {
              return l ? o.createElement(c) : {};
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/enum-bug-keys.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          }
        ),
        /***/
        "./node_modules/core-js/internals/export.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/export.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/object-get-own-property-descriptor */
              "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
            ).f, o = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), l = i(
              /*! ../internals/redefine */
              "./node_modules/core-js/internals/redefine.js"
            ), c = i(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), u = i(
              /*! ../internals/copy-constructor-properties */
              "./node_modules/core-js/internals/copy-constructor-properties.js"
            ), f = i(
              /*! ../internals/is-forced */
              "./node_modules/core-js/internals/is-forced.js"
            );
            t.exports = function(p, x) {
              var T = p.target, v = p.global, w = p.stat, E, C, P, F, k, K;
              if (v ? C = s : w ? C = s[T] || c(T, {}) : C = (s[T] || {}).prototype, C)
                for (P in x) {
                  if (k = x[P], p.noTargetGet ? (K = a(C, P), F = K && K.value) : F = C[P], E = f(v ? P : T + (w ? "." : "#") + P, p.forced), !E && F !== void 0) {
                    if (typeof k == typeof F)
                      continue;
                    u(k, F);
                  }
                  (p.sham || F && F.sham) && o(k, "sham", !0), l(C, P, k, p);
                }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/fails.js": (
          /*!*************************************************!*\
            !*** ./node_modules/core-js/internals/fails.js ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = function(i) {
              try {
                return !!i();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/function-to-string.js": (
          /*!**************************************************************!*\
            !*** ./node_modules/core-js/internals/function-to-string.js ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            );
            t.exports = s("native-function-to-string", Function.toString);
          }
        ),
        /***/
        "./node_modules/core-js/internals/get-iterator-method.js": (
          /*!***************************************************************!*\
            !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/classof */
              "./node_modules/core-js/internals/classof.js"
            ), a = i(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), o = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), l = o("iterator");
            t.exports = function(c) {
              if (c != null)
                return c[l] || c["@@iterator"] || a[s(c)];
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/global.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/global.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            (function(s) {
              var a = "object", o = function(l) {
                return l && l.Math == Math && l;
              };
              t.exports = // eslint-disable-next-line no-undef
              o(typeof globalThis == a && globalThis) || o(typeof window == a && window) || o(typeof self == a && self) || o(typeof s == a && s) || // eslint-disable-next-line no-new-func
              Function("return this")();
            }).call(this, i(
              /*! ./../../webpack/buildin/global.js */
              "./node_modules/webpack/buildin/global.js"
            ));
          }
        ),
        /***/
        "./node_modules/core-js/internals/has.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/internals/has.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            var i = {}.hasOwnProperty;
            t.exports = function(s, a) {
              return i.call(s, a);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/hidden-keys.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/hidden-keys.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = {};
          }
        ),
        /***/
        "./node_modules/core-js/internals/hide.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/hide.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), a = i(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = i(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            );
            t.exports = s ? function(l, c, u) {
              return a.f(l, c, o(1, u));
            } : function(l, c, u) {
              return l[c] = u, l;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/html.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/html.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = s.document;
            t.exports = a && a.documentElement;
          }
        ),
        /***/
        "./node_modules/core-js/internals/ie8-dom-define.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), a = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), o = i(
              /*! ../internals/document-create-element */
              "./node_modules/core-js/internals/document-create-element.js"
            );
            t.exports = !s && !a(function() {
              return Object.defineProperty(o("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/indexed-object.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/indexed-object.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), a = i(
              /*! ../internals/classof-raw */
              "./node_modules/core-js/internals/classof-raw.js"
            ), o = "".split;
            t.exports = s(function() {
              return !Object("z").propertyIsEnumerable(0);
            }) ? function(l) {
              return a(l) == "String" ? o.call(l, "") : Object(l);
            } : Object;
          }
        ),
        /***/
        "./node_modules/core-js/internals/internal-state.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/internal-state.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/native-weak-map */
              "./node_modules/core-js/internals/native-weak-map.js"
            ), a = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), o = i(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), l = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), c = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), u = i(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), f = i(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), p = a.WeakMap, x, T, v, w = function(Z) {
              return v(Z) ? T(Z) : x(Z, {});
            }, E = function(Z) {
              return function(ne) {
                var le;
                if (!o(ne) || (le = T(ne)).type !== Z)
                  throw TypeError("Incompatible receiver, " + Z + " required");
                return le;
              };
            };
            if (s) {
              var C = new p(), P = C.get, F = C.has, k = C.set;
              x = function(Z, ne) {
                return k.call(C, Z, ne), ne;
              }, T = function(Z) {
                return P.call(C, Z) || {};
              }, v = function(Z) {
                return F.call(C, Z);
              };
            } else {
              var K = u("state");
              f[K] = !0, x = function(Z, ne) {
                return l(Z, K, ne), ne;
              }, T = function(Z) {
                return c(Z, K) ? Z[K] : {};
              }, v = function(Z) {
                return c(Z, K);
              };
            }
            t.exports = {
              set: x,
              get: T,
              has: v,
              enforce: w,
              getterFor: E
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-array-iterator-method.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), a = i(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), o = s("iterator"), l = Array.prototype;
            t.exports = function(c) {
              return c !== void 0 && (a.Array === c || l[o] === c);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-forced.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/is-forced.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), a = /#|\.prototype\./, o = function(p, x) {
              var T = c[l(p)];
              return T == f ? !0 : T == u ? !1 : typeof x == "function" ? s(x) : !!x;
            }, l = o.normalize = function(p) {
              return String(p).replace(a, ".").toLowerCase();
            }, c = o.data = {}, u = o.NATIVE = "N", f = o.POLYFILL = "P";
            t.exports = o;
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/is-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = function(i) {
              return typeof i == "object" ? i !== null : typeof i == "function";
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-pure.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/internals/is-pure.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = !1;
          }
        ),
        /***/
        "./node_modules/core-js/internals/iterators-core.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/iterators-core.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/object-get-prototype-of */
              "./node_modules/core-js/internals/object-get-prototype-of.js"
            ), a = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), o = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), l = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), c = i(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), u = l("iterator"), f = !1, p = function() {
              return this;
            }, x, T, v;
            [].keys && (v = [].keys(), "next" in v ? (T = s(s(v)), T !== Object.prototype && (x = T)) : f = !0), x == null && (x = {}), !c && !o(x, u) && a(x, u, p), t.exports = {
              IteratorPrototype: x,
              BUGGY_SAFARI_ITERATORS: f
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/iterators.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/iterators.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = {};
          }
        ),
        /***/
        "./node_modules/core-js/internals/native-symbol.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/native-symbol.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            t.exports = !!Object.getOwnPropertySymbols && !s(function() {
              return !String(Symbol());
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/native-weak-map.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/native-weak-map.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/function-to-string */
              "./node_modules/core-js/internals/function-to-string.js"
            ), o = s.WeakMap;
            t.exports = typeof o == "function" && /native code/.test(a.call(o));
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-create.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/object-create.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), a = i(
              /*! ../internals/object-define-properties */
              "./node_modules/core-js/internals/object-define-properties.js"
            ), o = i(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            ), l = i(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), c = i(
              /*! ../internals/html */
              "./node_modules/core-js/internals/html.js"
            ), u = i(
              /*! ../internals/document-create-element */
              "./node_modules/core-js/internals/document-create-element.js"
            ), f = i(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), p = f("IE_PROTO"), x = "prototype", T = function() {
            }, v = function() {
              var w = u("iframe"), E = o.length, C = "<", P = "script", F = ">", k = "java" + P + ":", K;
              for (w.style.display = "none", c.appendChild(w), w.src = String(k), K = w.contentWindow.document, K.open(), K.write(C + P + F + "document.F=Object" + C + "/" + P + F), K.close(), v = K.F; E--; )
                delete v[x][o[E]];
              return v();
            };
            t.exports = Object.create || function(E, C) {
              var P;
              return E !== null ? (T[x] = s(E), P = new T(), T[x] = null, P[p] = E) : P = v(), C === void 0 ? P : a(P, C);
            }, l[p] = !0;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-define-properties.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/object-define-properties.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), a = i(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), l = i(
              /*! ../internals/object-keys */
              "./node_modules/core-js/internals/object-keys.js"
            );
            t.exports = s ? Object.defineProperties : function(u, f) {
              o(u);
              for (var p = l(f), x = p.length, T = 0, v; x > T; )
                a.f(u, v = p[T++], f[v]);
              return u;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-define-property.js": (
          /*!******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-define-property.js ***!
            \******************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), a = i(
              /*! ../internals/ie8-dom-define */
              "./node_modules/core-js/internals/ie8-dom-define.js"
            ), o = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), l = i(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), c = Object.defineProperty;
            n.f = s ? c : function(f, p, x) {
              if (o(f), p = l(p, !0), o(x), a)
                try {
                  return c(f, p, x);
                } catch {
                }
              if ("get" in x || "set" in x)
                throw TypeError("Accessors not supported");
              return "value" in x && (f[p] = x.value), f;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-descriptor.js": (
          /*!******************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
            \******************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), a = i(
              /*! ../internals/object-property-is-enumerable */
              "./node_modules/core-js/internals/object-property-is-enumerable.js"
            ), o = i(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            ), l = i(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), c = i(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), u = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), f = i(
              /*! ../internals/ie8-dom-define */
              "./node_modules/core-js/internals/ie8-dom-define.js"
            ), p = Object.getOwnPropertyDescriptor;
            n.f = s ? p : function(T, v) {
              if (T = l(T), v = c(v, !0), f)
                try {
                  return p(T, v);
                } catch {
                }
              if (u(T, v))
                return o(!a.f.call(T, v), T[v]);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-names.js": (
          /*!*************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
            \*************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/object-keys-internal */
              "./node_modules/core-js/internals/object-keys-internal.js"
            ), a = i(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            ), o = a.concat("length", "prototype");
            n.f = Object.getOwnPropertyNames || function(c) {
              return s(c, o);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-symbols.js": (
          /*!***************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
            \***************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            n.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-prototype-of.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), a = i(
              /*! ../internals/to-object */
              "./node_modules/core-js/internals/to-object.js"
            ), o = i(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), l = i(
              /*! ../internals/correct-prototype-getter */
              "./node_modules/core-js/internals/correct-prototype-getter.js"
            ), c = o("IE_PROTO"), u = Object.prototype;
            t.exports = l ? Object.getPrototypeOf : function(f) {
              return f = a(f), s(f, c) ? f[c] : typeof f.constructor == "function" && f instanceof f.constructor ? f.constructor.prototype : f instanceof Object ? u : null;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-keys-internal.js": (
          /*!****************************************************************!*\
            !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
            \****************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), a = i(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), o = i(
              /*! ../internals/array-includes */
              "./node_modules/core-js/internals/array-includes.js"
            ), l = i(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), c = o(!1);
            t.exports = function(u, f) {
              var p = a(u), x = 0, T = [], v;
              for (v in p)
                !s(l, v) && s(p, v) && T.push(v);
              for (; f.length > x; )
                s(p, v = f[x++]) && (~c(T, v) || T.push(v));
              return T;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-keys.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/object-keys.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/object-keys-internal */
              "./node_modules/core-js/internals/object-keys-internal.js"
            ), a = i(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            );
            t.exports = Object.keys || function(l) {
              return s(l, a);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-property-is-enumerable.js": (
          /*!*************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
            \*************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor, o = a && !s.call({ 1: 2 }, 1);
            n.f = o ? function(c) {
              var u = a(this, c);
              return !!u && u.enumerable;
            } : s;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-set-prototype-of.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/validate-set-prototype-of-arguments */
              "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js"
            );
            t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
              var a = !1, o = {}, l;
              try {
                l = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, l.call(o, []), a = o instanceof Array;
              } catch {
              }
              return function(u, f) {
                return s(u, f), a ? l.call(u, f) : u.__proto__ = f, u;
              };
            }() : void 0);
          }
        ),
        /***/
        "./node_modules/core-js/internals/own-keys.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/internals/own-keys.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/object-get-own-property-names */
              "./node_modules/core-js/internals/object-get-own-property-names.js"
            ), o = i(
              /*! ../internals/object-get-own-property-symbols */
              "./node_modules/core-js/internals/object-get-own-property-symbols.js"
            ), l = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), c = s.Reflect;
            t.exports = c && c.ownKeys || function(f) {
              var p = a.f(l(f)), x = o.f;
              return x ? p.concat(x(f)) : p;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/path.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/path.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            t.exports = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            );
          }
        ),
        /***/
        "./node_modules/core-js/internals/redefine.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/internals/redefine.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), o = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), l = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), c = i(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), u = i(
              /*! ../internals/function-to-string */
              "./node_modules/core-js/internals/function-to-string.js"
            ), f = i(
              /*! ../internals/internal-state */
              "./node_modules/core-js/internals/internal-state.js"
            ), p = f.get, x = f.enforce, T = String(u).split("toString");
            a("inspectSource", function(v) {
              return u.call(v);
            }), (t.exports = function(v, w, E, C) {
              var P = C ? !!C.unsafe : !1, F = C ? !!C.enumerable : !1, k = C ? !!C.noTargetGet : !1;
              if (typeof E == "function" && (typeof w == "string" && !l(E, "name") && o(E, "name", w), x(E).source = T.join(typeof w == "string" ? w : "")), v === s) {
                F ? v[w] = E : c(w, E);
                return;
              } else
                P ? !k && v[w] && (F = !0) : delete v[w];
              F ? v[w] = E : o(v, w, E);
            })(Function.prototype, "toString", function() {
              return typeof this == "function" && p(this).source || u.call(this);
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/require-object-coercible.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            t.exports = function(i) {
              if (i == null)
                throw TypeError("Can't call method on " + i);
              return i;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/set-global.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/set-global.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            );
            t.exports = function(o, l) {
              try {
                a(s, o, l);
              } catch {
                s[o] = l;
              }
              return l;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/set-to-string-tag.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ).f, a = i(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), o = i(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), l = o("toStringTag");
            t.exports = function(c, u, f) {
              c && !a(c = f ? c : c.prototype, l) && s(c, l, { configurable: !0, value: u });
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/shared-key.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/shared-key.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), a = i(
              /*! ../internals/uid */
              "./node_modules/core-js/internals/uid.js"
            ), o = s("keys");
            t.exports = function(l) {
              return o[l] || (o[l] = a(l));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/shared.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/shared.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), o = i(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), l = "__core-js_shared__", c = s[l] || a(l, {});
            (t.exports = function(u, f) {
              return c[u] || (c[u] = f !== void 0 ? f : {});
            })("versions", []).push({
              version: "3.1.3",
              mode: o ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/string-at.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/string-at.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), a = i(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            t.exports = function(o, l, c) {
              var u = String(a(o)), f = s(l), p = u.length, x, T;
              return f < 0 || f >= p ? c ? "" : void 0 : (x = u.charCodeAt(f), x < 55296 || x > 56319 || f + 1 === p || (T = u.charCodeAt(f + 1)) < 56320 || T > 57343 ? c ? u.charAt(f) : x : c ? u.slice(f, f + 2) : (x - 55296 << 10) + (T - 56320) + 65536);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-absolute-index.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), a = Math.max, o = Math.min;
            t.exports = function(l, c) {
              var u = s(l);
              return u < 0 ? a(u + c, 0) : o(u, c);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-indexed-object.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/indexed-object */
              "./node_modules/core-js/internals/indexed-object.js"
            ), a = i(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            t.exports = function(o) {
              return s(a(o));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-integer.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/to-integer.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            var i = Math.ceil, s = Math.floor;
            t.exports = function(a) {
              return isNaN(a = +a) ? 0 : (a > 0 ? s : i)(a);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-length.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/to-length.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), a = Math.min;
            t.exports = function(o) {
              return o > 0 ? a(s(o), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/to-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            t.exports = function(a) {
              return Object(s(a));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-primitive.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/internals/to-primitive.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            );
            t.exports = function(a, o) {
              if (!s(a))
                return a;
              var l, c;
              if (o && typeof (l = a.toString) == "function" && !s(c = l.call(a)) || typeof (l = a.valueOf) == "function" && !s(c = l.call(a)) || !o && typeof (l = a.toString) == "function" && !s(c = l.call(a)))
                return c;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/uid.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/internals/uid.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            var i = 0, s = Math.random();
            t.exports = function(a) {
              return "Symbol(".concat(a === void 0 ? "" : a, ")_", (++i + s).toString(36));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js": (
          /*!*******************************************************************************!*\
            !*** ./node_modules/core-js/internals/validate-set-prototype-of-arguments.js ***!
            \*******************************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), a = i(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            );
            t.exports = function(o, l) {
              if (a(o), !s(l) && l !== null)
                throw TypeError("Can't set " + String(l) + " as a prototype");
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/well-known-symbol.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), a = i(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), o = i(
              /*! ../internals/uid */
              "./node_modules/core-js/internals/uid.js"
            ), l = i(
              /*! ../internals/native-symbol */
              "./node_modules/core-js/internals/native-symbol.js"
            ), c = s.Symbol, u = a("wks");
            t.exports = function(f) {
              return u[f] || (u[f] = l && c[f] || (l ? c : o)("Symbol." + f));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/es.array.from.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/modules/es.array.from.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/export */
              "./node_modules/core-js/internals/export.js"
            ), a = i(
              /*! ../internals/array-from */
              "./node_modules/core-js/internals/array-from.js"
            ), o = i(
              /*! ../internals/check-correctness-of-iteration */
              "./node_modules/core-js/internals/check-correctness-of-iteration.js"
            ), l = !o(function(c) {
              Array.from(c);
            });
            s({ target: "Array", stat: !0, forced: l }, {
              from: a
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es.string.iterator.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ../internals/string-at */
              "./node_modules/core-js/internals/string-at.js"
            ), a = i(
              /*! ../internals/internal-state */
              "./node_modules/core-js/internals/internal-state.js"
            ), o = i(
              /*! ../internals/define-iterator */
              "./node_modules/core-js/internals/define-iterator.js"
            ), l = "String Iterator", c = a.set, u = a.getterFor(l);
            o(String, "String", function(f) {
              c(this, {
                type: l,
                string: String(f),
                index: 0
              });
            }, function() {
              var p = u(this), x = p.string, T = p.index, v;
              return T >= x.length ? { value: void 0, done: !0 } : (v = s(x, T, !0), p.index += v.length, { value: v, done: !1 });
            });
          }
        ),
        /***/
        "./node_modules/webpack/buildin/global.js": (
          /*!***********************************!*\
            !*** (webpack)/buildin/global.js ***!
            \***********************************/
          /*! no static exports found */
          /***/
          function(t, n) {
            var i;
            i = function() {
              return this;
            }();
            try {
              i = i || Function("return this")() || (0, eval)("this");
            } catch {
              typeof window == "object" && (i = window);
            }
            t.exports = i;
          }
        ),
        /***/
        "./src/default-attrs.json": (
          /*!********************************!*\
            !*** ./src/default-attrs.json ***!
            \********************************/
          /*! exports provided: xmlns, width, height, viewBox, fill, stroke, stroke-width, stroke-linecap, stroke-linejoin, default */
          /***/
          function(t) {
            t.exports = { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" };
          }
        ),
        /***/
        "./src/icon.js": (
          /*!*********************!*\
            !*** ./src/icon.js ***!
            \*********************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            Object.defineProperty(n, "__esModule", {
              value: !0
            });
            var s = Object.assign || function(v) {
              for (var w = 1; w < arguments.length; w++) {
                var E = arguments[w];
                for (var C in E)
                  Object.prototype.hasOwnProperty.call(E, C) && (v[C] = E[C]);
              }
              return v;
            }, a = function() {
              function v(w, E) {
                for (var C = 0; C < E.length; C++) {
                  var P = E[C];
                  P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(w, P.key, P);
                }
              }
              return function(w, E, C) {
                return E && v(w.prototype, E), C && v(w, C), w;
              };
            }(), o = i(
              /*! classnames/dedupe */
              "./node_modules/classnames/dedupe.js"
            ), l = f(o), c = i(
              /*! ./default-attrs.json */
              "./src/default-attrs.json"
            ), u = f(c);
            function f(v) {
              return v && v.__esModule ? v : { default: v };
            }
            function p(v, w) {
              if (!(v instanceof w))
                throw new TypeError("Cannot call a class as a function");
            }
            var x = function() {
              function v(w, E) {
                var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                p(this, v), this.name = w, this.contents = E, this.tags = C, this.attrs = s({}, u.default, { class: "feather feather-" + w });
              }
              return a(v, [{
                key: "toSvg",
                value: function() {
                  var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = s({}, this.attrs, E, { class: (0, l.default)(this.attrs.class, E.class) });
                  return "<svg " + T(C) + ">" + this.contents + "</svg>";
                }
                /**
                 * Return string representation of an `Icon`.
                 *
                 * Added for backward compatibility. If old code expects `feather.icons.<name>`
                 * to be a string, `toString()` will get implicitly called.
                 *
                 * @returns {string}
                 */
              }, {
                key: "toString",
                value: function() {
                  return this.contents;
                }
              }]), v;
            }();
            function T(v) {
              return Object.keys(v).map(function(w) {
                return w + '="' + v[w] + '"';
              }).join(" ");
            }
            n.default = x;
          }
        ),
        /***/
        "./src/icons.js": (
          /*!**********************!*\
            !*** ./src/icons.js ***!
            \**********************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            Object.defineProperty(n, "__esModule", {
              value: !0
            });
            var s = i(
              /*! ./icon */
              "./src/icon.js"
            ), a = f(s), o = i(
              /*! ../dist/icons.json */
              "./dist/icons.json"
            ), l = f(o), c = i(
              /*! ./tags.json */
              "./src/tags.json"
            ), u = f(c);
            function f(p) {
              return p && p.__esModule ? p : { default: p };
            }
            n.default = Object.keys(l.default).map(function(p) {
              return new a.default(p, l.default[p], u.default[p]);
            }).reduce(function(p, x) {
              return p[x.name] = x, p;
            }, {});
          }
        ),
        /***/
        "./src/index.js": (
          /*!**********************!*\
            !*** ./src/index.js ***!
            \**********************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            var s = i(
              /*! ./icons */
              "./src/icons.js"
            ), a = f(s), o = i(
              /*! ./to-svg */
              "./src/to-svg.js"
            ), l = f(o), c = i(
              /*! ./replace */
              "./src/replace.js"
            ), u = f(c);
            function f(p) {
              return p && p.__esModule ? p : { default: p };
            }
            t.exports = { icons: a.default, toSvg: l.default, replace: u.default };
          }
        ),
        /***/
        "./src/replace.js": (
          /*!************************!*\
            !*** ./src/replace.js ***!
            \************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            Object.defineProperty(n, "__esModule", {
              value: !0
            });
            var s = Object.assign || function(T) {
              for (var v = 1; v < arguments.length; v++) {
                var w = arguments[v];
                for (var E in w)
                  Object.prototype.hasOwnProperty.call(w, E) && (T[E] = w[E]);
              }
              return T;
            }, a = i(
              /*! classnames/dedupe */
              "./node_modules/classnames/dedupe.js"
            ), o = u(a), l = i(
              /*! ./icons */
              "./src/icons.js"
            ), c = u(l);
            function u(T) {
              return T && T.__esModule ? T : { default: T };
            }
            function f() {
              var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              if (typeof document > "u")
                throw new Error("`feather.replace()` only works in a browser environment.");
              var v = document.querySelectorAll("[data-feather]");
              Array.from(v).forEach(function(w) {
                return p(w, T);
              });
            }
            function p(T) {
              var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = x(T), E = w["data-feather"];
              delete w["data-feather"];
              var C = c.default[E].toSvg(s({}, v, w, { class: (0, o.default)(v.class, w.class) })), P = new DOMParser().parseFromString(C, "image/svg+xml"), F = P.querySelector("svg");
              T.parentNode.replaceChild(F, T);
            }
            function x(T) {
              return Array.from(T.attributes).reduce(function(v, w) {
                return v[w.name] = w.value, v;
              }, {});
            }
            n.default = f;
          }
        ),
        /***/
        "./src/tags.json": (
          /*!***********************!*\
            !*** ./src/tags.json ***!
            \***********************/
          /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, archive, at-sign, award, aperture, bar-chart, bar-chart-2, battery, battery-charging, bell, bell-off, bluetooth, book-open, book, bookmark, box, briefcase, calendar, camera, cast, chevron-down, chevron-up, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-rain, cloud-snow, cloud, codepen, codesandbox, code, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, dollar-sign, droplet, edit, edit-2, edit-3, eye, eye-off, external-link, facebook, fast-forward, figma, file-minus, file-plus, file-text, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, instagram, key, layers, layout, life-bouy, link, link-2, linkedin, list, lock, log-in, log-out, mail, map-pin, map, maximize, maximize-2, meh, menu, message-circle, message-square, mic-off, mic, minimize, minimize-2, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation, navigation-2, octagon, package, paperclip, pause, pause-circle, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, play, pie-chart, play-circle, plus, plus-circle, plus-square, pocket, power, printer, radio, refresh-cw, refresh-ccw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, settings, share-2, shield, shield-off, shopping-bag, shopping-cart, shuffle, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, star, stop-circle, sun, sunrise, sunset, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash, trash-2, triangle, truck, tv, twitch, twitter, type, umbrella, unlock, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume, volume-1, volume-2, volume-x, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
          /***/
          function(t) {
            t.exports = { activity: ["pulse", "health", "action", "motion"], airplay: ["stream", "cast", "mirroring"], "alert-circle": ["warning", "alert", "danger"], "alert-octagon": ["warning", "alert", "danger"], "alert-triangle": ["warning", "alert", "danger"], "align-center": ["text alignment", "center"], "align-justify": ["text alignment", "justified"], "align-left": ["text alignment", "left"], "align-right": ["text alignment", "right"], anchor: [], archive: ["index", "box"], "at-sign": ["mention", "at", "email", "message"], award: ["achievement", "badge"], aperture: ["camera", "photo"], "bar-chart": ["statistics", "diagram", "graph"], "bar-chart-2": ["statistics", "diagram", "graph"], battery: ["power", "electricity"], "battery-charging": ["power", "electricity"], bell: ["alarm", "notification", "sound"], "bell-off": ["alarm", "notification", "silent"], bluetooth: ["wireless"], "book-open": ["read", "library"], book: ["read", "dictionary", "booklet", "magazine", "library"], bookmark: ["read", "clip", "marker", "tag"], box: ["cube"], briefcase: ["work", "bag", "baggage", "folder"], calendar: ["date"], camera: ["photo"], cast: ["chromecast", "airplay"], "chevron-down": ["expand"], "chevron-up": ["collapse"], circle: ["off", "zero", "record"], clipboard: ["copy"], clock: ["time", "watch", "alarm"], "cloud-drizzle": ["weather", "shower"], "cloud-lightning": ["weather", "bolt"], "cloud-rain": ["weather"], "cloud-snow": ["weather", "blizzard"], cloud: ["weather"], codepen: ["logo"], codesandbox: ["logo"], code: ["source", "programming"], coffee: ["drink", "cup", "mug", "tea", "cafe", "hot", "beverage"], columns: ["layout"], command: ["keyboard", "cmd", "terminal", "prompt"], compass: ["navigation", "safari", "travel", "direction"], copy: ["clone", "duplicate"], "corner-down-left": ["arrow", "return"], "corner-down-right": ["arrow"], "corner-left-down": ["arrow"], "corner-left-up": ["arrow"], "corner-right-down": ["arrow"], "corner-right-up": ["arrow"], "corner-up-left": ["arrow"], "corner-up-right": ["arrow"], cpu: ["processor", "technology"], "credit-card": ["purchase", "payment", "cc"], crop: ["photo", "image"], crosshair: ["aim", "target"], database: ["storage", "memory"], delete: ["remove"], disc: ["album", "cd", "dvd", "music"], "dollar-sign": ["currency", "money", "payment"], droplet: ["water"], edit: ["pencil", "change"], "edit-2": ["pencil", "change"], "edit-3": ["pencil", "change"], eye: ["view", "watch"], "eye-off": ["view", "watch", "hide", "hidden"], "external-link": ["outbound"], facebook: ["logo", "social"], "fast-forward": ["music"], figma: ["logo", "design", "tool"], "file-minus": ["delete", "remove", "erase"], "file-plus": ["add", "create", "new"], "file-text": ["data", "txt", "pdf"], film: ["movie", "video"], filter: ["funnel", "hopper"], flag: ["report"], "folder-minus": ["directory"], "folder-plus": ["directory"], folder: ["directory"], framer: ["logo", "design", "tool"], frown: ["emoji", "face", "bad", "sad", "emotion"], gift: ["present", "box", "birthday", "party"], "git-branch": ["code", "version control"], "git-commit": ["code", "version control"], "git-merge": ["code", "version control"], "git-pull-request": ["code", "version control"], github: ["logo", "version control"], gitlab: ["logo", "version control"], globe: ["world", "browser", "language", "translate"], "hard-drive": ["computer", "server", "memory", "data"], hash: ["hashtag", "number", "pound"], headphones: ["music", "audio", "sound"], heart: ["like", "love", "emotion"], "help-circle": ["question mark"], hexagon: ["shape", "node.js", "logo"], home: ["house", "living"], image: ["picture"], inbox: ["email"], instagram: ["logo", "camera"], key: ["password", "login", "authentication", "secure"], layers: ["stack"], layout: ["window", "webpage"], "life-bouy": ["help", "life ring", "support"], link: ["chain", "url"], "link-2": ["chain", "url"], linkedin: ["logo", "social media"], list: ["options"], lock: ["security", "password", "secure"], "log-in": ["sign in", "arrow", "enter"], "log-out": ["sign out", "arrow", "exit"], mail: ["email", "message"], "map-pin": ["location", "navigation", "travel", "marker"], map: ["location", "navigation", "travel"], maximize: ["fullscreen"], "maximize-2": ["fullscreen", "arrows", "expand"], meh: ["emoji", "face", "neutral", "emotion"], menu: ["bars", "navigation", "hamburger"], "message-circle": ["comment", "chat"], "message-square": ["comment", "chat"], "mic-off": ["record", "sound", "mute"], mic: ["record", "sound", "listen"], minimize: ["exit fullscreen", "close"], "minimize-2": ["exit fullscreen", "arrows", "close"], minus: ["subtract"], monitor: ["tv", "screen", "display"], moon: ["dark", "night"], "more-horizontal": ["ellipsis"], "more-vertical": ["ellipsis"], "mouse-pointer": ["arrow", "cursor"], move: ["arrows"], music: ["note"], navigation: ["location", "travel"], "navigation-2": ["location", "travel"], octagon: ["stop"], package: ["box", "container"], paperclip: ["attachment"], pause: ["music", "stop"], "pause-circle": ["music", "audio", "stop"], "pen-tool": ["vector", "drawing"], percent: ["discount"], "phone-call": ["ring"], "phone-forwarded": ["call"], "phone-incoming": ["call"], "phone-missed": ["call"], "phone-off": ["call", "mute"], "phone-outgoing": ["call"], phone: ["call"], play: ["music", "start"], "pie-chart": ["statistics", "diagram"], "play-circle": ["music", "start"], plus: ["add", "new"], "plus-circle": ["add", "new"], "plus-square": ["add", "new"], pocket: ["logo", "save"], power: ["on", "off"], printer: ["fax", "office", "device"], radio: ["signal"], "refresh-cw": ["synchronise", "arrows"], "refresh-ccw": ["arrows"], repeat: ["loop", "arrows"], rewind: ["music"], "rotate-ccw": ["arrow"], "rotate-cw": ["arrow"], rss: ["feed", "subscribe"], save: ["floppy disk"], scissors: ["cut"], search: ["find", "magnifier", "magnifying glass"], send: ["message", "mail", "email", "paper airplane", "paper aeroplane"], settings: ["cog", "edit", "gear", "preferences"], "share-2": ["network", "connections"], shield: ["security", "secure"], "shield-off": ["security", "insecure"], "shopping-bag": ["ecommerce", "cart", "purchase", "store"], "shopping-cart": ["ecommerce", "cart", "purchase", "store"], shuffle: ["music"], "skip-back": ["music"], "skip-forward": ["music"], slack: ["logo"], slash: ["ban", "no"], sliders: ["settings", "controls"], smartphone: ["cellphone", "device"], smile: ["emoji", "face", "happy", "good", "emotion"], speaker: ["audio", "music"], star: ["bookmark", "favorite", "like"], "stop-circle": ["media", "music"], sun: ["brightness", "weather", "light"], sunrise: ["weather", "time", "morning", "day"], sunset: ["weather", "time", "evening", "night"], tablet: ["device"], tag: ["label"], target: ["logo", "bullseye"], terminal: ["code", "command line", "prompt"], thermometer: ["temperature", "celsius", "fahrenheit", "weather"], "thumbs-down": ["dislike", "bad", "emotion"], "thumbs-up": ["like", "good", "emotion"], "toggle-left": ["on", "off", "switch"], "toggle-right": ["on", "off", "switch"], tool: ["settings", "spanner"], trash: ["garbage", "delete", "remove", "bin"], "trash-2": ["garbage", "delete", "remove", "bin"], triangle: ["delta"], truck: ["delivery", "van", "shipping", "transport", "lorry"], tv: ["television", "stream"], twitch: ["logo"], twitter: ["logo", "social"], type: ["text"], umbrella: ["rain", "weather"], unlock: ["security"], "user-check": ["followed", "subscribed"], "user-minus": ["delete", "remove", "unfollow", "unsubscribe"], "user-plus": ["new", "add", "create", "follow", "subscribe"], "user-x": ["delete", "remove", "unfollow", "unsubscribe", "unavailable"], user: ["person", "account"], users: ["group"], "video-off": ["camera", "movie", "film"], video: ["camera", "movie", "film"], voicemail: ["phone"], volume: ["music", "sound", "mute"], "volume-1": ["music", "sound"], "volume-2": ["music", "sound"], "volume-x": ["music", "sound", "mute"], watch: ["clock", "time"], "wifi-off": ["disabled"], wifi: ["connection", "signal", "wireless"], wind: ["weather", "air"], "x-circle": ["cancel", "close", "delete", "remove", "times", "clear"], "x-octagon": ["delete", "stop", "alert", "warning", "times", "clear"], "x-square": ["cancel", "close", "delete", "remove", "times", "clear"], x: ["cancel", "close", "delete", "remove", "times", "clear"], youtube: ["logo", "video", "play"], "zap-off": ["flash", "camera", "lightning"], zap: ["flash", "camera", "lightning"], "zoom-in": ["magnifying glass"], "zoom-out": ["magnifying glass"] };
          }
        ),
        /***/
        "./src/to-svg.js": (
          /*!***********************!*\
            !*** ./src/to-svg.js ***!
            \***********************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            Object.defineProperty(n, "__esModule", {
              value: !0
            });
            var s = i(
              /*! ./icons */
              "./src/icons.js"
            ), a = o(s);
            function o(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function l(c) {
              var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              if (console.warn("feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."), !c)
                throw new Error("The required `key` (icon name) parameter is missing.");
              if (!a.default[c])
                throw new Error("No icon matching '" + c + "'. See the complete list of icons at https://feathericons.com");
              return a.default[c].toSvg(u);
            }
            n.default = l;
          }
        ),
        /***/
        0: (
          /*!**************************************************!*\
            !*** multi core-js/es/array/from ./src/index.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(t, n, i) {
            i(
              /*! core-js/es/array/from */
              "./node_modules/core-js/es/array/from.js"
            ), t.exports = i(
              /*! /home/runner/work/feather/feather/src/index.js */
              "./src/index.js"
            );
          }
        )
        /******/
      })
    );
  });
})(Up);
var Ul = Up.exports;
const r3 = /* @__PURE__ */ zi(Ul), n3 = /* @__PURE__ */ ob({
  __proto__: null,
  default: r3
}, [Ul]);
/*! vue-feather v2.0.0 | (c) 2018-present Chen Fengyuan | MIT */
var vn = vr({
  name: "VueFeather",
  props: {
    animation: {
      type: String,
      default: void 0
    },
    animationSpeed: {
      type: String,
      default: void 0
    },
    fill: {
      type: String,
      default: "none"
    },
    size: {
      type: [Number, String],
      default: 24
    },
    stroke: {
      type: String,
      default: "currentColor"
    },
    strokeLinecap: {
      type: String,
      default: "round"
    },
    strokeLinejoin: {
      type: String,
      default: "round"
    },
    strokeWidth: {
      type: [Number, String],
      default: 2
    },
    tag: {
      type: String,
      default: "i"
    },
    type: {
      type: String,
      default: "feather",
      validator(r) {
        if (!n3)
          throw new Error("The Feather icons is required.");
        if (!Ul.icons[r])
          throw new Error(`"${r}" is not an available icon type.`);
        return !0;
      }
    }
  },
  computed: {
    isRemSize() {
      return typeof this.size == "string" && this.size.endsWith("rem");
    }
  },
  render() {
    const { animation: r, animationSpeed: e, isRemSize: t, size: n, type: i } = this, s = Ul.icons[i];
    return Kt(this.tag, {
      ...this.$attrs,
      "data-name": i,
      "data-tags": s.tags,
      "data-type": i,
      class: {
        "vue-feather": !0,
        [`vue-feather--${i}`]: i,
        [`vue-feather--${r}`]: r,
        [`vue-feather--${e}`]: e
      },
      style: t ? {
        height: n,
        width: n
      } : void 0
    }, [
      Kt(
        "svg",
        // XXX: The `width` and `height` attributes do not support the `rem` unit in Safari (#13).
        {
          ...s.attrs,
          fill: this.fill,
          height: t ? void 0 : n,
          stroke: this.stroke,
          "stroke-linecap": this.strokeLinecap,
          "stroke-linejoin": this.strokeLinejoin,
          "stroke-width": this.strokeWidth,
          width: t ? void 0 : n,
          class: [s.attrs.class, "vue-feather__content"],
          innerHTML: s.contents
        }
      )
    ]);
  }
});
function i3(r, e) {
  e === void 0 && (e = {});
  var t = e.insertAt;
  if (!(!r || typeof document > "u")) {
    var n = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = r : i.appendChild(document.createTextNode(r));
  }
}
var s3 = "@keyframes vue-feather--spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.vue-feather{display:inline-block;overflow:hidden}.vue-feather--spin{animation:vue-feather--spin 2s linear infinite}.vue-feather--pulse{animation:vue-feather--spin 2s steps(8) infinite}.vue-feather--slow{animation-duration:3s}.vue-feather--fast{animation-duration:1s}.vue-feather__content{display:block;height:inherit;width:inherit}";
i3(s3);
const a3 = ["onKeyup", "aria-selected", "aria-label"], o3 = {
  key: 1,
  tabindex: "-1",
  class: "w-6 h-6"
}, l3 = { tabindex: "-1" }, c3 = ["innerHTML"], u3 = ["innerHTML"], d3 = {
  key: 0,
  tabindex: "-1",
  "data-out-of-stock-label": "",
  class: "text-sm font-bold text-red-500"
}, f3 = {
  key: 1,
  "data-unavailable-at-size-label": "",
  class: "italic text-orange-500"
}, Zi = /* @__PURE__ */ vr({
  __name: "Attribute",
  props: {
    label: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    isSizeCompatible: {
      type: Boolean,
      default: !0
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    isOutOfStock: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = r, n = Y(() => [
      "flex items-center gap-4 pl-2",
      t.isSelected ? "font-bold" : ""
    ]), i = Y(() => [
      t.isOutOfStock ? "text-gray-500 italic" : ""
    ]), s = Y(() => [
      "p-3 border-b border-gray-100",
      t.isSelected ? "bg-vanilla-50" : "",
      t.isSizeCompatible ? "cursor-pointer hover:bg-gray-50" : "text-gray-500",
      t.isOutOfStock || !t.isSizeCompatible ? "pointer-events-none" : ""
    ]), a = () => {
      t.isSizeCompatible && e("click");
    };
    return (o, l) => (N(), j("div", {
      class: Pe(m(s)),
      onClick: a,
      onKeyup: Us(a, ["enter"]),
      tabindex: "0",
      role: "option",
      "aria-selected": r.isSelected,
      "aria-label": r.label + " " + r.description + " " + o.$t("message.customizer.configurator.attribute.outOfStock")
    }, [
      _("div", {
        class: Pe(m(n)),
        tabindex: "-1"
      }, [
        r.isSelected ? (N(), Ne(m(vn), {
          key: 0,
          type: "check",
          class: "w-6 h-6 text-olive-500",
          tabindex: "-1"
        })) : (N(), j("div", o3)),
        _("div", l3, [
          _("div", {
            tabindex: "-1",
            class: Pe(m(i))
          }, [
            _("span", { innerHTML: r.label }, null, 8, c3),
            r.description ? (N(), j("div", {
              key: 0,
              tabindex: "-1",
              class: "flex text-sm italic",
              "data-description-label": "",
              innerHTML: r.description
            }, null, 8, u3)) : se("", !0)
          ], 2),
          r.isOutOfStock ? (N(), j("div", d3, he(o.$t("message.customizer.configurator.attribute.outOfStock")), 1)) : se("", !0),
          !t.isSizeCompatible && !t.isOutOfStock ? (N(), j("div", f3, he(o.$t("message.customizer.configurator.attribute.unavailableAtSelectedSize")), 1)) : se("", !0)
        ])
      ], 2)
    ], 42, a3));
  }
}), h3 = ["aria-checked", "aria-label", "onKeyup"], p3 = {
  key: 0,
  tabindex: "-1",
  class: "mr-1"
}, m3 = {
  key: 0,
  "data-testid": "radio-unchecked"
}, g3 = /* @__PURE__ */ _("svg", {
  class: "w-5 h-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ _("path", { d: "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" })
], -1), x3 = [
  g3
], b3 = {
  key: 1,
  "data-testid": "radio-checked"
}, v3 = /* @__PURE__ */ _("svg", {
  class: "w-5 h-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ _("path", { d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
], -1), y3 = [
  v3
], w3 = { tabindex: "-1" }, _3 = {
  class: "text-xs italic",
  tabindex: "-1"
}, oa = /* @__PURE__ */ vr({
  __name: "RadioButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    includesCheckmark: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    labelWidth: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = r, n = qx(), i = Y(() => [
      "text-center px-3 md:px-4 flex items-center w-1/2",
      t.checked ? "bg-vanilla-50 shadow-thin" : "bg-white border border-black",
      t.disabled ? "opacity-50 hover:cursor-not-allowed pointer-events-none" : "hover:cursor-pointer hover:bg-vanilla-50",
      n.icon ? "py-4 flex-col" : "h-10 justify-center"
    ]), s = Y(() => [
      "flex items-center justify-center",
      t.checked ? "font-bold" : "",
      t.labelWidth ? t.labelWidth : ""
    ]), a = () => {
      t.disabled || e("click");
    }, o = Y(() => t.isLoading === !0);
    return (l, c) => (N(), j("div", {
      "aria-checked": r.checked,
      tabindex: "0",
      "aria-label": r.label + ": " + r.description,
      class: Pe(m(i)),
      onClick: a,
      onKeyup: Us(a, ["enter"])
    }, [
      an(l.$slots, "icon"),
      m(o) ? (N(), j("span", {
        key: 0,
        class: Pe([m(s), "h-6"])
      }, [
        ae(m(Cn), { class: "w-5 h-5" })
      ], 2)) : (N(), j("div", {
        key: 1,
        class: Pe(m(s)),
        tabindex: "-1"
      }, [
        r.includesCheckmark ? (N(), j("span", p3, [
          t.checked ? se("", !0) : (N(), j("span", m3, x3)),
          t.checked ? (N(), j("span", b3, y3)) : se("", !0)
        ])) : se("", !0),
        _("span", w3, he(r.label), 1)
      ], 2)),
      _("div", _3, he(r.description), 1)
    ], 42, h3));
  }
}), va = 0, E3 = 1, A3 = {
  key: 0,
  class: "w-full"
}, S3 = {
  key: 0,
  class: "pl-1"
}, T3 = { key: 1 }, M3 = {
  key: 0,
  class: "pl-1 pb-3 pt-1"
}, I3 = {
  key: 1,
  class: "text-red-500 pb-2"
}, C3 = { class: "mb-3" }, P3 = { class: "grid grid-cols-5 gap-y-2" }, k3 = {
  key: 0,
  class: "h-14 w-14 border relative rounded-full mx-auto"
}, O3 = ["alt", "onClick", "src"], N3 = {
  key: 0,
  class: "absolute top-0 left-0 w-full h-full"
}, R3 = /* @__PURE__ */ _("svg", {
  class: "w-full text-red-500 fill-current h-full",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}, [
  /* @__PURE__ */ _("path", { d: "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z" })
], -1), L3 = [
  R3
], D3 = { key: 2 }, F3 = /* @__PURE__ */ _("p", { class: "text-red-500" }, 'No mats available at this size, choose new size or "No mat."', -1), B3 = [
  F3
], Qc = /* @__PURE__ */ vr({
  __name: "MatOption",
  props: {
    selectedMat: {
      type: String,
      default: null
    },
    selectedMatWidth: {
      type: Number,
      default: null
    },
    mats: {
      type: Object,
      default: null
    },
    heading: {
      type: String,
      default: ""
    },
    matBorders: {
      type: Object,
      default: null
    },
    index: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    tabKey: {
      type: String,
      default: "outer"
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["matUpdate", "updateMatColour", "matBorderUpdate", "activateTab"],
  setup(r, { emit: e }) {
    const t = r, n = Y(() => t.selectedMat), i = (l) => t.mats ? t.mats[l].availabilityStatus === va : !1, s = (l) => {
      e("matUpdate", l.toString());
    }, a = (l) => {
      e("updateMatColour", l.toString(), t.tabKey);
    }, o = (l) => {
      e("matBorderUpdate", l);
    };
    return pi(() => {
      t.selectedMat && t.mats[t.selectedMat] && a(t.mats[t.selectedMat].colour, t.tabKey);
    }), (l, c) => r.isActive ? (N(), j("div", A3, [
      _("div", null, [
        r.isMobile ? se("", !0) : (N(), j("span", S3, he(r.heading), 1)),
        Object.keys(r.mats).length > 0 ? (N(), j("div", T3, [
          _("div", {
            class: Pe(["flex flex-wrap items-center mb-3 mt-2", r.matBorders.length >= 4 ? "gap-2 md:gap-1" : "gap-1"])
          }, [
            (N(!0), j(De, null, wt(r.matBorders, (u, f) => (N(), Ne(m(oa), {
              key: f,
              label: u.label,
              checked: r.selectedMatWidth == u.value,
              onClick: (p) => o(u.value),
              class: Pe(r.matBorders.length >= 4 ? "w-16 md:w-24" : "w-24")
            }, null, 8, ["label", "checked", "onClick", "class"]))), 128))
          ], 2),
          m(n) && r.mats[m(n)] ? (N(), j("p", M3, [
            _("span", null, he(r.mats[m(n)].label.toLowerCase().replace(/\b\w/g, (u) => u.toUpperCase())), 1),
            Ea(" (" + he(m(n)) + ") ", 1)
          ])) : se("", !0),
          m(n) && !r.mats[m(n)] ? (N(), j("p", I3, "Selected mat and size are incompatible")) : se("", !0),
          _("div", C3, [
            _("div", P3, [
              (N(!0), j(De, null, wt(r.mats, (u, f) => (N(), j(De, { key: f }, [
                !i(f) || i(f) && m(n) === f ? (N(), j("div", k3, [
                  _("img", {
                    alt: u.label,
                    class: Pe([
                      "h-full w-full cursor-pointer rounded-full",
                      m(n) === f ? "border-2 border-green-700 p-1" : "border-gray-200",
                      i(f) ? "opacity-50" : ""
                    ]),
                    onClick: (p) => {
                      s(f), a(u.colour, t.tabKey);
                    },
                    src: u.thumbUrl
                  }, null, 10, O3),
                  i(f) ? (N(), j("div", N3, L3)) : se("", !0)
                ])) : se("", !0)
              ], 64))), 128))
            ])
          ])
        ])) : (N(), j("div", D3, B3))
      ])
    ])) : se("", !0);
  }
}), j3 = {
  props: {
    label: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: !1
    },
    overlay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        this.overlay ? "z-40" : ""
      ];
    },
    classListBackground() {
      return [
        "absolute inset-0 bg-white opacity-75 z-10"
      ];
    },
    classListSpinner() {
      return [
        "w-6 h-6 stroke-current"
      ];
    },
    classListLabel() {
      return [
        "text-sm text-center"
      ];
    }
  }
}, U3 = { class: "absolute top-50 left-50 -translate-center z-20 flex flex-col items-center justify-center" }, z3 = /* @__PURE__ */ _("circle", {
  "data-path": "",
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none"
}, null, -1), W3 = [
  z3
];
function H3(r, e, t, n, i, s) {
  return N(), Ne(br, { name: "transition-fade" }, {
    default: Se(() => [
      Ke(_("div", {
        class: Pe(s.classList)
      }, [
        t.overlay ? (N(), j("div", {
          key: 0,
          "data-background": "",
          class: Pe(s.classListBackground)
        }, null, 2)) : se("", !0),
        _("div", U3, [
          (N(), j("svg", {
            "data-loader": "",
            viewBox: "25 25 50 50",
            class: Pe(s.classListSpinner)
          }, W3, 2)),
          t.label ? (N(), j("div", {
            key: 0,
            "data-label": "",
            class: Pe(s.classListLabel)
          }, he(t.label), 3)) : se("", !0)
        ])
      ], 2), [
        [tt, t.visible]
      ])
    ]),
    _: 1
  });
}
const lc = /* @__PURE__ */ Vt(j3, [["render", H3]]), V3 = {
  components: {
    Loader: lc
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    inverted: {
      type: Boolean,
      default: !1
    },
    primary: {
      type: Boolean,
      default: !1
    },
    secondary: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "btn",
        this.inverted ? "btn--inverted" : "",
        this.disabled ? "btn--disabled" : "",
        this.primary ? "btn--primary" : "",
        this.secondary ? "btn--secondary" : ""
      ];
    },
    classListLabel() {
      return [
        "transition-opacity",
        this.loading ? "opacity-0" : ""
      ];
    },
    classListLoader() {
      return [
        "absolute top-50 left-50 -translate-center text-white transition-opacity",
        this.loading ? "opacity-100" : "opacity-0"
      ];
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}, $3 = ["disabled"];
function G3(r, e, t, n, i, s) {
  const a = Pt("Loader");
  return N(), j("button", {
    class: Pe(s.classList),
    disabled: t.disabled || t.loading,
    onClick: e[0] || (e[0] = (...o) => s.handleClick && s.handleClick(...o))
  }, [
    an(r.$slots, "default"),
    _("div", {
      "data-label": "",
      class: Pe(s.classListLabel)
    }, he(t.label), 3),
    ae(a, {
      visible: t.loading,
      class: Pe(s.classListLoader)
    }, null, 8, ["visible", "class"])
  ], 10, $3);
}
const Xd = /* @__PURE__ */ Vt(V3, [["render", G3]]), K3 = {
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex-grow flex flex-col overflow-hidden relative"
      ];
    }
  }
};
function Y3(r, e, t, n, i, s) {
  return N(), j("div", {
    class: Pe(s.classList)
  }, [
    an(r.$slots, "default")
  ], 2);
}
const zp = /* @__PURE__ */ Vt(K3, [["render", Y3]]), q3 = {
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex justify-center items-center min-h-14 relative"
      ];
    }
  }
};
function Z3(r, e, t, n, i, s) {
  return N(), j("div", {
    class: Pe(s.classList)
  }, [
    an(r.$slots, "default")
  ], 2);
}
const Wp = /* @__PURE__ */ Vt(q3, [["render", Z3]]), J3 = {
  data() {
    return {};
  },
  props: {
    showChat: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    classList() {
      return [
        this.showChat ? "flex justify-center items-center h-14 relative z-10" : "flex justify-end items-center h-14 relative z-10"
      ];
    }
  }
};
function X3(r, e, t, n, i, s) {
  return N(), j("div", {
    class: Pe(s.classList)
  }, [
    an(r.$slots, "default")
  ], 2);
}
const Hp = /* @__PURE__ */ Vt(J3, [["render", X3]]), Q0 = 72, eh = 26e3, Q3 = 7e8, e4 = 1e6, t4 = "landscape", r4 = "portrait", n4 = "square", i4 = (r) => {
  r = r.replace(/\s(?:\S*?)?:?xmlns:?.*?=["']{1}\S*?["']{1}/gmi, "");
  const e = r.match(/<\/?\w*?\b[^>]*>/gmi);
  return e && e.length && r.match(/<svg/gmi) && (e[0] = e[0].replace(/>/mi, ' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'), r = e.join("")), r;
}, s4 = (r) => new XMLSerializer().serializeToString(r), a4 = (r) => new Promise(async (e, t) => {
  const i = /data-original=["'](.*?)["']/.exec(r), s = i ? i[1] : null, a = /(xlink:href=["'])(.*?)(["'])/;
  e(r.replace(a, `$1${s}$3`));
}), Ga = (r, e) => {
  let t = !1;
  if (!r)
    return r;
  r[0] == "#" && (r = r.slice(1), t = !0);
  let n = parseInt(r, 16), i = (n >> 16) + e;
  i > 255 ? i = 255 : i < 0 && (i = 0);
  let s = (n >> 8 & 255) + e;
  s > 255 ? s = 255 : s < 0 && (s = 0);
  let a = (n & 255) + e;
  return a > 255 ? a = 255 : a < 0 && (a = 0), (t ? "#" : "") + (a | s << 8 | i << 16).toString(16);
}, o4 = (r) => {
  const n = new DOMParser().parseFromString(r, "image/svg+xml").querySelectorAll("image"), i = {};
  return n.forEach((s, a) => {
    const o = parseInt(s.getAttribute("data-id"), 10);
    let l = s.getAttribute("data-pane");
    const c = parseFloat(s.getAttribute("data-translate-x")), u = parseFloat(s.getAttribute("data-translate-y")), f = parseFloat(s.getAttribute("data-scale")), p = parseFloat(s.getAttribute("data-rotate"));
    isNaN(parseInt(l, 10)) || (l = `pane_${a + 1}`), i[l] = {
      id: o,
      transform: {
        x: c,
        y: u,
        scale: f,
        rotate: p
      }
    };
  }), i;
}, l4 = (r) => {
  const e = {}, t = c4(r);
  return Object.values(t).map((n, i) => {
    e[`pane_${i + 1}`] = n;
  }), e;
}, c4 = (r) => Object.keys(r).sort((e, t) => parseInt(e.split("_")[1]) - parseInt(t.split("_")[1])).reduce((e, t) => (e[t] = r[t], e), {}), u4 = (r, e) => {
  let t = 1e4, n;
  return r.map((i, s) => {
    const a = Math.abs(i - e);
    a < t && (t = a, n = s);
  }), n;
}, d4 = (r, e, t, n, i) => {
  const s = n * Q0 > r / t, a = i * Q0 > e / t;
  return s || a;
}, f4 = (r) => new Promise(async (e, t) => {
  let n = new FileReader();
  const i = r.slice(0, 4);
  n.readAsArrayBuffer(i), n.onload = function(s) {
    var u;
    const a = new Uint8Array((u = s.target) == null ? void 0 : u.result);
    let o = [];
    a.forEach((f) => {
      o.push(f.toString(16));
    });
    const l = o.join("").toUpperCase();
    let c;
    if (l.includes("FFD8FF"))
      c = !0;
    else
      switch (l) {
        case "89504E47":
        case "00024":
        case "00018":
        case "0001C":
        case "00028":
        case "52494646":
          c = !0;
          break;
        case "49492A0":
        case "4D4D02A":
        case "4D4D002A":
          c = !!(r.type && (r.type === "image/tiff" || r.type === "image/x-tiff"));
          break;
        default:
          c = !1;
          break;
      }
    e(c);
  }, n.onerror = function(s) {
    t(r.name);
  };
}), h4 = (r) => new Promise(async (e, t) => {
  let n;
  if (r.type !== "image/tiff" && r.type !== "image/x-tiff") {
    const i = new Image();
    i.src = URL.createObjectURL(r), await i.decode();
    const s = i.width, a = i.height;
    n = s * a, n < e4 || n > Q3 ? e(!1) : e(!0);
  } else
    e(!0);
}), Vp = (r, e, t) => {
  if (("which" in t ? t.which : t.keyCode) === 9) {
    const i = t.shiftKey;
    i && document.activeElement === r ? (t.preventDefault(), e.focus()) : !i && document.activeElement === e && (t.preventDefault(), r.focus());
  }
}, p4 = (r) => {
  let e = new Image(), t = 1, n = !1;
  const i = () => {
    e.removeEventListener("load", s), e.removeEventListener("error", a);
  }, s = () => {
    n = !0, i();
  }, a = () => {
    t < 3 && !n ? setTimeout(() => {
      t++, e.src = r;
    }, 200) : i();
  };
  e.addEventListener("load", s), e.addEventListener("error", a), e.src = r;
}, m4 = {
  components: {
    ActionButton: Xd,
    Body: zp,
    Footer: Wp,
    Header: Hp,
    VueFeather: vn
  },
  props: {
    heading: {
      type: String,
      default: ""
    },
    hasCancelOption: {
      type: Boolean,
      default: !1
    },
    cancelLabel: {
      type: String,
      default: ""
    },
    confirmLabel: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: !1
    },
    custom: {
      type: Boolean,
      default: !1
    },
    transitionName: {
      type: String,
      default: "transition-fade-pop"
    },
    maxWidth: {
      type: String,
      default: "max-w-md"
    },
    type: {
      type: String,
      default: "info",
      validator: (r) => ["info", "alert", "positive", "negative"].indexOf(r) !== -1
    },
    icon: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      triggerElement: null
    };
  },
  computed: {
    classList() {
      return [
        `bg-${this.shade}-50 text-${this.shade}-500`
      ];
    },
    shade() {
      switch (this.type) {
        case "alert":
          return "orange";
        case "positive":
          return "green";
        case "negative":
          return "red";
        case "info":
        default:
          return "blue";
      }
    },
    iconType() {
      switch (this.type) {
        case "alert":
          return "alert-circle";
        case "positive":
          return "thumbs-up";
        case "negative":
          return "thumbs-down";
        case "info":
        default:
          return "info";
      }
    },
    contentClassList() {
      return [
        this.custom ? "overflow-auto" : "overflow-hidden",
        "relative m-4 bg-white rounded shadow-lg w-full",
        this.maxWidth ? this.maxWidth : "max-w-md"
      ];
    }
  },
  unmounted() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  watch: {
    visible: function(r) {
      r ? (document.body.classList.add("overflow-hidden", "lg:overflow-hidden"), document.body.classList.remove("lg:overflow-auto", "lg:scrolling-touch"), document.addEventListener("keyup", this.handleKeyUp), document.addEventListener("keydown", this.handleKeyDown), this.focusDialog()) : (document.body.classList.add("lg:overflow-auto", "lg:scrolling-touch"), document.body.classList.remove("overflow-hidden", "lg:overflow-hidden"), document.removeEventListener("keyup", this.handleKeyUp), document.removeEventListener("keydown", this.handleKeyDown), this.focusTriggerElement());
    }
  },
  methods: {
    handleCancel() {
      this.hasCancelOption ? this.$emit("cancel") : this.$emit("confirm");
    },
    handleConfirm() {
      this.$emit("confirm");
    },
    handleKeyUp(r) {
      ("which" in r ? r.which : r.keyCode) === 27 && this.handleCancel();
    },
    handleKeyDown(r) {
      const e = this.$refs.confirmBtn;
      e && Vp(this.$refs.dialog, e.$el, r);
    },
    focusDialog() {
      this.triggerElement = document.activeElement, this.$nextTick(() => {
        let r = this.$refs.dialog;
        r == null || r.focus();
      });
    },
    focusTriggerElement() {
      this.$nextTick(() => {
        var r;
        (r = this.triggerElement) == null || r.focus();
      });
    }
  }
}, g4 = { class: "flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left" }, x4 = ["innerHTML"], b4 = {
  "data-body": "",
  class: "text-gray-500 leading-tight text-sm w-full"
}, v4 = {
  key: 0,
  "data-footer": "",
  class: "bg-gray-50 p-3 flex flex-col sm:flex-row sm:justify-end"
};
function y4(r, e, t, n, i, s) {
  const a = Pt("vue-feather"), o = Pt("ActionButton");
  return N(), Ne(br, { name: "transition-fade" }, {
    default: Se(() => [
      Ke(_("div", {
        "data-dialog": "",
        role: "dialog",
        "aria-modal": "true",
        ref: "dialog",
        tabindex: "0",
        class: Pe(["fixed inset-0 z-50 flex justify-center", t.custom ? "items-center" : "items-end sm:items-center"])
      }, [
        _("div", {
          "data-background": "",
          class: "absolute inset-0 bg-black opacity-75",
          onClick: e[0] || (e[0] = q1((...l) => s.handleCancel && s.handleCancel(...l), ["self"]))
        }),
        ae(br, { name: t.transitionName }, {
          default: Se(() => [
            t.visible ? (N(), j("div", {
              key: 0,
              "data-content": "",
              class: Pe(s.contentClassList)
            }, [
              _("div", {
                class: Pe(t.custom ? "" : "p-4")
              }, [
                _("div", g4, [
                  !t.custom && t.icon ? (N(), j("div", {
                    key: 0,
                    "data-icon": "",
                    class: Pe(["w-8 h-8 rounded-full flex justify-center items-center flex-shrink-0", s.classList])
                  }, [
                    ae(a, {
                      type: s.iconType,
                      "data-icon-svg": "",
                      class: "w-4 h-4"
                    }, null, 8, ["type"])
                  ], 2)) : se("", !0),
                  _("div", {
                    class: Pe(["w-full", t.custom ? "" : "pt-2 sm:pt-0 sm:pl-4"])
                  }, [
                    t.heading && !t.custom ? (N(), j("div", {
                      key: 0,
                      "data-heading": "",
                      tabindex: "0",
                      class: "font-bold text-lg mb-2 leading-tight",
                      innerHTML: t.heading ? t.heading : r.$t("message.dialog.heading")
                    }, null, 8, x4)) : se("", !0),
                    _("div", b4, [
                      an(r.$slots, "default")
                    ])
                  ], 2)
                ])
              ], 2),
              t.custom ? se("", !0) : (N(), j("div", v4, [
                t.hasCancelOption ? (N(), Ne(o, {
                  key: 0,
                  class: "order-2 w-auto bg-white mt-2 sm:order-1 sm:mt-0 sm:mr-2",
                  "data-cancel": "",
                  label: t.cancelLabel ? t.cancelLabel : r.$t("message.dialog.cancelLabel"),
                  onClick: s.handleCancel
                }, null, 8, ["label", "onClick"])) : se("", !0),
                ae(o, {
                  class: "order-1 w-auto sm:order-2 text-white btn--primary",
                  "data-confirm": "",
                  ref: "confirmBtn",
                  label: t.confirmLabel ? t.confirmLabel : r.$t("message.dialog.confirmLabel"),
                  onClick: s.handleConfirm
                }, null, 8, ["label", "onClick"])
              ]))
            ], 2)) : se("", !0)
          ]),
          _: 3
        }, 8, ["name"])
      ], 2), [
        [tt, t.visible]
      ])
    ]),
    _: 3
  });
}
const Bu = /* @__PURE__ */ Vt(m4, [["render", y4]]);
function Ao(r, e, ...t) {
  if (r in e) {
    let i = e[r];
    return typeof i == "function" ? i(...t) : i;
  }
  let n = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, Ao), n;
}
var $p = ((r) => (r[r.None = 0] = "None", r[r.RenderStrategy = 1] = "RenderStrategy", r[r.Static = 2] = "Static", r))($p || {}), os = ((r) => (r[r.Unmount = 0] = "Unmount", r[r.Hidden = 1] = "Hidden", r))(os || {});
function Gp({ visible: r = !0, features: e = 0, ourProps: t, theirProps: n, ...i }) {
  var s;
  let a = Yp(n, t), o = Object.assign(i, { props: a });
  if (r || e & 2 && a.static)
    return eu(o);
  if (e & 1) {
    let l = (s = a.unmount) == null || s ? 0 : 1;
    return Ao(l, { 0() {
      return null;
    }, 1() {
      return eu({ ...i, props: { ...a, hidden: !0, style: { display: "none" } } });
    } });
  }
  return eu(o);
}
function eu({ props: r, attrs: e, slots: t, slot: n, name: i }) {
  var s, a;
  let { as: o, ...l } = qp(r, ["unmount", "static"]), c = (s = t.default) == null ? void 0 : s.call(t, n), u = {};
  if (n) {
    let f = !1, p = [];
    for (let [x, T] of Object.entries(n))
      typeof T == "boolean" && (f = !0), T === !0 && p.push(x);
    f && (u["data-headlessui-state"] = p.join(" "));
  }
  if (o === "template") {
    if (c = Kp(c ?? []), Object.keys(l).length > 0 || Object.keys(e).length > 0) {
      let [f, ...p] = c ?? [];
      if (!w4(f) || p.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(e)).map((v) => v.trim()).filter((v, w, E) => E.indexOf(v) === w).sort((v, w) => v.localeCompare(w)).map((v) => `  - ${v}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((v) => `  - ${v}`).join(`
`)].join(`
`));
      let x = Yp((a = f.props) != null ? a : {}, l), T = Pu(f, x);
      for (let v in x)
        v.startsWith("on") && (T.props || (T.props = {}), T.props[v] = x[v]);
      return T;
    }
    return Array.isArray(c) && c.length === 1 ? c[0] : c;
  }
  return Kt(o, Object.assign({}, l, u), { default: () => c });
}
function Kp(r) {
  return r.flatMap((e) => e.type === De ? Kp(e.children) : [e]);
}
function Yp(...r) {
  if (r.length === 0)
    return {};
  if (r.length === 1)
    return r[0];
  let e = {}, t = {};
  for (let n of r)
    for (let i in n)
      i.startsWith("on") && typeof n[i] == "function" ? (t[i] != null || (t[i] = []), t[i].push(n[i])) : e[i] = n[i];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(t).map((n) => [n, void 0])));
  for (let n in t)
    Object.assign(e, { [n](i, ...s) {
      let a = t[n];
      for (let o of a) {
        if (i instanceof Event && i.defaultPrevented)
          return;
        o(i, ...s);
      }
    } });
  return e;
}
function qp(r, e = []) {
  let t = Object.assign({}, r);
  for (let n of e)
    n in t && delete t[n];
  return t;
}
function w4(r) {
  return r == null ? !1 : typeof r.type == "string" || typeof r.type == "object" || typeof r.type == "function";
}
let _4 = 0;
function E4() {
  return ++_4;
}
function A4() {
  return E4();
}
function th(r) {
  var e;
  return r == null || r.value == null ? null : (e = r.value.$el) != null ? e : r.value;
}
let Zp = Symbol("Context");
var Oi = ((r) => (r[r.Open = 1] = "Open", r[r.Closed = 2] = "Closed", r[r.Closing = 4] = "Closing", r[r.Opening = 8] = "Opening", r))(Oi || {});
function S4() {
  return Jp() !== null;
}
function Jp() {
  return ke(Zp, null);
}
function T4(r) {
  Ge(Zp, r);
}
var M4 = Object.defineProperty, I4 = (r, e, t) => e in r ? M4(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, rh = (r, e, t) => (I4(r, typeof e != "symbol" ? e + "" : e, t), t);
let C4 = class {
  constructor() {
    rh(this, "current", this.detect()), rh(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, P4 = new C4();
function Qd() {
  let r = [], e = { addEventListener(t, n, i, s) {
    return t.addEventListener(n, i, s), e.add(() => t.removeEventListener(n, i, s));
  }, requestAnimationFrame(...t) {
    let n = requestAnimationFrame(...t);
    e.add(() => cancelAnimationFrame(n));
  }, nextFrame(...t) {
    e.requestAnimationFrame(() => {
      e.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let n = setTimeout(...t);
    e.add(() => clearTimeout(n));
  }, style(t, n, i) {
    let s = t.style.getPropertyValue(n);
    return Object.assign(t.style, { [n]: i }), this.add(() => {
      Object.assign(t.style, { [n]: s });
    });
  }, group(t) {
    let n = Qd();
    return t(n), this.add(() => n.dispose());
  }, add(t) {
    return r.push(t), () => {
      let n = r.indexOf(t);
      if (n >= 0)
        for (let i of r.splice(n, 1))
          i();
    };
  }, dispose() {
    for (let t of r.splice(0))
      t();
  } };
  return e;
}
function k4(r) {
  let e = { called: !1 };
  return (...t) => {
    if (!e.called)
      return e.called = !0, r(...t);
  };
}
function tu(r, ...e) {
  r && e.length > 0 && r.classList.add(...e);
}
function rl(r, ...e) {
  r && e.length > 0 && r.classList.remove(...e);
}
var ju = ((r) => (r.Finished = "finished", r.Cancelled = "cancelled", r))(ju || {});
function O4(r, e) {
  let t = Qd();
  if (!r)
    return t.dispose;
  let { transitionDuration: n, transitionDelay: i } = getComputedStyle(r), [s, a] = [n, i].map((o) => {
    let [l = 0] = o.split(",").filter(Boolean).map((c) => c.includes("ms") ? parseFloat(c) : parseFloat(c) * 1e3).sort((c, u) => u - c);
    return l;
  });
  return s !== 0 ? t.setTimeout(() => e("finished"), s + a) : e("finished"), t.add(() => e("cancelled")), t.dispose;
}
function nh(r, e, t, n, i, s) {
  let a = Qd(), o = s !== void 0 ? k4(s) : () => {
  };
  return rl(r, ...i), tu(r, ...e, ...t), a.nextFrame(() => {
    rl(r, ...t), tu(r, ...n), a.add(O4(r, (l) => (rl(r, ...n, ...e), tu(r, ...i), o(l))));
  }), a.add(() => rl(r, ...e, ...t, ...n, ...i)), a.add(() => o("cancelled")), a.dispose;
}
function Ts(r = "") {
  return r.split(" ").filter((e) => e.trim().length > 1);
}
let ef = Symbol("TransitionContext");
var N4 = ((r) => (r.Visible = "visible", r.Hidden = "hidden", r))(N4 || {});
function R4() {
  return ke(ef, null) !== null;
}
function L4() {
  let r = ke(ef, null);
  if (r === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return r;
}
function D4() {
  let r = ke(tf, null);
  if (r === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return r;
}
let tf = Symbol("NestingContext");
function cc(r) {
  return "children" in r ? cc(r.children) : r.value.filter(({ state: e }) => e === "visible").length > 0;
}
function Xp(r) {
  let e = Ee([]), t = Ee(!1);
  pi(() => t.value = !0), Do(() => t.value = !1);
  function n(s, a = os.Hidden) {
    let o = e.value.findIndex(({ id: l }) => l === s);
    o !== -1 && (Ao(a, { [os.Unmount]() {
      e.value.splice(o, 1);
    }, [os.Hidden]() {
      e.value[o].state = "hidden";
    } }), !cc(e) && t.value && (r == null || r()));
  }
  function i(s) {
    let a = e.value.find(({ id: o }) => o === s);
    return a ? a.state !== "visible" && (a.state = "visible") : e.value.push({ id: s, state: "visible" }), () => n(s, os.Unmount);
  }
  return { children: e, register: i, unregister: n };
}
let Qp = $p.RenderStrategy, rf = vr({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(r, { emit: e, attrs: t, slots: n, expose: i }) {
  let s = Ee(0);
  function a() {
    s.value |= Oi.Opening, e("beforeEnter");
  }
  function o() {
    s.value &= ~Oi.Opening, e("afterEnter");
  }
  function l() {
    s.value |= Oi.Closing, e("beforeLeave");
  }
  function c() {
    s.value &= ~Oi.Closing, e("afterLeave");
  }
  if (!R4() && S4())
    return () => Kt(nf, { ...r, onBeforeEnter: a, onAfterEnter: o, onBeforeLeave: l, onAfterLeave: c }, n);
  let u = Ee(null), f = Y(() => r.unmount ? os.Unmount : os.Hidden);
  i({ el: u, $el: u });
  let { show: p, appear: x } = L4(), { register: T, unregister: v } = D4(), w = Ee(p.value ? "visible" : "hidden"), E = { value: !0 }, C = A4(), P = { value: !1 }, F = Xp(() => {
    !P.value && w.value !== "hidden" && (w.value = "hidden", v(C), c());
  });
  pi(() => {
    let L = T(C);
    Do(L);
  }), Ll(() => {
    if (f.value === os.Hidden && C) {
      if (p.value && w.value !== "visible") {
        w.value = "visible";
        return;
      }
      Ao(w.value, { hidden: () => v(C), visible: () => T(C) });
    }
  });
  let k = Ts(r.enter), K = Ts(r.enterFrom), Z = Ts(r.enterTo), ne = Ts(r.entered), le = Ts(r.leave), ye = Ts(r.leaveFrom), ge = Ts(r.leaveTo);
  pi(() => {
    Ll(() => {
      if (w.value === "visible") {
        let L = th(u);
        if (L instanceof Comment && L.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function _e(L) {
    let d = E.value && !x.value, b = th(u);
    !b || !(b instanceof HTMLElement) || d || (P.value = !0, p.value && a(), p.value || l(), L(p.value ? nh(b, k, K, Z, ne, (S) => {
      P.value = !1, S === ju.Finished && o();
    }) : nh(b, le, ye, ge, ne, (S) => {
      P.value = !1, S === ju.Finished && (cc(F) || (w.value = "hidden", v(C), c()));
    })));
  }
  return pi(() => {
    qr([p], (L, d, b) => {
      _e(b), E.value = !1;
    }, { immediate: !0 });
  }), Ge(tf, F), T4(Y(() => Ao(w.value, { visible: Oi.Open, hidden: Oi.Closed }) | s.value)), () => {
    let { appear: L, show: d, enter: b, enterFrom: S, enterTo: R, entered: D, leave: z, leaveFrom: q, leaveTo: y, ...h } = r, I = { ref: u }, V = { ...h, ...x.value && p.value && P4.isServer ? { class: Pe([t.class, h.class, ...k, ...K]) } : {} };
    return Gp({ theirProps: V, ourProps: I, slot: {}, slots: n, attrs: t, features: Qp, visible: w.value === "visible", name: "TransitionChild" });
  };
} }), F4 = rf, nf = vr({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(r, { emit: e, attrs: t, slots: n }) {
  let i = Jp(), s = Y(() => r.show === null && i !== null ? (i.value & Oi.Open) === Oi.Open : r.show);
  Ll(() => {
    if (![!0, !1].includes(s.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let a = Ee(s.value ? "visible" : "hidden"), o = Xp(() => {
    a.value = "hidden";
  }), l = Ee(!0), c = { show: s, appear: Y(() => r.appear || !l.value) };
  return pi(() => {
    Ll(() => {
      l.value = !1, s.value ? a.value = "visible" : cc(o) || (a.value = "hidden");
    });
  }), Ge(tf, o), Ge(ef, c), () => {
    let u = qp(r, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), f = { unmount: r.unmount };
    return Gp({ ourProps: { ...f, as: "template" }, theirProps: {}, slot: {}, slots: { ...n, default: () => [Kt(F4, { onBeforeEnter: () => e("beforeEnter"), onAfterEnter: () => e("afterEnter"), onBeforeLeave: () => e("beforeLeave"), onAfterLeave: () => e("afterLeave"), ...t, ...f, ...u }, n.default)] }, attrs: {}, features: Qp, visible: a.value === "visible", name: "Transition" });
  };
} });
const B4 = { class: "flex flex-row justify-between items-center border-b p-5 gap-3" }, j4 = {
  class: "relative overflow-auto flex flex-col md:pb-0",
  style: { height: "95%" }
}, U4 = ["innerHTML"], Ms = /* @__PURE__ */ vr({
  __name: "InfoDrawer",
  props: {
    content: {
      type: String,
      default: 1
    },
    show: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(r, { emit: e }) {
    const t = r, n = Y(() => t.isMobile), i = Y(
      () => (n.value, "transform transition ease-in-out duration-300 sm:duration-500")
    ), s = Y(
      () => n.value ? "translate-y-full" : "translate-x-full"
    ), a = Y(
      () => n.value ? "translate-y-0" : "translate-x-0"
    ), o = Y(
      () => (n.value, "transform transition ease-in-out duration-300 sm:duration-500")
    ), l = Y(
      () => n.value ? "translate-y-0" : "translate-x-0"
    ), c = Y(
      () => n.value ? "translate-y-full" : "translate-x-full"
    ), u = () => {
      e("close");
    };
    return (f, p) => (N(), Ne(m(nf), { show: r.show }, {
      default: Se(() => [
        ae(m(rf), {
          as: "template",
          enter: m(i),
          "enter-from": m(s),
          "enter-to": m(a),
          leave: m(o),
          "leave-from": m(l),
          "leave-to": m(c)
        }, {
          default: Se(() => [
            _("div", {
              class: Pe(["fixed top-0 right-0 z-50 md:max-w-screen-md h-full bg-white overflow-hidden", { "w-full": m(n) }]),
              style: qe(m(n) ? null : { maxWidth: "30vw", minWidth: "30vw" })
            }, [
              _("div", B4, [
                _("button", {
                  "data-back-button": "",
                  class: "flex items-center gap-1",
                  onClick: u
                }, [
                  ae(m(vn), {
                    type: "chevron-left",
                    "data-icon-svg": "",
                    class: "block"
                  }),
                  Ea(" " + he(f.$t("message.customizer.buttons.back")), 1)
                ])
              ]),
              _("div", j4, [
                _("span", {
                  "data-content": "",
                  class: "pt-4 px-4 pb-8 text-base font-normal",
                  innerHTML: r.content
                }, null, 8, U4),
                an(f.$slots, "default")
              ])
            ], 6)
          ]),
          _: 3
        }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), z4 = {
  components: {
    Loader: lc
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    image: {
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      src: ""
    };
  },
  computed: {
    classListImage() {
      return [
        "transition-all w-full h-full"
      ];
    }
  },
  mounted() {
    this.src = this.image.default || this.image, this.preload(this.src, this.handleLoad);
  },
  methods: {
    async load() {
      try {
        await Di.head(this.src), this.preload(this.src, this.handleLoad);
      } catch {
        this.handleError();
      }
    },
    preload(r, e) {
      let t = new Image();
      t.onload = e, t.src = r;
    },
    handleLoad() {
      this.loading = !1;
    },
    handleError() {
      this.$emit("error");
    }
  }
};
function W4(r, e, t, n, i, s) {
  const a = Pt("Loader");
  return N(), Ne(br, {
    name: "transition-fade-fast",
    mode: "out-in"
  }, {
    default: Se(() => [
      i.loading ? (N(), Ne(a, {
        key: 1,
        "data-thumbnail-loader": "",
        visible: !0,
        class: "absolute top-50 left-50 -translate-center text-olive-500"
      })) : (N(), j("div", {
        key: 0,
        "data-image": "",
        style: qe({ background: `url('${i.src}') center center / cover` }),
        class: Pe(s.classListImage)
      }, null, 6))
    ]),
    _: 1
  });
}
const Uu = /* @__PURE__ */ Vt(z4, [["render", W4]]), H4 = {
  components: {
    LazyImage: Uu
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    image: {
      default: null
    },
    color: {
      type: String,
      default: "white"
    },
    selected: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click", "error"],
  data() {
    return {};
  },
  computed: {
    classListInner() {
      return [
        "pt-full relative flex-none",
        this.disabled ? "bg-gray-200 cursor-not-allowed" : "bg-gray-50 cursor-pointer"
      ];
    },
    classListWrapper() {
      return [
        "absolute inset-0 flex items-center justify-center overflow-hidden transition-all"
      ];
    }
  },
  methods: {
    handleClick() {
      this.disabled || this.$emit("click");
    },
    handleError() {
      this.$emit("error");
    }
  }
};
function V4(r, e, t, n, i, s) {
  const a = Pt("LazyImage");
  return N(), j("div", {
    onClick: e[0] || (e[0] = (...o) => s.handleClick && s.handleClick(...o)),
    onKeyup: e[1] || (e[1] = Us((...o) => s.handleClick && s.handleClick(...o), ["enter"])),
    "aria-label": "Image thumbnail"
  }, [
    _("div", {
      class: Pe(s.classListInner)
    }, [
      _("div", {
        "data-background": "",
        class: Pe(s.classListWrapper),
        style: qe({ transform: t.selected ? "scale(.75)" : "scale(1)", "background-color": t.color })
      }, [
        t.image ? (N(), Ne(a, {
          key: 0,
          image: t.image,
          onError: s.handleError
        }, null, 8, ["image", "onError"])) : se("", !0)
      ], 6)
    ], 2)
  ], 32);
}
const em = /* @__PURE__ */ Vt(H4, [["render", V4]]), $4 = () => "IntersectionObserver" in window, tm = (r, e, t) => {
  if (!$4()) {
    t();
    return;
  }
  e = Object.assign({}, {
    root: null,
    rootMargin: "0px",
    threshold: 0
  }, e);
  const i = new IntersectionObserver((s) => {
    s.forEach((a) => {
      a.isIntersecting && (t(), i.unobserve(r));
    });
  }, e);
  i.observe(r);
}, G4 = ["onClick"], K4 = ["id"], Y4 = { key: 1 }, q4 = { class: "flex flex-wrap mt-5 mb-1 justify-center gap-1" }, Z4 = { class: "text-center" }, J4 = /* @__PURE__ */ vr({
  __name: "CollectionsPanel",
  props: {
    collections: {
      type: Object,
      default: {}
    },
    selectedCollection: {
      type: String,
      default: ""
    }
  },
  emits: ["selectCollection"],
  setup(r, { emit: e }) {
    const n = Ee(r.collections), i = () => {
      Object.keys(n.value).forEach((c, u) => {
        u <= 10 ? o(c) : s(c);
      });
    }, s = (c) => {
      const u = "placeholder-" + c, f = document.querySelector("#" + u);
      tm(f, {}, async () => {
        o(c);
      });
    }, a = Ee([]), o = (c) => {
      a.value.includes(c) || a.value.push(c);
    }, l = (c) => {
      e("selectCollection", c);
    };
    return pi(() => {
      i();
    }), (c, u) => (N(!0), j(De, null, wt(n.value, (f, p) => (N(), j("div", {
      onClick: (x) => l(p),
      class: Pe(["border pb-4 cursor-pointer", n.value[r.selectedCollection].slug === p ? "bg-gray-50 border-gray-200 " : ""])
    }, [
      a.value.includes(p) ? se("", !0) : (N(), j("div", {
        key: 0,
        id: "placeholder-" + p,
        class: "pt-full"
      }, null, 8, K4)),
      a.value.includes(p) ? (N(), j("div", Y4, [
        _("div", {
          class: Pe(["w-full", n.value[r.selectedCollection].slug === p ? "p-2" : ""])
        }, [
          f.thumbpath ? (N(), Ne(m(em), {
            key: 0,
            "data-thumbnail": "",
            image: f.thumbpath
          }, null, 8, ["image"])) : se("", !0)
        ], 2),
        _("div", q4, [
          (N(!0), j(De, null, wt(f.colors, (x) => (N(), j("div", {
            class: "h-3 w-3 rounded-full border",
            style: qe({ "background-color": x })
          }, null, 4))), 256))
        ]),
        _("p", Z4, he(f.name), 1)
      ])) : se("", !0)
    ], 10, G4))), 256));
  }
}), zu = "PART_ERROR_OUT_OF_STOCK", ih = "PART_ERROR_NOT_SIZE_COMPATIBLE", X4 = { class: "p-5" }, Q4 = {
  key: 0,
  class: "pb-3"
}, ew = {
  key: 0,
  "data-out-of-stock-label": "",
  class: "font-bold"
}, tw = {
  key: 1,
  "data-not-size-compatible-label": "",
  class: "font-bold"
}, rw = {
  role: "list",
  class: "my-4 flex flex-col gap-2"
}, nw = { class: "flex items-center gap-2 text-gray-500" }, iw = {
  key: 1,
  tabindex: "-1",
  class: "w-6 h-6"
}, sw = { role: "listitem" }, Ka = /* @__PURE__ */ vr({
  __name: "UnavailableParts",
  props: {
    unavailablePartsObject: {
      type: Object,
      required: !0
    },
    sizes: {
      type: Object,
      default: null
    },
    frames: {
      type: Object,
      default: null
    },
    selectedPart: {
      type: String,
      required: !0
    }
  },
  setup(r) {
    const e = r;
    return (t, n) => (N(), j("div", X4, [
      (N(!0), j(De, null, wt(e.unavailablePartsObject, (i, s) => (N(), j(De, null, [
        Object.keys(i).length !== 0 ? (N(), j("div", Q4, [
          s === zu ? (N(), j("p", ew, he(t.$t("message.unavailableParts.outOfStock")), 1)) : (N(), j("p", tw, he(t.$t("message.unavailableParts.notSizeCompatible")), 1)),
          _("div", rw, [
            (N(!0), j(De, null, wt(i, (a) => (N(), j("div", nw, [
              r.selectedPart === a.slug ? (N(), Ne(m(vn), {
                key: 0,
                "data-selected-part-check": "",
                type: "check",
                class: "w-6 h-6 text-olive-500",
                tabindex: "-1"
              })) : (N(), j("div", iw)),
              _("div", sw, he(e.sizes && e.frames ? r.sizes[r.frames[a.slug].defaultSize].label : a.label), 1)
            ]))), 256))
          ])
        ])) : se("", !0)
      ], 64))), 256))
    ]));
  }
}), rm = [
  {
    label: "Image Size",
    value: `<p class="mb-4">The max print size depends on which paper substrate you choose to print on. However, most of our state-of-the-art printers will print as large as 50 x 80+ inches. (Length is not an issue because our papers come on long continuous rolls.)</p>
            <p class="mb-4">We can print images with a minimum of 1-inch border as wide as 50 inches. We can stretch canvases up to 50 x 50 inches. However, because of shipping costs, the largest presentation size (including any frame) that you can order online is 48" x 83".</p>
            <p class="mb-4">If you know how to create your own digital files, make sure they are 300 DPI/PPI (dots per inch/pixels per inch) at actual output (print) size. Also, make sure you use RGB (red/green/blue) because our printers and RIP software are profiled to print only RGB files. We prefer .tiff format with no compression, but jpeg format is also acceptable. 
            Note: For those using Photoshop or a similar program, remember to merge all visible layers, including text layers.</p>`
  },
  {
    label: "Paper Options",
    value: `<p class="mb-4 font-bold">Economy Semi-Gloss Photo</p>
            <p class="mb-4">This versatile photo paper is the foundation for all kinds of decor-quality photos and prints. It's a budget-friendly choice with a bright white with a fine pearl finish, best for indoor photos and posters where archival quality is not important.</p>
            <p class="mb-4 font-bold">Premium Glossy Photo</p>
            <p class="mb-4">This ultra-gloss finish has luxuriant depth and vivid color. With a neutral tone, high D-max and ink saturation, this Premium Glossy Photo paper is an outstanding choice for giclee reproductions.</p>
            <p class="mb-4 font-bold">Premium Archival Matte Photo</p>
            <p class="mb-4">Long-lasting and versatile, this heavyweight matte finish paper is engineered for high contrast and a crisp reproduction of high-resolution images. It is a neutral white paper ideal for black and white photography and is acid-free for archival longevity.</p>
            <p class="mb-4 font-bold">Premium Luster Photo</p>
            <p class="mb-4">Preferred by portrait photographers for its cheerful sheen, this luster finish also has a delicate sparkle that makes images of water scintillate. With a neutral tone, high D-max and ink saturation, this is an outstanding choice for giclee reproductions.</p>
            <p class="mb-4 font-bold">Premium Semi-Matte Photo</p>
            <p class="mb-4">Artists and photographers love this paper for its understated semi-matte finish, optimized for maximum presentation quality with minimum glare. With a neutral tone, high D-max and ink saturation, this is an outstanding choice for giclee reproductions.</p>
            <p class="mb-4 font-bold">Cool Tone Picture Rag</p>
            <p class="mb-4">Popular among photographers for its exceptional expression of black and white imagery, Picture Rag also holds incredibly vivid and true colors. Cool Tone Picture Rag is an acid-free paper made from 100% cotton rag for archival longevity.</p>
            <p class="mb-4 font-bold">Velvet Digital Art</p>
            <p class="mb-4">This radiant white paper offers vivid color reproduction and deep, rich blacks for amazing contrast. A subtle texture gently softens the overall effect, adding an extra hint of warmth to reproductions of oils and pastels, and a softer edge to photography. Velvet Digital Art is a 100% cotton rag paper for archival longevity.</p>
            <p class="mb-4 font-bold">Cold Press Watercolor</p>
            <p class="mb-4">The textured finish and satisfying weight of this fine art paper provides an authentic look and feel for reproductions of watercolor art and creates spectacular photography. Collectors will appreciate this paper's rigidity and surface feel. It is a neutral-toned, acid-free paper made from 100% cotton rag for archival longevity.</p>
            <p class="mb-4 font-bold">Hahnemuehle Photo Rag 308</p>
            <p class="mb-4">This paper's extra-smooth, semi-matte surface will pick up every detail. Its bright but neutral tone makes it equally suitable for color and black and white photography. Hahnemuehle Photo Rag 308 paper is made from 100% cotton rag for archival longevity.</p>
            <p class="mb-4 font-bold">Hahnemuehle Bamboo Eco Matte</p>
            <p class="mb-4">Made with fibers from Bamboo grass & pure spring water, this eco-friendly paper is particularly suitable for warm-toned color and monochromatic prints. Bamboo paper has excellent contrast & sharpness and serves well for either black & white or color printing.</p>`
  },
  {
    label: "Canvas Material",
    value: `<p class="mb-4 font-bold">Gallery Grade Satin Canvas</p>
            <p class="mb-4">This white, poly-cotton blend, satin canvas accepts eco-solvent pigmented ink sets, utilizing the ultimate in eco-friendly technology (agent-free brighteners & fluorescent whitening).</p>
            <p class="mb-4">A top-coat isn't required for the Gallery Grade Satin Canvas, making it an economical choice, without compromising quality.</p>
            <p class="mb-4 font-bold">Gallery Grade Glossy Canvas</p>
            <p class="mb-4">This white, poly-cotton blend canvas accepts eco-solvent pigmented ink sets, utilizing the ultimate in eco-friendly technology (agent-free brighteners and fluorescent whitening). A quick drying and low odor topcoat gives the finished canvas a glossy sheen that will elevate any fine art print.</p>`
  },
  {
    label: "Mat Options",
    value: `<p class="mb-4 font-bold">Number of mats</p>
            <p class="mb-4">Start by deciding on the quantity of mats you want to use. Is a classic single mat sufficient, or do you want to make a bolder statement with double layers?</p>
            <p class="mb-4 font-bold">Mat type and material</p>
            <p class="mb-4">Select the type of picture mats that work best for your piece. The material and texture of your mat matters, so choose from decorative and acid-free options as well as suede and metallic mats for your prints and photos.</p>
            <p class="mb-4 font-bold">Mat color</p>
            <p class="mb-4">Once you know how many and the type of mats you need, explore our range of mat color options to find the most complementary custom picture mats for your artwork.</p>
            <p class="mb-4 font-bold">Mat size</p>
            <p class="mb-4">Measure the portion of the artwork or photo that you want visible through the window of the mat to get the inner dimensions. If you already have a picture frame in mind, the frame size will help you determine the outer dimensions of your mat.</p>
            <p class="mb-4">Standard mat sizes go up to 32" x 40". Oversize mat sizes go up to 40" x 60". Wider mats emphasize the art while creating a highly professional, gallery-quality presentation.</p>
            <p class="mb-4">We recommend a mat at least twice as wide as the width of the frame.</p>`
  },
  {
    label: "Acrylic & Backing",
    value: `<p class="mb-4 font-bold">Clear Acrylic - 1/16"</p>
            <p class="mb-4">Consists of a 3/16" thick foamcore backing board and "glass-like" 1/16" thick clear acrylic. This bestseller is a classic finishing choice - perfect for artwork and photography of all kinds. Foamcore is a great choice because it has a higher level of protection for framed items than corrugated backing. Its white finish preserves the integrity of translucent artwork. It doubles as a dust cover thanks to its neat, clean appearance, and it works well for dry mounting objects to the backing.</p>
            <p class="mb-4 font-bold">Non-Glare Acrylic - 1/16"</p>
            <p class="mb-4">Includes all the same benefits as the Clear Acrylic option, but with one major distinction: the 1/16" thick non-glare acrylic cuts down the glare on items in direct light or near windows. Note: This finishing option should not be used with presentations with more than one mat due to increased distortion.</p>
            <p class="mb-4 font-bold">Heavy-Duty Clear Acrylic - 3/32"</p>
            <p class="mb-4">Consists of a 3/16" thick foamcore backing board and "glass-like" 3/32" thick clear acrylic. This best seller is a classic finishing choice - perfect for larger artwork and photography and shadow box presentations. Foamcore is a great choice because it has a higher level of protection for framed items than corrugated backing. It doubles as a dust cover thanks to its neat, clean appearance. The smooth, white surface is ideal for dry mounting objects and preventing ripples in thin artwork.</p>
            <p class="mb-4 font-bold">UV Protective (Archival) Acrylic - 3/32"</p>
            <p class="mb-4">This framing option grants the best protection when preservation is the primary concern. Both the 3/16" thick, acid-free foamcore and the 3/32" thick UV protective acrylic helps guard an image against deterioration and fading - preserving your most treasured, irreplaceable items for generations. Perfect for: Vintage family photos, priceless artwork & historic and heirloom documents.</p>`
  },
  {
    label: "Mounting Hardware",
    value: `<p class="mb-4 font-bold">Wire Hanging Kit</p>
            <p class="mb-4">Acrylic prints with wire hanging kits are made up of 3 parts: the laminated acrylic print (1/16" depth), aluminum composite backing (⅛" depth) and the wooden frame & wire hanging system (½" depth). All of these combined is a total off-wall depth of approximately ¾".</p>
            <p class="mb-4 font-bold">Chrome Standoff Kit</p>
            <p class="mb-4">Acrylic prints with chrome standoffs are made up of 3 parts: the front metal chrome finish standoff cap (¼" depth), laminated acrylic print (¼" depth) and the back metal chrome finish standoff barrel (¾" depth). All of these combined is a total off-wall depth of approximately 1" and a total depth of approximately 1¼".</p>`
  },
  {
    label: "Liners",
    value: '<p class="mb-4">For canvas art, you may want a custom linen liner to give your art a similar look as adding a custom mat. These liners can be paired with 3/4" framed stretch canvases and linen liner-compatible frames so your canvas wall art looks just as refined as your framed photos and prints.</p>'
  },
  {
    label: "Canvas Edge",
    value: `<p class="mb-4 font-bold">Black</p>
            <p class="mb-4">The entire original work will be visible, and the sides where your canvas wraps around the stretcher bar will be black. This treatment is ideal for darker frames, or for standalone canvases.</p>
            <p class="mb-4 font-bold">White</p>
            <p class="mb-4">The entire original work will be visible, and the sides where your canvas wraps around the stretcher bar will be white. This treatment is ideal for lighter frames, or for standalone canvases.</p>
            <p class="mb-4 font-bold">Mirror</p>
            <p class="mb-4">The very edges of your image will be copied and flipped to cover the outer edge of the gallery wrap. The entire original work will be visible. It's just an artistic way to add visual interest to your canvas print (Just be careful selecting this option if the edge of your image has people or words).</p>`
  },
  {
    label: "Additional White Borders",
    value: `<p class="mb-4">Adding a white border to your paper print is optional, but there are reasons why you may want to include one. Here are a few:</p>
            <ul class="list-disc ml-5 mb-4">
                <li class="mb-2">Having that border gives you something to hold on to. Some fine art papers are more likely to show fingerprints if you touch the printed area directly. Having some extra space helps alleviate the potential for damage.</li>
                <li class="mb-2">Additional white borders give you extra space to sign a print. This is crucial in many cases since you might not want to tarnish your actual artwork with a pencil or marker if you are signing prints.</li>
                <li class="mb-2">Borders make it easier to place a print behind matting. If you choose to mat your own paper print, having a border around the print will create a larger sheet size, allowing you to easily position the print behind the mat.</li>
            </ul>`
  },
  {
    label: "Acrylic Finish Kit",
    value: `<p class="mb-4 font-bold">Custom Acrylic Print</p>
            <p class="mb-4">The glossy acrylic print is made up of 3 parts: the laminated acrylic print (1/16" depth), aluminum composite backing (½" depth), and the wooden frame & wire hanging system (½" depth). All of these combined is a total off-wall depth of approximately ¾".</p>
            <p class="mb-4 font-bold">Custom Acrylic Print with Mounting Posts</p>
            <p class="mb-4">The glossy acrylic print with standoffs is made up of 3 parts: the front metal chrome finish standoff cap (¼" depth), laminated acrylic print (¼" depth), and the back metal chrome finish standoff barrel (¾" depth). All of these combined is a total off-wall depth of approximately 1" and a total depth of approximately 1⅛".</p>`
  },
  {
    label: "Canvas Style",
    value: `<p class="mb-4 font-bold">3/4" Thin Standard Wrap</p>
            <p class="mb-4">A 3/4" stretched canvas is a classic presentation that's tautly stretched over an all-wood ⅝" stretcher bar and stapled in place for a finished depth of 3/4". Stapling is always done on the back for the more professional look that sets us apart from our competitors. This classic size is the most frame-friendly depth, finished with a standard, white border wrap and works well with hundreds of frame choices.</p>
            <p class="mb-4 font-bold">1", 1-1/2", or 2" Gallery Wrap</p>
            <p class="mb-4">A gallery wrap uses a thicker, all wood stretcher bar for a final depth of either 1", 1-1/2" or 2". It's most commonly used when the canvas is hung unframed as a stand-alone work of art or in a canvas floater frame with exposed edges.</p>
            <p class="mb-4 font-bold">Unstretched Rolled Canvas Print with 2½" White Border</p>
            <p class="mb-4">Rolled Canvases are prints only, with a 2½" white border around the edge of the canvas. A great choice for professional artists and photographers who want greater flexibility for mounting and framing, it's a more economical solution because it requires no additional stretcher bar materials and it's easier to ship.</p>`
  },
  {
    label: "Print Options",
    value: `<p class="mb-4 font-bold">Paper</p>
            <p class="mb-4">We offer several types of paper, including semi-gloss, glossy, semi-matte, matte, and even watercolor paper. Choose your paper type and learn more when you select "Paper Options".</p>
            <p class="mb-4 font-bold">Canvas</p>
            <p class="mb-4">We have two types of canvases available to print your image on: Gallery Grade Satin Canvas and Gallery Grade Glossy Canvas. Some canvas frames also offer the option to add a liner.</p>`
  },
  {
    label: "Tell Us About Your Art",
    value: `<p class="mb-4 font-bold">DIY Framing Options</p>
            <p class="mb-4">Tell us about the item you are looking to frame. Selecting paper (e.g. photos, certificates, drawings, etc) will give you mat and protective acrylic options. Selecting canvas will not. If you are framing something that fits neither of these (e.g. textile, scarf, jerseys, etc), consider the options that come with either option below to decide what will work best for your application.</p>
            <p class="mb-4 font-bold">Paper</p>
            <p class="mb-4">Choose paper if you are looking to frame a document, certificate, drawing, or physical photo. Selecting paper will give you the option to add single or double mat options to your frame.</p>
            <p class="mb-4 font-bold">Canvas</p>
            <p class="mb-4">Choose canvas if you are looking to frame a physical canvas. Be sure to note the rabbet depth of the frame you've selected in order to ensure it is compatible with the depth of your canvas artwork. For more information on rabbet depth compatibility, <a href="https://www.pictureframes.com/customer-care/faq" class="text-blue-500 underline">see our FAQs</a>.</p>.</p>`
  },
  {
    label: "Choose Your Service",
    value: `<p class="mb-4 font-bold">Print + Frame</p>
            <p class="mb-4">Select this option and we'll print, frame, and ship your uploaded image or document, ready to hang on your wall. We have been custom printing customer images for decades, so rest assured that we will take great care of your beloved art and photos. We accept multiple file types, including TIFF, JPG, PNG, HEIC, and PDF.</p>
            <p class="mb-4"><a href="https://www.pictureframes.com/customer-care/faq/printing" class="text-blue-500 underline">More printing specifications</a></p>
            <p class="mb-4 font-bold">Frame Only</p>
            <p class="mb-4">Choose this option if you are looking for a DIY solution for framing your artwork, photo prints, or certificates at home. Whether you're framing a canvas oil painting, watercolor illustration, diploma, vintage photo, or even a puzzle, choose this option to order the frame and accessories to complete your framing project at home.</p>
            <p class="mb-4"><a href="https://www.pictureframes.com/customer-care/faq/framing" class="text-blue-500 underline">More physical framing specifications</a></p>`
  },
  {
    label: "This frame arrives unassembled.",
    value: `<p class="mb-4 font-bold">Why does this frame arrive unassembled?</p>
            <p class="mb-4">This metal frame will need to be assembled upon arrival. An easy-to-assemble kit, along with hanging hardware, is included. All you need is a screwdriver. Note that if you order this frame with a digital print, your framed artwork will arrive fully assembled.</p>`
  }
], aw = { class: "flex flex-row justify-between items-center border-b p-5 gap-3" }, ow = { class: "flex items-center gap-x-2" }, lw = { class: "text-lg font-bold" }, cw = {
  class: "relative overflow-auto flex flex-col pb-20 md:pb-0",
  style: { height: "calc(100% - 11rem)" }
}, ii = /* @__PURE__ */ vr({
  __name: "Panel",
  props: {
    heading: {
      type: String,
      default: null
    },
    price: {
      type: Number,
      default: null
    },
    hasDiscount: {
      type: Boolean,
      default: !1
    },
    discountFactor: {
      type: Number,
      default: 1
    },
    show: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    awaitApply: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["applyChanges", "cancel"],
  setup(r, { emit: e }) {
    const t = r, n = Y(() => t.isMobile), i = Ee(!1), s = Y(() => {
      const v = rm.find((w) => w.label === t.heading);
      return v ? v.value : "";
    }), a = () => {
      i.value = !1;
    }, o = () => {
      i.value = !0;
    }, l = Y(
      () => (n.value, "transform transition ease-in-out duration-300 sm:duration-500")
    ), c = Y(
      () => n.value ? "translate-y-full" : "translate-x-full"
    ), u = Y(
      () => n.value ? "translate-y-0" : "translate-x-0"
    ), f = Y(
      () => (n.value, "transform transition ease-in-out duration-300 sm:duration-500")
    ), p = Y(
      () => n.value ? "translate-y-0" : "translate-x-0"
    ), x = Y(
      () => n.value ? "translate-y-full" : "translate-x-full"
    ), T = () => {
      e("cancel");
    };
    return (v, w) => (N(), Ne(m(nf), { show: r.show }, {
      default: Se(() => [
        ae(m(rf), {
          as: "template",
          enter: m(l),
          "enter-from": m(c),
          "enter-to": m(u),
          leave: m(f),
          "leave-from": m(p),
          "leave-to": m(x)
        }, {
          default: Se(() => [
            _("div", {
              class: Pe(["fixed top-0 right-0 z-50 md:max-w-screen-md h-full bg-white overflow-hidden", { "w-full": m(n) }]),
              style: qe(m(n) ? null : { maxWidth: "30vw", minWidth: "30vw" })
            }, [
              _("div", aw, [
                _("div", ow, [
                  _("span", lw, he(r.heading), 1),
                  _("button", {
                    onClick: o,
                    class: "flex items-center",
                    "data-info-button": ""
                  }, [
                    ae(m(vn), {
                      type: "info",
                      class: "w-5 h-5"
                    })
                  ]),
                  ae(m(Ms), {
                    show: i.value,
                    heading: r.heading,
                    content: m(s),
                    isMobile: m(n),
                    onClose: a
                  }, null, 8, ["show", "heading", "content", "isMobile"])
                ]),
                _("button", {
                  "data-cancel-button": "",
                  type: "button",
                  onClick: T,
                  class: "rounded-md bg-white font-bold text-olive-500 underline hover:text-gray-800 focus:outline-none"
                }, he(v.$t("message.customizer.buttons.cancel")), 1)
              ]),
              _("div", cw, [
                an(v.$slots, "default")
              ]),
              an(v.$slots, "secondary")
            ], 6)
          ]),
          _: 3
        }, 8, ["enter", "enter-from", "enter-to", "leave", "leave-from", "leave-to"])
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), uw = {
  name: "Printable",
  props: {
    panels: {
      type: Number,
      default: 1
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    edgeDimension: {
      type: Number,
      required: !0
    },
    edgeColor: {
      type: String,
      default: ""
    },
    edgeType: {
      type: String,
      default: ""
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    mgiPrintEdge: {
      type: Number,
      default: 0
    },
    mgiPhotoBorderBleed: {
      type: Number,
      default: 0
    },
    proofIndex: {
      type: Number,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    wrapperPaddingClasslist: {
      type: String,
      default: ""
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: String,
      default: "printable"
    }
  },
  data() {
    return {};
  },
  computed: {
    printableClasslist() {
      return [
        this.renderMode ? "z-0" : "z-10",
        "flex justify-center items-center",
        this.wrapperPaddingClasslist
      ];
    },
    hasPhotoBorder() {
      return (!this.edgeColor || this.mgiPrintEdge !== 0 || this.mgiPhotoBorderBleed !== 0) && !this.hasBlurBorder;
    },
    panelWidth() {
      return this.width / this.panels + 2 * this.edgeDimension;
    },
    panelHeight() {
      return this.height + 2 * this.edgeDimension;
    },
    totalWidth() {
      return this.panelWidth * this.panels;
    },
    edge() {
      return this.hasPhotoBorder ? 2 * this.edgeDimension : 0;
    },
    productWidth() {
      return this.width + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    productHeight() {
      return this.height + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    aspectRatio() {
      return this.width / this.height;
    },
    styleListContainer() {
      return {
        transform: this.aspectRatio >= 1 ? `scale(${(this.width - 2) / this.productWidth})` : `scale(${(this.height - 2) / this.productHeight})`
      };
    },
    sourceSelector() {
      return this.proofIndex !== null ? "#source-" + this.proofIndex : this.tileIndex !== null ? "#source-" + this.tileIndex : "#source";
    },
    hasBlurBorder() {
      var r;
      return ((r = this.featureFlags) == null ? void 0 : r.enableBlurBorder) && this.edgeType === "BLB";
    },
    enlargedPanelWidth() {
      return this.panelWidth + this.edgeDimension;
    },
    enlargedPanelHeight() {
      return this.panelHeight + this.edgeDimension;
    },
    blurBorderWidth() {
      return this.aspectRatio > 1 ? this.width / this.height * this.enlargedPanelHeight : this.enlargedPanelWidth;
    },
    blurBorderHeight() {
      return this.aspectRatio < 1 ? this.height / this.width * this.enlargedPanelWidth : this.enlargedPanelHeight;
    },
    blurBorderPositionX() {
      return this.aspectRatio > 1 ? (this.blurBorderWidth - this.enlargedPanelWidth) / 2 * -1 : this.edgeDimension / 2 * -1;
    },
    blurBorderPositionY() {
      return this.aspectRatio < 1 ? (this.blurBorderHeight - this.enlargedPanelHeight) / 2 * -1 : this.edgeDimension / 2 * -1;
    },
    blurEdgeStyleList() {
      return {
        filter: this.hasBlurBorder ? `blur(${0.25}px)` : "none"
      };
    }
  },
  mounted() {
    this.$el.addEventListener("wheel", () => {
    }, { passive: !0 });
  },
  methods: {
    getIndex(r) {
      return this.proofIndex ? this.proofIndex : r;
    }
  }
}, dw = ["id", "viewBox"], fw = ["id", "viewBox", "width", "height", "x"], hw = ["width", "height", "fill"], pw = ["viewBox", "width", "height", "x", "y"], mw = ["xlink:href"], gw = ["xlink:href"], xw = ["viewBox", "width", "height", "x", "y"], bw = ["id"], vw = ["x", "width", "height"], yw = ["xlink:href", "clip-path"];
function ww(r, e, t, n, i, s) {
  return N(), j("div", {
    class: Pe(["m-auto max-h-full max-w-full absolute inset-0 opacity-0 pointer-events-none", s.printableClasslist])
  }, [
    (N(), j("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: t.id,
      viewBox: `0 0 ${s.totalWidth} ${s.panelHeight}`,
      style: qe(s.styleListContainer),
      class: "pointer-events-auto flex-1 max-w-full max-h-full h-auto w-auto"
    }, [
      an(r.$slots, "default"),
      (N(!0), j(De, null, wt(t.panels, (a, o) => (N(), j("svg", {
        id: `printable-${s.getIndex(o)}-${t.tileIndex}`,
        key: `panel-${s.getIndex(o)}-${t.tileIndex}`,
        class: "pointer-events-none",
        viewBox: `0 0 ${s.panelWidth} ${s.panelHeight}`,
        width: s.panelWidth,
        height: s.panelHeight,
        x: s.panelWidth * s.getIndex(o),
        "aria-hidden": "true",
        tabindex: "-1"
      }, [
        s.hasBlurBorder ? se("", !0) : (N(), j("rect", {
          key: 0,
          x: "0",
          y: "0",
          width: s.panelWidth,
          height: s.panelHeight,
          fill: t.edgeColor
        }, null, 8, hw)),
        s.hasBlurBorder ? (N(), j("svg", {
          key: 1,
          "data-blur-edge": "",
          viewBox: `0 0 ${s.blurBorderWidth} ${s.blurBorderHeight}`,
          width: s.blurBorderWidth,
          height: s.blurBorderHeight,
          x: s.blurBorderPositionX,
          y: s.blurBorderPositionY
        }, [
          _("use", { "xlink:href": s.sourceSelector }, null, 8, mw),
          _("use", {
            style: qe(s.blurEdgeStyleList),
            "xlink:href": s.sourceSelector
          }, null, 12, gw)
        ], 8, pw)) : se("", !0),
        (N(), j("svg", {
          viewBox: `0 0 ${t.width + s.edge} ${t.height + s.edge}`,
          width: t.width + s.edge,
          height: t.height + s.edge,
          x: (s.hasPhotoBorder ? 0 : t.edgeDimension) - t.width / t.panels * o,
          y: s.hasPhotoBorder ? 0 : t.edgeDimension
        }, [
          _("defs", null, [
            _("clipPath", {
              id: `path-${s.getIndex(o)}-${t.tileIndex}`
            }, [
              _("rect", {
                x: t.width / t.panels * o,
                y: "0",
                width: t.width / t.panels + s.edge,
                height: t.height + s.edge,
                fill: "#fff"
              }, null, 8, vw)
            ], 8, bw)
          ]),
          _("use", {
            "xlink:href": s.sourceSelector,
            "clip-path": `url(#path-${s.getIndex(o)}-${t.tileIndex})`,
            tabindex: "-1"
          }, null, 8, yw)
        ], 8, xw))
      ], 8, fw))), 128))
    ], 12, dw))
  ], 2);
}
const _w = /* @__PURE__ */ Vt(uw, [["render", ww]]), nm = "USD", Ew = "CAD", uc = "en-US", Aw = "en-CA", im = "de-DE", sm = "fr-FR", am = uc, om = nm, Xk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CURRENCY_CODE_CA: Ew,
  CURRENCY_CODE_DEFAULT: om,
  CURRENCY_CODE_US: nm,
  LOCALE_CA: Aw,
  LOCALE_DE: im,
  LOCALE_DEFAULT: am,
  LOCALE_FR: sm,
  LOCALE_US: uc
}, Symbol.toStringTag, { value: "Module" })), Sw = {
  name: "Panes",
  components: {
    Pane: Z1(() => Promise.resolve().then(() => GA))
  },
  props: {
    panes: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    edge: {
      type: Number,
      required: !0
    },
    edgeColor: {
      type: String,
      required: !0
    },
    edgeType: {
      type: String,
      default: ""
    },
    border: {
      type: Number,
      required: !0
    },
    borderColor: {
      type: String,
      required: !0
    },
    events: {
      type: Boolean,
      default: !0
    },
    images: {
      type: Object,
      required: !0
    },
    uploadLater: {
      type: Boolean,
      default: !1
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    productSlug: {
      type: String,
      required: !0
    },
    mgiPhotoBorderBleed: {
      type: Number,
      default: 0
    },
    mgiImage: {
      type: Object,
      default: null
    },
    mgiPrintEdge: {
      type: Number,
      default: 0
    },
    proofIndex: {
      type: Number,
      default: null
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    disableCollageOuterBorder: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: String,
      default: null
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    imageEditTrigger: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: uc
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    disableZoomCrop: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    hasPhotoBorder() {
      return (!this.edgeColor || this.mgiPrintEdge !== 0 || this.mgiPhotoBorderBleed !== 0) && this.edgeType !== "BLB";
    },
    mgiOffset() {
      let r = 0;
      return this.mgiPrintEdge ? r = this.mgiPrintEdge - this.edge : this.mgiPhotoBorderBleed && (r = this.mgiPhotoBorderBleed), r;
    },
    borderOffset() {
      return this.disableCollageOuterBorder ? 0 : this.borderDimensions;
    },
    totalWidth() {
      return this.width + (this.hasPhotoBorder ? 2 * this.edge : 0);
    },
    totalHeight() {
      return this.height + (this.hasPhotoBorder ? 2 * this.edge : 0);
    },
    totalInnerWidth() {
      return this.disableCollageOuterBorder ? this.totalWidth + this.borderDimensions : this.totalWidth - this.borderDimensions;
    },
    totalInnerHeight() {
      return this.disableCollageOuterBorder ? this.totalHeight + this.borderDimensions : this.totalHeight - this.borderDimensions;
    },
    aspectRatio() {
      return this.totalWidth / this.totalHeight;
    },
    offset() {
      return this.borderDimensions / 2;
    },
    borderDimensions() {
      return this.totalWidth / 100 * this.border;
    },
    classList() {
      return [
        "flex-1 max-w-full max-h-full absolute bottom-0 right-0 z-40 opacity-100 outline-none",
        this.aspectRatio >= 1 ? "w-full h-auto" : "h-full w-auto"
      ];
    },
    sourceSelectorId() {
      return this.proofIndex !== null ? "source-" + this.proofIndex : this.tileIndex !== null ? "source-" + this.tileIndex : "source";
    },
    filterString() {
      return this.filter && !this.selectedEditToolId ? "url(#" + this.filter + ")" : null;
    },
    lomoPointLightOffsets() {
      return {
        x: this.width / 2 + (this.hasPhotoBorder ? this.edge : 0),
        y: this.height / 2 + (this.hasPhotoBorder ? this.edge : 0)
      };
    }
  },
  methods: {
    handleClick(r) {
      this.$emit("paneClick", r);
    },
    getImage(r) {
      return this.mgiImage ? this.mgiImage : r;
    }
  }
}, Tw = ["id", "viewBox", "filter"], Mw = /* @__PURE__ */ _("filter", { id: "SP" }, [
  /* @__PURE__ */ _("feColorMatrix", {
    type: "matrix",
    values: ` 0.397  0.397  0.397  0.000 -0.005
               0.326  0.326  0.326  0.000 -0.004
               0.261  0.261  0.261  0.000 -0.003
               0.000  0.000  0.000  1.000  0.000`
  })
], -1), Iw = {
  id: "LM",
  "color-interpolation-filters": "sRGB"
}, Cw = /* @__PURE__ */ _("feFlood", {
  id: "vignette-flood",
  x: "0",
  y: "0",
  result: "blackfield",
  "flood-color": "#000000",
  "flood-opacity": "1"
}, null, -1), Pw = {
  id: "vignette-specular",
  result: "spotlight",
  "lighting-color": "#FFFFFF",
  surfaceScale: "1",
  specularConstant: "1",
  specularExponent: 128
}, kw = ["x", "y", "z"], Ow = /* @__PURE__ */ _("feBlend", {
  id: "vignette-mask",
  result: "mask",
  in: "blackfield",
  in2: "spotlight",
  mode: "lighten"
}, null, -1), Nw = /* @__PURE__ */ _("feBlend", {
  id: "vignette-mask-multiply",
  in: "mask",
  in2: "SourceGraphic",
  mode: "multiply",
  result: "vignette-result"
}, null, -1), Rw = /* @__PURE__ */ _("feColorMatrix", {
  type: "matrix",
  values: `1.320 -0.054 -0.003  0.000 -0.035
              -0.015  1.290 -0.003  0.000 -0.035
              -0.015 -0.054  1.340  0.000 -0.035
               0.000  0.000  0.000  1.000  0.000`
}, null, -1), Lw = /* @__PURE__ */ _("filter", { id: "BW" }, [
  /* @__PURE__ */ _("feColorMatrix", {
    type: "matrix",
    values: `0.33 0.33 0.33 0 0
                             0.33 0.33 0.33 0 0
                             0.33 0.33 0.33 0 0
                             0 0 0 1 0`
  })
], -1), Dw = { id: "VT" }, Fw = /* @__PURE__ */ _("feFlood", {
  id: "vignette-flood",
  x: "0",
  y: "0",
  result: "blackfield",
  "flood-color": "#000000",
  "flood-opacity": "1"
}, null, -1), Bw = {
  id: "vignette-specular",
  result: "spotlight",
  "lighting-color": "#FFFFFF",
  surfaceScale: "1",
  specularConstant: "0.7",
  specularExponent: 128
}, jw = ["x", "y", "z"], Uw = /* @__PURE__ */ Fo(`<feBlend id="vignette-mask" result="mask" in="blackfield" in2="spotlight" mode="soft-light"></feBlend><feFlood id="vignette-flood2" x="0" y="0" result="magentaField" flood-color="#FF00FF" flood-opacity="0.04"></feFlood><feBlend id="vignette-mask" result="maskMagenta" in="magentaField" in2="SourceGraphic" mode="soft-light"></feBlend><feBlend id="vignette-mask-multiply" in="mask" in2="maskMagenta" mode="soft-light" result="vignette-result"></feBlend><feColorMatrix type="matrix" values="0.778  0.187  0.038  0.000 -0.012
               0.118  0.641  0.093  0.000 -0.011
               0.095 -0.118  0.889  0.000 -0.011
               0.000  0.000  0.000  1.000  0.000"></feColorMatrix>`, 5), zw = ["width", "height", "fill"];
function Ww(r, e, t, n, i, s) {
  const a = Pt("Pane");
  return N(), j("svg", {
    id: s.sourceSelectorId,
    "data-panes": "",
    viewBox: `0 0 ${s.totalWidth} ${s.totalHeight}`,
    class: Pe(s.classList),
    filter: s.filterString,
    tabindex: "-1"
  }, [
    _("defs", null, [
      Mw,
      _("filter", Iw, [
        Cw,
        _("feSpecularLighting", Pw, [
          _("fePointLight", {
            id: "vignette-pointlight",
            x: s.lomoPointLightOffsets.x,
            y: s.lomoPointLightOffsets.y,
            z: t.width >= t.height ? t.width * 3.25 : t.height * 3.25
          }, null, 8, kw)
        ]),
        Ow,
        Nw,
        Rw
      ]),
      Lw,
      _("filter", Dw, [
        Fw,
        _("feSpecularLighting", Bw, [
          _("fePointLight", {
            id: "vignette-pointlight",
            x: t.width / 2,
            y: t.height / 2,
            z: t.width >= t.height ? t.width * 4 : t.height * 4
          }, null, 8, jw)
        ]),
        Uw
      ])
    ]),
    _("rect", {
      "data-border": "",
      x: "0",
      y: "0",
      width: s.totalWidth,
      height: s.totalHeight,
      fill: t.borderColor
    }, null, 8, zw),
    (N(!0), j(De, null, wt(t.panes, (o) => (N(), Ne(a, {
      key: o.id,
      name: o.id,
      width: s.totalInnerWidth / 100 * o.width - s.borderDimensions + s.mgiOffset * 2,
      height: s.totalInnerHeight / 100 * o.height - s.borderDimensions + s.mgiOffset * 2,
      x: s.totalInnerWidth / 100 * o.left + s.borderOffset - s.mgiOffset,
      y: s.totalInnerHeight / 100 * o.top + s.borderOffset - s.mgiOffset,
      image: s.getImage(t.images[o.id]),
      events: t.events,
      placeholder: !t.uploadLater && !t.images[o.id] && !t.isArt,
      renderMode: t.renderMode,
      "product-slug": t.productSlug,
      selectedEditToolId: t.selectedEditToolId,
      "feature-flags": t.featureFlags,
      imageEditTrigger: t.imageEditTrigger,
      locale: t.locale,
      tileIndex: t.tileIndex,
      disableZoomCrop: t.disableZoomCrop,
      onClick: (l) => s.handleClick(o.id)
    }, null, 8, ["name", "width", "height", "x", "y", "image", "events", "placeholder", "renderMode", "product-slug", "selectedEditToolId", "feature-flags", "imageEditTrigger", "locale", "tileIndex", "disableZoomCrop", "onClick"]))), 128))
  ], 10, Tw);
}
const Hw = /* @__PURE__ */ Vt(Sw, [["render", Ww]]);
var lm = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(r) {
  (function(e, t, n, i) {
    var s = ["", "webkit", "Moz", "MS", "ms", "o"], a = t.createElement("div"), o = "function", l = Math.round, c = Math.abs, u = Date.now;
    function f(M, O, W) {
      return setTimeout(P(M, W), O);
    }
    function p(M, O, W) {
      return Array.isArray(M) ? (x(M, W[O], W), !0) : !1;
    }
    function x(M, O, W) {
      var ee;
      if (M)
        if (M.forEach)
          M.forEach(O, W);
        else if (M.length !== i)
          for (ee = 0; ee < M.length; )
            O.call(W, M[ee], ee, M), ee++;
        else
          for (ee in M)
            M.hasOwnProperty(ee) && O.call(W, M[ee], ee, M);
    }
    function T(M, O, W) {
      var ee = "DEPRECATED METHOD: " + O + `
` + W + ` AT 
`;
      return function() {
        var me = new Error("get-stack-trace"), Te = me && me.stack ? me.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", ze = e.console && (e.console.warn || e.console.log);
        return ze && ze.call(e.console, ee, Te), M.apply(this, arguments);
      };
    }
    var v;
    typeof Object.assign != "function" ? v = function(O) {
      if (O === i || O === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var W = Object(O), ee = 1; ee < arguments.length; ee++) {
        var me = arguments[ee];
        if (me !== i && me !== null)
          for (var Te in me)
            me.hasOwnProperty(Te) && (W[Te] = me[Te]);
      }
      return W;
    } : v = Object.assign;
    var w = T(function(O, W, ee) {
      for (var me = Object.keys(W), Te = 0; Te < me.length; )
        (!ee || ee && O[me[Te]] === i) && (O[me[Te]] = W[me[Te]]), Te++;
      return O;
    }, "extend", "Use `assign`."), E = T(function(O, W) {
      return w(O, W, !0);
    }, "merge", "Use `assign`.");
    function C(M, O, W) {
      var ee = O.prototype, me;
      me = M.prototype = Object.create(ee), me.constructor = M, me._super = ee, W && v(me, W);
    }
    function P(M, O) {
      return function() {
        return M.apply(O, arguments);
      };
    }
    function F(M, O) {
      return typeof M == o ? M.apply(O && O[0] || i, O) : M;
    }
    function k(M, O) {
      return M === i ? O : M;
    }
    function K(M, O, W) {
      x(ye(O), function(ee) {
        M.addEventListener(ee, W, !1);
      });
    }
    function Z(M, O, W) {
      x(ye(O), function(ee) {
        M.removeEventListener(ee, W, !1);
      });
    }
    function ne(M, O) {
      for (; M; ) {
        if (M == O)
          return !0;
        M = M.parentNode;
      }
      return !1;
    }
    function le(M, O) {
      return M.indexOf(O) > -1;
    }
    function ye(M) {
      return M.trim().split(/\s+/g);
    }
    function ge(M, O, W) {
      if (M.indexOf && !W)
        return M.indexOf(O);
      for (var ee = 0; ee < M.length; ) {
        if (W && M[ee][W] == O || !W && M[ee] === O)
          return ee;
        ee++;
      }
      return -1;
    }
    function _e(M) {
      return Array.prototype.slice.call(M, 0);
    }
    function L(M, O, W) {
      for (var ee = [], me = [], Te = 0; Te < M.length; ) {
        var ze = O ? M[Te][O] : M[Te];
        ge(me, ze) < 0 && ee.push(M[Te]), me[Te] = ze, Te++;
      }
      return W && (O ? ee = ee.sort(function(hr, pr) {
        return hr[O] > pr[O];
      }) : ee = ee.sort()), ee;
    }
    function d(M, O) {
      for (var W, ee, me = O[0].toUpperCase() + O.slice(1), Te = 0; Te < s.length; ) {
        if (W = s[Te], ee = W ? W + me : O, ee in M)
          return ee;
        Te++;
      }
      return i;
    }
    var b = 1;
    function S() {
      return b++;
    }
    function R(M) {
      var O = M.ownerDocument || M;
      return O.defaultView || O.parentWindow || e;
    }
    var D = /mobile|tablet|ip(ad|hone|od)|android/i, z = "ontouchstart" in e, q = d(e, "PointerEvent") !== i, y = z && D.test(navigator.userAgent), h = "touch", I = "pen", V = "mouse", g = "kinect", G = 25, Q = 1, J = 2, X = 4, pe = 8, ce = 1, ue = 2, B = 4, A = 8, $ = 16, de = ue | B, xe = A | $, Ae = de | xe, ut = ["x", "y"], Le = ["clientX", "clientY"];
    function Re(M, O) {
      var W = this;
      this.manager = M, this.callback = O, this.element = M.element, this.target = M.options.inputTarget, this.domHandler = function(ee) {
        F(M.options.enable, [M]) && W.handler(ee);
      }, this.init();
    }
    Re.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && K(this.element, this.evEl, this.domHandler), this.evTarget && K(this.target, this.evTarget, this.domHandler), this.evWin && K(R(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && Z(this.element, this.evEl, this.domHandler), this.evTarget && Z(this.target, this.evTarget, this.domHandler), this.evWin && Z(R(this.element), this.evWin, this.domHandler);
      }
    };
    function Me(M) {
      var O, W = M.options.inputClass;
      return W ? O = W : q ? O = Xr : y ? O = bt : z ? O = Vr : O = Be, new O(M, re);
    }
    function re(M, O, W) {
      var ee = W.pointers.length, me = W.changedPointers.length, Te = O & Q && ee - me === 0, ze = O & (X | pe) && ee - me === 0;
      W.isFirst = !!Te, W.isFinal = !!ze, Te && (M.session = {}), W.eventType = O, fe(M, W), M.emit("hammer.input", W), M.recognize(W), M.session.prevInput = W;
    }
    function fe(M, O) {
      var W = M.session, ee = O.pointers, me = ee.length;
      W.firstInput || (W.firstInput = dt(O)), me > 1 && !W.firstMultiple ? W.firstMultiple = dt(O) : me === 1 && (W.firstMultiple = !1);
      var Te = W.firstInput, ze = W.firstMultiple, ar = ze ? ze.center : Te.center, hr = O.center = Sr(ee);
      O.timeStamp = u(), O.deltaTime = O.timeStamp - Te.timeStamp, O.angle = ft(ar, hr), O.distance = Tr(ar, hr), Mt(W, O), O.offsetDirection = Ze(O.deltaX, O.deltaY);
      var pr = rt(O.deltaTime, O.deltaX, O.deltaY);
      O.overallVelocityX = pr.x, O.overallVelocityY = pr.y, O.overallVelocity = c(pr.x) > c(pr.y) ? pr.x : pr.y, O.scale = ze ? En(ze.pointers, ee) : 1, O.rotation = ze ? _t(ze.pointers, ee) : 0, O.maxPointers = W.prevInput ? O.pointers.length > W.prevInput.maxPointers ? O.pointers.length : W.prevInput.maxPointers : O.pointers.length, Fe(W, O);
      var Tn = M.element;
      ne(O.srcEvent.target, Tn) && (Tn = O.srcEvent.target), O.target = Tn;
    }
    function Mt(M, O) {
      var W = O.center, ee = M.offsetDelta || {}, me = M.prevDelta || {}, Te = M.prevInput || {};
      (O.eventType === Q || Te.eventType === X) && (me = M.prevDelta = {
        x: Te.deltaX || 0,
        y: Te.deltaY || 0
      }, ee = M.offsetDelta = {
        x: W.x,
        y: W.y
      }), O.deltaX = me.x + (W.x - ee.x), O.deltaY = me.y + (W.y - ee.y);
    }
    function Fe(M, O) {
      var W = M.lastInterval || O, ee = O.timeStamp - W.timeStamp, me, Te, ze, ar;
      if (O.eventType != pe && (ee > G || W.velocity === i)) {
        var hr = O.deltaX - W.deltaX, pr = O.deltaY - W.deltaY, Tn = rt(ee, hr, pr);
        Te = Tn.x, ze = Tn.y, me = c(Tn.x) > c(Tn.y) ? Tn.x : Tn.y, ar = Ze(hr, pr), M.lastInterval = O;
      } else
        me = W.velocity, Te = W.velocityX, ze = W.velocityY, ar = W.direction;
      O.velocity = me, O.velocityX = Te, O.velocityY = ze, O.direction = ar;
    }
    function dt(M) {
      for (var O = [], W = 0; W < M.pointers.length; )
        O[W] = {
          clientX: l(M.pointers[W].clientX),
          clientY: l(M.pointers[W].clientY)
        }, W++;
      return {
        timeStamp: u(),
        pointers: O,
        center: Sr(O),
        deltaX: M.deltaX,
        deltaY: M.deltaY
      };
    }
    function Sr(M) {
      var O = M.length;
      if (O === 1)
        return {
          x: l(M[0].clientX),
          y: l(M[0].clientY)
        };
      for (var W = 0, ee = 0, me = 0; me < O; )
        W += M[me].clientX, ee += M[me].clientY, me++;
      return {
        x: l(W / O),
        y: l(ee / O)
      };
    }
    function rt(M, O, W) {
      return {
        x: O / M || 0,
        y: W / M || 0
      };
    }
    function Ze(M, O) {
      return M === O ? ce : c(M) >= c(O) ? M < 0 ? ue : B : O < 0 ? A : $;
    }
    function Tr(M, O, W) {
      W || (W = ut);
      var ee = O[W[0]] - M[W[0]], me = O[W[1]] - M[W[1]];
      return Math.sqrt(ee * ee + me * me);
    }
    function ft(M, O, W) {
      W || (W = ut);
      var ee = O[W[0]] - M[W[0]], me = O[W[1]] - M[W[1]];
      return Math.atan2(me, ee) * 180 / Math.PI;
    }
    function _t(M, O) {
      return ft(O[1], O[0], Le) + ft(M[1], M[0], Le);
    }
    function En(M, O) {
      return Tr(O[0], O[1], Le) / Tr(M[0], M[1], Le);
    }
    var vt = {
      mousedown: Q,
      mousemove: J,
      mouseup: X
    }, It = "mousedown", Jr = "mousemove mouseup";
    function Be() {
      this.evEl = It, this.evWin = Jr, this.pressed = !1, Re.apply(this, arguments);
    }
    C(Be, Re, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(O) {
        var W = vt[O.type];
        W & Q && O.button === 0 && (this.pressed = !0), W & J && O.which !== 1 && (W = X), this.pressed && (W & X && (this.pressed = !1), this.callback(this.manager, W, {
          pointers: [O],
          changedPointers: [O],
          pointerType: V,
          srcEvent: O
        }));
      }
    });
    var We = {
      pointerdown: Q,
      pointermove: J,
      pointerup: X,
      pointercancel: pe,
      pointerout: pe
    }, Lr = {
      2: h,
      3: I,
      4: V,
      5: g
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, lt = "pointerdown", yt = "pointermove pointerup pointercancel";
    e.MSPointerEvent && !e.PointerEvent && (lt = "MSPointerDown", yt = "MSPointerMove MSPointerUp MSPointerCancel");
    function Xr() {
      this.evEl = lt, this.evWin = yt, Re.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    C(Xr, Re, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(O) {
        var W = this.store, ee = !1, me = O.type.toLowerCase().replace("ms", ""), Te = We[me], ze = Lr[O.pointerType] || O.pointerType, ar = ze == h, hr = ge(W, O.pointerId, "pointerId");
        Te & Q && (O.button === 0 || ar) ? hr < 0 && (W.push(O), hr = W.length - 1) : Te & (X | pe) && (ee = !0), !(hr < 0) && (W[hr] = O, this.callback(this.manager, Te, {
          pointers: W,
          changedPointers: [O],
          pointerType: ze,
          srcEvent: O
        }), ee && W.splice(hr, 1));
      }
    });
    var Et = {
      touchstart: Q,
      touchmove: J,
      touchend: X,
      touchcancel: pe
    }, At = "touchstart", Je = "touchstart touchmove touchend touchcancel";
    function Ve() {
      this.evTarget = At, this.evWin = Je, this.started = !1, Re.apply(this, arguments);
    }
    C(Ve, Re, {
      handler: function(O) {
        var W = Et[O.type];
        if (W === Q && (this.started = !0), !!this.started) {
          var ee = Ct.call(this, O, W);
          W & (X | pe) && ee[0].length - ee[1].length === 0 && (this.started = !1), this.callback(this.manager, W, {
            pointers: ee[0],
            changedPointers: ee[1],
            pointerType: h,
            srcEvent: O
          });
        }
      }
    });
    function Ct(M, O) {
      var W = _e(M.touches), ee = _e(M.changedTouches);
      return O & (X | pe) && (W = L(W.concat(ee), "identifier", !0)), [W, ee];
    }
    var Zt = {
      touchstart: Q,
      touchmove: J,
      touchend: X,
      touchcancel: pe
    }, nt = "touchstart touchmove touchend touchcancel";
    function bt() {
      this.evTarget = nt, this.targetIds = {}, Re.apply(this, arguments);
    }
    C(bt, Re, {
      handler: function(O) {
        var W = Zt[O.type], ee = rr.call(this, O, W);
        ee && this.callback(this.manager, W, {
          pointers: ee[0],
          changedPointers: ee[1],
          pointerType: h,
          srcEvent: O
        });
      }
    });
    function rr(M, O) {
      var W = _e(M.touches), ee = this.targetIds;
      if (O & (Q | J) && W.length === 1)
        return ee[W[0].identifier] = !0, [W, W];
      var me, Te, ze = _e(M.changedTouches), ar = [], hr = this.target;
      if (Te = W.filter(function(pr) {
        return ne(pr.target, hr);
      }), O === Q)
        for (me = 0; me < Te.length; )
          ee[Te[me].identifier] = !0, me++;
      for (me = 0; me < ze.length; )
        ee[ze[me].identifier] && ar.push(ze[me]), O & (X | pe) && delete ee[ze[me].identifier], me++;
      if (ar.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          L(Te.concat(ar), "identifier", !0),
          ar
        ];
    }
    var Xe = 2500, pt = 25;
    function Vr() {
      Re.apply(this, arguments);
      var M = P(this.handler, this);
      this.touch = new bt(this.manager, M), this.mouse = new Be(this.manager, M), this.primaryTouch = null, this.lastTouches = [];
    }
    C(Vr, Re, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(O, W, ee) {
        var me = ee.pointerType == h, Te = ee.pointerType == V;
        if (!(Te && ee.sourceCapabilities && ee.sourceCapabilities.firesTouchEvents)) {
          if (me)
            ht.call(this, W, ee);
          else if (Te && cn.call(this, ee))
            return;
          this.callback(O, W, ee);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function ht(M, O) {
      M & Q ? (this.primaryTouch = O.changedPointers[0].identifier, it.call(this, O)) : M & (X | pe) && it.call(this, O);
    }
    function it(M) {
      var O = M.changedPointers[0];
      if (O.identifier === this.primaryTouch) {
        var W = { x: O.clientX, y: O.clientY };
        this.lastTouches.push(W);
        var ee = this.lastTouches, me = function() {
          var Te = ee.indexOf(W);
          Te > -1 && ee.splice(Te, 1);
        };
        setTimeout(me, Xe);
      }
    }
    function cn(M) {
      for (var O = M.srcEvent.clientX, W = M.srcEvent.clientY, ee = 0; ee < this.lastTouches.length; ee++) {
        var me = this.lastTouches[ee], Te = Math.abs(O - me.x), ze = Math.abs(W - me.y);
        if (Te <= pt && ze <= pt)
          return !0;
      }
      return !1;
    }
    var St = d(a.style, "touchAction"), Tt = St !== i, un = "compute", Ue = "auto", mt = "manipulation", Ft = "none", Ut = "pan-x", nr = "pan-y", cr = ur();
    function zt(M, O) {
      this.manager = M, this.set(O);
    }
    zt.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(M) {
        M == un && (M = this.compute()), Tt && this.manager.element.style && cr[M] && (this.manager.element.style[St] = M), this.actions = M.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var M = [];
        return x(this.manager.recognizers, function(O) {
          F(O.options.enable, [O]) && (M = M.concat(O.getTouchAction()));
        }), dn(M.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(M) {
        var O = M.srcEvent, W = M.offsetDirection;
        if (this.manager.session.prevented) {
          O.preventDefault();
          return;
        }
        var ee = this.actions, me = le(ee, Ft) && !cr[Ft], Te = le(ee, nr) && !cr[nr], ze = le(ee, Ut) && !cr[Ut];
        if (me) {
          var ar = M.pointers.length === 1, hr = M.distance < 2, pr = M.deltaTime < 250;
          if (ar && hr && pr)
            return;
        }
        if (!(ze && Te) && (me || Te && W & de || ze && W & xe))
          return this.preventSrc(O);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(M) {
        this.manager.session.prevented = !0, M.preventDefault();
      }
    };
    function dn(M) {
      if (le(M, Ft))
        return Ft;
      var O = le(M, Ut), W = le(M, nr);
      return O && W ? Ft : O || W ? O ? Ut : nr : le(M, mt) ? mt : Ue;
    }
    function ur() {
      if (!Tt)
        return !1;
      var M = {}, O = e.CSS && e.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(W) {
        M[W] = O ? e.CSS.supports("touch-action", W) : !0;
      }), M;
    }
    var Jn = 1, dr = 2, An = 4, Mr = 8, yr = Mr, Qr = 16, Wt = 32;
    function wr(M) {
      this.options = v({}, this.defaults, M || {}), this.id = S(), this.manager = null, this.options.enable = k(this.options.enable, !0), this.state = Jn, this.simultaneous = {}, this.requireFail = [];
    }
    wr.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(M) {
        return v(this.options, M), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(M) {
        if (p(M, "recognizeWith", this))
          return this;
        var O = this.simultaneous;
        return M = Sn(M, this), O[M.id] || (O[M.id] = M, M.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(M) {
        return p(M, "dropRecognizeWith", this) ? this : (M = Sn(M, this), delete this.simultaneous[M.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(M) {
        if (p(M, "requireFailure", this))
          return this;
        var O = this.requireFail;
        return M = Sn(M, this), ge(O, M) === -1 && (O.push(M), M.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(M) {
        if (p(M, "dropRequireFailure", this))
          return this;
        M = Sn(M, this);
        var O = ge(this.requireFail, M);
        return O > -1 && this.requireFail.splice(O, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(M) {
        return !!this.simultaneous[M.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(M) {
        var O = this, W = this.state;
        function ee(me) {
          O.manager.emit(me, M);
        }
        W < Mr && ee(O.options.event + fn(W)), ee(O.options.event), M.additionalEvent && ee(M.additionalEvent), W >= Mr && ee(O.options.event + fn(W));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(M) {
        if (this.canEmit())
          return this.emit(M);
        this.state = Wt;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var M = 0; M < this.requireFail.length; ) {
          if (!(this.requireFail[M].state & (Wt | Jn)))
            return !1;
          M++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(M) {
        var O = v({}, M);
        if (!F(this.options.enable, [this, O])) {
          this.reset(), this.state = Wt;
          return;
        }
        this.state & (yr | Qr | Wt) && (this.state = Jn), this.state = this.process(O), this.state & (dr | An | Mr | Qr) && this.tryEmit(O);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(M) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function fn(M) {
      return M & Qr ? "cancel" : M & Mr ? "end" : M & An ? "move" : M & dr ? "start" : "";
    }
    function Fn(M) {
      return M == $ ? "down" : M == A ? "up" : M == ue ? "left" : M == B ? "right" : "";
    }
    function Sn(M, O) {
      var W = O.manager;
      return W ? W.get(M) : M;
    }
    function fr() {
      wr.apply(this, arguments);
    }
    C(fr, wr, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(M) {
        var O = this.options.pointers;
        return O === 0 || M.pointers.length === O;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(M) {
        var O = this.state, W = M.eventType, ee = O & (dr | An), me = this.attrTest(M);
        return ee && (W & pe || !me) ? O | Qr : ee || me ? W & X ? O | Mr : O & dr ? O | An : dr : Wt;
      }
    });
    function Si() {
      fr.apply(this, arguments), this.pX = null, this.pY = null;
    }
    C(Si, fr, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: Ae
      },
      getTouchAction: function() {
        var M = this.options.direction, O = [];
        return M & de && O.push(nr), M & xe && O.push(Ut), O;
      },
      directionTest: function(M) {
        var O = this.options, W = !0, ee = M.distance, me = M.direction, Te = M.deltaX, ze = M.deltaY;
        return me & O.direction || (O.direction & de ? (me = Te === 0 ? ce : Te < 0 ? ue : B, W = Te != this.pX, ee = Math.abs(M.deltaX)) : (me = ze === 0 ? ce : ze < 0 ? A : $, W = ze != this.pY, ee = Math.abs(M.deltaY))), M.direction = me, W && ee > O.threshold && me & O.direction;
      },
      attrTest: function(M) {
        return fr.prototype.attrTest.call(this, M) && (this.state & dr || !(this.state & dr) && this.directionTest(M));
      },
      emit: function(M) {
        this.pX = M.deltaX, this.pY = M.deltaY;
        var O = Fn(M.direction);
        O && (M.additionalEvent = this.options.event + O), this._super.emit.call(this, M);
      }
    });
    function ir() {
      fr.apply(this, arguments);
    }
    C(ir, fr, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Ft];
      },
      attrTest: function(M) {
        return this._super.attrTest.call(this, M) && (Math.abs(M.scale - 1) > this.options.threshold || this.state & dr);
      },
      emit: function(M) {
        if (M.scale !== 1) {
          var O = M.scale < 1 ? "in" : "out";
          M.additionalEvent = this.options.event + O;
        }
        this._super.emit.call(this, M);
      }
    });
    function vs() {
      wr.apply(this, arguments), this._timer = null, this._input = null;
    }
    C(vs, wr, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [Ue];
      },
      process: function(M) {
        var O = this.options, W = M.pointers.length === O.pointers, ee = M.distance < O.threshold, me = M.deltaTime > O.time;
        if (this._input = M, !ee || !W || M.eventType & (X | pe) && !me)
          this.reset();
        else if (M.eventType & Q)
          this.reset(), this._timer = f(function() {
            this.state = yr, this.tryEmit();
          }, O.time, this);
        else if (M.eventType & X)
          return yr;
        return Wt;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(M) {
        this.state === yr && (M && M.eventType & X ? this.manager.emit(this.options.event + "up", M) : (this._input.timeStamp = u(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function ys() {
      fr.apply(this, arguments);
    }
    C(ys, fr, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Ft];
      },
      attrTest: function(M) {
        return this._super.attrTest.call(this, M) && (Math.abs(M.rotation) > this.options.threshold || this.state & dr);
      }
    });
    function ws() {
      fr.apply(this, arguments);
    }
    C(ws, fr, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: de | xe,
        pointers: 1
      },
      getTouchAction: function() {
        return Si.prototype.getTouchAction.call(this);
      },
      attrTest: function(M) {
        var O = this.options.direction, W;
        return O & (de | xe) ? W = M.overallVelocity : O & de ? W = M.overallVelocityX : O & xe && (W = M.overallVelocityY), this._super.attrTest.call(this, M) && O & M.offsetDirection && M.distance > this.options.threshold && M.maxPointers == this.options.pointers && c(W) > this.options.velocity && M.eventType & X;
      },
      emit: function(M) {
        var O = Fn(M.offsetDirection);
        O && this.manager.emit(this.options.event + O, M), this.manager.emit(this.options.event, M);
      }
    });
    function Xn() {
      wr.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    C(Xn, wr, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [mt];
      },
      process: function(M) {
        var O = this.options, W = M.pointers.length === O.pointers, ee = M.distance < O.threshold, me = M.deltaTime < O.time;
        if (this.reset(), M.eventType & Q && this.count === 0)
          return this.failTimeout();
        if (ee && me && W) {
          if (M.eventType != X)
            return this.failTimeout();
          var Te = this.pTime ? M.timeStamp - this.pTime < O.interval : !0, ze = !this.pCenter || Tr(this.pCenter, M.center) < O.posThreshold;
          this.pTime = M.timeStamp, this.pCenter = M.center, !ze || !Te ? this.count = 1 : this.count += 1, this._input = M;
          var ar = this.count % O.taps;
          if (ar === 0)
            return this.hasRequireFailures() ? (this._timer = f(function() {
              this.state = yr, this.tryEmit();
            }, O.interval, this), dr) : yr;
        }
        return Wt;
      },
      failTimeout: function() {
        return this._timer = f(function() {
          this.state = Wt;
        }, this.options.interval, this), Wt;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == yr && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function _r(M, O) {
      return O = O || {}, O.recognizers = k(O.recognizers, _r.defaults.preset), new hn(M, O);
    }
    _r.VERSION = "2.0.7", _r.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: un,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [ys, { enable: !1 }],
        [ir, { enable: !1 }, ["rotate"]],
        [ws, { direction: de }],
        [Si, { direction: de }, ["swipe"]],
        [Xn],
        [Xn, { event: "doubletap", taps: 2 }, ["tap"]],
        [vs]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var Pc = 1, Jt = 2;
    function hn(M, O) {
      this.options = v({}, _r.defaults, O || {}), this.options.inputTarget = this.options.inputTarget || M, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = M, this.input = Me(this), this.touchAction = new zt(this, this.options.touchAction), Zs(this, !0), x(this.options.recognizers, function(W) {
        var ee = this.add(new W[0](W[1]));
        W[2] && ee.recognizeWith(W[2]), W[3] && ee.requireFailure(W[3]);
      }, this);
    }
    hn.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(M) {
        return v(this.options, M), M.touchAction && this.touchAction.update(), M.inputTarget && (this.input.destroy(), this.input.target = M.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(M) {
        this.session.stopped = M ? Jt : Pc;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(M) {
        var O = this.session;
        if (!O.stopped) {
          this.touchAction.preventDefaults(M);
          var W, ee = this.recognizers, me = O.curRecognizer;
          (!me || me && me.state & yr) && (me = O.curRecognizer = null);
          for (var Te = 0; Te < ee.length; )
            W = ee[Te], O.stopped !== Jt && // 1
            (!me || W == me || // 2
            W.canRecognizeWith(me)) ? W.recognize(M) : W.reset(), !me && W.state & (dr | An | Mr) && (me = O.curRecognizer = W), Te++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(M) {
        if (M instanceof wr)
          return M;
        for (var O = this.recognizers, W = 0; W < O.length; W++)
          if (O[W].options.event == M)
            return O[W];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(M) {
        if (p(M, "add", this))
          return this;
        var O = this.get(M.options.event);
        return O && this.remove(O), this.recognizers.push(M), M.manager = this, this.touchAction.update(), M;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(M) {
        if (p(M, "remove", this))
          return this;
        if (M = this.get(M), M) {
          var O = this.recognizers, W = ge(O, M);
          W !== -1 && (O.splice(W, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(M, O) {
        if (M !== i && O !== i) {
          var W = this.handlers;
          return x(ye(M), function(ee) {
            W[ee] = W[ee] || [], W[ee].push(O);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(M, O) {
        if (M !== i) {
          var W = this.handlers;
          return x(ye(M), function(ee) {
            O ? W[ee] && W[ee].splice(ge(W[ee], O), 1) : delete W[ee];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(M, O) {
        this.options.domEvents && Ko(M, O);
        var W = this.handlers[M] && this.handlers[M].slice();
        if (!(!W || !W.length)) {
          O.type = M, O.preventDefault = function() {
            O.srcEvent.preventDefault();
          };
          for (var ee = 0; ee < W.length; )
            W[ee](O), ee++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && Zs(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function Zs(M, O) {
      var W = M.element;
      if (W.style) {
        var ee;
        x(M.options.cssProps, function(me, Te) {
          ee = d(W.style, Te), O ? (M.oldCssProps[ee] = W.style[ee], W.style[ee] = me) : W.style[ee] = M.oldCssProps[ee] || "";
        }), O || (M.oldCssProps = {});
      }
    }
    function Ko(M, O) {
      var W = t.createEvent("Event");
      W.initEvent(M, !0, !0), W.gesture = O, O.target.dispatchEvent(W);
    }
    v(_r, {
      INPUT_START: Q,
      INPUT_MOVE: J,
      INPUT_END: X,
      INPUT_CANCEL: pe,
      STATE_POSSIBLE: Jn,
      STATE_BEGAN: dr,
      STATE_CHANGED: An,
      STATE_ENDED: Mr,
      STATE_RECOGNIZED: yr,
      STATE_CANCELLED: Qr,
      STATE_FAILED: Wt,
      DIRECTION_NONE: ce,
      DIRECTION_LEFT: ue,
      DIRECTION_RIGHT: B,
      DIRECTION_UP: A,
      DIRECTION_DOWN: $,
      DIRECTION_HORIZONTAL: de,
      DIRECTION_VERTICAL: xe,
      DIRECTION_ALL: Ae,
      Manager: hn,
      Input: Re,
      TouchAction: zt,
      TouchInput: bt,
      MouseInput: Be,
      PointerEventInput: Xr,
      TouchMouseInput: Vr,
      SingleTouchInput: Ve,
      Recognizer: wr,
      AttrRecognizer: fr,
      Tap: Xn,
      Pan: Si,
      Swipe: ws,
      Pinch: ir,
      Rotate: ys,
      Press: vs,
      on: K,
      off: Z,
      each: x,
      merge: E,
      extend: w,
      assign: v,
      inherit: C,
      bindFn: P,
      prefixed: d
    });
    var sr = typeof e < "u" ? e : typeof self < "u" ? self : {};
    sr.Hammer = _r, typeof i == "function" && i.amd ? i(function() {
      return _r;
    }) : r.exports ? r.exports = _r : e[n] = _r;
  })(window, document, "Hammer");
})(lm);
var Vw = lm.exports;
const Cs = /* @__PURE__ */ zi(Vw), Os = 1, sf = 2, $w = {
  [Os]: {
    name: "zoom",
    svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_205_15)">
              <path
                  d="M98.861 93.363L74.4561 68.9587C80.5223 61.6638 84.177 52.2965 84.177 42.0898C84.177 18.8814 65.2961 0 42.0887 0C18.8808 0 -0.00012207 18.8814 -0.00012207 42.0898C-0.00012207 65.2967 18.8808 84.1766 42.0887 84.1766C52.2948 84.1766 61.6627 80.5224 68.9575 74.4562L93.3629 98.8611C94.1218 99.6205 95.1171 100 96.1119 100C97.1067 100 98.102 99.6205 98.8615 98.8611C100.38 97.3427 100.38 94.8814 98.861 93.363ZM7.77577 42.0898C7.77577 23.169 23.1684 7.77589 42.0887 7.77589C61.0085 7.77589 76.4006 23.169 76.4006 42.0898C76.4006 61.0091 61.0085 76.4007 42.0887 76.4007C23.1684 76.4007 7.77577 61.0091 7.77577 42.0898Z"
                  fill="#7D7E82"/>
            </g>
          </svg>`
  },
  [sf]: {
    name: "crop",
    svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.7778 72.2222V0H16.6667V16.6667H0V27.7778H16.6667V72.2222C16.6667 78.3333 21.6611 83.3333 27.7778 83.3333H72.2222V100H83.3333V83.3333H100V72.2222H27.7778ZM72.2222 66.6667H83.3333V27.7778C83.3333 21.6667 78.3389 16.6667 72.2222 16.6667H33.3333V27.7778H72.2222V66.6667Z"
                fill="#7D7E82"/>
          </svg>`
  }
  // [EDIT_TOOL_ROTATE_CLOCKWISE]: {
  //     name: 'rotate',
  //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <g clip-path="url(#clip0_205_17)">
  //           <path
  //               d="M3.85712 92.8572V50C3.85929 48.1063 4.61254 46.2907 5.95161 44.9517C7.29069 43.6126 9.10624 42.8594 11 42.8572H53.8571C55.7508 42.8594 57.5664 43.6126 58.9055 44.9517C60.2445 46.2907 60.9978 48.1063 61 50V92.8572C60.9978 94.7509 60.2445 96.5665 58.9055 97.9055C57.5664 99.2446 55.7508 99.9979 53.8571 100H11C9.10624 99.9979 7.29069 99.2446 5.95161 97.9055C4.61254 96.5665 3.85929 94.7509 3.85712 92.8572V92.8572Z"
  //               fill="#7D7E82"/>
  //           <path
  //               d="M57.4287 0L62.4644 5.03571L53.2501 14.2857H71.7144C78.3425 14.2931 84.6971 16.9294 89.3839 21.6162C94.0707 26.303 96.707 32.6576 96.7144 39.2857V57.1428H89.5715V39.2857C89.5661 34.5514 87.683 30.0125 84.3353 26.6648C80.9876 23.3171 76.4487 21.434 71.7144 21.4286H53.2501L62.4644 30.6786L57.4287 35.7143L39.5715 17.8571L57.4287 0Z"
  //               fill="#7D7E82"/>
  //         </g>
  //       </svg>`
  // },
  // [EDIT_TOOL_FLIP_HORIZONTAL]: {
  //     name: 'flip',
  //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <g clip-path="url(#clip0_205_18)">
  //           <path
  //               d="M37.8114 2.5941L0.313374 94.256C-0.808053 96.997 1.20805 100 4.16962 100H41.6677C43.9687 100 45.8341 98.1347 45.8341 95.8336V4.17156C45.8341 -0.397737 39.5414 -1.63517 37.8114 2.5941ZM37.5013 91.667H10.3757L37.5013 25.3601V91.667Z"
  //               fill="#7D7E82"/>
  //           <path
  //               d="M99.6871 94.2558L62.189 2.59396C60.459 -1.63512 54.1664 -0.397685 54.1664 4.17141V95.8333C54.1664 98.1343 56.0317 99.9997 58.3328 99.9997H95.8308C98.7924 99.9999 100.809 96.9969 99.6871 94.2558ZM62.4993 91.6669V25.36L89.6249 91.6669H62.4993V91.6669Z"
  //               fill="#7D7E82"/>
  //           <path d="M59.9989 95.9999V13.9999L93.9989 95.9999H59.9989Z" fill="#7D7E82" stroke="#7D7E82"/>
  //         </g>
  //       </svg>`
  // }
}, Gw = {
  components: {
    VueFeather: vn
  },
  props: {
    isMobile: {
      type: Boolean,
      default: !1
    },
    tileLabel: {
      type: String,
      default: ""
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    canEdit: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      editToolIcons: $w
    };
  },
  computed: {
    ...Lp({
      selectedEditToolId: "image/selectedEditToolId",
      hasEdits: "image/hasEdits"
    }),
    toolInstructions() {
      switch (this.selectedEditToolId) {
        case Os:
        case sf:
          return this.$t("message.builder.imageEditor.instructions.cropZoom.desktop");
      }
    }
  },
  methods: {
    ...Dp({
      setEditTool: "image/setEditTool",
      resetImage: "image/resetImage",
      cancelEdit: "image/cancelEdit",
      setEditTile: "image/setEditTile"
    }),
    selectEditTool(r) {
      this.setEditTool(parseInt(r));
    },
    selectEditTile() {
      this.setEditTile(this.tileIndex);
    }
  }
}, Kw = { class: "flex justify-center" }, Yw = { class: "flex items-center relative w-full justify-center" }, qw = {
  key: 0,
  "data-edit-tools": "",
  class: "flex items-center space-x-2 absolute top-0 w-full"
}, Zw = ["onClick"], Jw = ["innerHTML"], Xw = { style: { marginLeft: "auto" } }, Qw = {
  key: 0,
  class: "flex items-center justify-center space-x-2 absolute top-0 w-full cursor-pointer"
}, e6 = {
  key: 0,
  class: "text-center w-full md:w-full md:text-left md:flex md:items-center md:absolute md:top-0"
}, t6 = { class: "md:pb-0 md:mr-8 font-bold" }, r6 = {
  key: 0,
  class: "py-3 md:pt-0 md:pb-0"
}, n6 = { "data-tool-instructions": "" }, i6 = { class: "flex justify-center pb-4 md:pb-0 md:justify-start md:items-center md:ml-auto" };
function s6(r, e, t, n, i, s) {
  return N(), j("div", Kw, [
    _("div", Yw, [
      ae(br, { name: "transition-slide-fade-bottom-delay" }, {
        default: Se(() => [
          !r.selectedEditToolId && !t.tileLabel && t.canEdit ? (N(), j("div", qw, [
            (N(!0), j(De, null, wt(i.editToolIcons, (a, o) => (N(), j("div", {
              onClick: (l) => s.selectEditTool(o),
              class: "cursor-pointer"
            }, [
              _("div", {
                innerHTML: a.svg
              }, null, 8, Jw)
            ], 8, Zw))), 256)),
            _("div", Xw, [
              _("span", {
                onClick: e[0] || (e[0] = (...a) => r.resetImage && r.resetImage(...a)),
                class: "font-bold text-gray-600 cursor-pointer"
              }, he(r.$t("message.builder.imageEditor.reset")), 1)
            ])
          ])) : se("", !0)
        ]),
        _: 1
      }),
      ae(br, { name: "transition-slide-fade-bottom-delay" }, {
        default: Se(() => [
          t.tileLabel ? (N(), j("div", Qw, he(t.tileLabel), 1)) : se("", !0)
        ]),
        _: 1
      }),
      ae(br, { name: "transition-slide-fade-bottom-delay" }, {
        default: Se(() => [
          r.selectedEditToolId && !t.isMobile ? (N(), j("div", e6, [
            _("div", t6, [
              _("p", null, he(r.$t("message.builder.imageEditor.tools." + i.editToolIcons[r.selectedEditToolId].name)), 1)
            ]),
            s.toolInstructions ? (N(), j("div", r6, [
              _("p", n6, he(s.toolInstructions), 1)
            ])) : se("", !0),
            _("div", i6, [
              _("p", {
                onClick: e[1] || (e[1] = (a) => r.cancelEdit()),
                class: "hidden md:block cursor-pointer p-2 mr-2"
              }, he(r.$t("message.builder.imageEditor.cancel")), 1),
              _("button", {
                onClick: e[2] || (e[2] = (a) => r.cancelEdit()),
                class: "md:hidden w-auto btn border-gray-400 py-2 px-4 mr-2"
              }, he(r.$t("message.builder.imageEditor.cancel")), 1),
              _("button", {
                onClick: e[3] || (e[3] = (a) => r.setEditTool(null)),
                class: "w-auto btn btn--dark py-2 px-4"
              }, he(r.$t("message.builder.imageEditor.apply")), 1)
            ])
          ])) : se("", !0)
        ]),
        _: 1
      })
    ])
  ]);
}
const a6 = /* @__PURE__ */ Vt(Gw, [["render", s6]]), o6 = {
  name: "Previews",
  components: {
    ImageEditTools: a6,
    Preview: Z1(() => Promise.resolve().then(() => dT))
  },
  props: {
    canManipulate: {
      type: Boolean,
      default: !0
    },
    canEdit: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    visible: {
      type: Boolean,
      default: !1
    },
    events: {
      type: Boolean,
      default: !0
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    defaultRotateX: {
      type: Number
    },
    defaultRotateY: {
      type: Number
    },
    passiveMouseWheel: {
      type: Boolean,
      default: !0
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    frameType: {
      type: String,
      required: !1,
      default: ""
    },
    edge: {
      type: Number,
      required: !0
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    frameColor: {
      type: String,
      default: null
    },
    cornerRadius: {
      type: String,
      default: "0px"
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    panels: {
      type: Number,
      default: 1
    },
    preview: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    enableScaleAnimation: {
      type: Boolean,
      default: !0
    },
    enableInitialAnimation: {
      type: Boolean,
      default: !1
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    tileLabel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hammer: null,
      currentX: 0,
      currentY: 0,
      startX: 0,
      startY: 0,
      rotateX: 25,
      rotateY: 0,
      minRotation: -60,
      maxRotation: 60,
      rotateTimer: null,
      currentScale: 1,
      scaleStart: 1,
      minScale: 0.5,
      maxScale: 2,
      scaleTimer: null,
      clientWidth: 200,
      clientHeight: 200,
      timeout: null,
      isRotating: !1,
      isZooming: !1
    };
  },
  computed: {
    aspectRatio() {
      return this.width / this.height;
    },
    clientAspectRatio() {
      return this.clientWidth / this.clientHeight;
    },
    cssWidth() {
      return this.clientAspectRatio <= this.aspectRatio ? `${this.clientWidth}px` : `${this.clientHeight * this.aspectRatio}px`;
    },
    cssHeight() {
      return this.clientAspectRatio <= this.aspectRatio ? `${this.clientWidth / this.aspectRatio}px` : `${this.clientHeight}px`;
    },
    styleList() {
      return {
        transition: this.isZooming ? "none" : "transform 1s cubic-bezier(.49,.01,.2,.99)",
        perspective: `${100 + 100 / this.currentScale}vmin`,
        transform: this.visible ? `scale(${this.currentScale})` : "scale(1)"
      };
    },
    styleListContainer() {
      return {
        width: this.cssWidth,
        height: this.cssHeight,
        transition: this.isRotating || !this.enableScaleAnimation ? "none" : "all 1s cubic-bezier(.49,.01,.2,.99)",
        perspective: "500vmin",
        "transform-style": "preserve-3d",
        transform: this.visible ? `translateZ(-100px) rotateX(${this.rotateY}deg) rotateY(${this.rotateX}deg)` : "translateZ(0)"
      };
    },
    enableNewPreviewControls() {
      var r;
      return (r = this.featureFlags) == null ? void 0 : r.enableNewPreviewControls;
    },
    productWidth() {
      return this.width + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    productHeight() {
      return this.height + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    matWidth() {
      return this.frame === 0 ? 0 : this.mat / this.width * 100;
    },
    matHeight() {
      return this.frame === 0 ? 0 : this.mat / this.height * 100;
    },
    gapWidth() {
      return this.frame === 0 ? 0 : this.gap / this.width * 100;
    },
    gapHeight() {
      return this.frame === 0 ? 0 : this.gap / this.height * 100;
    },
    frameWidth() {
      return this.frame / this.width * 100;
    },
    frameHeight() {
      return this.frame / this.height * 100;
    },
    showImageEditor() {
      return !(this.selectedEditToolId && this.isMobile);
    },
    styleListImageEditor() {
      const r = (this.height - 2) / this.productHeight, e = (this.width - 2) / this.productWidth, t = this.gapHeight + this.matHeight + this.frameHeight, n = this.gapWidth + this.matWidth + this.frameWidth, i = t * (this.aspectRatio > 1 ? e : r), s = n * (this.aspectRatio > 1 ? e : r), a = this.aspectRatio > 1 ? 4 : 2, o = (100 - (this.aspectRatio > 1 ? e : r) * 100) / a, l = (100 - (this.aspectRatio > 1 ? e : r) * 100) / 2, c = this.aspectRatio >= 1 ? 10 : 0, u = o - i;
      let f = 0;
      return this.aspectRatio < 0.45 ? f = this.isMobile ? this.clientWidth : "450" : this.isMobile && this.selectedEditToolId && (f = this.clientWidth), {
        "margin-top": `calc(-${u > 0 ? u : 0}% + ${c}px)`,
        "margin-left": this.isMobile && this.selectedEditToolId ? "0px" : `${l - s}%`,
        "margin-right": this.isMobile && this.selectedEditToolId ? "0px" : `${l - s}%`,
        "min-width": f + "px",
        left: f ? "50%" : "",
        transform: f ? "translateX(-50%)" : "",
        position: f ? "absolute" : ""
      };
    },
    pointerEventsNone() {
      return this.preview ? "" : "pointer-events-none";
    }
  },
  watch: {
    visible: function(r, e) {
      r === !1 && (this.currentScale = 1);
    },
    width: function() {
      this.setClientDimensions();
    },
    height: function() {
      this.setClientDimensions();
    }
  },
  mounted() {
    this.rotateX = this.defaultRotateX != null ? this.defaultRotateX : this.rotateX, this.rotateY = this.defaultRotateY != null ? this.defaultRotateY : this.rotateY, this.enableInitialAnimation && this.animatePreview(), this.hammer = new Cs.Manager(this.$el), this.hammer.options.domEvents = !0;
    const r = new Cs.Pan({ threshold: 0, pointers: 0 });
    if (this.hammer.add(r), this.canManipulate === !0) {
      const t = new Cs.Pinch({ threshold: 0 });
      this.hammer.add(t).recognizeWith([r]), this.$el.addEventListener("touchmove", (i) => this.preventEvent(i), { passive: !1 }), this.hammer.on("panstart panmove panend", (i) => this.handlePan(i)), this.hammer.on("pinchstart pinchmove", (i) => this.handlePinch(i));
      let n = !1;
      try {
        var e = Object.defineProperty({}, "passive", {
          get: () => {
            n = { passive: !0 };
          }
        });
        window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
      } catch {
      }
      this.passiveMouseWheel || (n = { passive: !1 }), this.$el.addEventListener("wheel", (i) => this.handleWheel(i), n);
    }
    window.addEventListener("resize", this.setClientDimensions), this.setClientDimensions();
  },
  methods: {
    /**
     * Handles the pan event on the preview.
     *
     * @param {Event} event
     * @param {SVGElement} element
     */
    handlePan(r) {
      if (this.events)
        if (this.isRotating = !0, r.type === "panstart")
          this.startX = this.rotateX, this.startY = this.rotateY;
        else if (r.type === "panend")
          clearTimeout(this.rotateTimer), this.rotateTimer = setTimeout(() => {
            this.isRotating = !1;
          }, 100);
        else {
          let e = this.startX + r.deltaX / (this.clientWidth / 1.5) * this.maxRotation, t = this.startY + r.deltaY / (this.clientWidth / 1.5) * this.minRotation;
          e = Math.min(Math.max(e, this.minRotation), this.maxRotation), t = Math.min(Math.max(t, this.minRotation), this.maxRotation), this.rotateX = e, this.rotateY = t, r.preventDefault();
        }
    },
    handlePinch(r) {
      if (this.events) {
        if (this.isZooming = !0, r.type === "pinchstart")
          this.scaleStart = this.currentScale;
        else if (r.type === "pinchend")
          clearTimeout(this.scaleTimer), this.scaleTimer = setTimeout(() => {
            this.isZooming = !1;
          }, 100);
        else {
          let e = this.scaleStart * r.scale;
          this.currentScale = this.clampScale(e);
        }
        this.preventEvent(r);
      }
    },
    /**
     * Handles zooming with the mousewheel.
     *
     * @param {Event} event
     */
    handleWheel(r) {
      if (this.events) {
        this.isZooming = !0;
        let e = this.currentScale;
        e += e * (-r.deltaY / 200), this.currentScale = this.clampScale(e), clearTimeout(this.scaleTimer), this.scaleTimer = setTimeout(() => {
          this.isZooming = !1;
        }, 100), this.preventEvent(r);
      }
    },
    /**
     * Sets the clientWidth for the component so that we can accurately
     * calculate the rotation of the preview on a pan gesture.
     */
    setClientDimensions(r) {
      this.timeout && window.cancelAnimationFrame(this.timeout), this.timeout = window.requestAnimationFrame(() => {
        this.clientWidth = this.$el.clientWidth, this.clientHeight = this.$el.clientHeight;
      });
    },
    /**
     * Clamps the scale between a minimum and maximum.
     *
     * @param {Number} scale
     * @return {Number}
     */
    clampScale(r) {
      return Math.min(Math.max(r, this.minScale), this.maxScale);
    },
    /**
     * Prevents default on an event when possible.
     */
    preventEvent(r) {
      r.cancelable && r.preventDefault();
    },
    animatePreview() {
      let r = this;
      new Promise((e, t) => {
        setTimeout(() => {
          r.rotateX = 30, e();
        }, 750);
      }).then(
        () => new Promise((e, t) => {
          setTimeout(() => {
            r.rotateX = 1e-7, e();
          }, 1e3);
        })
      );
    }
  }
}, l6 = { class: "relative w-full h-auto max-w-full preserve-3d pointer-events-none" }, c6 = { class: "flex relative justify-center items-center preserve-3d" }, u6 = /* @__PURE__ */ _("div", { class: "clear-both float-left" }, null, -1);
function d6(r, e, t, n, i, s) {
  const a = Pt("Preview"), o = Pt("ImageEditTools");
  return N(), j("div", {
    class: Pe(["flex flex-grow w-full justify-center items-center", [t.renderMode ? "z-10" : "z-0", s.pointerEventsNone]]),
    style: qe(s.styleList)
  }, [
    _("div", {
      class: "flex relative justify-center items-center",
      style: qe(s.styleListContainer)
    }, [
      _("div", l6, [
        _("div", c6, [
          (N(!0), j(De, null, wt(t.panels, (l, c) => (N(), Ne(a, {
            key: `preview-${c}-${t.tileIndex}`,
            offset: c,
            isMobile: t.isMobile,
            isArt: t.isArt,
            panels: t.panels,
            width: t.width / t.panels,
            height: t.height,
            edge: t.edge,
            frame: t.frame,
            gap: t.gap,
            mat: t.mat,
            "frame-color": t.frameColor,
            preview: t.preview,
            cornerRadius: t.cornerRadius,
            productWidth: s.productWidth / t.panels,
            productHeight: s.productHeight,
            matWidth: s.matWidth,
            matHeight: s.matHeight,
            gapWidth: s.gapWidth,
            gapHeight: s.gapHeight,
            frameWidth: s.frameWidth,
            frameHeight: s.frameHeight,
            frameType: t.frameType,
            tileIndex: t.tileIndex
          }, null, 8, ["offset", "isMobile", "isArt", "panels", "width", "height", "edge", "frame", "gap", "mat", "frame-color", "preview", "cornerRadius", "productWidth", "productHeight", "matWidth", "matHeight", "gapWidth", "gapHeight", "frameWidth", "frameHeight", "frameType", "tileIndex"]))), 128))
        ]),
        u6,
        ae(br, { name: "transition-slide-fade-bottom-delay" }, {
          default: Se(() => [
            _("div", {
              "data-image-editor": "",
              style: qe(s.styleListImageEditor),
              class: "pointer-events-auto"
            }, [
              ae(o, {
                isMobile: t.isMobile,
                canEdit: t.canEdit && s.showImageEditor,
                tileLabel: t.tileLabel,
                tileIndex: t.tileIndex
              }, null, 8, ["isMobile", "canEdit", "tileLabel", "tileIndex"])
            ], 4)
          ]),
          _: 1
        })
      ])
    ], 4)
  ], 6);
}
const f6 = /* @__PURE__ */ Vt(o6, [["render", d6]]), h6 = { class: "pt-8 px-10" }, p6 = {
  key: 0,
  class: "italic text-white"
}, m6 = {
  key: 1,
  class: "italic text-white"
}, g6 = { class: "p-4 flex flex-col justify-center md:justify-between md:flex-row md:px-10 md:pb-6" }, x6 = { class: "flex space-x-8 pb-10 justify-center md:pb-0 md:justify-normal" }, b6 = /* @__PURE__ */ _("svg", {
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 503 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ _("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M30 359V30H217V265H134C122.954 265 114 273.954 114 285V359H30ZM483 265L247 265V20C247 8.95431 238.046 0 227 0H20C8.9543 0 0 8.95431 0 20V369C0 380.046 8.9543 389 20 389H114V492C114 503.046 122.954 512 134 512H483C494.046 512 503 503.046 503 492V285C503 273.954 494.046 265 483 265ZM473 295L144 295L144 482H473V295ZM398.374 217.225C402.243 221.094 408.468 221.094 412.337 217.225L454.225 175.337C458.094 171.468 458.094 165.243 454.225 161.374C450.356 157.505 444.131 157.505 440.262 161.374L431.07 170.566L430.954 170.682L415.216 186.42L415.246 156.08C415.246 134.496 406.664 113.813 391.393 98.5416C364.456 71.6051 324.982 64.8274 291.763 78.2084C286.701 80.2446 284.258 86.0042 286.294 91.0657C288.33 96.1272 294.09 98.5707 299.151 96.5344C325.273 86.0042 356.282 91.3566 377.43 112.504C388.978 124.053 395.465 139.732 395.494 156.109V186.42L379.757 170.682L370.448 161.374C366.58 157.505 360.355 157.505 356.486 161.374C352.617 165.243 352.617 171.468 356.486 175.337L365.794 184.645L398.374 217.225Z"
  })
], -1), v6 = ["disabled"], y6 = { key: 0 }, w6 = /* @__PURE__ */ _("svg", {
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ _("path", { d: "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z" })
], -1), _6 = [
  w6
], E6 = {
  key: 1,
  "data-rotate-image-spinner": ""
}, A6 = /* @__PURE__ */ _("svg", {
  "data-test-id": "replace-image-button",
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ _("path", { d: "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" })
], -1), S6 = { class: "justify-center flex space-x-4 md:justify-normal" }, T6 = /* @__PURE__ */ vr({
  __name: "StandaloneImageEditor",
  emits: ["paneClick", "applyImageEdits", "cancelImageEdits", "replaceImage", "changeOrientation", "rotateImage"],
  setup(r, { emit: e }) {
    const t = ke("panels"), n = ke("selectedWidth"), i = ke("selectedHeight"), s = ke("edgeDimension"), a = ke("edgeColor"), o = ke("selectedEdge"), l = ke("renderMode"), c = ke("frameDimension"), u = ke("gapDimension"), f = ke("matDimension"), p = ke("isMobile");
    ke("selectedEditToolId");
    const x = ke("wrapperPaddingClasslist"), T = ke("featureFlags"), v = ke("panes"), w = ke("borderDimension", 0), E = ke("borderColorValue", ""), C = ke("images"), P = ke("uploadLater", !1), F = ke("isArt", !1), k = ke("productSlug"), K = ke("disableCollageOuterBorder", !0), Z = ke("imageEditTrigger", null), ne = ke("locale"), le = ke("cornerRadius", "0"), ye = ke("canEdit", !1), ge = ke("frameColor", ""), _e = ke("filter", null), L = ke("canManipulate"), d = ke("pane", "pane_1"), b = ke("isCollageProduct", !1), S = ke("showStandaloneImageEditor", Ee(!1)), R = ke("hidePrintable", !1), D = ke("renderIsLoading", !1), z = ep, q = Y(() => n.value > i.value ? t4 : n.value < i.value ? r4 : n4), y = Y(() => [
      "fixed w-full h-full top-0 left-0 bg-gray-900",
      "flex flex-col flex-grow z-50"
    ]), h = Y(() => [
      "flex-grow relative flex overflow-hidden px-4",
      R.value ? "opacity-0" : ""
    ]), I = (ue) => {
      e("paneClick", ue);
    }, V = () => {
      e("applyImageEdits");
    }, g = () => {
      e("cancelImageEdits");
    }, G = () => {
      e("paneClick", d.value);
    }, Q = () => {
      e("changeOrientation");
    }, J = () => {
      e("rotateImage");
    }, X = Y(() => {
      let ue = JSON.parse(JSON.stringify(v.value)).filter((B) => B.id === d.value);
      return ue[0].width = 100, ue[0].height = 100, ue[0].top = 0, ue[0].left = 0, ue;
    }), pe = Y(() => {
      let ue = 0, B = 0, A = v.value.filter((xe) => xe.id === d.value)[0];
      for (let xe = 0; xe < v.value.length; xe++) {
        const Ae = v.value[xe], ut = Ae.width + Ae.left, Le = Ae.height + Ae.top;
        ut > ue && (ue = ut), Le > B && (B = Le);
      }
      const $ = A.width * (n.value / ue), de = A.height * (i.value / B);
      return {
        width: $,
        height: de
      };
    }), ce = Y(() => k.value === z);
    return qr(S, (ue) => {
      ue ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
    }), (ue, B) => (N(), j("div", {
      class: Pe(m(y))
    }, [
      _("div", h6, [
        m(p) ? se("", !0) : (N(), j("p", p6, he(ue.$t("message.builder.standaloneImageEditor.instructions.desktop.editor")), 1)),
        m(p) ? (N(), j("p", m6, he(ue.$t("message.builder.standaloneImageEditor.instructions.mobile.editor")), 1)) : se("", !0)
      ]),
      _("div", {
        class: Pe(m(h))
      }, [
        (N(), Ne(m(_w), {
          id: "imageEditorPrintable",
          key: "printable-" + JSON.stringify(m(C)) + m(S),
          panels: m(t),
          width: m(pe).width,
          height: m(pe).height,
          "edge-dimension": m(s),
          "edge-color": m(a),
          "edge-type": m(o),
          "render-mode": m(l),
          frame: m(c),
          gap: m(u),
          mat: m(f),
          isMobile: m(p),
          selectedEditToolId: Os,
          wrapperPaddingClasslist: m(x),
          featureFlags: m(T)
        }, {
          default: Se(() => [
            (N(), Ne(m(Hw), {
              key: "panes-" + JSON.stringify(m(C)) + m(S),
              panes: m(X),
              width: m(pe).width,
              height: m(pe).height,
              edge: m(s),
              "edge-color": m(a),
              "edge-type": m(o),
              border: m(w),
              "border-color": m(E),
              images: m(C),
              events: !0,
              "upload-later": m(P),
              "render-mode": m(l),
              "is-art": m(F),
              "product-slug": m(k),
              "disable-collage-outer-border": m(K),
              filter: m(_e),
              featureFlags: m(T),
              selectedEditToolId: Os,
              imageEditTrigger: m(Z),
              locale: m(ne),
              onPaneClick: I
            }, null, 8, ["panes", "width", "height", "edge", "edge-color", "edge-type", "border", "border-color", "images", "upload-later", "render-mode", "is-art", "product-slug", "disable-collage-outer-border", "filter", "featureFlags", "selectedEditToolId", "imageEditTrigger", "locale"]))
          ]),
          _: 1
        }, 8, ["panels", "width", "height", "edge-dimension", "edge-color", "edge-type", "render-mode", "frame", "gap", "mat", "isMobile", "selectedEditToolId", "wrapperPaddingClasslist", "featureFlags"])),
        (N(), Ne(m(f6), {
          "aria-hidden": "true",
          tabindex: "-1",
          key: "previews-" + m(S),
          selectedEditToolId: Os,
          events: !1,
          visible: !1,
          width: m(pe).width,
          height: m(pe).height,
          frame: 0,
          gap: 0,
          mat: 0,
          "render-mode": m(l),
          cornerRadius: m(le),
          "can-manipulate": m(L),
          "feature-flags": m(T),
          "can-edit": m(ye),
          "frame-color": m(ge),
          preview: !1,
          isMobile: m(p),
          isArt: m(F),
          panels: m(t),
          edge: m(s),
          frameType: null
        }, null, 8, ["selectedEditToolId", "width", "height", "render-mode", "cornerRadius", "can-manipulate", "feature-flags", "can-edit", "frame-color", "isMobile", "isArt", "panels", "edge"]))
      ], 2),
      _("div", g6, [
        _("div", x6, [
          m(q) !== "square" && !m(b) && !m(ce) ? (N(), j("button", {
            key: 0,
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-change-orientation": "",
            onClick: Q
          }, [
            b6,
            _("span", null, he(ue.$t("message.builder.standaloneImageEditor.buttons.flip")), 1)
          ])) : se("", !0),
          _("button", {
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-rotate-image": "",
            disabled: m(D),
            onClick: J
          }, [
            m(D) ? se("", !0) : (N(), j("span", y6, _6)),
            m(D) ? (N(), j("span", E6, [
              ae(m(Cn), { class: "w-6 h-6" })
            ])) : se("", !0),
            _("span", null, he(ue.$t("message.builder.standaloneImageEditor.buttons.rotate")), 1)
          ], 8, v6),
          _("button", {
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-replace-image": "",
            onClick: G
          }, [
            A6,
            _("span", null, he(ue.$t("message.builder.standaloneImageEditor.buttons.replace")), 1)
          ])
        ]),
        _("div", S6, [
          _("button", {
            "data-cancel-btn": "",
            class: "btn btn--secondary grow text-base md:grow-0 md:w-40",
            onClick: g
          }, he(ue.$t("message.builder.standaloneImageEditor.buttons.cancel")), 1),
          _("button", {
            "data-apply-btn": "",
            class: "btn btn--primary grow text-base md:grow-0 md:w-40",
            onClick: V
          }, he(ue.$t("message.builder.standaloneImageEditor.buttons.apply")), 1)
        ])
      ])
    ], 2));
  }
}), ru = "NO_MAT", nu = "SINGLE_MAT", iu = "DOUBLE_MAT", su = "TRIPLE_MAT", ro = "PM918", Wu = "SM9141", sh = 0, au = [
  { label: '1/4"', value: 0.25 },
  { label: '3/8"', value: 0.375 },
  { label: '1/2"', value: 0.5 },
  { label: '5/8"', value: 0.625 },
  { label: '3/4"', value: 0.75 },
  { label: '7/8"', value: 0.875 },
  { label: '1"', value: 1 }
], nl = [
  { label: '1"', value: 1 },
  { label: '1 1/2"', value: 1.5 },
  { label: '2"', value: 2 }
], Mi = "outer", Ji = "inner", il = "mat", Xi = {
  0.25: "9.25V125.5",
  0.375: "13.875V121.75",
  0.5: "18.50V118",
  0.625: "23.125V114.25",
  0.75: "27.75V110.5",
  0.875: "32.375V106.75",
  1: "37.00V104",
  1.125: "41.625V100.25",
  1.25: "46.25V095.5",
  1.375: "50.875V91.75",
  1.5: "55.50V88",
  1.625: "60.125V84.25",
  1.75: "64.75V80.5",
  1.875: "69.375V76.75",
  2: "74.00V71",
  2.125: "78.625V65.25",
  2.25: "83.25V61.5",
  2.375: "87.875V57.75",
  2.5: "92.50V54",
  2.625: "97.125V50.25",
  2.75: "101.75V46.5",
  2.875: "106.375V42.75",
  3: "111.00V40"
}, sl = (r) => ({
  top: r,
  left: r,
  bottom: r,
  right: r
}), al = [
  { label: "1/4", value: 0.25, html: '<span class="text-sm"><sup>1</sup>&frasl;<sub>4</sub></span>' },
  { label: "1/2", value: 0.5, html: '<span class="text-sm"><sup>1</sup>&frasl;<sub>2</sub></span>' },
  { label: "3/4", value: 0.75, html: '<span class="text-sm"><sup>3</sup>&frasl;<sub>4</sub></span>' }
], M6 = "/customizer/api/v2/product", ah = "/customizer/api/upload", oh = "/api/orders/upload", So = Di.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
Di.create({
  baseURL: "/cart",
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
const I6 = async (r, e, t, n, i, s, a, o) => {
  let l = [];
  i ? l.push(`/api/orders/order/${i}/product/${r}`) : l.push(`${M6}/${r}`), n && l.push(`/frame/${n}`), l.push(`/sizes/${e}/${t}`), s && a && o && l.push(`/${s}/${s}/${a}/${o}`);
  const c = l.join("");
  return So.get(c);
}, cm = (r, e) => e ? So.post(ah, r, e) : So.post(ah, r), C6 = (r, e) => e ? So.post(oh, r, e) : So.post(oh, r), P6 = {
  components: {
    VueFeather: vn
  },
  props: {
    checked: {
      type: Boolean,
      default: !1
    },
    customSize: {
      type: Number
    }
  },
  data() {
    return {
      size: "5"
    };
  },
  computed: {
    classList() {
      return [
        "w-" + this.size,
        "h-" + this.size,
        "rounded-full border-2 text-white flex justify-center items-center bg-blue-500 opacity-1 border-blue-500"
      ];
    },
    classListIcon() {
      return [
        "w-3 h-3"
      ];
    }
  },
  mounted() {
    this.size = this.customSize ? this.customSize.toString() : this.size;
  }
};
function k6(r, e, t, n, i, s) {
  const a = Pt("vue-feather");
  return N(), Ne(br, { name: "transition-fade" }, {
    default: Se(() => [
      Ke(_("div", {
        "data-checkmark": "",
        class: Pe(s.classList)
      }, [
        ae(a, {
          type: "check",
          class: Pe(s.classListIcon)
        }, null, 8, ["class"])
      ], 2), [
        [tt, t.checked]
      ])
    ]),
    _: 1
  });
}
const O6 = /* @__PURE__ */ Vt(P6, [["render", k6]]), N6 = {
  components: {
    Loader: lc,
    VueFeather: vn
  },
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "medium",
      validator: (r) => ["small", "medium", "large"].indexOf(r) !== -1
    },
    inverted: {
      type: Boolean,
      default: !1
    },
    fixed: {
      type: Boolean,
      default: !0
    },
    position: {
      type: String,
      default: "relative"
    },
    accessibilityLabel: {
      type: String,
      default: null
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex flex-col justify-center items-center transition-all select-none focus:outline-none",
        this.position,
        this.fixed ? "" : "flex-1",
        this.size === "small" ? "w-8 h-8" : "",
        this.size === "medium" ? "w-14 h-14" : "",
        this.size === "large" ? "w-16 h-16" : "",
        this.disabled ? "text-gray-300 cursor-not-allowed" : "hover:bg-blue-50 hover:text-olive-500",
        this.inverted ? "text-white" : "text-black",
        this.active ? "text-olive-500 bg-blue-50" : ""
      ];
    },
    classListWrapper() {
      return [
        "relative flex flex-col justify-center items-center transition-all",
        this.loading ? "opacity-0" : "opacity-100"
      ];
    },
    classListLabel() {
      return [
        "text-xs text-gray-700 leading-tight group-hover:text-olive-500 group-focus:text-olive-500 transition-color",
        this.active ? "text-olive-500" : ""
      ];
    },
    classListIcon() {
      return [
        this.size === "small" ? "w-4 h-4" : "",
        this.size === "medium" ? "w-5 h-5" : "",
        this.size === "large" ? "w-6 h-6" : ""
      ];
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}, R6 = ["disabled", "aria-label", "title"];
function L6(r, e, t, n, i, s) {
  const a = Pt("vue-feather"), o = Pt("Loader");
  return N(), j("button", {
    class: Pe(s.classList),
    disabled: t.disabled,
    "aria-label": t.accessibilityLabel,
    title: t.accessibilityLabel,
    onClick: e[0] || (e[0] = q1((...l) => s.handleClick && s.handleClick(...l), ["stop"]))
  }, [
    _("div", {
      class: Pe(s.classListWrapper)
    }, [
      ae(a, {
        type: t.icon,
        "data-icon": "",
        class: Pe(s.classListIcon)
      }, null, 8, ["type", "class"]),
      t.label ? (N(), j("span", {
        key: 0,
        class: Pe(s.classListLabel)
      }, he(t.label), 3)) : se("", !0)
    ], 2),
    ae(br, { name: "transition-fade-pop" }, {
      default: Se(() => [
        Ke(ae(o, {
          "data-loader": "",
          visible: "",
          class: "absolute inset-0 z-20"
        }, null, 512), [
          [tt, t.loading]
        ])
      ]),
      _: 1
    })
  ], 10, R6);
}
const um = /* @__PURE__ */ Vt(N6, [["render", L6]]), D6 = {
  props: {
    active: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "absolute inset-0 overflow-hidden"
      ];
    }
  }
};
function F6(r, e, t, n, i, s) {
  return N(), j("div", {
    "data-tab-content": "",
    class: Pe(s.classList)
  }, [
    an(r.$slots, "default")
  ], 2);
}
const B6 = /* @__PURE__ */ Vt(D6, [["render", F6]]), j6 = {
  props: {
    label: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "px-4 py-4 whitespace-nowrap select-none flex-grow text-center transition-bg text-sm font-bold transition-all",
        this.active ? "bg-olive-50 text-olive-500" : this.disabled ? "text-gray-200" : "text-gray-600",
        this.active ? "shadow-inner-border-olive" : "",
        this.disabled ? "cursor-not-allowed" : "cursor-pointer"
      ];
    }
  },
  methods: {
    handleClick() {
      this.disabled || this.$emit("click");
    }
  }
};
function U6(r, e, t, n, i, s) {
  return N(), j("div", {
    "data-label": "",
    class: Pe(s.classList),
    tabindex: "0",
    onClick: e[0] || (e[0] = (...a) => s.handleClick && s.handleClick(...a)),
    onKeyup: e[1] || (e[1] = Us((...a) => s.handleClick && s.handleClick(...a), ["enter"]))
  }, he(t.label), 35);
}
const z6 = /* @__PURE__ */ Vt(j6, [["render", U6]]), W6 = {
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex flex-nowrap border-b overflow-auto w-full bg-white"
      ];
    },
    hasContent() {
      return !!this.$slots.content;
    }
  }
}, H6 = { class: "flex-grow flex flex-col overflow-hidden" }, V6 = {
  key: 0,
  "data-content": "",
  class: "flex-grow overflow-hidden relative"
};
function $6(r, e, t, n, i, s) {
  return N(), j("div", H6, [
    _("div", {
      class: Pe([s.classList, "flex-grow-0 flex-shrink-0"])
    }, [
      an(r.$slots, "labels")
    ], 2),
    s.hasContent ? (N(), j("div", V6, [
      an(r.$slots, "content")
    ])) : se("", !0)
  ]);
}
const G6 = /* @__PURE__ */ Vt(W6, [["render", $6]]), K6 = {
  props: {
    percentageCompleted: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingCompleted: !1
    };
  },
  watch: {
    percentageCompleted: function(r) {
      const t = this.$refs.progressWrapper.offsetHeight / 39.5;
      this.updateProgressCircle(r * t), r >= 100 && this.showCompletedState().then(this.hideProgressLoader());
    }
  },
  methods: {
    updateProgressCircle(r) {
      const e = this.$refs.progressCircle;
      e.style.strokeDasharray = r + " 999";
    },
    showCompletedState() {
      return new Promise((r, e) => {
        setTimeout(() => {
          this.loadingCompleted = !0, r(!0);
        }, 500);
      });
    },
    hideProgressLoader() {
      return new Promise((r, e) => {
        setTimeout(() => {
          this.$emit("hideProgressLoader", !0), r(!0);
        }, 3e3);
      });
    }
  }
}, Y6 = {
  ref: "progressWrapper",
  class: "absolute top-0 left-0 w-full h-full z-10 bg-white"
}, q6 = { class: "flex justify-center items-center absolute top-0 left-0 w-full h-full" }, Z6 = /* @__PURE__ */ _("svg", {
  class: "checkmark_animation",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}, [
  /* @__PURE__ */ _("circle", {
    class: "checkmark_animation__circle",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  }),
  /* @__PURE__ */ _("path", {
    class: "checkmark_animation__check",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  })
], -1), J6 = { class: "text-center text-sm text-gray-700" }, X6 = {
  class: "text-center",
  "data-progress": "0"
}, Q6 = { class: "mt-2" }, e5 = { class: "text-sm" }, t5 = { class: "text-lg" }, r5 = { class: "absolute left-0 h-full top-0 w-full" }, n5 = {
  class: "animate-spin",
  width: "100%",
  height: "100%",
  viewbox: "0 0 50% 50%",
  xmlns: "http://www.w3.org/2000/svg"
}, i5 = /* @__PURE__ */ _("circle", {
  style: { fill: "none", stroke: "rgb(209, 213, 219)", "stroke-width": "5" },
  cx: "50%",
  cy: "50%",
  r: "40%"
}, null, -1), s5 = {
  ref: "progressCircle",
  class: "stroke-gray-400",
  style: { fill: "none", stroke: "hsla(99, 16%, 39%, 1)", "stroke-width": "5", "stroke-dasharray": "0 999", "stroke-dashoffset": "0px", transition: "stroke-dasharray 0.5s ease-out" },
  cx: "50%",
  cy: "50%",
  r: "40%"
};
function a5(r, e, t, n, i, s) {
  return N(), Ne(br, { name: "transition-fade" }, {
    default: Se(() => [
      _("div", Y6, [
        _("div", q6, [
          ae(br, { name: "transition-fade" }, {
            default: Se(() => [
              Ke(_("div", null, [
                Z6,
                _("p", J6, he(r.$t("message.progressLoader.finishedLabel")), 1)
              ], 512), [
                [tt, i.loadingCompleted]
              ])
            ]),
            _: 1
          }),
          Ke(_("div", X6, [
            _("div", Q6, [
              _("p", e5, he(r.$t("message.progressLoader.uploadingLabel")), 1),
              _("p", t5, he(t.percentageCompleted + "%"), 1)
            ])
          ], 512), [
            [tt, !i.loadingCompleted]
          ])
        ]),
        _("div", r5, [
          Ke((N(), j("svg", n5, [
            i5,
            _("circle", s5, null, 512)
          ], 512)), [
            [tt, !i.loadingCompleted]
          ])
        ])
      ], 512)
    ]),
    _: 1
  });
}
const o5 = /* @__PURE__ */ Vt(K6, [["render", a5]]), l5 = {
  components: {
    ProgressLoader: o5,
    ActionButton: Xd,
    IconButton: um
  },
  props: {
    uploading: {
      type: Boolean,
      default: !1
    },
    isActionBtn: {
      type: Boolean,
      default: !1
    },
    droppedImages: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      declinedFileTypeFileNames: [],
      declinedFileSizeFileNames: [],
      uploadPercentages: [],
      totalUploadPercentage: 0,
      showProgressLoader: !1
    };
  },
  emits: ["uploadStart", "uploadEnd", "uploadError"],
  inject: {
    isEcommerce: {
      default: null
    }
  },
  watch: {
    uploadPercentages: {
      handler(r) {
        let e;
        r.length > 0 && (r.length > 1 ? (e = r.reduce(function(t, n) {
          return t + n.percentage;
        }, 0), e = e / r.length) : e = r[0].percentage, this.totalUploadPercentage = e * 0.85);
      },
      deep: !0
    },
    droppedImages: {
      handler: function(r) {
        this.handleFileUpload(r);
      },
      deep: !0
    }
  },
  computed: {
    classList() {
      return [
        "cursor-pointer",
        this.isActionBtn ? "relative" : "absolute w-full h-full top-0 left-0"
      ];
    },
    displayPercentage() {
      return Math.round(this.totalUploadPercentage);
    }
  },
  methods: {
    handleClick() {
      this.uploading || this.selectFile();
    },
    selectFile() {
      this.$refs.upload.click();
    },
    async handleFileChange(r) {
      const t = [...r.target ? r.target.files : r.dataTransfer.files];
      this.handleFileUpload(t);
    },
    handleFileUpload(r) {
      this.$emit("uploadStart"), this.showProgressLoader = !0, this.declinedFileTypeFileNames = [], this.declinedFileSizeFileNames = [];
      const e = [...r];
      this.validateFileTypes(e).then(this.uploadFiles).then(this.emitFiles).catch(this.handleUploadError);
    },
    validateFileTypes(r) {
      return new Promise(async (e, t) => {
        let n = [];
        for (let i = 0; i < r.length; i++)
          await f4(r[i]).catch((a) => {
            const o = this.$t("message.uploader.mimeErrorMessage", { fileName: a });
            this.handleUploadError(o);
          }) ? n.push(r[i]) : this.declinedFileTypeFileNames.push(r[i].name);
        e(n);
      });
    },
    async validateImageResolution(r) {
      return new Promise(async (e, t) => {
        let n = [];
        for (let i = 0; i < r.length; i++)
          await h4(r[i]).catch((a) => {
            const o = this.$t("message.uploader.mimeErrorMessage", { fileName: a });
            this.handleUploadError(o);
          }) ? n.push(r[i]) : this.declinedFileSizeFileNames.push(r[i].name);
        e(n);
      });
    },
    async uploadFiles(r) {
      this.totalUploadPercentage = 0, this.uploadPercentages = [], r.forEach((s, a) => {
        this.uploadPercentages.push({
          id: a,
          percentage: 0
        });
      });
      let e = [], t = this, n = 3;
      for await (const s of i(r, n))
        e = e.concat(s);
      async function* i(s, a) {
        for (let o = 0; o < s.length; o = o + a) {
          const l = s.slice(o, o + a);
          let c = [], u = !1;
          for (let p = 0; p < l.length; p++) {
            let x = new FormData();
            x.append("file", l[p]), x.append("persistable", !0);
            const T = {
              onUploadProgress: (function(v) {
                const w = t.uploadPercentages.find((E) => E.id === p + o);
                w.percentage = Math.round(v.loaded * 100 / v.total);
              }).bind(t)
            };
            try {
              t.isEcommerce ? c.push(C6(x, T)) : c.push(cm(x, T));
            } catch (v) {
              t.handleUploadError("Oops, something went wrong on our end"), v.response.status === 500 && (u = !0);
            }
          }
          if (u)
            break;
          yield await Promise.all(c);
        }
      }
      return e;
    },
    emitFiles(r) {
      const e = r.map((t) => t.data);
      this.$emit("uploadEnd", e), this.totalUploadPercentage += 15, this.showDeclinedFileTypeFileNames(), this.showDeclinedFileSizeFileNames(), this.$refs.upload && (this.$refs.upload.value = "");
    },
    showDeclinedFileTypeFileNames() {
      if (this.declinedFileTypeFileNames.length > 0) {
        let r = "";
        this.declinedFileTypeFileNames.forEach((t, n) => {
          n > 0 && (r += ", "), r += t;
        });
        const e = this.$t("message.constants.warnings.warningDeclinedFileNames", { declinedFileNames: r });
        this.handleUploadError(e + ". " + this.$t("message.constants.errors.errorCannotUpload"));
      }
    },
    showDeclinedFileSizeFileNames() {
      if (this.declinedFileSizeFileNames.length > 0) {
        let r = "";
        this.declinedFileSizeFileNames.forEach((t, n) => {
          n > 0 && (r += ", "), r += t;
        });
        const e = "Sorry, we could not upload " + r + ". Your image must be no larger than " + eh + "px X " + eh + "px";
        this.handleUploadError(e);
      }
    },
    handleUploadError(r) {
      const e = {
        data: {
          errorMessage: r
        }
      };
      this.showProgressLoader = !1, this.$emit("uploadError", e), this.$refs.upload && (this.$refs.upload.value = "");
    }
  }
};
function c5(r, e, t, n, i, s) {
  const a = Pt("ProgressLoader"), o = Pt("ActionButton"), l = Pt("IconButton");
  return N(), j("div", null, [
    ae(br, { name: "transition-fade" }, {
      default: Se(() => [
        i.showProgressLoader ? (N(), Ne(a, {
          key: 0,
          percentageCompleted: s.displayPercentage,
          onHideProgressLoader: e[0] || (e[0] = (c) => i.showProgressLoader = !1)
        }, null, 8, ["percentageCompleted"])) : se("", !0)
      ]),
      _: 1
    }),
    Ke(_("div", {
      class: Pe(s.classList),
      "data-upload-wrapper": "",
      onClick: e[2] || (e[2] = (...c) => s.handleClick && s.handleClick(...c))
    }, [
      _("input", {
        id: "upload",
        ref: "upload",
        "data-upload": "",
        type: "file",
        class: "hidden",
        accept: ".jpg,.jpeg,.png,.heic,.heif,.webp,.tiff,.tif",
        multiple: "",
        onChange: e[1] || (e[1] = (...c) => s.handleFileChange && s.handleFileChange(...c))
      }, null, 544),
      t.isActionBtn ? (N(), Ne(o, {
        key: 0,
        label: r.$t("message.imageSelector.uploadFirstImage"),
        ref: "emptyUploadBtn",
        class: "btn--primary w-full sm:w-auto"
      }, null, 8, ["label"])) : se("", !0),
      t.isActionBtn ? se("", !0) : (N(), Ne(l, {
        key: 1,
        icon: "plus-circle",
        loading: t.uploading,
        label: r.$t("message.imageSelector.uploadLabel"),
        size: "large",
        class: "absolute w-full h-full top-0 left-0",
        "aria-label": "Upload an image",
        ref: "uploadBtn",
        onClick: s.handleClick
      }, null, 8, ["loading", "label", "onClick"]))
    ], 2), [
      [tt, !i.showProgressLoader]
    ])
  ]);
}
const u5 = /* @__PURE__ */ Vt(l5, [["render", c5]]), d5 = {
  components: {
    ActionButton: Xd,
    Body: zp,
    Checkmark: O6,
    Footer: Wp,
    Header: Hp,
    IconButton: um,
    Loader: lc,
    TabContent: B6,
    TabLabel: z6,
    Tabs: G6,
    Thumbnail: em,
    Uploader: u5,
    Dialog: Bu,
    VueFeather: vn
  },
  props: {
    selectedImages: {
      type: Array,
      default: () => []
    },
    uploadLater: {
      type: Boolean,
      default: !1
    },
    autoSelectSingleUpload: {
      type: Boolean,
      default: !1
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      selectedTab: 0,
      selected: [],
      loading: !1,
      loadingMessage: null,
      uploading: !1,
      uploadedImages: [],
      isLoggedInToFacebook: !1,
      facebookImages: [],
      facebookToken: null,
      facebookNext: null,
      isLoggedInToInstagram: !1,
      instagramImages: [],
      instagramToken: null,
      instagramUserId: null,
      instagramNext: null,
      nftImages: [],
      nftNext: null,
      nftLoading: !1,
      walletLoading: !1,
      listenersAttached: !1,
      hasMetamask: null,
      walletAccount: null,
      chainId: "0x1",
      web3: null,
      transition: "left",
      removeIndex: null,
      showError: !1,
      error: null,
      visibleImages: [],
      triggerElement: null,
      KEY_UPLOADS: "cp-uploaded-images",
      KEY_FACEBOOK: "cp-facebook-images",
      KEY_INSTAGRAM: "cp-instagram-images",
      KEY_NFT: "cp-nft-images",
      isDragging: !1,
      droppedImages: null,
      inActiveTimeout: null
    };
  },
  emits: ["close", "confirm", "uploadLater"],
  computed: {
    ...Lp({
      facebookClientId: "app/facebookClientId",
      instagramClientId: "app/instagramClientId",
      instagramRedirectUri: "app/instagramRedirectUri"
    }),
    connectWalletLabel() {
      return this.hasMetamask ? "message.imageSelector.nft.login" : "message.imageSelector.nft.installMetamask";
    },
    nftTitleLabel() {
      return this.nftLoading ? "message.imageSelector.nft.loading.title" : "message.imageSelector.nft.title";
    },
    nftDescriptionLabel() {
      return this.nftLoading ? "message.imageSelector.nft.loading.description" : "message.imageSelector.nft.description";
    },
    classList() {
      return [
        "fixed inset-0 bg-white z-60 flex flex-col lg:w-4/5 lg:rounded-lg lg:m-auto lg:my-12"
      ];
    },
    thumbnailWrapperClassList() {
      return [
        this.isEmptyState ? "flex-grow items-center content-center justify-center" : "",
        "flex flex-wrap overflow-auto"
      ];
    },
    thumbnailClassList() {
      return [
        this.isEmptyState ? "rounded m-4  bg-white shadow-lg" : "w-1/4 md:w-1/6 xl:w-1/8"
      ];
    },
    uploaderClassList() {
      return [
        this.isEmptyState ? "p-4 bg-vanilla-50  text-right" : "pt-full relative flex items-center justify-center bg-white"
      ];
    },
    isEmptyState() {
      return this.uploadedImages.length === 0 && !this.uploading;
    },
    enableNFT() {
      var r;
      return (r = this.featureFlags) == null ? void 0 : r.enableNFT;
    }
  },
  watch: {
    selectedTab: function(r, e) {
      this.transition = r > e ? "right" : "left", r == 3 && this.checkIfWalletIsConnected();
    },
    selectedImages: {
      handler: function(r, e) {
        this.selected = [...r];
      },
      deep: !0
    },
    uploadedImages: {
      handler: function(r, e) {
        this.writeImages(this.KEY_UPLOADS, r);
      },
      deep: !0
    }
  },
  created() {
    this.uploadedImages = this.filterOldImages(this.readImages(this.KEY_UPLOADS)), this.selected = [...this.selectedImages];
  },
  async mounted() {
    this.attachIntersectionObservers(), this.focusImageSelector(), document.addEventListener("keydown", this.handleKeyDown);
  },
  unmounted() {
    this.focusTriggerElement(), window.ethereum && window.ethereum.removeListener && (window.ethereum.removeListener("accountsChanged", this.handleAccountsChanged), window.ethereum.removeListener("chainChanged", this.handleChainChanged)), document.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleCancel() {
      this.$emit("close");
    },
    handleTabSelect(r) {
      this.selectedTab = r, this.$nextTick(() => {
        this.$refs.tabContent && this.$refs.tabContent.$el.focus();
      });
    },
    handleUploadStart() {
      this.showError = !1, this.uploading = !0;
    },
    handleUploadEnd(r) {
      r.forEach((e) => {
        this.showImage(e.id);
      }), this.uploadedImages = r.concat(this.uploadedImages), r.length === 1 && this.autoSelectSingleUpload && this.handleSelectImage(r[0]), this.uploading = !1;
    },
    handleUploadError(r) {
      this.error = r.data.errorMessage, this.showError = !0, this.uploading = !1;
    },
    readImages(r) {
      const e = localStorage.getItem(r) || "[]";
      return JSON.parse(e);
    },
    writeImages(r, e) {
      localStorage.setItem(r, JSON.stringify(e));
    },
    filterOldImages(r) {
      const e = /* @__PURE__ */ new Date();
      e.setDate(e.getDate() - 60);
      let t = r.filter((n) => {
        const i = new Date(n.dateCreated);
        if (n.dateCreated) {
          if (i >= e)
            return n;
        } else
          return n;
      });
      return t.sort((n, i) => n.id < i.id ? 1 : -1), t;
    },
    async handleSelectImage(r, e = !1, t) {
      if (e) {
        this.loading = !0;
        let n = new FormData();
        if (n.append("imgUrl", r), n.append("persistable", !0), t === this.KEY_NFT) {
          const i = "https://5tbu1v09w3.execute-api.us-east-1.amazonaws.com/dev/get?i=" + r, s = await Di.get(i), a = ["png", "jpg"];
          if (s.data && !a.includes(s.data.type.toLowerCase())) {
            this.error = "Sorry, this NFT is not a supported image type. Please select an image.", this.showError = !0, this.loading = !1;
            return;
          }
        }
        try {
          const i = await cm(n);
          t === this.KEY_FACEBOOK && (this.facebookImages = this.facebookImages.map((s) => s.images && s.images[0].source === r ? i.data : s)), t === this.KEY_INSTAGRAM && (this.instagramImages = this.instagramImages.map((s) => s.media_url === r ? i.data : s)), t === this.KEY_NFT && (this.nftImages = this.nftImages.map((s) => s && s.mediaUrl === r ? i.data : s)), this.$emit("confirm", i.data);
        } catch (i) {
          this.error = i, this.showError = !0;
        }
        this.loading = !1;
      } else
        this.$emit("confirm", r);
    },
    handleDelete() {
      this.selected.length && (this.uploadedImages = this.uploadedImages.filter((r, e) => this.selected.indexOf(e) === -1), this.selected = []);
    },
    handleConfirmRemoveUpload(r) {
      this.removeIndex = r;
    },
    removeUpload(r) {
      this.uploadedImages = this.uploadedImages.filter((e, t) => t !== r), this.removeIndex = null;
    },
    facebookLogin() {
      FB.login((r) => {
        this.facebookStatusCallback(r);
      }, {
        scope: "user_photos"
      });
    },
    facebookLogout() {
      FB.logout((r) => {
        this.facebookStatusCallback(r);
      });
    },
    facebookStatusCallback(r) {
      r.authResponse && r.status === "connected" ? (this.isLoggedInToFacebook = !0, this.facebookToken = r.authResponse.accessToken, this.loadFacebookImages()) : (this.isLoggedInToFacebook = !1, this.facebookToken = null, this.facebookImages = []);
    },
    loadFacebookImages() {
      const r = this.facebookNext || "/me/photos?type=uploaded&limit=24&fields=id,picture,images";
      FB.api(r, (e) => {
        e.data.length && (this.facebookImages = this.facebookImages.concat(e.data), this.facebookNext = e.paging.next);
      });
    },
    handleUploadLater() {
      this.$emit("uploadLater"), this.$emit("close");
    },
    async instagramLogin() {
      return window.open(`https://api.instagram.com/oauth/authorize?client_id=${this.instagramClientId}&redirect_uri=${this.instagramRedirectUri}&scope=user_profile,user_media&response_type=code`);
    },
    /**
     * Checks if the user has metamask installed
     * @returns {Promise<boolean>}
     */
    async checkIfHasMetamask() {
      ethereum || (this.hasMetamask = !1), this.hasMetamask = !0;
    },
    async checkIfWalletIsConnected(r) {
      await this.checkIfHasMetamask(), this.hasMetamask && window.ethereum && window.ethereum.selectedAddress && await this.walletLogin();
    },
    async loadWalletImages() {
      if (this.walletLoading === !1) {
        const r = this.nftNext || `/customizer/api/v1/wallet?address=${this.walletAccount}&chainId=${this.chainId}`;
        this.nftLoading = !0, this.walletLoading = !0;
        try {
          const e = await Di.get(r);
          e.data.data.images && (this.nftImages = this.nftImages.concat(e.data.data.images), this.nftImages = Array.from(new Set(this.nftImages.map((t) => t.id))).map((t) => this.nftImages.find((n) => n.id === t))), this.nftNext = this.nftImages.length > 0 ? e.data.paging.next : null, this.nftLoading = !1, this.walletLoading = !1;
        } catch (e) {
          this.error = e.response.data ? e.response.data.errorMessage : "Sorry something went wrong, OpenSea is not currently reachable.", this.showError = !0, this.nftLoading = !1, this.walletLoading = !1;
        }
      }
    },
    async handleAccountsChanged(r) {
      this.showError = !1, this.nftImages = [], this.walletAccount = r[0], this.nftLoading == !1 && this.loadWalletImages();
    },
    async handleChainChanged(r) {
      this.showError = !1, this.nftImages = [], this.chainId = r, this.loadWalletImages();
    },
    // handle NFT wallet actions
    async walletLogin() {
      let r = null;
      if (window.ethereum) {
        ethereum.selectedAddress || await window.ethereum.request({ method: "eth_requestAccounts" }), this.listenersAttached == !1 && (window.ethereum.on("accountsChanged", this.handleAccountsChanged), window.ethereum.on("chainChanged", (n) => this.handleChainChanged), this.listenersAttached = !0), this.nftLoading = !0, this.walletAccount = ethereum.selectedAddress, this.web3 = new this.ethers.providers.Web3Provider(window.ethereum);
        let e = await this.web3.getNetwork();
        this.chainId = e.chainId, r == null && (r = await window.ethereum.request({ method: "eth_requestAccounts" })), r[0] ? (this.nftLoading = !1, this.loadWalletImages()) : console.log("error");
      } else
        console.log("no extension connected");
    },
    instagramLogout() {
      console.log("IG logout");
    },
    instagramStatusCallback(r) {
      r.access_token && r.user_id ? (this.isLoggedInToInstagram = !0, this.instagramToken = r.access_token, this.instagramUserId = r.user_id, this.loadInstagramImages()) : (this.isLoggedInToInstagram = !1, this.instagramToken = null, this.instagramUserId = null, this.instagramImages = []);
    },
    async loadInstagramImages() {
      const r = this.instagramNext || `https://graph.instagram.com/me/media?fields=id,media_url&access_token=${this.instagramToken}&limit=24`;
      try {
        const e = await Di.get(r);
        this.instagramImages = this.instagramImages.concat(e.data.data), this.instagramNext = e.data.paging.next;
      } catch (e) {
        this.error = e, this.showError = !0;
      }
    },
    async initializeEthers() {
      const r = Promise.resolve().then(() => Wk), { ethers: e } = await r;
      this.ethers = e;
    },
    attachIntersectionObservers() {
      this.uploadedImages.forEach((r, e) => {
        e <= 19 ? this.showImage(r.id) : this.attachIntersectionObserver(r.id);
      });
    },
    attachIntersectionObserver(r) {
      const e = "placeholder-" + r, t = document.querySelector("#" + e);
      tm(t, {}, async () => {
        this.showImage(r);
      });
    },
    showImage(r) {
      this.visibleImages.includes(r) || this.visibleImages.push(r);
    },
    imageSelectedParams(r) {
      return JSON.stringify({
        provider: r
      });
    },
    focusImageSelector() {
      this.triggerElement = document.activeElement, this.$nextTick(() => {
        let r;
        this.uploadedImages.length > 0 ? this.$refs.uploader.$refs.uploadBtn && (r = this.$refs.uploader.$refs.uploadBtn.$el) : this.$refs.uploader.$refs.emptyUploadBtn && (r = this.$refs.uploader.$refs.emptyUploadBtn.$el), r == null || r.focus();
      });
    },
    focusTriggerElement() {
      this.$nextTick(() => {
        var r;
        (r = this.triggerElement) == null || r.focus();
      });
    },
    handleKeyDown(r) {
      Vp(this.$refs.imageSelector, this.$refs.closeBtn.$el, r);
    },
    dragOver(r) {
      r.preventDefault(), this.isDragging = !0, clearTimeout(this.inActiveTimeout);
    },
    dragLeave(r) {
      r.preventDefault(), this.inActiveTimeout = setTimeout(() => {
        this.isDragging = !1;
      }, 50);
    },
    dropFiles(r) {
      r.preventDefault(), this.droppedImages = r.dataTransfer.files, this.isDragging = !1;
    }
  }
}, f5 = {
  key: 0,
  "data-dropzone": "",
  class: "inset-0 bg-white absolute pointer-events-none z-60"
}, h5 = /* @__PURE__ */ _("div", { class: "m-5 border-8 border-dashed border-gray-300 inset-0 absolute flex items-center jusitfy-center" }, [
  /* @__PURE__ */ _("div", { class: "text-center w-full text-3xl font-bold text-gray-500" }, " Drop your files here to upload ")
], -1), p5 = [
  h5
], m5 = { class: "absolute top-50 left-50 -translate-center font-bold" }, g5 = {
  key: 0,
  class: "p-4"
}, x5 = { class: "font-bold text-lg mb-2 leading-tight" }, b5 = { class: "text-gray-500 leading-tight text-sm" }, v5 = ["id"], y5 = { key: 1 }, w5 = ["onClick", "onKeydown"], _5 = { class: "text-center text-gray-600 my-8 w-full" }, E5 = { class: "font-bold" }, A5 = { class: "text-sm" }, S5 = {
  key: 0,
  class: "text-sm"
}, T5 = {
  key: "upload-error",
  class: "absolute inset-x-0 bottom-0 text-center text-sm bg-red-500 text-white rounded m-4 p-2 flex items-center shadow-lg"
}, M5 = { class: "w-6 h-6 bg-red-800 text-white flex justify-center items-center rounded mr-2" }, I5 = {
  key: 0,
  class: "flex-grow flex flex-wrap items-center content-center justify-center overflow-auto"
}, C5 = { class: "rounded m-4 bg-white shadow-lg" }, P5 = { class: "p-4" }, k5 = { class: "font-bold text-lg mb-2 leading-tight" }, O5 = { class: "text-gray-500 leading-tight text-sm" }, N5 = { class: "p-4 bg-vanilla-50 text-right" }, R5 = {
  key: 1,
  class: "flex flex-wrap overflow-auto"
}, L5 = {
  key: "fb-error",
  class: "absolute inset-x-0 bottom-0 text-center text-sm bg-red-500 text-white rounded m-4 p-2 flex items-center shadow-lg"
}, D5 = { class: "w-6 h-6 bg-red-800 text-white flex justify-center items-center rounded mr-2" }, F5 = {
  key: 0,
  class: "flex-grow flex flex-wrap items-center content-center justify-center overflow-auto"
}, B5 = { class: "rounded m-4 bg-white shadow-lg" }, j5 = { class: "p-4" }, U5 = { class: "font-bold text-lg mb-2 leading-tight" }, z5 = { class: "text-gray-500 leading-tight text-sm" }, W5 = { class: "p-4 bg-gray-50 text-right" }, H5 = {
  key: 1,
  class: "flex flex-wrap overflow-auto"
}, V5 = {
  key: "ig-error",
  class: "absolute inset-x-0 bottom-0 text-center text-sm bg-red-500 text-white rounded m-4 p-2 flex items-center shadow-lg"
}, $5 = { class: "w-6 h-6 bg-red-800 text-white flex justify-center items-center rounded mr-2" }, G5 = {
  key: 0,
  class: "flex-grow flex flex-wrap items-center content-center justify-center overflow-auto"
}, K5 = { class: "rounded m-4 bg-white shadow-lg" }, Y5 = { class: "p-4" }, q5 = { class: "font-bold text-lg mb-2 leading-tight" }, Z5 = { class: "text-gray-500 leading-tight text-sm" }, J5 = { class: "p-4 bg-gray-50 text-right" }, X5 = {
  key: "noimages",
  class: "flex-grow flex flex-wrap items-center content-center justify-center overflow-auto"
}, Q5 = /* @__PURE__ */ _("div", { class: "rounded m-4 bg-white shadow-lg lg:w-1/2 xl:w-1/3" }, [
  /* @__PURE__ */ _("div", { class: "p-4" }, [
    /* @__PURE__ */ _("p", { class: "font-bold text-lg mb-2 leading-tight" }, " There are no images in the connected wallet. "),
    /* @__PURE__ */ _("p", { class: "text-gray-500 leading-tight text-sm" }, " Make sure you've selected the correct wallet and network in metamask. ")
  ])
], -1), e8 = [
  Q5
], t8 = {
  key: 2,
  class: "flex flex-wrap overflow-auto"
}, r8 = {
  key: "nft-error",
  class: "absolute inset-x-0 bottom-0 text-center text-sm bg-red-500 text-white rounded m-4 p-2 flex items-center shadow-lg z-10"
}, n8 = { class: "w-6 h-6 bg-red-800 text-white flex justify-center items-center rounded mr-2" };
function i8(r, e, t, n, i, s) {
  const a = Pt("Loader"), o = Pt("Dialog"), l = Pt("Header"), c = Pt("Uploader"), u = Pt("Thumbnail"), f = Pt("Checkmark"), p = Pt("vue-feather"), x = Pt("Body"), T = Pt("TabContent"), v = Pt("ActionButton"), w = Pt("Footer"), E = Pt("Tabs"), C = Pt("IconButton");
  return N(), j("div", {
    class: Pe(s.classList),
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "Image Selector",
    ref: "imageSelector",
    onDragover: e[8] || (e[8] = (...P) => s.dragOver && s.dragOver(...P)),
    onDragleave: e[9] || (e[9] = (...P) => s.dragLeave && s.dragLeave(...P)),
    onDrop: e[10] || (e[10] = (...P) => s.dropFiles && s.dropFiles(...P)),
    tabindex: "0"
  }, [
    ae(br, { name: "transition-fade" }, {
      default: Se(() => [
        i.isDragging ? (N(), j("div", f5, p5)) : se("", !0)
      ]),
      _: 1
    }),
    ae(a, {
      overlay: "",
      visible: i.loading,
      class: "absolute inset-0 text-olive-500",
      label: r.$t("message.constants.messages.loadingProcessingImage")
    }, null, 8, ["visible", "label"]),
    Ke(ae(o, {
      "data-remove-confirm": "",
      "has-cancel-option": "",
      visible: i.removeIndex !== null,
      heading: r.$t("message.imageSelector.removeUpload.heading"),
      "cancel-label": r.$t("message.imageSelector.removeUpload.cancelLabel"),
      "confirm-label": r.$t("message.imageSelector.removeUpload.confirmLabel"),
      onConfirm: e[0] || (e[0] = (P) => s.removeUpload(i.removeIndex)),
      onCancel: e[1] || (e[1] = (P) => i.removeIndex = null)
    }, {
      default: Se(() => [
        _("p", null, he(r.$t("message.imageSelector.removeUpload.warning")), 1)
      ]),
      _: 1
    }, 8, ["visible", "heading", "cancel-label", "confirm-label"]), [
      [tt, i.removeIndex !== null]
    ]),
    ae(l, { class: "border-b" }, {
      default: Se(() => [
        _("p", m5, he(r.$t("message.imageSelector.selectAnImage")), 1)
      ]),
      _: 1
    }),
    ae(x, { class: "bg-vanilla-50" }, {
      default: Se(() => [
        ae(E, { class: "border-b" }, {
          labels: Se(() => []),
          content: Se(() => [
            ae(J1, {
              name: `transition-slide-${i.transition}`,
              tag: "div",
              ref: "tabContent",
              "aria-label": "tabpanel",
              tabindex: "0"
            }, {
              default: Se(() => [
                Ke(ae(T, {
                  key: "a",
                  "data-tab-uploads": "",
                  class: "flex flex-col"
                }, {
                  default: Se(() => [
                    ae(x, null, {
                      default: Se(() => [
                        _("div", {
                          class: Pe(s.thumbnailWrapperClassList)
                        }, [
                          _("div", {
                            "data-upload": "",
                            class: Pe(s.thumbnailClassList)
                          }, [
                            s.isEmptyState ? (N(), j("div", g5, [
                              _("p", x5, he(r.$t("message.imageSelector.noUploadedImages")), 1),
                              _("p", b5, he(r.$t("message.imageSelector.uploadPhotosDirectly")), 1)
                            ])) : se("", !0),
                            _("div", {
                              class: Pe(s.uploaderClassList)
                            }, [
                              ae(c, {
                                uploading: i.uploading,
                                isActionBtn: s.isEmptyState,
                                droppedImages: i.droppedImages,
                                onUploadStart: s.handleUploadStart,
                                onUploadEnd: s.handleUploadEnd,
                                onUploadError: s.handleUploadError,
                                ref: "uploader"
                              }, null, 8, ["uploading", "isActionBtn", "droppedImages", "onUploadStart", "onUploadEnd", "onUploadError"])
                            ], 2)
                          ], 2),
                          (N(!0), j(De, null, wt(i.uploadedImages, (P, F) => (N(), j("div", {
                            key: P.id,
                            class: "relative w-1/4 md:w-1/6 xl:w-1/8"
                          }, [
                            i.visibleImages.includes(P.id) ? se("", !0) : (N(), j("div", {
                              key: 0,
                              id: "placeholder-" + P.id,
                              class: "pt-full"
                            }, null, 8, v5)),
                            i.visibleImages.includes(P.id) ? (N(), j("div", y5, [
                              ae(u, {
                                tabindex: "0",
                                "data-module-analytics-track-click": "",
                                "data-module-analytics-category": "image_providers",
                                "data-module-analytics-action": "image_selected",
                                "data-module-analytics-label": "upload",
                                "data-module-analytics-value": "1",
                                "data-module-analytics-event-name": "builder_select_image",
                                "data-module-analytics-event-parameters": s.imageSelectedParams("upload"),
                                image: P.thumbPath,
                                selected: t.selectedImages.indexOf(P.id) !== -1,
                                "aria-label": t.selectedImages.indexOf(P.id) !== -1 ? "selected image" : "image",
                                onClick: (k) => s.handleSelectImage(P),
                                onError: (k) => s.removeUpload(F)
                              }, null, 8, ["data-module-analytics-event-parameters", "image", "selected", "aria-label", "onClick", "onError"]),
                              ae(f, {
                                checked: t.selectedImages.indexOf(P.id) !== -1,
                                class: "absolute top-1/8 left-1/8 -translate-center z-20 m-1"
                              }, null, 8, ["checked"]),
                              _("div", {
                                "data-remove-upload-btn": "",
                                "data-module-analytics-track-click": "",
                                "data-module-analytics-category": "imageSelector",
                                "data-module-analytics-action": "click",
                                "data-module-analytics-label": "Confirm remove upload",
                                "data-module-analytics-value": "1",
                                class: "rounded-full bg-opacity-60 absolute top-0 right-0 bg-black p-1 m-1 cursor-pointer focus-visible:outline-olive-500",
                                "aria-label": "Remove image",
                                tabindex: "0",
                                onClick: (k) => s.handleConfirmRemoveUpload(F),
                                onKeydown: Us((k) => s.handleConfirmRemoveUpload(F), ["enter"])
                              }, [
                                ae(p, {
                                  type: "x",
                                  "aria-hidden": "true",
                                  class: "w-4 h-4 text-white block"
                                })
                              ], 40, w5)
                            ])) : se("", !0)
                          ]))), 128)),
                          _("div", _5, [
                            _("p", E5, he(r.$t("message.imageSelector.supportedFormats.label")), 1),
                            _("p", A5, he(r.$t("message.imageSelector.supportedFormats.formats")), 1),
                            t.uploadLater ? (N(), j("p", S5, [
                              Ea(he(r.$t("message.imageSelector.supportedFormats.formatUnavailable")) + " ", 1),
                              _("a", {
                                onClick: e[2] || (e[2] = (...P) => s.handleUploadLater && s.handleUploadLater(...P)),
                                class: "underline text-olive-500 cursor-pointer"
                              }, he(r.$t("message.imageSelector.supportedFormats.provideLater")), 1)
                            ])) : se("", !0)
                          ])
                        ], 2)
                      ]),
                      _: 1
                    }),
                    ae(br, { name: "transition-slide-fade-bottom" }, {
                      default: Se(() => [
                        Ke(_("div", T5, [
                          _("div", M5, [
                            ae(p, {
                              type: "alert-circle",
                              class: "w-4 h-4 block"
                            })
                          ]),
                          _("div", null, he(i.error), 1),
                          _("div", {
                            class: "w-6 h-6 text-white flex justify-center items-center rounded ml-auto",
                            onClick: e[3] || (e[3] = (P) => i.showError = !1)
                          }, [
                            ae(p, {
                              type: "x",
                              class: "w-4 h-4 block"
                            })
                          ])
                        ], 512), [
                          [tt, i.showError]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [tt, i.selectedTab === 0]
                ]),
                Ke(ae(T, {
                  key: "b",
                  "data-tab-facebook": "",
                  class: "flex flex-col"
                }, {
                  default: Se(() => [
                    ae(x, null, {
                      default: Se(() => [
                        i.facebookImages.length === 0 ? (N(), j("div", I5, [
                          _("div", C5, [
                            _("div", P5, [
                              _("p", k5, he(r.$t("message.imageSelector.facebook.title")), 1),
                              _("p", O5, he(r.$t("message.imageSelector.facebook.description")), 1)
                            ]),
                            _("div", N5, [
                              ae(v, {
                                "data-login-facebook": "",
                                class: "btn--primary w-full sm:w-auto",
                                label: r.$t("message.imageSelector.facebook.login"),
                                onClick: s.facebookLogin
                              }, null, 8, ["label", "onClick"])
                            ])
                          ])
                        ])) : (N(), j("div", R5, [
                          (N(!0), j(De, null, wt(i.facebookImages, (P) => (N(), j("div", {
                            key: P.id,
                            class: "relative w-1/4 md:w-1/6 xl:w-1/8"
                          }, [
                            ae(u, {
                              tabindex: "0",
                              "aria-label": t.selectedImages.indexOf(P.id) !== -1 ? "selected image" : "image",
                              image: P.thumbPath ? P.thumbPath : P.picture,
                              selected: t.selectedImages.indexOf(P.id) !== -1,
                              "data-module-analytics-track-click": "",
                              "data-module-analytics-category": "image_providers",
                              "data-module-analytics-action": "image_selected",
                              "data-module-analytics-label": "facebook",
                              "data-module-analytics-value": "1",
                              "data-module-analytics-event-name": "builder_select_image",
                              "data-module-analytics-event-parameters": s.imageSelectedParams("facebook"),
                              onClick: (F) => s.handleSelectImage(P.thumbPath ? P : P.images[0].source, !P.thumbPath, i.KEY_FACEBOOK)
                            }, null, 8, ["aria-label", "image", "selected", "data-module-analytics-event-parameters", "onClick"]),
                            ae(f, {
                              checked: t.selectedImages.indexOf(P.id) !== -1,
                              class: "absolute top-1/8 left-1/8 -translate-center z-20 m-1"
                            }, null, 8, ["checked"])
                          ]))), 128))
                        ]))
                      ]),
                      _: 1
                    }),
                    ae(br, { name: "transition-slide-fade-bottom" }, {
                      default: Se(() => [
                        Ke(_("div", L5, [
                          _("div", D5, [
                            ae(p, {
                              type: "alert-circle",
                              class: "w-4 h-4 block"
                            })
                          ]),
                          _("div", null, he(i.error), 1),
                          _("div", {
                            class: "w-6 h-6 text-white flex justify-center items-center rounded ml-auto",
                            onClick: e[4] || (e[4] = (P) => i.showError = !1)
                          }, [
                            ae(p, {
                              type: "x",
                              class: "w-4 h-4 block"
                            })
                          ])
                        ], 512), [
                          [tt, i.showError]
                        ])
                      ]),
                      _: 1
                    }),
                    i.facebookNext ? (N(), Ne(w, {
                      key: 0,
                      class: "p-4 border-t flex flex-col flex-shrink-0 justify-center relative bg-white w-full md:flex-row md:justify-center"
                    }, {
                      default: Se(() => [
                        ae(v, {
                          class: "btn--primary w-full md:w-1/3 lg:w-1/4 xl:w-1/5",
                          label: r.$t("message.imageSelector.loadMoreImages"),
                          onClick: s.loadFacebookImages
                        }, null, 8, ["label", "onClick"])
                      ]),
                      _: 1
                    })) : se("", !0)
                  ]),
                  _: 1
                }, 512), [
                  [tt, i.selectedTab === 1]
                ]),
                Ke(ae(T, {
                  key: "c",
                  "data-tab-instagram": "",
                  class: "flex flex-col"
                }, {
                  default: Se(() => [
                    ae(x, null, {
                      default: Se(() => [
                        i.instagramImages.length === 0 ? (N(), j("div", F5, [
                          _("div", B5, [
                            _("div", j5, [
                              _("p", U5, he(r.$t("message.imageSelector.instagram.title")), 1),
                              _("p", z5, he(r.$t("message.imageSelector.instagram.description")), 1)
                            ]),
                            _("div", W5, [
                              ae(v, {
                                "data-login-instagram": "",
                                class: "btn--primary w-full sm:w-auto",
                                label: r.$t("message.imageSelector.instagram.login"),
                                onClick: s.instagramLogin
                              }, null, 8, ["label", "onClick"])
                            ])
                          ])
                        ])) : (N(), j("div", H5, [
                          (N(!0), j(De, null, wt(i.instagramImages, (P) => (N(), j("div", {
                            key: P.id,
                            class: "relative w-1/4 md:w-1/6 xl:w-1/8"
                          }, [
                            ae(u, {
                              tabindex: "0",
                              "aria-label": t.selectedImages.indexOf(P.id) !== -1 ? "selected image" : "image",
                              image: P.thumbPath ? P.thumbPath : P.media_url,
                              selected: t.selectedImages.indexOf(P.id) !== -1,
                              "data-module-analytics-track-click": "",
                              "data-module-analytics-category": "image_providers",
                              "data-module-analytics-action": "image_selected",
                              "data-module-analytics-label": "instagram",
                              "data-module-analytics-value": "1",
                              "data-module-analytics-event-name": "builder_select_image",
                              "data-module-analytics-event-parameters": s.imageSelectedParams("instagram"),
                              onClick: (F) => s.handleSelectImage(P.thumbPath ? P : P.media_url, !P.thumbPath, i.KEY_INSTAGRAM)
                            }, null, 8, ["aria-label", "image", "selected", "data-module-analytics-event-parameters", "onClick"]),
                            ae(f, {
                              checked: t.selectedImages.indexOf(P.id) !== -1,
                              class: "absolute top-1/8 left-1/8 -translate-center z-20 m-1"
                            }, null, 8, ["checked"])
                          ]))), 128))
                        ]))
                      ]),
                      _: 1
                    }),
                    ae(br, { name: "transition-slide-fade-bottom" }, {
                      default: Se(() => [
                        Ke(_("div", V5, [
                          _("div", $5, [
                            ae(p, {
                              type: "alert-circle",
                              class: "w-4 h-4 block"
                            })
                          ]),
                          _("div", null, he(i.error), 1),
                          _("div", {
                            class: "w-6 h-6 text-white flex justify-center items-center rounded ml-auto",
                            onClick: e[5] || (e[5] = (P) => i.showError = !1)
                          }, [
                            ae(p, {
                              type: "x",
                              class: "w-4 h-4 block"
                            })
                          ])
                        ], 512), [
                          [tt, i.showError]
                        ])
                      ]),
                      _: 1
                    }),
                    i.instagramNext ? (N(), Ne(w, {
                      key: 0,
                      class: "p-4 border-t flex flex-col flex-shrink-0 justify-center relative bg-white w-full md:flex-row md:justify-center"
                    }, {
                      default: Se(() => [
                        ae(v, {
                          class: "btn--primary w-full mb-2 md:mb-0 md:mx-1 md:w-1/3 lg:w-1/4 xl:w-1/5",
                          label: r.$t("message.imageSelector.loadMoreImages"),
                          onClick: s.loadInstagramImages
                        }, null, 8, ["label", "onClick"])
                      ]),
                      _: 1
                    })) : se("", !0)
                  ]),
                  _: 1
                }, 512), [
                  [tt, i.selectedTab === 2]
                ]),
                Ke(ae(T, {
                  key: "d",
                  "data-tab-nft": "",
                  class: "flex flex-col"
                }, {
                  default: Se(() => [
                    ae(x, null, {
                      default: Se(() => [
                        i.nftImages.length === 0 && i.walletAccount == null || i.nftLoading == !0 && i.nftImages.length === 0 ? (N(), j("div", G5, [
                          _("div", K5, [
                            _("div", Y5, [
                              _("p", q5, he(r.$t(s.nftTitleLabel)), 1),
                              _("p", Z5, he(r.$t(s.nftDescriptionLabel)), 1)
                            ]),
                            _("div", J5, [
                              ae(v, {
                                "data-login-nft": "",
                                class: "btn--primary w-full sm:w-auto",
                                label: r.$t(s.connectWalletLabel),
                                loading: i.nftLoading,
                                onClick: e[6] || (e[6] = (P) => s.walletLogin())
                              }, null, 8, ["label", "loading"])
                            ])
                          ])
                        ])) : se("", !0),
                        i.nftImages.length === 0 && i.walletAccount && i.nftLoading == !1 ? (N(), j("div", X5, e8)) : (N(), j("div", t8, [
                          (N(!0), j(De, null, wt(i.nftImages, (P) => (N(), j("div", {
                            key: P.id,
                            class: "relative w-1/4 md:w-1/6 lg:w-1/8 xl:w-1/10"
                          }, [
                            ae(u, {
                              tabindex: "0",
                              "aria-label": t.selectedImages.indexOf(P.id) !== -1 ? "selected image" : "image",
                              image: P.thumbPath ? P.thumbPath : P.mediaUrl,
                              selected: t.selectedImages.indexOf(P.id) !== -1,
                              "data-module-analytics-track-click": "",
                              "data-module-analytics-category": "image_providers",
                              "data-module-analytics-action": "image_selected",
                              "data-module-analytics-label": "nft",
                              "data-module-analytics-value": "1",
                              "data-module-analytics-event-name": "builder_select_image",
                              "data-module-analytics-event-parameters": s.imageSelectedParams("nft"),
                              onClick: (F) => s.handleSelectImage(P.thumbPath ? P : P.mediaUrl, !P.thumbPath, i.KEY_NFT)
                            }, null, 8, ["aria-label", "image", "selected", "data-module-analytics-event-parameters", "onClick"]),
                            ae(f, {
                              checked: t.selectedImages.indexOf(P.id) !== -1,
                              class: "absolute top-1/8 left-1/8 -translate-center z-20 m-1"
                            }, null, 8, ["checked"])
                          ]))), 128))
                        ]))
                      ]),
                      _: 1
                    }),
                    ae(br, { name: "transition-slide-fade-bottom" }, {
                      default: Se(() => [
                        Ke(_("div", r8, [
                          _("div", n8, [
                            ae(p, {
                              type: "alert-circle",
                              class: "w-4 h-4 block"
                            })
                          ]),
                          _("div", null, he(i.error), 1),
                          _("div", {
                            class: "w-6 h-6 text-white flex justify-center items-center rounded ml-auto",
                            onClick: e[7] || (e[7] = (P) => i.showError = !1)
                          }, [
                            ae(p, {
                              type: "x",
                              class: "w-4 h-4 block"
                            })
                          ])
                        ], 512), [
                          [tt, i.showError]
                        ])
                      ]),
                      _: 1
                    }),
                    i.nftNext ? (N(), Ne(w, {
                      key: 0,
                      class: "p-4 border-t flex flex-col flex-shrink-0 justify-center relative bg-white w-full md:flex-row md:justify-center"
                    }, {
                      default: Se(() => [
                        ae(v, {
                          class: "btn--primary w-full mb-2 md:mb-0 md:mx-1 md:w-1/3 lg:w-1/4 xl:w-1/5",
                          label: r.$t("message.imageSelector.loadMoreImages"),
                          loading: i.nftLoading,
                          onClick: s.loadWalletImages
                        }, null, 8, ["label", "loading", "onClick"])
                      ]),
                      _: 1
                    })) : se("", !0)
                  ]),
                  _: 1
                }, 512), [
                  [tt, i.selectedTab === 3]
                ])
              ]),
              _: 1
            }, 8, ["name"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    t.uploadLater ? (N(), Ne(w, {
      key: 0,
      class: "p-4 flex flex-col flex-shrink-0 justify-center relative bg-white w-full md:justify-end md:flex-row md:justify-center lg:rounded-lg"
    }, {
      default: Se(() => [
        ae(v, {
          "data-test-id": "upload-later",
          class: "btn--secondary w-full sm:w-auto md:mx-1 md:w-auto md:w-1/3 lg:w-1/4 xl:w-1/5",
          label: r.$t("message.imageSelector.provideImageLater"),
          onClick: s.handleUploadLater
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    })) : se("", !0),
    ae(C, {
      "data-close": "",
      icon: "x",
      class: "ml-auto right-0 top-0 z-20",
      ref: "closeBtn",
      position: "absolute",
      "accessibility-label": r.$t("message.builder.header.closeAccessibility"),
      onClick: s.handleCancel
    }, null, 8, ["accessibility-label", "onClick"])
  ], 34);
}
const s8 = /* @__PURE__ */ Vt(d5, [["render", i8]]), a8 = { class: "text-ginger-700 bg-ginger-50 text-sm px-4 my-3 py-2" }, o8 = { "data-size-image-error-message": "" }, l8 = { key: 0 }, ol = /* @__PURE__ */ vr({
  __name: "SizeImageError",
  props: {
    stringKeyPath: {
      type: String,
      default: "message.customizer.configurator.categories.imageSize.errorMessage"
    },
    enableChooseSmallerSizeAction: {
      type: Boolean,
      default: !0
    },
    enableUploadNewImageAction: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["showImageSizePanel", "openImageSelector"],
  setup(r, { emit: e }) {
    const t = r, n = Y(() => [
      t.enableChooseSmallerSizeAction ? "text-black underline font-bold cursor-pointer" : ""
    ]);
    return (i, s) => {
      const a = Pt("i18n-t");
      return N(), j("div", a8, [
        _("p", o8, [
          ae(a, {
            keypath: r.stringKeyPath,
            scope: "global"
          }, {
            chooseSmallerSize: Se(() => [
              _("a", {
                onClick: s[0] || (s[0] = (o) => e("showImageSizePanel")),
                class: Pe(m(n))
              }, he(i.$t("message.customizer.configurator.categories.imageSize.chooseSmallerSize")), 3),
              r.enableUploadNewImageAction ? (N(), j("span", l8, " " + he(i.$t("message.customizer.configurator.categories.imageSize.or")), 1)) : se("", !0)
            ]),
            uploadNewImage: Se(() => [
              r.enableUploadNewImageAction ? (N(), j("a", {
                key: 0,
                onClick: s[1] || (s[1] = (o) => e("openImageSelector")),
                class: "text-black underline font-bold cursor-pointer"
              }, he(i.$t("message.customizer.configurator.categories.imageSize.uploadNewImage")), 1)) : se("", !0)
            ]),
            _: 1
          }, 8, ["keypath"])
        ])
      ]);
    };
  }
}), zl = 5, oo = 8, lo = 23, ha = 24, co = 25, dm = 26, Dr = 27, kn = 28, Fr = 29, Hn = 30, af = 31, Wl = 32, of = 33, lf = 34;
function lh(r, e, t) {
  return us(e * r + t);
}
function ou(r, e, t = 0, n = 0, i = 0, s = 0, a = 0) {
  const o = a ? a * 2 : 0, l = r + o + n + s - sh, c = e + o + t + i - sh;
  return cf(l, c);
}
function c8(r, e, t = 0) {
  const n = t ? t * 2 : 0, i = r + n, s = e + n;
  return cf(i, s);
}
function cf(r, e) {
  const t = r * e / 144;
  return Math.ceil(t * 2) / 2;
}
function Ma(r, e, t = 0, n = 0, i = 0) {
  const s = t + n, a = i ? i * 2 : 0, o = e === On || e === Aa ? s + a : 0;
  return r + o;
}
function fm(r, e) {
  return e ? r[e].value : 0;
}
function u8(r, e, t, n) {
  const s = cf(r, e) * t[n].foreignPrice, a = t[n].additionalFee;
  return s + a;
}
function d8(r, e, t) {
  const n = r ? parseInt(r.split("|")[0], 10) : 0, i = r ? parseInt(r.split("|")[1], 10) : 0, s = n * i, a = t ? e[t].foreignPrice : 0, o = e[t].basePrice ?? 0;
  return us(s * a + o);
}
function us(r) {
  return parseFloat((Math.ceil(r * 100) / 100).toFixed(2));
}
function f8(r, e, t) {
  return r[e] && r[e].frames && r[e].frames[t] ? r[e].frames[t].foreignPrice : 0;
}
function h8(r, e, t) {
  if (r[e] && r[e].frames && r[e].frames[t]) {
    const n = r[e].frames[t], i = n.specialPrice ? n.foreignPrice - n.specialPrice : n.foreignPrice;
    return n.specialPrice ? i : 0;
  } else
    return 0;
}
function p8(r, e, t, n) {
  return n && r[e] && r[e].canvasDepths && r[e].canvasDepths[t] ? r[e].canvasDepths[t].foreignPrice : 0;
}
function m8(r, e, t, n, i, s) {
  const o = t ? {
    "075D": 1.125,
    "100D": 1.25,
    "150D": 1.875,
    "200D": 2.375,
    RLD: 2
  }[t] * 2 : 0, l = r + o, c = e + o, u = c8(l, c, n), f = s ? i[s].foreignPrice : 0;
  return u * f;
}
function g8(r, e, t) {
  const n = r ? parseInt(r.split("|")[0], 10) : 0, i = r ? parseInt(r.split("|")[1], 10) : 0, s = n * i, a = t ? e[t].foreignPrice : 0, o = e[t].basePrice ?? 0;
  return us(s * a + o);
}
function x8(r, e) {
  for (let t = 0; t < e.length; t++) {
    const [n, i, s] = e[t];
    if (r > n && r <= i)
      return s;
  }
}
function Pn(r, e, t) {
  if (t) {
    const n = t.minWidth, i = t.maxWidth, s = t.minHeight, a = t.maxHeight;
    if (n && i && s && a) {
      const o = Math.max(r, e), l = Math.min(r, e), c = Math.max(i, a), u = Math.min(i, a), f = o <= c && l <= u, p = Math.max(n, s), x = Math.min(n, s), T = o >= p && l >= x;
      return f && T;
    }
  }
  return !0;
}
function b8(r, e, t, n, i, s, a, o, l, c) {
  let u = r ? r.minSize : null;
  u = c ?? u;
  let f = null, p = null, x = null, T = null, v = null, w = null, E = null, C = null, P = null, F = null, k = null, K = null;
  e && t && (p = c ?? Math.min(e[t].minWidth, e[t].minHeight), x = Math.min(e[t].maxHeight, e[t].maxWidth), T = Math.max(e[t].maxHeight, e[t].maxWidth));
  let Z = s ? i[s] : null;
  if (Z && (v = Math.min(Z.minWidth, Z.minHeight), w = Z.maxHeight, E = Z.maxWidth), l)
    k = l.lowerMax, K = l.higherMax;
  else if (n && Z) {
    const _e = Math.round(n.width / 150 * 3), L = Math.round(n.height / 150 * 3);
    k = Math.min(_e, L), K = Math.max(_e, L);
  }
  let ne = o ? a[o] : null;
  ne && (C = Math.min(ne.minWidth, ne.minHeight), P = ne.maxHeight, F = ne.maxWidth);
  const le = [u, p, v, C].filter((_e) => _e !== null), ye = [f, x, w, k, P].filter((_e) => _e !== null), ge = [f, T, E, K, F].filter((_e) => _e !== null);
  return {
    minSize: Math.max(...le),
    // get highest of the min sizes
    lowerMaxSize: Math.min(...ye),
    // get lowest of the max sizes
    higherMaxSize: Math.min(...ge),
    // get highest of the max sizes
    minPotentialSize: p ?? u,
    // provides lowest options to be greyed out
    lowerMaxPotentialSize: x ?? E,
    // provides highest options to be greyed out
    higherMaxPotentialSize: T ?? E
    // provides highest options to be greyed out
  };
}
function ch(r, e, t, n, i) {
  let { minSize: s, lowerMaxSize: a, higherMaxSize: o, minPotentialSize: l, lowerMaxPotentialSize: c, higherMaxPotentialSize: u } = r, f = 0;
  const p = i ? u : o, x = i ? c : a;
  t <= x ? f = p : (t > x || t > x && e > x) && (f = x);
  let T = [];
  if (l && u)
    for (let v = l; v <= u; v++) {
      let w = !0;
      if (v >= s && v <= f) {
        let E = t === 5 && v < 7, C = t === 6 && v < 6;
        n && v === f || E || C ? w = !0 : w = !1;
      }
      T.push({ label: v, value: v, disabled: w });
    }
  return T;
}
function uh(r, e, t, n) {
  let { lowerMaxSize: i, higherMaxSize: s, lowerMaxPotentialSize: a, higherMaxPotentialSize: o } = r, l = 0;
  const c = n ? o : s, u = n ? a : i;
  return t <= u ? l = c : (t > u || t > u && e > u) && (l = u), e < l;
}
function v8(r) {
  let e = r, t = e.productData.options, n = t[Fr] ? t[Fr].bottom : 0, i = t[kn] ? t[kn].bottom : 0, s = t[Dr] ? t[Dr].bottom : 0;
  return t[Fr] && (t[Fr] = n), t[kn] && (t[kn] = i), t[Dr] && (t[Dr] = s), e;
}
function hm(r, e, t, n = !1) {
  return Object.fromEntries(
    Object.entries(r).filter((i) => n ? Pn(e, t, i[1]) && i[1].availabilityStatus !== va : Pn(e, t, i[1]))
  );
}
function lu(r) {
  return Object.fromEntries(
    Object.entries(r).filter((e) => e[1].availabilityStatus !== va)
  );
}
function uo(r, e, t, n, i, s, a, o) {
  let l = Ma(t, i, r, r, s), c = Ma(n, i, e, e, s);
  const u = Pn(l, c, o);
  let f = {};
  u && (f = hm(
    a,
    l,
    c,
    !0
  ));
  const p = !!f[ro], x = !!f[Wu], T = Object.keys(f).length !== 0, v = T ? Object.keys(f)[0] : null;
  return {
    whiteMatCompatible: p,
    blackMatCompatible: x,
    hasMats: T,
    firstMat: v
  };
}
function dh(r, e = 16) {
  if (r = Number(r), isNaN(r))
    return "";
  if (r % 1 === 0)
    return r.toString();
  const t = Math.floor(r), n = r - t, i = [
    { value: 1 / 32, fraction: "1/32" },
    { value: 1 / 16, fraction: "1/16" },
    { value: 3 / 32, fraction: "3/32" },
    { value: 1 / 8, fraction: "1/8" },
    { value: 5 / 32, fraction: "5/32" },
    { value: 3 / 16, fraction: "3/16" },
    { value: 7 / 32, fraction: "7/32" },
    { value: 1 / 4, fraction: "1/4" },
    { value: 9 / 32, fraction: "9/32" },
    { value: 5 / 16, fraction: "5/16" },
    { value: 11 / 32, fraction: "11/32" },
    { value: 3 / 8, fraction: "3/8" },
    { value: 13 / 32, fraction: "13/32" },
    { value: 7 / 16, fraction: "7/16" },
    { value: 15 / 32, fraction: "15/32" },
    { value: 1 / 2, fraction: "1/2" },
    { value: 17 / 32, fraction: "17/32" },
    { value: 9 / 16, fraction: "9/16" },
    { value: 19 / 32, fraction: "19/32" },
    { value: 5 / 8, fraction: "5/8" },
    { value: 21 / 32, fraction: "21/32" },
    { value: 11 / 16, fraction: "11/16" },
    { value: 23 / 32, fraction: "23/32" },
    { value: 3 / 4, fraction: "3/4" },
    { value: 25 / 32, fraction: "25/32" },
    { value: 13 / 16, fraction: "13/16" },
    { value: 27 / 32, fraction: "27/32" },
    { value: 7 / 8, fraction: "7/8" },
    { value: 29 / 32, fraction: "29/32" },
    { value: 15 / 16, fraction: "15/16" },
    { value: 31 / 32, fraction: "31/32" }
  ];
  let s = i[0], a = Math.abs(n - s.value);
  for (const l of i) {
    const c = Math.abs(n - l.value);
    c < a && (a = c, s = l);
  }
  if (a < 0.01)
    return t > 0 ? `${t} ${s.fraction}` : s.fraction;
  const o = Math.round(n * 8) / 8;
  if (o === 0)
    return t.toString();
  if (o === 1)
    return (t + 1).toString();
  for (const l of i)
    if (Math.abs(o - l.value) < 1e-3)
      return t > 0 ? `${t} ${l.fraction}` : l.fraction;
  return Number(r).toFixed(e);
}
function y8(r) {
  const e = /\d+/g, t = r.match(e);
  if (!t || t.length !== 2)
    throw new Error("The string should contain exactly two numbers.");
  const [n, i] = t;
  return r.replace(n, "TEMP").replace(i, n).replace("TEMP", i);
}
function w8(r, e) {
  const t = parseFloat(r.split("|")[0]), n = parseFloat(r.split("|")[1]);
  let i, s;
  switch (r) {
    case "5|7":
    case "5|8":
    case "6|8":
      i = 8, s = 12;
      break;
    case "7|5":
    case "8|5":
    case "8|6":
      i = 12, s = 8;
      break;
    case "6|7":
    case "7|8":
    case "7|6":
    case "8|7":
    case "6|6":
    case "7|7":
      i = 8, s = 8;
      break;
    default:
      i = t < e ? e : t, s = n < e ? e : n;
      break;
  }
  return i + "|" + s;
}
const _8 = () => "10000000-1000-4000-8000-100000000000".replace(
  /[018]/g,
  (r) => (+r ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +r / 4).toString(16)
), fh = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI1IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWFzayBpZD0icGF0aC0xLWluc2lkZS0xXzE2NTlfOTA2NCIgZmlsbD0id2hpdGUiPgo8cGF0aCBkPSJNMC43NSAwSDI0Ljc1VjI0SDAuNzVWMFoiLz4KPC9tYXNrPgo8cGF0aCBkPSJNMC43NSAyNEgtOS4yNVYzNEgwLjc1VjI0Wk0yNC43NSAxNEgwLjc1VjM0SDI0Ljc1VjE0Wk0xMC43NSAyNFYwSC05LjI1VjI0SDEwLjc1WiIgZmlsbD0iI0NBQzlDOSIgbWFzaz0idXJsKCNwYXRoLTEtaW5zaWRlLTFfMTY1OV85MDY0KSIvPgo8bWFzayBpZD0icGF0aC0zLWluc2lkZS0yXzE2NTlfOTA2NCIgZmlsbD0id2hpdGUiPgo8cGF0aCBkPSJNMTAuNzUgMEgyNC43NVYxNEgxMC43NVYwWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik0xMC43NSAxNEg3Ljc1VjE3SDEwLjc1VjE0Wk0yNC43NSAxMUgxMC43NVYxN0gyNC43NVYxMVpNMTMuNzUgMTRWMEg3Ljc1VjE0SDEzLjc1WiIgZmlsbD0iI0FFNDIxRSIgbWFzaz0idXJsKCNwYXRoLTMtaW5zaWRlLTJfMTY1OV85MDY0KSIvPgo8L3N2Zz4=", hh = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI1IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWFzayBpZD0icGF0aC0xLWluc2lkZS0xXzE2NTlfOTA1NyIgZmlsbD0id2hpdGUiPgo8cGF0aCBkPSJNMC4yNSAwSDI0LjI1VjI0SDAuMjVWMFoiLz4KPC9tYXNrPgo8cGF0aCBkPSJNMC4yNSAyNEgtOS43NVYzNEgwLjI1VjI0Wk0yNC4yNSAxNEgwLjI1VjM0SDI0LjI1VjE0Wk0xMC4yNSAyNFYwSC05Ljc1VjI0SDEwLjI1WiIgZmlsbD0iI0FFNDIxRSIgbWFzaz0idXJsKCNwYXRoLTEtaW5zaWRlLTFfMTY1OV85MDU3KSIvPgo8bWFzayBpZD0icGF0aC0zLWluc2lkZS0yXzE2NTlfOTA1NyIgZmlsbD0id2hpdGUiPgo8cGF0aCBkPSJNMTAuMjUgMEgyNC4yNVYxNEgxMC4yNVYwWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik0xMC4yNSAxNEg3LjI1VjE3SDEwLjI1VjE0Wk0yNC4yNSAxMUgxMC4yNVYxN0gyNC4yNVYxMVpNMTMuMjUgMTRWMEg3LjI1VjE0SDEzLjI1WiIgZmlsbD0iI0NBQzlDOSIgbWFzaz0idXJsKCNwYXRoLTMtaW5zaWRlLTJfMTY1OV85MDU3KSIvPgo8L3N2Zz4=";
/*!
  * shared v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const fs = typeof window < "u";
let yn, Ls;
if (process.env.NODE_ENV !== "production") {
  const r = fs && window.performance;
  r && r.mark && r.measure && r.clearMarks && r.clearMeasures && (yn = (e) => r.mark(e), Ls = (e, t, n) => {
    r.measure(e, t, n), r.clearMarks(t), r.clearMarks(n);
  });
}
const E8 = /\{([0-9a-zA-Z]+)\}/g;
function dc(r, ...e) {
  return e.length === 1 && Rt(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), r.replace(E8, (t, n) => e.hasOwnProperty(n) ? e[n] : "");
}
const A8 = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol", Wi = (r) => A8 ? Symbol(r) : r, S8 = (r, e, t) => T8({ l: r, k: e, s: t }), T8 = (r) => JSON.stringify(r).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ur = (r) => typeof r == "number" && isFinite(r), M8 = (r) => df(r) === "[object Date]", Ia = (r) => df(r) === "[object RegExp]", fc = (r) => at(r) && Object.keys(r).length === 0;
function Bo(r, e) {
  typeof console < "u" && (console.warn("[intlify] " + r), e && console.warn(e.stack));
}
const Or = Object.assign;
let ph;
const fo = () => ph || (ph = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function mh(r) {
  return r.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const I8 = Object.prototype.hasOwnProperty;
function uf(r, e) {
  return I8.call(r, e);
}
const er = Array.isArray, xr = (r) => typeof r == "function", Ie = (r) => typeof r == "string", jt = (r) => typeof r == "boolean", Rt = (r) => (
  // eslint-disable-line
  r !== null && typeof r == "object"
), pm = Object.prototype.toString, df = (r) => pm.call(r), at = (r) => df(r) === "[object Object]", C8 = (r) => r == null ? "" : er(r) || at(r) && r.toString === pm ? JSON.stringify(r, null, 2) : String(r), gh = 2;
function P8(r, e = 0, t = r.length) {
  const n = r.split(/\r?\n/);
  let i = 0;
  const s = [];
  for (let a = 0; a < n.length; a++)
    if (i += n[a].length + 1, i >= e) {
      for (let o = a - gh; o <= a + gh || t > i; o++) {
        if (o < 0 || o >= n.length)
          continue;
        const l = o + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${n[o]}`);
        const c = n[o].length;
        if (o === a) {
          const u = e - (i - c) + 1, f = Math.max(1, t > i ? c - u : t - e);
          s.push("   |  " + " ".repeat(u) + "^".repeat(f));
        } else if (o > a) {
          if (t > i) {
            const u = Math.max(Math.min(t - i, c), 1);
            s.push("   |  " + "^".repeat(u));
          }
          i += c + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function k8() {
  const r = /* @__PURE__ */ new Map();
  return {
    events: r,
    on(t, n) {
      const i = r.get(t);
      i && i.push(n) || r.set(t, [n]);
    },
    off(t, n) {
      const i = r.get(t);
      i && i.splice(i.indexOf(n) >>> 0, 1);
    },
    emit(t, n) {
      (r.get(t) || []).slice().map((i) => i(n)), (r.get("*") || []).slice().map((i) => i(t, n));
    }
  };
}
/*!
  * message-compiler v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const je = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 15
}, O8 = {
  // tokenizer error messages
  [je.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [je.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [je.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [je.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [je.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [je.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [je.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [je.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [je.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [je.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [je.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [je.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [je.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [je.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'"
};
function hc(r, e, t = {}) {
  const { domain: n, messages: i, args: s } = t, a = process.env.NODE_ENV !== "production" ? dc((i || O8)[r] || "", ...s || []) : r, o = new SyntaxError(String(a));
  return o.code = r, e && (o.location = e), o.domain = n, o;
}
function N8(r) {
  throw r;
}
function R8(r, e, t) {
  return { line: r, column: e, offset: t };
}
function Hu(r, e, t) {
  const n = { start: r, end: e };
  return t != null && (n.source = t), n;
}
const Ii = " ", L8 = "\r", Gr = `
`, D8 = String.fromCharCode(8232), F8 = String.fromCharCode(8233);
function B8(r) {
  const e = r;
  let t = 0, n = 1, i = 1, s = 0;
  const a = (Z) => e[Z] === L8 && e[Z + 1] === Gr, o = (Z) => e[Z] === Gr, l = (Z) => e[Z] === F8, c = (Z) => e[Z] === D8, u = (Z) => a(Z) || o(Z) || l(Z) || c(Z), f = () => t, p = () => n, x = () => i, T = () => s, v = (Z) => a(Z) || l(Z) || c(Z) ? Gr : e[Z], w = () => v(t), E = () => v(t + s);
  function C() {
    return s = 0, u(t) && (n++, i = 0), a(t) && t++, t++, i++, e[t];
  }
  function P() {
    return a(t + s) && s++, s++, e[t + s];
  }
  function F() {
    t = 0, n = 1, i = 1, s = 0;
  }
  function k(Z = 0) {
    s = Z;
  }
  function K() {
    const Z = t + s;
    for (; Z !== t; )
      C();
    s = 0;
  }
  return {
    index: f,
    line: p,
    column: x,
    peekOffset: T,
    charAt: v,
    currentChar: w,
    currentPeek: E,
    next: C,
    peek: P,
    reset: F,
    resetPeek: k,
    skipToPeek: K
  };
}
const Qi = void 0, xh = "'", j8 = "tokenizer";
function U8(r, e = {}) {
  const t = e.location !== !1, n = B8(r), i = () => n.index(), s = () => R8(n.line(), n.column(), n.index()), a = s(), o = i(), l = {
    currentType: 14,
    offset: o,
    startLoc: a,
    endLoc: a,
    lastType: 14,
    lastOffset: o,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = e;
  function f(B, A, $, ...de) {
    const xe = c();
    if (A.column += $, A.offset += $, u) {
      const Ae = Hu(xe.startLoc, A), ut = hc(B, Ae, {
        domain: j8,
        args: de
      });
      u(ut);
    }
  }
  function p(B, A, $) {
    B.endLoc = s(), B.currentType = A;
    const de = { type: A };
    return t && (de.loc = Hu(B.startLoc, B.endLoc)), $ != null && (de.value = $), de;
  }
  const x = (B) => p(
    B,
    14
    /* EOF */
  );
  function T(B, A) {
    return B.currentChar() === A ? (B.next(), A) : (f(je.EXPECTED_TOKEN, s(), 0, A), "");
  }
  function v(B) {
    let A = "";
    for (; B.currentPeek() === Ii || B.currentPeek() === Gr; )
      A += B.currentPeek(), B.peek();
    return A;
  }
  function w(B) {
    const A = v(B);
    return B.skipToPeek(), A;
  }
  function E(B) {
    if (B === Qi)
      return !1;
    const A = B.charCodeAt(0);
    return A >= 97 && A <= 122 || // a-z
    A >= 65 && A <= 90 || // A-Z
    A === 95;
  }
  function C(B) {
    if (B === Qi)
      return !1;
    const A = B.charCodeAt(0);
    return A >= 48 && A <= 57;
  }
  function P(B, A) {
    const { currentType: $ } = A;
    if ($ !== 2)
      return !1;
    v(B);
    const de = E(B.currentPeek());
    return B.resetPeek(), de;
  }
  function F(B, A) {
    const { currentType: $ } = A;
    if ($ !== 2)
      return !1;
    v(B);
    const de = B.currentPeek() === "-" ? B.peek() : B.currentPeek(), xe = C(de);
    return B.resetPeek(), xe;
  }
  function k(B, A) {
    const { currentType: $ } = A;
    if ($ !== 2)
      return !1;
    v(B);
    const de = B.currentPeek() === xh;
    return B.resetPeek(), de;
  }
  function K(B, A) {
    const { currentType: $ } = A;
    if ($ !== 8)
      return !1;
    v(B);
    const de = B.currentPeek() === ".";
    return B.resetPeek(), de;
  }
  function Z(B, A) {
    const { currentType: $ } = A;
    if ($ !== 9)
      return !1;
    v(B);
    const de = E(B.currentPeek());
    return B.resetPeek(), de;
  }
  function ne(B, A) {
    const { currentType: $ } = A;
    if (!($ === 8 || $ === 12))
      return !1;
    v(B);
    const de = B.currentPeek() === ":";
    return B.resetPeek(), de;
  }
  function le(B, A) {
    const { currentType: $ } = A;
    if ($ !== 10)
      return !1;
    const de = () => {
      const Ae = B.currentPeek();
      return Ae === "{" ? E(B.peek()) : Ae === "@" || Ae === "%" || Ae === "|" || Ae === ":" || Ae === "." || Ae === Ii || !Ae ? !1 : Ae === Gr ? (B.peek(), de()) : E(Ae);
    }, xe = de();
    return B.resetPeek(), xe;
  }
  function ye(B) {
    v(B);
    const A = B.currentPeek() === "|";
    return B.resetPeek(), A;
  }
  function ge(B) {
    const A = v(B), $ = B.currentPeek() === "%" && B.peek() === "{";
    return B.resetPeek(), {
      isModulo: $,
      hasSpace: A.length > 0
    };
  }
  function _e(B, A = !0) {
    const $ = (xe = !1, Ae = "", ut = !1) => {
      const Le = B.currentPeek();
      return Le === "{" ? Ae === "%" ? !1 : xe : Le === "@" || !Le ? Ae === "%" ? !0 : xe : Le === "%" ? (B.peek(), $(xe, "%", !0)) : Le === "|" ? Ae === "%" || ut ? !0 : !(Ae === Ii || Ae === Gr) : Le === Ii ? (B.peek(), $(!0, Ii, ut)) : Le === Gr ? (B.peek(), $(!0, Gr, ut)) : !0;
    }, de = $();
    return A && B.resetPeek(), de;
  }
  function L(B, A) {
    const $ = B.currentChar();
    return $ === Qi ? Qi : A($) ? (B.next(), $) : null;
  }
  function d(B) {
    return L(B, ($) => {
      const de = $.charCodeAt(0);
      return de >= 97 && de <= 122 || // a-z
      de >= 65 && de <= 90 || // A-Z
      de >= 48 && de <= 57 || // 0-9
      de === 95 || // _
      de === 36;
    });
  }
  function b(B) {
    return L(B, ($) => {
      const de = $.charCodeAt(0);
      return de >= 48 && de <= 57;
    });
  }
  function S(B) {
    return L(B, ($) => {
      const de = $.charCodeAt(0);
      return de >= 48 && de <= 57 || // 0-9
      de >= 65 && de <= 70 || // A-F
      de >= 97 && de <= 102;
    });
  }
  function R(B) {
    let A = "", $ = "";
    for (; A = b(B); )
      $ += A;
    return $;
  }
  function D(B) {
    w(B);
    const A = B.currentChar();
    return A !== "%" && f(je.EXPECTED_TOKEN, s(), 0, A), B.next(), "%";
  }
  function z(B) {
    let A = "";
    for (; ; ) {
      const $ = B.currentChar();
      if ($ === "{" || $ === "}" || $ === "@" || $ === "|" || !$)
        break;
      if ($ === "%")
        if (_e(B))
          A += $, B.next();
        else
          break;
      else if ($ === Ii || $ === Gr)
        if (_e(B))
          A += $, B.next();
        else {
          if (ye(B))
            break;
          A += $, B.next();
        }
      else
        A += $, B.next();
    }
    return A;
  }
  function q(B) {
    w(B);
    let A = "", $ = "";
    for (; A = d(B); )
      $ += A;
    return B.currentChar() === Qi && f(je.UNTERMINATED_CLOSING_BRACE, s(), 0), $;
  }
  function y(B) {
    w(B);
    let A = "";
    return B.currentChar() === "-" ? (B.next(), A += `-${R(B)}`) : A += R(B), B.currentChar() === Qi && f(je.UNTERMINATED_CLOSING_BRACE, s(), 0), A;
  }
  function h(B) {
    w(B), T(B, "'");
    let A = "", $ = "";
    const de = (Ae) => Ae !== xh && Ae !== Gr;
    for (; A = L(B, de); )
      A === "\\" ? $ += I(B) : $ += A;
    const xe = B.currentChar();
    return xe === Gr || xe === Qi ? (f(je.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), xe === Gr && (B.next(), T(B, "'")), $) : (T(B, "'"), $);
  }
  function I(B) {
    const A = B.currentChar();
    switch (A) {
      case "\\":
      case "'":
        return B.next(), `\\${A}`;
      case "u":
        return V(B, A, 4);
      case "U":
        return V(B, A, 6);
      default:
        return f(je.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, A), "";
    }
  }
  function V(B, A, $) {
    T(B, A);
    let de = "";
    for (let xe = 0; xe < $; xe++) {
      const Ae = S(B);
      if (!Ae) {
        f(je.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${A}${de}${B.currentChar()}`);
        break;
      }
      de += Ae;
    }
    return `\\${A}${de}`;
  }
  function g(B) {
    w(B);
    let A = "", $ = "";
    const de = (xe) => xe !== "{" && xe !== "}" && xe !== Ii && xe !== Gr;
    for (; A = L(B, de); )
      $ += A;
    return $;
  }
  function G(B) {
    let A = "", $ = "";
    for (; A = d(B); )
      $ += A;
    return $;
  }
  function Q(B) {
    const A = ($ = !1, de) => {
      const xe = B.currentChar();
      return xe === "{" || xe === "%" || xe === "@" || xe === "|" || !xe || xe === Ii ? de : xe === Gr ? (de += xe, B.next(), A($, de)) : (de += xe, B.next(), A(!0, de));
    };
    return A(!1, "");
  }
  function J(B) {
    w(B);
    const A = T(
      B,
      "|"
      /* Pipe */
    );
    return w(B), A;
  }
  function X(B, A) {
    let $ = null;
    switch (B.currentChar()) {
      case "{":
        return A.braceNest >= 1 && f(je.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), B.next(), $ = p(
          A,
          2,
          "{"
          /* BraceLeft */
        ), w(B), A.braceNest++, $;
      case "}":
        return A.braceNest > 0 && A.currentType === 2 && f(je.EMPTY_PLACEHOLDER, s(), 0), B.next(), $ = p(
          A,
          3,
          "}"
          /* BraceRight */
        ), A.braceNest--, A.braceNest > 0 && w(B), A.inLinked && A.braceNest === 0 && (A.inLinked = !1), $;
      case "@":
        return A.braceNest > 0 && f(je.UNTERMINATED_CLOSING_BRACE, s(), 0), $ = pe(B, A) || x(A), A.braceNest = 0, $;
      default:
        let xe = !0, Ae = !0, ut = !0;
        if (ye(B))
          return A.braceNest > 0 && f(je.UNTERMINATED_CLOSING_BRACE, s(), 0), $ = p(A, 1, J(B)), A.braceNest = 0, A.inLinked = !1, $;
        if (A.braceNest > 0 && (A.currentType === 5 || A.currentType === 6 || A.currentType === 7))
          return f(je.UNTERMINATED_CLOSING_BRACE, s(), 0), A.braceNest = 0, ce(B, A);
        if (xe = P(B, A))
          return $ = p(A, 5, q(B)), w(B), $;
        if (Ae = F(B, A))
          return $ = p(A, 6, y(B)), w(B), $;
        if (ut = k(B, A))
          return $ = p(A, 7, h(B)), w(B), $;
        if (!xe && !Ae && !ut)
          return $ = p(A, 13, g(B)), f(je.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, $.value), w(B), $;
        break;
    }
    return $;
  }
  function pe(B, A) {
    const { currentType: $ } = A;
    let de = null;
    const xe = B.currentChar();
    switch (($ === 8 || $ === 9 || $ === 12 || $ === 10) && (xe === Gr || xe === Ii) && f(je.INVALID_LINKED_FORMAT, s(), 0), xe) {
      case "@":
        return B.next(), de = p(
          A,
          8,
          "@"
          /* LinkedAlias */
        ), A.inLinked = !0, de;
      case ".":
        return w(B), B.next(), p(
          A,
          9,
          "."
          /* LinkedDot */
        );
      case ":":
        return w(B), B.next(), p(
          A,
          10,
          ":"
          /* LinkedDelimiter */
        );
      default:
        return ye(B) ? (de = p(A, 1, J(B)), A.braceNest = 0, A.inLinked = !1, de) : K(B, A) || ne(B, A) ? (w(B), pe(B, A)) : Z(B, A) ? (w(B), p(A, 12, G(B))) : le(B, A) ? (w(B), xe === "{" ? X(B, A) || de : p(A, 11, Q(B))) : ($ === 8 && f(je.INVALID_LINKED_FORMAT, s(), 0), A.braceNest = 0, A.inLinked = !1, ce(B, A));
    }
  }
  function ce(B, A) {
    let $ = {
      type: 14
      /* EOF */
    };
    if (A.braceNest > 0)
      return X(B, A) || x(A);
    if (A.inLinked)
      return pe(B, A) || x(A);
    switch (B.currentChar()) {
      case "{":
        return X(B, A) || x(A);
      case "}":
        return f(je.UNBALANCED_CLOSING_BRACE, s(), 0), B.next(), p(
          A,
          3,
          "}"
          /* BraceRight */
        );
      case "@":
        return pe(B, A) || x(A);
      default:
        if (ye(B))
          return $ = p(A, 1, J(B)), A.braceNest = 0, A.inLinked = !1, $;
        const { isModulo: xe, hasSpace: Ae } = ge(B);
        if (xe)
          return Ae ? p(A, 0, z(B)) : p(A, 4, D(B));
        if (_e(B))
          return p(A, 0, z(B));
        break;
    }
    return $;
  }
  function ue() {
    const { currentType: B, offset: A, startLoc: $, endLoc: de } = l;
    return l.lastType = B, l.lastOffset = A, l.lastStartLoc = $, l.lastEndLoc = de, l.offset = i(), l.startLoc = s(), n.currentChar() === Qi ? p(
      l,
      14
      /* EOF */
    ) : ce(n, l);
  }
  return {
    nextToken: ue,
    currentOffset: i,
    currentPosition: s,
    context: c
  };
}
const z8 = "parser", W8 = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function H8(r, e, t) {
  switch (r) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const n = parseInt(e || t, 16);
      return n <= 55295 || n >= 57344 ? String.fromCodePoint(n) : "�";
    }
  }
}
function V8(r = {}) {
  const e = r.location !== !1, { onError: t } = r;
  function n(E, C, P, F, ...k) {
    const K = E.currentPosition();
    if (K.offset += F, K.column += F, t) {
      const Z = Hu(P, K), ne = hc(C, Z, {
        domain: z8,
        args: k
      });
      t(ne);
    }
  }
  function i(E, C, P) {
    const F = {
      type: E,
      start: C,
      end: C
    };
    return e && (F.loc = { start: P, end: P }), F;
  }
  function s(E, C, P, F) {
    E.end = C, F && (E.type = F), e && E.loc && (E.loc.end = P);
  }
  function a(E, C) {
    const P = E.context(), F = i(3, P.offset, P.startLoc);
    return F.value = C, s(F, E.currentOffset(), E.currentPosition()), F;
  }
  function o(E, C) {
    const P = E.context(), { lastOffset: F, lastStartLoc: k } = P, K = i(5, F, k);
    return K.index = parseInt(C, 10), E.nextToken(), s(K, E.currentOffset(), E.currentPosition()), K;
  }
  function l(E, C) {
    const P = E.context(), { lastOffset: F, lastStartLoc: k } = P, K = i(4, F, k);
    return K.key = C, E.nextToken(), s(K, E.currentOffset(), E.currentPosition()), K;
  }
  function c(E, C) {
    const P = E.context(), { lastOffset: F, lastStartLoc: k } = P, K = i(9, F, k);
    return K.value = C.replace(W8, H8), E.nextToken(), s(K, E.currentOffset(), E.currentPosition()), K;
  }
  function u(E) {
    const C = E.nextToken(), P = E.context(), { lastOffset: F, lastStartLoc: k } = P, K = i(8, F, k);
    return C.type !== 12 ? (n(E, je.UNEXPECTED_EMPTY_LINKED_MODIFIER, P.lastStartLoc, 0), K.value = "", s(K, F, k), {
      nextConsumeToken: C,
      node: K
    }) : (C.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, si(C)), K.value = C.value || "", s(K, E.currentOffset(), E.currentPosition()), {
      node: K
    });
  }
  function f(E, C) {
    const P = E.context(), F = i(7, P.offset, P.startLoc);
    return F.value = C, s(F, E.currentOffset(), E.currentPosition()), F;
  }
  function p(E) {
    const C = E.context(), P = i(6, C.offset, C.startLoc);
    let F = E.nextToken();
    if (F.type === 9) {
      const k = u(E);
      P.modifier = k.node, F = k.nextConsumeToken || E.nextToken();
    }
    switch (F.type !== 10 && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(F)), F = E.nextToken(), F.type === 2 && (F = E.nextToken()), F.type) {
      case 11:
        F.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(F)), P.key = f(E, F.value || "");
        break;
      case 5:
        F.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(F)), P.key = l(E, F.value || "");
        break;
      case 6:
        F.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(F)), P.key = o(E, F.value || "");
        break;
      case 7:
        F.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(F)), P.key = c(E, F.value || "");
        break;
      default:
        n(E, je.UNEXPECTED_EMPTY_LINKED_KEY, C.lastStartLoc, 0);
        const k = E.context(), K = i(7, k.offset, k.startLoc);
        return K.value = "", s(K, k.offset, k.startLoc), P.key = K, s(P, k.offset, k.startLoc), {
          nextConsumeToken: F,
          node: P
        };
    }
    return s(P, E.currentOffset(), E.currentPosition()), {
      node: P
    };
  }
  function x(E) {
    const C = E.context(), P = C.currentType === 1 ? E.currentOffset() : C.offset, F = C.currentType === 1 ? C.endLoc : C.startLoc, k = i(2, P, F);
    k.items = [];
    let K = null;
    do {
      const le = K || E.nextToken();
      switch (K = null, le.type) {
        case 0:
          le.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(le)), k.items.push(a(E, le.value || ""));
          break;
        case 6:
          le.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(le)), k.items.push(o(E, le.value || ""));
          break;
        case 5:
          le.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(le)), k.items.push(l(E, le.value || ""));
          break;
        case 7:
          le.value == null && n(E, je.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, si(le)), k.items.push(c(E, le.value || ""));
          break;
        case 8:
          const ye = p(E);
          k.items.push(ye.node), K = ye.nextConsumeToken || null;
          break;
      }
    } while (C.currentType !== 14 && C.currentType !== 1);
    const Z = C.currentType === 1 ? C.lastOffset : E.currentOffset(), ne = C.currentType === 1 ? C.lastEndLoc : E.currentPosition();
    return s(k, Z, ne), k;
  }
  function T(E, C, P, F) {
    const k = E.context();
    let K = F.items.length === 0;
    const Z = i(1, C, P);
    Z.cases = [], Z.cases.push(F);
    do {
      const ne = x(E);
      K || (K = ne.items.length === 0), Z.cases.push(ne);
    } while (k.currentType !== 14);
    return K && n(E, je.MUST_HAVE_MESSAGES_IN_PLURAL, P, 0), s(Z, E.currentOffset(), E.currentPosition()), Z;
  }
  function v(E) {
    const C = E.context(), { offset: P, startLoc: F } = C, k = x(E);
    return C.currentType === 14 ? k : T(E, P, F, k);
  }
  function w(E) {
    const C = U8(E, Or({}, r)), P = C.context(), F = i(0, P.offset, P.startLoc);
    return e && F.loc && (F.loc.source = E), F.body = v(C), P.currentType !== 14 && n(C, je.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, E[P.offset] || ""), s(F, C.currentOffset(), C.currentPosition()), F;
  }
  return { parse: w };
}
function si(r) {
  if (r.type === 14)
    return "EOF";
  const e = (r.value || "").replace(/\r?\n/gu, "\\n");
  return e.length > 10 ? e.slice(0, 9) + "…" : e;
}
function $8(r, e = {}) {
  const t = {
    ast: r,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => t, helper: (s) => (t.helpers.add(s), s) };
}
function bh(r, e) {
  for (let t = 0; t < r.length; t++)
    ff(r[t], e);
}
function ff(r, e) {
  switch (r.type) {
    case 1:
      bh(r.cases, e), e.helper(
        "plural"
        /* PLURAL */
      );
      break;
    case 2:
      bh(r.items, e);
      break;
    case 6:
      ff(r.key, e), e.helper(
        "linked"
        /* LINKED */
      ), e.helper(
        "type"
        /* TYPE */
      );
      break;
    case 5:
      e.helper(
        "interpolate"
        /* INTERPOLATE */
      ), e.helper(
        "list"
        /* LIST */
      );
      break;
    case 4:
      e.helper(
        "interpolate"
        /* INTERPOLATE */
      ), e.helper(
        "named"
        /* NAMED */
      );
      break;
  }
}
function G8(r, e = {}) {
  const t = $8(r);
  t.helper(
    "normalize"
    /* NORMALIZE */
  ), r.body && ff(r.body, t);
  const n = t.context();
  r.helpers = Array.from(n.helpers);
}
function K8(r, e) {
  const { sourceMap: t, filename: n, breakLineCode: i, needIndent: s } = e, a = {
    source: r.loc.source,
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: i,
    needIndent: s,
    indentLevel: 0
  }, o = () => a;
  function l(v, w) {
    a.code += v;
  }
  function c(v, w = !0) {
    const E = w ? i : "";
    l(s ? E + "  ".repeat(v) : E);
  }
  function u(v = !0) {
    const w = ++a.indentLevel;
    v && c(w);
  }
  function f(v = !0) {
    const w = --a.indentLevel;
    v && c(w);
  }
  function p() {
    c(a.indentLevel);
  }
  return {
    context: o,
    push: l,
    indent: u,
    deindent: f,
    newline: p,
    helper: (v) => `_${v}`,
    needIndent: () => a.needIndent
  };
}
function Y8(r, e) {
  const { helper: t } = r;
  r.push(`${t(
    "linked"
    /* LINKED */
  )}(`), Ca(r, e.key), e.modifier ? (r.push(", "), Ca(r, e.modifier), r.push(", _type")) : r.push(", undefined, _type"), r.push(")");
}
function q8(r, e) {
  const { helper: t, needIndent: n } = r;
  r.push(`${t(
    "normalize"
    /* NORMALIZE */
  )}([`), r.indent(n());
  const i = e.items.length;
  for (let s = 0; s < i && (Ca(r, e.items[s]), s !== i - 1); s++)
    r.push(", ");
  r.deindent(n()), r.push("])");
}
function Z8(r, e) {
  const { helper: t, needIndent: n } = r;
  if (e.cases.length > 1) {
    r.push(`${t(
      "plural"
      /* PLURAL */
    )}([`), r.indent(n());
    const i = e.cases.length;
    for (let s = 0; s < i && (Ca(r, e.cases[s]), s !== i - 1); s++)
      r.push(", ");
    r.deindent(n()), r.push("])");
  }
}
function J8(r, e) {
  e.body ? Ca(r, e.body) : r.push("null");
}
function Ca(r, e) {
  const { helper: t } = r;
  switch (e.type) {
    case 0:
      J8(r, e);
      break;
    case 1:
      Z8(r, e);
      break;
    case 2:
      q8(r, e);
      break;
    case 6:
      Y8(r, e);
      break;
    case 8:
      r.push(JSON.stringify(e.value), e);
      break;
    case 7:
      r.push(JSON.stringify(e.value), e);
      break;
    case 5:
      r.push(`${t(
        "interpolate"
        /* INTERPOLATE */
      )}(${t(
        "list"
        /* LIST */
      )}(${e.index}))`, e);
      break;
    case 4:
      r.push(`${t(
        "interpolate"
        /* INTERPOLATE */
      )}(${t(
        "named"
        /* NAMED */
      )}(${JSON.stringify(e.key)}))`, e);
      break;
    case 9:
      r.push(JSON.stringify(e.value), e);
      break;
    case 3:
      r.push(JSON.stringify(e.value), e);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw new Error(`unhandled codegen node type: ${e.type}`);
  }
}
const X8 = (r, e = {}) => {
  const t = Ie(e.mode) ? e.mode : "normal", n = Ie(e.filename) ? e.filename : "message.intl", i = !!e.sourceMap, s = e.breakLineCode != null ? e.breakLineCode : t === "arrow" ? ";" : `
`, a = e.needIndent ? e.needIndent : t !== "arrow", o = r.helpers || [], l = K8(r, {
    mode: t,
    filename: n,
    sourceMap: i,
    breakLineCode: s,
    needIndent: a
  });
  l.push(t === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(a), o.length > 0 && (l.push(`const { ${o.map((f) => `${f}: _${f}`).join(", ")} } = ctx`), l.newline()), l.push("return "), Ca(l, r), l.deindent(a), l.push("}");
  const { code: c, map: u } = l.context();
  return {
    ast: r,
    code: c,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Q8(r, e = {}) {
  const t = Or({}, e), i = V8(t).parse(r);
  return G8(i, t), X8(i, t);
}
/*!
  * devtools-if v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const mm = {
  I18nInit: "i18n:init",
  FunctionTranslate: "function:translate"
};
/*!
  * core-base v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const ms = [];
ms[
  0
  /* BEFORE_PATH */
] = {
  w: [
    0
    /* BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* APPEND */
  ],
  "[": [
    4
    /* IN_SUB_PATH */
  ],
  o: [
    7
    /* AFTER_PATH */
  ]
};
ms[
  1
  /* IN_PATH */
] = {
  w: [
    1
    /* IN_PATH */
  ],
  ".": [
    2
    /* BEFORE_IDENT */
  ],
  "[": [
    4
    /* IN_SUB_PATH */
  ],
  o: [
    7
    /* AFTER_PATH */
  ]
};
ms[
  2
  /* BEFORE_IDENT */
] = {
  w: [
    2
    /* BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* APPEND */
  ],
  0: [
    3,
    0
    /* APPEND */
  ]
};
ms[
  3
  /* IN_IDENT */
] = {
  i: [
    3,
    0
    /* APPEND */
  ],
  0: [
    3,
    0
    /* APPEND */
  ],
  w: [
    1,
    1
    /* PUSH */
  ],
  ".": [
    2,
    1
    /* PUSH */
  ],
  "[": [
    4,
    1
    /* PUSH */
  ],
  o: [
    7,
    1
    /* PUSH */
  ]
};
ms[
  4
  /* IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* APPEND */
  ],
  '"': [
    6,
    0
    /* APPEND */
  ],
  "[": [
    4,
    2
    /* INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* APPEND */
  ]
};
ms[
  5
  /* IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* APPEND */
  ]
};
ms[
  6
  /* IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* APPEND */
  ]
};
const e_ = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function t_(r) {
  return e_.test(r);
}
function r_(r) {
  const e = r.charCodeAt(0), t = r.charCodeAt(r.length - 1);
  return e === t && (e === 34 || e === 39) ? r.slice(1, -1) : r;
}
function n_(r) {
  if (r == null)
    return "o";
  switch (r.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return r;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function i_(r) {
  const e = r.trim();
  return r.charAt(0) === "0" && isNaN(parseInt(r)) ? !1 : t_(e) ? r_(e) : "*" + e;
}
function s_(r) {
  const e = [];
  let t = -1, n = 0, i = 0, s, a, o, l, c, u, f;
  const p = [];
  p[
    0
    /* APPEND */
  ] = () => {
    a === void 0 ? a = o : a += o;
  }, p[
    1
    /* PUSH */
  ] = () => {
    a !== void 0 && (e.push(a), a = void 0);
  }, p[
    2
    /* INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* APPEND */
    ](), i++;
  }, p[
    3
    /* PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, n = 4, p[
        0
        /* APPEND */
      ]();
    else {
      if (i = 0, a === void 0 || (a = i_(a), a === !1))
        return !1;
      p[
        1
        /* PUSH */
      ]();
    }
  };
  function x() {
    const T = r[t + 1];
    if (n === 5 && T === "'" || n === 6 && T === '"')
      return t++, o = "\\" + T, p[
        0
        /* APPEND */
      ](), !0;
  }
  for (; n !== null; )
    if (t++, s = r[t], !(s === "\\" && x())) {
      if (l = n_(s), f = ms[n], c = f[l] || f.l || 8, c === 8 || (n = c[0], c[1] !== void 0 && (u = p[c[1]], u && (o = s, u() === !1))))
        return;
      if (n === 7)
        return e;
    }
}
const vh = /* @__PURE__ */ new Map();
function a_(r, e) {
  return Rt(r) ? r[e] : null;
}
function o_(r, e) {
  if (!Rt(r))
    return null;
  let t = vh.get(e);
  if (t || (t = s_(e), t && vh.set(e, t)), !t)
    return null;
  const n = t.length;
  let i = r, s = 0;
  for (; s < n; ) {
    const a = i[t[s]];
    if (a === void 0)
      return null;
    i = a, s++;
  }
  return i;
}
const l_ = (r) => r, c_ = (r) => "", u_ = "text", d_ = (r) => r.length === 0 ? "" : r.join(""), f_ = C8;
function yh(r, e) {
  return r = Math.abs(r), e === 2 ? r ? r > 1 ? 1 : 0 : 1 : r ? Math.min(r, 2) : 0;
}
function h_(r) {
  const e = Ur(r.pluralIndex) ? r.pluralIndex : -1;
  return r.named && (Ur(r.named.count) || Ur(r.named.n)) ? Ur(r.named.count) ? r.named.count : Ur(r.named.n) ? r.named.n : e : e;
}
function p_(r, e) {
  e.count || (e.count = r), e.n || (e.n = r);
}
function m_(r = {}) {
  const e = r.locale, t = h_(r), n = Rt(r.pluralRules) && Ie(e) && xr(r.pluralRules[e]) ? r.pluralRules[e] : yh, i = Rt(r.pluralRules) && Ie(e) && xr(r.pluralRules[e]) ? yh : void 0, s = (E) => E[n(t, E.length, i)], a = r.list || [], o = (E) => a[E], l = r.named || {};
  Ur(r.pluralIndex) && p_(t, l);
  const c = (E) => l[E];
  function u(E) {
    const C = xr(r.messages) ? r.messages(E) : Rt(r.messages) ? r.messages[E] : !1;
    return C || (r.parent ? r.parent.message(E) : c_);
  }
  const f = (E) => r.modifiers ? r.modifiers[E] : l_, p = at(r.processor) && xr(r.processor.normalize) ? r.processor.normalize : d_, x = at(r.processor) && xr(r.processor.interpolate) ? r.processor.interpolate : f_, T = at(r.processor) && Ie(r.processor.type) ? r.processor.type : u_, w = {
    list: o,
    named: c,
    plural: s,
    linked: (E, ...C) => {
      const [P, F] = C;
      let k = "text", K = "";
      C.length === 1 ? Rt(P) ? (K = P.modifier || K, k = P.type || k) : Ie(P) && (K = P || K) : C.length === 2 && (Ie(P) && (K = P || K), Ie(F) && (k = F || k));
      let Z = u(E)(w);
      return k === "vnode" && er(Z) && K && (Z = Z[0]), K ? f(K)(Z, k) : Z;
    },
    message: u,
    type: T,
    interpolate: x,
    normalize: p
  };
  return w;
}
let To = null;
function g_(r) {
  To = r;
}
function x_(r, e, t) {
  To && To.emit(mm.I18nInit, {
    timestamp: Date.now(),
    i18n: r,
    version: e,
    meta: t
  });
}
const b_ = /* @__PURE__ */ v_(mm.FunctionTranslate);
function v_(r) {
  return (e) => To && To.emit(r, e);
}
const bn = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  __EXTEND_POINT__: 7
}, y_ = {
  [bn.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [bn.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [bn.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [bn.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [bn.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [bn.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale."
};
function Pa(r, ...e) {
  return dc(y_[r], ...e);
}
function w_(r, e, t) {
  return [.../* @__PURE__ */ new Set([
    t,
    ...er(e) ? e : Rt(e) ? Object.keys(e) : Ie(e) ? [e] : [t]
  ])];
}
function gm(r, e, t) {
  const n = Ie(t) ? t : mc, i = r;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let s = i.__localeChainCache.get(n);
  if (!s) {
    s = [];
    let a = [t];
    for (; er(a); )
      a = wh(s, a, e);
    const o = er(e) || !at(e) ? e : e.default ? e.default : null;
    a = Ie(o) ? [o] : o, er(a) && wh(s, a, !1), i.__localeChainCache.set(n, s);
  }
  return s;
}
function wh(r, e, t) {
  let n = !0;
  for (let i = 0; i < e.length && jt(n); i++) {
    const s = e[i];
    Ie(s) && (n = __(r, e[i], t));
  }
  return n;
}
function __(r, e, t) {
  let n;
  const i = e.split("-");
  do {
    const s = i.join("-");
    n = E_(r, s, t), i.splice(-1, 1);
  } while (i.length && n === !0);
  return n;
}
function E_(r, e, t) {
  let n = !1;
  if (!r.includes(e) && (n = !0, e)) {
    n = e[e.length - 1] !== "!";
    const i = e.replace(/!/g, "");
    r.push(i), (er(t) || at(t)) && t[i] && (n = t[i]);
  }
  return n;
}
const A_ = "9.2.2", pc = -1, mc = "en-US", Hl = "", _h = (r) => `${r.charAt(0).toLocaleUpperCase()}${r.substr(1)}`;
function S_() {
  return {
    upper: (r, e) => e === "text" && Ie(r) ? r.toUpperCase() : e === "vnode" && Rt(r) && "__v_isVNode" in r ? r.children.toUpperCase() : r,
    lower: (r, e) => e === "text" && Ie(r) ? r.toLowerCase() : e === "vnode" && Rt(r) && "__v_isVNode" in r ? r.children.toLowerCase() : r,
    capitalize: (r, e) => e === "text" && Ie(r) ? _h(r) : e === "vnode" && Rt(r) && "__v_isVNode" in r ? _h(r.children) : r
  };
}
let xm;
function T_(r) {
  xm = r;
}
let bm;
function M_(r) {
  bm = r;
}
let vm;
function I_(r) {
  vm = r;
}
let ym = null;
const Eh = (r) => {
  ym = r;
}, C_ = () => ym;
let wm = null;
const Ah = (r) => {
  wm = r;
}, P_ = () => wm;
let Sh = 0;
function k_(r = {}) {
  const e = Ie(r.version) ? r.version : A_, t = Ie(r.locale) ? r.locale : mc, n = er(r.fallbackLocale) || at(r.fallbackLocale) || Ie(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : t, i = at(r.messages) ? r.messages : { [t]: {} }, s = at(r.datetimeFormats) ? r.datetimeFormats : { [t]: {} }, a = at(r.numberFormats) ? r.numberFormats : { [t]: {} }, o = Or({}, r.modifiers || {}, S_()), l = r.pluralRules || {}, c = xr(r.missing) ? r.missing : null, u = jt(r.missingWarn) || Ia(r.missingWarn) ? r.missingWarn : !0, f = jt(r.fallbackWarn) || Ia(r.fallbackWarn) ? r.fallbackWarn : !0, p = !!r.fallbackFormat, x = !!r.unresolving, T = xr(r.postTranslation) ? r.postTranslation : null, v = at(r.processor) ? r.processor : null, w = jt(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, E = !!r.escapeParameter, C = xr(r.messageCompiler) ? r.messageCompiler : xm, P = xr(r.messageResolver) ? r.messageResolver : bm || a_, F = xr(r.localeFallbacker) ? r.localeFallbacker : vm || w_, k = Rt(r.fallbackContext) ? r.fallbackContext : void 0, K = xr(r.onWarn) ? r.onWarn : Bo, Z = r, ne = Rt(Z.__datetimeFormatters) ? Z.__datetimeFormatters : /* @__PURE__ */ new Map(), le = Rt(Z.__numberFormatters) ? Z.__numberFormatters : /* @__PURE__ */ new Map(), ye = Rt(Z.__meta) ? Z.__meta : {};
  Sh++;
  const ge = {
    version: e,
    cid: Sh,
    locale: t,
    fallbackLocale: n,
    messages: i,
    modifiers: o,
    pluralRules: l,
    missing: c,
    missingWarn: u,
    fallbackWarn: f,
    fallbackFormat: p,
    unresolving: x,
    postTranslation: T,
    processor: v,
    warnHtmlMessage: w,
    escapeParameter: E,
    messageCompiler: C,
    messageResolver: P,
    localeFallbacker: F,
    fallbackContext: k,
    onWarn: K,
    __meta: ye
  };
  return ge.datetimeFormats = s, ge.numberFormats = a, ge.__datetimeFormatters = ne, ge.__numberFormatters = le, process.env.NODE_ENV !== "production" && (ge.__v_emitter = Z.__v_emitter != null ? Z.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && x_(ge, e, ye), ge;
}
function gc(r, e) {
  return r instanceof RegExp ? r.test(e) : r;
}
function _m(r, e) {
  return r instanceof RegExp ? r.test(e) : r;
}
function hf(r, e, t, n, i) {
  const { missing: s, onWarn: a } = r;
  if (process.env.NODE_ENV !== "production") {
    const o = r.__v_emitter;
    o && o.emit("missing", {
      locale: t,
      key: e,
      type: i,
      groupId: `${i}:${e}`
    });
  }
  if (s !== null) {
    const o = s(r, t, e, i);
    return Ie(o) ? o : e;
  } else
    return process.env.NODE_ENV !== "production" && _m(n, e) && a(Pa(bn.NOT_FOUND_KEY, { key: e, locale: t })), e;
}
function Ya(r, e, t) {
  const n = r;
  n.__localeChainCache = /* @__PURE__ */ new Map(), r.localeFallbacker(r, t, e);
}
const O_ = /<\/?[\w\s="/.':;#-\/]+>/, N_ = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function R_(r, e) {
  (jt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0) && O_.test(r) && Bo(dc(N_, { source: r }));
}
const L_ = (r) => r;
let Th = /* @__PURE__ */ Object.create(null);
function D_(r, e = {}) {
  {
    process.env.NODE_ENV !== "production" && R_(r, e);
    const n = (e.onCacheKey || L_)(r), i = Th[n];
    if (i)
      return i;
    let s = !1;
    const a = e.onError || N8;
    e.onError = (c) => {
      s = !0, a(c);
    };
    const { code: o } = Q8(r, e), l = new Function(`return ${o}`)();
    return s ? l : Th[n] = l;
  }
}
let Em = je.__EXTEND_POINT__;
const cu = () => ++Em, Li = {
  INVALID_ARGUMENT: Em,
  INVALID_DATE_ARGUMENT: cu(),
  INVALID_ISO_DATE_ARGUMENT: cu(),
  __EXTEND_POINT__: cu()
  // 18
};
function pa(r) {
  return hc(r, null, process.env.NODE_ENV !== "production" ? { messages: F_ } : void 0);
}
const F_ = {
  [Li.INVALID_ARGUMENT]: "Invalid arguments",
  [Li.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Li.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string"
}, Mh = () => "", ci = (r) => xr(r);
function Ih(r, ...e) {
  const { fallbackFormat: t, postTranslation: n, unresolving: i, messageCompiler: s, fallbackLocale: a, messages: o } = r, [l, c] = Vu(...e), u = jt(c.missingWarn) ? c.missingWarn : r.missingWarn, f = jt(c.fallbackWarn) ? c.fallbackWarn : r.fallbackWarn, p = jt(c.escapeParameter) ? c.escapeParameter : r.escapeParameter, x = !!c.resolvedMessage, T = Ie(c.default) || jt(c.default) ? jt(c.default) ? s ? l : () => l : c.default : t ? s ? l : () => l : "", v = t || T !== "", w = Ie(c.locale) ? c.locale : r.locale;
  p && B_(c);
  let [E, C, P] = x ? [
    l,
    w,
    o[w] || {}
  ] : Am(r, l, w, a, f, u), F = E, k = l;
  if (!x && !(Ie(F) || ci(F)) && v && (F = T, k = F), !x && (!(Ie(F) || ci(F)) || !Ie(C)))
    return i ? pc : l;
  if (process.env.NODE_ENV !== "production" && Ie(F) && r.messageCompiler == null)
    return Bo(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let K = !1;
  const Z = () => {
    K = !0;
  }, ne = ci(F) ? F : Sm(r, l, C, F, k, Z);
  if (K)
    return F;
  const le = z_(r, C, P, c), ye = m_(le), ge = j_(r, ne, ye), _e = n ? n(ge, l) : ge;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const L = {
      timestamp: Date.now(),
      key: Ie(l) ? l : ci(F) ? F.key : "",
      locale: C || (ci(F) ? F.locale : ""),
      format: Ie(F) ? F : ci(F) ? F.source : "",
      message: _e
    };
    L.meta = Or({}, r.__meta, C_() || {}), b_(L);
  }
  return _e;
}
function B_(r) {
  er(r.list) ? r.list = r.list.map((e) => Ie(e) ? mh(e) : e) : Rt(r.named) && Object.keys(r.named).forEach((e) => {
    Ie(r.named[e]) && (r.named[e] = mh(r.named[e]));
  });
}
function Am(r, e, t, n, i, s) {
  const { messages: a, onWarn: o, messageResolver: l, localeFallbacker: c } = r, u = c(r, n, t);
  let f = {}, p, x = null, T = t, v = null;
  const w = "translate";
  for (let E = 0; E < u.length; E++) {
    if (p = v = u[E], process.env.NODE_ENV !== "production" && t !== p && gc(i, e) && o(Pa(bn.FALLBACK_TO_TRANSLATE, {
      key: e,
      target: p
    })), process.env.NODE_ENV !== "production" && t !== p) {
      const K = r.__v_emitter;
      K && K.emit("fallback", {
        type: w,
        key: e,
        from: T,
        to: v,
        groupId: `${w}:${e}`
      });
    }
    f = a[p] || {};
    let C = null, P, F;
    if (process.env.NODE_ENV !== "production" && fs && (C = window.performance.now(), P = "intlify-message-resolve-start", F = "intlify-message-resolve-end", yn && yn(P)), (x = l(f, e)) === null && (x = f[e]), process.env.NODE_ENV !== "production" && fs) {
      const K = window.performance.now(), Z = r.__v_emitter;
      Z && C && x && Z.emit("message-resolve", {
        type: "message-resolve",
        key: e,
        message: x,
        time: K - C,
        groupId: `${w}:${e}`
      }), P && F && yn && Ls && (yn(F), Ls("intlify message resolve", P, F));
    }
    if (Ie(x) || xr(x))
      break;
    const k = hf(
      r,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      e,
      p,
      s,
      w
    );
    k !== e && (x = k), T = v;
  }
  return [x, p, f];
}
function Sm(r, e, t, n, i, s) {
  const { messageCompiler: a, warnHtmlMessage: o } = r;
  if (ci(n)) {
    const p = n;
    return p.locale = p.locale || t, p.key = p.key || e, p;
  }
  if (a == null) {
    const p = () => n;
    return p.locale = t, p.key = e, p;
  }
  let l = null, c, u;
  process.env.NODE_ENV !== "production" && fs && (l = window.performance.now(), c = "intlify-message-compilation-start", u = "intlify-message-compilation-end", yn && yn(c));
  const f = a(n, U_(r, t, i, n, o, s));
  if (process.env.NODE_ENV !== "production" && fs) {
    const p = window.performance.now(), x = r.__v_emitter;
    x && l && x.emit("message-compilation", {
      type: "message-compilation",
      message: n,
      time: p - l,
      groupId: `translate:${e}`
    }), c && u && yn && Ls && (yn(u), Ls("intlify message compilation", c, u));
  }
  return f.locale = t, f.key = e, f.source = n, f;
}
function j_(r, e, t) {
  let n = null, i, s;
  process.env.NODE_ENV !== "production" && fs && (n = window.performance.now(), i = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", yn && yn(i));
  const a = e(t);
  if (process.env.NODE_ENV !== "production" && fs) {
    const o = window.performance.now(), l = r.__v_emitter;
    l && n && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: o - n,
      groupId: `translate:${e.key}`
    }), i && s && yn && Ls && (yn(s), Ls("intlify message evaluation", i, s));
  }
  return a;
}
function Vu(...r) {
  const [e, t, n] = r, i = {};
  if (!Ie(e) && !Ur(e) && !ci(e))
    throw pa(Li.INVALID_ARGUMENT);
  const s = Ur(e) ? String(e) : (ci(e), e);
  return Ur(t) ? i.plural = t : Ie(t) ? i.default = t : at(t) && !fc(t) ? i.named = t : er(t) && (i.list = t), Ur(n) ? i.plural = n : Ie(n) ? i.default = n : at(n) && Or(i, n), [s, i];
}
function U_(r, e, t, n, i, s) {
  return {
    warnHtmlMessage: i,
    onError: (a) => {
      if (s && s(a), process.env.NODE_ENV !== "production") {
        const o = `Message compilation error: ${a.message}`, l = a.location && P8(n, a.location.start.offset, a.location.end.offset), c = r.__v_emitter;
        c && c.emit("compile-error", {
          message: n,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${t}`
        }), console.error(l ? `${o}
${l}` : o);
      } else
        throw a;
    },
    onCacheKey: (a) => S8(e, t, a)
  };
}
function z_(r, e, t, n) {
  const { modifiers: i, pluralRules: s, messageResolver: a, fallbackLocale: o, fallbackWarn: l, missingWarn: c, fallbackContext: u } = r, p = {
    locale: e,
    modifiers: i,
    pluralRules: s,
    messages: (x) => {
      let T = a(t, x);
      if (T == null && u) {
        const [, , v] = Am(u, x, e, o, l, c);
        T = a(v, x);
      }
      if (Ie(T)) {
        let v = !1;
        const E = Sm(r, x, e, T, x, () => {
          v = !0;
        });
        return v ? Mh : E;
      } else
        return ci(T) ? T : Mh;
    }
  };
  return r.processor && (p.processor = r.processor), n.list && (p.list = n.list), n.named && (p.named = n.named), Ur(n.plural) && (p.pluralIndex = n.plural), p;
}
const Ch = typeof Intl < "u", Tm = {
  dateTimeFormat: Ch && typeof Intl.DateTimeFormat < "u",
  numberFormat: Ch && typeof Intl.NumberFormat < "u"
};
function Ph(r, ...e) {
  const { datetimeFormats: t, unresolving: n, fallbackLocale: i, onWarn: s, localeFallbacker: a } = r, { __datetimeFormatters: o } = r;
  if (process.env.NODE_ENV !== "production" && !Tm.dateTimeFormat)
    return s(Pa(bn.CANNOT_FORMAT_DATE)), Hl;
  const [l, c, u, f] = $u(...e), p = jt(u.missingWarn) ? u.missingWarn : r.missingWarn, x = jt(u.fallbackWarn) ? u.fallbackWarn : r.fallbackWarn, T = !!u.part, v = Ie(u.locale) ? u.locale : r.locale, w = a(
    r,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    v
  );
  if (!Ie(l) || l === "")
    return new Intl.DateTimeFormat(v, f).format(c);
  let E = {}, C, P = null, F = v, k = null;
  const K = "datetime format";
  for (let le = 0; le < w.length; le++) {
    if (C = k = w[le], process.env.NODE_ENV !== "production" && v !== C && gc(x, l) && s(Pa(bn.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: C
    })), process.env.NODE_ENV !== "production" && v !== C) {
      const ye = r.__v_emitter;
      ye && ye.emit("fallback", {
        type: K,
        key: l,
        from: F,
        to: k,
        groupId: `${K}:${l}`
      });
    }
    if (E = t[C] || {}, P = E[l], at(P))
      break;
    hf(r, l, C, p, K), F = k;
  }
  if (!at(P) || !Ie(C))
    return n ? pc : l;
  let Z = `${C}__${l}`;
  fc(f) || (Z = `${Z}__${JSON.stringify(f)}`);
  let ne = o.get(Z);
  return ne || (ne = new Intl.DateTimeFormat(C, Or({}, P, f)), o.set(Z, ne)), T ? ne.formatToParts(c) : ne.format(c);
}
const Mm = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function $u(...r) {
  const [e, t, n, i] = r, s = {};
  let a = {}, o;
  if (Ie(e)) {
    const l = e.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw pa(Li.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    o = new Date(c);
    try {
      o.toISOString();
    } catch {
      throw pa(Li.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (M8(e)) {
    if (isNaN(e.getTime()))
      throw pa(Li.INVALID_DATE_ARGUMENT);
    o = e;
  } else if (Ur(e))
    o = e;
  else
    throw pa(Li.INVALID_ARGUMENT);
  return Ie(t) ? s.key = t : at(t) && Object.keys(t).forEach((l) => {
    Mm.includes(l) ? a[l] = t[l] : s[l] = t[l];
  }), Ie(n) ? s.locale = n : at(n) && (a = n), at(i) && (a = i), [s.key || "", o, s, a];
}
function kh(r, e, t) {
  const n = r;
  for (const i in t) {
    const s = `${e}__${i}`;
    n.__datetimeFormatters.has(s) && n.__datetimeFormatters.delete(s);
  }
}
function Oh(r, ...e) {
  const { numberFormats: t, unresolving: n, fallbackLocale: i, onWarn: s, localeFallbacker: a } = r, { __numberFormatters: o } = r;
  if (process.env.NODE_ENV !== "production" && !Tm.numberFormat)
    return s(Pa(bn.CANNOT_FORMAT_NUMBER)), Hl;
  const [l, c, u, f] = Gu(...e), p = jt(u.missingWarn) ? u.missingWarn : r.missingWarn, x = jt(u.fallbackWarn) ? u.fallbackWarn : r.fallbackWarn, T = !!u.part, v = Ie(u.locale) ? u.locale : r.locale, w = a(
    r,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    v
  );
  if (!Ie(l) || l === "")
    return new Intl.NumberFormat(v, f).format(c);
  let E = {}, C, P = null, F = v, k = null;
  const K = "number format";
  for (let le = 0; le < w.length; le++) {
    if (C = k = w[le], process.env.NODE_ENV !== "production" && v !== C && gc(x, l) && s(Pa(bn.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: C
    })), process.env.NODE_ENV !== "production" && v !== C) {
      const ye = r.__v_emitter;
      ye && ye.emit("fallback", {
        type: K,
        key: l,
        from: F,
        to: k,
        groupId: `${K}:${l}`
      });
    }
    if (E = t[C] || {}, P = E[l], at(P))
      break;
    hf(r, l, C, p, K), F = k;
  }
  if (!at(P) || !Ie(C))
    return n ? pc : l;
  let Z = `${C}__${l}`;
  fc(f) || (Z = `${Z}__${JSON.stringify(f)}`);
  let ne = o.get(Z);
  return ne || (ne = new Intl.NumberFormat(C, Or({}, P, f)), o.set(Z, ne)), T ? ne.formatToParts(c) : ne.format(c);
}
const Im = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Gu(...r) {
  const [e, t, n, i] = r, s = {};
  let a = {};
  if (!Ur(e))
    throw pa(Li.INVALID_ARGUMENT);
  const o = e;
  return Ie(t) ? s.key = t : at(t) && Object.keys(t).forEach((l) => {
    Im.includes(l) ? a[l] = t[l] : s[l] = t[l];
  }), Ie(n) ? s.locale = n : at(n) && (a = n), at(i) && (a = i), [s.key || "", o, s, a];
}
function Nh(r, e, t) {
  const n = r;
  for (const i in t) {
    const s = `${e}__${i}`;
    n.__numberFormatters.has(s) && n.__numberFormatters.delete(s);
  }
}
typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fo().__INTLIFY_PROD_DEVTOOLS__ = !1);
/*!
  * vue-i18n v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
const W_ = "9.2.2";
function H_() {
  let r = !1;
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (r = !0, fo().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (r = !0, fo().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fo().__INTLIFY_PROD_DEVTOOLS__ = !1), process.env.NODE_ENV !== "production" && r && console.warn("You are running the esm-bundler build of vue-i18n. It is recommended to configure your bundler to explicitly replace feature flag globals with boolean literals to get proper tree-shaking in the final bundle.");
}
let Cm = bn.__EXTEND_POINT__;
const na = () => ++Cm, Ci = {
  FALLBACK_TO_ROOT: Cm,
  NOT_SUPPORTED_PRESERVE: na(),
  NOT_SUPPORTED_FORMATTER: na(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: na(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: na(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: na(),
  NOT_FOUND_PARENT_SCOPE: na()
  // 13
}, V_ = {
  [Ci.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ci.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Ci.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Ci.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Ci.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Ci.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Ci.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope."
};
function Pm(r, ...e) {
  return dc(V_[r], ...e);
}
let km = je.__EXTEND_POINT__;
const en = () => ++km, Ht = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: km,
  // legacy module errors
  INVALID_ARGUMENT: en(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: en(),
  NOT_INSLALLED: en(),
  NOT_AVAILABLE_IN_LEGACY_MODE: en(),
  // directive module errors
  REQUIRED_VALUE: en(),
  INVALID_VALUE: en(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: en(),
  NOT_INSLALLED_WITH_PROVIDE: en(),
  // unexpected error
  UNEXPECTED_ERROR: en(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: en(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: en(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: en(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: en(),
  // for enhancement
  __EXTEND_POINT__: en()
  // 29
};
function Fi(r, ...e) {
  return hc(r, null, process.env.NODE_ENV !== "production" ? { messages: $_, args: e } : void 0);
}
const $_ = {
  [Ht.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ht.INVALID_ARGUMENT]: "Invalid argument",
  [Ht.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ht.NOT_INSLALLED]: "Need to install with `app.use` function",
  [Ht.UNEXPECTED_ERROR]: "Unexpected error",
  [Ht.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [Ht.REQUIRED_VALUE]: "Required in value: {0}",
  [Ht.INVALID_VALUE]: "Invalid value",
  [Ht.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ht.NOT_INSLALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ht.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ht.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [Ht.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [Ht.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Ku = /* @__PURE__ */ Wi("__transrateVNode"), Yu = /* @__PURE__ */ Wi("__datetimeParts"), qu = /* @__PURE__ */ Wi("__numberParts"), Zu = /* @__PURE__ */ Wi("__enableEmitter"), Ju = /* @__PURE__ */ Wi("__disableEmitter"), G_ = Wi("__setPluralRules");
Wi("__intlifyMeta");
const Om = /* @__PURE__ */ Wi("__injectWithOption");
function Xu(r) {
  if (!Rt(r))
    return r;
  for (const e in r)
    if (uf(r, e))
      if (!e.includes("."))
        Rt(r[e]) && Xu(r[e]);
      else {
        const t = e.split("."), n = t.length - 1;
        let i = r;
        for (let s = 0; s < n; s++)
          t[s] in i || (i[t[s]] = {}), i = i[t[s]];
        i[t[n]] = r[e], delete r[e], Rt(i[t[n]]) && Xu(i[t[n]]);
      }
  return r;
}
function pf(r, e) {
  const { messages: t, __i18n: n, messageResolver: i, flatJson: s } = e, a = at(t) ? t : er(n) ? {} : { [r]: {} };
  if (er(n) && n.forEach((o) => {
    if ("locale" in o && "resource" in o) {
      const { locale: l, resource: c } = o;
      l ? (a[l] = a[l] || {}, ho(c, a[l])) : ho(c, a);
    } else
      Ie(o) && ho(JSON.parse(o), a);
  }), i == null && s)
    for (const o in a)
      uf(a, o) && Xu(a[o]);
  return a;
}
const ll = (r) => !Rt(r) || er(r);
function ho(r, e) {
  if (ll(r) || ll(e))
    throw Fi(Ht.INVALID_VALUE);
  for (const t in r)
    uf(r, t) && (ll(r[t]) || ll(e[t]) ? e[t] = r[t] : ho(r[t], e[t]));
}
function Nm(r) {
  return r.type;
}
function K_(r, e, t) {
  let n = Rt(e.messages) ? e.messages : {};
  "__i18nGlobal" in t && (n = pf(r.locale.value, {
    messages: n,
    __i18n: t.__i18nGlobal
  }));
  const i = Object.keys(n);
  i.length && i.forEach((s) => {
    r.mergeLocaleMessage(s, n[s]);
  });
  {
    if (Rt(e.datetimeFormats)) {
      const s = Object.keys(e.datetimeFormats);
      s.length && s.forEach((a) => {
        r.mergeDateTimeFormat(a, e.datetimeFormats[a]);
      });
    }
    if (Rt(e.numberFormats)) {
      const s = Object.keys(e.numberFormats);
      s.length && s.forEach((a) => {
        r.mergeNumberFormat(a, e.numberFormats[a]);
      });
    }
  }
}
function Rh(r) {
  return ae(Xx, null, r, 0);
}
const Lh = "__INTLIFY_META__";
let Dh = 0;
function Fh(r) {
  return (e, t, n, i) => r(t, n, Bd() || void 0, i);
}
const Y_ = () => {
  const r = Bd();
  let e = null;
  return r && (e = Nm(r)[Lh]) ? { [Lh]: e } : null;
};
function q_(r = {}, e) {
  const { __root: t } = r, n = t === void 0;
  let i = jt(r.inheritLocale) ? r.inheritLocale : !0;
  const s = Ee(
    // prettier-ignore
    t && i ? t.locale.value : Ie(r.locale) ? r.locale : mc
  ), a = Ee(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : Ie(r.fallbackLocale) || er(r.fallbackLocale) || at(r.fallbackLocale) || r.fallbackLocale === !1 ? r.fallbackLocale : s.value
  ), o = Ee(pf(s.value, r)), l = Ee(at(r.datetimeFormats) ? r.datetimeFormats : { [s.value]: {} }), c = Ee(at(r.numberFormats) ? r.numberFormats : { [s.value]: {} });
  let u = t ? t.missingWarn : jt(r.missingWarn) || Ia(r.missingWarn) ? r.missingWarn : !0, f = t ? t.fallbackWarn : jt(r.fallbackWarn) || Ia(r.fallbackWarn) ? r.fallbackWarn : !0, p = t ? t.fallbackRoot : jt(r.fallbackRoot) ? r.fallbackRoot : !0, x = !!r.fallbackFormat, T = xr(r.missing) ? r.missing : null, v = xr(r.missing) ? Fh(r.missing) : null, w = xr(r.postTranslation) ? r.postTranslation : null, E = t ? t.warnHtmlMessage : jt(r.warnHtmlMessage) ? r.warnHtmlMessage : !0, C = !!r.escapeParameter;
  const P = t ? t.modifiers : at(r.modifiers) ? r.modifiers : {};
  let F = r.pluralRules || t && t.pluralRules, k;
  k = (() => {
    n && Ah(null);
    const re = {
      version: W_,
      locale: s.value,
      fallbackLocale: a.value,
      messages: o.value,
      modifiers: P,
      pluralRules: F,
      missing: v === null ? void 0 : v,
      missingWarn: u,
      fallbackWarn: f,
      fallbackFormat: x,
      unresolving: !0,
      postTranslation: w === null ? void 0 : w,
      warnHtmlMessage: E,
      escapeParameter: C,
      messageResolver: r.messageResolver,
      __meta: { framework: "vue" }
    };
    re.datetimeFormats = l.value, re.numberFormats = c.value, re.__datetimeFormatters = at(k) ? k.__datetimeFormatters : void 0, re.__numberFormatters = at(k) ? k.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (re.__v_emitter = at(k) ? k.__v_emitter : void 0);
    const fe = k_(re);
    return n && Ah(fe), fe;
  })(), Ya(k, s.value, a.value);
  function Z() {
    return [
      s.value,
      a.value,
      o.value,
      l.value,
      c.value
    ];
  }
  const ne = Y({
    get: () => s.value,
    set: (re) => {
      s.value = re, k.locale = s.value;
    }
  }), le = Y({
    get: () => a.value,
    set: (re) => {
      a.value = re, k.fallbackLocale = a.value, Ya(k, s.value, re);
    }
  }), ye = Y(() => o.value), ge = /* @__PURE__ */ Y(() => l.value), _e = /* @__PURE__ */ Y(() => c.value);
  function L() {
    return xr(w) ? w : null;
  }
  function d(re) {
    w = re, k.postTranslation = re;
  }
  function b() {
    return T;
  }
  function S(re) {
    re !== null && (v = Fh(re)), T = re, k.missing = v;
  }
  function R(re, fe) {
    return re !== "translate" || !fe.resolvedMessage;
  }
  const D = (re, fe, Mt, Fe, dt, Sr) => {
    Z();
    let rt;
    if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__)
      try {
        Eh(Y_()), n || (k.fallbackContext = t ? P_() : void 0), rt = re(k);
      } finally {
        Eh(null), n || (k.fallbackContext = void 0);
      }
    else
      rt = re(k);
    if (Ur(rt) && rt === pc) {
      const [Ze, Tr] = fe();
      if (process.env.NODE_ENV !== "production" && t && Ie(Ze) && R(Mt, Tr) && (p && (gc(f, Ze) || _m(u, Ze)) && Bo(Pm(Ci.FALLBACK_TO_ROOT, {
        key: Ze,
        type: Mt
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ft } = k;
        ft && p && ft.emit("fallback", {
          type: Mt,
          key: Ze,
          to: "global",
          groupId: `${Mt}:${Ze}`
        });
      }
      return t && p ? Fe(t) : dt(Ze);
    } else {
      if (Sr(rt))
        return rt;
      throw Fi(Ht.UNEXPECTED_RETURN_TYPE);
    }
  };
  function z(...re) {
    return D((fe) => Reflect.apply(Ih, null, [fe, ...re]), () => Vu(...re), "translate", (fe) => Reflect.apply(fe.t, fe, [...re]), (fe) => fe, (fe) => Ie(fe));
  }
  function q(...re) {
    const [fe, Mt, Fe] = re;
    if (Fe && !Rt(Fe))
      throw Fi(Ht.INVALID_ARGUMENT);
    return z(fe, Mt, Or({ resolvedMessage: !0 }, Fe || {}));
  }
  function y(...re) {
    return D((fe) => Reflect.apply(Ph, null, [fe, ...re]), () => $u(...re), "datetime format", (fe) => Reflect.apply(fe.d, fe, [...re]), () => Hl, (fe) => Ie(fe));
  }
  function h(...re) {
    return D((fe) => Reflect.apply(Oh, null, [fe, ...re]), () => Gu(...re), "number format", (fe) => Reflect.apply(fe.n, fe, [...re]), () => Hl, (fe) => Ie(fe));
  }
  function I(re) {
    return re.map((fe) => Ie(fe) || Ur(fe) || jt(fe) ? Rh(String(fe)) : fe);
  }
  const g = {
    normalize: I,
    interpolate: (re) => re,
    type: "vnode"
  };
  function G(...re) {
    return D(
      (fe) => {
        let Mt;
        const Fe = fe;
        try {
          Fe.processor = g, Mt = Reflect.apply(Ih, null, [Fe, ...re]);
        } finally {
          Fe.processor = null;
        }
        return Mt;
      },
      () => Vu(...re),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fe) => fe[Ku](...re),
      (fe) => [Rh(fe)],
      (fe) => er(fe)
    );
  }
  function Q(...re) {
    return D(
      (fe) => Reflect.apply(Oh, null, [fe, ...re]),
      () => Gu(...re),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fe) => fe[qu](...re),
      () => [],
      (fe) => Ie(fe) || er(fe)
    );
  }
  function J(...re) {
    return D(
      (fe) => Reflect.apply(Ph, null, [fe, ...re]),
      () => $u(...re),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (fe) => fe[Yu](...re),
      () => [],
      (fe) => Ie(fe) || er(fe)
    );
  }
  function X(re) {
    F = re, k.pluralRules = F;
  }
  function pe(re, fe) {
    const Mt = Ie(fe) ? fe : s.value, Fe = B(Mt);
    return k.messageResolver(Fe, re) !== null;
  }
  function ce(re) {
    let fe = null;
    const Mt = gm(k, a.value, s.value);
    for (let Fe = 0; Fe < Mt.length; Fe++) {
      const dt = o.value[Mt[Fe]] || {}, Sr = k.messageResolver(dt, re);
      if (Sr != null) {
        fe = Sr;
        break;
      }
    }
    return fe;
  }
  function ue(re) {
    const fe = ce(re);
    return fe ?? (t ? t.tm(re) || {} : {});
  }
  function B(re) {
    return o.value[re] || {};
  }
  function A(re, fe) {
    o.value[re] = fe, k.messages = o.value;
  }
  function $(re, fe) {
    o.value[re] = o.value[re] || {}, ho(fe, o.value[re]), k.messages = o.value;
  }
  function de(re) {
    return l.value[re] || {};
  }
  function xe(re, fe) {
    l.value[re] = fe, k.datetimeFormats = l.value, kh(k, re, fe);
  }
  function Ae(re, fe) {
    l.value[re] = Or(l.value[re] || {}, fe), k.datetimeFormats = l.value, kh(k, re, fe);
  }
  function ut(re) {
    return c.value[re] || {};
  }
  function Le(re, fe) {
    c.value[re] = fe, k.numberFormats = c.value, Nh(k, re, fe);
  }
  function Re(re, fe) {
    c.value[re] = Or(c.value[re] || {}, fe), k.numberFormats = c.value, Nh(k, re, fe);
  }
  Dh++, t && fs && (qr(t.locale, (re) => {
    i && (s.value = re, k.locale = re, Ya(k, s.value, a.value));
  }), qr(t.fallbackLocale, (re) => {
    i && (a.value = re, k.fallbackLocale = re, Ya(k, s.value, a.value));
  }));
  const Me = {
    id: Dh,
    locale: ne,
    fallbackLocale: le,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(re) {
      i = re, re && t && (s.value = t.locale.value, a.value = t.fallbackLocale.value, Ya(k, s.value, a.value));
    },
    get availableLocales() {
      return Object.keys(o.value).sort();
    },
    messages: ye,
    get modifiers() {
      return P;
    },
    get pluralRules() {
      return F || {};
    },
    get isGlobal() {
      return n;
    },
    get missingWarn() {
      return u;
    },
    set missingWarn(re) {
      u = re, k.missingWarn = u;
    },
    get fallbackWarn() {
      return f;
    },
    set fallbackWarn(re) {
      f = re, k.fallbackWarn = f;
    },
    get fallbackRoot() {
      return p;
    },
    set fallbackRoot(re) {
      p = re;
    },
    get fallbackFormat() {
      return x;
    },
    set fallbackFormat(re) {
      x = re, k.fallbackFormat = x;
    },
    get warnHtmlMessage() {
      return E;
    },
    set warnHtmlMessage(re) {
      E = re, k.warnHtmlMessage = re;
    },
    get escapeParameter() {
      return C;
    },
    set escapeParameter(re) {
      C = re, k.escapeParameter = re;
    },
    t: z,
    getLocaleMessage: B,
    setLocaleMessage: A,
    mergeLocaleMessage: $,
    getPostTranslationHandler: L,
    setPostTranslationHandler: d,
    getMissingHandler: b,
    setMissingHandler: S,
    [G_]: X
  };
  return Me.datetimeFormats = ge, Me.numberFormats = _e, Me.rt = q, Me.te = pe, Me.tm = ue, Me.d = y, Me.n = h, Me.getDateTimeFormat = de, Me.setDateTimeFormat = xe, Me.mergeDateTimeFormat = Ae, Me.getNumberFormat = ut, Me.setNumberFormat = Le, Me.mergeNumberFormat = Re, Me[Om] = r.__injectWithOption, Me[Ku] = G, Me[Yu] = J, Me[qu] = Q, process.env.NODE_ENV !== "production" && (Me[Zu] = (re) => {
    k.__v_emitter = re;
  }, Me[Ju] = () => {
    k.__v_emitter = void 0;
  }), Me;
}
const mf = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (r) => r === "parent" || r === "global",
    default: "parent"
    /* ComponetI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Z_({ slots: r }, e) {
  return e.length === 1 && e[0] === "default" ? (r.default ? r.default() : []).reduce((n, i) => n = [
    ...n,
    ...er(i.children) ? i.children : [i]
  ], []) : e.reduce((t, n) => {
    const i = r[n];
    return i && (t[n] = i()), t;
  }, {});
}
function Rm(r) {
  return De;
}
Or({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (r) => Ur(r) || !isNaN(r)
  }
}, mf);
function J_(r) {
  return er(r) && !Ie(r[0]);
}
function Lm(r, e, t, n) {
  const { slots: i, attrs: s } = e;
  return () => {
    const a = { part: !0 };
    let o = {};
    r.locale && (a.locale = r.locale), Ie(r.format) ? a.key = r.format : Rt(r.format) && (Ie(r.format.key) && (a.key = r.format.key), o = Object.keys(r.format).reduce((p, x) => t.includes(x) ? Or({}, p, { [x]: r.format[x] }) : p, {}));
    const l = n(r.value, a, o);
    let c = [a.key];
    er(l) ? c = l.map((p, x) => {
      const T = i[p.type], v = T ? T({ [p.type]: p.value, index: x, parts: l }) : [p.value];
      return J_(v) && (v[0].key = `${p.type}-${x}`), v;
    }) : Ie(l) && (c = [l]);
    const u = Or({}, s), f = Ie(r.tag) || Rt(r.tag) ? r.tag : Rm();
    return Kt(f, u, c);
  };
}
Or({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, mf);
Or({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, mf);
function Bh(r, e) {
}
const X_ = /* @__PURE__ */ Wi("global-vue-i18n");
function xc(r = {}) {
  const e = Bd();
  if (e == null)
    throw Fi(Ht.MUST_BE_CALL_SETUP_TOP);
  if (!e.isCE && e.appContext.app != null && !e.appContext.app.__VUE_I18N_SYMBOL__)
    throw Fi(Ht.NOT_INSLALLED);
  const t = Q_(e), n = t7(t), i = Nm(e), s = e7(r, i);
  if (__VUE_I18N_LEGACY_API__ && t.mode === "legacy" && !r.__useComponent) {
    if (!t.allowComposition)
      throw Fi(Ht.NOT_AVAILABLE_IN_LEGACY_MODE);
    return i7(e, s, n, r);
  }
  if (s === "global")
    return K_(n, r, i), n;
  if (s === "parent") {
    let l = r7(t, e, r.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Bo(Pm(Ci.NOT_FOUND_PARENT_SCOPE)), l = n), l;
  }
  const a = t;
  let o = a.__getInstance(e);
  if (o == null) {
    const l = Or({}, r);
    "__i18n" in i && (l.__i18n = i.__i18n), n && (l.__root = n), o = q_(l), n7(a, e, o), a.__setInstance(e, o);
  }
  return o;
}
function Q_(r) {
  {
    const e = ke(r.isCE ? X_ : r.appContext.app.__VUE_I18N_SYMBOL__);
    if (!e)
      throw Fi(r.isCE ? Ht.NOT_INSLALLED_WITH_PROVIDE : Ht.UNEXPECTED_ERROR);
    return e;
  }
}
function e7(r, e) {
  return fc(r) ? "__i18n" in e ? "local" : "global" : r.useScope ? r.useScope : "local";
}
function t7(r) {
  return r.mode === "composition" ? r.global : r.global.__composer;
}
function r7(r, e, t = !1) {
  let n = null;
  const i = e.root;
  let s = e.parent;
  for (; s != null; ) {
    const a = r;
    if (r.mode === "composition")
      n = a.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const o = a.__getInstance(s);
      o != null && (n = o.__composer, t && n && !n[Om] && (n = null));
    }
    if (n != null || i === s)
      break;
    s = s.parent;
  }
  return n;
}
function n7(r, e, t) {
  let n = null;
  pi(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el) {
      e.vnode.el.__VUE_I18N__ = t, n = k8();
      const i = t;
      i[Zu] && i[Zu](n), n.on("*", Bh);
    }
  }, e), Do(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el && e.vnode.el.__VUE_I18N__) {
      n && n.off("*", Bh);
      const i = t;
      i[Ju] && i[Ju](), delete e.vnode.el.__VUE_I18N__;
    }
    r.__deleteInstance(e);
  }, e);
}
function i7(r, e, t, n = {}) {
  const i = e === "local", s = Zx(null);
  if (i && r.proxy && !(r.proxy.$options.i18n || r.proxy.$options.__i18n))
    throw Fi(Ht.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const a = jt(n.inheritLocale) ? n.inheritLocale : !0, o = Ee(
    // prettier-ignore
    i && a ? t.locale.value : Ie(n.locale) ? n.locale : mc
  ), l = Ee(
    // prettier-ignore
    i && a ? t.fallbackLocale.value : Ie(n.fallbackLocale) || er(n.fallbackLocale) || at(n.fallbackLocale) || n.fallbackLocale === !1 ? n.fallbackLocale : o.value
  ), c = Ee(pf(o.value, n)), u = Ee(at(n.datetimeFormats) ? n.datetimeFormats : { [o.value]: {} }), f = Ee(at(n.numberFormats) ? n.numberFormats : { [o.value]: {} }), p = i ? t.missingWarn : jt(n.missingWarn) || Ia(n.missingWarn) ? n.missingWarn : !0, x = i ? t.fallbackWarn : jt(n.fallbackWarn) || Ia(n.fallbackWarn) ? n.fallbackWarn : !0, T = i ? t.fallbackRoot : jt(n.fallbackRoot) ? n.fallbackRoot : !0, v = !!n.fallbackFormat, w = xr(n.missing) ? n.missing : null, E = xr(n.postTranslation) ? n.postTranslation : null, C = i ? t.warnHtmlMessage : jt(n.warnHtmlMessage) ? n.warnHtmlMessage : !0, P = !!n.escapeParameter, F = i ? t.modifiers : at(n.modifiers) ? n.modifiers : {}, k = n.pluralRules || i && t.pluralRules;
  function K() {
    return [
      o.value,
      l.value,
      c.value,
      u.value,
      f.value
    ];
  }
  const Z = Y({
    get: () => s.value ? s.value.locale.value : o.value,
    set: (A) => {
      s.value && (s.value.locale.value = A), o.value = A;
    }
  }), ne = Y({
    get: () => s.value ? s.value.fallbackLocale.value : l.value,
    set: (A) => {
      s.value && (s.value.fallbackLocale.value = A), l.value = A;
    }
  }), le = Y(() => s.value ? s.value.messages.value : c.value), ye = Y(() => u.value), ge = Y(() => f.value);
  function _e() {
    return s.value ? s.value.getPostTranslationHandler() : E;
  }
  function L(A) {
    s.value && s.value.setPostTranslationHandler(A);
  }
  function d() {
    return s.value ? s.value.getMissingHandler() : w;
  }
  function b(A) {
    s.value && s.value.setMissingHandler(A);
  }
  function S(A) {
    return K(), A();
  }
  function R(...A) {
    return s.value ? S(() => Reflect.apply(s.value.t, null, [...A])) : S(() => "");
  }
  function D(...A) {
    return s.value ? Reflect.apply(s.value.rt, null, [...A]) : "";
  }
  function z(...A) {
    return s.value ? S(() => Reflect.apply(s.value.d, null, [...A])) : S(() => "");
  }
  function q(...A) {
    return s.value ? S(() => Reflect.apply(s.value.n, null, [...A])) : S(() => "");
  }
  function y(A) {
    return s.value ? s.value.tm(A) : {};
  }
  function h(A, $) {
    return s.value ? s.value.te(A, $) : !1;
  }
  function I(A) {
    return s.value ? s.value.getLocaleMessage(A) : {};
  }
  function V(A, $) {
    s.value && (s.value.setLocaleMessage(A, $), c.value[A] = $);
  }
  function g(A, $) {
    s.value && s.value.mergeLocaleMessage(A, $);
  }
  function G(A) {
    return s.value ? s.value.getDateTimeFormat(A) : {};
  }
  function Q(A, $) {
    s.value && (s.value.setDateTimeFormat(A, $), u.value[A] = $);
  }
  function J(A, $) {
    s.value && s.value.mergeDateTimeFormat(A, $);
  }
  function X(A) {
    return s.value ? s.value.getNumberFormat(A) : {};
  }
  function pe(A, $) {
    s.value && (s.value.setNumberFormat(A, $), f.value[A] = $);
  }
  function ce(A, $) {
    s.value && s.value.mergeNumberFormat(A, $);
  }
  const ue = {
    get id() {
      return s.value ? s.value.id : -1;
    },
    locale: Z,
    fallbackLocale: ne,
    messages: le,
    datetimeFormats: ye,
    numberFormats: ge,
    get inheritLocale() {
      return s.value ? s.value.inheritLocale : a;
    },
    set inheritLocale(A) {
      s.value && (s.value.inheritLocale = A);
    },
    get availableLocales() {
      return s.value ? s.value.availableLocales : Object.keys(c.value);
    },
    get modifiers() {
      return s.value ? s.value.modifiers : F;
    },
    get pluralRules() {
      return s.value ? s.value.pluralRules : k;
    },
    get isGlobal() {
      return s.value ? s.value.isGlobal : !1;
    },
    get missingWarn() {
      return s.value ? s.value.missingWarn : p;
    },
    set missingWarn(A) {
      s.value && (s.value.missingWarn = A);
    },
    get fallbackWarn() {
      return s.value ? s.value.fallbackWarn : x;
    },
    set fallbackWarn(A) {
      s.value && (s.value.missingWarn = A);
    },
    get fallbackRoot() {
      return s.value ? s.value.fallbackRoot : T;
    },
    set fallbackRoot(A) {
      s.value && (s.value.fallbackRoot = A);
    },
    get fallbackFormat() {
      return s.value ? s.value.fallbackFormat : v;
    },
    set fallbackFormat(A) {
      s.value && (s.value.fallbackFormat = A);
    },
    get warnHtmlMessage() {
      return s.value ? s.value.warnHtmlMessage : C;
    },
    set warnHtmlMessage(A) {
      s.value && (s.value.warnHtmlMessage = A);
    },
    get escapeParameter() {
      return s.value ? s.value.escapeParameter : P;
    },
    set escapeParameter(A) {
      s.value && (s.value.escapeParameter = A);
    },
    t: R,
    getPostTranslationHandler: _e,
    setPostTranslationHandler: L,
    getMissingHandler: d,
    setMissingHandler: b,
    rt: D,
    d: z,
    n: q,
    tm: y,
    te: h,
    getLocaleMessage: I,
    setLocaleMessage: V,
    mergeLocaleMessage: g,
    getDateTimeFormat: G,
    setDateTimeFormat: Q,
    mergeDateTimeFormat: J,
    getNumberFormat: X,
    setNumberFormat: pe,
    mergeNumberFormat: ce
  };
  function B(A) {
    A.locale.value = o.value, A.fallbackLocale.value = l.value, Object.keys(c.value).forEach(($) => {
      A.mergeLocaleMessage($, c.value[$]);
    }), Object.keys(u.value).forEach(($) => {
      A.mergeDateTimeFormat($, u.value[$]);
    }), Object.keys(f.value).forEach(($) => {
      A.mergeNumberFormat($, f.value[$]);
    }), A.escapeParameter = P, A.fallbackFormat = v, A.fallbackRoot = T, A.fallbackWarn = x, A.missingWarn = p, A.warnHtmlMessage = C;
  }
  return Jx(() => {
    if (r.proxy == null || r.proxy.$i18n == null)
      throw Fi(Ht.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const A = s.value = r.proxy.$i18n.__composer;
    e === "global" ? (o.value = A.locale.value, l.value = A.fallbackLocale.value, c.value = A.messages.value, u.value = A.datetimeFormats.value, f.value = A.numberFormats.value) : i && B(A);
  }), ue;
}
T_(D_);
M_(o_);
I_(gm);
H_();
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const r = fo();
  r.__INTLIFY__ = !0, g_(r.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const s7 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJ1dWlkLWMyMjViZTY5LTQ2ZTUtNDA5Zi05YmU4LWY4NDc3YmY3MWIzYyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDEgNDEiPjxkZWZzPjxzdHlsZT4udXVpZC02ODVmYjhjYy1hZTIyLTQ4OTAtOGFlNi1iZjIzODMzNjhkYjJ7ZmlsbDojZmZmO3N0cm9rZTojMjcyNDIyO30udXVpZC02ODVmYjhjYy1hZTIyLTQ4OTAtOGFlNi1iZjIzODMzNjhkYjIsLnV1aWQtY2MxMDhlYjUtZmE0ZS00MjQ3LWFlMWEtNjU1MWFiY2ZiYWVme3N0cm9rZS1taXRlcmxpbWl0OjEwO30udXVpZC1jYzEwOGViNS1mYTRlLTQyNDctYWUxYS02NTUxYWJjZmJhZWZ7ZmlsbDpub25lO3N0cm9rZTojYWU0MjFlO308L3N0eWxlPjwvZGVmcz48ZyBpZD0idXVpZC0wYWU1OGJlNC04OTA3LTQ0YjQtYTQ2Ny0wNDcwZmQ4YjVlYzMiPjxyZWN0IGNsYXNzPSJ1dWlkLTY4NWZiOGNjLWFlMjItNDg5MC04YWU2LWJmMjM4MzM2OGRiMiIgeD0iLjUiIHk9Ii41IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiLz48bGluZSBjbGFzcz0idXVpZC1jYzEwOGViNS1mYTRlLTQyNDctYWUxYS02NTUxYWJjZmJhZWYiIHgxPSI0MC41IiB5MT0iLjUiIHgyPSIuNSIgeTI9IjQwLjUiLz48L2c+PC9zdmc+", a7 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJ1dWlkLTI2ZmI3MjRkLWY0NjUtNGM2YS1iNGFkLTc2MmRjYjcwMDdmZCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgNDAiPjxkZWZzPjxzdHlsZT4udXVpZC02Y2RjMGUyMS0wNWFmLTQ1YjMtYjQwNC03NzEwMmYzOGM3MDV7ZmlsbDojZjNmMGVlO30udXVpZC1lYTQyZThmZS03ODYwLTQ1MDItYWViOC0yOWI0NWZjM2M5NWJ7ZmlsbDojZmZmO30udXVpZC1jZTkxMzdmMy1iMDAyLTRjNmQtOGFmNy1iOGQzYzFhZWQ1Mjh7ZmlsbDpub25lO3N0cm9rZTojZDRkM2QzO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJ1dWlkLWJkNDBlYjUyLWU1NzUtNDdlYi1iYmE4LTMzMTYwYTFlNDIxYiI+PGc+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIi8+PHJlY3QgY2xhc3M9InV1aWQtZWE0MmU4ZmUtNzg2MC00NTAyLWFlYjgtMjliNDVmYzNjOTViIiB4PSI2LjcxIiB3aWR0aD0iMzMuMjkiIGhlaWdodD0iMzMuMjkiLz48cmVjdCBjbGFzcz0idXVpZC02Y2RjMGUyMS0wNWFmLTQ1YjMtYjQwNC03NzEwMmYzOGM3MDUiIHg9IjIwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiLz48cG9seWxpbmUgY2xhc3M9InV1aWQtY2U5MTM3ZjMtYjAwMi00YzZkLThhZjctYjhkM2MxYWVkNTI4IiBwb2ludHM9IjQwIDIwIDIwIDIwIDIwIDAiLz48L2c+PC9nPjwvc3ZnPg==", o7 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJ1dWlkLTEwN2IyMTVhLTllYWMtNDgzZS1iOGM5LWRhNWFiZjE2OTIzMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgNDAiPjxkZWZzPjxzdHlsZT4udXVpZC1iYTMyNGJjYy01ZmQzLTQ2YWUtYjczYy0wNjI0Zjk4NDg4NWF7ZmlsbDojZjNmMGVlO30udXVpZC0wZjlhNjA5ZS0wMGY2LTQ0YWMtOTNiNS05NGEzNjUwZDgyMTZ7ZmlsbDojZmZmO30udXVpZC1kYmM0NzRiNy1hMWFlLTQ5YTYtYmFhYS04ODQ5Njg5YWRmM2V7ZmlsbDpub25lO3N0cm9rZTojZDRkM2QzO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJ1dWlkLWQ1NWRiYmVhLTM3NmYtNGMyMi1iNGNmLWI1YWQ0YzE3OWRkMiI+PGc+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIi8+PHJlY3QgY2xhc3M9InV1aWQtMGY5YTYwOWUtMDBmNi00NGFjLTkzYjUtOTRhMzY1MGQ4MjE2IiB4PSI2LjcxIiB3aWR0aD0iMzMuMjkiIGhlaWdodD0iMzMuMjkiLz48cmVjdCBjbGFzcz0idXVpZC0wZjlhNjA5ZS0wMGY2LTQ0YWMtOTNiNS05NGEzNjUwZDgyMTYiIHg9IjIwIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiLz48cG9seWxpbmUgY2xhc3M9InV1aWQtZGJjNDc0YjctYTFhZS00OWE2LWJhYWEtODg0OTY4OWFkZjNlIiBwb2ludHM9IjQwIDIwIDIwIDIwIDIwIDAiLz48cmVjdCBjbGFzcz0idXVpZC1iYTMyNGJjYy01ZmQzLTQ2YWUtYjczYy0wNjI0Zjk4NDg4NWEiIHg9IjI1LjA5IiB3aWR0aD0iMTQuOTEiIGhlaWdodD0iMTQuOTEiLz48cG9seWxpbmUgY2xhc3M9InV1aWQtZGJjNDc0YjctYTFhZS00OWE2LWJhYWEtODg0OTY4OWFkZjNlIiBwb2ludHM9IjQwIDE0LjkxIDI1LjA5IDE0LjkxIDI1LjA5IDAiLz48L2c+PC9nPjwvc3ZnPg==", l7 = {
  class: "p-4 bg-vanilla-50 absolute w-full bottom-0 border-t-2",
  style: { "box-shadow": "rgba(0, 0, 0, 0.3) 0px 1px 15px -5px, rgba(0, 0, 0, 0.1) 0px 8px 5px -6px" }
}, c7 = { class: "mb-4" }, u7 = { class: "flex justify-center text-sm italic" }, d7 = { class: "flex items-center" }, f7 = { class: "w-1/2" }, h7 = {
  key: 0,
  class: "flex items-end justify-center gap-2"
}, p7 = {
  "data-total-price": "",
  class: "text-xl tracking-tight text-ginger-700 font-bold"
}, m7 = {
  key: 0,
  "data-total-original-price": "",
  class: "line-through text-gray-900 text-base"
}, g7 = {
  key: 1,
  class: "flex items-end justify-center gap-2"
}, x7 = /* @__PURE__ */ _("div", { class: "animate-pulse bg-gray-100 h-8 w-24" }, null, -1), b7 = [
  x7
], v7 = { class: "w-1/2" }, y7 = ["disabled"], w7 = { key: 0 }, es = /* @__PURE__ */ vr({
  __name: "PanelFooter",
  props: {
    hasDiscount: {
      type: Boolean,
      default: !1
    },
    discountFactor: {
      type: Number,
      default: 1
    },
    selectedFrame: {
      type: String,
      default: !1
    },
    isReadyMadeProduct: {
      type: Boolean,
      default: !1
    },
    finishedWidth: {
      type: Number,
      default: 0
    },
    finishedHeight: {
      type: Number,
      default: 0
    },
    customPriceLoading: {
      type: Number,
      default: !1
    },
    totalPrice: {
      type: Number,
      default: 0
    },
    quantity: {
      type: Number,
      default: 1
    },
    selectedSize: {
      type: String,
      required: !0
    },
    priceDeductedFromFrame: {
      type: Function,
      required: !0
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["applyChanges", "cancel"],
  setup(r, { emit: e }) {
    const t = () => {
      e("applyChanges");
    };
    return (n, i) => (N(), j("div", l7, [
      _("div", c7, [
        _("div", u7, he(n.$t("message.customizer.footer.finishedSize")) + " " + he(r.finishedWidth) + '" x ' + he(r.finishedHeight) + '" ', 1)
      ]),
      _("div", d7, [
        _("div", f7, [
          r.customPriceLoading ? (N(), j("div", g7, b7)) : (N(), j("div", h7, [
            _("p", p7, he(n.$filters.currency((r.totalPrice - r.priceDeductedFromFrame(r.selectedSize, r.selectedFrame)) * r.discountFactor * r.quantity)), 1),
            r.hasDiscount || r.priceDeductedFromFrame(r.selectedSize, r.selectedFrame) ? (N(), j("p", m7, he(n.$filters.currency(r.totalPrice * r.quantity)), 1)) : se("", !0)
          ]))
        ]),
        _("div", v7, [
          _("button", {
            type: "button",
            "data-apply": "",
            class: "btn btn--primary serif py-2 px-4 rounded-2xl text-white text-lg md:text-base focus:outline-none w-full",
            "data-test-id": "apply-button",
            disabled: r.customPriceLoading,
            onClick: t
          }, [
            r.customPriceLoading ? (N(), j("span", w7, [
              ae(m(Cn), { class: "w-6 h-6" })
            ])) : se("", !0),
            Ea(" " + he(n.$t("message.customizer.buttons.apply")), 1)
          ], 8, y7)
        ])
      ])
    ]));
  }
}), _7 = {
  props: {
    heading: {
      type: String,
      required: !0
    },
    subheading: {
      type: String,
      required: !0
    },
    supplementaryHeading: {
      type: String
    },
    tertiaryHeading: {
      type: String
    },
    errorMessage: {
      type: String,
      default: null
    },
    includeTopBorder: {
      type: Boolean,
      default: !1
    },
    includeBottomBorder: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "px-3 py-2 cursor-pointer flex justify-between items-center",
        this.includeTopBorder ? "border-t border-gray-200" : "",
        this.includeBottomBorder ? "border-b border-gray-200" : ""
      ];
    },
    classListHeading() {
      return [
        "text-sm font-bold"
      ];
    }
  },
  methods: {
    handleClick() {
      this.disabled || this.$emit("click");
    }
  }
}, E7 = ["aria-selected"], A7 = { class: "pr-2" }, S7 = {
  key: 0,
  class: "text-olive-500 flex gap-2 items-center flex-wrap",
  "data-selector-content": ""
}, T7 = ["innerHTML"], M7 = {
  key: 0,
  "data-supplementary-heading": ""
}, I7 = {
  key: 1,
  "data-tertiary-heading": "",
  class: "text-xs"
}, C7 = ["innerHTML"], P7 = /* @__PURE__ */ _("div", { "data-caret-icon": "" }, [
  /* @__PURE__ */ _("svg", {
    width: "10",
    height: "16",
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ _("path", {
      d: "M9.15148 7.48622C9.43338 7.76812 9.43338 8.23188 9.15148 8.51378L1.87668 15.7886C1.59479 16.0705 1.13102 16.0705 0.849119 15.7886C0.567221 15.5067 0.567221 15.0429 0.849119 14.761L7.61013 8L0.849119 1.23899C0.567221 0.95709 0.567221 0.493322 0.849119 0.211424C1.13102 -0.0704746 1.59479 -0.0704746 1.87668 0.211424L9.15148 7.48622Z",
      fill: "#454545"
    })
  ])
], -1);
function k7(r, e, t, n, i, s) {
  return N(), j("div", {
    class: Pe(s.classList),
    tabindex: "0",
    role: "option",
    "aria-selected": String(t.heading),
    onClick: e[0] || (e[0] = (...a) => s.handleClick && s.handleClick(...a)),
    onKeyup: e[1] || (e[1] = Us((...a) => s.handleClick && s.handleClick(...a), ["enter"]))
  }, [
    _("div", A7, [
      _("p", {
        "data-heading": "",
        class: Pe(s.classListHeading)
      }, he(t.heading), 3),
      t.errorMessage ? (N(), j("div", {
        key: 1,
        innerHTML: t.errorMessage,
        class: "text-ginger-700 text-sm",
        "data-error-message": ""
      }, null, 8, C7)) : (N(), j("div", S7, [
        _("span", {
          innerHTML: t.subheading,
          "data-subheading": ""
        }, null, 8, T7),
        t.supplementaryHeading ? (N(), j("span", M7, he(t.supplementaryHeading), 1)) : se("", !0),
        t.tertiaryHeading ? (N(), j("span", I7, he(t.tertiaryHeading), 1)) : se("", !0)
      ]))
    ]),
    P7
  ], 42, E7);
}
const ai = /* @__PURE__ */ Vt(_7, [["render", k7]]), O7 = /* @__PURE__ */ _("p", null, "Oops, something went wrong on our end.", -1), N7 = {
  key: 0,
  class: "bg-black fixed top-0 left-0 w-full h-full z-50 bg-opacity-60 inset-0 filter"
}, R7 = {
  key: 0,
  class: "relative"
}, L7 = { class: "space-y-4 px-3 md:px-0" }, D7 = { key: 0 }, F7 = /* @__PURE__ */ _("label", null, "Paper type", -1), B7 = { class: "border rounded-lg flex items-center relative" }, j7 = ["value"], U7 = ["value", "disabled"], z7 = { role: "tabpanel" }, W7 = { role: "tabpanel" }, H7 = { class: "p-6 flex justify-center bg-gray-50" }, V7 = {
  key: 0,
  style: { filter: "drop-shadow(3px 3px 8px rgba(0, 0, 0, 0.3))" },
  width: "130",
  height: "130",
  viewBox: "0 0 144 144",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $7 = ["d", "fill"], G7 = {
  key: 1,
  width: "130",
  style: { filter: "drop-shadow(3px 3px 8px rgba(0, 0, 0, 0.3))" },
  height: "130",
  viewBox: "0 0 144 144",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K7 = ["d", "fill"], Y7 = ["d", "fill"], q7 = ["d", "fill"], Z7 = { class: "flex" }, J7 = { class: "w-5 h-5 mr-2" }, X7 = { class: "w-5 h-5 mr-2" }, Q7 = { class: "p-3 w-full" }, e9 = { role: "tabpanel" }, t9 = { role: "tabpanel" }, r9 = {
  role: "tabpanel",
  "data-test-id": "canvas-depth"
}, n9 = { role: "tabpanel" }, i9 = { class: "flex items-center justify-between px-4 py-6 h-8" }, s9 = {
  key: 0,
  class: "font-bold"
}, a9 = {
  key: 1,
  class: "font-bold"
}, o9 = /* @__PURE__ */ _("svg", {
  class: "w-6 h-6 text-olive-500 fill-current",
  viewBox: "0 0 503 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ _("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M30 359V30H217V265H134C122.954 265 114 273.954 114 285V359H30ZM483 265L247 265V20C247 8.95431 238.046 0 227 0H20C8.9543 0 0 8.95431 0 20V369C0 380.046 8.9543 389 20 389H114V492C114 503.046 122.954 512 134 512H483C494.046 512 503 503.046 503 492V285C503 273.954 494.046 265 483 265ZM473 295L144 295L144 482H473V295ZM398.374 217.225C402.243 221.094 408.468 221.094 412.337 217.225L454.225 175.337C458.094 171.468 458.094 165.243 454.225 161.374C450.356 157.505 444.131 157.505 440.262 161.374L431.07 170.566L430.954 170.682L415.216 186.42L415.246 156.08C415.246 134.496 406.664 113.813 391.393 98.5416C364.456 71.6051 324.982 64.8274 291.763 78.2084C286.701 80.2446 284.258 86.0042 286.294 91.0657C288.33 96.1272 294.09 98.5707 299.151 96.5344C325.273 86.0042 356.282 91.3566 377.43 112.504C388.978 124.053 395.465 139.732 395.494 156.109V186.42L379.757 170.682L370.448 161.374C366.58 157.505 360.355 157.505 356.486 161.374C352.617 165.243 352.617 171.468 356.486 175.337L365.794 184.645L398.374 217.225Z"
  })
], -1), l9 = [
  o9
], c9 = { class: "px-4" }, u9 = {
  role: "tabpanel",
  "data-test-id": "size-option"
}, d9 = {
  key: 0,
  class: "bg-vanilla-50 p-4"
}, f9 = { class: "mb-3 grid grid-cols-9 items-center" }, h9 = { class: "flex flex-col col-span-2" }, p9 = {
  key: 0,
  class: "border border-black bg-white flex items-center justify-center h-12 mr-1"
}, m9 = {
  key: 1,
  class: "border flex items-center relative mr-1 h-full"
}, g9 = ["value", "disabled"], x9 = /* @__PURE__ */ _("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 pointer-events-none absolute right-0 mr-1",
  viewBox: "0 0 448 512"
}, [
  /* @__PURE__ */ _("path", { d: "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" })
], -1), b9 = {
  key: 0,
  class: "border border-black bg-white flex items-center justify-center h-12 w-full col-span-2 mt-6"
}, v9 = {
  key: 1,
  class: "col-span-2 flex items-center relative h-full"
}, y9 = /* @__PURE__ */ _("option", { value: 0 }, "--", -1), w9 = ["value", "disabled"], _9 = /* @__PURE__ */ _("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 pointer-events-none absolute right-0 mr-1 mt-6",
  viewBox: "0 0 448 512"
}, [
  /* @__PURE__ */ _("path", { d: "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" })
], -1), E9 = /* @__PURE__ */ _("div", { class: "col-span-1 text-center text-2xl mt-6" }, " × ", -1), A9 = { class: "flex flex-col col-span-2" }, S9 = {
  key: 0,
  class: "border border-black bg-white flex items-center justify-center h-12 mr-1"
}, T9 = {
  key: 1,
  class: "border flex items-center relative mr-1 h-full"
}, M9 = ["value", "disabled"], I9 = /* @__PURE__ */ _("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 pointer-events-none absolute right-0 mr-1",
  viewBox: "0 0 448 512"
}, [
  /* @__PURE__ */ _("path", { d: "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" })
], -1), C9 = {
  key: 0,
  class: "border border-black bg-white flex items-center justify-center h-12 w-full col-span-2 mt-6"
}, P9 = {
  key: 1,
  class: "col-span-2 flex items-center relative h-full"
}, k9 = /* @__PURE__ */ _("option", { value: 0 }, "--", -1), O9 = ["value", "disabled"], N9 = /* @__PURE__ */ _("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 pointer-events-none absolute right-0 mr-1 mt-6",
  viewBox: "0 0 448 512"
}, [
  /* @__PURE__ */ _("path", { d: "M241 337c-9.4 9.4-24.6 9.4-33.9 0L47 177c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 337z" })
], -1), R9 = { class: "grid grid-cols-3 gap-4 p-4" }, L9 = {
  key: 1,
  class: "w-full px-0 md:px-3"
}, D9 = { class: "flex items-center gap-2" }, F9 = { class: "text-3xl mb-1 font-serif" }, B9 = ["aria-label"], j9 = {
  "data-category-services": "",
  class: "flex gap-2",
  "data-test-id": "choose-service"
}, U9 = /* @__PURE__ */ _("svg", {
  class: "w-14 mb-2",
  width: "52",
  height: "40",
  viewBox: "0 0 52 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ _("path", {
    d: "M5.73286 2.38634L49.574 5.44071V34.897L5.73286 37.6285V2.38634ZM3.5061 0V40L51.8008 36.9902V3.36241L3.5061 0Z",
    fill: "#333333"
  }),
  /* @__PURE__ */ _("path", {
    d: "M0.199219 39.1575V1.67007L3.50595 0V40L0.199219 39.1575Z",
    fill: "black"
  })
], -1), z9 = /* @__PURE__ */ _("svg", {
  class: "w-14 mb-2",
  width: "52",
  height: "40",
  viewBox: "0 0 52 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ _("path", {
    d: "M4.6189 1.19502L50.6868 4.40155V35.9473L4.6189 38.8161V1.19502Z",
    fill: "#C0BFBF"
  }),
  /* @__PURE__ */ _("path", {
    d: "M5.73262 2.38634L49.5738 5.44071V34.897L5.73262 37.6285V2.38634ZM3.50586 0V40L51.8005 36.9902V3.36241L3.50586 0Z",
    fill: "#333333"
  }),
  /* @__PURE__ */ _("path", {
    d: "M0.199219 39.1575V1.67007L3.50595 0V40L0.199219 39.1575Z",
    fill: "black"
  }),
  /* @__PURE__ */ _("path", {
    d: "M49.5699 18.1517C46.1481 14.9675 41.5313 12.017 36.6844 13.3271C33.7228 14.0545 31.9154 16.6524 30.3196 19.0795C28.4306 21.8556 26.4747 24.6019 24.1552 27.0254C23.6393 27.5449 23.0752 28.0385 22.4369 28.3948C19.7202 29.9758 16.8626 28.0571 14.6247 26.4761C11.986 24.6242 8.99096 23.0951 5.72876 22.9578V37.6396L49.5736 34.9489V18.1554L49.5699 18.1517Z",
    fill: "white"
  }),
  /* @__PURE__ */ _("path", {
    d: "M18.0833 19.9999C20.1543 19.9999 21.8333 18.321 21.8333 16.2499C21.8333 14.1789 20.1543 12.4999 18.0833 12.4999C16.0122 12.4999 14.3333 14.1789 14.3333 16.2499C14.3333 18.321 16.0122 19.9999 18.0833 19.9999Z",
    fill: "white"
  })
], -1), W9 = {
  key: 1,
  "data-substrate-only-title": "",
  class: "text-3xl font-serif"
}, H9 = {
  key: 2,
  class: "flex flex-col xl:flex-row gap-1 xl:gap-2 xl:items-center"
}, V9 = { class: "text-ginger-700 font-bold" }, $9 = ["href"], G9 = {
  key: 3,
  "data-image-uploader": "",
  class: "flex justify-center"
}, K9 = { class: "flex items-center gap-2" }, Y9 = { class: "text-3xl mb-1 font-serif mt-6" }, q9 = { key: 0 }, Z9 = { key: 1 }, J9 = ["aria-label"], X9 = {
  key: 0,
  "data-print-options-selector": "",
  class: "flex gap-2 mb-4"
}, Q9 = { class: "flex flex-col gap-y-3" }, eE = {
  key: 0,
  "data-all-frames": ""
}, tE = /* @__PURE__ */ _("div", { class: "font-bold mb-1" }, "Frames", -1), rE = ["value"], nE = /* @__PURE__ */ _("option", { value: "" }, "-- Select a frame --", -1), iE = ["value"], sE = /* @__PURE__ */ _("div", { class: "font-bold mb-1" }, "Quantity", -1), aE = ["value"], oE = ["value"], lE = {
  key: 0,
  "data-image-size": ""
}, cE = { key: 0 }, uE = {
  key: 1,
  "data-substrate-type": ""
}, dE = {
  key: 2,
  "data-canvas-edge": ""
}, fE = {
  key: 3,
  "data-canvas-style": ""
}, hE = {
  key: 4,
  "data-paper-additional-white-borders": ""
}, pE = {
  key: 1,
  "data-frame-size": ""
}, mE = {
  key: 2,
  "data-mats": "",
  class: "flex items-center mb-3 pt-5 justify-between"
}, gE = { class: "flex items-center gap-2" }, xE = { class: "text-3xl font-serif" }, bE = ["aria-label"], vE = { class: "flex gap-2" }, yE = { key: 3 }, wE = { key: 0 }, _E = { key: 1 }, EE = {
  key: 0,
  "data-mats-error-message": ""
}, AE = {
  key: 0,
  "data-mats-unavailable-message": ""
}, SE = {
  key: 1,
  "data-mats-warning-message": ""
}, TE = {
  key: 5,
  "data-finish-kits": "",
  class: "pt-2"
}, ME = { class: "flex items-center gap-2" }, IE = { class: "text-3xl mb-1 font-serif" }, CE = ["aria-label"], PE = { key: 0 }, kE = {
  key: 0,
  class: "p-5 xl:p-0"
}, OE = {
  key: 0,
  class: "xl:mt-8 mb-3"
}, NE = {
  class: "flex justify-center text-sm italic",
  "data-test-id": "finished-dimension"
}, RE = {
  key: 0,
  "data-unassembled-label": "",
  class: "flex justify-center mt-1"
}, LE = { class: "flex gap-1" }, DE = { class: "text-ginger-700" }, FE = { class: "flex items-center" }, BE = { class: "w-1/2" }, jE = {
  key: 0,
  class: "flex items-end justify-center gap-2"
}, UE = {
  "data-total-price": "",
  class: "text-xl tracking-tight text-ginger-700 font-bold"
}, zE = {
  key: 0,
  "data-total-original-price": "",
  class: "line-through text-gray-900 text-base"
}, WE = {
  key: 1,
  class: "flex items-end justify-center gap-2"
}, HE = /* @__PURE__ */ _("div", { class: "animate-pulse bg-gray-100 h-8 w-24" }, null, -1), VE = [
  HE
], $E = { class: "w-1/2" }, GE = { class: "relative" }, KE = {
  key: 0,
  class: "absolute -translate-y-full w-full"
}, YE = { class: "p-2 bg-black text-white text-sm rounded text-center" }, qE = /* @__PURE__ */ _("div", { class: "relative flex justify-center" }, [
  /* @__PURE__ */ _("div", { class: "w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-black" })
], -1), ZE = { key: 0 }, JE = { key: 1 }, XE = ["disabled"], QE = { key: 0 }, eA = { key: 1 }, tA = {
  key: 0,
  "data-footer-upload-button": ""
}, rA = { key: 1 }, nA = { key: 0 }, iA = { key: 1 }, sA = { key: 1 }, aA = { key: 2 }, oA = {
  key: 0,
  class: "py-3 text-center text-olive-500 flex justify-center"
}, lA = /* @__PURE__ */ _("div", { tabindex: "-1" }, [
  /* @__PURE__ */ _("svg", {
    tabindex: "-1",
    class: "w-4 h-4 fill-current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /* @__PURE__ */ _("path", { d: "M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24V350.1L350.1 128 160 128V80l238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H432v56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384H352v48H136c-30.9 0-56-25.1-56-56V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80H80V24z" })
  ])
], -1), cA = { tabindex: "0" }, uA = /* @__PURE__ */ _("div", {
  class: "px-3",
  tabindex: "-1"
}, "|", -1), dA = /* @__PURE__ */ _("div", { tabindex: "-1" }, [
  /* @__PURE__ */ _("svg", {
    tabindex: "-1",
    class: "w-4 h-4 fill-current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /* @__PURE__ */ _("path", { d: "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" })
  ])
], -1), fA = { tabindex: "0" }, hA = /* @__PURE__ */ _("div", {
  class: "px-3",
  tabindex: "-1"
}, "|", -1), pA = /* @__PURE__ */ _("div", { tabindex: "-1" }, [
  /* @__PURE__ */ _("svg", {
    tabindex: "-1",
    class: "w-4 h-4 fill-current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, [
    /* @__PURE__ */ _("path", { d: "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z" })
  ])
], -1), mA = { tabindex: "0" }, gA = { tabindex: "0" }, Qk = /* @__PURE__ */ vr({
  __name: "Customizer",
  props: {
    media: Object,
    productSlug: {
      type: String,
      required: !0
    },
    isFloatFrame: {
      type: Boolean,
      required: !0
    },
    frame: {
      type: String,
      default: null
    },
    lineitemId: {
      type: String,
      default: null
    },
    couponAmount: {
      type: Number,
      default: null
    },
    allFrames: {
      type: Object,
      default: null
    },
    orderId: {
      type: Number,
      default: null
    },
    isEcommerce: {
      type: Boolean,
      default: !1
    },
    featureFlags: {
      type: Object,
      default: null
    },
    locale: {
      type: String,
      default: null
    },
    useThumborInSprout: {
      type: Boolean,
      default: !0
    },
    userLoggedIn: {
      type: Boolean,
      default: !1
    }
  },
  setup(r) {
    const e = r, { t } = xc(), n = Ee(!1);
    Ee(!1);
    const i = Y(() => e.couponAmount ? (100 - e.couponAmount) / 100 : 1), s = Y(() => !!e.couponAmount);
    pi(async () => {
      await a();
    }), Do(() => {
      window.removeEventListener("resize", Oc);
    });
    const a = async () => {
      if (P(e.featureFlags), e.isEcommerce && w(e.isEcommerce), e.orderId && p(e.orderId), e.lineitemId ? await u(parseInt(e.lineitemId)) : await l(e.productSlug, e.frame), e.allFrames && (x(e.allFrames), e.isEcommerce && e.frame && !e.lineitemId && Z(e.frame)), e.media && T(e.media), n.value = !0, Oc(), window.addEventListener("resize", Oc), Ue.value) {
        const U = Ue.value.pane_1.transform;
        U && (e0.value = U.scale);
      }
      document.querySelectorAll(".skeleton-loader").forEach(
        (U) => {
          U.classList.add("hidden");
        }
      ), setTimeout(async () => {
        await Es();
      }, 200);
    }, o = By(), l = (U, te) => o.dispatch("customizer/getProduct", { code: U, frame: te }), c = (U) => o.dispatch("customizer/getCustomSize", U), u = (U) => o.dispatch("customizer/getLineitem", U), f = (U, te) => o.dispatch("customizer/getCollectionFrames", { code: U, collection: te }), p = (U) => o.dispatch("customizer/setOrderId", U), x = (U) => o.dispatch("customizer/setFrames", U), T = (U) => o.dispatch("customizer/setProductMedia", U), v = () => o.dispatch("customizer/resetMessages"), w = (U) => o.dispatch("customizer/setIsEcommerce", U), E = () => o.dispatch("customizer/revertToSnapshot"), C = () => o.dispatch("customizer/setSnapshot"), P = (U) => o.dispatch("customizer/setFeatureFlags", U), F = (U) => o.dispatch("customizer/setDirtyState", U), k = (U) => o.dispatch("customizer/setRenderToken", U), K = (U) => o.dispatch("product/setSize", U), Z = (U) => o.dispatch("product/setFrame", U), ne = (U) => o.dispatch("product/setSubstrateType", U.target.value), le = (U) => o.dispatch("product/setSubstrateType", U), ye = (U) => o.dispatch("product/setPaperAdditionalWhiteBorder", U), ge = (U) => o.dispatch("product/setBottomMat", U), _e = (U) => o.dispatch("product/setTopMat", U), L = (U) => {
      o.dispatch("product/setBottomMatWidth", U), o.dispatch("product/updateFilteredSuggestedSizes");
    }, d = (U) => {
      o.dispatch("product/setTopMatWidth", U), o.dispatch("product/updateFilteredSuggestedSizes");
    }, b = (U) => o.dispatch("product/setFinishKit", U), S = (U) => o.dispatch("product/setMatType", U), R = (U) => o.dispatch("product/setCanvasDepth", U), D = (U) => o.dispatch("product/setEdge", U), z = () => o.dispatch("product/setSnapshot"), q = () => o.dispatch("product/revertToSnapshot"), y = (U) => o.dispatch("product/setImage", U), h = (U) => o.dispatch("product/setTransforms", U), I = () => o.dispatch("product/setImage", null), V = (U) => o.dispatch("product/togglePrintOption", U), g = (U) => o.dispatch("product/toggleProductData", U), G = (U) => o.dispatch("product/setQuantity", parseInt(U.target.value)), Q = () => o.dispatch("product/toggleOrientation"), J = () => o.dispatch("product/setImageRotate"), X = Y(() => o.getters["customizer/sizes"]), pe = Y(() => o.getters["customizer/filteredSuggestedSizes"]), ce = Y(() => o.getters["customizer/mats"]), ue = Y(() => o.getters["customizer/allMats"]), B = Y(() => o.getters["customizer/frames"]), A = Y(() => o.getters["customizer/finishKits"]);
    Y(() => o.getters["customizer/matBorders"]), Y(() => o.getters["customizer/liners"]);
    const $ = Y(() => o.getters["customizer/substrateTypes"]), de = Y(() => o.getters["customizer/paperAdditionalWhiteBorders"]), xe = Y(() => o.getters["customizer/supportedProducts"]), Ae = Y(() => o.getters["customizer/canvasDepths"]), ut = Y(() => o.getters["customizer/canvasEdges"]), Le = Y(() => o.getters["customizer/collections"]);
    Y(() => o.getters["customizer/totalMatPrice"]);
    const Re = Y(() => o.getters["customizer/totalPrice"]), Me = Y(() => us(o.getters["customizer/customPriceLoading"]));
    Y(() => us(o.getters["customizer/suggestedPriceLoading"])), Y(() => us(o.getters["customizer/frameLoading"]));
    const re = Y(() => o.getters["customizer/allowedCustomWholeHeights"]), fe = Y(() => o.getters["customizer/allowedCustomWholeWidths"]);
    Y(() => o.getters["customizer/assemblyFees"]), Y(() => o.getters["customizer/floatFrameAssemblyFee"]);
    const Mt = Y(() => o.getters["customizer/addingToCart"]), Fe = Y(() => o.getters["customizer/invalidAttributeError"]), dt = Y(() => o.getters["customizer/productMedia"]), Sr = Y(() => o.getters["customizer/error"]), rt = Y(() => o.getters["customizer/enableCustomFractionalWidths"]), Ze = Y(() => o.getters["customizer/enableCustomFractionalHeights"]);
    Y(() => o.getters["customizer/supportsAllProducts"]);
    const Tr = Y(() => o.getters["customizer/bottomMatError"]), ft = Y(() => o.getters["customizer/topMatError"]), _t = Y(() => o.getters["customizer/isSingleMatCompatible"]), En = Y(() => o.getters["customizer/isDoubleMatCompatible"]), vt = Y(() => o.getters["customizer/sizeImageError"]), It = Y(() => o.getters["customizer/renderToken"]), Jr = Y(() => o.getters["customizer/imageTooSmallForSelectedSize"]), Be = Y(() => o.getters["product/productSlug"]), We = Y(() => o.getters["product/size"]), Lr = Y(() => o.getters["product/width"]), lt = Y(() => o.getters["product/height"]), yt = Y(() => o.getters["product/wholeWidth"]), Xr = Y(() => o.getters["product/fractionalWidth"]), Et = Y(() => o.getters["product/wholeHeight"]), At = Y(() => o.getters["product/fractionalHeight"]), Je = Y(() => o.getters["product/frame"]), Ve = Y(() => o.getters["product/bottomMat"]), Ct = Y(() => o.getters["product/middleMat"]), Zt = Y(() => o.getters["product/topMat"]), nt = Y(() => o.getters["product/bottomMatWidth"]), bt = Y(() => o.getters["product/middleMatWidth"]), rr = Y(() => o.getters["product/topMatWidth"]), Xe = Y(() => o.getters["product/finishKit"]), pt = Y(() => o.getters["product/edge"]), Vr = Y(() => o.getters["product/canvasDepth"]), ht = Y(() => o.getters["product/matType"]), it = Y(() => o.getters["product/substrateType"]), cn = Y(() => o.getters["product/paperAdditionalWhiteBorder"]), St = Y(() => o.getters["product/paperAdditionalWhiteBorderInches"]), Tt = Y(() => o.getters["product/collection"]), un = Y(() => o.getters["product/svg"]), Ue = Y(() => o.getters["product/images"]), mt = Y(() => o.getters["product/includePrint"]);
    Y(() => o.getters["product/finishedWidth"]), Y(() => o.getters["product/finishedHeight"]);
    const Ft = Y(() => o.getters["product/finishedFractionWidth"]), Ut = Y(() => o.getters["product/finishedFractionHeight"]), nr = Y(() => o.getters["product/finishedInnerWidth"]), cr = Y(() => o.getters["product/finishedInnerHeight"]), zt = Y(() => e.isEcommerce ? o.getters["product/quantity"] : 1), dn = Y(() => o.getters["product/substrateOnlyProduct"]);
    Y(() => o.getters["product/imageUploadLoading"]);
    const ur = Y(() => o.getters["product/printOption"]), Jn = Y(() => o.getters["product/isFrameOnly"]);
    Y(() => o.getters["product/snapshot"]);
    const dr = Y(() => [
      "relative btn font-bold serif rounded-2xl text-lg w-full h-full md:text-base transition duration-300 ease-in-out ",
      Yo.value ? "btn--warning" : "btn--primary text-white"
    ]), { escape: An } = Ay(), Mr = Ee(!1), yr = Ee(!1), Qr = Ee(!1), Wt = Ee(!1), wr = Ee(!1), fn = Ee(!1), Fn = Ee(!1), Sn = Ee(!1), fr = Ee(!1), Si = Ee(!1), ir = Ee(""), vs = Ee(!1), ys = Ee(""), ws = Ee(""), Xn = Ee(!1), _r = (U) => {
      ir.value = U;
    };
    Ee(!1);
    const Pc = Y(() => (dn.value || As.value) && !Ue.value ? !0 : ur.value !== Cr && !Ue.value);
    qr(An, (U) => {
      U && hn();
    });
    const Jt = async () => {
      hn(), await Es();
    }, hn = () => {
      Mr.value = !1, fn.value = !1, Fn.value = !1, Sn.value = !1, Qr.value = !1, Wt.value = !1, yr.value = !1, wr.value = !1, fr.value = !1, Si.value = !1;
    }, Zs = Y(() => !!fn.value || !!Fn.value || !!Sn.value || !!Qr.value || !!yr.value || !!wr.value || !!fr.value || !!Si.value || !!Wt.value || !!Mr.value), Ko = () => {
      gt.value === !1 && hn();
    }, sr = async () => {
      hn(), await E(), await q();
    }, M = Ee(!1), O = Ee(!1), W = Ee(!1), ee = Ee(!1), me = Ee(!1), Te = Y(() => !!M.value || !!O.value || !!W.value || !!ee.value || !!me.value);
    function ze(U) {
      const te = rm.find((Oe) => Oe.label === U);
      return te ? te.value : "";
    }
    async function ar(U) {
      K(U), await ao(), Xn.value = !1, Lc(), F(!0);
    }
    function hr() {
      Xn.value = !0;
    }
    function pr(U, te) {
      te == Mi ? ys.value = U : ws.value = U;
    }
    const Tn = async () => {
      Yo.value ? Ti() : await xx();
    }, xx = async () => {
      e.lineitemId ? o.dispatch("customizer/cartUpdate") : o.dispatch("customizer/cartAdd");
    }, qf = Y(() => Yo.value ? !1 : Mt.value || Pc.value || Me.value || Ux.value || !!Fe.value || Zs.value), Yo = Y(() => !Ue.value && (ur.value !== Cr || dn.value)), qo = Ee(!1), Js = Ee(!1), bx = async (U) => {
      Ue.value && kc.value === U.id || (Js.value = !1, _s.value == !1 && !Xs.value && (_s.value = !0), await y(U), await ao(), setTimeout(async () => {
        if (Xs.value) {
          const te = await h0();
          await h(te);
        } else
          await Es();
      }, 200));
    }, vx = async () => {
      I(), await Es();
    }, kc = Y(() => Ue.value ? Ue.value.pane_1.imageId : null), gt = Ee(!1), Zf = Ee(!1), Oc = () => {
      gt.value = !window.matchMedia("(min-width: 768px)").matches, Zf.value = !window.matchMedia("(min-width: 1024px)").matches;
    };
    let Gi = Ee(), Qn = Ee(), Ki = Ee(), ei = Ee();
    qr(We, (U) => {
      U && (Gi.value !== yt.value && (Gi.value = yt.value), Qn.value !== Xr.value && (Qn.value = Xr.value), Ki.value !== Et.value && (Ki.value = Et.value), ei.value !== At.value && (ei.value = At.value));
    });
    const Jf = Y(() => e.userLoggedIn && e.featureFlags.enableFractionalDimensions || Qn.value || ei.value || e.featureFlags.enableFractionalDimensionsForAllCustomers);
    Y(() => !e.userLoggedIn && e.featureFlags.enableFractionalDimensions && !e.featureFlags.enableFractionalDimensionsForAllCustomers);
    const Xf = Y(() => Ki.value + ei.value), Qf = Y(() => Gi.value + Qn.value), yx = Y(() => {
      if (!ei.value && !Qn.value)
        return X.value[We.value] ? X.value[We.value].label : "";
      {
        let U = al.find((oe) => oe.value === ei.value), te = al.find((oe) => oe.value === Qn.value);
        const Oe = [];
        return Oe.push(Gi.value), te && Oe.push(" " + te.html), Oe.push('"'), Oe.push(" x "), Oe.push(Ki.value), U && Oe.push(" " + U.html), Oe.push('"'), Oe.join("");
      }
    }), Zo = () => {
      F(!0), c({ width: Qf.value, height: Xf.value, updateSize: !0 }), Lc(Qf.value, Xf.value);
    }, wx = () => {
      Wt.value = !0, z();
    }, _x = (U) => {
      hn(), f(Be.value, U);
    }, _s = Ee(!1), Ha = Ee("");
    Ge("renderer", {
      renderIsLoading: _s
    }), Ge("fullScale", {
      previewFullScale: !0
    });
    const e0 = Ee(1);
    Ge("imageEdits", {
      scale: e0
    }), qr(Zs, (U) => {
      U ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden");
    }), qr([Be], async ([U]) => {
      n.value && await Es();
    });
    const Es = async () => {
      if ((dn.value || As.value) && !Ue.value) {
        Ha.value = null;
        return;
      }
      const U = _8();
      k(U), _s.value = !0, Ue.value && await Ex();
      let te = !0;
      ce.value && (te = Pn(nr.value, cr.value, ce.value[Ve.value]));
      let Oe = te ? Ve.value : null, oe = te ? Ct.value : null, Qe = te ? Zt.value : null;
      try {
        const Ir = await by(
          lt.value,
          Lr.value,
          un.value,
          Je.value,
          Qe,
          oe,
          Oe,
          rr.value,
          bt.value,
          nt.value,
          it.value,
          St.value,
          Be.value,
          Xe.value
        );
        Ha.value !== Ir && It.value === U && (Ha.value = Ir), _s.value = !1;
      } catch {
        Ha.value = null, _s.value = !1;
      }
    }, Ex = async () => {
      const U = await h0();
      o.dispatch("product/setSvg", U);
    }, ti = Y(() => Be.value === On), Va = Y(() => Be.value === jr), t0 = Y(() => Be.value === Aa), Ax = Y(() => e.isFloatFrame), As = Y(() => Va.value && !Je.value), r0 = Y(() => xe.value ? xe.value.includes(jr) : !1), n0 = Y(() => xe.value ? xe.value.includes(On) : !1), Sx = Ee([
      "btn btn--warning text-lg font-bold rounded-sm w-full p-3 items-center",
      dn.value || As.value ? "mt-1" : "mt-4"
    ]), Tx = () => {
      ur.value === ba && Lc(), V(Cr);
    }, Mx = () => {
      ti.value ? (V(ba), Yi.value && b(Yi.value)) : V(Fl);
    }, ri = (U, te) => h8(X.value, U, te);
    Ge("isEcommerce", e.isEcommerce);
    const Ix = (U) => {
      const te = U.target.value;
      if (Z(te), Be === nn) {
        const Oe = B.value[te].defaultSize;
        K(Oe);
      }
      if (te) {
        const Oe = B.value[te], oe = Oe.minHeight, Qe = Oe.minWidth, Ir = Lr.value < Qe ? Qe : Lr.value, qi = lt.value < oe ? oe : lt.value;
        c({ width: Ir, height: qi, updateSize: !0 });
      }
    }, $r = Y(() => Be.value === nn), Jo = Y(() => Be.value === ks), Xo = Y(() => Be.value === Aa), Nc = Y(() => Object.values(B.value).sort((te, Oe) => {
      const oe = parseInt(te.defaultSize.split("|")[0]) * parseInt(te.defaultSize.split("|")[1]), Qe = parseInt(Oe.defaultSize.split("|")[0]) * parseInt(Oe.defaultSize.split("|")[1]);
      return oe > Qe ? 1 : -1;
    })), i0 = Y(() => {
      let U = {};
      if (B.value && Je.value && B.value[Je.value]) {
        let te = B.value[Je.value].numMats;
        const Oe = e.featureFlags && e.featureFlags.enableDoubleMats;
        Ve.value !== void 0 && te >= 1 && Object.assign(U, { NO_MAT: { name: "None", image: s7, sizeCompatible: !0 }, SINGLE_MAT: { name: "Single", image: a7, sizeCompatible: _t.value } }), Zt.value !== void 0 && (Zt.value || Oe) && te >= 2 && Object.assign(U, { DOUBLE_MAT: { name: "Double", image: o7, sizeCompatible: En.value } });
      }
      return U;
    }), Cx = async (U) => {
      U !== ht.value && !Me.value && (S(U), await ao(), await Es());
    }, Px = Y(() => !_t.value && !En.value && ti.value), s0 = Y(() => {
      if (Be.value == jr)
        return !1;
      const U = ue.value;
      if (!U || typeof U != "object" || Object.keys(U).length === 0)
        return !0;
      for (const te in U) {
        const Oe = U[te];
        if ((Oe == null ? void 0 : Oe.availabilityStatus) !== va)
          return !1;
      }
      return !0;
    }), kx = () => {
      v();
    };
    Y(() => de.value ? Object.values(de.value).sort((te, Oe) => te.code < Oe.code ? -1 : te.code > Oe.code ? 1 : 0) : []);
    const Ss = (U) => U ? U.availabilityStatus === E3 || U.availabilityStatus === null || !("availabilityStatus" in U) : !1, Rc = (U) => {
      let te = {}, Oe;
      for (Oe in U)
        U.hasOwnProperty(Oe) && Ss(U[Oe]) && Pn(nr.value, cr.value, U[Oe]) && (te[Oe] = U[Oe]);
      return te;
    }, ni = (U) => {
      let te = {
        [ih]: {},
        [zu]: {}
      }, Oe, oe = !1;
      for (Oe in U) {
        let Qe = !Ss(U[Oe]), Ir = !Pn(nr.value, cr.value, U[Oe]);
        if (U.hasOwnProperty(Oe) && (Qe || Ir)) {
          let qi;
          Qe ? qi = zu : Ir && (qi = ih), te[qi][Oe] = U[Oe], oe = !0;
        }
      }
      return oe ? te : null;
    }, Ox = Y(() => !!(ce.value && Zt.value && !Ss(ce.value[Zt.value]))), Nx = Y(() => !!(ce.value && Ve.value && !Ss(ce.value[Ve.value]))), $a = Y(() => !!(B.value && Je.value && !Ss(B.value[Je.value]))), a0 = Y(() => !!($.value && it.value && !Ss($.value[it.value]))), Rx = Y(() => {
      let U = "";
      return a0.value && (U = ti.value ? t("message.customizer.configurator.categories.errorMessages.outOfStock.substratePaper") : t("message.customizer.configurator.categories.errorMessages.outOfStock.substrateCanvas")), U;
    }), o0 = Y(() => !!(A.value && Xe.value && !Ss(A.value[Xe.value]))), Lx = Y(() => {
      let U = "";
      return o0.value && (U = t("message.customizer.configurator.categories.errorMessages.outOfStock.finishKit")), U;
    }), Dx = Y(() => B.value && Je.value ? ur.value !== Cr ? !1 : B.value[Je.value].shipsUnassembled : !1), Fx = Y(() => {
      const U = nt.value || "1";
      return `M0 0H${Xi[U] || Xi[1]}H144V144H0V0Z`;
    }), Bx = Y(() => {
      const U = nt.value || "1", te = rr.value || "1";
      let Oe;
      if (ir.value === Ji) {
        const oe = parseFloat(U) + parseFloat(te);
        Oe = Xi[oe.toString()];
      } else {
        const oe = rr.value || "1";
        Oe = Xi[oe] || Xi[1];
      }
      return `M0 0H${Oe}H144V144H0V0Z`;
    }), l0 = Y(() => {
      const U = nt.value || "1", te = rr.value || "1";
      let Oe;
      if (ir.value === Mi) {
        const oe = parseFloat(U) + parseFloat(te);
        Oe = Xi[oe.toString()];
      } else {
        const oe = rr.value || "1";
        Oe = Xi[oe] || Xi[1];
      }
      return `M0 0H${Oe}H144V144H0V0Z`;
    }), c0 = Y(() => {
      const U = ir.value === Mi ? ys.value : ws.value;
      return U !== "#" ? U : "#CAC9C9";
    }), u0 = Y(() => {
      const U = ir.value === Ji ? ys.value : ws.value;
      return U !== "#" ? U : "#CAC9C9";
    }), d0 = (U) => nl.filter((Oe) => Oe.value === U)[0].label, jx = (U) => au.filter((Oe) => Oe.value === U)[0].label, Ux = Y(() => $a.value || Ox.value || Nx.value || a0.value || o0.value), Xs = Ee(!1), zx = Y(() => [
      Xs.value ? "" : "hidden"
    ]), Ti = () => {
      Js.value = !0;
    }, Wx = async () => {
      f0(), await Es();
    }, Hx = async () => {
      await E(), await q(), f0();
    }, Vx = async () => {
      J();
    }, Bn = async () => {
      await z(), await C();
    }, $x = async () => {
      await Bn(), h(un.value), Xs.value = !0;
    }, f0 = () => {
      Xs.value = !1;
    }, Yi = Ee(null), Lc = (U, te) => {
      if (ti.value) {
        const Oe = U || Lr.value, oe = te || lt.value, Qe = Math.max(Oe, oe), Ir = Math.min(Oe, oe), qi = Yi.value ? Yi.value : Xe.value, p0 = A.value[qi].maxWidth, m0 = A.value[qi].maxHeight, g0 = Math.max(p0, m0), Gx = Math.min(p0, m0);
        Qe > g0 || Qe <= g0 && Ir > Gx ? (Yi.value = Xe.value, b("NOFK")) : Yi.value && (b(Yi.value), Yi.value = null);
      }
    }, h0 = async () => {
      let U = document.querySelector("#imageEditorPrintable");
      U.style.transform = "none";
      let te = i4(s4(U));
      return e.useThumborInSprout || (te = await a4(te)), te;
    };
    return Ge("panels", Y(() => 1)), Ge("selectedWidth", Y(() => Lr.value)), Ge("selectedHeight", Y(() => lt.value)), Ge("edgeDimension", Y(() => 0)), Ge("edgeColor", Y(() => "")), Ge("selectedEdge", Y(() => "BB")), Ge("renderMode", Y(() => !1)), Ge("frameDimension", Y(() => 0)), Ge("gapDimension", Y(() => 0)), Ge("matDimension", Y(() => 0)), Ge("isMobile", Y(() => !1)), Ge("selectedEditToolId", Y(() => Os)), Ge("wrapperPaddingClasslist", Y(() => "p-4")), Ge("featureFlags", Y(() => e.featureFlags)), Ge("panes", Y(() => [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        id: "pane_1"
      }
    ])), Ge("images", Y(() => Ue.value)), Ge("productSlug", Y(() => "S")), Ge("locale", Y(() => e.locale)), Ge("canManipulate", Y(() => !0)), Ge("pane", Y(() => "pane_1")), Ge("showStandaloneImageEditor", Y(() => Xs.value)), Ge("disablePaneTap", Y(() => !0)), Ge("substrateOnlyProduct", Y(() => dn.value)), Ge("isCanvasProductWithoutFrame", Y(() => As.value)), Ge("renderIsLoading", Y(() => _s.value)), (U, te) => {
      const Oe = Pt("i18n-t");
      return N(), j(De, null, [
        ae(m(Bu), {
          "data-error": "",
          visible: !!m(Sr),
          type: "negative",
          "confirm-label": "Okay",
          onConfirm: kx
        }, {
          default: Se(() => [
            O7
          ]),
          _: 1
        }, 8, ["visible"]),
        ae(br, { name: "transition-fade" }, {
          default: Se(() => [
            m(Zs) && !gt.value || !gt.value && m(Te) ? (N(), j("div", N7)) : se("", !0)
          ]),
          _: 1
        }),
        n.value ? (N(), j("div", R7, [
          ae(m(ii), {
            heading: "Print Option",
            show: Sn.value,
            awaitApply: !0,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            default: Se(() => [
              _("div", L7, [
                m(ti) && m(mt) ? (N(), j("div", D7, [
                  F7,
                  _("div", B7, [
                    _("select", {
                      class: "appearance-none rounded-lg block p-3 pr-10 text-gray-900 cursor-pointer w-full",
                      onChange: ne,
                      value: m(it)
                    }, [
                      (N(!0), j(De, null, wt(m($), (oe, Qe) => (N(), j("option", {
                        value: oe.code,
                        disabled: m($)[Qe].availabilityStatus === va,
                        key: Qe
                      }, he((m($)[Qe].availabilityStatus === va ? "(Out of stock) " : "") + oe.label), 9, U7))), 128))
                    ], 40, j7),
                    ae(m(lb), { class: "absolute right-0 mr-3 h-5 w-5 text-black pointer-events-none" })
                  ])
                ])) : se("", !0)
              ])
            ]),
            _: 1
          }, 8, ["show", "isMobile"]),
          ae(m(ii), {
            heading: U.$t("message.customizer.configurator.categories.additionalWhiteBorders.label"),
            show: Mr.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", z7, [
                (N(!0), j(De, null, wt(m(de), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => {
                    ye(Qe), Ko();
                  },
                  isSelected: m(cn) === Qe,
                  label: oe.label
                }, null, 8, ["onClick", "isSelected", "label"]))), 256))
              ])
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: "Frame Size",
            show: Si.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", W7, [
                (N(!0), j(De, null, wt(Rc(m(Nc)), (oe) => (N(), Ne(m(Zi), {
                  onClick: (Qe) => {
                    Z(oe.slug), Ko();
                  },
                  isSelected: m(Je) === oe.slug,
                  label: m(X)[m(B)[oe.slug].defaultSize].label
                }, null, 8, ["onClick", "isSelected", "label"]))), 256))
              ]),
              ni(m(Nc)) ? (N(), Ne(m(Ka), {
                key: 0,
                unavailablePartsObject: ni(m(Nc)),
                sizes: m(X),
                frames: m(B),
                selectedPart: m(Je)
              }, null, 8, ["unavailablePartsObject", "sizes", "frames", "selectedPart"])) : se("", !0)
            ]),
            _: 1
          }, 8, ["show", "isMobile"]),
          ae(m(ii), {
            heading: U.$t("message.customizer.configurator.categories.matOptions.label"),
            show: fn.value,
            isMobile: gt.value,
            discountFactor: m(i),
            hasDiscount: m(s),
            awaitApply: !0,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", null, [
                _("div", H7, [
                  ir.value === m(il) ? (N(), j("svg", V7, [
                    _("path", {
                      d: m(Fx),
                      fill: m(c0)
                    }, null, 8, $7)
                  ])) : (N(), j("svg", G7, [
                    ir.value === m(Mi) ? (N(), j("path", {
                      key: 0,
                      d: m(l0),
                      fill: m(u0)
                    }, null, 8, K7)) : se("", !0),
                    _("path", {
                      d: m(Bx),
                      fill: m(c0)
                    }, null, 8, Y7),
                    ir.value === m(Ji) ? (N(), j("path", {
                      key: 1,
                      d: m(l0),
                      fill: m(u0)
                    }, null, 8, q7)) : se("", !0)
                  ]))
                ]),
                _("div", Z7, [
                  ir.value !== m(il) ? (N(), j(De, { key: 0 }, [
                    _("div", {
                      class: Pe(["font-bold flex items-center justify-center px-2 py-4 cursor-pointer w-1/2 border-t-2 border-gray-50", {
                        "border-t-2 border-green-700 bg-white": ir.value === m(Mi),
                        "bg-gray-50": ir.value !== m(Mi)
                      }]),
                      onClick: te[0] || (te[0] = (oe) => _r(m(Mi)))
                    }, [
                      _("div", J7, [
                        m(hh) ? (N(), Ne(m(Uu), {
                          key: 0,
                          image: m(hh)
                        }, null, 8, ["image"])) : se("", !0)
                      ]),
                      Ea(" " + he(U.$t("message.customizer.configurator.categories.matOptions.outerMat")), 1)
                    ], 2),
                    _("div", {
                      class: Pe(["font-bold flex items-center justify-center px-2 py-4 cursor-pointer w-1/2 border-t-2 border-gray-50", {
                        "border-t-2 border-green-700 bg-white": ir.value === m(Ji),
                        "bg-gray-50": ir.value !== m(Ji)
                      }]),
                      onClick: te[1] || (te[1] = (oe) => _r(m(Ji)))
                    }, [
                      _("div", X7, [
                        m(fh) ? (N(), Ne(m(Uu), {
                          key: 0,
                          image: m(fh)
                        }, null, 8, ["image"])) : se("", !0)
                      ]),
                      Ea(" " + he(m(rr) ? U.$t("message.customizer.configurator.categories.matOptions.innerMat") : U.$t("message.customizer.configurator.categories.matOptions.mat")), 1)
                    ], 2)
                  ], 64)) : se("", !0)
                ]),
                _("div", Q7, [
                  ae(m(Qc), {
                    selectedMat: m(Zt),
                    selectedMatWidth: m(rr),
                    mats: m(ce),
                    heading: U.$t("message.customizer.configurator.categories.matOptions.outerWidth"),
                    matBorders: m(nl),
                    isActive: ir.value === m(Mi),
                    isMobile: gt.value,
                    tabKey: "outer",
                    onMatUpdate: _e,
                    onUpdateMatColour: pr,
                    onMatBorderUpdate: d,
                    onActivateTab: _r
                  }, null, 8, ["selectedMat", "selectedMatWidth", "mats", "heading", "matBorders", "isActive", "isMobile"]),
                  ae(m(Qc), {
                    selectedMat: m(Ve),
                    selectedMatWidth: m(nt),
                    mats: m(ce),
                    heading: m(rr) ? U.$t("message.customizer.configurator.categories.matOptions.innerWidth") : U.$t("message.customizer.configurator.matOptions.matWidth"),
                    matBorders: m(Zt) ? m(au) : m(nl),
                    isActive: ir.value === m(Ji),
                    isMobile: gt.value,
                    tabKey: "inner",
                    onMatUpdate: ge,
                    onUpdateMatColour: pr,
                    onMatBorderUpdate: L,
                    onActivateTab: _r
                  }, null, 8, ["selectedMat", "selectedMatWidth", "mats", "heading", "matBorders", "isActive", "isMobile"]),
                  ae(m(Qc), {
                    selectedMat: m(Ve),
                    selectedMatWidth: m(nt),
                    mats: m(ce),
                    heading: U.$t("message.customizer.configurator.categories.matOptions.matWidth"),
                    matBorders: m(Zt) ? m(au) : m(nl),
                    isActive: ir.value === m(il),
                    isMobile: gt.value,
                    tabKey: "mat",
                    onMatUpdate: ge,
                    onUpdateMatColour: pr,
                    onMatBorderUpdate: L,
                    onActivateTab: _r
                  }, null, 8, ["selectedMat", "selectedMatWidth", "mats", "heading", "matBorders", "isActive", "isMobile"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile", "discountFactor", "hasDiscount"]),
          ae(m(ii), {
            heading: m(Jo) ? U.$t("message.customizer.configurator.categories.finishingKit.mountingHardware") : U.$t("message.customizer.configurator.categories.finishingKit.acrylicBacking"),
            show: Fn.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", e9, [
                (N(!0), j(De, null, wt(Rc(m(A)), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => b(Qe),
                  label: oe.label,
                  isSelected: m(Xe) === Qe,
                  description: oe.description,
                  isSizeCompatible: m(Pn)(m(nr), m(cr), oe)
                }, null, 8, ["onClick", "label", "isSelected", "description", "isSizeCompatible"]))), 256))
              ]),
              ni(m(A)) ? (N(), Ne(m(Ka), {
                key: 0,
                unavailablePartsObject: ni(m(A)),
                selectedPart: m(Xe)
              }, null, 8, ["unavailablePartsObject", "selectedPart"])) : se("", !0)
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: m(Xo) || m(ti) ? U.$t("message.customizer.configurator.categories.paperOptions.label") : U.$t("message.customizer.configurator.categories.canvasMaterial.label"),
            show: wr.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", t9, [
                (N(!0), j(De, null, wt(Rc(m($)), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => le(Qe),
                  label: oe.label,
                  isSelected: m(it) === Qe,
                  isSizeCompatible: m(Pn)(m(nr), m(cr), oe)
                }, null, 8, ["onClick", "label", "isSelected", "isSizeCompatible"]))), 256))
              ]),
              ni(m($)) ? (N(), Ne(m(Ka), {
                key: 0,
                unavailablePartsObject: ni(m($)),
                selectedPart: m(it)
              }, null, 8, ["unavailablePartsObject", "selectedPart"])) : se("", !0)
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: U.$t("message.customizer.configurator.categories.canvasStyle.label"),
            show: yr.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", r9, [
                (N(!0), j(De, null, wt(m(Ae), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => R(Qe),
                  isSelected: m(Vr) === Qe,
                  label: oe.label
                }, null, 8, ["onClick", "isSelected", "label"]))), 256))
              ]),
              ni(m(Ae)) ? (N(), Ne(m(Ka), {
                key: 0,
                unavailablePartsObject: ni(m(Ae)),
                selectedPart: m(Vr)
              }, null, 8, ["unavailablePartsObject", "selectedPart"])) : se("", !0)
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: U.$t("message.customizer.configurator.categories.canvasEdge.label"),
            show: Qr.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", n9, [
                (N(!0), j(De, null, wt(m(ut), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => D(Qe),
                  isSelected: m(pt) === Qe,
                  label: oe.description
                }, null, 8, ["onClick", "isSelected", "label"]))), 256))
              ]),
              ni(m(ut)) ? (N(), Ne(m(Ka), {
                key: 0,
                unavailablePartsObject: ni(m(ut)),
                selectedPart: m(pt)
              }, null, 8, ["unavailablePartsObject", "selectedPart"])) : se("", !0)
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: U.$t("message.customizer.configurator.categories.imageSize.label"),
            show: Wt.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            secondary: Se(() => [
              ae(es, {
                hasDiscount: m(s),
                discountFactor: m(i),
                selectedFrame: m(Je),
                isReadyMadeProduct: m($r),
                finishedWidth: m(Ft),
                finishedHeight: m(Ut),
                customPriceLoading: m(Me),
                totalPrice: m(Re),
                quantity: m(zt),
                selectedSize: m(We),
                priceDeductedFromFrame: ri,
                isMobile: gt.value,
                onCancel: sr,
                onApplyChanges: Jt
              }, null, 8, ["hasDiscount", "discountFactor", "selectedFrame", "isReadyMadeProduct", "finishedWidth", "finishedHeight", "customPriceLoading", "totalPrice", "quantity", "selectedSize", "isMobile"])
            ]),
            default: Se(() => [
              _("div", i9, [
                m(Ue) ? (N(), j("span", a9, he(U.$t("message.customizer.configurator.categories.imageSize.recommendedSizes")), 1)) : (N(), j("span", s9, he(U.$t("message.customizer.configurator.categories.imageSize.popularSizes")), 1)),
                _("div", {
                  onClick: Q,
                  class: "flex justify-center cursor-pointer pr-2"
                }, l9)
              ]),
              _("div", c9, [
                m(vt) && !m(Jr) ? (N(), Ne(m(ol), {
                  key: 0,
                  enableChooseSmallerSizeAction: !1,
                  enableUploadNewImageAction: !1,
                  onOpenImageSelector: te[2] || (te[2] = (oe) => {
                    hn(), Ti();
                  }),
                  onShowImageSizePanel: te[3] || (te[3] = (oe) => Wt.value = !0)
                })) : se("", !0),
                m(Jr) ? (N(), Ne(m(ol), {
                  key: 1,
                  enableChooseSmallerSizeAction: !1,
                  stringKeyPath: "message.customizer.configurator.categories.imageSize.smallErrorMessage",
                  onShowImageSizePanel: te[4] || (te[4] = (oe) => Wt.value = !0),
                  onOpenImageSelector: te[5] || (te[5] = (oe) => {
                    hn(), Ti();
                  })
                }, null, 8, ["stringKeyPath"])) : se("", !0)
              ]),
              _("div", u9, [
                (N(!0), j(De, null, wt(m(pe), (oe, Qe) => (N(), Ne(m(Zi), {
                  onClick: (Ir) => ar(Qe),
                  label: oe.label,
                  isSelected: m(We) === Qe && !Xn.value
                }, null, 8, ["onClick", "label", "isSelected"]))), 256)),
                ae(m(Zi), {
                  "data-custom-size": "",
                  label: "Custom Size",
                  isSelected: Xn.value,
                  onClick: hr
                }, null, 8, ["isSelected"])
              ]),
              Xn.value ? (N(), j("div", d9, [
                _("div", f9, [
                  _("div", h9, [
                    _("span", null, he(U.$t("message.customizer.configurator.categories.imageSize.width")), 1),
                    m(Me) ? (N(), j("div", p9, [
                      ae(m(Cn), { class: "w-6 h-6" })
                    ])) : se("", !0),
                    m(Me) ? se("", !0) : (N(), j("div", m9, [
                      Ke(_("select", {
                        "onUpdate:modelValue": te[6] || (te[6] = (oe) => Qo(Gi) ? Gi.value = oe : Gi = oe),
                        "data-custom-width": "",
                        key: "wholeWidth",
                        onChange: Zo,
                        class: "appearance-none block p-2 text-gray-900 cursor-pointer w-full h-12 border border-black"
                      }, [
                        (N(!0), j(De, null, wt(m(fe), (oe) => (N(), j("option", {
                          value: oe.value,
                          disabled: oe.disabled
                        }, he(oe.label) + '"', 9, g9))), 256))
                      ], 544), [
                        [el, m(Gi)]
                      ]),
                      x9
                    ]))
                  ]),
                  m(Jf) ? (N(), j(De, { key: 0 }, [
                    m(Me) ? (N(), j("div", b9, [
                      ae(m(Cn), { class: "w-6 h-6" })
                    ])) : se("", !0),
                    m(Me) ? se("", !0) : (N(), j("div", v9, [
                      Ke(_("select", {
                        "onUpdate:modelValue": te[7] || (te[7] = (oe) => Qo(Qn) ? Qn.value = oe : Qn = oe),
                        key: "fractionalWidth",
                        onChange: Zo,
                        class: "appearance-none block p-2 text-gray-900 cursor-pointer w-full h-12 border border-black mt-6"
                      }, [
                        y9,
                        (N(!0), j(De, null, wt(m(al), (oe) => (N(), j("option", {
                          value: oe.value,
                          disabled: !m(rt)
                        }, he(oe.label) + '"', 9, w9))), 256))
                      ], 544), [
                        [el, m(Qn)]
                      ]),
                      _9
                    ]))
                  ], 64)) : se("", !0),
                  E9,
                  _("div", A9, [
                    _("span", null, he(U.$t("message.customizer.configurator.categories.imageSize.height")), 1),
                    m(Me) ? (N(), j("div", S9, [
                      ae(m(Cn), { class: "w-6 h-6" })
                    ])) : se("", !0),
                    m(Me) ? se("", !0) : (N(), j("div", T9, [
                      Ke(_("select", {
                        "onUpdate:modelValue": te[8] || (te[8] = (oe) => Qo(Ki) ? Ki.value = oe : Ki = oe),
                        "data-custom-height": "",
                        key: "wholeHeight",
                        onChange: Zo,
                        class: "appearance-none block p-3 pr-4 text-gray-900 cursor-pointer w-full h-12 border border-black"
                      }, [
                        (N(!0), j(De, null, wt(m(re), (oe) => (N(), j("option", {
                          value: oe.value,
                          disabled: oe.disabled
                        }, he(oe.label) + '"', 9, M9))), 256))
                      ], 544), [
                        [el, m(Ki)]
                      ]),
                      I9
                    ]))
                  ]),
                  m(Jf) ? (N(), j(De, { key: 1 }, [
                    m(Me) ? (N(), j("div", C9, [
                      ae(m(Cn), { class: "w-6 h-6" })
                    ])) : se("", !0),
                    m(Me) ? se("", !0) : (N(), j("div", P9, [
                      Ke(_("select", {
                        "onUpdate:modelValue": te[9] || (te[9] = (oe) => Qo(ei) ? ei.value = oe : ei = oe),
                        key: "fractionalHeight",
                        onChange: Zo,
                        class: "appearance-none block p-3 pr-4 text-gray-900 cursor-pointer w-full h-12 border border-black mt-6"
                      }, [
                        k9,
                        (N(!0), j(De, null, wt(m(al), (oe) => (N(), j("option", {
                          value: oe.value,
                          disabled: !m(Ze)
                        }, he(oe.label) + '"', 9, O9))), 256))
                      ], 544), [
                        [el, m(ei)]
                      ]),
                      N9
                    ]))
                  ], 64)) : se("", !0)
                ])
              ])) : se("", !0)
            ]),
            _: 1
          }, 8, ["heading", "show", "isMobile"]),
          ae(m(ii), {
            heading: "Frame Type",
            show: fr.value,
            isMobile: gt.value,
            onCancel: sr,
            onApplyChanges: Jt
          }, {
            default: Se(() => [
              _("div", R9, [
                ae(m(J4), {
                  collections: m(Le),
                  selectedCollection: m(Tt),
                  onSelectCollection: _x
                }, null, 8, ["collections", "selectedCollection"])
              ])
            ]),
            _: 1
          }, 8, ["show", "isMobile"]),
          m(Ue) ? (N(), j("div", {
            key: 0,
            class: Pe(m(zx))
          }, [
            ae(m(T6), {
              "data-standalone-image-editor": "",
              onPaneClick: Ti,
              onApplyImageEdits: Wx,
              onCancelImageEdits: Hx,
              onRotateImage: Vx,
              onChangeOrientation: Q
            })
          ], 2)) : se("", !0),
          m($a) ? se("", !0) : (N(), j("div", L9, [
            m(Je) && !m($r) ? (N(), j(De, { key: 0 }, [
              _("div", D9, [
                _("h3", F9, he(U.$t("message.customizer.configurator.categories.services.label")), 1),
                _("button", {
                  "data-service-info-button": "",
                  onClick: te[10] || (te[10] = (oe) => M.value = !0),
                  "aria-label": "Learn more about " + U.$t("message.customizer.configurator.categories.services.label")
                }, [
                  ae(m(vn), {
                    type: "info",
                    class: "w-5 h-5"
                  })
                ], 8, B9),
                ae(m(Ms), {
                  "data-service-info-drawer": "",
                  show: M.value,
                  content: ze(U.$t("message.customizer.configurator.categories.services.label")),
                  isMobile: gt.value,
                  onClose: te[11] || (te[11] = (oe) => M.value = !1)
                }, null, 8, ["show", "content", "isMobile"])
              ]),
              _("div", j9, [
                ae(m(oa), {
                  label: U.$t("message.customizer.configurator.categories.services.options.frameOnly.label"),
                  description: U.$t("message.customizer.configurator.categories.services.options.frameOnly.description"),
                  checked: m(ur) === Cr,
                  onClick: Tx,
                  "data-test-id": "frame-only"
                }, {
                  icon: Se(() => [
                    U9
                  ]),
                  _: 1
                }, 8, ["label", "description", "checked"]),
                ae(m(oa), {
                  label: U.$t("message.customizer.configurator.categories.services.options.printFrame.label"),
                  description: U.$t("message.customizer.configurator.categories.services.options.printFrame.description"),
                  checked: m(ur) !== Cr,
                  onClick: Mx,
                  "data-test-id": "print+frame"
                }, {
                  icon: Se(() => [
                    z9
                  ]),
                  _: 1
                }, 8, ["label", "description", "checked"])
              ])
            ], 64)) : se("", !0),
            m(dn) || m(As) ? (N(), j("h3", W9, he(U.$t("message.customizer.configurator.categories.printOptions.label.printAndFrame")), 1)) : se("", !0),
            (m(t0) || m(Va)) && !m(Ax) ? (N(), j("div", H9, [
              _("span", V9, he(U.$t("message.customizer.configurator.categories.printOptions.wantToFrameYourPrint")), 1),
              _("a", {
                href: `/custom-framing/all-frames?page=1&substrates=${m(t0) ? "paper" : "canvas"}`,
                class: "underline text-md cursor-pointer text-sm"
              }, he(U.$t("message.customizer.configurator.categories.printOptions.startWithAFrame")), 9, $9)
            ])) : se("", !0),
            !m(Ue) && !m($r) ? (N(), j("div", G9, [
              m(ur) !== Cr || m(dn) || m(As) ? (N(), j("button", {
                key: 0,
                onClick: Ti,
                type: "button",
                "data-upload-image-button": "",
                tabindex: "0",
                class: Pe(Sx.value),
                id: "menu-button",
                "aria-expanded": "true",
                "aria-haspopup": "true"
              }, [
                _("span", null, he(U.$t("message.customizer.configurator.uploadButton.print")), 1)
              ], 2)) : (N(), j("span", {
                key: 1,
                onClick: Ti,
                "data-upload-preview-button": "",
                tabindex: "0",
                class: "text-gray-900 underline cursor-pointer mt-3 hover:no-underline"
              }, he(U.$t("message.customizer.configurator.uploadButton.preview")), 1))
            ])) : se("", !0),
            m(Je) ? (N(), j(De, { key: 4 }, [
              _("div", K9, [
                _("h3", Y9, [
                  m(ur) !== Cr ? (N(), j("span", q9, he(U.$t("message.customizer.configurator.categories.printOptions.label.printAndFrame")), 1)) : se("", !0),
                  m(ur) === Cr ? (N(), j("span", Z9, he(U.$t("message.customizer.configurator.categories.printOptions.label.frameOnly")), 1)) : se("", !0)
                ]),
                _("button", {
                  onClick: te[12] || (te[12] = (oe) => O.value = !0),
                  class: "pt-6",
                  "aria-label": m(ur) !== Cr ? "Learn more about " + U.$t("message.customizer.configurator.categories.printOptions.label.printAndFrame") : "Learn more about " + U.$t("message.customizer.configurator.categories.printOptions.label.frameOnly")
                }, [
                  ae(m(vn), {
                    type: "info",
                    class: "w-5 h-5"
                  })
                ], 8, J9),
                m(ur) !== Cr ? (N(), Ne(m(Ms), {
                  key: 0,
                  show: O.value,
                  content: ze(U.$t("message.customizer.configurator.categories.printOptions.label.printAndFrame")),
                  isMobile: gt.value,
                  onClose: te[13] || (te[13] = (oe) => O.value = !1)
                }, null, 8, ["show", "content", "isMobile"])) : se("", !0),
                m(ur) === Cr ? (N(), Ne(m(Ms), {
                  key: 1,
                  show: O.value,
                  content: ze(U.$t("message.customizer.configurator.categories.printOptions.label.frameOnly")),
                  isMobile: gt.value,
                  onClose: te[14] || (te[14] = (oe) => O.value = !1)
                }, null, 8, ["show", "content", "isMobile"])) : se("", !0)
              ]),
              !m($r) && m(n0) && m(r0) ? (N(), j("div", X9, [
                m(n0) ? (N(), Ne(m(oa), {
                  key: 0,
                  "data-print-option-paper": "",
                  label: U.$t("message.customizer.configurator.categories.printOptions.paper"),
                  checked: m(ti),
                  includesCheckmark: !0,
                  onClick: te[15] || (te[15] = (oe) => g(ba))
                }, null, 8, ["label", "checked"])) : se("", !0),
                m(r0) ? (N(), Ne(m(oa), {
                  key: 1,
                  "data-print-option-canvas": "",
                  label: U.$t("message.customizer.configurator.categories.printOptions.canvas"),
                  checked: m(Va),
                  includesCheckmark: !0,
                  "data-test-id": "print-option-canvas",
                  onClick: te[16] || (te[16] = (oe) => g(Fl))
                }, null, 8, ["label", "checked"])) : se("", !0)
              ])) : se("", !0)
            ], 64)) : se("", !0),
            _("div", Q9, [
              r.isEcommerce ? (N(), j(De, { key: 0 }, [
                m(Be) === On || m(Be) === jr || m(Be) === nn ? (N(), j("div", eE, [
                  tE,
                  _("select", {
                    value: m(Je),
                    onChange: Ix
                  }, [
                    nE,
                    (N(!0), j(De, null, wt(r.allFrames, (oe) => (N(), j("option", {
                      value: oe.slug
                    }, he(oe.slug) + " - " + he(oe.name), 9, iE))), 256))
                  ], 40, rE)
                ])) : se("", !0),
                _("div", null, [
                  sE,
                  _("select", {
                    value: m(zt),
                    onChange: G
                  }, [
                    (N(), j(De, null, wt(100, (oe) => _("option", { value: oe }, he(oe), 9, oE)), 64))
                  ], 40, aE)
                ])
              ], 64)) : se("", !0),
              _("div", null, [
                m($r) ? se("", !0) : (N(), j("div", lE, [
                  m(X) && Object.keys(m(X)).length > 0 ? (N(), j("div", cE, [
                    ae(ai, {
                      heading: U.$t("message.customizer.configurator.categories.imageSize.label"),
                      subheading: m(yx),
                      includeTopBorder: !0,
                      includeBottomBorder: !0,
                      onClick: te[17] || (te[17] = (oe) => {
                        Wt.value = !0, Bn();
                      }),
                      "data-test-id": "image-size"
                    }, null, 8, ["heading", "subheading"])
                  ])) : se("", !0),
                  m(vt) && !m(Jr) ? (N(), Ne(m(ol), {
                    key: 1,
                    enableUploadNewImageAction: !1,
                    onShowImageSizePanel: te[18] || (te[18] = (oe) => Wt.value = !0),
                    onOpenImageSelector: te[19] || (te[19] = (oe) => {
                      hn(), Ti();
                    })
                  })) : se("", !0),
                  m(Jr) ? (N(), Ne(m(ol), {
                    key: 2,
                    stringKeyPath: "message.customizer.configurator.categories.imageSize.smallErrorMessage",
                    onShowImageSizePanel: te[20] || (te[20] = (oe) => Wt.value = !0),
                    onOpenImageSelector: te[21] || (te[21] = (oe) => {
                      hn(), Ti();
                    })
                  }, null, 8, ["stringKeyPath"])) : se("", !0)
                ])),
                (m(Je) && m(mt) && !m(Jn) || m(Xo) || m(As)) && m($) && m(it) ? (N(), j("div", uE, [
                  ae(ai, {
                    heading: m(Xo) || m(ti) ? U.$t("message.customizer.configurator.categories.paperOptions.label") : U.$t("message.customizer.configurator.categories.canvasMaterial.label"),
                    subheading: m($)[m(it)].label,
                    includeBottomBorder: !0,
                    includeTopBorder: !!m(vt),
                    errorMessage: m(Rx),
                    onClick: te[22] || (te[22] = (oe) => {
                      wr.value = !0, Bn();
                    }),
                    "data-test-id": "select-options"
                  }, null, 8, ["heading", "subheading", "includeTopBorder", "errorMessage"])
                ])) : se("", !0),
                m(Va) && m(pt) && m(ut) && m(mt) ? (N(), j("div", dE, [
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.canvasEdge.label"),
                    subheading: m(ut)[m(pt)].description,
                    includeBottomBorder: !0,
                    onClick: te[23] || (te[23] = (oe) => {
                      Qr.value = !0, Bn();
                    }),
                    "data-test-id": "canvas-edge"
                  }, null, 8, ["heading", "subheading"])
                ])) : se("", !0),
                m(Va) && !m(Je) && m(Ae) ? (N(), j("div", fE, [
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.canvasStyle.label"),
                    subheading: m(Ae)[m(Vr)].label,
                    includeBottomBorder: !0,
                    onClick: te[24] || (te[24] = (oe) => {
                      yr.value = !0, Bn();
                    }),
                    "data-test-id": "canvas-style"
                  }, null, 8, ["heading", "subheading"])
                ])) : se("", !0),
                m(Xo) && m(de) && m(cn) ? (N(), j("div", hE, [
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.additionalWhiteBorders.label"),
                    subheading: m(de)[m(cn)].label,
                    includeBottomBorder: !0,
                    onClick: te[25] || (te[25] = (oe) => {
                      Mr.value = !0, Bn();
                    })
                  }, null, 8, ["heading", "subheading"])
                ])) : se("", !0)
              ]),
              m(Je) && m(X)[m(We)] && m($r) && !r.isEcommerce ? (N(), j("div", pE, [
                ae(ai, {
                  heading: U.$t("message.customizer.configurator.categories.frameSize.label"),
                  subheading: m(X)[m(We)].label,
                  includeTopBorder: !0,
                  includeBottomBorder: !0,
                  errorMessage: m($a) ? U.$t("message.customizer.configurator.categories.frameSize.label") : "",
                  onClick: te[26] || (te[26] = (oe) => {
                    Si.value = !0, Bn();
                  })
                }, null, 8, ["heading", "subheading", "errorMessage"])
              ])) : se("", !0),
              m(ti) && Object.keys(m(i0)).length !== 0 ? (N(), j("div", mE, [
                _("div", gE, [
                  _("h3", xE, he(U.$t("message.customizer.configurator.categories.matOptions.mat")), 1),
                  _("button", {
                    onClick: te[27] || (te[27] = (oe) => me.value = !0),
                    "aria-label": U.$t("message.customizer.configurator.categories.matOptions.label")
                  }, [
                    ae(m(vn), {
                      type: "info",
                      class: "w-5 h-5"
                    })
                  ], 8, bE),
                  ae(m(Ms), {
                    show: me.value,
                    content: ze(U.$t("message.customizer.configurator.categories.matOptions.label")),
                    isMobile: gt.value,
                    onClose: te[28] || (te[28] = (oe) => me.value = !1)
                  }, null, 8, ["show", "content", "isMobile"])
                ]),
                _("div", vE, [
                  (N(!0), j(De, null, wt(m(i0), (oe, Qe) => (N(), Ne(m(oa), {
                    label: oe.name,
                    checked: m(ht) === Qe,
                    disabled: (Object.keys(m(ce)).length == 0 || !oe.sizeCompatible) && oe.name !== "None",
                    isLoading: typeof m(Me) == "boolean" ? m(Me) : m(Me) === 1,
                    labelWidth: "w-12",
                    onClick: (Ir) => Cx(Qe)
                  }, null, 8, ["label", "checked", "disabled", "isLoading", "onClick"]))), 256))
                ])
              ])) : se("", !0),
              m(ce) && Object.keys(m(ce)).length > 0 && m(Me) == 0 ? (N(), j("div", yE, [
                m(ht) === "SINGLE_MAT" && m(nt) ? (N(), j("div", wE, [
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.matOptions.mat"),
                    subheading: d0(m(nt)),
                    supplementaryHeading: m(ce)[m(Ve)] ? m(ce)[m(Ve)].label.toLowerCase().replace(/\b\w/g, (oe) => oe.toUpperCase()) : "",
                    tertiaryHeading: m(Ve),
                    errorMessage: m(Tr),
                    includeTopBorder: !0,
                    includeBottomBorder: !0,
                    onClick: te[29] || (te[29] = (oe) => {
                      _r(m(il)), fn.value = !0, Bn();
                    })
                  }, null, 8, ["heading", "subheading", "supplementaryHeading", "tertiaryHeading", "errorMessage"])
                ])) : se("", !0),
                m(ht) === "DOUBLE_MAT" && m(rr) && m(Ve) ? (N(), j("div", _E, [
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.matOptions.outerMat"),
                    subheading: d0(m(rr)),
                    supplementaryHeading: m(ce)[m(Zt)] ? m(ce)[m(Zt)].label.toLowerCase().replace(/\b\w/g, (oe) => oe.toUpperCase()) : "",
                    tertiaryHeading: m(Zt),
                    errorMessage: m(ft),
                    includeTopBorder: !0,
                    onClick: te[30] || (te[30] = (oe) => {
                      _r(m(Mi)), fn.value = !0, Bn();
                    })
                  }, null, 8, ["heading", "subheading", "supplementaryHeading", "tertiaryHeading", "errorMessage"]),
                  ae(ai, {
                    heading: U.$t("message.customizer.configurator.categories.matOptions.innerMat"),
                    subheading: jx(m(nt)),
                    supplementaryHeading: m(ce)[m(Ve)] ? m(ce)[m(Ve)].label.toLowerCase().replace(/\b\w/g, (oe) => oe.toUpperCase()) : "",
                    tertiaryHeading: m(Ve),
                    errorMessage: m(Tr),
                    includeTopBorder: !0,
                    includeBottomBorder: !0,
                    onClick: te[31] || (te[31] = (oe) => {
                      _r(m(Ji)), fn.value = !0, Bn();
                    })
                  }, null, 8, ["heading", "subheading", "supplementaryHeading", "tertiaryHeading", "errorMessage"])
                ])) : se("", !0)
              ])) : se("", !0),
              m(ce) && m(Px) || m(s0) ? (N(), j("div", {
                key: 4,
                class: Pe([m(ht) !== "NO_MAT" ? "text-ginger-700 bg-ginger-50" : "bg-notice-100", "text-sm px-4 py-2"])
              }, [
                m(ht) !== "NO_MAT" ? (N(), j("p", EE, [
                  ae(Oe, {
                    keypath: "message.customizer.configurator.categories.matOptions.errorMessage",
                    scope: "global"
                  }, {
                    textLink: Se(() => [
                      _("a", {
                        onClick: wx,
                        class: "text-vanilla-950 underline font-bold cursor-pointer"
                      }, he(U.$t("message.customizer.configurator.categories.matOptions.errorMessageTextLink")), 1)
                    ]),
                    _: 1
                  })
                ])) : (N(), j(De, { key: 1 }, [
                  m(s0) ? (N(), j("p", AE, he(U.$t("message.customizer.configurator.categories.matOptions.warningMessageMatsUnavailable")), 1)) : (N(), j("p", SE, he(U.$t("message.customizer.configurator.categories.matOptions.warningMessage")), 1))
                ], 64))
              ], 2)) : se("", !0),
              (m(ti) || m($r) || m(Jo)) && m(A) && m(A)[m(Xe)] ? (N(), j("div", TE, [
                _("div", ME, [
                  _("h3", IE, he(U.$t("message.customizer.configurator.categories.finishingKit.label")), 1),
                  _("button", {
                    onClick: te[32] || (te[32] = (oe) => ee.value = !0),
                    "aria-label": U.$t("message.customizer.configurator.categories.finishingKit.label")
                  }, [
                    ae(m(vn), {
                      type: "info",
                      class: "w-5 h-5"
                    })
                  ], 8, CE),
                  ae(m(Ms), {
                    show: ee.value,
                    content: m(Jo) ? ze(U.$t("message.customizer.configurator.categories.finishingKit.mountingHardware")) : ze(U.$t("message.customizer.configurator.categories.finishingKit.acrylicBacking")),
                    isMobile: gt.value,
                    onClose: te[33] || (te[33] = (oe) => ee.value = !1)
                  }, null, 8, ["show", "content", "isMobile"])
                ]),
                Object.keys(m(A)).length > 0 && m(Me) == 0 ? (N(), j("div", PE, [
                  ae(ai, {
                    heading: m(Jo) ? U.$t("message.customizer.configurator.categories.finishingKit.mountingHardware") : U.$t("message.customizer.configurator.categories.finishingKit.acrylicBacking"),
                    subheading: m(A)[m(Xe)].label,
                    errorMessage: m(Lx),
                    includeTopBorder: !0,
                    includeBottomBorder: !0,
                    onClick: te[34] || (te[34] = (oe) => {
                      Fn.value = !0, Bn();
                    })
                  }, null, 8, ["heading", "subheading", "errorMessage"])
                ])) : se("", !0)
              ])) : se("", !0)
            ])
          ]))
        ])) : se("", !0),
        (N(), Ne(x0, {
          to: Zf.value ? "[data-customizer-cta-mobile]" : "[data-cta-desktop]"
        }, [
          n.value ? (N(), j("div", kE, [
            m($a) ? se("", !0) : (N(), j("div", OE, [
              _("div", NE, he(U.$t("message.customizer.footer.finishedSize")) + " " + he(m(Ft)) + '" x ' + he(m(Ut)) + '" ' + he(U.$t("message.customizer.footer.approx")), 1),
              m(Dx) ? (N(), j("div", RE, [
                _("div", LE, [
                  _("span", DE, he(U.$t("message.customizer.footer.unassembled")), 1),
                  _("button", {
                    onClick: te[35] || (te[35] = (oe) => W.value = !0),
                    class: "underline"
                  }, he(U.$t("message.customizer.footer.why")), 1)
                ])
              ])) : se("", !0)
            ])),
            _("div", FE, [
              _("div", BE, [
                m(Me) ? (N(), j("div", WE, VE)) : (N(), j("div", jE, [
                  _("p", UE, he(U.$filters.currency((m(Re) - ri(m(We), m(Je))) * m(i) * m(zt))), 1),
                  m(s) || ri(m(We), m(Je)) ? (N(), j("p", zE, he(U.$filters.currency(m(Re) * m(zt))), 1)) : se("", !0)
                ]))
              ]),
              _("div", $E, [
                _("div", GE, [
                  vs.value && m(qf) && !gt.value && !m(Mt) ? (N(), j("div", KE, [
                    _("div", YE, he(U.$t("message.customizer.tooltip")), 1),
                    qE
                  ])) : se("", !0),
                  m($a) ? (N(), j("button", {
                    key: 1,
                    "data-unavailable-frame-button": "",
                    disabled: !0,
                    class: Pe(m(dr))
                  }, [
                    m(Mt) ? (N(), j(De, { key: 1 }, [
                      m(Fe) ? se("", !0) : (N(), Ne(m(Cn), {
                        key: 0,
                        class: "w-6 h-6"
                      }))
                    ], 64)) : (N(), j(De, { key: 0 }, [
                      m(Me) ? (N(), j("span", ZE, [
                        ae(m(Cn), { class: "w-6 h-6" })
                      ])) : se("", !0),
                      m(Me) ? se("", !0) : (N(), j("span", JE, [
                        _("span", null, he(U.$t("message.customizer.buttons.outOfStock")), 1)
                      ]))
                    ], 64))
                  ], 2)) : (N(), j("button", {
                    key: 2,
                    onClick: Tn,
                    onMouseenter: te[36] || (te[36] = (oe) => vs.value = !0),
                    onMouseleave: te[37] || (te[37] = (oe) => vs.value = !1),
                    "data-add-to-cart": "",
                    disabled: m(qf),
                    class: Pe(m(dr))
                  }, [
                    m(Mt) ? (N(), j(De, { key: 1 }, [
                      m(Fe) ? se("", !0) : (N(), Ne(m(Cn), {
                        key: 0,
                        class: "w-6 h-6"
                      })),
                      e.lineitemId ? (N(), j("span", sA, "Saving")) : (N(), j("span", aA, "Adding to cart"))
                    ], 64)) : (N(), j(De, { key: 0 }, [
                      m(Me) ? (N(), j("span", QE, [
                        ae(m(Cn), { class: "w-6 h-6" })
                      ])) : se("", !0),
                      m(Me) ? se("", !0) : (N(), j("span", eA, [
                        m(Yo) ? (N(), j("span", tA, he(U.$t("message.customizer.configurator.uploadButton.print")), 1)) : (N(), j("span", rA, [
                          e.lineitemId ? (N(), j("span", nA, he(U.$t("message.customizer.buttons.save")), 1)) : (N(), j("span", iA, he(U.$t("message.customizer.buttons.addToCart")), 1))
                        ]))
                      ]))
                    ], 64))
                  ], 42, XE))
                ])
              ])
            ])
          ])) : se("", !0)
        ], 8, ["to"])),
        ae(m(Ms), {
          show: W.value,
          content: ze(U.$t("message.customizer.footer.unassembled")),
          isMobile: gt.value,
          onClose: te[38] || (te[38] = (oe) => W.value = !1)
        }, null, 8, ["show", "content", "isMobile"]),
        ae(J1, { name: "transition-fade-in" }, {
          default: Se(() => [
            Ke((N(), Ne(m(s8), {
              key: "imageSelector" + m(kc),
              "data-image-selector": "",
              "selected-images": [m(kc)],
              autoSelectSingleUpload: !0,
              onClose: te[39] || (te[39] = (oe) => Js.value = !1),
              onConfirm: bx
            }, null, 8, ["selected-images"])), [
              [tt, Js.value]
            ]),
            Js.value ? (N(), j("div", {
              key: "imageSelector2",
              onClick: te[40] || (te[40] = (oe) => Js.value = !1),
              class: "bg-black bg-opacity-75 fixed inset-0 z-50"
            })) : se("", !0)
          ]),
          _: 1
        }),
        n.value ? (N(), Ne(x0, {
          key: 1,
          to: "[data-preview-el]"
        }, [
          ae(m(Gb), {
            images: m(dt),
            frame: m(Je),
            previewUrl: Ha.value,
            width: m(Lr),
            height: m(lt),
            productSlug: m(Be),
            isReadyMadeProduct: m($r),
            isMobile: gt.value,
            isEcommerce: r.isEcommerce,
            finishKit: m(Xe),
            selectedImages: m(Ue),
            selectedPrintOption: m(ur)
          }, {
            default: Se(() => [
              m(Ue) ? (N(), j("div", oA, [
                _("div", {
                  onClick: $x,
                  class: "cursor-pointer hover:underline no-underline flex items-center gap-1"
                }, [
                  lA,
                  _("div", cA, he(U.$t("message.customizer.carousel.image.edit")), 1)
                ]),
                uA,
                _("div", {
                  class: "cursor-pointer hover:underline no-underline flex items-center gap-1",
                  onClick: Ti
                }, [
                  dA,
                  _("div", fA, he(U.$t("message.customizer.carousel.image.replace")), 1)
                ]),
                hA,
                _("button", {
                  "data-remove-image-button": "",
                  class: "cursor-pointer hover:underline no-underline flex items-center gap-1",
                  onClick: te[41] || (te[41] = (oe) => qo.value = !0)
                }, [
                  pA,
                  _("div", mA, he(U.$t("message.customizer.carousel.image.remove")), 1)
                ])
              ])) : se("", !0)
            ]),
            _: 1
          }, 8, ["images", "frame", "previewUrl", "width", "height", "productSlug", "isReadyMadeProduct", "isMobile", "isEcommerce", "finishKit", "selectedImages", "selectedPrintOption"])
        ])) : se("", !0),
        ae(m(Bu), {
          "data-remove-image-dialog": "",
          "has-cancel-option": "",
          visible: qo.value,
          "cancel-label": U.$t("message.customizer.buttons.cancel"),
          "confirm-label": U.$t("message.customizer.carousel.image.confirmLabel"),
          icon: !1,
          onConfirm: te[42] || (te[42] = (oe) => {
            vx(), qo.value = !1;
          }),
          onCancel: te[43] || (te[43] = (oe) => qo.value = !1)
        }, {
          default: Se(() => [
            _("p", gA, he(U.$t("message.customizer.carousel.image.confirmRemove")), 1)
          ]),
          _: 1
        }, 8, ["visible", "cancel-label", "confirm-label"])
      ], 64);
    };
  }
});
const xA = {
  sizes: (r) => r.sizes,
  suggestedSizes: (r) => r.suggestedSizes,
  filteredSuggestedSizes: (r, e) => r.suggestedSizes ? r.suggestedSizes.reduce((t, n) => {
    let i = r.sizes;
    if (i[n]) {
      const s = parseInt(i[n].width), a = parseInt(i[n].height), o = Math.max(s, a), l = Math.min(s, a), c = o <= e.minMaxDimensions.higherMaxSize && l <= e.minMaxDimensions.lowerMaxSize, u = l >= e.minMaxDimensions.minSize;
      e.minMaxDimensions ? c && u && (t[n] = i[n]) : t[n] = i[n];
    }
    return t;
  }, {}) : null,
  mats: (r, e, t, n) => {
    let i = r.mats;
    return i && (i = hm(i, n["product/finishedInnerWidth"], n["product/finishedInnerHeight"])), i;
  },
  allMats: (r, e, t, n) => r.mats,
  frames: (r) => r.frames,
  canvasDepths: (r) => r.canvasDepths,
  stretchFees: (r) => r.stretchFees,
  assemblyFees: (r, e, t, n) => n["product/productSlug"] === jr ? e.stretchFees : r.assemblyFees ? r.assemblyFees : [],
  finishKits: (r, e, t, n) => {
    let i = r.finishKits;
    return i && (i = Object.fromEntries(
      Object.entries(i).sort((s, a) => s[1].foreignPrice - a[1].foreignPrice).filter((s) => n["product/includePrint"] && r.finishKits ? !s.includes("NOFK") : !0)
    )), i;
  },
  liners: (r) => r.liners,
  matBorders: (r) => r.matBorders,
  substrateTypes: (r) => r.substrateTypes,
  alternativeProperties: (r) => r.alternativeProperties,
  paperAdditionalWhiteBorders: (r) => r.paperAdditionalWhiteBorders,
  paperAdditionalWhiteBorderInches: (r, e, t, n) => fm(e.paperAdditionalWhiteBorders, n["product/paperAdditionalWhiteBorder"]),
  supportedProducts: (r) => r.supportedProducts,
  supportsAllProducts: (r) => r.supportedProducts && r.supportedProducts.includes(On) && r.supportedProducts.includes(jr),
  totalMatPrice: (r, e, t, n) => {
    var p, x, T, v;
    let i = 0, s = 0, a = 0;
    const o = n["product/width"] || 0, l = n["product/height"] || 0, c = e.paperAdditionalWhiteBorderInches, u = n["product/topMatWidth"] || 0;
    let f = 0;
    if (e.mats && n["product/bottomMat"] && n["product/bottomMatWidth"]) {
      const w = ((p = e == null ? void 0 : e.mats[n["product/bottomMat"]]) == null ? void 0 : p.foreignPrice) || 0, E = ((x = e == null ? void 0 : e.mats[n["product/bottomMat"]]) == null ? void 0 : x.additionalFee) || 0;
      let C = n["product/totalMatWidth"];
      f = ou(
        o,
        l,
        C,
        C,
        C,
        C,
        c
      ), i = lh(w, f, E);
    }
    if (e.mats && n["product/topMat"] && n["product/topMatWidth"]) {
      const w = ((T = e == null ? void 0 : e.mats[n["product/topMat"]]) == null ? void 0 : T.foreignPrice) || 0, E = ((v = e == null ? void 0 : e.mats[n["product/topMat"]]) == null ? void 0 : v.additionalFee) || 0;
      f = ou(
        o,
        l,
        u,
        u,
        u,
        u,
        c
      ), a = lh(w, f, E);
    }
    return i + s + a;
  },
  totalFramePrice: (r, e, t, n) => f8(e.sizes, n["product/size"], n["product/frame"]),
  totalSubstratePrice: (r, e, t, n) => n["product/productSlug"] === _o || n["product/productSlug"] === Eo ? g8(n["product/size"], e.substrateTypes, n["product/substrateType"]) : m8(n["product/width"], n["product/height"], n["product/canvasDepth"], n["product/paperAdditionalWhiteBorderInches"], e.substrateTypes, n["product/substrateType"]),
  totalCanvasDepthPrice: (r, e, t, n) => p8(e.sizes, n["product/size"], n["product/canvasDepth"], n["product/substrateType"]),
  assemblyFee: (r, e, t, n) => {
    let i = 0;
    const s = n["product/totalMatWidth"];
    if (n["product/substrateType"] && e.assemblyFees.length > 0) {
      const a = ou(n["product/width"], n["product/height"], s, s, s, s, n["product/paperAdditionalWhiteBorderInches"]);
      i = x8(a, e.assemblyFees);
    }
    return i;
  },
  totalFinishKitPrice: (r, e, t, n) => n["product/finishKit"] ? n["product/productSlug"] === nn ? e.sizes[n["product/size"]].finishKits[n["product/finishKit"]].foreignPrice : n["product/productSlug"] === ks ? d8(
    n["product/size"],
    e.finishKits,
    n["product/finishKit"]
  ) : u8(
    n["product/finishedInnerWidth"],
    n["product/finishedInnerHeight"],
    e.finishKits,
    n["product/finishKit"]
  ) : 0,
  totalPrice: (r, e) => e.totalFramePrice + e.totalSubstratePrice + e.totalCanvasDepthPrice + e.assemblyFee + e.floatFrameAssemblyFee + e.totalMatPrice + e.totalFinishKitPrice,
  canvasEdges: (r) => r.canvasEdges,
  customSizes: (r) => r.customSizes,
  collections: (r) => r.collections,
  // discountFactor: (state: any,  getters: any) => getters.couponAmount ? ((100 - getters.couponAmount) / 100) : 1,
  customPriceLoading: (r) => r.customPriceLoading,
  suggestedPriceLoading: (r) => r.suggestedPriceLoading,
  frameLoading: (r) => r.frameLoading,
  addingToCart: (r) => r.addingToCart,
  minMaxDimensions: (r, e, t, n) => {
    if (n["product/productSlug"] !== nn) {
      let i = null;
      n["product/images"] && !(n["product/frame"] && !n["product/includePrint"]) && (i = e.suggestedSizeMaxDimensions);
      let s = null, a = 8;
      return (n["product/productSlug"] === jr && !n["product/frame"] || n["product/productSlug"] === jr && n["product/frame"] && n["product/includePrint"]) && (s = a), b8(
        e.customSizes,
        e.frames,
        n["product/frame"],
        n["product/imageResolution"],
        e.substrateTypes,
        n["product/substrateType"],
        e.finishKits,
        n["product/finishKit"],
        i,
        s
      );
    } else
      return null;
  },
  imageTooSmallForSelectedSize: (r, e, t, n) => {
    if (e.suggestedSizeMaxDimensions && n["product/includePrint"] && n["product/images"]) {
      let i = e.suggestedSizeMaxDimensions.higherMax;
      if (n["product/width"] > i || n["product/height"] > i)
        return !0;
    }
    return !1;
  },
  allowedCustomWholeHeights: (r, e, t, n) => n["product/productSlug"] !== nn ? ch(e.minMaxDimensions, n["product/wholeHeight"], n["product/wholeWidth"], n["product/fractionalHeight"], n["product/isFrameOnly"]) : null,
  allowedCustomWholeWidths: (r, e, t, n) => n["product/productSlug"] !== nn ? ch(e.minMaxDimensions, n["product/wholeWidth"], n["product/wholeHeight"], n["product/fractionalWidth"], n["product/isFrameOnly"]) : null,
  enableCustomFractionalHeights: (r, e, t, n) => n["product/productSlug"] !== nn ? uh(e.minMaxDimensions, n["product/height"], n["product/width"], n["product/isFrameOnly"]) : !1,
  enableCustomFractionalWidths: (r, e, t, n) => n["product/productSlug"] !== nn ? uh(e.minMaxDimensions, n["product/width"], n["product/height"], n["product/isFrameOnly"]) : !1,
  floatFrameAssemblyFee: (r, e, t, n) => n["product/frame"] && n["product/productSlug"] === jr && n["product/substrateType"] ? r.floatFrameAssemblyFee : 0,
  invalidAttributeError: (r, e, t, n) => {
    let i = "";
    const s = n["product/bottomMat"] && !e.mats[n["product/bottomMat"]], a = n["product/topMat"] && !e.mats[n["product/topMat"]];
    if (e.mats && (Object.keys(e.mats).length === 0 || s || a) && (n["product/bottomMat"] && (i += '<p>Selected size too large for inner mat, resize, or select "No mat"</p>'), n["product/topMat"] && (i += '<p>Selected size too large for outer mat, resize or select "No mat"</p>')), e.finishKits && n["product/finishKit"]) {
      const o = e.finishKits[n["product/finishKit"]];
      o && (Pn(n["product/finishedInnerWidth"], n["product/finishedInnerHeight"], o) || (i += "<p>Selected size too large for finish kit, resize or pick a different finish kit.</p>"));
    }
    if (e.substrateTypes && n["product/substrateType"]) {
      const o = e.substrateTypes[n["product/substrateType"]];
      o && (Pn(n["product/finishedInnerWidth"], n["product/finishedInnerHeight"], o) || (i += "<p>Selected size too large for canvas type, resize or pick a different canvas type.</p>"));
    }
    return e.sizeImageError && (i += e.sizeImageError), e.imageTooSmallForSelectedSize && (i += e.imageTooSmallForSelectedSize), i;
  },
  topMatError: (r, e, t, n) => {
    let i = "";
    const s = n["product/topMat"] && !e.mats[n["product/topMat"]];
    return e.mats && (Object.keys(e.mats).length === 0 || s) && n["product/topMat"] && (i += '<p>Selected size too large for outer mat, resize or select "No mat"</p>'), i;
  },
  bottomMatError: (r, e, t, n) => {
    let i = "";
    const s = n["product/bottomMat"] && !e.mats[n["product/bottomMat"]];
    return e.mats && (Object.keys(e.mats).length === 0 || s) && n["product/bottomMat"] && (i += '<p>Selected size too large for inner mat, resize, or select "No mat"</p>'), i;
  },
  finishKitError: (r, e, t, n) => {
    let i = "";
    if (e.finishKits && n["product/finishKit"]) {
      const s = e.finishKits[n["product/finishKit"]];
      s && (Pn(n["product/finishedInnerWidth"], n["product/finishedInnerHeight"], s) || (i += "<p>Selected size too large for finish kit, resize or pick a different finish kit.</p>"));
    }
    return i;
  },
  substrateTypeError: (r, e, t, n) => {
    let i = "";
    if (e.substrateTypes && n["product/substrateType"]) {
      const s = e.substrateTypes[n["product/substrateType"]];
      s && (Pn(n["product/finishedInnerWidth"], n["product/finishedInnerHeight"], s) || (i += "<p>Selected size too large for canvas type, resize or pick a different canvas type.</p>"));
    }
    return i;
  },
  sizeImageError: (r, e, t, n) => {
    let i = "", s = n["product/size"];
    const a = parseFloat(s.split("|")[0]), o = parseFloat(s.split("|")[1]), l = Math.max(a, o), c = Math.min(a, o);
    return n["product/productSlug"] !== nn && (l <= e.minMaxDimensions.higherMaxSize && c <= e.minMaxDimensions.lowerMaxSize || (i += "<p>Selected size too large for uploaded image, pick a smaller size</p>")), i;
  },
  canvasData: (r) => r.canvasData,
  orderId: (r) => r.orderId,
  productMedia: (r) => r.productMedia,
  error: (r) => r.error,
  isEcommerce: (r) => r.isEcommerce,
  snapshot: (r) => r.snapshot,
  suggestedSizeMaxDimensions: (r) => r.suggestedSizeMaxDimensions,
  featureFlags: (r) => r.featureFlags ? r.featureFlags : {},
  isSingleMatCompatible: (r, e, t, n) => e.mats ? uo(
    2,
    2,
    n["product/width"],
    n["product/height"],
    n["product/productSlug"],
    n["product/paperAdditionalWhiteBorderInches"],
    e.mats,
    e.frames[n["product/frame"]]
  ).hasMats : !1,
  isDoubleMatCompatible: (r, e, t, n) => e.mats ? uo(
    2.25,
    2.25,
    n["product/width"],
    n["product/height"],
    n["product/productSlug"],
    n["product/paperAdditionalWhiteBorderInches"],
    e.mats,
    e.frames[n["product/frame"]]
  ).hasMats : !1,
  sizeStateIsDirty: (r) => r.sizeStateIsDirty,
  renderToken: (r) => r.renderToken
}, Dm = "CUSTOMIZER_SET_DATA", Fm = "CUSTOMIZER_STORE_CANVAS_DATA", Bm = "CUSTOMIZER_STORE_PAPER_DATA", El = "CUSTOMIZER_SET_SIZES", Qu = "CUSTOMIZER_SET_FRAMES", jm = "CUSTOMIZER_START_CUSTOM_PRICE_LOADING", Um = "CUSTOMIZER_STOP_CUSTOM_PRICE_LOADING", zm = "CUSTOMIZER_START_SUGGESTED_PRICE_LOADING", Wm = "CUSTOMIZER_STOP_SUGGESTED_PRICE_LOADING", Hm = "CUSTOMIZER_START_FRAME_LOADING", Vm = "CUSTOMIZER_STOP_FRAME_LOADING", no = "CUSTOMIZER_SET_ADDING_TO_CART", $m = "CUSTOMIZER_SET_SUPPORTED_PRODUCTS", Gm = "CUSTOMIZER_SET_ALTERNATIVE_PROPERTIES", Km = "CUSTOMIZER_SET_SUBSTRATE_TYPES", Ym = "CUSTOMIZER_SET_ORDER_ID", ed = "CUSTOMIZER_SET_PRODUCT_MEDIA", td = "CUSTOMIZER_SET_SUGGESTED_SIZES", qm = "CUSTOMIZER_SET_SUGGESTED_SIZE_MAX_DIMENSIONS", ns = "CUSTOMIZER_SET_ERROR", Zm = "CUSTOMIZER_SET_IS_ECOMMERCE", Jm = "CUSTOMIZER_SET_SNAPSHOT", Xm = "CUSTOMIZER_REVERT_TO_SNAPSHOT", Qm = "CUSTOMIZER_SET_FEATURE_FLAGS", eg = "CUSTOMIZER_SET_SIZE_DIRTY_STATE", tg = "CUSTOMIZER_SET_RENDER_TOKEN", la = "errorAPI", bA = {
  // @ts-ignore
  async getProduct({ commit: r, dispatch: e, getters: t, rootGetters: n }, i) {
    try {
      let s = null;
      t.orderId ? s = await uy(
        i.code,
        n["product/width"],
        n["product/height"],
        t.orderId,
        i.frame
      ) : s = await cy(i.code, i.frame);
      let a = s.data;
      e("setData", a), n["product/productSlug"] !== nn && e("storeAlternativeProperties", a);
    } catch (s) {
      r(ns, la), console.error(s);
    }
  },
  // @ts-ignore
  async getLineitem({ commit: r, dispatch: e, getters: t, rootState: n, rootGetters: i }, s) {
    try {
      let a = null;
      t.orderId ? a = await fy(t.orderId, s) : a = await dy(s);
      let o = v8(a.data);
      o.maxDimensions && e("setSuggestedSizeMaxDimensions", o.maxDimensions), e("setDirtyState", !0), e("setData", o), e("storeAlternativeProperties", a.data), o.productData.options[Hn] ? o.productData.productSlug === On ? e("product/setPrintOption", ba, { root: !0 }) : o.productData.productSlug === jr && e("product/setPrintOption", Fl, { root: !0 }) : e("product/setPrintOption", Cr, { root: !0 });
    } catch {
      window.location.assign("/404");
    }
  },
  // @ts-ignore
  setDirtyState({ commit: r }, e) {
    r(eg, e);
  },
  // @ts-ignore
  setData({ commit: r, dispatch: e }, t) {
    r(Dm, t), e("product/setProductData", t.productData, { root: !0 });
  },
  // @ts-ignore
  async cartAdd({ commit: r, dispatch: e, getters: t, rootState: n, rootGetters: i }, s) {
    r(no, !0);
    let a = JSON.parse(JSON.stringify(n.product));
    a.uploadLater = !!a.includePrint, a.note = null, a.version = 1;
    const o = i["product/options"][Fr] ? i["product/options"][Fr] : 0;
    i["product/options"][kn] && i["product/options"][kn];
    const l = i["product/options"][Dr] ? i["product/options"][Dr] : 0;
    if (i["product/options"][Fr]) {
      const c = l + o;
      a.options[Fr] = sl(c);
    }
    i["product/options"][Dr] && (a.options[Dr] = sl(l)), !i["product/options"][Hn] && a.svg && i["product/frame"] && (a.svg = null);
    try {
      let c = null;
      t.orderId ? (c = await ay(a, t.orderId), c.status === 201 && window.location.assign("/orders/view/id/" + t.orderId)) : (c = await sy(a), c.status === 201 && window.location.assign("/cart"));
    } catch {
      r(ns, la), r(no, !1);
    }
  },
  // @ts-ignore
  async cartUpdate({ commit: r, dispatch: e, getters: t, rootState: n, rootGetters: i }, s) {
    r(no, !0);
    let a = JSON.parse(JSON.stringify(n.product));
    a.uploadLater = !!a.includePrint, a.note = null, a.version = 1;
    const o = i["product/options"][Fr] ? i["product/options"][Fr] : 0;
    i["product/options"][kn] && i["product/options"][kn];
    const l = i["product/options"][Dr] ? i["product/options"][Dr] : 0;
    if (i["product/options"][Fr]) {
      const c = l + o;
      a.options[Fr] = sl(c);
    }
    i["product/options"][Dr] && (a.options[Dr] = sl(l)), !i["product/options"][Hn] && a.svg && i["product/frame"] && (a.svg = null);
    try {
      let c = null;
      t.orderId ? (c = await ly(a, t.orderId), c.status === 204 && window.location.assign("/orders/view/id/" + t.orderId)) : (c = await oy(a), c.status === 204 && window.location.assign("/cart"));
    } catch {
      r(ns, la), r(no, !1);
    }
  },
  // @ts-ignore
  async getCustomSize({ commit: r, dispatch: e, getters: t, rootState: n, rootGetters: i }, s) {
    let { width: a, height: o, updateSize: l, refreshSuggestedSizePricing: c } = s;
    r(c ? zm : jm), a || (a = i["product/width"]), o || (o = i["product/height"]);
    const u = `${a}|${o}`, f = i["product/totalMatWidth"] ? i["product/totalMatWidth"] : 0, p = Ma(a, i["product/productSlug"], f, f, i["customizer/paperAdditionalWhiteBorderInches"]), x = Ma(o, i["product/productSlug"], f, f, i["customizer/paperAdditionalWhiteBorderInches"]);
    try {
      let T = null;
      t.orderId ? T = await my(
        i["product/productSlug"],
        p,
        x,
        t.orderId,
        i["product/frame"]
      ) : T = await py(
        i["product/productSlug"],
        p,
        x,
        i["product/frame"]
      );
      let v = T.data;
      v.label = a + '" x ' + o + '"', r(El, { [u]: v }), l === !0 && e("product/setSize", u, { root: !0 }), r(c ? Wm : Um);
    } catch {
      r(ns, la);
    }
  },
  // @ts-ignore
  async getCollectionFrames({ commit: r, dispatch: e, rootGetters: t }, n) {
    try {
      r(Hm);
      const { code: i, collection: s, width: a, height: o } = n, c = (await gy(i, s, a, o)).data, u = c.collection, f = c.sizes, p = c.supportedProducts;
      r(Qu, u), r(El, f), r($m, p);
      const x = Object.keys(u)[0];
      r(ed, u[x].media), e("product/setFrame", x, { root: !0 }), r(Vm);
    } catch (i) {
      r(ns, la), console.error(i);
    }
  },
  // @ts-ignore
  storeAlternativeProperties({ commit: r, dispatch: e, getters: t }, n) {
    var i;
    if (t.supportsAllProducts) {
      let s = null;
      if (n.productData.productCode === On ? (s = jr, n[s] && r(Fm, n[s])) : (s = On, n[s] && r(Bm, n[s])), n[s]) {
        let a = {
          productOptions: (i = n[s].productData) == null ? void 0 : i.options,
          substrateTypes: n[s].substrateTypes,
          edges: n[s].edges,
          sizes: n[s].sizes
        };
        e("setAlternativeProperties", a);
      }
    }
  },
  // @ts-ignore
  setAlternativeProperties({ commit: r }, e) {
    r(Gm, e);
  },
  // @ts-ignore
  setSubstrateTypes({ commit: r }, e) {
    r(Km, e);
  },
  // @ts-ignore
  setSizes({ commit: r }, e) {
    r(El, e);
  },
  // @ts-ignore
  setOrderId({ commit: r, dispatch: e }, t) {
    r(Ym, t);
  },
  // @ts-ignore
  setFrames({ commit: r, dispatch: e }, t) {
    r(Qu, t);
  },
  // @ts-ignore
  setProductMedia({ commit: r, dispatch: e }, t) {
    r(ed, t);
  },
  // @ts-ignore
  setSuggestedSizes({ commit: r, dispatch: e }, t) {
    r(td, t);
  },
  // @ts-ignore
  setSuggestedSizeMaxDimensions({ commit: r }, e) {
    const t = [parseInt(e.split("|")[0], 10), parseInt(e.split("|")[1], 10)];
    let n = Math.max(...t);
    r(qm, {
      lowerMax: n,
      //TODO: for now, allowing user to transcend aspect ratio for custom sizes
      higherMax: n
    });
  },
  // @ts-ignore
  resetMessages({ commit: r }) {
    r(ns, null);
  },
  // @ts-ignore
  setError({ commit: r }, e) {
    r(ns, e);
  },
  // @ts-ignore
  setIsEcommerce({ commit: r }, e) {
    r(Zm, e);
  },
  // @ts-ignore
  setSnapshot({ commit: r, state: e }) {
    let t = Object.assign({}, e);
    delete t.snapshot, r(Jm, t);
  },
  // @ts-ignore
  setFeatureFlags({ commit: r }, e) {
    r(Qm, e);
  },
  // @ts-ignore
  async revertToSnapshot({ commit: r, state: e, getters: t }) {
    let n = e.snapshot;
    n && (n.suggestedPriceLoading = t.suggestedPriceLoading, n.customPriceLoading = t.customPriceLoading, n.frameLoading = t.frameLoading, r(Xm, n));
  },
  // @ts-ignore
  flipSuggestedSizes({ commit: r, getters: e }) {
    let t = e.suggestedSizes, n = [];
    for (let i = 0; i < t.length; i++) {
      const s = parseInt(t[i].split("|")[0], 10), a = parseInt(t[i].split("|")[1], 10);
      n.push(a + "|" + s);
    }
    r(td, n);
  },
  // @ts-ignore
  setRenderToken({ commit: r }, e) {
    r(tg, e);
  }
}, vA = {
  [Dm](r, e) {
    r.sizes = e.sizes, r.suggestedSizes = e.suggestedSizes, r.mats = e.mats, r.frames = e.frames, r.finishKits = e.finishKits, r.liners = e.liners, r.matBorders = e.bottomMatBorders, r.substrateTypes = e.substrateTypes, r.paperAdditionalWhiteBorders = e.paperAdditionalWhiteBorders, r.supportedProducts = e.supportedProducts, r.canvasDepths = e.canvasDepths, r.canvasEdges = e.edges, r.customSizes = e.customSizes, r.floatFrameAssemblyFee = e.floatFrameAssemblyFee, r.collections = e.frameCollections, e.assemblyFees ? r.assemblyFees = e.assemblyFees : r.stretchFees = e.stretchFees;
  },
  [Fm](r, e) {
    r.canvasDepths = e.canvasDepths, r.canvasEdges = e.edges, r.floatFrameAssemblyFee = e.floatFrameAssemblyFee, r.collections = e.frameCollections, r.stretchFees = e.stretchFees;
  },
  [Bm](r, e) {
    r.mats = e.mats, r.frames = e.frames, r.finishKits = e.finishKits, r.liners = e.liners, r.matBorders = e.bottomMatBorders, r.assemblyFees = e.assemblyFees, r.paperAdditionalWhiteBorders = e.paperAdditionalWhiteBorders;
  },
  [El](r, e) {
    r.sizes = Object.assign({}, r.sizes, e);
  },
  [jm](r) {
    r.customPriceLoading += 1;
  },
  [Um](r) {
    r.customPriceLoading -= 1;
  },
  [zm](r) {
    r.suggestedPriceLoading += 1;
  },
  [Wm](r) {
    r.suggestedPriceLoading -= 1;
  },
  [Hm](r) {
    r.frameLoading += 1;
  },
  [Vm](r) {
    r.frameLoading -= 1;
  },
  [Qu](r, e) {
    r.frames = e;
  },
  [no](r, e) {
    r.addingToCart = e;
  },
  [$m](r, e) {
    r.supportedProducts = e;
  },
  [Gm](r, e) {
    r.alternativeProperties = e;
  },
  [Km](r, e) {
    r.substrateTypes = e;
  },
  [Ym](r, e) {
    r.orderId = e;
  },
  [ed](r, e) {
    r.productMedia = e;
  },
  [td](r, e) {
    r.suggestedSizes = e;
  },
  [qm](r, e) {
    r.suggestedSizeMaxDimensions = e;
  },
  [ns](r, e) {
    r.error = e;
  },
  [Zm](r, e) {
    r.isEcommerce = e;
  },
  [Jm](r, e) {
    r.snapshot = e;
  },
  [Qm](r, e) {
    r.featureFlags = e;
  },
  [Xm](r, e) {
    Object.assign(r, e);
  },
  [eg](r, e) {
    r.sizeStateIsDirty = e;
  },
  [tg](r, e) {
    r.renderToken = e;
  }
}, yA = () => ({
  customPriceLoading: 0,
  suggestedPriceLoading: 0,
  frameLoading: 0
}), wA = Object.assign({}, yA()), _A = {
  namespaced: !0,
  state: wA,
  getters: xA,
  actions: bA,
  mutations: vA
}, EA = {
  productSlug: (r) => r.productSlug,
  size: (r) => r.size,
  canvasIncompatibleSize: (r) => r.canvasIncompatibleSize,
  images: (r) => r.images,
  collection: (r, e, t, n) => r.options[oo] ? n["customizer/frames"][r.options[oo]].collectionSlug : null,
  frame: (r) => r.options[oo],
  finishKit: (r) => r.options[af],
  quantity: (r) => r.quantity,
  options: (r) => r.options,
  svg: (r) => r.svg,
  bottomMat: (r) => r.options[co] ?? null,
  middleMat: (r) => r.options[ha],
  topMat: (r) => r.options[lo],
  bottomMatWidth: (r) => r.options[Fr] ?? 0,
  middleMatWidth: (r) => r.options[kn] ?? 0,
  topMatWidth: (r) => r.options[Dr] ?? 0,
  totalMatWidth: (r, e) => e.bottomMatWidth + e.topMatWidth,
  includePrint: (r) => !!r.options[Hn],
  substrateType: (r) => r.options[Wl],
  paperAdditionalWhiteBorder: (r) => r.options[of],
  canvasDepth: (r, e, t, n) => e.frame && n["customizer/frames"][e.frame].canvasDepthSlug ? n["customizer/frames"][e.frame].canvasDepthSlug : r.options[lf],
  liner: (r) => r.options[dm],
  edge: (r) => r.options[zl],
  matType: (r) => r.matType,
  snapshot: (r) => r.snapshot,
  width: (r) => r.size ? parseFloat(r.size.split("|")[0]) : 0,
  height: (r) => r.size ? parseFloat(r.size.split("|")[1]) : 0,
  wholeWidth: (r, e) => {
    if (e.width) {
      const t = e.width.toString();
      return t.includes(".") ? parseInt(t.split(".")[0]) : e.width;
    }
  },
  fractionalWidth: (r, e) => {
    if (e.width) {
      const t = e.width.toString();
      return t.includes(".") ? parseFloat("0." + t.split(".")[1]) : 0;
    }
  },
  wholeHeight: (r, e) => {
    if (e.height) {
      const t = e.height.toString();
      return t.includes(".") ? parseInt(t.split(".")[0]) : e.height;
    }
  },
  fractionalHeight: (r, e) => {
    if (e.height) {
      const t = e.height.toString();
      return t.includes(".") ? parseFloat("0." + t.split(".")[1]) : 0;
    }
  },
  lineitemId: (r) => r.lineitemId,
  moulding: (r, e, t, n) => e.frame && n["customizer/frames"][e.frame] ? n["customizer/frames"][e.frame].frameWidth : 0,
  rabbetLipWidth: (r, e, t, n) => e.frame && n["customizer/frames"][e.frame] && n["customizer/frames"][e.frame].rabbetLipWidth && (e.productSlug === On || e.productSlug === nn || e.productSlug === jr) ? n["customizer/frames"][e.frame].rabbetLipWidth : 0,
  paperAdditionalWhiteBorderInches: (r, e, t, n) => fm(n["customizer/paperAdditionalWhiteBorders"], e.paperAdditionalWhiteBorder),
  finishedInnerWidth: (r, e) => Ma(e.width, e.productSlug, e.totalMatWidth, e.totalMatWidth, e.paperAdditionalWhiteBorderInches),
  finishedInnerHeight: (r, e) => Ma(e.height, e.productSlug, e.totalMatWidth, e.totalMatWidth, e.paperAdditionalWhiteBorderInches),
  finishedWidth: (r, e) => us(e.finishedInnerWidth + e.moulding * 2 - e.rabbetLipWidth * 2),
  finishedFractionWidth: (r, e) => {
    const t = e.finishedWidth;
    return dh(t);
  },
  finishedHeight: (r, e) => us(e.finishedInnerHeight + e.moulding * 2 - e.rabbetLipWidth * 2),
  finishedFractionHeight: (r, e) => {
    const t = e.finishedHeight;
    return dh(t);
  },
  imageResolution: (r) => r.imageResolution,
  alternativeProductOptions: (r) => r.alternativeProductOptions,
  imageUploadLoading: (r) => r.imageUploadLoading,
  substrateOnlyProduct: (r) => r.productSlug === _o || r.productSlug === Eo || r.productSlug === ks || r.productSlug === Aa,
  printOption: (r) => r.printOption,
  isFrameOnly: (r, e) => e.printOption === Cr && e.frame,
  renderToken: (r) => r.renderToken
}, Al = "PRODUCT_SET_SIZE", rd = "PRODUCT_SET_FRAME", nd = "PRODUCT_SET_FINISH_KIT", id = "PRODUCT_SET_SVG", sd = "PRODUCT_SET_PRODUCT_CODE", ad = "PRODUCT_SET_MAT_BOTTOM", od = "PRODUCT_SET_MAT_MIDDLE", ld = "PRODUCT_SET_MAT_TOP", cd = "PRODUCT_SET_MAT_WIDTH_BOTTOM", ud = "PRODUCT_SET_MAT_WIDTH_MIDDLE", dd = "PRODUCT_SET_MAT_WIDTH_TOP", rg = "PRODUCT_SET_LINER", ca = "PRODUCT_SET_MAT_TYPE", ng = "PRODUCT_SET_SNAPSHOT", ig = "PRODUCT_REVERT_TO_SNAPSHOT", sg = "PRODUCT_SET_IMAGE", ag = "PRODUCT_SET_IMAGES", Sl = "PRODUCT_SET_INCLUDE_PRINT", fd = "PRODUCT_SET_SUBSTRATE_TYPE", hd = "PRODUCT_SET_PAPER_ADDITIONAL_WHITE_BORDER", AA = "PRODUCT_SET_MATERIAL", og = "PRODUCT_SET_LINEITEM_ID", pd = "PRODUCT_SET_EDGE", md = "PRODUCT_SET_CANVAS_DEPTH", lg = "PRODUCT_SET_TRANSFORMS", gd = "PRODUCT_SET_IMAGE_RESOLUTION", SA = "PRODUCT_SET_ALTERNATIVE_PRODUCT_OPTIONS", xd = "PRODUCT_SET_QUANTITY", cg = "PRODUCT_START_IMAGE_UPLOAD_LOADING", ug = "PRODUCT_STOP_IMAGE_UPLOAD_LOADING", dg = "PRODUCT_SET_ROTATE", bd = "PRODUCT_SET_PRINT_OPTION", vd = "PRODUCT_SET_CANVAS_INCOMPATIBLE_SIZE", TA = {
  setProductData({ commit: r, dispatch: e }, t) {
    r(Al, t.size), r(sd, t.productSlug), r(xd, t.quantity);
    let n = JSON.parse(JSON.stringify(t.options));
    if (n.initial = !0, e("setProductOptions", n), t.images) {
      const i = l4(t.images);
      r(ag, i), r(gd, t.imageResolution);
    }
    t.svg && (r(id, t.svg), e("setTransforms", t.svg)), t.lineitemId && r(og, t.lineitemId);
  },
  setProductOptions({ commit: r, dispatch: e }, t) {
    r(rd, t[oo]), r(nd, t[af]), r(ad, t[co]), r(od, t[ha]), r(ld, t[lo]), r(pd, t[zl]), r(Sl, t[Hn]), r(fd, t[Wl]), r(hd, t[of]), r(md, t[lf]), t[Hn] && r(Sl, t[Hn]), t[co] || r(ca, ru), t[co] && !t[ha] && !t[lo] && r(ca, nu), t[lo] && !t[ha] && r(ca, iu), t[ha] && r(ca, su);
    let n = t[Fr] ? t[Fr] : null, i = t[kn] ? t[kn] : null, s = t[Dr] ? t[Dr] : null;
    r(cd, s && t.initial ? n - s : n), r(ud, i), r(dd, s), n && e("updateFilteredSuggestedSizes");
  },
  setSize({ commit: r }, e) {
    r(Al, e);
  },
  setFrame({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    r(rd, i);
    let s = t["customizer/productMedia"];
    if (s) {
      const o = t["customizer/frames"][i];
      if (t["customizer/isEcommerce"] === !0)
        for (const l in s)
          l !== Object.keys(s)[0] && delete s[l];
      s[Object.keys(s)[0]].altText = o.thumbAltText, s[Object.keys(s)[0]].path = o.thumbPath, n("customizer/setProductMedia", s, { root: !0 });
    }
    if (e.productSlug === nn) {
      const o = t["customizer/frames"][i].defaultSize;
      n("setSize", o);
    }
    const a = new CustomEvent("frameChanged", { detail: { sku: i } });
    window.dispatchEvent(a);
  },
  setFinishKit({ commit: r }, e) {
    r(nd, e);
  },
  setSvg({ commit: r }, e) {
    r(id, e);
  },
  togglePrintOption({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    switch (i) {
      case Cr:
      default:
        n("setIncludePrint", null);
        break;
      case ba:
      case Fl:
        n("setIncludePrint", Pb);
        break;
    }
    n("toggleCanvasCompatibleSize"), r(bd, i);
  },
  toggleProductData({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    let s = ba === i ? On : jr;
    if (e.productSlug !== s) {
      r(sd, s);
      const a = JSON.parse(JSON.stringify(e.options)), o = JSON.parse(JSON.stringify(t["customizer/substrateTypes"])), l = JSON.parse(JSON.stringify(t["customizer/sizes"])), c = t["customizer/alternativeProperties"];
      c.productOptions[Hn] = a[Hn], n("setProductOptions", c.productOptions), n("customizer/setSubstrateTypes", c.substrateTypes, { root: !0 }), n("customizer/setSizes", c.sizes, { root: !0 }), n("customizer/setAlternativeProperties", {
        productOptions: a,
        substrateTypes: o,
        sizes: l
      }, { root: !0 }), a[Hn] && !c.productOptions[Wl] && !c.productOptions[zl] && n("setMaterialDefaults", !0), n("toggleCanvasCompatibleSize"), c.sizes[e.size] || n("customizer/getCustomSize", { width: null, height: null, updateSize: null, refreshSuggestedSizePricing: null }, { root: !0 });
    }
  },
  setBottomMat({ commit: r, getters: e }, t) {
    e.bottomMat !== void 0 && r(ad, t);
  },
  setMiddleMat({ commit: r, getters: e }, t) {
    e.middleMat !== void 0 && r(od, t);
  },
  setTopMat({ commit: r, getters: e }, t) {
    e.topMat !== void 0 && r(ld, t);
  },
  setBottomMatWidth({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    r(cd, i);
  },
  setMiddleMatWidth({ commit: r }, e) {
    r(ud, e);
  },
  setTopMatWidth({ commit: r, dispatch: e }, t) {
    r(dd, t);
  },
  setLiner({ commit: r }, e) {
    r(rg, e);
  },
  setCanvasDepth({ commit: r }, e) {
    r(md, e);
  },
  setEdge({ commit: r }, e) {
    r(pd, e);
  },
  setMatType({ commit: r, dispatch: e }, t) {
    r(ca, t), e("setMatDefaults", t);
  },
  setSnapshot({ commit: r, state: e }) {
    let t = Object.assign({}, e);
    delete t.snapshot, r(ng, t);
  },
  async revertToSnapshot({ commit: r, state: e }) {
    r(ig, e.snapshot);
  },
  async setImage({ commit: r, getters: e, dispatch: t, rootGetters: n }, i) {
    r(cg);
    let s = null;
    if (i && (s = {
      width: i.width,
      height: i.height
    }, n["customizer/sizeStateIsDirty"] || (s.height > s.width && e.width > e.height || s.height < s.width && e.width < e.height) && t("toggleOrientation"), e.productSlug !== nn))
      try {
        const a = await I6(
          e.productSlug,
          s.width,
          s.height,
          e.frame,
          n["customizer/orderId"],
          n["customizer/minMaxDimensions"].minSize,
          n["customizer/minMaxDimensions"].lowerMaxPotentialSize,
          n["customizer/minMaxDimensions"].higherMaxPotentialSize
        );
        if (Object.keys(a.data.sizes).length > 0) {
          let o = a.data.sizes;
          if (Object.entries(a.data.sizes).forEach(([l, c]) => {
            const u = parseInt(l.split("|")[0], 10), f = parseInt(l.split("|")[1], 10), p = f + "|" + u;
            let x = { ...c };
            x.width = f, x.height = u, x.label = y8(c.label), o[p] = x;
          }), t("customizer/setSizes", o, { root: !0 }), t("customizer/setSuggestedSizes", a.data.suggestedSizes, { root: !0 }), t("customizer/setSuggestedSizeMaxDimensions", a.data.maxDimensions, { root: !0 }), !n["customizer/sizeStateIsDirty"]) {
            const l = e.width, c = e.height, u = l * c, f = a.data.suggestedSizes.map(
              (x) => x.split("|")[0] * x.split("|")[1]
            ), p = u4(f, u);
            t("setSize", a.data.suggestedSizes[p]), t("customizer/setDirtyState", !0, { root: !0 });
          }
        }
      } catch {
        t("customizer/setError", la, { root: !0 });
      }
    r(sg, i), r(gd, s), i || t("setSvg", null), r(ug);
  },
  setIncludePrint({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    r(Sl, i), n("setMaterialDefaults", !!i);
  },
  setMaterial({ commit: r }, e) {
    r(AA, e);
  },
  setSubstrateType({ commit: r }, e) {
    r(fd, e);
  },
  setPaperAdditionalWhiteBorder({ commit: r, dispatch: e, getters: t, rootGetters: n }, i) {
    r(hd, i), n["customizer/orderId"] || e("updateFilteredSuggestedSizes");
  },
  setMaterialDefaults({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    const s = i ? Object.values(t["customizer/substrateTypes"])[0].code : null;
    if (n("setSubstrateType", s), e.productSlug === On) {
      const a = i && t["customizer/paperAdditionalWhiteBorders"].length > 0 ? Object.values(t["customizer/paperAdditionalWhiteBorders"])[0].code : null, o = lu(t["customizer/finishKits"]), l = i && o ? Object.values(o)[0].code : "NOFK";
      !e.paperAdditionalWhiteBorder && a && n("setPaperAdditionalWhiteBorder", a), (e.finishKit === "NOFK" || !e.finishKit) && n("setFinishKit", l);
    } else if (e.productSlug === jr) {
      const a = lu(t["customizer/canvasEdges"]), o = i && a ? Object.values(a)[0].code : null, l = e.frame ? null : lu(t["customizer/canvasDepths"]), c = i && l ? Object.values(l)[0].code : null;
      n("setEdge", o), c && n("setCanvasDepth", c);
    }
  },
  updateFilteredSuggestedSizes({ getters: r, rootGetters: e, dispatch: t }) {
    const n = e["customizer/filteredSuggestedSizes"];
    for (const [i, s] of Object.entries(n)) {
      const a = parseInt(i.split("|")[0], 10), o = parseInt(i.split("|")[1], 10);
      r.width !== a && r.height !== o && t(
        "customizer/getCustomSize",
        { width: a, height: o, updateSize: !1, refreshSuggestedSizePricing: !0 },
        { root: !0 }
      );
    }
    t(
      "customizer/getCustomSize",
      { width: r.width, height: r.height, updateSize: !1 },
      { root: !0 }
    );
  },
  setTransforms({ commit: r }, e) {
    let t = o4(e);
    r(lg, t);
  },
  setImageRotate({ getters: r, commit: e }) {
    var i, s;
    let t = 90, n = ((s = (i = r.images.pane_1) == null ? void 0 : i.transform) == null ? void 0 : s.rotate) || 0;
    n !== 270 ? n += t : n = 0, e(dg, n);
  },
  setMatDefaults({ commit: r, rootGetters: e, dispatch: t, getters: n }, i) {
    let s, a, o, l, c;
    switch (i) {
      case ru:
      default:
      case nu:
        s = uo(
          2,
          2,
          n.width,
          n.height,
          n.productSlug,
          n.paperAdditionalWhiteBorderInches,
          e["customizer/mats"]
        ), a = s.hasMats, o = s.firstMat, l = s.whiteMatCompatible;
        break;
      case iu:
        s = uo(
          2.25,
          2.25,
          n.width,
          n.height,
          n.productSlug,
          n.paperAdditionalWhiteBorderInches,
          e["customizer/mats"]
        ), a = s.hasMats, o = s.firstMat, l = s.whiteMatCompatible, c = s.blackMatCompatible;
        break;
      case su:
        s = uo(
          2.5,
          2.5,
          n.width,
          n.height,
          n.productSlug,
          n.paperAdditionalWhiteBorderInches,
          e["customizer/mats"]
        ), a = s.hasMats, o = s.firstMat, l = s.whiteMatCompatible, c = s.blackMatCompatible;
        break;
    }
    switch (i) {
      case ru:
      default:
        t("setBottomMat", null), t("setBottomMatWidth", null), t("setMiddleMat", null), t("setMiddleMatWidth", null), t("setTopMat", null), t("setTopMatWidth", null);
        break;
      case nu:
        a && (l ? t("setBottomMat", ro) : t("setBottomMat", o), t("setBottomMatWidth", 2), t("setMiddleMat", null), t("setMiddleMatWidth", null), t("setTopMat", null), t("setTopMatWidth", null));
        break;
      case iu:
        a && (c ? t("setBottomMat", Wu) : t("setBottomMat", o), t("setBottomMatWidth", 0.25), l ? t("setTopMat", ro) : t("setTopMat", o), t("setMiddleMatWidth", null), t("setMiddleMat", null), t("setTopMatWidth", 2));
        break;
      case su:
        a && (l ? (t("setBottomMat", ro), t("setTopMat", ro)) : (t("setBottomMat", o), t("setTopMat", o)), t("setBottomMatWidth", 2), t("setTopMatWidth", 0.25), c ? t("setMiddleMat", Wu) : t("setMiddleMat", o), t("setMiddleMatWidth", 0.25));
        break;
    }
    t("updateFilteredSuggestedSizes");
  },
  // @ts-ignore
  setQuantity({ commit: r, dispatch: e }, t) {
    r(xd, t);
  },
  // @ts-ignore
  toggleOrientation({ commit: r, getters: e, rootGetters: t, dispatch: n }) {
    const i = e.size, s = parseInt(i.split("|")[0], 10), o = parseInt(i.split("|")[1], 10) + "|" + s;
    t["customizer/sizes"][o] ? r(Al, o) : n(
      "customizer/getCustomSize",
      { width: e.height, height: e.width, updateSize: !0 },
      { root: !0 }
    ), n("customizer/flipSuggestedSizes", null, { root: !0 });
  },
  // @ts-ignore
  setPrintOption({ commit: r, dispatch: e }, t) {
    r(bd, t);
  },
  // @ts-ignore
  toggleCanvasCompatibleSize({ commit: r, getters: e, rootGetters: t, dispatch: n }, i) {
    let s = e.canvasIncompatibleSize, a = 8;
    if (s && !t["customizer/sizeStateIsDirty"]) {
      const o = parseFloat(s.split("|")[0]), l = parseFloat(s.split("|")[1]);
      (o < a || l < a) && (n("setSize", s), r(vd, null));
    }
    if (e.productSlug === jr && e.includePrint && (e.width < a || e.height < a)) {
      const o = w8(e.size, a);
      if (r(vd, e.size), n("customizer/setDirtyState", !1, { root: !0 }), t["customizer/sizes"][o])
        n("setSize", o);
      else {
        const l = parseFloat(o.split("|")[0]), c = parseFloat(o.split("|")[1]);
        n(
          "customizer/getCustomSize",
          { width: l, height: c, updateSize: !0, refreshSuggestedSizePricing: !1 },
          { root: !0 }
        );
      }
    }
  }
}, MA = {
  [Al](r, e) {
    r.size = e;
  },
  [rd](r, e) {
    r.options = Object.assign({}, r.options, {
      [oo]: e
    });
  },
  [nd](r, e) {
    r.options = Object.assign({}, r.options, {
      [af]: e
    });
  },
  [id](r, e) {
    r.svg = e;
  },
  [sd](r, e) {
    r.productSlug = e;
  },
  [ca](r, e) {
    r.matType = e;
  },
  [ad](r, e) {
    r.options = Object.assign({}, r.options, {
      [co]: e
    });
  },
  [od](r, e) {
    r.options = Object.assign({}, r.options, {
      [ha]: e
    });
  },
  [ld](r, e) {
    r.options = Object.assign({}, r.options, {
      [lo]: e
    });
  },
  [cd](r, e) {
    r.options = Object.assign({}, r.options, {
      [Fr]: e
    });
  },
  [ud](r, e) {
    r.options = Object.assign({}, r.options, {
      [kn]: e
    });
  },
  [dd](r, e) {
    r.options = Object.assign({}, r.options, {
      [Dr]: e
    });
  },
  [rg](r, e) {
    r.options = Object.assign({}, r.options, {
      [dm]: e
    });
  },
  [ng](r, e) {
    r.snapshot = e;
  },
  [ig](r, e) {
    Object.assign(r, e);
  },
  [sg](r, e) {
    if (e) {
      let t = { imageId: e.id };
      r.images = { pane_1: Object.assign(e, t) };
    } else
      r.images = null;
  },
  [ag](r, e) {
    r.images = e;
  },
  [Sl](r, e) {
    r.options = Object.assign({}, r.options, {
      [Hn]: e
    });
  },
  [fd](r, e) {
    r.options = Object.assign({}, r.options, {
      [Wl]: e
    });
  },
  [hd](r, e) {
    r.options = Object.assign({}, r.options, {
      [of]: e
    });
  },
  [og](r, e) {
    r.lineitemId = e;
  },
  [pd](r, e) {
    r.options = Object.assign({}, r.options, {
      [zl]: e
    });
  },
  [md](r, e) {
    r.options = Object.assign({}, r.options, {
      [lf]: e
    });
  },
  [lg](r, e) {
    Object.keys(e).forEach((t) => {
      r.images[t] = Object.assign({}, r.images[t], e[t]);
    });
  },
  [gd](r, e) {
    r.imageResolution = e;
  },
  [SA](r, e) {
    r.alternativeProductOptions = e;
  },
  [xd](r, e) {
    r.quantity = e;
  },
  [dg](r, e) {
    r.images && r.images.pane_1 && (r.images.pane_1.transform.rotate = e);
  },
  [cg](r) {
    r.imageUploadLoading += 1;
  },
  [ug](r) {
    r.imageUploadLoading -= 1;
  },
  [bd](r, e) {
    r.printOption = e;
  },
  [vd](r, e) {
    r.canvasIncompatibleSize = e;
  }
}, IA = () => ({
  imageUploadLoading: 0,
  images: null,
  svg: null,
  imageResolution: null,
  options: {},
  printOption: Cr
}), CA = Object.assign({}, IA()), PA = {
  namespaced: !0,
  state: CA,
  getters: EA,
  actions: TA,
  mutations: MA
}, eO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  customizer: _A,
  product: PA
}, Symbol.toStringTag, { value: "Module" }));
class tO {
  constructor(e = am, t = om) {
    this.locale = e, this.currencyCode = t;
  }
  format(e) {
    return new Intl.NumberFormat(this.locale, {
      style: "currency",
      currency: this.currencyCode
    }).format(e);
  }
}
const kA = "warningImageTooSmall", OA = {
  name: "Pane",
  props: {
    image: {
      type: Object,
      default: null,
      validator: (r) => r.hasOwnProperty("width") && r.hasOwnProperty("height") && r.hasOwnProperty("thumbPath") && r.hasOwnProperty("id")
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    x: {
      type: Number,
      required: !0
    },
    y: {
      type: Number,
      required: !0
    },
    events: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: Boolean,
      default: !0
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "pane_1"
    },
    productSlug: {
      type: String,
      required: !0
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    imageEditTrigger: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: uc
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    tileIndex: {
      type: Number,
      default: null
    },
    disableZoomCrop: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    var r, e, t, n, i, s, a, o;
    return {
      hammer: null,
      svgPoint: null,
      panning: !1,
      currentWidth: 100,
      currentHeight: 100,
      currentX: 0,
      currentXStart: 0,
      currentY: 0,
      currentYStart: 0,
      currentTransform: "",
      scaleStart: 1,
      currentRotate: ((e = (r = this.image) == null ? void 0 : r.transform) == null ? void 0 : e.rotate) || 0,
      currentRotateStart: 0,
      currentThumb: "",
      currentOriginal: "",
      currentOriginalWidth: 0,
      currentOriginalHeight: 0,
      currentScale: ((n = (t = this.image) == null ? void 0 : t.transform) == null ? void 0 : n.scale) || 1,
      currentTranslateX: ((s = (i = this.image) == null ? void 0 : i.transform) == null ? void 0 : s.x) || 0,
      currentTranslateY: ((o = (a = this.image) == null ? void 0 : a.transform) == null ? void 0 : o.y) || 0,
      preEditPosition: null,
      minScale: 1,
      maxScale: 50,
      pan: null,
      pinch: null,
      injectedScale: this.imageEdits ? this.imageEdits.scale : null,
      injectedRotate: this.rotate ? this.rotate : null
    };
  },
  inject: {
    imageEdits: {
      default: null
    },
    rotate: {
      default: 0
    },
    disablePaneTap: {
      default: !1
    }
  },
  computed: {
    /**
     * Returns the transform attribute for the SVGImageElement.
     *
     * It clamps the x, y, scale, and rotate values in order to make sure the
     * image can't be positioned too far inside the view.
     *
     * @return {String}
     */
    transform() {
      const r = this.clampImage(), { x: e, y: t, scale: n, rotate: i } = r, s = this.width, a = this.height;
      let o = n.toFixed(4), l = 0, c = 0, u = n.toFixed(4), f = (s / 2 - n * (s / 2)).toFixed(4), p = (a / 2 - n * (a / 2)).toFixed(4);
      const x = `translate(${e} ${t})`, T = `rotate(${i} ${s / 2} ${a / 2})`, v = `matrix(${o} ${l} ${c} ${u} ${f} ${p})`;
      return `${x} ${T} ${v}`;
    },
    isLowRes() {
      return this.image ? d4(this.image.width, this.image.height, this.currentScale, this.currentWidth, this.currentHeight) : !1;
    },
    imageSelectorMultiplicator() {
      return this.productSlug === ep ? 0.25 : 0.5;
    },
    placeHolderText() {
      let r = 1.9, e = 4.5;
      switch (this.locale) {
        case sm:
          r = 1.3, e = 4;
          break;
        case im:
          r = 1.7, e = 4.1;
          break;
      }
      return {
        size: r,
        xPos: e
      };
    },
    enableZoomCrop() {
      var r;
      return this.disableZoomCrop === !0 ? !1 : (r = this.featureFlags) != null && r.enableImageEditor ? this.selectedEditToolId === Os || this.selectedEditToolId === sf : !0;
    },
    useStore() {
      var r;
      return (r = this.featureFlags) == null ? void 0 : r.enableImageEditor;
    },
    isCollageProduct() {
      return this.productSlug === Mb || this.productSlug === Ib;
    },
    paneAriaLabel() {
      let r, e = this.tileIndex + 1;
      return e ? r = "tile " + e + " " + this.name : r = this.name, "Selectable " + r;
    },
    // Image's width and height need to be inverted if rotation is 90 or 270
    // Example, if a landscape image is rotated 90 degrees within a landscape canvas,
    // the images "height" will need to equal the full width of the canvas.
    invertDimensions() {
      if (this.currentRotate === 90 || this.currentRotate === 270)
        return !0;
    }
  },
  /**
   * The component's watched properties.
   *
   * @type {Object}
   */
  watch: {
    injectedScale: function(r) {
      this.setCurrentScale(parseInt(r));
    },
    injectedRotate: function(r) {
      this.setCurrentRotate(parseInt(r)), this.resetImage();
    },
    image: function(r, e) {
      this.resetImage(!0), this.currentScale = this.getImageScale(), this.currentTranslateX = this.getImageTranslateX(), this.currentTranslateY = this.getImageTranslateY();
    },
    width: function(r, e) {
      this.resetImage(!1, e, this.height);
    },
    height: function(r, e) {
      this.resetImage(!1, this.width, e);
    },
    imageEditTrigger: {
      deep: !0,
      handler: function(r) {
        if (r)
          switch (r) {
            case "cancel":
              this.revertImage();
              break;
            case "reset":
              this.resetImage(!0);
              break;
          }
      }
    }
  },
  mounted() {
    this.hammer = new Cs.Manager(this.$el), this.hammer.options.domEvents = !0, this.createSVGPoint();
    const r = new Cs.Tap();
    this.hammer.add(r), this.hammer.on("tap", (n) => this.handleTap()), this.pan = new Cs.Pan({ threshold: 1, pointers: 0 }), this.pinch = new Cs.Pinch({ threshold: 0 }), this.initializePanPinch(), this.$el.addEventListener("touchmove", (n) => {
      this.selectedEditToolId && this.preventEvent(n);
    }, { passive: !1 });
    let e = !1;
    try {
      var t = Object.defineProperty({}, "passive", {
        get: () => {
          e = { passive: !0 };
        }
      });
      window.addEventListener("testPassive", null, t), window.removeEventListener("testPassive", null, t);
    } catch {
    }
    this.$el.addEventListener("wheel", (n) => {
      e || n.preventDefault(), this.handleWheel(n, this.$el);
    }, e), p4(this.getImageThumb()), this.resetImage();
  },
  methods: {
    ...Dp({
      setWarning: "builder/setWarning",
      resetImageTrigger: "image/resetImageTrigger"
    }),
    /**
     * Prevents the default event for dragging the SVG/image, which interferes
     * with the pan handler.
     */
    handleDragStart(r) {
      this.preventEvent(r);
    },
    /**
     * Gets the image's x offset so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageX() {
      return (this.getImageWidth() - this.width) / -2;
    },
    /**
     * Gets the image's y offset so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageY() {
      return (this.getImageHeight() - this.height) / -2;
    },
    /**
     * Gets the image's thumbnail URL.
     *
     * @return {Float}
     */
    getImageThumb() {
      return this.image ? this.image.thumbPath : this.currentThumb;
    },
    /**
     * Gets the image's original URL.
     *
     * @return {Float}
     */
    getImageOriginal() {
      return this.image ? this.image.originalPath : this.currentOriginal;
    },
    /**
     * Gets the image's original width.
     *
     * @return {Float}
     */
    getImageOriginalWidth() {
      return this.image ? this.image.width : this.currentOriginalWidth;
    },
    /**
     * Gets the image's original height.
     *
     * @return {Float}
     */
    getImageOriginalHeight() {
      return this.image ? this.image.height : this.currentOriginalHeight;
    },
    /**
     * Gets the image's width so that it's rendered in the center of the pane.
     *
     * @return {Float}
     */
    getImageWidth() {
      return this.invertDimensions ? this.getImageHeightCalc() : this.getImageWidthCalc();
    },
    getImageWidthCalc() {
      let r = this.width / this.height, e;
      this.invertDimensions ? e = this.image ? this.image.height / this.image.width : this.currentHeight / this.currentWidth : e = this.image ? this.image.width / this.image.height : this.currentWidth / this.currentHeight;
      let t;
      return r >= e ? t = this.width : t = this.width * (e / r), t;
    },
    /**
     * Gets the image's height so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageHeight() {
      return this.invertDimensions ? this.getImageWidthCalc() : this.getImageHeightCalc();
    },
    getImageHeightCalc() {
      let r = this.width / this.height, e;
      this.invertDimensions ? e = this.image ? this.image.height / this.image.width : this.currentHeight / this.currentWidth : e = this.image ? this.image.width / this.image.height : this.currentWidth / this.currentHeight;
      let t;
      return r >= e ? t = this.height / (e / r) : t = this.height, t;
    },
    /**
     * Gets the image's scale.
     *
     * @return {Float}
     */
    getImageScale() {
      return this.image && this.image.transform ? this.image.transform.scale : this.currentScale;
    },
    /**
     * Gets the image's translate X value.
     *
     * @return {Float}
     */
    getImageTranslateX() {
      return this.image && this.image.transform ? this.image.transform.x : this.currentTranslateX;
    },
    /**
     * Gets the image's translate X value.
     *
     * @return {Float}
     */
    getImageTranslateY() {
      return this.image && this.image.transform ? this.image.transform.y : this.currentTranslateX;
    },
    /**
     * Handles taps on the pane.
     *
     * Doesn't use the Hammer tap handler, because it'll fire a different event
     * that interferes with things like the modal background clicks.
     */
    handleTap() {
      this.events && !this.panning && !this.disablePaneTap && this.$emit("click");
    },
    /**
     * Handles the pan event on the image.
     *
     * @param {Event} event
     */
    handlePan(r) {
      if (this.events && this.enableZoomCrop) {
        if (this.panning = !0, r.type === "panstart")
          this.currentXStart = this.currentTranslateX, this.currentYStart = this.currentTranslateY;
        else if (r.type === "panend")
          setTimeout(() => {
            this.panning = !1;
          }, 150);
        else {
          const e = this.getSvgPoints(r.center.x, r.center.y), t = this.getSvgPoints(r.center.x + r.deltaX, r.center.y + r.deltaY);
          let n = this.currentXStart + (t.x - e.x), i = this.currentYStart + (t.y - e.y);
          this.setCurrentTranslateX(n), this.setCurrentTranslateY(i);
        }
        this.preventEvent(r);
      }
    },
    handlePinch(r) {
      if (this.events && this.enableZoomCrop) {
        if (r.type === "pinchstart")
          this.scaleStart = this.currentScale;
        else {
          let e = this.scaleStart * r.scale;
          this.setCurrentScale(this.clampScale(e));
        }
        this.preventEvent(r);
      }
    },
    /**
     * Handles zooming with the mousewheel.
     *
     * @param {Event} event
     */
    handleWheel(r) {
      if (this.events && this.enableZoomCrop) {
        let e = this.currentScale;
        e += e * (-r.deltaY / 200), this.setCurrentScale(this.clampScale(e)), this.imageEdits && (this.imageEdits.scale = this.currentScale), this.preventEvent(r);
      }
    },
    /**
     * Clmaps the image to the boundaries of the pane.
     */
    clampImage() {
      const r = this.width, e = this.height;
      let t = this.currentWidth, n = this.currentHeight;
      this.invertDimensions && (t = this.currentHeight, n = this.currentWidth);
      const i = this.currentScale, s = this.currentRotate;
      let a = this.currentTranslateX, o = this.currentTranslateY, l = (r - t * i) / 2, c = (e - n * i) / 2;
      return a < l && (a = l), a > Math.abs(l) && (a = Math.abs(l)), o < c && (o = c), o > Math.abs(c) && (o = Math.abs(c)), this.setCurrentTranslateX(a), this.setCurrentTranslateY(o), this.setCurrentScale(i), this.setCurrentRotate(s), { x: a, y: o, scale: i, rotate: s };
    },
    /**
     * Resets the used image and clamps it to the canvas boundaries.
     */
    resetImage(r, e, t) {
      let n = this.getImageWidth(), i = this.getImageHeight(), s = this.getImageX(), a = this.getImageY(), o = this.getImageThumb(), l = this.getImageOriginal(), c = this.getImageOriginalWidth(), u = this.getImageOriginalHeight(), f = e > 0 ? this.currentTranslateX / e * this.width : this.getImageTranslateX(), p = t > 0 ? this.currentTranslateY / t * this.height : this.getImageTranslateY();
      this.currentWidth = n, this.currentHeight = i, this.currentX = s, this.currentY = a, this.currentThumb = o, this.currentOriginal = l, this.currentOriginalWidth = c, this.currentOriginalHeight = u, this.setCurrentTranslateX(f), this.setCurrentTranslateY(p), r && (this.setCurrentScale(1), this.setCurrentTranslateX(0), this.setCurrentTranslateY(0), this.currentTransform = "", this.currentRotate = 0);
    },
    /**
     * Reverts image to its pre-edit position
     *
     */
    revertImage() {
      this.preEditPosition && (this.setCurrentScale(this.preEditPosition.scale), this.setCurrentTranslateX(this.preEditPosition.translateX), this.setCurrentTranslateY(this.preEditPosition.translateY), this.preEditPosition = null);
    },
    /**
     * Clamps the scale between a minimum and maximum.
     *
     * @param {Number} scale
     * @return {Number}
     */
    clampScale(r) {
      return Math.min(Math.max(r, this.minScale), this.maxScale);
    },
    /**
     * Gets a point in SVG space.
     *
     * @param {Number} x
     * @param {Number} y
     * @return {matrixTransform}
     */
    getSvgPoints(r, e) {
      return this.svgPoint.x = r, this.svgPoint.y = e, this.svgPoint.matrixTransform(this.$el.getScreenCTM().inverse());
    },
    /**
     * Creates an SVGPoint.
     */
    createSVGPoint() {
      this.svgPoint = this.$el.createSVGPoint ? this.$el.createSVGPoint() : null;
    },
    /**
     * Handles clicking on the warning.
     */
    handleWarningClick() {
      this.setWarning(kA);
    },
    /**
     * Prevents default on an event when possible.
     */
    preventEvent(r) {
      r.cancelable && r.preventDefault();
    },
    setCurrentScale(r) {
      this.currentScale = r;
    },
    setCurrentTranslateX(r) {
      this.currentTranslateX = r;
    },
    setCurrentTranslateY(r) {
      this.currentTranslateY = r;
    },
    setCurrentRotate(r) {
      this.currentRotate = r;
    },
    initializePanPinch() {
      this.preEditPosition = {
        scale: this.currentScale,
        translateX: this.currentTranslateX,
        translateY: this.currentTranslateY
      }, this.productSlug !== Cb && (this.hammer.add(this.pan), this.hammer.add(this.pinch).recognizeWith([this.pan]), this.hammer.on("panstart panmove panend", (r) => this.handlePan(r, this.$el)), this.hammer.on("pinchstart pinchmove", (r) => this.handlePinch(r, this.$el)));
    }
  }
}, NA = ["viewBox", "x", "y", "width", "height"], RA = ["aria-label", "id"], LA = ["viewBox"], DA = ["width", "height"], FA = ["x", "y", "width", "height"], BA = /* @__PURE__ */ _("rect", {
  x: "0",
  y: "0",
  rx: ".25",
  ry: ".25",
  width: "16",
  height: "4",
  class: "fill-current text-blue-50 pointer-events-none",
  tabindex: "-1",
  "aria-hidden": "true"
}, null, -1), jA = /* @__PURE__ */ _("svg", {
  viewBox: "0 0 28 28",
  x: ".75",
  y: ".75",
  width: "3",
  height: "3",
  class: "fill-current text-blue-500 pointer-events-none",
  tabindex: "-1",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ _("path", { d: "M19 2h-14c-1.7 0-3 1.3-3 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-14c0-1.7-1.3-3-3-3zM4 5c0-0.6 0.4-1 1-1h14c0.6 0 1 0.4 1 1v7.6l-3.3-3.3c-0.4-0.4-1-0.4-1.4 0l-10.6 10.6c-0.4-0.1-0.7-0.5-0.7-0.9v-14zM19 20h-11.6l8.6-8.6 4 4v3.6c0 0.6-0.4 1-1 1z" }),
  /* @__PURE__ */ _("path", { d: "M8.5 11c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5zM8.5 8c0.3 0 0.5 0.2 0.5 0.5s-0.2 0.5-0.5 0.5-0.5-0.2-0.5-0.5 0.2-0.5 0.5-0.5z" })
], -1), UA = ["x", "font-size"], zA = ["width", "height"], WA = ["width", "height", "x", "y", "data-id", "data-pane", "data-translate-x", "data-translate-y", "data-scale", "data-rotate", "data-original", "data-original-width", "data-original-height", "xlink:href", "transform"], HA = ["width", "height"];
function VA(r, e, t, n, i, s) {
  return N(), j("svg", {
    "data-svg": "",
    viewBox: `0 0 ${t.width} ${t.height}`,
    x: t.x,
    y: t.y,
    width: t.width,
    height: t.height,
    tabindex: "-1",
    class: "outline-none"
  }, [
    _("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "#ffffff",
      tabindex: "0",
      class: "outline-none focus-visible:stroke-blue",
      "data-test-id": "select-image",
      "aria-label": s.paneAriaLabel,
      id: `tile_${t.tileIndex}-${t.name}`,
      role: "button",
      onKeydown: e[0] || (e[0] = Us((...a) => s.handleTap && s.handleTap(...a), ["enter"]))
    }, null, 40, RA),
    Ke((N(), j("svg", {
      "data-placeholder": "",
      class: "cursor-pointer outline-none",
      viewBox: `0 0 ${t.width} ${t.height}`
    }, [
      _("rect", {
        width: t.width,
        height: t.height,
        fill: "#ffffff",
        class: "outline-none",
        tabindex: "-1",
        "aria-hidden": "true"
      }, null, 8, DA),
      (N(), j("svg", {
        viewBox: "0 0 16 4",
        x: t.width / 2 - t.width * s.imageSelectorMultiplicator / 2,
        y: t.height / 2 - t.width * s.imageSelectorMultiplicator / 8,
        width: t.width * s.imageSelectorMultiplicator,
        height: t.width * s.imageSelectorMultiplicator / 4,
        tabindex: "-1",
        class: "outline-none"
      }, [
        BA,
        jA,
        _("text", {
          x: s.placeHolderText.xPos,
          y: "2.2",
          "dominant-baseline": "middle",
          "font-size": s.placeHolderText.size,
          class: "fill-current text-blue-500 pointer-events-none outline-none",
          tabindex: "-1"
        }, he(r.$t("message.builder.selectImage")), 9, UA)
      ], 8, FA))
    ], 8, LA)), [
      [tt, t.placeholder && !t.renderMode]
    ]),
    t.image ? (N(), j("rect", {
      key: 0,
      "data-pane-background": "",
      width: t.width,
      height: t.height,
      fill: "#ffffff",
      "aria-hidden": "true",
      class: "outline-none",
      tabindex: "-1"
    }, null, 8, zA)) : se("", !0),
    t.image ? (N(), j("image", {
      key: i.currentThumb,
      "data-image": "",
      tabindex: "-1",
      width: i.currentWidth,
      height: i.currentHeight,
      x: i.currentX,
      y: i.currentY,
      "data-id": t.image ? t.image.id : null,
      "data-pane": t.name,
      "data-translate-x": i.currentTranslateX,
      "data-translate-y": i.currentTranslateY,
      "data-scale": i.currentScale,
      "data-rotate": i.currentRotate,
      "data-original": i.currentOriginal,
      "data-original-width": i.currentOriginalWidth,
      "data-original-height": i.currentOriginalHeight,
      "xlink:href": i.currentThumb,
      transform: s.transform,
      preserveAspectRatio: "xMidYMid slice",
      class: "pane-image",
      "aria-hidden": "true",
      onDragstart: e[1] || (e[1] = (...a) => s.handleDragStart && s.handleDragStart(...a))
    }, null, 40, WA)) : se("", !0),
    t.image ? (N(), j("rect", {
      key: 2,
      width: t.width,
      height: t.height,
      fill: "#ffffff",
      "fill-opacity": "0",
      class: "outline-none",
      tabindex: "-1"
    }, null, 8, HA)) : se("", !0)
  ], 8, NA);
}
const $A = /* @__PURE__ */ Vt(OA, [["render", VA]]), GA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $A
}, Symbol.toStringTag, { value: "Module" }));
const KA = {
  name: "Preview",
  props: {
    width: {
      type: Number,
      required: !0
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    height: {
      type: Number,
      required: !0
    },
    edge: {
      type: Number,
      required: !0
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    frameType: {
      type: String,
      required: !1,
      default: ""
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    frameColor: {
      type: String,
      default: null
    },
    offset: {
      type: Number,
      default: 0
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    panels: {
      type: Number,
      default: 1
    },
    preview: {
      type: Boolean,
      default: !1
    },
    frameWidth: {
      type: Number,
      default: 0
    },
    frameHeight: {
      type: Number,
      default: 0
    },
    cornerRadius: {
      type: String,
      default: null
    },
    matWidth: {
      type: Number,
      default: 0
    },
    matHeight: {
      type: Number,
      default: 0
    },
    productWidth: {
      type: Number,
      default: 0
    },
    productHeight: {
      type: Number,
      default: 0
    },
    gapWidth: {
      type: Number,
      default: 0
    },
    gapHeight: {
      type: Number,
      default: 0
    },
    tileIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  inject: {
    fullScale: {
      default: !1
    }
  },
  computed: {
    aspectRatio() {
      return this.width / this.height;
    },
    edgeWidth() {
      return this.edge / this.width * 100;
    },
    edgeHeight() {
      return this.edge / this.height * 100;
    },
    matDepthWidth() {
      return this.frame === 0 ? 0 : 0.25 / this.width * 100;
    },
    matDepthHeight() {
      return this.frame === 0 ? 0 : 0.25 / this.height * 100;
    },
    canvasWidth() {
      return this.width + 2 * this.edge;
    },
    canvasHeight() {
      return this.height + 2 * this.edge;
    },
    classList() {
      return [
        "flex-1 overflow-visible h-full max-w-full"
      ];
    },
    depthWidth() {
      return this.edge ? this.edgeWidth : this.frameWidth;
    },
    depthHeight() {
      return this.edge ? this.edgeHeight : this.frameHeight;
    },
    patternScale() {
      return ` ${this.productWidth * 72 / (548e3 / 1.5)} 0.0035`;
    },
    patternScaleVertical() {
      return `0.0035 ${0.585 / (this.productHeight ? this.productHeight : 1)}`;
    },
    styleListContainer() {
      let r = "scale(1)";
      return this.fullScale || (this.isArt && this.isMobile === !1 ? r = "scale(0.5)" : this.aspectRatio >= 1 ? r = `scale(${(this.width - 2) / this.productWidth})` : r = `scale(${(this.height - 2) / this.productHeight})`), {
        transform: r
      };
    },
    styleListBackground() {
      return {
        transform: `rotateX(90deg) translateY(${(this.edge ? this.edge : this.frame) / this.productHeight * -100}%) rotateX(-90deg)`,
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        "background-color": Ga(this.frameColor, -30),
        "box-shadow": `0 0 ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 8}px ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 4}px rgba(0, 0, 0, 0.15), 0 0 ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 2}px ${this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight}px rgba(0, 0, 0, 0.25), inset 0 0 10000px rgba(0, 0, 0, .2)`
      };
    },
    styleListFrameTopInner() {
      return {
        left: `-${this.gapWidth + this.matWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        height: `${this.frameHeight}%`,
        top: `-${this.gapHeight + this.matHeight}%`,
        "background-color": Ga(this.frameColor, -20)
      };
    },
    styleListFrameRightInner() {
      return {
        top: `-${this.gapHeight + this.matHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        width: `${this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        "background-color": Ga(this.frameColor, -10)
      };
    },
    styleListFrameBottomInner() {
      return {
        left: `-${this.gapWidth + this.matWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        height: `${this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        "background-color": Ga(this.frameColor, -10)
      };
    },
    styleListFrameLeftInner() {
      return {
        top: `-${this.gapHeight + this.matHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        width: `${this.frameWidth}%`,
        left: `-${this.gapWidth + this.matWidth}%`,
        "background-color": Ga(this.frameColor, -10)
      };
    },
    styleListFrameTop() {
      return {
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        height: `${this.frameHeight}%`,
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`
      };
    },
    styleListFrameRight() {
      return {
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        width: `${this.frameWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`
      };
    },
    styleListFrameBottom() {
      return {
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        height: `${this.frameHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`
      };
    },
    styleListFrameLeft() {
      return {
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        width: `${this.frameWidth}%`,
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`
      };
    },
    styleListFrameTopOuter() {
      return {
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        height: `${this.depthHeight}%`,
        top: `-${this.gapHeight + this.matHeight + this.depthHeight + this.frameHeight}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameRightOuter() {
      return {
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        width: `${this.depthWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.depthWidth + this.frameWidth}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameBottomOuter() {
      return {
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        height: `${this.depthHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.depthHeight + this.frameHeight}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameLeftOuter() {
      return {
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        width: `${this.depthWidth}%`,
        left: `-${this.gapWidth + this.matWidth + this.depthWidth + this.frameWidth}%`,
        "background-color": this.frameColor
      };
    },
    styleListCanvas() {
      return {
        transform: `rotateX(90deg) translateY(${this.mat ? -1 : 0}%) rotateX(-90deg)`,
        "clip-path": this.cornerRadius ? `inset(0% 0% 0% 0% round ${this.cornerRadius})` : "none"
      };
    },
    styleListMatTop() {
      return {
        height: `${this.matDepthHeight}%`
      };
    },
    styleListMatRight() {
      return {
        width: `${this.matDepthWidth}%`
      };
    },
    styleListMatBottom() {
      return {
        height: `${this.matDepthHeight}%`
      };
    },
    styleListMatLeft() {
      return {
        width: `${this.matDepthWidth}%`
      };
    },
    styleListEdgeTop() {
      return {
        height: `${this.edgeHeight}%`
      };
    },
    styleListEdgeRight() {
      return {
        width: `${this.edgeWidth}%`
      };
    },
    styleListEdgeBottom() {
      return {
        height: `${this.edgeHeight}%`
      };
    },
    styleListEdgeLeft() {
      return {
        width: `${this.edgeWidth}%`
      };
    },
    styleListMat() {
      return {
        left: `-${this.matWidth + this.gapWidth}%`,
        right: `-${this.matWidth + this.gapWidth}%`,
        bottom: `-${this.matHeight + this.gapHeight}%`,
        top: `-${this.matHeight + this.gapHeight}%`
      };
    },
    isWoodFrame() {
      return ["BF", "WF", "EF", "NF", "GF", "SF"].includes(this.frameType);
    }
  }
}, jo = (r) => (Qx("data-v-1b1b42df"), r = r(), eb(), r), YA = {
  "data-wrapper": "",
  class: "absolute inset-0 pointer-events-none preserve-3d"
}, qA = {
  "data-shadow": "",
  class: "absolute inset-0 preserve-3d"
}, ZA = ["viewBox"], JA = ["x", "viewBox", "width", "height"], XA = /* @__PURE__ */ Fo('<linearGradient id="GradientTopDark" x1="0" x2="0" y1="0" y2="1" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.7" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.4" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientTopLight" x1="0" x2="0" y1="0" y2="1" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.3" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.15" data-v-1b1b42df></stop></linearGradient>', 2), QA = ["id"], eS = ["x", "width", "height"], tS = ["xlink:href", "clip-path"], rS = ["x", "width", "height"], nS = ["viewBox"], iS = ["x", "y", "viewBox", "width", "height"], sS = /* @__PURE__ */ Fo('<linearGradient id="GradientRightDark" x1="1" x2="0" y1="0" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.8" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientRightLight" x1="1" x2="0" y1="0" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.4" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.2" data-v-1b1b42df></stop></linearGradient>', 2), aS = ["id"], oS = ["x", "y", "width", "height"], lS = ["xlink:href", "clip-path"], cS = ["x", "y", "width", "height"], uS = ["viewBox"], dS = ["x", "y", "viewBox", "width", "height"], fS = /* @__PURE__ */ Fo('<linearGradient id="GradientBottomDark" x1="0" x2="0" y1="1" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#333" stop-opacity="0.9" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.6" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientBottomLight" x1="0" x2="0" y1="1" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.25" data-v-1b1b42df></stop></linearGradient>', 2), hS = ["id"], pS = ["x", "y", "width", "height"], mS = ["xlink:href", "clip-path"], gS = ["x", "y", "width", "height"], xS = ["viewBox"], bS = ["x", "y", "viewBox", "width", "height"], vS = /* @__PURE__ */ Fo('<linearGradient id="GradientLeftDark" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.8" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientLeftLight" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.2" data-v-1b1b42df></stop></linearGradient>', 2), yS = ["id"], wS = ["x", "y", "width", "height"], _S = ["xlink:href", "clip-path"], ES = ["x", "y", "width", "height"], AS = ["viewBox"], SS = ["id"], TS = ["width", "height"], MS = ["x", "y", "width", "height"], IS = ["width", "height", "mask"], CS = /* @__PURE__ */ jo(() => /* @__PURE__ */ _("div", {
  class: "absolute inset-0",
  style: { "box-shadow": "inset 0 0 40px 0 rgba(0, 0, 0, .2), inset 0 0 20px 0 rgba(0, 0, 0, .4)" }
}, null, -1)), PS = ["viewBox"], kS = /* @__PURE__ */ jo(() => /* @__PURE__ */ _("linearGradient", {
  id: "ShadingTop",
  x1: "0",
  x2: "0",
  y1: "0",
  y2: "1"
}, [
  /* @__PURE__ */ _("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ _("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), OS = ["id"], NS = ["d"], RS = ["width", "height", "clip-path", "fill"], LS = ["width", "height", "clip-path", "fill"], DS = ["viewBox"], FS = /* @__PURE__ */ jo(() => /* @__PURE__ */ _("linearGradient", {
  id: "ShadingRight",
  x1: "1",
  x2: "0",
  y1: "0",
  y2: "0"
}, [
  /* @__PURE__ */ _("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ _("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), BS = ["id"], jS = ["d"], US = ["width", "height", "clip-path", "fill"], zS = ["width", "height", "clip-path", "fill"], WS = ["viewBox"], HS = /* @__PURE__ */ jo(() => /* @__PURE__ */ _("linearGradient", {
  id: "ShadingBottom",
  x1: "0",
  x2: "0",
  y1: "1",
  y2: "0"
}, [
  /* @__PURE__ */ _("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ _("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), VS = ["id"], $S = ["d"], GS = ["id", "patternTransform"], KS = ["href"], YS = ["width", "height", "clip-path", "fill"], qS = ["width", "height", "clip-path", "fill"], ZS = ["viewBox"], JS = /* @__PURE__ */ jo(() => /* @__PURE__ */ _("linearGradient", {
  id: "ShadingLeft",
  x1: "0",
  x2: "1",
  y1: "0",
  y2: "0"
}, [
  /* @__PURE__ */ _("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ _("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), XS = ["id"], QS = ["d"], eT = ["id", "patternTransform"], tT = ["href"], rT = ["width", "height", "clip-path", "fill"], nT = ["width", "height", "clip-path", "fill"], iT = ["viewBox"], sT = ["x", "y", "viewBox", "width", "height"], aT = ["id"], oT = ["x", "y", "width", "height"], lT = ["xlink:href", "clip-path"];
function cT(r, e, t, n, i, s) {
  return N(), j("div", {
    "data-container": "",
    class: "flex relative w-full h-auto max-w-full preserve-3d",
    style: qe(s.styleListContainer)
  }, [
    _("div", YA, [
      Ke(_("div", qA, null, 512), [
        [tt, t.mat]
      ]),
      Ke(_("div", {
        "data-background": "",
        class: "backface-hidden absolute preserve-3d",
        style: qe(s.styleListBackground)
      }, null, 4), [
        [tt, t.edge || t.frame]
      ]),
      Ke(_("div", {
        "data-frame-top-inner": "",
        class: "backface-hidden absolute top-0 preserve-3d",
        style: qe(s.styleListFrameTopInner)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-right-inner": "",
        class: "backface-hidden absolute right-0 preserve-3d",
        style: qe(s.styleListFrameRightInner)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-bottom-inner": "",
        class: "backface-hidden absolute bottom-0 preserve-3d",
        style: qe(s.styleListFrameBottomInner)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-left-inner": "",
        class: "backface-hidden absolute left-0 preserve-3d",
        style: qe(s.styleListFrameLeftInner)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-mat-top": "",
        class: "backface-hidden absolute inset-x-0 top-0 preserve-3d",
        style: qe(s.styleListMatTop)
      }, null, 4), [
        [tt, t.mat]
      ]),
      Ke(_("div", {
        "data-mat-right": "",
        class: "backface-hidden absolute inset-y-0 right-0 preserve-3d",
        style: qe(s.styleListMatRight)
      }, null, 4), [
        [tt, t.mat]
      ]),
      Ke(_("div", {
        "data-mat-bottom": "",
        class: "backface-hidden absolute inset-x-0 bottom-0 preserve-3d",
        style: qe(s.styleListMatBottom)
      }, null, 4), [
        [tt, t.mat]
      ]),
      Ke(_("div", {
        "data-mat-left": "",
        class: "backface-hidden absolute inset-y-0 left-0 preserve-3d",
        style: qe(s.styleListMatLeft)
      }, null, 4), [
        [tt, t.mat]
      ]),
      _("div", {
        "data-edge-top": "",
        class: "backface-hidden absolute inset-x-0 top-0 preserve-3d",
        style: qe(s.styleListEdgeTop)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.width} ${t.edge}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (N(), j("svg", {
            x: -t.edge - t.offset * (t.width + 2 * t.edge),
            y: 0,
            viewBox: `0 0 ${(t.width + 2 * t.edge) * t.panels} ${t.height + 2 * t.edge}`,
            width: (t.width + 2 * t.edge) * t.panels,
            height: t.height + 2 * t.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            _("defs", null, [
              XA,
              _("clipPath", {
                id: `clip-edge-top-${t.offset}-${t.tileIndex}`
              }, [
                _("rect", {
                  x: t.edge + t.offset * (t.width + 2 * t.edge),
                  y: 0,
                  width: t.width,
                  height: t.edge
                }, null, 8, eS)
              ], 8, QA)
            ]),
            _("use", {
              "xlink:href": `#printable-${t.offset}-${t.tileIndex}`,
              "clip-path": `url(#clip-edge-top-${t.offset}-${t.tileIndex})`,
              tabindex: "-1"
            }, null, 8, tS),
            _("rect", {
              x: t.edge + t.offset * (t.width + 2 * t.edge),
              y: 0,
              width: t.width,
              height: t.edge,
              fill: "url(#GradientTopLight)"
            }, null, 8, rS)
          ], 8, JA))
        ], 8, ZA))
      ], 4),
      _("div", {
        "data-edge-right": "",
        class: "backface-hidden absolute inset-y-0 right-0 preserve-3d",
        style: qe(s.styleListEdgeRight)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.edge} ${t.height}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (N(), j("svg", {
            x: -(t.edge + t.width + t.offset * (t.width + 2 * t.edge)),
            y: -t.edge,
            viewBox: `0 0 ${(t.width + 2 * t.edge) * t.panels} ${t.height + 2 * t.edge}`,
            width: (t.width + 2 * t.edge) * t.panels,
            height: t.height + 2 * t.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            _("defs", null, [
              sS,
              _("clipPath", {
                id: `clip-edge-right-${t.offset}-${t.tileIndex}`
              }, [
                _("rect", {
                  x: t.edge + t.width + t.offset * (t.width + 2 * t.edge),
                  y: t.edge,
                  width: t.edge,
                  height: t.height
                }, null, 8, oS)
              ], 8, aS)
            ]),
            _("use", {
              "xlink:href": `#printable-${t.offset}-${t.tileIndex}`,
              "clip-path": `url(#clip-edge-right-${t.offset}-${t.tileIndex})`
            }, null, 8, lS),
            _("rect", {
              x: t.edge + t.width + t.offset * (t.width + 2 * t.edge),
              y: t.edge,
              width: t.edge,
              height: t.height,
              fill: "url(#GradientRightLight)"
            }, null, 8, cS)
          ], 8, iS))
        ], 8, nS))
      ], 4),
      _("div", {
        "data-edge-bottom": "",
        class: "backface-hidden absolute inset-x-0 bottom-0 preserve-3d",
        style: qe(s.styleListEdgeBottom)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.width} ${t.edge}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (N(), j("svg", {
            x: -(t.edge + t.offset * (t.width + 2 * t.edge)),
            y: -(t.height + t.edge),
            viewBox: `0 0 ${(t.width + 2 * t.edge) * t.panels} ${t.height + 2 * t.edge}`,
            width: (t.width + 2 * t.edge) * t.panels,
            height: t.height + 2 * t.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            _("defs", null, [
              fS,
              _("clipPath", {
                id: `clip-edge-bottom-${t.offset}-${t.tileIndex}`
              }, [
                _("rect", {
                  x: t.edge + t.offset * (t.width + 2 * t.edge),
                  y: t.height + t.edge,
                  width: t.width,
                  height: t.edge
                }, null, 8, pS)
              ], 8, hS)
            ]),
            _("use", {
              "xlink:href": `#printable-${t.offset}-${t.tileIndex}`,
              "clip-path": `url(#clip-edge-bottom-${t.offset}-${t.tileIndex})`
            }, null, 8, mS),
            _("rect", {
              x: t.edge + t.offset * (t.width + 2 * t.edge),
              y: s.canvasHeight - t.edge,
              width: t.width,
              height: t.edge,
              fill: "url(#GradientBottomLight)"
            }, null, 8, gS)
          ], 8, dS))
        ], 8, uS))
      ], 4),
      _("div", {
        "data-edge-left": "",
        class: "backface-hidden absolute inset-y-0 left-0 preserve-3d",
        style: qe(s.styleListEdgeLeft)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.edge} ${t.height}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (N(), j("svg", {
            x: -(t.offset * (t.width + 2 * t.edge)),
            y: -t.edge,
            viewBox: `0 0 ${(t.width + 2 * t.edge) * t.panels} ${t.height + 2 * t.edge}`,
            width: (t.width + 2 * t.edge) * t.panels,
            height: t.height + 2 * t.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            _("defs", null, [
              vS,
              _("clipPath", {
                id: `clip-edge-left-${t.offset}-${t.tileIndex}`
              }, [
                _("rect", {
                  x: t.offset * (t.width + 2 * t.edge),
                  y: t.edge,
                  width: t.edge,
                  height: t.height
                }, null, 8, wS)
              ], 8, yS)
            ]),
            _("use", {
              "xlink:href": `#printable-${t.offset}-${t.tileIndex}`,
              "clip-path": `url(#clip-edge-left-${t.offset}-${t.tileIndex})`
            }, null, 8, _S),
            _("rect", {
              x: t.offset * (t.width + 2 * t.edge),
              y: t.edge,
              width: t.edge,
              height: t.height,
              fill: "url(#GradientLeftLight)"
            }, null, 8, ES)
          ], 8, bS))
        ], 8, xS))
      ], 4),
      Ke(_("div", {
        "data-mat": "",
        class: "backface-hidden absolute preserve-3d",
        style: qe(s.styleListMat)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.width + 2 * t.mat} ${t.height + 2 * t.mat}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          _("defs", null, [
            _("mask", {
              id: `mat-${t.tileIndex}`
            }, [
              _("rect", {
                x: 0,
                y: 0,
                width: t.productWidth,
                height: t.productHeight,
                fill: "#fff"
              }, null, 8, TS),
              _("rect", {
                x: t.mat,
                y: t.mat,
                width: t.width + 2 * t.gap,
                height: t.height + 2 * t.gap,
                fill: "#000"
              }, null, 8, MS)
            ], 8, SS)
          ]),
          _("rect", {
            x: 0,
            y: 0,
            width: t.width + 2 * t.mat,
            height: t.height + 2 * t.mat,
            fill: "#fff",
            mask: `url(#mat-${t.tileIndex})`
          }, null, 8, IS)
        ], 8, AS)),
        CS
      ], 4), [
        [tt, t.mat]
      ]),
      Ke(_("div", {
        class: "absolute top-0 preserve-3d",
        style: qe(s.styleListFrameTop)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.productWidth} ${t.frame}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          _("defs", null, [
            kS,
            _("clipPath", {
              id: `frame-top-${t.tileIndex}`
            }, [
              _("path", {
                d: `M 0 0 L ${t.productWidth} 0 L ${t.productWidth - t.frame} ${t.frame} L ${t.frame} ${t.frame} Z`
              }, null, 8, NS)
            ], 8, OS)
          ]),
          _("rect", {
            "data-frame-top": "",
            x: "0",
            y: "0",
            width: t.productWidth,
            height: t.frame,
            "clip-path": `url(#frame-top-${t.tileIndex})`,
            fill: t.frameColor
          }, null, 8, RS),
          _("rect", {
            x: "0",
            y: "0",
            width: t.productWidth,
            height: t.frame,
            "clip-path": `url(#frame-top-${t.tileIndex})`,
            fill: `url(#pattern-image-horizontal-${t.tileIndex})`
          }, null, 8, LS)
        ], 8, PS))
      ], 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        class: "absolute right-0 preserve-3d",
        style: qe(s.styleListFrameRight)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.frame} ${t.productHeight}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          _("defs", null, [
            FS,
            _("clipPath", {
              id: `frame-right-${t.tileIndex}`
            }, [
              _("path", {
                d: `M ${t.frame} 0 L ${t.frame} ${t.productHeight} L 0 ${t.productHeight - t.frame} L 0 ${t.frame} Z`
              }, null, 8, jS)
            ], 8, BS)
          ]),
          _("rect", {
            x: "0",
            y: "0",
            width: t.frame,
            height: t.productHeight,
            "clip-path": `url(#frame-right-${t.tileIndex})`,
            fill: t.frameColor
          }, null, 8, US),
          _("rect", {
            x: "0",
            y: "0",
            width: t.frame,
            height: t.productHeight,
            "clip-path": `url(#frame-right-${t.tileIndex})`,
            fill: `url(#pattern-image-vertical-${t.tileIndex})`
          }, null, 8, zS)
        ], 8, DS))
      ], 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        class: "absolute bottom-0 preserve-3d",
        style: qe(s.styleListFrameBottom)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.productWidth} ${t.frame}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          _("defs", null, [
            HS,
            _("clipPath", {
              id: `frame-bottom-${t.tileIndex}`
            }, [
              _("path", {
                d: `M ${t.frame} 0 L ${t.productWidth - t.frame} 0 L ${t.productWidth} ${t.frame} L 0 ${t.frame} Z`
              }, null, 8, $S)
            ], 8, VS),
            _("pattern", {
              id: `pattern-image-horizontal-${t.tileIndex}`,
              x: "0",
              y: "0",
              width: "5480",
              height: "354",
              patternUnits: "objectBoundingBox",
              patternTransform: `scale(${s.patternScale})`
            }, [
              s.isWoodFrame ? (N(), j("image", {
                key: 0,
                href: `https://d14c5m7lr5jmwa.cloudfront.net/frame-textures/woodframex4-${t.frameType}.jpg`,
                x: "0",
                y: "0",
                width: "5480",
                height: "354"
              }, null, 8, KS)) : se("", !0)
            ], 8, GS)
          ]),
          _("rect", {
            x: "0",
            y: "0",
            width: t.productWidth,
            height: t.frame,
            "clip-path": `url(#frame-bottom-${t.tileIndex})`,
            fill: t.frameColor
          }, null, 8, YS),
          _("rect", {
            x: "0",
            y: "0",
            width: t.productWidth,
            height: t.frame,
            "clip-path": `url(#frame-bottom-${t.tileIndex})`,
            fill: `url(#pattern-image-horizontal-${t.tileIndex})`
          }, null, 8, qS)
        ], 8, WS))
      ], 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        class: "absolute left-0 preserve-3d",
        style: qe(s.styleListFrameLeft)
      }, [
        (N(), j("svg", {
          viewBox: `0 0 ${t.frame} ${t.productHeight}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          _("defs", null, [
            JS,
            _("clipPath", {
              id: `frame-left-${t.tileIndex}`
            }, [
              _("path", {
                d: `M 0 0 L ${t.frame} ${t.frame} L ${t.frame} ${t.productHeight - t.frame} L 0 ${t.productHeight} Z`
              }, null, 8, QS)
            ], 8, XS),
            _("pattern", {
              id: `pattern-image-vertical-${t.tileIndex}`,
              x: "0",
              y: "0",
              width: "577",
              height: "100",
              patternUnits: "objectBoundingBox",
              patternTransform: `scale(${s.patternScaleVertical}) rotate(270)`
            }, [
              s.isWoodFrame ? (N(), j("image", {
                key: 0,
                href: `https://d14c5m7lr5jmwa.cloudfront.net/frame-textures/woodframex4-${t.frameType}.jpg`,
                x: "0",
                y: "0",
                width: "5480",
                height: "354"
              }, null, 8, tT)) : se("", !0)
            ], 8, eT)
          ]),
          _("rect", {
            x: "0",
            y: "0",
            width: t.frame,
            height: t.productHeight,
            "clip-path": `url(#frame-left-${t.tileIndex})`,
            fill: t.frameColor
          }, null, 8, rT),
          _("rect", {
            x: "0",
            y: "0",
            width: t.frame,
            height: t.productHeight,
            "clip-path": `url(#frame-left-${t.tileIndex})`,
            fill: `url(#pattern-image-vertical-${t.tileIndex})`
          }, null, 8, nT)
        ], 8, ZS))
      ], 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-top-outer": "",
        class: "absolute top-0 preserve-3d",
        style: qe(s.styleListFrameTopOuter)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-right-outer": "",
        class: "absolute right-0 preserve-3d",
        style: qe(s.styleListFrameRightOuter)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-bottom-outer": "",
        class: "absolute bottom-0 preserve-3d",
        style: qe(s.styleListFrameBottomOuter)
      }, null, 4), [
        [tt, t.frame]
      ]),
      Ke(_("div", {
        "data-frame-left-outer": "",
        class: "absolute left-0 preserve-3d",
        style: qe(s.styleListFrameLeftOuter)
      }, null, 4), [
        [tt, t.frame]
      ])
    ]),
    (N(), j("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "data-preview-svg": "",
      viewBox: `0 0 ${t.width} ${t.height}`,
      class: Pe(s.classList),
      style: qe(s.styleListCanvas),
      preserveAspectRatio: "xMidYMid slice"
    }, [
      (N(), j("svg", {
        x: -t.edge - t.offset * (t.width + 2 * t.edge),
        y: -t.edge,
        viewBox: `0 0 ${(t.width + 2 * t.edge) * t.panels} ${t.height + 2 * t.edge}`,
        width: (t.width + 2 * t.edge) * t.panels,
        height: t.height + 2 * t.edge,
        preserveAspectRatio: "xMidYMid slice"
      }, [
        _("defs", null, [
          _("clipPath", {
            id: `clip-main-${t.offset}-${t.tileIndex}`
          }, [
            _("rect", {
              x: t.edge + t.offset * (t.width + 2 * t.edge),
              y: t.edge,
              width: t.width,
              height: t.height
            }, null, 8, oT)
          ], 8, aT)
        ]),
        _("use", {
          "xlink:href": `#printable-${t.offset}-${t.tileIndex}`,
          "clip-path": `url(#clip-main-${t.offset}-${t.tileIndex})`
        }, null, 8, lT)
      ], 8, sT))
    ], 14, iT))
  ], 4);
}
const uT = /* @__PURE__ */ Vt(KA, [["render", cT], ["__scopeId", "data-v-1b1b42df"]]), dT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uT
}, Symbol.toStringTag, { value: "Module" }));
var gf = { exports: {} };
const fT = {}, hT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fT
}, Symbol.toStringTag, { value: "Module" })), pT = /* @__PURE__ */ Kb(hT);
gf.exports;
(function(r) {
  (function(e, t) {
    function n(L, d) {
      if (!L)
        throw new Error(d || "Assertion failed");
    }
    function i(L, d) {
      L.super_ = d;
      var b = function() {
      };
      b.prototype = d.prototype, L.prototype = new b(), L.prototype.constructor = L;
    }
    function s(L, d, b) {
      if (s.isBN(L))
        return L;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, L !== null && ((d === "le" || d === "be") && (b = d, d = 10), this._init(L || 0, d || 10, b || "be"));
    }
    typeof e == "object" ? e.exports = s : t.BN = s, s.BN = s, s.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = pT.Buffer;
    } catch {
    }
    s.isBN = function(d) {
      return d instanceof s ? !0 : d !== null && typeof d == "object" && d.constructor.wordSize === s.wordSize && Array.isArray(d.words);
    }, s.max = function(d, b) {
      return d.cmp(b) > 0 ? d : b;
    }, s.min = function(d, b) {
      return d.cmp(b) < 0 ? d : b;
    }, s.prototype._init = function(d, b, S) {
      if (typeof d == "number")
        return this._initNumber(d, b, S);
      if (typeof d == "object")
        return this._initArray(d, b, S);
      b === "hex" && (b = 16), n(b === (b | 0) && b >= 2 && b <= 36), d = d.toString().replace(/\s+/g, "");
      var R = 0;
      d[0] === "-" && (R++, this.negative = 1), R < d.length && (b === 16 ? this._parseHex(d, R, S) : (this._parseBase(d, b, R), S === "le" && this._initArray(this.toArray(), b, S)));
    }, s.prototype._initNumber = function(d, b, S) {
      d < 0 && (this.negative = 1, d = -d), d < 67108864 ? (this.words = [d & 67108863], this.length = 1) : d < 4503599627370496 ? (this.words = [
        d & 67108863,
        d / 67108864 & 67108863
      ], this.length = 2) : (n(d < 9007199254740992), this.words = [
        d & 67108863,
        d / 67108864 & 67108863,
        1
      ], this.length = 3), S === "le" && this._initArray(this.toArray(), b, S);
    }, s.prototype._initArray = function(d, b, S) {
      if (n(typeof d.length == "number"), d.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(d.length / 3), this.words = new Array(this.length);
      for (var R = 0; R < this.length; R++)
        this.words[R] = 0;
      var D, z, q = 0;
      if (S === "be")
        for (R = d.length - 1, D = 0; R >= 0; R -= 3)
          z = d[R] | d[R - 1] << 8 | d[R - 2] << 16, this.words[D] |= z << q & 67108863, this.words[D + 1] = z >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, D++);
      else if (S === "le")
        for (R = 0, D = 0; R < d.length; R += 3)
          z = d[R] | d[R + 1] << 8 | d[R + 2] << 16, this.words[D] |= z << q & 67108863, this.words[D + 1] = z >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, D++);
      return this._strip();
    };
    function o(L, d) {
      var b = L.charCodeAt(d);
      if (b >= 48 && b <= 57)
        return b - 48;
      if (b >= 65 && b <= 70)
        return b - 55;
      if (b >= 97 && b <= 102)
        return b - 87;
      n(!1, "Invalid character in " + L);
    }
    function l(L, d, b) {
      var S = o(L, b);
      return b - 1 >= d && (S |= o(L, b - 1) << 4), S;
    }
    s.prototype._parseHex = function(d, b, S) {
      this.length = Math.ceil((d.length - b) / 6), this.words = new Array(this.length);
      for (var R = 0; R < this.length; R++)
        this.words[R] = 0;
      var D = 0, z = 0, q;
      if (S === "be")
        for (R = d.length - 1; R >= b; R -= 2)
          q = l(d, b, R) << D, this.words[z] |= q & 67108863, D >= 18 ? (D -= 18, z += 1, this.words[z] |= q >>> 26) : D += 8;
      else {
        var y = d.length - b;
        for (R = y % 2 === 0 ? b + 1 : b; R < d.length; R += 2)
          q = l(d, b, R) << D, this.words[z] |= q & 67108863, D >= 18 ? (D -= 18, z += 1, this.words[z] |= q >>> 26) : D += 8;
      }
      this._strip();
    };
    function c(L, d, b, S) {
      for (var R = 0, D = 0, z = Math.min(L.length, b), q = d; q < z; q++) {
        var y = L.charCodeAt(q) - 48;
        R *= S, y >= 49 ? D = y - 49 + 10 : y >= 17 ? D = y - 17 + 10 : D = y, n(y >= 0 && D < S, "Invalid character"), R += D;
      }
      return R;
    }
    s.prototype._parseBase = function(d, b, S) {
      this.words = [0], this.length = 1;
      for (var R = 0, D = 1; D <= 67108863; D *= b)
        R++;
      R--, D = D / b | 0;
      for (var z = d.length - S, q = z % R, y = Math.min(z, z - q) + S, h = 0, I = S; I < y; I += R)
        h = c(d, I, I + R, b), this.imuln(D), this.words[0] + h < 67108864 ? this.words[0] += h : this._iaddn(h);
      if (q !== 0) {
        var V = 1;
        for (h = c(d, I, d.length, b), I = 0; I < q; I++)
          V *= b;
        this.imuln(V), this.words[0] + h < 67108864 ? this.words[0] += h : this._iaddn(h);
      }
      this._strip();
    }, s.prototype.copy = function(d) {
      d.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        d.words[b] = this.words[b];
      d.length = this.length, d.negative = this.negative, d.red = this.red;
    };
    function u(L, d) {
      L.words = d.words, L.length = d.length, L.negative = d.negative, L.red = d.red;
    }
    if (s.prototype._move = function(d) {
      u(d, this);
    }, s.prototype.clone = function() {
      var d = new s(null);
      return this.copy(d), d;
    }, s.prototype._expand = function(d) {
      for (; this.length < d; )
        this.words[this.length++] = 0;
      return this;
    }, s.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, s.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = f;
      } catch {
        s.prototype.inspect = f;
      }
    else
      s.prototype.inspect = f;
    function f() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var p = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], x = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], T = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    s.prototype.toString = function(d, b) {
      d = d || 10, b = b | 0 || 1;
      var S;
      if (d === 16 || d === "hex") {
        S = "";
        for (var R = 0, D = 0, z = 0; z < this.length; z++) {
          var q = this.words[z], y = ((q << R | D) & 16777215).toString(16);
          D = q >>> 24 - R & 16777215, R += 2, R >= 26 && (R -= 26, z--), D !== 0 || z !== this.length - 1 ? S = p[6 - y.length] + y + S : S = y + S;
        }
        for (D !== 0 && (S = D.toString(16) + S); S.length % b !== 0; )
          S = "0" + S;
        return this.negative !== 0 && (S = "-" + S), S;
      }
      if (d === (d | 0) && d >= 2 && d <= 36) {
        var h = x[d], I = T[d];
        S = "";
        var V = this.clone();
        for (V.negative = 0; !V.isZero(); ) {
          var g = V.modrn(I).toString(d);
          V = V.idivn(I), V.isZero() ? S = g + S : S = p[h - g.length] + g + S;
        }
        for (this.isZero() && (S = "0" + S); S.length % b !== 0; )
          S = "0" + S;
        return this.negative !== 0 && (S = "-" + S), S;
      }
      n(!1, "Base should be between 2 and 36");
    }, s.prototype.toNumber = function() {
      var d = this.words[0];
      return this.length === 2 ? d += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? d += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -d : d;
    }, s.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (s.prototype.toBuffer = function(d, b) {
      return this.toArrayLike(a, d, b);
    }), s.prototype.toArray = function(d, b) {
      return this.toArrayLike(Array, d, b);
    };
    var v = function(d, b) {
      return d.allocUnsafe ? d.allocUnsafe(b) : new d(b);
    };
    s.prototype.toArrayLike = function(d, b, S) {
      this._strip();
      var R = this.byteLength(), D = S || Math.max(1, R);
      n(R <= D, "byte array longer than desired length"), n(D > 0, "Requested array length <= 0");
      var z = v(d, D), q = b === "le" ? "LE" : "BE";
      return this["_toArrayLike" + q](z, R), z;
    }, s.prototype._toArrayLikeLE = function(d, b) {
      for (var S = 0, R = 0, D = 0, z = 0; D < this.length; D++) {
        var q = this.words[D] << z | R;
        d[S++] = q & 255, S < d.length && (d[S++] = q >> 8 & 255), S < d.length && (d[S++] = q >> 16 & 255), z === 6 ? (S < d.length && (d[S++] = q >> 24 & 255), R = 0, z = 0) : (R = q >>> 24, z += 2);
      }
      if (S < d.length)
        for (d[S++] = R; S < d.length; )
          d[S++] = 0;
    }, s.prototype._toArrayLikeBE = function(d, b) {
      for (var S = d.length - 1, R = 0, D = 0, z = 0; D < this.length; D++) {
        var q = this.words[D] << z | R;
        d[S--] = q & 255, S >= 0 && (d[S--] = q >> 8 & 255), S >= 0 && (d[S--] = q >> 16 & 255), z === 6 ? (S >= 0 && (d[S--] = q >> 24 & 255), R = 0, z = 0) : (R = q >>> 24, z += 2);
      }
      if (S >= 0)
        for (d[S--] = R; S >= 0; )
          d[S--] = 0;
    }, Math.clz32 ? s.prototype._countBits = function(d) {
      return 32 - Math.clz32(d);
    } : s.prototype._countBits = function(d) {
      var b = d, S = 0;
      return b >= 4096 && (S += 13, b >>>= 13), b >= 64 && (S += 7, b >>>= 7), b >= 8 && (S += 4, b >>>= 4), b >= 2 && (S += 2, b >>>= 2), S + b;
    }, s.prototype._zeroBits = function(d) {
      if (d === 0)
        return 26;
      var b = d, S = 0;
      return b & 8191 || (S += 13, b >>>= 13), b & 127 || (S += 7, b >>>= 7), b & 15 || (S += 4, b >>>= 4), b & 3 || (S += 2, b >>>= 2), b & 1 || S++, S;
    }, s.prototype.bitLength = function() {
      var d = this.words[this.length - 1], b = this._countBits(d);
      return (this.length - 1) * 26 + b;
    };
    function w(L) {
      for (var d = new Array(L.bitLength()), b = 0; b < d.length; b++) {
        var S = b / 26 | 0, R = b % 26;
        d[b] = L.words[S] >>> R & 1;
      }
      return d;
    }
    s.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var d = 0, b = 0; b < this.length; b++) {
        var S = this._zeroBits(this.words[b]);
        if (d += S, S !== 26)
          break;
      }
      return d;
    }, s.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, s.prototype.toTwos = function(d) {
      return this.negative !== 0 ? this.abs().inotn(d).iaddn(1) : this.clone();
    }, s.prototype.fromTwos = function(d) {
      return this.testn(d - 1) ? this.notn(d).iaddn(1).ineg() : this.clone();
    }, s.prototype.isNeg = function() {
      return this.negative !== 0;
    }, s.prototype.neg = function() {
      return this.clone().ineg();
    }, s.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, s.prototype.iuor = function(d) {
      for (; this.length < d.length; )
        this.words[this.length++] = 0;
      for (var b = 0; b < d.length; b++)
        this.words[b] = this.words[b] | d.words[b];
      return this._strip();
    }, s.prototype.ior = function(d) {
      return n((this.negative | d.negative) === 0), this.iuor(d);
    }, s.prototype.or = function(d) {
      return this.length > d.length ? this.clone().ior(d) : d.clone().ior(this);
    }, s.prototype.uor = function(d) {
      return this.length > d.length ? this.clone().iuor(d) : d.clone().iuor(this);
    }, s.prototype.iuand = function(d) {
      var b;
      this.length > d.length ? b = d : b = this;
      for (var S = 0; S < b.length; S++)
        this.words[S] = this.words[S] & d.words[S];
      return this.length = b.length, this._strip();
    }, s.prototype.iand = function(d) {
      return n((this.negative | d.negative) === 0), this.iuand(d);
    }, s.prototype.and = function(d) {
      return this.length > d.length ? this.clone().iand(d) : d.clone().iand(this);
    }, s.prototype.uand = function(d) {
      return this.length > d.length ? this.clone().iuand(d) : d.clone().iuand(this);
    }, s.prototype.iuxor = function(d) {
      var b, S;
      this.length > d.length ? (b = this, S = d) : (b = d, S = this);
      for (var R = 0; R < S.length; R++)
        this.words[R] = b.words[R] ^ S.words[R];
      if (this !== b)
        for (; R < b.length; R++)
          this.words[R] = b.words[R];
      return this.length = b.length, this._strip();
    }, s.prototype.ixor = function(d) {
      return n((this.negative | d.negative) === 0), this.iuxor(d);
    }, s.prototype.xor = function(d) {
      return this.length > d.length ? this.clone().ixor(d) : d.clone().ixor(this);
    }, s.prototype.uxor = function(d) {
      return this.length > d.length ? this.clone().iuxor(d) : d.clone().iuxor(this);
    }, s.prototype.inotn = function(d) {
      n(typeof d == "number" && d >= 0);
      var b = Math.ceil(d / 26) | 0, S = d % 26;
      this._expand(b), S > 0 && b--;
      for (var R = 0; R < b; R++)
        this.words[R] = ~this.words[R] & 67108863;
      return S > 0 && (this.words[R] = ~this.words[R] & 67108863 >> 26 - S), this._strip();
    }, s.prototype.notn = function(d) {
      return this.clone().inotn(d);
    }, s.prototype.setn = function(d, b) {
      n(typeof d == "number" && d >= 0);
      var S = d / 26 | 0, R = d % 26;
      return this._expand(S + 1), b ? this.words[S] = this.words[S] | 1 << R : this.words[S] = this.words[S] & ~(1 << R), this._strip();
    }, s.prototype.iadd = function(d) {
      var b;
      if (this.negative !== 0 && d.negative === 0)
        return this.negative = 0, b = this.isub(d), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && d.negative !== 0)
        return d.negative = 0, b = this.isub(d), d.negative = 1, b._normSign();
      var S, R;
      this.length > d.length ? (S = this, R = d) : (S = d, R = this);
      for (var D = 0, z = 0; z < R.length; z++)
        b = (S.words[z] | 0) + (R.words[z] | 0) + D, this.words[z] = b & 67108863, D = b >>> 26;
      for (; D !== 0 && z < S.length; z++)
        b = (S.words[z] | 0) + D, this.words[z] = b & 67108863, D = b >>> 26;
      if (this.length = S.length, D !== 0)
        this.words[this.length] = D, this.length++;
      else if (S !== this)
        for (; z < S.length; z++)
          this.words[z] = S.words[z];
      return this;
    }, s.prototype.add = function(d) {
      var b;
      return d.negative !== 0 && this.negative === 0 ? (d.negative = 0, b = this.sub(d), d.negative ^= 1, b) : d.negative === 0 && this.negative !== 0 ? (this.negative = 0, b = d.sub(this), this.negative = 1, b) : this.length > d.length ? this.clone().iadd(d) : d.clone().iadd(this);
    }, s.prototype.isub = function(d) {
      if (d.negative !== 0) {
        d.negative = 0;
        var b = this.iadd(d);
        return d.negative = 1, b._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(d), this.negative = 1, this._normSign();
      var S = this.cmp(d);
      if (S === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var R, D;
      S > 0 ? (R = this, D = d) : (R = d, D = this);
      for (var z = 0, q = 0; q < D.length; q++)
        b = (R.words[q] | 0) - (D.words[q] | 0) + z, z = b >> 26, this.words[q] = b & 67108863;
      for (; z !== 0 && q < R.length; q++)
        b = (R.words[q] | 0) + z, z = b >> 26, this.words[q] = b & 67108863;
      if (z === 0 && q < R.length && R !== this)
        for (; q < R.length; q++)
          this.words[q] = R.words[q];
      return this.length = Math.max(this.length, q), R !== this && (this.negative = 1), this._strip();
    }, s.prototype.sub = function(d) {
      return this.clone().isub(d);
    };
    function E(L, d, b) {
      b.negative = d.negative ^ L.negative;
      var S = L.length + d.length | 0;
      b.length = S, S = S - 1 | 0;
      var R = L.words[0] | 0, D = d.words[0] | 0, z = R * D, q = z & 67108863, y = z / 67108864 | 0;
      b.words[0] = q;
      for (var h = 1; h < S; h++) {
        for (var I = y >>> 26, V = y & 67108863, g = Math.min(h, d.length - 1), G = Math.max(0, h - L.length + 1); G <= g; G++) {
          var Q = h - G | 0;
          R = L.words[Q] | 0, D = d.words[G] | 0, z = R * D + V, I += z / 67108864 | 0, V = z & 67108863;
        }
        b.words[h] = V | 0, y = I | 0;
      }
      return y !== 0 ? b.words[h] = y | 0 : b.length--, b._strip();
    }
    var C = function(d, b, S) {
      var R = d.words, D = b.words, z = S.words, q = 0, y, h, I, V = R[0] | 0, g = V & 8191, G = V >>> 13, Q = R[1] | 0, J = Q & 8191, X = Q >>> 13, pe = R[2] | 0, ce = pe & 8191, ue = pe >>> 13, B = R[3] | 0, A = B & 8191, $ = B >>> 13, de = R[4] | 0, xe = de & 8191, Ae = de >>> 13, ut = R[5] | 0, Le = ut & 8191, Re = ut >>> 13, Me = R[6] | 0, re = Me & 8191, fe = Me >>> 13, Mt = R[7] | 0, Fe = Mt & 8191, dt = Mt >>> 13, Sr = R[8] | 0, rt = Sr & 8191, Ze = Sr >>> 13, Tr = R[9] | 0, ft = Tr & 8191, _t = Tr >>> 13, En = D[0] | 0, vt = En & 8191, It = En >>> 13, Jr = D[1] | 0, Be = Jr & 8191, We = Jr >>> 13, Lr = D[2] | 0, lt = Lr & 8191, yt = Lr >>> 13, Xr = D[3] | 0, Et = Xr & 8191, At = Xr >>> 13, Je = D[4] | 0, Ve = Je & 8191, Ct = Je >>> 13, Zt = D[5] | 0, nt = Zt & 8191, bt = Zt >>> 13, rr = D[6] | 0, Xe = rr & 8191, pt = rr >>> 13, Vr = D[7] | 0, ht = Vr & 8191, it = Vr >>> 13, cn = D[8] | 0, St = cn & 8191, Tt = cn >>> 13, un = D[9] | 0, Ue = un & 8191, mt = un >>> 13;
      S.negative = d.negative ^ b.negative, S.length = 19, y = Math.imul(g, vt), h = Math.imul(g, It), h = h + Math.imul(G, vt) | 0, I = Math.imul(G, It);
      var Ft = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Ft >>> 26) | 0, Ft &= 67108863, y = Math.imul(J, vt), h = Math.imul(J, It), h = h + Math.imul(X, vt) | 0, I = Math.imul(X, It), y = y + Math.imul(g, Be) | 0, h = h + Math.imul(g, We) | 0, h = h + Math.imul(G, Be) | 0, I = I + Math.imul(G, We) | 0;
      var Ut = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Ut >>> 26) | 0, Ut &= 67108863, y = Math.imul(ce, vt), h = Math.imul(ce, It), h = h + Math.imul(ue, vt) | 0, I = Math.imul(ue, It), y = y + Math.imul(J, Be) | 0, h = h + Math.imul(J, We) | 0, h = h + Math.imul(X, Be) | 0, I = I + Math.imul(X, We) | 0, y = y + Math.imul(g, lt) | 0, h = h + Math.imul(g, yt) | 0, h = h + Math.imul(G, lt) | 0, I = I + Math.imul(G, yt) | 0;
      var nr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (nr >>> 26) | 0, nr &= 67108863, y = Math.imul(A, vt), h = Math.imul(A, It), h = h + Math.imul($, vt) | 0, I = Math.imul($, It), y = y + Math.imul(ce, Be) | 0, h = h + Math.imul(ce, We) | 0, h = h + Math.imul(ue, Be) | 0, I = I + Math.imul(ue, We) | 0, y = y + Math.imul(J, lt) | 0, h = h + Math.imul(J, yt) | 0, h = h + Math.imul(X, lt) | 0, I = I + Math.imul(X, yt) | 0, y = y + Math.imul(g, Et) | 0, h = h + Math.imul(g, At) | 0, h = h + Math.imul(G, Et) | 0, I = I + Math.imul(G, At) | 0;
      var cr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (cr >>> 26) | 0, cr &= 67108863, y = Math.imul(xe, vt), h = Math.imul(xe, It), h = h + Math.imul(Ae, vt) | 0, I = Math.imul(Ae, It), y = y + Math.imul(A, Be) | 0, h = h + Math.imul(A, We) | 0, h = h + Math.imul($, Be) | 0, I = I + Math.imul($, We) | 0, y = y + Math.imul(ce, lt) | 0, h = h + Math.imul(ce, yt) | 0, h = h + Math.imul(ue, lt) | 0, I = I + Math.imul(ue, yt) | 0, y = y + Math.imul(J, Et) | 0, h = h + Math.imul(J, At) | 0, h = h + Math.imul(X, Et) | 0, I = I + Math.imul(X, At) | 0, y = y + Math.imul(g, Ve) | 0, h = h + Math.imul(g, Ct) | 0, h = h + Math.imul(G, Ve) | 0, I = I + Math.imul(G, Ct) | 0;
      var zt = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (zt >>> 26) | 0, zt &= 67108863, y = Math.imul(Le, vt), h = Math.imul(Le, It), h = h + Math.imul(Re, vt) | 0, I = Math.imul(Re, It), y = y + Math.imul(xe, Be) | 0, h = h + Math.imul(xe, We) | 0, h = h + Math.imul(Ae, Be) | 0, I = I + Math.imul(Ae, We) | 0, y = y + Math.imul(A, lt) | 0, h = h + Math.imul(A, yt) | 0, h = h + Math.imul($, lt) | 0, I = I + Math.imul($, yt) | 0, y = y + Math.imul(ce, Et) | 0, h = h + Math.imul(ce, At) | 0, h = h + Math.imul(ue, Et) | 0, I = I + Math.imul(ue, At) | 0, y = y + Math.imul(J, Ve) | 0, h = h + Math.imul(J, Ct) | 0, h = h + Math.imul(X, Ve) | 0, I = I + Math.imul(X, Ct) | 0, y = y + Math.imul(g, nt) | 0, h = h + Math.imul(g, bt) | 0, h = h + Math.imul(G, nt) | 0, I = I + Math.imul(G, bt) | 0;
      var dn = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, y = Math.imul(re, vt), h = Math.imul(re, It), h = h + Math.imul(fe, vt) | 0, I = Math.imul(fe, It), y = y + Math.imul(Le, Be) | 0, h = h + Math.imul(Le, We) | 0, h = h + Math.imul(Re, Be) | 0, I = I + Math.imul(Re, We) | 0, y = y + Math.imul(xe, lt) | 0, h = h + Math.imul(xe, yt) | 0, h = h + Math.imul(Ae, lt) | 0, I = I + Math.imul(Ae, yt) | 0, y = y + Math.imul(A, Et) | 0, h = h + Math.imul(A, At) | 0, h = h + Math.imul($, Et) | 0, I = I + Math.imul($, At) | 0, y = y + Math.imul(ce, Ve) | 0, h = h + Math.imul(ce, Ct) | 0, h = h + Math.imul(ue, Ve) | 0, I = I + Math.imul(ue, Ct) | 0, y = y + Math.imul(J, nt) | 0, h = h + Math.imul(J, bt) | 0, h = h + Math.imul(X, nt) | 0, I = I + Math.imul(X, bt) | 0, y = y + Math.imul(g, Xe) | 0, h = h + Math.imul(g, pt) | 0, h = h + Math.imul(G, Xe) | 0, I = I + Math.imul(G, pt) | 0;
      var ur = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (ur >>> 26) | 0, ur &= 67108863, y = Math.imul(Fe, vt), h = Math.imul(Fe, It), h = h + Math.imul(dt, vt) | 0, I = Math.imul(dt, It), y = y + Math.imul(re, Be) | 0, h = h + Math.imul(re, We) | 0, h = h + Math.imul(fe, Be) | 0, I = I + Math.imul(fe, We) | 0, y = y + Math.imul(Le, lt) | 0, h = h + Math.imul(Le, yt) | 0, h = h + Math.imul(Re, lt) | 0, I = I + Math.imul(Re, yt) | 0, y = y + Math.imul(xe, Et) | 0, h = h + Math.imul(xe, At) | 0, h = h + Math.imul(Ae, Et) | 0, I = I + Math.imul(Ae, At) | 0, y = y + Math.imul(A, Ve) | 0, h = h + Math.imul(A, Ct) | 0, h = h + Math.imul($, Ve) | 0, I = I + Math.imul($, Ct) | 0, y = y + Math.imul(ce, nt) | 0, h = h + Math.imul(ce, bt) | 0, h = h + Math.imul(ue, nt) | 0, I = I + Math.imul(ue, bt) | 0, y = y + Math.imul(J, Xe) | 0, h = h + Math.imul(J, pt) | 0, h = h + Math.imul(X, Xe) | 0, I = I + Math.imul(X, pt) | 0, y = y + Math.imul(g, ht) | 0, h = h + Math.imul(g, it) | 0, h = h + Math.imul(G, ht) | 0, I = I + Math.imul(G, it) | 0;
      var Jn = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Jn >>> 26) | 0, Jn &= 67108863, y = Math.imul(rt, vt), h = Math.imul(rt, It), h = h + Math.imul(Ze, vt) | 0, I = Math.imul(Ze, It), y = y + Math.imul(Fe, Be) | 0, h = h + Math.imul(Fe, We) | 0, h = h + Math.imul(dt, Be) | 0, I = I + Math.imul(dt, We) | 0, y = y + Math.imul(re, lt) | 0, h = h + Math.imul(re, yt) | 0, h = h + Math.imul(fe, lt) | 0, I = I + Math.imul(fe, yt) | 0, y = y + Math.imul(Le, Et) | 0, h = h + Math.imul(Le, At) | 0, h = h + Math.imul(Re, Et) | 0, I = I + Math.imul(Re, At) | 0, y = y + Math.imul(xe, Ve) | 0, h = h + Math.imul(xe, Ct) | 0, h = h + Math.imul(Ae, Ve) | 0, I = I + Math.imul(Ae, Ct) | 0, y = y + Math.imul(A, nt) | 0, h = h + Math.imul(A, bt) | 0, h = h + Math.imul($, nt) | 0, I = I + Math.imul($, bt) | 0, y = y + Math.imul(ce, Xe) | 0, h = h + Math.imul(ce, pt) | 0, h = h + Math.imul(ue, Xe) | 0, I = I + Math.imul(ue, pt) | 0, y = y + Math.imul(J, ht) | 0, h = h + Math.imul(J, it) | 0, h = h + Math.imul(X, ht) | 0, I = I + Math.imul(X, it) | 0, y = y + Math.imul(g, St) | 0, h = h + Math.imul(g, Tt) | 0, h = h + Math.imul(G, St) | 0, I = I + Math.imul(G, Tt) | 0;
      var dr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (dr >>> 26) | 0, dr &= 67108863, y = Math.imul(ft, vt), h = Math.imul(ft, It), h = h + Math.imul(_t, vt) | 0, I = Math.imul(_t, It), y = y + Math.imul(rt, Be) | 0, h = h + Math.imul(rt, We) | 0, h = h + Math.imul(Ze, Be) | 0, I = I + Math.imul(Ze, We) | 0, y = y + Math.imul(Fe, lt) | 0, h = h + Math.imul(Fe, yt) | 0, h = h + Math.imul(dt, lt) | 0, I = I + Math.imul(dt, yt) | 0, y = y + Math.imul(re, Et) | 0, h = h + Math.imul(re, At) | 0, h = h + Math.imul(fe, Et) | 0, I = I + Math.imul(fe, At) | 0, y = y + Math.imul(Le, Ve) | 0, h = h + Math.imul(Le, Ct) | 0, h = h + Math.imul(Re, Ve) | 0, I = I + Math.imul(Re, Ct) | 0, y = y + Math.imul(xe, nt) | 0, h = h + Math.imul(xe, bt) | 0, h = h + Math.imul(Ae, nt) | 0, I = I + Math.imul(Ae, bt) | 0, y = y + Math.imul(A, Xe) | 0, h = h + Math.imul(A, pt) | 0, h = h + Math.imul($, Xe) | 0, I = I + Math.imul($, pt) | 0, y = y + Math.imul(ce, ht) | 0, h = h + Math.imul(ce, it) | 0, h = h + Math.imul(ue, ht) | 0, I = I + Math.imul(ue, it) | 0, y = y + Math.imul(J, St) | 0, h = h + Math.imul(J, Tt) | 0, h = h + Math.imul(X, St) | 0, I = I + Math.imul(X, Tt) | 0, y = y + Math.imul(g, Ue) | 0, h = h + Math.imul(g, mt) | 0, h = h + Math.imul(G, Ue) | 0, I = I + Math.imul(G, mt) | 0;
      var An = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (An >>> 26) | 0, An &= 67108863, y = Math.imul(ft, Be), h = Math.imul(ft, We), h = h + Math.imul(_t, Be) | 0, I = Math.imul(_t, We), y = y + Math.imul(rt, lt) | 0, h = h + Math.imul(rt, yt) | 0, h = h + Math.imul(Ze, lt) | 0, I = I + Math.imul(Ze, yt) | 0, y = y + Math.imul(Fe, Et) | 0, h = h + Math.imul(Fe, At) | 0, h = h + Math.imul(dt, Et) | 0, I = I + Math.imul(dt, At) | 0, y = y + Math.imul(re, Ve) | 0, h = h + Math.imul(re, Ct) | 0, h = h + Math.imul(fe, Ve) | 0, I = I + Math.imul(fe, Ct) | 0, y = y + Math.imul(Le, nt) | 0, h = h + Math.imul(Le, bt) | 0, h = h + Math.imul(Re, nt) | 0, I = I + Math.imul(Re, bt) | 0, y = y + Math.imul(xe, Xe) | 0, h = h + Math.imul(xe, pt) | 0, h = h + Math.imul(Ae, Xe) | 0, I = I + Math.imul(Ae, pt) | 0, y = y + Math.imul(A, ht) | 0, h = h + Math.imul(A, it) | 0, h = h + Math.imul($, ht) | 0, I = I + Math.imul($, it) | 0, y = y + Math.imul(ce, St) | 0, h = h + Math.imul(ce, Tt) | 0, h = h + Math.imul(ue, St) | 0, I = I + Math.imul(ue, Tt) | 0, y = y + Math.imul(J, Ue) | 0, h = h + Math.imul(J, mt) | 0, h = h + Math.imul(X, Ue) | 0, I = I + Math.imul(X, mt) | 0;
      var Mr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Mr >>> 26) | 0, Mr &= 67108863, y = Math.imul(ft, lt), h = Math.imul(ft, yt), h = h + Math.imul(_t, lt) | 0, I = Math.imul(_t, yt), y = y + Math.imul(rt, Et) | 0, h = h + Math.imul(rt, At) | 0, h = h + Math.imul(Ze, Et) | 0, I = I + Math.imul(Ze, At) | 0, y = y + Math.imul(Fe, Ve) | 0, h = h + Math.imul(Fe, Ct) | 0, h = h + Math.imul(dt, Ve) | 0, I = I + Math.imul(dt, Ct) | 0, y = y + Math.imul(re, nt) | 0, h = h + Math.imul(re, bt) | 0, h = h + Math.imul(fe, nt) | 0, I = I + Math.imul(fe, bt) | 0, y = y + Math.imul(Le, Xe) | 0, h = h + Math.imul(Le, pt) | 0, h = h + Math.imul(Re, Xe) | 0, I = I + Math.imul(Re, pt) | 0, y = y + Math.imul(xe, ht) | 0, h = h + Math.imul(xe, it) | 0, h = h + Math.imul(Ae, ht) | 0, I = I + Math.imul(Ae, it) | 0, y = y + Math.imul(A, St) | 0, h = h + Math.imul(A, Tt) | 0, h = h + Math.imul($, St) | 0, I = I + Math.imul($, Tt) | 0, y = y + Math.imul(ce, Ue) | 0, h = h + Math.imul(ce, mt) | 0, h = h + Math.imul(ue, Ue) | 0, I = I + Math.imul(ue, mt) | 0;
      var yr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (yr >>> 26) | 0, yr &= 67108863, y = Math.imul(ft, Et), h = Math.imul(ft, At), h = h + Math.imul(_t, Et) | 0, I = Math.imul(_t, At), y = y + Math.imul(rt, Ve) | 0, h = h + Math.imul(rt, Ct) | 0, h = h + Math.imul(Ze, Ve) | 0, I = I + Math.imul(Ze, Ct) | 0, y = y + Math.imul(Fe, nt) | 0, h = h + Math.imul(Fe, bt) | 0, h = h + Math.imul(dt, nt) | 0, I = I + Math.imul(dt, bt) | 0, y = y + Math.imul(re, Xe) | 0, h = h + Math.imul(re, pt) | 0, h = h + Math.imul(fe, Xe) | 0, I = I + Math.imul(fe, pt) | 0, y = y + Math.imul(Le, ht) | 0, h = h + Math.imul(Le, it) | 0, h = h + Math.imul(Re, ht) | 0, I = I + Math.imul(Re, it) | 0, y = y + Math.imul(xe, St) | 0, h = h + Math.imul(xe, Tt) | 0, h = h + Math.imul(Ae, St) | 0, I = I + Math.imul(Ae, Tt) | 0, y = y + Math.imul(A, Ue) | 0, h = h + Math.imul(A, mt) | 0, h = h + Math.imul($, Ue) | 0, I = I + Math.imul($, mt) | 0;
      var Qr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, y = Math.imul(ft, Ve), h = Math.imul(ft, Ct), h = h + Math.imul(_t, Ve) | 0, I = Math.imul(_t, Ct), y = y + Math.imul(rt, nt) | 0, h = h + Math.imul(rt, bt) | 0, h = h + Math.imul(Ze, nt) | 0, I = I + Math.imul(Ze, bt) | 0, y = y + Math.imul(Fe, Xe) | 0, h = h + Math.imul(Fe, pt) | 0, h = h + Math.imul(dt, Xe) | 0, I = I + Math.imul(dt, pt) | 0, y = y + Math.imul(re, ht) | 0, h = h + Math.imul(re, it) | 0, h = h + Math.imul(fe, ht) | 0, I = I + Math.imul(fe, it) | 0, y = y + Math.imul(Le, St) | 0, h = h + Math.imul(Le, Tt) | 0, h = h + Math.imul(Re, St) | 0, I = I + Math.imul(Re, Tt) | 0, y = y + Math.imul(xe, Ue) | 0, h = h + Math.imul(xe, mt) | 0, h = h + Math.imul(Ae, Ue) | 0, I = I + Math.imul(Ae, mt) | 0;
      var Wt = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Wt >>> 26) | 0, Wt &= 67108863, y = Math.imul(ft, nt), h = Math.imul(ft, bt), h = h + Math.imul(_t, nt) | 0, I = Math.imul(_t, bt), y = y + Math.imul(rt, Xe) | 0, h = h + Math.imul(rt, pt) | 0, h = h + Math.imul(Ze, Xe) | 0, I = I + Math.imul(Ze, pt) | 0, y = y + Math.imul(Fe, ht) | 0, h = h + Math.imul(Fe, it) | 0, h = h + Math.imul(dt, ht) | 0, I = I + Math.imul(dt, it) | 0, y = y + Math.imul(re, St) | 0, h = h + Math.imul(re, Tt) | 0, h = h + Math.imul(fe, St) | 0, I = I + Math.imul(fe, Tt) | 0, y = y + Math.imul(Le, Ue) | 0, h = h + Math.imul(Le, mt) | 0, h = h + Math.imul(Re, Ue) | 0, I = I + Math.imul(Re, mt) | 0;
      var wr = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, y = Math.imul(ft, Xe), h = Math.imul(ft, pt), h = h + Math.imul(_t, Xe) | 0, I = Math.imul(_t, pt), y = y + Math.imul(rt, ht) | 0, h = h + Math.imul(rt, it) | 0, h = h + Math.imul(Ze, ht) | 0, I = I + Math.imul(Ze, it) | 0, y = y + Math.imul(Fe, St) | 0, h = h + Math.imul(Fe, Tt) | 0, h = h + Math.imul(dt, St) | 0, I = I + Math.imul(dt, Tt) | 0, y = y + Math.imul(re, Ue) | 0, h = h + Math.imul(re, mt) | 0, h = h + Math.imul(fe, Ue) | 0, I = I + Math.imul(fe, mt) | 0;
      var fn = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (fn >>> 26) | 0, fn &= 67108863, y = Math.imul(ft, ht), h = Math.imul(ft, it), h = h + Math.imul(_t, ht) | 0, I = Math.imul(_t, it), y = y + Math.imul(rt, St) | 0, h = h + Math.imul(rt, Tt) | 0, h = h + Math.imul(Ze, St) | 0, I = I + Math.imul(Ze, Tt) | 0, y = y + Math.imul(Fe, Ue) | 0, h = h + Math.imul(Fe, mt) | 0, h = h + Math.imul(dt, Ue) | 0, I = I + Math.imul(dt, mt) | 0;
      var Fn = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Fn >>> 26) | 0, Fn &= 67108863, y = Math.imul(ft, St), h = Math.imul(ft, Tt), h = h + Math.imul(_t, St) | 0, I = Math.imul(_t, Tt), y = y + Math.imul(rt, Ue) | 0, h = h + Math.imul(rt, mt) | 0, h = h + Math.imul(Ze, Ue) | 0, I = I + Math.imul(Ze, mt) | 0;
      var Sn = (q + y | 0) + ((h & 8191) << 13) | 0;
      q = (I + (h >>> 13) | 0) + (Sn >>> 26) | 0, Sn &= 67108863, y = Math.imul(ft, Ue), h = Math.imul(ft, mt), h = h + Math.imul(_t, Ue) | 0, I = Math.imul(_t, mt);
      var fr = (q + y | 0) + ((h & 8191) << 13) | 0;
      return q = (I + (h >>> 13) | 0) + (fr >>> 26) | 0, fr &= 67108863, z[0] = Ft, z[1] = Ut, z[2] = nr, z[3] = cr, z[4] = zt, z[5] = dn, z[6] = ur, z[7] = Jn, z[8] = dr, z[9] = An, z[10] = Mr, z[11] = yr, z[12] = Qr, z[13] = Wt, z[14] = wr, z[15] = fn, z[16] = Fn, z[17] = Sn, z[18] = fr, q !== 0 && (z[19] = q, S.length++), S;
    };
    Math.imul || (C = E);
    function P(L, d, b) {
      b.negative = d.negative ^ L.negative, b.length = L.length + d.length;
      for (var S = 0, R = 0, D = 0; D < b.length - 1; D++) {
        var z = R;
        R = 0;
        for (var q = S & 67108863, y = Math.min(D, d.length - 1), h = Math.max(0, D - L.length + 1); h <= y; h++) {
          var I = D - h, V = L.words[I] | 0, g = d.words[h] | 0, G = V * g, Q = G & 67108863;
          z = z + (G / 67108864 | 0) | 0, Q = Q + q | 0, q = Q & 67108863, z = z + (Q >>> 26) | 0, R += z >>> 26, z &= 67108863;
        }
        b.words[D] = q, S = z, z = R;
      }
      return S !== 0 ? b.words[D] = S : b.length--, b._strip();
    }
    function F(L, d, b) {
      return P(L, d, b);
    }
    s.prototype.mulTo = function(d, b) {
      var S, R = this.length + d.length;
      return this.length === 10 && d.length === 10 ? S = C(this, d, b) : R < 63 ? S = E(this, d, b) : R < 1024 ? S = P(this, d, b) : S = F(this, d, b), S;
    }, s.prototype.mul = function(d) {
      var b = new s(null);
      return b.words = new Array(this.length + d.length), this.mulTo(d, b);
    }, s.prototype.mulf = function(d) {
      var b = new s(null);
      return b.words = new Array(this.length + d.length), F(this, d, b);
    }, s.prototype.imul = function(d) {
      return this.clone().mulTo(d, this);
    }, s.prototype.imuln = function(d) {
      var b = d < 0;
      b && (d = -d), n(typeof d == "number"), n(d < 67108864);
      for (var S = 0, R = 0; R < this.length; R++) {
        var D = (this.words[R] | 0) * d, z = (D & 67108863) + (S & 67108863);
        S >>= 26, S += D / 67108864 | 0, S += z >>> 26, this.words[R] = z & 67108863;
      }
      return S !== 0 && (this.words[R] = S, this.length++), b ? this.ineg() : this;
    }, s.prototype.muln = function(d) {
      return this.clone().imuln(d);
    }, s.prototype.sqr = function() {
      return this.mul(this);
    }, s.prototype.isqr = function() {
      return this.imul(this.clone());
    }, s.prototype.pow = function(d) {
      var b = w(d);
      if (b.length === 0)
        return new s(1);
      for (var S = this, R = 0; R < b.length && b[R] === 0; R++, S = S.sqr())
        ;
      if (++R < b.length)
        for (var D = S.sqr(); R < b.length; R++, D = D.sqr())
          b[R] !== 0 && (S = S.mul(D));
      return S;
    }, s.prototype.iushln = function(d) {
      n(typeof d == "number" && d >= 0);
      var b = d % 26, S = (d - b) / 26, R = 67108863 >>> 26 - b << 26 - b, D;
      if (b !== 0) {
        var z = 0;
        for (D = 0; D < this.length; D++) {
          var q = this.words[D] & R, y = (this.words[D] | 0) - q << b;
          this.words[D] = y | z, z = q >>> 26 - b;
        }
        z && (this.words[D] = z, this.length++);
      }
      if (S !== 0) {
        for (D = this.length - 1; D >= 0; D--)
          this.words[D + S] = this.words[D];
        for (D = 0; D < S; D++)
          this.words[D] = 0;
        this.length += S;
      }
      return this._strip();
    }, s.prototype.ishln = function(d) {
      return n(this.negative === 0), this.iushln(d);
    }, s.prototype.iushrn = function(d, b, S) {
      n(typeof d == "number" && d >= 0);
      var R;
      b ? R = (b - b % 26) / 26 : R = 0;
      var D = d % 26, z = Math.min((d - D) / 26, this.length), q = 67108863 ^ 67108863 >>> D << D, y = S;
      if (R -= z, R = Math.max(0, R), y) {
        for (var h = 0; h < z; h++)
          y.words[h] = this.words[h];
        y.length = z;
      }
      if (z !== 0)
        if (this.length > z)
          for (this.length -= z, h = 0; h < this.length; h++)
            this.words[h] = this.words[h + z];
        else
          this.words[0] = 0, this.length = 1;
      var I = 0;
      for (h = this.length - 1; h >= 0 && (I !== 0 || h >= R); h--) {
        var V = this.words[h] | 0;
        this.words[h] = I << 26 - D | V >>> D, I = V & q;
      }
      return y && I !== 0 && (y.words[y.length++] = I), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, s.prototype.ishrn = function(d, b, S) {
      return n(this.negative === 0), this.iushrn(d, b, S);
    }, s.prototype.shln = function(d) {
      return this.clone().ishln(d);
    }, s.prototype.ushln = function(d) {
      return this.clone().iushln(d);
    }, s.prototype.shrn = function(d) {
      return this.clone().ishrn(d);
    }, s.prototype.ushrn = function(d) {
      return this.clone().iushrn(d);
    }, s.prototype.testn = function(d) {
      n(typeof d == "number" && d >= 0);
      var b = d % 26, S = (d - b) / 26, R = 1 << b;
      if (this.length <= S)
        return !1;
      var D = this.words[S];
      return !!(D & R);
    }, s.prototype.imaskn = function(d) {
      n(typeof d == "number" && d >= 0);
      var b = d % 26, S = (d - b) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= S)
        return this;
      if (b !== 0 && S++, this.length = Math.min(S, this.length), b !== 0) {
        var R = 67108863 ^ 67108863 >>> b << b;
        this.words[this.length - 1] &= R;
      }
      return this._strip();
    }, s.prototype.maskn = function(d) {
      return this.clone().imaskn(d);
    }, s.prototype.iaddn = function(d) {
      return n(typeof d == "number"), n(d < 67108864), d < 0 ? this.isubn(-d) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= d ? (this.words[0] = d - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(d), this.negative = 1, this) : this._iaddn(d);
    }, s.prototype._iaddn = function(d) {
      this.words[0] += d;
      for (var b = 0; b < this.length && this.words[b] >= 67108864; b++)
        this.words[b] -= 67108864, b === this.length - 1 ? this.words[b + 1] = 1 : this.words[b + 1]++;
      return this.length = Math.max(this.length, b + 1), this;
    }, s.prototype.isubn = function(d) {
      if (n(typeof d == "number"), n(d < 67108864), d < 0)
        return this.iaddn(-d);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(d), this.negative = 1, this;
      if (this.words[0] -= d, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var b = 0; b < this.length && this.words[b] < 0; b++)
          this.words[b] += 67108864, this.words[b + 1] -= 1;
      return this._strip();
    }, s.prototype.addn = function(d) {
      return this.clone().iaddn(d);
    }, s.prototype.subn = function(d) {
      return this.clone().isubn(d);
    }, s.prototype.iabs = function() {
      return this.negative = 0, this;
    }, s.prototype.abs = function() {
      return this.clone().iabs();
    }, s.prototype._ishlnsubmul = function(d, b, S) {
      var R = d.length + S, D;
      this._expand(R);
      var z, q = 0;
      for (D = 0; D < d.length; D++) {
        z = (this.words[D + S] | 0) + q;
        var y = (d.words[D] | 0) * b;
        z -= y & 67108863, q = (z >> 26) - (y / 67108864 | 0), this.words[D + S] = z & 67108863;
      }
      for (; D < this.length - S; D++)
        z = (this.words[D + S] | 0) + q, q = z >> 26, this.words[D + S] = z & 67108863;
      if (q === 0)
        return this._strip();
      for (n(q === -1), q = 0, D = 0; D < this.length; D++)
        z = -(this.words[D] | 0) + q, q = z >> 26, this.words[D] = z & 67108863;
      return this.negative = 1, this._strip();
    }, s.prototype._wordDiv = function(d, b) {
      var S = this.length - d.length, R = this.clone(), D = d, z = D.words[D.length - 1] | 0, q = this._countBits(z);
      S = 26 - q, S !== 0 && (D = D.ushln(S), R.iushln(S), z = D.words[D.length - 1] | 0);
      var y = R.length - D.length, h;
      if (b !== "mod") {
        h = new s(null), h.length = y + 1, h.words = new Array(h.length);
        for (var I = 0; I < h.length; I++)
          h.words[I] = 0;
      }
      var V = R.clone()._ishlnsubmul(D, 1, y);
      V.negative === 0 && (R = V, h && (h.words[y] = 1));
      for (var g = y - 1; g >= 0; g--) {
        var G = (R.words[D.length + g] | 0) * 67108864 + (R.words[D.length + g - 1] | 0);
        for (G = Math.min(G / z | 0, 67108863), R._ishlnsubmul(D, G, g); R.negative !== 0; )
          G--, R.negative = 0, R._ishlnsubmul(D, 1, g), R.isZero() || (R.negative ^= 1);
        h && (h.words[g] = G);
      }
      return h && h._strip(), R._strip(), b !== "div" && S !== 0 && R.iushrn(S), {
        div: h || null,
        mod: R
      };
    }, s.prototype.divmod = function(d, b, S) {
      if (n(!d.isZero()), this.isZero())
        return {
          div: new s(0),
          mod: new s(0)
        };
      var R, D, z;
      return this.negative !== 0 && d.negative === 0 ? (z = this.neg().divmod(d, b), b !== "mod" && (R = z.div.neg()), b !== "div" && (D = z.mod.neg(), S && D.negative !== 0 && D.iadd(d)), {
        div: R,
        mod: D
      }) : this.negative === 0 && d.negative !== 0 ? (z = this.divmod(d.neg(), b), b !== "mod" && (R = z.div.neg()), {
        div: R,
        mod: z.mod
      }) : this.negative & d.negative ? (z = this.neg().divmod(d.neg(), b), b !== "div" && (D = z.mod.neg(), S && D.negative !== 0 && D.isub(d)), {
        div: z.div,
        mod: D
      }) : d.length > this.length || this.cmp(d) < 0 ? {
        div: new s(0),
        mod: this
      } : d.length === 1 ? b === "div" ? {
        div: this.divn(d.words[0]),
        mod: null
      } : b === "mod" ? {
        div: null,
        mod: new s(this.modrn(d.words[0]))
      } : {
        div: this.divn(d.words[0]),
        mod: new s(this.modrn(d.words[0]))
      } : this._wordDiv(d, b);
    }, s.prototype.div = function(d) {
      return this.divmod(d, "div", !1).div;
    }, s.prototype.mod = function(d) {
      return this.divmod(d, "mod", !1).mod;
    }, s.prototype.umod = function(d) {
      return this.divmod(d, "mod", !0).mod;
    }, s.prototype.divRound = function(d) {
      var b = this.divmod(d);
      if (b.mod.isZero())
        return b.div;
      var S = b.div.negative !== 0 ? b.mod.isub(d) : b.mod, R = d.ushrn(1), D = d.andln(1), z = S.cmp(R);
      return z < 0 || D === 1 && z === 0 ? b.div : b.div.negative !== 0 ? b.div.isubn(1) : b.div.iaddn(1);
    }, s.prototype.modrn = function(d) {
      var b = d < 0;
      b && (d = -d), n(d <= 67108863);
      for (var S = (1 << 26) % d, R = 0, D = this.length - 1; D >= 0; D--)
        R = (S * R + (this.words[D] | 0)) % d;
      return b ? -R : R;
    }, s.prototype.modn = function(d) {
      return this.modrn(d);
    }, s.prototype.idivn = function(d) {
      var b = d < 0;
      b && (d = -d), n(d <= 67108863);
      for (var S = 0, R = this.length - 1; R >= 0; R--) {
        var D = (this.words[R] | 0) + S * 67108864;
        this.words[R] = D / d | 0, S = D % d;
      }
      return this._strip(), b ? this.ineg() : this;
    }, s.prototype.divn = function(d) {
      return this.clone().idivn(d);
    }, s.prototype.egcd = function(d) {
      n(d.negative === 0), n(!d.isZero());
      var b = this, S = d.clone();
      b.negative !== 0 ? b = b.umod(d) : b = b.clone();
      for (var R = new s(1), D = new s(0), z = new s(0), q = new s(1), y = 0; b.isEven() && S.isEven(); )
        b.iushrn(1), S.iushrn(1), ++y;
      for (var h = S.clone(), I = b.clone(); !b.isZero(); ) {
        for (var V = 0, g = 1; !(b.words[0] & g) && V < 26; ++V, g <<= 1)
          ;
        if (V > 0)
          for (b.iushrn(V); V-- > 0; )
            (R.isOdd() || D.isOdd()) && (R.iadd(h), D.isub(I)), R.iushrn(1), D.iushrn(1);
        for (var G = 0, Q = 1; !(S.words[0] & Q) && G < 26; ++G, Q <<= 1)
          ;
        if (G > 0)
          for (S.iushrn(G); G-- > 0; )
            (z.isOdd() || q.isOdd()) && (z.iadd(h), q.isub(I)), z.iushrn(1), q.iushrn(1);
        b.cmp(S) >= 0 ? (b.isub(S), R.isub(z), D.isub(q)) : (S.isub(b), z.isub(R), q.isub(D));
      }
      return {
        a: z,
        b: q,
        gcd: S.iushln(y)
      };
    }, s.prototype._invmp = function(d) {
      n(d.negative === 0), n(!d.isZero());
      var b = this, S = d.clone();
      b.negative !== 0 ? b = b.umod(d) : b = b.clone();
      for (var R = new s(1), D = new s(0), z = S.clone(); b.cmpn(1) > 0 && S.cmpn(1) > 0; ) {
        for (var q = 0, y = 1; !(b.words[0] & y) && q < 26; ++q, y <<= 1)
          ;
        if (q > 0)
          for (b.iushrn(q); q-- > 0; )
            R.isOdd() && R.iadd(z), R.iushrn(1);
        for (var h = 0, I = 1; !(S.words[0] & I) && h < 26; ++h, I <<= 1)
          ;
        if (h > 0)
          for (S.iushrn(h); h-- > 0; )
            D.isOdd() && D.iadd(z), D.iushrn(1);
        b.cmp(S) >= 0 ? (b.isub(S), R.isub(D)) : (S.isub(b), D.isub(R));
      }
      var V;
      return b.cmpn(1) === 0 ? V = R : V = D, V.cmpn(0) < 0 && V.iadd(d), V;
    }, s.prototype.gcd = function(d) {
      if (this.isZero())
        return d.abs();
      if (d.isZero())
        return this.abs();
      var b = this.clone(), S = d.clone();
      b.negative = 0, S.negative = 0;
      for (var R = 0; b.isEven() && S.isEven(); R++)
        b.iushrn(1), S.iushrn(1);
      do {
        for (; b.isEven(); )
          b.iushrn(1);
        for (; S.isEven(); )
          S.iushrn(1);
        var D = b.cmp(S);
        if (D < 0) {
          var z = b;
          b = S, S = z;
        } else if (D === 0 || S.cmpn(1) === 0)
          break;
        b.isub(S);
      } while (!0);
      return S.iushln(R);
    }, s.prototype.invm = function(d) {
      return this.egcd(d).a.umod(d);
    }, s.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, s.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, s.prototype.andln = function(d) {
      return this.words[0] & d;
    }, s.prototype.bincn = function(d) {
      n(typeof d == "number");
      var b = d % 26, S = (d - b) / 26, R = 1 << b;
      if (this.length <= S)
        return this._expand(S + 1), this.words[S] |= R, this;
      for (var D = R, z = S; D !== 0 && z < this.length; z++) {
        var q = this.words[z] | 0;
        q += D, D = q >>> 26, q &= 67108863, this.words[z] = q;
      }
      return D !== 0 && (this.words[z] = D, this.length++), this;
    }, s.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, s.prototype.cmpn = function(d) {
      var b = d < 0;
      if (this.negative !== 0 && !b)
        return -1;
      if (this.negative === 0 && b)
        return 1;
      this._strip();
      var S;
      if (this.length > 1)
        S = 1;
      else {
        b && (d = -d), n(d <= 67108863, "Number is too big");
        var R = this.words[0] | 0;
        S = R === d ? 0 : R < d ? -1 : 1;
      }
      return this.negative !== 0 ? -S | 0 : S;
    }, s.prototype.cmp = function(d) {
      if (this.negative !== 0 && d.negative === 0)
        return -1;
      if (this.negative === 0 && d.negative !== 0)
        return 1;
      var b = this.ucmp(d);
      return this.negative !== 0 ? -b | 0 : b;
    }, s.prototype.ucmp = function(d) {
      if (this.length > d.length)
        return 1;
      if (this.length < d.length)
        return -1;
      for (var b = 0, S = this.length - 1; S >= 0; S--) {
        var R = this.words[S] | 0, D = d.words[S] | 0;
        if (R !== D) {
          R < D ? b = -1 : R > D && (b = 1);
          break;
        }
      }
      return b;
    }, s.prototype.gtn = function(d) {
      return this.cmpn(d) === 1;
    }, s.prototype.gt = function(d) {
      return this.cmp(d) === 1;
    }, s.prototype.gten = function(d) {
      return this.cmpn(d) >= 0;
    }, s.prototype.gte = function(d) {
      return this.cmp(d) >= 0;
    }, s.prototype.ltn = function(d) {
      return this.cmpn(d) === -1;
    }, s.prototype.lt = function(d) {
      return this.cmp(d) === -1;
    }, s.prototype.lten = function(d) {
      return this.cmpn(d) <= 0;
    }, s.prototype.lte = function(d) {
      return this.cmp(d) <= 0;
    }, s.prototype.eqn = function(d) {
      return this.cmpn(d) === 0;
    }, s.prototype.eq = function(d) {
      return this.cmp(d) === 0;
    }, s.red = function(d) {
      return new ge(d);
    }, s.prototype.toRed = function(d) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), d.convertTo(this)._forceRed(d);
    }, s.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, s.prototype._forceRed = function(d) {
      return this.red = d, this;
    }, s.prototype.forceRed = function(d) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(d);
    }, s.prototype.redAdd = function(d) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, d);
    }, s.prototype.redIAdd = function(d) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, d);
    }, s.prototype.redSub = function(d) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, d);
    }, s.prototype.redISub = function(d) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, d);
    }, s.prototype.redShl = function(d) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, d);
    }, s.prototype.redMul = function(d) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, d), this.red.mul(this, d);
    }, s.prototype.redIMul = function(d) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, d), this.red.imul(this, d);
    }, s.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, s.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, s.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, s.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, s.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, s.prototype.redPow = function(d) {
      return n(this.red && !d.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, d);
    };
    var k = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function K(L, d) {
      this.name = L, this.p = new s(d, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    K.prototype._tmp = function() {
      var d = new s(null);
      return d.words = new Array(Math.ceil(this.n / 13)), d;
    }, K.prototype.ireduce = function(d) {
      var b = d, S;
      do
        this.split(b, this.tmp), b = this.imulK(b), b = b.iadd(this.tmp), S = b.bitLength();
      while (S > this.n);
      var R = S < this.n ? -1 : b.ucmp(this.p);
      return R === 0 ? (b.words[0] = 0, b.length = 1) : R > 0 ? b.isub(this.p) : b.strip !== void 0 ? b.strip() : b._strip(), b;
    }, K.prototype.split = function(d, b) {
      d.iushrn(this.n, 0, b);
    }, K.prototype.imulK = function(d) {
      return d.imul(this.k);
    };
    function Z() {
      K.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(Z, K), Z.prototype.split = function(d, b) {
      for (var S = 4194303, R = Math.min(d.length, 9), D = 0; D < R; D++)
        b.words[D] = d.words[D];
      if (b.length = R, d.length <= 9) {
        d.words[0] = 0, d.length = 1;
        return;
      }
      var z = d.words[9];
      for (b.words[b.length++] = z & S, D = 10; D < d.length; D++) {
        var q = d.words[D] | 0;
        d.words[D - 10] = (q & S) << 4 | z >>> 22, z = q;
      }
      z >>>= 22, d.words[D - 10] = z, z === 0 && d.length > 10 ? d.length -= 10 : d.length -= 9;
    }, Z.prototype.imulK = function(d) {
      d.words[d.length] = 0, d.words[d.length + 1] = 0, d.length += 2;
      for (var b = 0, S = 0; S < d.length; S++) {
        var R = d.words[S] | 0;
        b += R * 977, d.words[S] = b & 67108863, b = R * 64 + (b / 67108864 | 0);
      }
      return d.words[d.length - 1] === 0 && (d.length--, d.words[d.length - 1] === 0 && d.length--), d;
    };
    function ne() {
      K.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(ne, K);
    function le() {
      K.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(le, K);
    function ye() {
      K.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(ye, K), ye.prototype.imulK = function(d) {
      for (var b = 0, S = 0; S < d.length; S++) {
        var R = (d.words[S] | 0) * 19 + b, D = R & 67108863;
        R >>>= 26, d.words[S] = D, b = R;
      }
      return b !== 0 && (d.words[d.length++] = b), d;
    }, s._prime = function(d) {
      if (k[d])
        return k[d];
      var b;
      if (d === "k256")
        b = new Z();
      else if (d === "p224")
        b = new ne();
      else if (d === "p192")
        b = new le();
      else if (d === "p25519")
        b = new ye();
      else
        throw new Error("Unknown prime " + d);
      return k[d] = b, b;
    };
    function ge(L) {
      if (typeof L == "string") {
        var d = s._prime(L);
        this.m = d.p, this.prime = d;
      } else
        n(L.gtn(1), "modulus must be greater than 1"), this.m = L, this.prime = null;
    }
    ge.prototype._verify1 = function(d) {
      n(d.negative === 0, "red works only with positives"), n(d.red, "red works only with red numbers");
    }, ge.prototype._verify2 = function(d, b) {
      n((d.negative | b.negative) === 0, "red works only with positives"), n(
        d.red && d.red === b.red,
        "red works only with red numbers"
      );
    }, ge.prototype.imod = function(d) {
      return this.prime ? this.prime.ireduce(d)._forceRed(this) : (u(d, d.umod(this.m)._forceRed(this)), d);
    }, ge.prototype.neg = function(d) {
      return d.isZero() ? d.clone() : this.m.sub(d)._forceRed(this);
    }, ge.prototype.add = function(d, b) {
      this._verify2(d, b);
      var S = d.add(b);
      return S.cmp(this.m) >= 0 && S.isub(this.m), S._forceRed(this);
    }, ge.prototype.iadd = function(d, b) {
      this._verify2(d, b);
      var S = d.iadd(b);
      return S.cmp(this.m) >= 0 && S.isub(this.m), S;
    }, ge.prototype.sub = function(d, b) {
      this._verify2(d, b);
      var S = d.sub(b);
      return S.cmpn(0) < 0 && S.iadd(this.m), S._forceRed(this);
    }, ge.prototype.isub = function(d, b) {
      this._verify2(d, b);
      var S = d.isub(b);
      return S.cmpn(0) < 0 && S.iadd(this.m), S;
    }, ge.prototype.shl = function(d, b) {
      return this._verify1(d), this.imod(d.ushln(b));
    }, ge.prototype.imul = function(d, b) {
      return this._verify2(d, b), this.imod(d.imul(b));
    }, ge.prototype.mul = function(d, b) {
      return this._verify2(d, b), this.imod(d.mul(b));
    }, ge.prototype.isqr = function(d) {
      return this.imul(d, d.clone());
    }, ge.prototype.sqr = function(d) {
      return this.mul(d, d);
    }, ge.prototype.sqrt = function(d) {
      if (d.isZero())
        return d.clone();
      var b = this.m.andln(3);
      if (n(b % 2 === 1), b === 3) {
        var S = this.m.add(new s(1)).iushrn(2);
        return this.pow(d, S);
      }
      for (var R = this.m.subn(1), D = 0; !R.isZero() && R.andln(1) === 0; )
        D++, R.iushrn(1);
      n(!R.isZero());
      var z = new s(1).toRed(this), q = z.redNeg(), y = this.m.subn(1).iushrn(1), h = this.m.bitLength();
      for (h = new s(2 * h * h).toRed(this); this.pow(h, y).cmp(q) !== 0; )
        h.redIAdd(q);
      for (var I = this.pow(h, R), V = this.pow(d, R.addn(1).iushrn(1)), g = this.pow(d, R), G = D; g.cmp(z) !== 0; ) {
        for (var Q = g, J = 0; Q.cmp(z) !== 0; J++)
          Q = Q.redSqr();
        n(J < G);
        var X = this.pow(I, new s(1).iushln(G - J - 1));
        V = V.redMul(X), I = X.redSqr(), g = g.redMul(I), G = J;
      }
      return V;
    }, ge.prototype.invm = function(d) {
      var b = d._invmp(this.m);
      return b.negative !== 0 ? (b.negative = 0, this.imod(b).redNeg()) : this.imod(b);
    }, ge.prototype.pow = function(d, b) {
      if (b.isZero())
        return new s(1).toRed(this);
      if (b.cmpn(1) === 0)
        return d.clone();
      var S = 4, R = new Array(1 << S);
      R[0] = new s(1).toRed(this), R[1] = d;
      for (var D = 2; D < R.length; D++)
        R[D] = this.mul(R[D - 1], d);
      var z = R[0], q = 0, y = 0, h = b.bitLength() % 26;
      for (h === 0 && (h = 26), D = b.length - 1; D >= 0; D--) {
        for (var I = b.words[D], V = h - 1; V >= 0; V--) {
          var g = I >> V & 1;
          if (z !== R[0] && (z = this.sqr(z)), g === 0 && q === 0) {
            y = 0;
            continue;
          }
          q <<= 1, q |= g, y++, !(y !== S && (D !== 0 || V !== 0)) && (z = this.mul(z, R[q]), y = 0, q = 0);
        }
        h = 26;
      }
      return z;
    }, ge.prototype.convertTo = function(d) {
      var b = d.umod(this.m);
      return b === d ? b.clone() : b;
    }, ge.prototype.convertFrom = function(d) {
      var b = d.clone();
      return b.red = null, b;
    }, s.mont = function(d) {
      return new _e(d);
    };
    function _e(L) {
      ge.call(this, L), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(_e, ge), _e.prototype.convertTo = function(d) {
      return this.imod(d.ushln(this.shift));
    }, _e.prototype.convertFrom = function(d) {
      var b = this.imod(d.mul(this.rinv));
      return b.red = null, b;
    }, _e.prototype.imul = function(d, b) {
      if (d.isZero() || b.isZero())
        return d.words[0] = 0, d.length = 1, d;
      var S = d.imul(b), R = S.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), D = S.isub(R).iushrn(this.shift), z = D;
      return D.cmp(this.m) >= 0 ? z = D.isub(this.m) : D.cmpn(0) < 0 && (z = D.iadd(this.m)), z._forceRed(this);
    }, _e.prototype.mul = function(d, b) {
      if (d.isZero() || b.isZero())
        return new s(0)._forceRed(this);
      var S = d.mul(b), R = S.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), D = S.isub(R).iushrn(this.shift), z = D;
      return D.cmp(this.m) >= 0 ? z = D.isub(this.m) : D.cmpn(0) < 0 && (z = D.iadd(this.m)), z._forceRed(this);
    }, _e.prototype.invm = function(d) {
      var b = this.imod(d._invmp(this.m).mul(this.r2));
      return b._forceRed(this);
    };
  })(r, jd);
})(gf);
var mT = gf.exports;
const $e = /* @__PURE__ */ zi(mT), gT = "logger/5.7.0";
let jh = !1, Uh = !1;
const Tl = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let zh = Tl.default, uu = null;
function xT() {
  try {
    const r = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((e) => {
      try {
        if ("test".normalize(e) !== "test")
          throw new Error("bad normalize");
      } catch {
        r.push(e);
      }
    }), r.length)
      throw new Error("missing " + r.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (r) {
    return r.message;
  }
  return null;
}
const Wh = xT();
var yd;
(function(r) {
  r.DEBUG = "DEBUG", r.INFO = "INFO", r.WARNING = "WARNING", r.ERROR = "ERROR", r.OFF = "OFF";
})(yd || (yd = {}));
var mn;
(function(r) {
  r.UNKNOWN_ERROR = "UNKNOWN_ERROR", r.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", r.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", r.NETWORK_ERROR = "NETWORK_ERROR", r.SERVER_ERROR = "SERVER_ERROR", r.TIMEOUT = "TIMEOUT", r.BUFFER_OVERRUN = "BUFFER_OVERRUN", r.NUMERIC_FAULT = "NUMERIC_FAULT", r.MISSING_NEW = "MISSING_NEW", r.INVALID_ARGUMENT = "INVALID_ARGUMENT", r.MISSING_ARGUMENT = "MISSING_ARGUMENT", r.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", r.CALL_EXCEPTION = "CALL_EXCEPTION", r.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", r.NONCE_EXPIRED = "NONCE_EXPIRED", r.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", r.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", r.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", r.ACTION_REJECTED = "ACTION_REJECTED";
})(mn || (mn = {}));
const Hh = "0123456789abcdef";
class H {
  constructor(e) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: e,
      writable: !1
    });
  }
  _log(e, t) {
    const n = e.toLowerCase();
    Tl[n] == null && this.throwArgumentError("invalid log level name", "logLevel", e), !(zh > Tl[n]) && console.log.apply(console, t);
  }
  debug(...e) {
    this._log(H.levels.DEBUG, e);
  }
  info(...e) {
    this._log(H.levels.INFO, e);
  }
  warn(...e) {
    this._log(H.levels.WARNING, e);
  }
  makeError(e, t, n) {
    if (Uh)
      return this.makeError("censored error", t, {});
    t || (t = H.errors.UNKNOWN_ERROR), n || (n = {});
    const i = [];
    Object.keys(n).forEach((l) => {
      const c = n[l];
      try {
        if (c instanceof Uint8Array) {
          let u = "";
          for (let f = 0; f < c.length; f++)
            u += Hh[c[f] >> 4], u += Hh[c[f] & 15];
          i.push(l + "=Uint8Array(0x" + u + ")");
        } else
          i.push(l + "=" + JSON.stringify(c));
      } catch {
        i.push(l + "=" + JSON.stringify(n[l].toString()));
      }
    }), i.push(`code=${t}`), i.push(`version=${this.version}`);
    const s = e;
    let a = "";
    switch (t) {
      case mn.NUMERIC_FAULT: {
        a = "NUMERIC_FAULT";
        const l = e;
        switch (l) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            a += "-" + l;
            break;
          case "negative-power":
          case "negative-width":
            a += "-unsupported";
            break;
          case "unbound-bitwise-result":
            a += "-unbound-result";
            break;
        }
        break;
      }
      case mn.CALL_EXCEPTION:
      case mn.INSUFFICIENT_FUNDS:
      case mn.MISSING_NEW:
      case mn.NONCE_EXPIRED:
      case mn.REPLACEMENT_UNDERPRICED:
      case mn.TRANSACTION_REPLACED:
      case mn.UNPREDICTABLE_GAS_LIMIT:
        a = t;
        break;
    }
    a && (e += " [ See: https://links.ethers.org/v5-errors-" + a + " ]"), i.length && (e += " (" + i.join(", ") + ")");
    const o = new Error(e);
    return o.reason = s, o.code = t, Object.keys(n).forEach(function(l) {
      o[l] = n[l];
    }), o;
  }
  throwError(e, t, n) {
    throw this.makeError(e, t, n);
  }
  throwArgumentError(e, t, n) {
    return this.throwError(e, H.errors.INVALID_ARGUMENT, {
      argument: t,
      value: n
    });
  }
  assert(e, t, n, i) {
    e || this.throwError(t, n, i);
  }
  assertArgument(e, t, n, i) {
    e || this.throwArgumentError(t, n, i);
  }
  checkNormalize(e) {
    Wh && this.throwError("platform missing String.prototype.normalize", H.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: Wh
    });
  }
  checkSafeUint53(e, t) {
    typeof e == "number" && (t == null && (t = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(t, H.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: e
    }), e % 1 && this.throwError(t, H.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: e
    }));
  }
  checkArgumentCount(e, t, n) {
    n ? n = ": " + n : n = "", e < t && this.throwError("missing argument" + n, H.errors.MISSING_ARGUMENT, {
      count: e,
      expectedCount: t
    }), e > t && this.throwError("too many arguments" + n, H.errors.UNEXPECTED_ARGUMENT, {
      count: e,
      expectedCount: t
    });
  }
  checkNew(e, t) {
    (e === Object || e == null) && this.throwError("missing new", H.errors.MISSING_NEW, { name: t.name });
  }
  checkAbstract(e, t) {
    e === t ? this.throwError("cannot instantiate abstract class " + JSON.stringify(t.name) + " directly; use a sub-class", H.errors.UNSUPPORTED_OPERATION, { name: e.name, operation: "new" }) : (e === Object || e == null) && this.throwError("missing new", H.errors.MISSING_NEW, { name: t.name });
  }
  static globalLogger() {
    return uu || (uu = new H(gT)), uu;
  }
  static setCensorship(e, t) {
    if (!e && t && this.globalLogger().throwError("cannot permanently disable censorship", H.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), jh) {
      if (!e)
        return;
      this.globalLogger().throwError("error censorship permanent", H.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    Uh = !!e, jh = !!t;
  }
  static setLogLevel(e) {
    const t = Tl[e.toLowerCase()];
    if (t == null) {
      H.globalLogger().warn("invalid log level - " + e);
      return;
    }
    zh = t;
  }
  static from(e) {
    return new H(e);
  }
}
H.errors = mn;
H.levels = yd;
const bT = "bytes/5.7.0", Yt = new H(bT);
function fg(r) {
  return !!r.toHexString;
}
function ya(r) {
  return r.slice || (r.slice = function() {
    const e = Array.prototype.slice.call(arguments);
    return ya(new Uint8Array(Array.prototype.slice.apply(r, e)));
  }), r;
}
function Uo(r) {
  return Ye(r) && !(r.length % 2) || gs(r);
}
function Vh(r) {
  return typeof r == "number" && r == r && r % 1 === 0;
}
function gs(r) {
  if (r == null)
    return !1;
  if (r.constructor === Uint8Array)
    return !0;
  if (typeof r == "string" || !Vh(r.length) || r.length < 0)
    return !1;
  for (let e = 0; e < r.length; e++) {
    const t = r[e];
    if (!Vh(t) || t < 0 || t >= 256)
      return !1;
  }
  return !0;
}
function ve(r, e) {
  if (e || (e = {}), typeof r == "number") {
    Yt.checkSafeUint53(r, "invalid arrayify value");
    const t = [];
    for (; r; )
      t.unshift(r & 255), r = parseInt(String(r / 256));
    return t.length === 0 && t.push(0), ya(new Uint8Array(t));
  }
  if (e.allowMissingPrefix && typeof r == "string" && r.substring(0, 2) !== "0x" && (r = "0x" + r), fg(r) && (r = r.toHexString()), Ye(r)) {
    let t = r.substring(2);
    t.length % 2 && (e.hexPad === "left" ? t = "0" + t : e.hexPad === "right" ? t += "0" : Yt.throwArgumentError("hex data is odd-length", "value", r));
    const n = [];
    for (let i = 0; i < t.length; i += 2)
      n.push(parseInt(t.substring(i, i + 2), 16));
    return ya(new Uint8Array(n));
  }
  return gs(r) ? ya(new Uint8Array(r)) : Yt.throwArgumentError("invalid arrayify value", "value", r);
}
function Lt(r) {
  const e = r.map((i) => ve(i)), t = e.reduce((i, s) => i + s.length, 0), n = new Uint8Array(t);
  return e.reduce((i, s) => (n.set(s, i), i + s.length), 0), ya(n);
}
function mi(r) {
  let e = ve(r);
  if (e.length === 0)
    return e;
  let t = 0;
  for (; t < e.length && e[t] === 0; )
    t++;
  return t && (e = e.slice(t)), e;
}
function po(r, e) {
  r = ve(r), r.length > e && Yt.throwArgumentError("value out of range", "value", arguments[0]);
  const t = new Uint8Array(e);
  return t.set(r, e - r.length), ya(t);
}
function Ye(r, e) {
  return !(typeof r != "string" || !r.match(/^0x[0-9A-Fa-f]*$/) || e && r.length !== 2 + 2 * e);
}
const du = "0123456789abcdef";
function we(r, e) {
  if (e || (e = {}), typeof r == "number") {
    Yt.checkSafeUint53(r, "invalid hexlify value");
    let t = "";
    for (; r; )
      t = du[r & 15] + t, r = Math.floor(r / 16);
    return t.length ? (t.length % 2 && (t = "0" + t), "0x" + t) : "0x00";
  }
  if (typeof r == "bigint")
    return r = r.toString(16), r.length % 2 ? "0x0" + r : "0x" + r;
  if (e.allowMissingPrefix && typeof r == "string" && r.substring(0, 2) !== "0x" && (r = "0x" + r), fg(r))
    return r.toHexString();
  if (Ye(r))
    return r.length % 2 && (e.hexPad === "left" ? r = "0x0" + r.substring(2) : e.hexPad === "right" ? r += "0" : Yt.throwArgumentError("hex data is odd-length", "value", r)), r.toLowerCase();
  if (gs(r)) {
    let t = "0x";
    for (let n = 0; n < r.length; n++) {
      let i = r[n];
      t += du[(i & 240) >> 4] + du[i & 15];
    }
    return t;
  }
  return Yt.throwArgumentError("invalid hexlify value", "value", r);
}
function vi(r) {
  if (typeof r != "string")
    r = we(r);
  else if (!Ye(r) || r.length % 2)
    return null;
  return (r.length - 2) / 2;
}
function Qt(r, e, t) {
  return typeof r != "string" ? r = we(r) : (!Ye(r) || r.length % 2) && Yt.throwArgumentError("invalid hexData", "value", r), e = 2 + 2 * e, t != null ? "0x" + r.substring(e, 2 + 2 * t) : "0x" + r.substring(e);
}
function Kr(r) {
  let e = "0x";
  return r.forEach((t) => {
    e += we(t).substring(2);
  }), e;
}
function zo(r) {
  const e = hg(we(r, { hexPad: "left" }));
  return e === "0x" ? "0x0" : e;
}
function hg(r) {
  typeof r != "string" && (r = we(r)), Ye(r) || Yt.throwArgumentError("invalid hex string", "value", r), r = r.substring(2);
  let e = 0;
  for (; e < r.length && r[e] === "0"; )
    e++;
  return "0x" + r.substring(e);
}
function Dt(r, e) {
  for (typeof r != "string" ? r = we(r) : Ye(r) || Yt.throwArgumentError("invalid hex string", "value", r), r.length > 2 * e + 2 && Yt.throwArgumentError("value out of range", "value", arguments[1]); r.length < 2 * e + 2; )
    r = "0x0" + r.substring(2);
  return r;
}
function Vs(r) {
  const e = {
    r: "0x",
    s: "0x",
    _vs: "0x",
    recoveryParam: 0,
    v: 0,
    yParityAndS: "0x",
    compact: "0x"
  };
  if (Uo(r)) {
    let t = ve(r);
    t.length === 64 ? (e.v = 27 + (t[32] >> 7), t[32] &= 127, e.r = we(t.slice(0, 32)), e.s = we(t.slice(32, 64))) : t.length === 65 ? (e.r = we(t.slice(0, 32)), e.s = we(t.slice(32, 64)), e.v = t[64]) : Yt.throwArgumentError("invalid signature string", "signature", r), e.v < 27 && (e.v === 0 || e.v === 1 ? e.v += 27 : Yt.throwArgumentError("signature invalid v byte", "signature", r)), e.recoveryParam = 1 - e.v % 2, e.recoveryParam && (t[32] |= 128), e._vs = we(t.slice(32, 64));
  } else {
    if (e.r = r.r, e.s = r.s, e.v = r.v, e.recoveryParam = r.recoveryParam, e._vs = r._vs, e._vs != null) {
      const i = po(ve(e._vs), 32);
      e._vs = we(i);
      const s = i[0] >= 128 ? 1 : 0;
      e.recoveryParam == null ? e.recoveryParam = s : e.recoveryParam !== s && Yt.throwArgumentError("signature recoveryParam mismatch _vs", "signature", r), i[0] &= 127;
      const a = we(i);
      e.s == null ? e.s = a : e.s !== a && Yt.throwArgumentError("signature v mismatch _vs", "signature", r);
    }
    if (e.recoveryParam == null)
      e.v == null ? Yt.throwArgumentError("signature missing v and recoveryParam", "signature", r) : e.v === 0 || e.v === 1 ? e.recoveryParam = e.v : e.recoveryParam = 1 - e.v % 2;
    else if (e.v == null)
      e.v = 27 + e.recoveryParam;
    else {
      const i = e.v === 0 || e.v === 1 ? e.v : 1 - e.v % 2;
      e.recoveryParam !== i && Yt.throwArgumentError("signature recoveryParam mismatch v", "signature", r);
    }
    e.r == null || !Ye(e.r) ? Yt.throwArgumentError("signature missing or invalid r", "signature", r) : e.r = Dt(e.r, 32), e.s == null || !Ye(e.s) ? Yt.throwArgumentError("signature missing or invalid s", "signature", r) : e.s = Dt(e.s, 32);
    const t = ve(e.s);
    t[0] >= 128 && Yt.throwArgumentError("signature s out of range", "signature", r), e.recoveryParam && (t[0] |= 128);
    const n = we(t);
    e._vs && (Ye(e._vs) || Yt.throwArgumentError("signature invalid _vs", "signature", r), e._vs = Dt(e._vs, 32)), e._vs == null ? e._vs = n : e._vs !== n && Yt.throwArgumentError("signature _vs mismatch v and s", "signature", r);
  }
  return e.yParityAndS = e._vs, e.compact = e.r + e.yParityAndS.substring(2), e;
}
function wd(r) {
  return r = Vs(r), we(Lt([
    r.r,
    r.s,
    r.recoveryParam ? "0x1c" : "0x1b"
  ]));
}
const pg = "bignumber/5.7.0";
var Mo = $e.BN;
const Pi = new H(pg), fu = {}, $h = 9007199254740991;
function vT(r) {
  return r != null && (be.isBigNumber(r) || typeof r == "number" && r % 1 === 0 || typeof r == "string" && !!r.match(/^-?[0-9]+$/) || Ye(r) || typeof r == "bigint" || gs(r));
}
let Gh = !1;
class be {
  constructor(e, t) {
    e !== fu && Pi.throwError("cannot call constructor directly; use BigNumber.from", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = t, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(e) {
    return tn(st(this).fromTwos(e));
  }
  toTwos(e) {
    return tn(st(this).toTwos(e));
  }
  abs() {
    return this._hex[0] === "-" ? be.from(this._hex.substring(1)) : this;
  }
  add(e) {
    return tn(st(this).add(st(e)));
  }
  sub(e) {
    return tn(st(this).sub(st(e)));
  }
  div(e) {
    return be.from(e).isZero() && Mn("division-by-zero", "div"), tn(st(this).div(st(e)));
  }
  mul(e) {
    return tn(st(this).mul(st(e)));
  }
  mod(e) {
    const t = st(e);
    return t.isNeg() && Mn("division-by-zero", "mod"), tn(st(this).umod(t));
  }
  pow(e) {
    const t = st(e);
    return t.isNeg() && Mn("negative-power", "pow"), tn(st(this).pow(t));
  }
  and(e) {
    const t = st(e);
    return (this.isNegative() || t.isNeg()) && Mn("unbound-bitwise-result", "and"), tn(st(this).and(t));
  }
  or(e) {
    const t = st(e);
    return (this.isNegative() || t.isNeg()) && Mn("unbound-bitwise-result", "or"), tn(st(this).or(t));
  }
  xor(e) {
    const t = st(e);
    return (this.isNegative() || t.isNeg()) && Mn("unbound-bitwise-result", "xor"), tn(st(this).xor(t));
  }
  mask(e) {
    return (this.isNegative() || e < 0) && Mn("negative-width", "mask"), tn(st(this).maskn(e));
  }
  shl(e) {
    return (this.isNegative() || e < 0) && Mn("negative-width", "shl"), tn(st(this).shln(e));
  }
  shr(e) {
    return (this.isNegative() || e < 0) && Mn("negative-width", "shr"), tn(st(this).shrn(e));
  }
  eq(e) {
    return st(this).eq(st(e));
  }
  lt(e) {
    return st(this).lt(st(e));
  }
  lte(e) {
    return st(this).lte(st(e));
  }
  gt(e) {
    return st(this).gt(st(e));
  }
  gte(e) {
    return st(this).gte(st(e));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return st(this).isZero();
  }
  toNumber() {
    try {
      return st(this).toNumber();
    } catch {
      Mn("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Pi.throwError("this platform does not support BigInt", H.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? Gh || (Gh = !0, Pi.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Pi.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", H.errors.UNEXPECTED_ARGUMENT, {}) : Pi.throwError("BigNumber.toString does not accept parameters", H.errors.UNEXPECTED_ARGUMENT, {})), st(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(e) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(e) {
    if (e instanceof be)
      return e;
    if (typeof e == "string")
      return e.match(/^-?0x[0-9a-f]+$/i) ? new be(fu, Io(e)) : e.match(/^-?[0-9]+$/) ? new be(fu, Io(new Mo(e))) : Pi.throwArgumentError("invalid BigNumber string", "value", e);
    if (typeof e == "number")
      return e % 1 && Mn("underflow", "BigNumber.from", e), (e >= $h || e <= -$h) && Mn("overflow", "BigNumber.from", e), be.from(String(e));
    const t = e;
    if (typeof t == "bigint")
      return be.from(t.toString());
    if (gs(t))
      return be.from(we(t));
    if (t)
      if (t.toHexString) {
        const n = t.toHexString();
        if (typeof n == "string")
          return be.from(n);
      } else {
        let n = t._hex;
        if (n == null && t.type === "BigNumber" && (n = t.hex), typeof n == "string" && (Ye(n) || n[0] === "-" && Ye(n.substring(1))))
          return be.from(n);
      }
    return Pi.throwArgumentError("invalid BigNumber value", "value", e);
  }
  static isBigNumber(e) {
    return !!(e && e._isBigNumber);
  }
}
function Io(r) {
  if (typeof r != "string")
    return Io(r.toString(16));
  if (r[0] === "-")
    return r = r.substring(1), r[0] === "-" && Pi.throwArgumentError("invalid hex", "value", r), r = Io(r), r === "0x00" ? r : "-" + r;
  if (r.substring(0, 2) !== "0x" && (r = "0x" + r), r === "0x")
    return "0x00";
  for (r.length % 2 && (r = "0x0" + r.substring(2)); r.length > 4 && r.substring(0, 4) === "0x00"; )
    r = "0x" + r.substring(4);
  return r;
}
function tn(r) {
  return be.from(Io(r));
}
function st(r) {
  const e = be.from(r).toHexString();
  return e[0] === "-" ? new Mo("-" + e.substring(3), 16) : new Mo(e.substring(2), 16);
}
function Mn(r, e, t) {
  const n = { fault: r, operation: e };
  return t != null && (n.value = t), Pi.throwError(r, H.errors.NUMERIC_FAULT, n);
}
function yT(r) {
  return new Mo(r, 36).toString(16);
}
function wT(r) {
  return new Mo(r, 16).toString(36);
}
const Yr = new H(pg), mo = {}, mg = be.from(0), gg = be.from(-1);
function xg(r, e, t, n) {
  const i = { fault: e, operation: t };
  return n !== void 0 && (i.value = n), Yr.throwError(r, H.errors.NUMERIC_FAULT, i);
}
let go = "0";
for (; go.length < 256; )
  go += go;
function xf(r) {
  if (typeof r != "number")
    try {
      r = be.from(r).toNumber();
    } catch {
    }
  return typeof r == "number" && r >= 0 && r <= 256 && !(r % 1) ? "1" + go.substring(0, r) : Yr.throwArgumentError("invalid decimal size", "decimals", r);
}
function Ml(r, e) {
  e == null && (e = 0);
  const t = xf(e);
  r = be.from(r);
  const n = r.lt(mg);
  n && (r = r.mul(gg));
  let i = r.mod(t).toString();
  for (; i.length < t.length - 1; )
    i = "0" + i;
  i = i.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const s = r.div(t).toString();
  return t.length === 1 ? r = s : r = s + "." + i, n && (r = "-" + r), r;
}
function oi(r, e) {
  e == null && (e = 0);
  const t = xf(e);
  (typeof r != "string" || !r.match(/^-?[0-9.]+$/)) && Yr.throwArgumentError("invalid decimal value", "value", r);
  const n = r.substring(0, 1) === "-";
  n && (r = r.substring(1)), r === "." && Yr.throwArgumentError("missing value", "value", r);
  const i = r.split(".");
  i.length > 2 && Yr.throwArgumentError("too many decimal points", "value", r);
  let s = i[0], a = i[1];
  for (s || (s = "0"), a || (a = "0"); a[a.length - 1] === "0"; )
    a = a.substring(0, a.length - 1);
  for (a.length > t.length - 1 && xg("fractional component exceeds decimals", "underflow", "parseFixed"), a === "" && (a = "0"); a.length < t.length - 1; )
    a += "0";
  const o = be.from(s), l = be.from(a);
  let c = o.mul(t).add(l);
  return n && (c = c.mul(gg)), c;
}
class wa {
  constructor(e, t, n, i) {
    e !== mo && Yr.throwError("cannot use FixedFormat constructor; use FixedFormat.from", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = t, this.width = n, this.decimals = i, this.name = (t ? "" : "u") + "fixed" + String(n) + "x" + String(i), this._multiplier = xf(i), Object.freeze(this);
  }
  static from(e) {
    if (e instanceof wa)
      return e;
    typeof e == "number" && (e = `fixed128x${e}`);
    let t = !0, n = 128, i = 18;
    if (typeof e == "string") {
      if (e !== "fixed")
        if (e === "ufixed")
          t = !1;
        else {
          const s = e.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          s || Yr.throwArgumentError("invalid fixed format", "format", e), t = s[1] !== "u", n = parseInt(s[2]), i = parseInt(s[3]);
        }
    } else if (e) {
      const s = (a, o, l) => e[a] == null ? l : (typeof e[a] !== o && Yr.throwArgumentError("invalid fixed format (" + a + " not " + o + ")", "format." + a, e[a]), e[a]);
      t = s("signed", "boolean", t), n = s("width", "number", n), i = s("decimals", "number", i);
    }
    return n % 8 && Yr.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", n), i > 80 && Yr.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", i), new wa(mo, t, n, i);
  }
}
class mr {
  constructor(e, t, n, i) {
    e !== mo && Yr.throwError("cannot use FixedNumber constructor; use FixedNumber.from", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = i, this._hex = t, this._value = n, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(e) {
    this.format.name !== e.format.name && Yr.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", e);
  }
  addUnsafe(e) {
    this._checkFormat(e);
    const t = oi(this._value, this.format.decimals), n = oi(e._value, e.format.decimals);
    return mr.fromValue(t.add(n), this.format.decimals, this.format);
  }
  subUnsafe(e) {
    this._checkFormat(e);
    const t = oi(this._value, this.format.decimals), n = oi(e._value, e.format.decimals);
    return mr.fromValue(t.sub(n), this.format.decimals, this.format);
  }
  mulUnsafe(e) {
    this._checkFormat(e);
    const t = oi(this._value, this.format.decimals), n = oi(e._value, e.format.decimals);
    return mr.fromValue(t.mul(n).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(e) {
    this._checkFormat(e);
    const t = oi(this._value, this.format.decimals), n = oi(e._value, e.format.decimals);
    return mr.fromValue(t.mul(this.format._multiplier).div(n), this.format.decimals, this.format);
  }
  floor() {
    const e = this.toString().split(".");
    e.length === 1 && e.push("0");
    let t = mr.from(e[0], this.format);
    const n = !e[1].match(/^(0*)$/);
    return this.isNegative() && n && (t = t.subUnsafe(Kh.toFormat(t.format))), t;
  }
  ceiling() {
    const e = this.toString().split(".");
    e.length === 1 && e.push("0");
    let t = mr.from(e[0], this.format);
    const n = !e[1].match(/^(0*)$/);
    return !this.isNegative() && n && (t = t.addUnsafe(Kh.toFormat(t.format))), t;
  }
  // @TODO: Support other rounding algorithms
  round(e) {
    e == null && (e = 0);
    const t = this.toString().split(".");
    if (t.length === 1 && t.push("0"), (e < 0 || e > 80 || e % 1) && Yr.throwArgumentError("invalid decimal count", "decimals", e), t[1].length <= e)
      return this;
    const n = mr.from("1" + go.substring(0, e), this.format), i = _T.toFormat(this.format);
    return this.mulUnsafe(n).addUnsafe(i).floor().divUnsafe(n);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(e) {
    if (e == null)
      return this._hex;
    e % 8 && Yr.throwArgumentError("invalid byte width", "width", e);
    const t = be.from(this._hex).fromTwos(this.format.width).toTwos(e).toHexString();
    return Dt(t, e / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(e) {
    return mr.fromString(this._value, e);
  }
  static fromValue(e, t, n) {
    return n == null && t != null && !vT(t) && (n = t, t = null), t == null && (t = 0), n == null && (n = "fixed"), mr.fromString(Ml(e, t), wa.from(n));
  }
  static fromString(e, t) {
    t == null && (t = "fixed");
    const n = wa.from(t), i = oi(e, n.decimals);
    !n.signed && i.lt(mg) && xg("unsigned value cannot be negative", "overflow", "value", e);
    let s = null;
    n.signed ? s = i.toTwos(n.width).toHexString() : (s = i.toHexString(), s = Dt(s, n.width / 8));
    const a = Ml(i, n.decimals);
    return new mr(mo, s, a, n);
  }
  static fromBytes(e, t) {
    t == null && (t = "fixed");
    const n = wa.from(t);
    if (ve(e).length > n.width / 8)
      throw new Error("overflow");
    let i = be.from(e);
    n.signed && (i = i.fromTwos(n.width));
    const s = i.toTwos((n.signed ? 0 : 1) + n.width).toHexString(), a = Ml(i, n.decimals);
    return new mr(mo, s, a, n);
  }
  static from(e, t) {
    if (typeof e == "string")
      return mr.fromString(e, t);
    if (gs(e))
      return mr.fromBytes(e, t);
    try {
      return mr.fromValue(e, 0, t);
    } catch (n) {
      if (n.code !== H.errors.INVALID_ARGUMENT)
        throw n;
    }
    return Yr.throwArgumentError("invalid FixedNumber value", "value", e);
  }
  static isFixedNumber(e) {
    return !!(e && e._isFixedNumber);
  }
}
const Kh = mr.from(1), _T = mr.from("0.5"), ET = "properties/5.7.0";
var AT = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Vl = new H(ET);
function ie(r, e, t) {
  Object.defineProperty(r, e, {
    enumerable: !0,
    value: t,
    writable: !1
  });
}
function kr(r, e) {
  for (let t = 0; t < 32; t++) {
    if (r[e])
      return r[e];
    if (!r.prototype || typeof r.prototype != "object")
      break;
    r = Object.getPrototypeOf(r.prototype).constructor;
  }
  return null;
}
function qt(r) {
  return AT(this, void 0, void 0, function* () {
    const e = Object.keys(r).map((n) => {
      const i = r[n];
      return Promise.resolve(i).then((s) => ({ key: n, value: s }));
    });
    return (yield Promise.all(e)).reduce((n, i) => (n[i.key] = i.value, n), {});
  });
}
function bf(r, e) {
  (!r || typeof r != "object") && Vl.throwArgumentError("invalid object", "object", r), Object.keys(r).forEach((t) => {
    e[t] || Vl.throwArgumentError("invalid object key - " + t, "transaction:" + t, r);
  });
}
function Bt(r) {
  const e = {};
  for (const t in r)
    e[t] = r[t];
  return e;
}
const ST = { bigint: !0, boolean: !0, function: !0, number: !0, string: !0 };
function bg(r) {
  if (r == null || ST[typeof r])
    return !0;
  if (Array.isArray(r) || typeof r == "object") {
    if (!Object.isFrozen(r))
      return !1;
    const e = Object.keys(r);
    for (let t = 0; t < e.length; t++) {
      let n = null;
      try {
        n = r[e[t]];
      } catch {
        continue;
      }
      if (!bg(n))
        return !1;
    }
    return !0;
  }
  return Vl.throwArgumentError(`Cannot deepCopy ${typeof r}`, "object", r);
}
function TT(r) {
  if (bg(r))
    return r;
  if (Array.isArray(r))
    return Object.freeze(r.map((e) => Zr(e)));
  if (typeof r == "object") {
    const e = {};
    for (const t in r) {
      const n = r[t];
      n !== void 0 && ie(e, t, Zr(n));
    }
    return e;
  }
  return Vl.throwArgumentError(`Cannot deepCopy ${typeof r}`, "object", r);
}
function Zr(r) {
  return TT(r);
}
class $s {
  constructor(e) {
    for (const t in e)
      this[t] = Zr(e[t]);
  }
}
const Wo = "abi/5.7.0", ct = new H(Wo), Ds = {};
let Yh = { calldata: !0, memory: !0, storage: !0 }, MT = { calldata: !0, memory: !0 };
function cl(r, e) {
  if (r === "bytes" || r === "string") {
    if (Yh[e])
      return !0;
  } else if (r === "address") {
    if (e === "payable")
      return !0;
  } else if ((r.indexOf("[") >= 0 || r === "tuple") && MT[e])
    return !0;
  return (Yh[e] || e === "payable") && ct.throwArgumentError("invalid modifier", "name", e), !1;
}
function IT(r, e) {
  let t = r;
  function n(o) {
    ct.throwArgumentError(`unexpected character at position ${o}`, "param", r);
  }
  r = r.replace(/\s/g, " ");
  function i(o) {
    let l = { type: "", name: "", parent: o, state: { allowType: !0 } };
    return e && (l.indexed = !1), l;
  }
  let s = { type: "", name: "", state: { allowType: !0 } }, a = s;
  for (let o = 0; o < r.length; o++) {
    let l = r[o];
    switch (l) {
      case "(":
        a.state.allowType && a.type === "" ? a.type = "tuple" : a.state.allowParams || n(o), a.state.allowType = !1, a.type = ua(a.type), a.components = [i(a)], a = a.components[0];
        break;
      case ")":
        delete a.state, a.name === "indexed" && (e || n(o), a.indexed = !0, a.name = ""), cl(a.type, a.name) && (a.name = ""), a.type = ua(a.type);
        let c = a;
        a = a.parent, a || n(o), delete c.parent, a.state.allowParams = !1, a.state.allowName = !0, a.state.allowArray = !0;
        break;
      case ",":
        delete a.state, a.name === "indexed" && (e || n(o), a.indexed = !0, a.name = ""), cl(a.type, a.name) && (a.name = ""), a.type = ua(a.type);
        let u = i(a.parent);
        a.parent.components.push(u), delete a.parent, a = u;
        break;
      case " ":
        a.state.allowType && a.type !== "" && (a.type = ua(a.type), delete a.state.allowType, a.state.allowName = !0, a.state.allowParams = !0), a.state.allowName && a.name !== "" && (a.name === "indexed" ? (e || n(o), a.indexed && n(o), a.indexed = !0, a.name = "") : cl(a.type, a.name) ? a.name = "" : a.state.allowName = !1);
        break;
      case "[":
        a.state.allowArray || n(o), a.type += l, a.state.allowArray = !1, a.state.allowName = !1, a.state.readArray = !0;
        break;
      case "]":
        a.state.readArray || n(o), a.type += l, a.state.readArray = !1, a.state.allowArray = !0, a.state.allowName = !0;
        break;
      default:
        a.state.allowType ? (a.type += l, a.state.allowParams = !0, a.state.allowArray = !0) : a.state.allowName ? (a.name += l, delete a.state.allowArray) : a.state.readArray ? a.type += l : n(o);
    }
  }
  return a.parent && ct.throwArgumentError("unexpected eof", "param", r), delete s.state, a.name === "indexed" ? (e || n(t.length - 7), a.indexed && n(t.length - 7), a.indexed = !0, a.name = "") : cl(a.type, a.name) && (a.name = ""), s.type = ua(s.type), s;
}
function Il(r, e) {
  for (let t in e)
    ie(r, t, e[t]);
}
const xt = Object.freeze({
  // Bare formatting, as is needed for computing a sighash of an event or function
  sighash: "sighash",
  // Human-Readable with Minimal spacing and without names (compact human-readable)
  minimal: "minimal",
  // Human-Readable with nice spacing, including all names
  full: "full",
  // JSON-format a la Solidity
  json: "json"
}), CT = new RegExp(/^(.*)\[([0-9]*)\]$/);
class gr {
  constructor(e, t) {
    e !== Ds && ct.throwError("use fromString", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), Il(this, t);
    let n = this.type.match(CT);
    n ? Il(this, {
      arrayLength: parseInt(n[2] || "-1"),
      arrayChildren: gr.fromObject({
        type: n[1],
        components: this.components
      }),
      baseType: "array"
    }) : Il(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  // Format the parameter fragment
  //   - sighash: "(uint256,address)"
  //   - minimal: "tuple(uint256,address) indexed"
  //   - full:    "tuple(uint256 foo, address bar) indexed baz"
  format(e) {
    if (e || (e = xt.sighash), xt[e] || ct.throwArgumentError("invalid format type", "format", e), e === xt.json) {
      let n = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (n.indexed = this.indexed), this.components && (n.components = this.components.map((i) => JSON.parse(i.format(e)))), JSON.stringify(n);
    }
    let t = "";
    return this.baseType === "array" ? (t += this.arrayChildren.format(e), t += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (e !== xt.sighash && (t += this.type), t += "(" + this.components.map((n) => n.format(e)).join(e === xt.full ? ", " : ",") + ")") : t += this.type, e !== xt.sighash && (this.indexed === !0 && (t += " indexed"), e === xt.full && this.name && (t += " " + this.name)), t;
  }
  static from(e, t) {
    return typeof e == "string" ? gr.fromString(e, t) : gr.fromObject(e);
  }
  static fromObject(e) {
    return gr.isParamType(e) ? e : new gr(Ds, {
      name: e.name || null,
      type: ua(e.type),
      indexed: e.indexed == null ? null : !!e.indexed,
      components: e.components ? e.components.map(gr.fromObject) : null
    });
  }
  static fromString(e, t) {
    function n(i) {
      return gr.fromObject({
        name: i.name,
        type: i.type,
        indexed: i.indexed,
        components: i.components
      });
    }
    return n(IT(e, !!t));
  }
  static isParamType(e) {
    return !!(e != null && e._isParamType);
  }
}
function Co(r, e) {
  return kT(r).map((t) => gr.fromString(t, e));
}
class fi {
  constructor(e, t) {
    e !== Ds && ct.throwError("use a static from method", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new Fragment()"
    }), Il(this, t), this._isFragment = !0, Object.freeze(this);
  }
  static from(e) {
    return fi.isFragment(e) ? e : typeof e == "string" ? fi.fromString(e) : fi.fromObject(e);
  }
  static fromObject(e) {
    if (fi.isFragment(e))
      return e;
    switch (e.type) {
      case "function":
        return $n.fromObject(e);
      case "event":
        return di.fromObject(e);
      case "constructor":
        return Vn.fromObject(e);
      case "error":
        return Ri.fromObject(e);
      case "fallback":
      case "receive":
        return null;
    }
    return ct.throwArgumentError("invalid fragment object", "value", e);
  }
  static fromString(e) {
    return e = e.replace(/\s/g, " "), e = e.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " "), e = e.trim(), e.split(" ")[0] === "event" ? di.fromString(e.substring(5).trim()) : e.split(" ")[0] === "function" ? $n.fromString(e.substring(8).trim()) : e.split("(")[0].trim() === "constructor" ? Vn.fromString(e.trim()) : e.split(" ")[0] === "error" ? Ri.fromString(e.substring(5).trim()) : ct.throwArgumentError("unsupported fragment", "value", e);
  }
  static isFragment(e) {
    return !!(e && e._isFragment);
  }
}
class di extends fi {
  format(e) {
    if (e || (e = xt.sighash), xt[e] || ct.throwArgumentError("invalid format type", "format", e), e === xt.json)
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((n) => JSON.parse(n.format(e)))
      });
    let t = "";
    return e !== xt.sighash && (t += "event "), t += this.name + "(" + this.inputs.map((n) => n.format(e)).join(e === xt.full ? ", " : ",") + ") ", e !== xt.sighash && this.anonymous && (t += "anonymous "), t.trim();
  }
  static from(e) {
    return typeof e == "string" ? di.fromString(e) : di.fromObject(e);
  }
  static fromObject(e) {
    if (di.isEventFragment(e))
      return e;
    e.type !== "event" && ct.throwArgumentError("invalid event object", "value", e);
    const t = {
      name: Po(e.name),
      anonymous: e.anonymous,
      inputs: e.inputs ? e.inputs.map(gr.fromObject) : [],
      type: "event"
    };
    return new di(Ds, t);
  }
  static fromString(e) {
    let t = e.match(ko);
    t || ct.throwArgumentError("invalid event string", "value", e);
    let n = !1;
    return t[3].split(" ").forEach((i) => {
      switch (i.trim()) {
        case "anonymous":
          n = !0;
          break;
        case "":
          break;
        default:
          ct.warn("unknown modifier: " + i);
      }
    }), di.fromObject({
      name: t[1].trim(),
      anonymous: n,
      inputs: Co(t[2], !0),
      type: "event"
    });
  }
  static isEventFragment(e) {
    return e && e._isFragment && e.type === "event";
  }
}
function vg(r, e) {
  e.gas = null;
  let t = r.split("@");
  return t.length !== 1 ? (t.length > 2 && ct.throwArgumentError("invalid human-readable ABI signature", "value", r), t[1].match(/^[0-9]+$/) || ct.throwArgumentError("invalid human-readable ABI signature gas", "value", r), e.gas = be.from(t[1]), t[0]) : r;
}
function yg(r, e) {
  e.constant = !1, e.payable = !1, e.stateMutability = "nonpayable", r.split(" ").forEach((t) => {
    switch (t.trim()) {
      case "constant":
        e.constant = !0;
        break;
      case "payable":
        e.payable = !0, e.stateMutability = "payable";
        break;
      case "nonpayable":
        e.payable = !1, e.stateMutability = "nonpayable";
        break;
      case "pure":
        e.constant = !0, e.stateMutability = "pure";
        break;
      case "view":
        e.constant = !0, e.stateMutability = "view";
        break;
      case "external":
      case "public":
      case "":
        break;
      default:
        console.log("unknown modifier: " + t);
    }
  });
}
function wg(r) {
  let e = {
    constant: !1,
    payable: !0,
    stateMutability: "payable"
  };
  return r.stateMutability != null ? (e.stateMutability = r.stateMutability, e.constant = e.stateMutability === "view" || e.stateMutability === "pure", r.constant != null && !!r.constant !== e.constant && ct.throwArgumentError("cannot have constant function with mutability " + e.stateMutability, "value", r), e.payable = e.stateMutability === "payable", r.payable != null && !!r.payable !== e.payable && ct.throwArgumentError("cannot have payable function with mutability " + e.stateMutability, "value", r)) : r.payable != null ? (e.payable = !!r.payable, r.constant == null && !e.payable && r.type !== "constructor" && ct.throwArgumentError("unable to determine stateMutability", "value", r), e.constant = !!r.constant, e.constant ? e.stateMutability = "view" : e.stateMutability = e.payable ? "payable" : "nonpayable", e.payable && e.constant && ct.throwArgumentError("cannot have constant payable function", "value", r)) : r.constant != null ? (e.constant = !!r.constant, e.payable = !e.constant, e.stateMutability = e.constant ? "view" : "payable") : r.type !== "constructor" && ct.throwArgumentError("unable to determine stateMutability", "value", r), e;
}
class Vn extends fi {
  format(e) {
    if (e || (e = xt.sighash), xt[e] || ct.throwArgumentError("invalid format type", "format", e), e === xt.json)
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((n) => JSON.parse(n.format(e)))
      });
    e === xt.sighash && ct.throwError("cannot format a constructor for sighash", H.errors.UNSUPPORTED_OPERATION, {
      operation: "format(sighash)"
    });
    let t = "constructor(" + this.inputs.map((n) => n.format(e)).join(e === xt.full ? ", " : ",") + ") ";
    return this.stateMutability && this.stateMutability !== "nonpayable" && (t += this.stateMutability + " "), t.trim();
  }
  static from(e) {
    return typeof e == "string" ? Vn.fromString(e) : Vn.fromObject(e);
  }
  static fromObject(e) {
    if (Vn.isConstructorFragment(e))
      return e;
    e.type !== "constructor" && ct.throwArgumentError("invalid constructor object", "value", e);
    let t = wg(e);
    t.constant && ct.throwArgumentError("constructor cannot be constant", "value", e);
    const n = {
      name: null,
      type: e.type,
      inputs: e.inputs ? e.inputs.map(gr.fromObject) : [],
      payable: t.payable,
      stateMutability: t.stateMutability,
      gas: e.gas ? be.from(e.gas) : null
    };
    return new Vn(Ds, n);
  }
  static fromString(e) {
    let t = { type: "constructor" };
    e = vg(e, t);
    let n = e.match(ko);
    return (!n || n[1].trim() !== "constructor") && ct.throwArgumentError("invalid constructor string", "value", e), t.inputs = Co(n[2].trim(), !1), yg(n[3].trim(), t), Vn.fromObject(t);
  }
  static isConstructorFragment(e) {
    return e && e._isFragment && e.type === "constructor";
  }
}
class $n extends Vn {
  format(e) {
    if (e || (e = xt.sighash), xt[e] || ct.throwArgumentError("invalid format type", "format", e), e === xt.json)
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas ? this.gas.toNumber() : void 0,
        inputs: this.inputs.map((n) => JSON.parse(n.format(e))),
        outputs: this.outputs.map((n) => JSON.parse(n.format(e)))
      });
    let t = "";
    return e !== xt.sighash && (t += "function "), t += this.name + "(" + this.inputs.map((n) => n.format(e)).join(e === xt.full ? ", " : ",") + ") ", e !== xt.sighash && (this.stateMutability ? this.stateMutability !== "nonpayable" && (t += this.stateMutability + " ") : this.constant && (t += "view "), this.outputs && this.outputs.length && (t += "returns (" + this.outputs.map((n) => n.format(e)).join(", ") + ") "), this.gas != null && (t += "@" + this.gas.toString() + " ")), t.trim();
  }
  static from(e) {
    return typeof e == "string" ? $n.fromString(e) : $n.fromObject(e);
  }
  static fromObject(e) {
    if ($n.isFunctionFragment(e))
      return e;
    e.type !== "function" && ct.throwArgumentError("invalid function object", "value", e);
    let t = wg(e);
    const n = {
      type: e.type,
      name: Po(e.name),
      constant: t.constant,
      inputs: e.inputs ? e.inputs.map(gr.fromObject) : [],
      outputs: e.outputs ? e.outputs.map(gr.fromObject) : [],
      payable: t.payable,
      stateMutability: t.stateMutability,
      gas: e.gas ? be.from(e.gas) : null
    };
    return new $n(Ds, n);
  }
  static fromString(e) {
    let t = { type: "function" };
    e = vg(e, t);
    let n = e.split(" returns ");
    n.length > 2 && ct.throwArgumentError("invalid function string", "value", e);
    let i = n[0].match(ko);
    if (i || ct.throwArgumentError("invalid function signature", "value", e), t.name = i[1].trim(), t.name && Po(t.name), t.inputs = Co(i[2], !1), yg(i[3].trim(), t), n.length > 1) {
      let s = n[1].match(ko);
      (s[1].trim() != "" || s[3].trim() != "") && ct.throwArgumentError("unexpected tokens", "value", e), t.outputs = Co(s[2], !1);
    } else
      t.outputs = [];
    return $n.fromObject(t);
  }
  static isFunctionFragment(e) {
    return e && e._isFragment && e.type === "function";
  }
}
function qh(r) {
  const e = r.format();
  return (e === "Error(string)" || e === "Panic(uint256)") && ct.throwArgumentError(`cannot specify user defined ${e} error`, "fragment", r), r;
}
class Ri extends fi {
  format(e) {
    if (e || (e = xt.sighash), xt[e] || ct.throwArgumentError("invalid format type", "format", e), e === xt.json)
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((n) => JSON.parse(n.format(e)))
      });
    let t = "";
    return e !== xt.sighash && (t += "error "), t += this.name + "(" + this.inputs.map((n) => n.format(e)).join(e === xt.full ? ", " : ",") + ") ", t.trim();
  }
  static from(e) {
    return typeof e == "string" ? Ri.fromString(e) : Ri.fromObject(e);
  }
  static fromObject(e) {
    if (Ri.isErrorFragment(e))
      return e;
    e.type !== "error" && ct.throwArgumentError("invalid error object", "value", e);
    const t = {
      type: e.type,
      name: Po(e.name),
      inputs: e.inputs ? e.inputs.map(gr.fromObject) : []
    };
    return qh(new Ri(Ds, t));
  }
  static fromString(e) {
    let t = { type: "error" }, n = e.match(ko);
    return n || ct.throwArgumentError("invalid error signature", "value", e), t.name = n[1].trim(), t.name && Po(t.name), t.inputs = Co(n[2], !1), qh(Ri.fromObject(t));
  }
  static isErrorFragment(e) {
    return e && e._isFragment && e.type === "error";
  }
}
function ua(r) {
  return r.match(/^uint($|[^1-9])/) ? r = "uint256" + r.substring(4) : r.match(/^int($|[^1-9])/) && (r = "int256" + r.substring(3)), r;
}
const PT = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function Po(r) {
  return (!r || !r.match(PT)) && ct.throwArgumentError(`invalid identifier "${r}"`, "value", r), r;
}
const ko = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function kT(r) {
  r = r.trim();
  let e = [], t = "", n = 0;
  for (let i = 0; i < r.length; i++) {
    let s = r[i];
    s === "," && n === 0 ? (e.push(t), t = "") : (t += s, s === "(" ? n++ : s === ")" && (n--, n === -1 && ct.throwArgumentError("unbalanced parenthesis", "value", r)));
  }
  return t && e.push(t), e;
}
const vf = new H(Wo);
function _g(r) {
  const e = [], t = function(n, i) {
    if (Array.isArray(i))
      for (let s in i) {
        const a = n.slice();
        a.push(s);
        try {
          t(a, i[s]);
        } catch (o) {
          e.push({ path: a, error: o });
        }
      }
  };
  return t([], r), e;
}
class Hi {
  constructor(e, t, n, i) {
    this.name = e, this.type = t, this.localName = n, this.dynamic = i;
  }
  _throwError(e, t) {
    vf.throwArgumentError(e, this.localName, t);
  }
}
class _d {
  constructor(e) {
    ie(this, "wordSize", e || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(e);
  }
  get data() {
    return Kr(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(e) {
    return this._data.push(e), this._dataLength += e.length, e.length;
  }
  appendWriter(e) {
    return this._writeData(Lt(e._data));
  }
  // Arrayish items; padded on the right to wordSize
  writeBytes(e) {
    let t = ve(e);
    const n = t.length % this.wordSize;
    return n && (t = Lt([t, this._padding.slice(n)])), this._writeData(t);
  }
  _getValue(e) {
    let t = ve(be.from(e));
    return t.length > this.wordSize && vf.throwError("value out-of-bounds", H.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: t.length
    }), t.length % this.wordSize && (t = Lt([this._padding.slice(t.length % this.wordSize), t])), t;
  }
  // BigNumberish items; padded on the left to wordSize
  writeValue(e) {
    return this._writeData(this._getValue(e));
  }
  writeUpdatableValue() {
    const e = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (t) => {
      this._data[e] = this._getValue(t);
    };
  }
}
class $l {
  constructor(e, t, n, i) {
    ie(this, "_data", ve(e)), ie(this, "wordSize", t || 32), ie(this, "_coerceFunc", n), ie(this, "allowLoose", i), this._offset = 0;
  }
  get data() {
    return we(this._data);
  }
  get consumed() {
    return this._offset;
  }
  // The default Coerce function
  static coerce(e, t) {
    let n = e.match("^u?int([0-9]+)$");
    return n && parseInt(n[1]) <= 48 && (t = t.toNumber()), t;
  }
  coerce(e, t) {
    return this._coerceFunc ? this._coerceFunc(e, t) : $l.coerce(e, t);
  }
  _peekBytes(e, t, n) {
    let i = Math.ceil(t / this.wordSize) * this.wordSize;
    return this._offset + i > this._data.length && (this.allowLoose && n && this._offset + t <= this._data.length ? i = t : vf.throwError("data out-of-bounds", H.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + i
    })), this._data.slice(this._offset, this._offset + i);
  }
  subReader(e) {
    return new $l(this._data.slice(this._offset + e), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(e, t) {
    let n = this._peekBytes(0, e, !!t);
    return this._offset += n.length, n.slice(0, e);
  }
  readValue() {
    return be.from(this.readBytes(this.wordSize));
  }
}
var Eg = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(r) {
  (function() {
    var e = "input is invalid type", t = "finalize already called", n = typeof window == "object", i = n ? window : {};
    i.JS_SHA3_NO_WINDOW && (n = !1);
    var s = !n && typeof self == "object", a = !i.JS_SHA3_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    a ? i = jd : s && (i = self);
    var o = !i.JS_SHA3_NO_COMMON_JS && !0 && r.exports, l = !i.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), u = [31, 7936, 2031616, 520093696], f = [4, 1024, 262144, 67108864], p = [1, 256, 65536, 16777216], x = [6, 1536, 393216, 100663296], T = [0, 8, 16, 24], v = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], w = [224, 256, 384, 512], E = [128, 256], C = ["hex", "buffer", "arrayBuffer", "array", "digest"], P = {
      128: 168,
      256: 136
    };
    (i.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(g) {
      return Object.prototype.toString.call(g) === "[object Array]";
    }), l && (i.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(g) {
      return typeof g == "object" && g.buffer && g.buffer.constructor === ArrayBuffer;
    });
    for (var F = function(g, G, Q) {
      return function(J) {
        return new h(g, G, g).update(J)[Q]();
      };
    }, k = function(g, G, Q) {
      return function(J, X) {
        return new h(g, G, X).update(J)[Q]();
      };
    }, K = function(g, G, Q) {
      return function(J, X, pe, ce) {
        return d["cshake" + g].update(J, X, pe, ce)[Q]();
      };
    }, Z = function(g, G, Q) {
      return function(J, X, pe, ce) {
        return d["kmac" + g].update(J, X, pe, ce)[Q]();
      };
    }, ne = function(g, G, Q, J) {
      for (var X = 0; X < C.length; ++X) {
        var pe = C[X];
        g[pe] = G(Q, J, pe);
      }
      return g;
    }, le = function(g, G) {
      var Q = F(g, G, "hex");
      return Q.create = function() {
        return new h(g, G, g);
      }, Q.update = function(J) {
        return Q.create().update(J);
      }, ne(Q, F, g, G);
    }, ye = function(g, G) {
      var Q = k(g, G, "hex");
      return Q.create = function(J) {
        return new h(g, G, J);
      }, Q.update = function(J, X) {
        return Q.create(X).update(J);
      }, ne(Q, k, g, G);
    }, ge = function(g, G) {
      var Q = P[g], J = K(g, G, "hex");
      return J.create = function(X, pe, ce) {
        return !pe && !ce ? d["shake" + g].create(X) : new h(g, G, X).bytepad([pe, ce], Q);
      }, J.update = function(X, pe, ce, ue) {
        return J.create(pe, ce, ue).update(X);
      }, ne(J, K, g, G);
    }, _e = function(g, G) {
      var Q = P[g], J = Z(g, G, "hex");
      return J.create = function(X, pe, ce) {
        return new I(g, G, pe).bytepad(["KMAC", ce], Q).bytepad([X], Q);
      }, J.update = function(X, pe, ce, ue) {
        return J.create(X, ce, ue).update(pe);
      }, ne(J, Z, g, G);
    }, L = [
      { name: "keccak", padding: p, bits: w, createMethod: le },
      { name: "sha3", padding: x, bits: w, createMethod: le },
      { name: "shake", padding: u, bits: E, createMethod: ye },
      { name: "cshake", padding: f, bits: E, createMethod: ge },
      { name: "kmac", padding: f, bits: E, createMethod: _e }
    ], d = {}, b = [], S = 0; S < L.length; ++S)
      for (var R = L[S], D = R.bits, z = 0; z < D.length; ++z) {
        var q = R.name + "_" + D[z];
        if (b.push(q), d[q] = R.createMethod(D[z], R.padding), R.name !== "sha3") {
          var y = R.name + D[z];
          b.push(y), d[y] = d[q];
        }
      }
    function h(g, G, Q) {
      this.blocks = [], this.s = [], this.padding = G, this.outputBits = Q, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (g << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = Q >> 5, this.extraBytes = (Q & 31) >> 3;
      for (var J = 0; J < 50; ++J)
        this.s[J] = 0;
    }
    h.prototype.update = function(g) {
      if (this.finalized)
        throw new Error(t);
      var G, Q = typeof g;
      if (Q !== "string") {
        if (Q === "object") {
          if (g === null)
            throw new Error(e);
          if (l && g.constructor === ArrayBuffer)
            g = new Uint8Array(g);
          else if (!Array.isArray(g) && (!l || !ArrayBuffer.isView(g)))
            throw new Error(e);
        } else
          throw new Error(e);
        G = !0;
      }
      for (var J = this.blocks, X = this.byteCount, pe = g.length, ce = this.blockCount, ue = 0, B = this.s, A, $; ue < pe; ) {
        if (this.reset)
          for (this.reset = !1, J[0] = this.block, A = 1; A < ce + 1; ++A)
            J[A] = 0;
        if (G)
          for (A = this.start; ue < pe && A < X; ++ue)
            J[A >> 2] |= g[ue] << T[A++ & 3];
        else
          for (A = this.start; ue < pe && A < X; ++ue)
            $ = g.charCodeAt(ue), $ < 128 ? J[A >> 2] |= $ << T[A++ & 3] : $ < 2048 ? (J[A >> 2] |= (192 | $ >> 6) << T[A++ & 3], J[A >> 2] |= (128 | $ & 63) << T[A++ & 3]) : $ < 55296 || $ >= 57344 ? (J[A >> 2] |= (224 | $ >> 12) << T[A++ & 3], J[A >> 2] |= (128 | $ >> 6 & 63) << T[A++ & 3], J[A >> 2] |= (128 | $ & 63) << T[A++ & 3]) : ($ = 65536 + (($ & 1023) << 10 | g.charCodeAt(++ue) & 1023), J[A >> 2] |= (240 | $ >> 18) << T[A++ & 3], J[A >> 2] |= (128 | $ >> 12 & 63) << T[A++ & 3], J[A >> 2] |= (128 | $ >> 6 & 63) << T[A++ & 3], J[A >> 2] |= (128 | $ & 63) << T[A++ & 3]);
        if (this.lastByteIndex = A, A >= X) {
          for (this.start = A - X, this.block = J[ce], A = 0; A < ce; ++A)
            B[A] ^= J[A];
          V(B), this.reset = !0;
        } else
          this.start = A;
      }
      return this;
    }, h.prototype.encode = function(g, G) {
      var Q = g & 255, J = 1, X = [Q];
      for (g = g >> 8, Q = g & 255; Q > 0; )
        X.unshift(Q), g = g >> 8, Q = g & 255, ++J;
      return G ? X.push(J) : X.unshift(J), this.update(X), X.length;
    }, h.prototype.encodeString = function(g) {
      var G, Q = typeof g;
      if (Q !== "string") {
        if (Q === "object") {
          if (g === null)
            throw new Error(e);
          if (l && g.constructor === ArrayBuffer)
            g = new Uint8Array(g);
          else if (!Array.isArray(g) && (!l || !ArrayBuffer.isView(g)))
            throw new Error(e);
        } else
          throw new Error(e);
        G = !0;
      }
      var J = 0, X = g.length;
      if (G)
        J = X;
      else
        for (var pe = 0; pe < g.length; ++pe) {
          var ce = g.charCodeAt(pe);
          ce < 128 ? J += 1 : ce < 2048 ? J += 2 : ce < 55296 || ce >= 57344 ? J += 3 : (ce = 65536 + ((ce & 1023) << 10 | g.charCodeAt(++pe) & 1023), J += 4);
        }
      return J += this.encode(J * 8), this.update(g), J;
    }, h.prototype.bytepad = function(g, G) {
      for (var Q = this.encode(G), J = 0; J < g.length; ++J)
        Q += this.encodeString(g[J]);
      var X = G - Q % G, pe = [];
      return pe.length = X, this.update(pe), this;
    }, h.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var g = this.blocks, G = this.lastByteIndex, Q = this.blockCount, J = this.s;
        if (g[G >> 2] |= this.padding[G & 3], this.lastByteIndex === this.byteCount)
          for (g[0] = g[Q], G = 1; G < Q + 1; ++G)
            g[G] = 0;
        for (g[Q - 1] |= 2147483648, G = 0; G < Q; ++G)
          J[G] ^= g[G];
        V(J);
      }
    }, h.prototype.toString = h.prototype.hex = function() {
      this.finalize();
      for (var g = this.blockCount, G = this.s, Q = this.outputBlocks, J = this.extraBytes, X = 0, pe = 0, ce = "", ue; pe < Q; ) {
        for (X = 0; X < g && pe < Q; ++X, ++pe)
          ue = G[X], ce += c[ue >> 4 & 15] + c[ue & 15] + c[ue >> 12 & 15] + c[ue >> 8 & 15] + c[ue >> 20 & 15] + c[ue >> 16 & 15] + c[ue >> 28 & 15] + c[ue >> 24 & 15];
        pe % g === 0 && (V(G), X = 0);
      }
      return J && (ue = G[X], ce += c[ue >> 4 & 15] + c[ue & 15], J > 1 && (ce += c[ue >> 12 & 15] + c[ue >> 8 & 15]), J > 2 && (ce += c[ue >> 20 & 15] + c[ue >> 16 & 15])), ce;
    }, h.prototype.arrayBuffer = function() {
      this.finalize();
      var g = this.blockCount, G = this.s, Q = this.outputBlocks, J = this.extraBytes, X = 0, pe = 0, ce = this.outputBits >> 3, ue;
      J ? ue = new ArrayBuffer(Q + 1 << 2) : ue = new ArrayBuffer(ce);
      for (var B = new Uint32Array(ue); pe < Q; ) {
        for (X = 0; X < g && pe < Q; ++X, ++pe)
          B[pe] = G[X];
        pe % g === 0 && V(G);
      }
      return J && (B[X] = G[X], ue = ue.slice(0, ce)), ue;
    }, h.prototype.buffer = h.prototype.arrayBuffer, h.prototype.digest = h.prototype.array = function() {
      this.finalize();
      for (var g = this.blockCount, G = this.s, Q = this.outputBlocks, J = this.extraBytes, X = 0, pe = 0, ce = [], ue, B; pe < Q; ) {
        for (X = 0; X < g && pe < Q; ++X, ++pe)
          ue = pe << 2, B = G[X], ce[ue] = B & 255, ce[ue + 1] = B >> 8 & 255, ce[ue + 2] = B >> 16 & 255, ce[ue + 3] = B >> 24 & 255;
        pe % g === 0 && V(G);
      }
      return J && (ue = pe << 2, B = G[X], ce[ue] = B & 255, J > 1 && (ce[ue + 1] = B >> 8 & 255), J > 2 && (ce[ue + 2] = B >> 16 & 255)), ce;
    };
    function I(g, G, Q) {
      h.call(this, g, G, Q);
    }
    I.prototype = new h(), I.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), h.prototype.finalize.call(this);
    };
    var V = function(g) {
      var G, Q, J, X, pe, ce, ue, B, A, $, de, xe, Ae, ut, Le, Re, Me, re, fe, Mt, Fe, dt, Sr, rt, Ze, Tr, ft, _t, En, vt, It, Jr, Be, We, Lr, lt, yt, Xr, Et, At, Je, Ve, Ct, Zt, nt, bt, rr, Xe, pt, Vr, ht, it, cn, St, Tt, un, Ue, mt, Ft, Ut, nr, cr, zt;
      for (J = 0; J < 48; J += 2)
        X = g[0] ^ g[10] ^ g[20] ^ g[30] ^ g[40], pe = g[1] ^ g[11] ^ g[21] ^ g[31] ^ g[41], ce = g[2] ^ g[12] ^ g[22] ^ g[32] ^ g[42], ue = g[3] ^ g[13] ^ g[23] ^ g[33] ^ g[43], B = g[4] ^ g[14] ^ g[24] ^ g[34] ^ g[44], A = g[5] ^ g[15] ^ g[25] ^ g[35] ^ g[45], $ = g[6] ^ g[16] ^ g[26] ^ g[36] ^ g[46], de = g[7] ^ g[17] ^ g[27] ^ g[37] ^ g[47], xe = g[8] ^ g[18] ^ g[28] ^ g[38] ^ g[48], Ae = g[9] ^ g[19] ^ g[29] ^ g[39] ^ g[49], G = xe ^ (ce << 1 | ue >>> 31), Q = Ae ^ (ue << 1 | ce >>> 31), g[0] ^= G, g[1] ^= Q, g[10] ^= G, g[11] ^= Q, g[20] ^= G, g[21] ^= Q, g[30] ^= G, g[31] ^= Q, g[40] ^= G, g[41] ^= Q, G = X ^ (B << 1 | A >>> 31), Q = pe ^ (A << 1 | B >>> 31), g[2] ^= G, g[3] ^= Q, g[12] ^= G, g[13] ^= Q, g[22] ^= G, g[23] ^= Q, g[32] ^= G, g[33] ^= Q, g[42] ^= G, g[43] ^= Q, G = ce ^ ($ << 1 | de >>> 31), Q = ue ^ (de << 1 | $ >>> 31), g[4] ^= G, g[5] ^= Q, g[14] ^= G, g[15] ^= Q, g[24] ^= G, g[25] ^= Q, g[34] ^= G, g[35] ^= Q, g[44] ^= G, g[45] ^= Q, G = B ^ (xe << 1 | Ae >>> 31), Q = A ^ (Ae << 1 | xe >>> 31), g[6] ^= G, g[7] ^= Q, g[16] ^= G, g[17] ^= Q, g[26] ^= G, g[27] ^= Q, g[36] ^= G, g[37] ^= Q, g[46] ^= G, g[47] ^= Q, G = $ ^ (X << 1 | pe >>> 31), Q = de ^ (pe << 1 | X >>> 31), g[8] ^= G, g[9] ^= Q, g[18] ^= G, g[19] ^= Q, g[28] ^= G, g[29] ^= Q, g[38] ^= G, g[39] ^= Q, g[48] ^= G, g[49] ^= Q, ut = g[0], Le = g[1], bt = g[11] << 4 | g[10] >>> 28, rr = g[10] << 4 | g[11] >>> 28, _t = g[20] << 3 | g[21] >>> 29, En = g[21] << 3 | g[20] >>> 29, Ut = g[31] << 9 | g[30] >>> 23, nr = g[30] << 9 | g[31] >>> 23, Ve = g[40] << 18 | g[41] >>> 14, Ct = g[41] << 18 | g[40] >>> 14, We = g[2] << 1 | g[3] >>> 31, Lr = g[3] << 1 | g[2] >>> 31, Re = g[13] << 12 | g[12] >>> 20, Me = g[12] << 12 | g[13] >>> 20, Xe = g[22] << 10 | g[23] >>> 22, pt = g[23] << 10 | g[22] >>> 22, vt = g[33] << 13 | g[32] >>> 19, It = g[32] << 13 | g[33] >>> 19, cr = g[42] << 2 | g[43] >>> 30, zt = g[43] << 2 | g[42] >>> 30, St = g[5] << 30 | g[4] >>> 2, Tt = g[4] << 30 | g[5] >>> 2, lt = g[14] << 6 | g[15] >>> 26, yt = g[15] << 6 | g[14] >>> 26, re = g[25] << 11 | g[24] >>> 21, fe = g[24] << 11 | g[25] >>> 21, Vr = g[34] << 15 | g[35] >>> 17, ht = g[35] << 15 | g[34] >>> 17, Jr = g[45] << 29 | g[44] >>> 3, Be = g[44] << 29 | g[45] >>> 3, rt = g[6] << 28 | g[7] >>> 4, Ze = g[7] << 28 | g[6] >>> 4, un = g[17] << 23 | g[16] >>> 9, Ue = g[16] << 23 | g[17] >>> 9, Xr = g[26] << 25 | g[27] >>> 7, Et = g[27] << 25 | g[26] >>> 7, Mt = g[36] << 21 | g[37] >>> 11, Fe = g[37] << 21 | g[36] >>> 11, it = g[47] << 24 | g[46] >>> 8, cn = g[46] << 24 | g[47] >>> 8, Zt = g[8] << 27 | g[9] >>> 5, nt = g[9] << 27 | g[8] >>> 5, Tr = g[18] << 20 | g[19] >>> 12, ft = g[19] << 20 | g[18] >>> 12, mt = g[29] << 7 | g[28] >>> 25, Ft = g[28] << 7 | g[29] >>> 25, At = g[38] << 8 | g[39] >>> 24, Je = g[39] << 8 | g[38] >>> 24, dt = g[48] << 14 | g[49] >>> 18, Sr = g[49] << 14 | g[48] >>> 18, g[0] = ut ^ ~Re & re, g[1] = Le ^ ~Me & fe, g[10] = rt ^ ~Tr & _t, g[11] = Ze ^ ~ft & En, g[20] = We ^ ~lt & Xr, g[21] = Lr ^ ~yt & Et, g[30] = Zt ^ ~bt & Xe, g[31] = nt ^ ~rr & pt, g[40] = St ^ ~un & mt, g[41] = Tt ^ ~Ue & Ft, g[2] = Re ^ ~re & Mt, g[3] = Me ^ ~fe & Fe, g[12] = Tr ^ ~_t & vt, g[13] = ft ^ ~En & It, g[22] = lt ^ ~Xr & At, g[23] = yt ^ ~Et & Je, g[32] = bt ^ ~Xe & Vr, g[33] = rr ^ ~pt & ht, g[42] = un ^ ~mt & Ut, g[43] = Ue ^ ~Ft & nr, g[4] = re ^ ~Mt & dt, g[5] = fe ^ ~Fe & Sr, g[14] = _t ^ ~vt & Jr, g[15] = En ^ ~It & Be, g[24] = Xr ^ ~At & Ve, g[25] = Et ^ ~Je & Ct, g[34] = Xe ^ ~Vr & it, g[35] = pt ^ ~ht & cn, g[44] = mt ^ ~Ut & cr, g[45] = Ft ^ ~nr & zt, g[6] = Mt ^ ~dt & ut, g[7] = Fe ^ ~Sr & Le, g[16] = vt ^ ~Jr & rt, g[17] = It ^ ~Be & Ze, g[26] = At ^ ~Ve & We, g[27] = Je ^ ~Ct & Lr, g[36] = Vr ^ ~it & Zt, g[37] = ht ^ ~cn & nt, g[46] = Ut ^ ~cr & St, g[47] = nr ^ ~zt & Tt, g[8] = dt ^ ~ut & Re, g[9] = Sr ^ ~Le & Me, g[18] = Jr ^ ~rt & Tr, g[19] = Be ^ ~Ze & ft, g[28] = Ve ^ ~We & lt, g[29] = Ct ^ ~Lr & yt, g[38] = it ^ ~Zt & bt, g[39] = cn ^ ~nt & rr, g[48] = cr ^ ~St & un, g[49] = zt ^ ~Tt & Ue, g[0] ^= v[J], g[1] ^= v[J + 1];
    };
    if (o)
      r.exports = d;
    else
      for (S = 0; S < b.length; ++S)
        i[b[S]] = d[b[S]];
  })();
})(Eg);
var OT = Eg.exports;
const NT = /* @__PURE__ */ zi(OT);
function Nt(r) {
  return "0x" + NT.keccak_256(ve(r));
}
const RT = "rlp/5.7.0", li = new H(RT);
function Zh(r) {
  const e = [];
  for (; r; )
    e.unshift(r & 255), r >>= 8;
  return e;
}
function Jh(r, e, t) {
  let n = 0;
  for (let i = 0; i < t; i++)
    n = n * 256 + r[e + i];
  return n;
}
function Ag(r) {
  if (Array.isArray(r)) {
    let n = [];
    if (r.forEach(function(s) {
      n = n.concat(Ag(s));
    }), n.length <= 55)
      return n.unshift(192 + n.length), n;
    const i = Zh(n.length);
    return i.unshift(247 + i.length), i.concat(n);
  }
  Uo(r) || li.throwArgumentError("RLP object must be BytesLike", "object", r);
  const e = Array.prototype.slice.call(ve(r));
  if (e.length === 1 && e[0] <= 127)
    return e;
  if (e.length <= 55)
    return e.unshift(128 + e.length), e;
  const t = Zh(e.length);
  return t.unshift(183 + t.length), t.concat(e);
}
function Fs(r) {
  return we(Ag(r));
}
function Xh(r, e, t, n) {
  const i = [];
  for (; t < e + 1 + n; ) {
    const s = Sg(r, t);
    i.push(s.result), t += s.consumed, t > e + 1 + n && li.throwError("child data too short", H.errors.BUFFER_OVERRUN, {});
  }
  return { consumed: 1 + n, result: i };
}
function Sg(r, e) {
  if (r.length === 0 && li.throwError("data too short", H.errors.BUFFER_OVERRUN, {}), r[e] >= 248) {
    const t = r[e] - 247;
    e + 1 + t > r.length && li.throwError("data short segment too short", H.errors.BUFFER_OVERRUN, {});
    const n = Jh(r, e + 1, t);
    return e + 1 + t + n > r.length && li.throwError("data long segment too short", H.errors.BUFFER_OVERRUN, {}), Xh(r, e, e + 1 + t, t + n);
  } else if (r[e] >= 192) {
    const t = r[e] - 192;
    return e + 1 + t > r.length && li.throwError("data array too short", H.errors.BUFFER_OVERRUN, {}), Xh(r, e, e + 1, t);
  } else if (r[e] >= 184) {
    const t = r[e] - 183;
    e + 1 + t > r.length && li.throwError("data array too short", H.errors.BUFFER_OVERRUN, {});
    const n = Jh(r, e + 1, t);
    e + 1 + t + n > r.length && li.throwError("data array too short", H.errors.BUFFER_OVERRUN, {});
    const i = we(r.slice(e + 1 + t, e + 1 + t + n));
    return { consumed: 1 + t + n, result: i };
  } else if (r[e] >= 128) {
    const t = r[e] - 128;
    e + 1 + t > r.length && li.throwError("data too short", H.errors.BUFFER_OVERRUN, {});
    const n = we(r.slice(e + 1, e + 1 + t));
    return { consumed: 1 + t, result: n };
  }
  return { consumed: 1, result: we(r[e]) };
}
function bc(r) {
  const e = ve(r), t = Sg(e, 0);
  return t.consumed !== e.length && li.throwArgumentError("invalid rlp data", "data", r), t.result;
}
const LT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: bc,
  encode: Fs
}, Symbol.toStringTag, { value: "Module" })), DT = "address/5.7.0", ls = new H(DT);
function Qh(r) {
  Ye(r, 20) || ls.throwArgumentError("invalid address", "address", r), r = r.toLowerCase();
  const e = r.substring(2).split(""), t = new Uint8Array(40);
  for (let i = 0; i < 40; i++)
    t[i] = e[i].charCodeAt(0);
  const n = ve(Nt(t));
  for (let i = 0; i < 40; i += 2)
    n[i >> 1] >> 4 >= 8 && (e[i] = e[i].toUpperCase()), (n[i >> 1] & 15) >= 8 && (e[i + 1] = e[i + 1].toUpperCase());
  return "0x" + e.join("");
}
const FT = 9007199254740991;
function BT(r) {
  return Math.log10 ? Math.log10(r) : Math.log(r) / Math.LN10;
}
const yf = {};
for (let r = 0; r < 10; r++)
  yf[String(r)] = String(r);
for (let r = 0; r < 26; r++)
  yf[String.fromCharCode(65 + r)] = String(10 + r);
const e1 = Math.floor(BT(FT));
function Tg(r) {
  r = r.toUpperCase(), r = r.substring(4) + r.substring(0, 2) + "00";
  let e = r.split("").map((n) => yf[n]).join("");
  for (; e.length >= e1; ) {
    let n = e.substring(0, e1);
    e = parseInt(n, 10) % 97 + e.substring(n.length);
  }
  let t = String(98 - parseInt(e, 10) % 97);
  for (; t.length < 2; )
    t = "0" + t;
  return t;
}
function kt(r) {
  let e = null;
  if (typeof r != "string" && ls.throwArgumentError("invalid address", "address", r), r.match(/^(0x)?[0-9a-fA-F]{40}$/))
    r.substring(0, 2) !== "0x" && (r = "0x" + r), e = Qh(r), r.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== r && ls.throwArgumentError("bad address checksum", "address", r);
  else if (r.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (r.substring(2, 4) !== Tg(r) && ls.throwArgumentError("bad icap checksum", "address", r), e = yT(r.substring(4)); e.length < 40; )
      e = "0" + e;
    e = Qh("0x" + e);
  } else
    ls.throwArgumentError("invalid address", "address", r);
  return e;
}
function jT(r) {
  try {
    return kt(r), !0;
  } catch {
  }
  return !1;
}
function UT(r) {
  let e = wT(kt(r).substring(2)).toUpperCase();
  for (; e.length < 30; )
    e = "0" + e;
  return "XE" + Tg("XE00" + e) + e;
}
function vc(r) {
  let e = null;
  try {
    e = kt(r.from);
  } catch {
    ls.throwArgumentError("missing from address", "transaction", r);
  }
  const t = mi(ve(be.from(r.nonce).toHexString()));
  return kt(Qt(Nt(Fs([e, t])), 12));
}
function zT(r, e, t) {
  return vi(e) !== 32 && ls.throwArgumentError("salt must be 32 bytes", "salt", e), vi(t) !== 32 && ls.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", t), kt(Qt(Nt(Lt(["0xff", kt(r), e, t])), 12));
}
class WT extends Hi {
  constructor(e) {
    super("address", "address", e, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(e, t) {
    try {
      t = kt(t);
    } catch (n) {
      this._throwError(n.message, t);
    }
    return e.writeValue(t);
  }
  decode(e) {
    return kt(Dt(e.readValue().toHexString(), 20));
  }
}
class HT extends Hi {
  constructor(e) {
    super(e.name, e.type, void 0, e.dynamic), this.coder = e;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(e, t) {
    return this.coder.encode(e, t);
  }
  decode(e) {
    return this.coder.decode(e);
  }
}
const ma = new H(Wo);
function Mg(r, e, t) {
  let n = null;
  if (Array.isArray(t))
    n = t;
  else if (t && typeof t == "object") {
    let l = {};
    n = e.map((c) => {
      const u = c.localName;
      return u || ma.throwError("cannot encode object for signature with missing names", H.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: c,
        value: t
      }), l[u] && ma.throwError("cannot encode object for signature with duplicate names", H.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: c,
        value: t
      }), l[u] = !0, t[u];
    });
  } else
    ma.throwArgumentError("invalid tuple value", "tuple", t);
  e.length !== n.length && ma.throwArgumentError("types/value length mismatch", "tuple", t);
  let i = new _d(r.wordSize), s = new _d(r.wordSize), a = [];
  e.forEach((l, c) => {
    let u = n[c];
    if (l.dynamic) {
      let f = s.length;
      l.encode(s, u);
      let p = i.writeUpdatableValue();
      a.push((x) => {
        p(x + f);
      });
    } else
      l.encode(i, u);
  }), a.forEach((l) => {
    l(i.length);
  });
  let o = r.appendWriter(i);
  return o += r.appendWriter(s), o;
}
function Ig(r, e) {
  let t = [], n = r.subReader(0);
  e.forEach((s) => {
    let a = null;
    if (s.dynamic) {
      let o = r.readValue(), l = n.subReader(o.toNumber());
      try {
        a = s.decode(l);
      } catch (c) {
        if (c.code === H.errors.BUFFER_OVERRUN)
          throw c;
        a = c, a.baseType = s.name, a.name = s.localName, a.type = s.type;
      }
    } else
      try {
        a = s.decode(r);
      } catch (o) {
        if (o.code === H.errors.BUFFER_OVERRUN)
          throw o;
        a = o, a.baseType = s.name, a.name = s.localName, a.type = s.type;
      }
    a != null && t.push(a);
  });
  const i = e.reduce((s, a) => {
    const o = a.localName;
    return o && (s[o] || (s[o] = 0), s[o]++), s;
  }, {});
  e.forEach((s, a) => {
    let o = s.localName;
    if (!o || i[o] !== 1 || (o === "length" && (o = "_length"), t[o] != null))
      return;
    const l = t[a];
    l instanceof Error ? Object.defineProperty(t, o, {
      enumerable: !0,
      get: () => {
        throw l;
      }
    }) : t[o] = l;
  });
  for (let s = 0; s < t.length; s++) {
    const a = t[s];
    a instanceof Error && Object.defineProperty(t, s, {
      enumerable: !0,
      get: () => {
        throw a;
      }
    });
  }
  return Object.freeze(t);
}
class VT extends Hi {
  constructor(e, t, n) {
    const i = e.type + "[" + (t >= 0 ? t : "") + "]", s = t === -1 || e.dynamic;
    super("array", i, n, s), this.coder = e, this.length = t;
  }
  defaultValue() {
    const e = this.coder.defaultValue(), t = [];
    for (let n = 0; n < this.length; n++)
      t.push(e);
    return t;
  }
  encode(e, t) {
    Array.isArray(t) || this._throwError("expected array value", t);
    let n = this.length;
    n === -1 && (n = t.length, e.writeValue(t.length)), ma.checkArgumentCount(t.length, n, "coder array" + (this.localName ? " " + this.localName : ""));
    let i = [];
    for (let s = 0; s < t.length; s++)
      i.push(this.coder);
    return Mg(e, i, t);
  }
  decode(e) {
    let t = this.length;
    t === -1 && (t = e.readValue().toNumber(), t * 32 > e._data.length && ma.throwError("insufficient data length", H.errors.BUFFER_OVERRUN, {
      length: e._data.length,
      count: t
    }));
    let n = [];
    for (let i = 0; i < t; i++)
      n.push(new HT(this.coder));
    return e.coerce(this.name, Ig(e, n));
  }
}
class $T extends Hi {
  constructor(e) {
    super("bool", "bool", e, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(e, t) {
    return e.writeValue(t ? 1 : 0);
  }
  decode(e) {
    return e.coerce(this.type, !e.readValue().isZero());
  }
}
class Cg extends Hi {
  constructor(e, t) {
    super(e, e, t, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(e, t) {
    t = ve(t);
    let n = e.writeValue(t.length);
    return n += e.writeBytes(t), n;
  }
  decode(e) {
    return e.readBytes(e.readValue().toNumber(), !0);
  }
}
class GT extends Cg {
  constructor(e) {
    super("bytes", e);
  }
  decode(e) {
    return e.coerce(this.name, we(super.decode(e)));
  }
}
class KT extends Hi {
  constructor(e, t) {
    let n = "bytes" + String(e);
    super(n, n, t, !1), this.size = e;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(e, t) {
    let n = ve(t);
    return n.length !== this.size && this._throwError("incorrect data length", t), e.writeBytes(n);
  }
  decode(e) {
    return e.coerce(this.name, we(e.readBytes(this.size)));
  }
}
class YT extends Hi {
  constructor(e) {
    super("null", "", e, !1);
  }
  defaultValue() {
    return null;
  }
  encode(e, t) {
    return t != null && this._throwError("not null", t), e.writeBytes([]);
  }
  decode(e) {
    return e.readBytes(0), e.coerce(this.name, null);
  }
}
const Pg = "0x0000000000000000000000000000000000000000", kg = /* @__PURE__ */ be.from(-1), wf = /* @__PURE__ */ be.from(0), Og = /* @__PURE__ */ be.from(1), qT = /* @__PURE__ */ be.from(2), ZT = /* @__PURE__ */ be.from("1000000000000000000"), Ng = /* @__PURE__ */ be.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), JT = /* @__PURE__ */ be.from("-0x8000000000000000000000000000000000000000000000000000000000000000"), XT = /* @__PURE__ */ be.from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), _f = "0x0000000000000000000000000000000000000000000000000000000000000000", QT = "Ξ", Rg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddressZero: Pg,
  EtherSymbol: QT,
  HashZero: _f,
  MaxInt256: XT,
  MaxUint256: Ng,
  MinInt256: JT,
  NegativeOne: kg,
  One: Og,
  Two: qT,
  WeiPerEther: ZT,
  Zero: wf
}, Symbol.toStringTag, { value: "Module" }));
class eM extends Hi {
  constructor(e, t, n) {
    const i = (t ? "int" : "uint") + e * 8;
    super(i, i, n, !1), this.size = e, this.signed = t;
  }
  defaultValue() {
    return 0;
  }
  encode(e, t) {
    let n = be.from(t), i = Ng.mask(e.wordSize * 8);
    if (this.signed) {
      let s = i.mask(this.size * 8 - 1);
      (n.gt(s) || n.lt(s.add(Og).mul(kg))) && this._throwError("value out-of-bounds", t);
    } else
      (n.lt(wf) || n.gt(i.mask(this.size * 8))) && this._throwError("value out-of-bounds", t);
    return n = n.toTwos(this.size * 8).mask(this.size * 8), this.signed && (n = n.fromTwos(this.size * 8).toTwos(8 * e.wordSize)), e.writeValue(n);
  }
  decode(e) {
    let t = e.readValue().mask(this.size * 8);
    return this.signed && (t = t.fromTwos(this.size * 8)), e.coerce(this.name, t);
  }
}
const tM = "strings/5.7.0", Lg = new H(tM);
var yi;
(function(r) {
  r.current = "", r.NFC = "NFC", r.NFD = "NFD", r.NFKC = "NFKC", r.NFKD = "NFKD";
})(yi || (yi = {}));
var sn;
(function(r) {
  r.UNEXPECTED_CONTINUE = "unexpected continuation byte", r.BAD_PREFIX = "bad codepoint prefix", r.OVERRUN = "string overrun", r.MISSING_CONTINUE = "missing continuation byte", r.OUT_OF_RANGE = "out of UTF-8 range", r.UTF16_SURROGATE = "UTF-16 surrogate", r.OVERLONG = "overlong representation";
})(sn || (sn = {}));
function rM(r, e, t, n, i) {
  return Lg.throwArgumentError(`invalid codepoint at offset ${e}; ${r}`, "bytes", t);
}
function Dg(r, e, t, n, i) {
  if (r === sn.BAD_PREFIX || r === sn.UNEXPECTED_CONTINUE) {
    let s = 0;
    for (let a = e + 1; a < t.length && t[a] >> 6 === 2; a++)
      s++;
    return s;
  }
  return r === sn.OVERRUN ? t.length - e - 1 : 0;
}
function nM(r, e, t, n, i) {
  return r === sn.OVERLONG ? (n.push(i), 0) : (n.push(65533), Dg(r, e, t));
}
const Fg = Object.freeze({
  error: rM,
  ignore: Dg,
  replace: nM
});
function Ef(r, e) {
  e == null && (e = Fg.error), r = ve(r);
  const t = [];
  let n = 0;
  for (; n < r.length; ) {
    const i = r[n++];
    if (!(i >> 7)) {
      t.push(i);
      continue;
    }
    let s = null, a = null;
    if ((i & 224) === 192)
      s = 1, a = 127;
    else if ((i & 240) === 224)
      s = 2, a = 2047;
    else if ((i & 248) === 240)
      s = 3, a = 65535;
    else {
      (i & 192) === 128 ? n += e(sn.UNEXPECTED_CONTINUE, n - 1, r, t) : n += e(sn.BAD_PREFIX, n - 1, r, t);
      continue;
    }
    if (n - 1 + s >= r.length) {
      n += e(sn.OVERRUN, n - 1, r, t);
      continue;
    }
    let o = i & (1 << 8 - s - 1) - 1;
    for (let l = 0; l < s; l++) {
      let c = r[n];
      if ((c & 192) != 128) {
        n += e(sn.MISSING_CONTINUE, n, r, t), o = null;
        break;
      }
      o = o << 6 | c & 63, n++;
    }
    if (o !== null) {
      if (o > 1114111) {
        n += e(sn.OUT_OF_RANGE, n - 1 - s, r, t, o);
        continue;
      }
      if (o >= 55296 && o <= 57343) {
        n += e(sn.UTF16_SURROGATE, n - 1 - s, r, t, o);
        continue;
      }
      if (o <= a) {
        n += e(sn.OVERLONG, n - 1 - s, r, t, o);
        continue;
      }
      t.push(o);
    }
  }
  return t;
}
function tr(r, e = yi.current) {
  e != yi.current && (Lg.checkNormalize(), r = r.normalize(e));
  let t = [];
  for (let n = 0; n < r.length; n++) {
    const i = r.charCodeAt(n);
    if (i < 128)
      t.push(i);
    else if (i < 2048)
      t.push(i >> 6 | 192), t.push(i & 63 | 128);
    else if ((i & 64512) == 55296) {
      n++;
      const s = r.charCodeAt(n);
      if (n >= r.length || (s & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const a = 65536 + ((i & 1023) << 10) + (s & 1023);
      t.push(a >> 18 | 240), t.push(a >> 12 & 63 | 128), t.push(a >> 6 & 63 | 128), t.push(a & 63 | 128);
    } else
      t.push(i >> 12 | 224), t.push(i >> 6 & 63 | 128), t.push(i & 63 | 128);
  }
  return ve(t);
}
function hu(r) {
  const e = "0000" + r.toString(16);
  return "\\u" + e.substring(e.length - 4);
}
function iM(r, e) {
  return '"' + Ef(r, e).map((t) => {
    if (t < 256) {
      switch (t) {
        case 8:
          return "\\b";
        case 9:
          return "\\t";
        case 10:
          return "\\n";
        case 13:
          return "\\r";
        case 34:
          return '\\"';
        case 92:
          return "\\\\";
      }
      if (t >= 32 && t < 127)
        return String.fromCharCode(t);
    }
    return t <= 65535 ? hu(t) : (t -= 65536, hu((t >> 10 & 1023) + 55296) + hu((t & 1023) + 56320));
  }).join("") + '"';
}
function Ed(r) {
  return r.map((e) => e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10 & 1023) + 55296, (e & 1023) + 56320))).join("");
}
function Gs(r, e) {
  return Ed(Ef(r, e));
}
function Gl(r, e = yi.current) {
  return Ef(tr(r, e));
}
function sM(r) {
  const e = tr(r);
  if (e.length > 31)
    throw new Error("bytes32 string must be less than 32 bytes");
  return we(Lt([e, _f]).slice(0, 32));
}
function aM(r) {
  const e = ve(r);
  if (e.length !== 32)
    throw new Error("invalid bytes32 - not 32 bytes long");
  if (e[31] !== 0)
    throw new Error("invalid bytes32 string - no null terminator");
  let t = 31;
  for (; e[t - 1] === 0; )
    t--;
  return Gs(e.slice(0, t));
}
function oM(r) {
  if (r.length % 4 !== 0)
    throw new Error("bad data");
  let e = [];
  for (let t = 0; t < r.length; t += 4)
    e.push(parseInt(r.substring(t, t + 4), 16));
  return e;
}
function Af(r, e) {
  e || (e = function(i) {
    return [parseInt(i, 16)];
  });
  let t = 0, n = {};
  return r.split(",").forEach((i) => {
    let s = i.split(":");
    t += parseInt(s[0], 16), n[t] = e(s[1]);
  }), n;
}
function Bg(r) {
  let e = 0;
  return r.split(",").map((t) => {
    let n = t.split("-");
    n.length === 1 ? n[1] = "0" : n[1] === "" && (n[1] = "1");
    let i = e + parseInt(n[0], 16);
    return e = parseInt(n[1], 16), { l: i, h: e };
  });
}
function Sf(r, e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let i = e[n];
    if (t += i.l, r >= t && r <= t + i.h && (r - t) % (i.d || 1) === 0) {
      if (i.e && i.e.indexOf(r - t) !== -1)
        continue;
      return i;
    }
  }
  return null;
}
const lM = Bg("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), cM = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((r) => parseInt(r, 16)), uM = [
  { h: 25, s: 32, l: 65 },
  { h: 30, s: 32, e: [23], l: 127 },
  { h: 54, s: 1, e: [48], l: 64, d: 2 },
  { h: 14, s: 1, l: 57, d: 2 },
  { h: 44, s: 1, l: 17, d: 2 },
  { h: 10, s: 1, e: [2, 6, 8], l: 61, d: 2 },
  { h: 16, s: 1, l: 68, d: 2 },
  { h: 84, s: 1, e: [18, 24, 66], l: 19, d: 2 },
  { h: 26, s: 32, e: [17], l: 435 },
  { h: 22, s: 1, l: 71, d: 2 },
  { h: 15, s: 80, l: 40 },
  { h: 31, s: 32, l: 16 },
  { h: 32, s: 1, l: 80, d: 2 },
  { h: 52, s: 1, l: 42, d: 2 },
  { h: 12, s: 1, l: 55, d: 2 },
  { h: 40, s: 1, e: [38], l: 15, d: 2 },
  { h: 14, s: 1, l: 48, d: 2 },
  { h: 37, s: 48, l: 49 },
  { h: 148, s: 1, l: 6351, d: 2 },
  { h: 88, s: 1, l: 160, d: 2 },
  { h: 15, s: 16, l: 704 },
  { h: 25, s: 26, l: 854 },
  { h: 25, s: 32, l: 55915 },
  { h: 37, s: 40, l: 1247 },
  { h: 25, s: -119711, l: 53248 },
  { h: 25, s: -119763, l: 52 },
  { h: 25, s: -119815, l: 52 },
  { h: 25, s: -119867, e: [1, 4, 5, 7, 8, 11, 12, 17], l: 52 },
  { h: 25, s: -119919, l: 52 },
  { h: 24, s: -119971, e: [2, 7, 8, 17], l: 52 },
  { h: 24, s: -120023, e: [2, 7, 13, 15, 16, 17], l: 52 },
  { h: 25, s: -120075, l: 52 },
  { h: 25, s: -120127, l: 52 },
  { h: 25, s: -120179, l: 52 },
  { h: 25, s: -120231, l: 52 },
  { h: 25, s: -120283, l: 52 },
  { h: 25, s: -120335, l: 52 },
  { h: 24, s: -119543, e: [17], l: 56 },
  { h: 24, s: -119601, e: [17], l: 58 },
  { h: 24, s: -119659, e: [17], l: 58 },
  { h: 24, s: -119717, e: [17], l: 58 },
  { h: 24, s: -119775, e: [17], l: 58 }
], dM = Af("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), fM = Af("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), hM = Af("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", oM), pM = Bg("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function mM(r) {
  return r.reduce((e, t) => (t.forEach((n) => {
    e.push(n);
  }), e), []);
}
function gM(r) {
  return !!Sf(r, lM);
}
function xM(r) {
  let e = Sf(r, uM);
  if (e)
    return [r + e.s];
  let t = dM[r];
  if (t)
    return t;
  let n = fM[r];
  if (n)
    return [r + n[0]];
  let i = hM[r];
  return i || null;
}
function bM(r) {
  return !!Sf(r, pM);
}
function vM(r) {
  if (r.match(/^[a-z0-9-]*$/i) && r.length <= 59)
    return r.toLowerCase();
  let e = Gl(r);
  e = mM(e.map((n) => {
    if (cM.indexOf(n) >= 0)
      return [];
    if (n >= 65024 && n <= 65039)
      return [];
    let i = xM(n);
    return i || [n];
  })), e = Gl(Ed(e), yi.NFKC), e.forEach((n) => {
    if (bM(n))
      throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
  }), e.forEach((n) => {
    if (gM(n))
      throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
  });
  let t = Ed(e);
  if (t.substring(0, 1) === "-" || t.substring(2, 4) === "--" || t.substring(t.length - 1) === "-")
    throw new Error("invalid hyphen");
  return t;
}
class yM extends Cg {
  constructor(e) {
    super("string", e);
  }
  defaultValue() {
    return "";
  }
  encode(e, t) {
    return super.encode(e, tr(t));
  }
  decode(e) {
    return Gs(super.decode(e));
  }
}
class ul extends Hi {
  constructor(e, t) {
    let n = !1;
    const i = [];
    e.forEach((a) => {
      a.dynamic && (n = !0), i.push(a.type);
    });
    const s = "tuple(" + i.join(",") + ")";
    super("tuple", s, t, n), this.coders = e;
  }
  defaultValue() {
    const e = [];
    this.coders.forEach((n) => {
      e.push(n.defaultValue());
    });
    const t = this.coders.reduce((n, i) => {
      const s = i.localName;
      return s && (n[s] || (n[s] = 0), n[s]++), n;
    }, {});
    return this.coders.forEach((n, i) => {
      let s = n.localName;
      !s || t[s] !== 1 || (s === "length" && (s = "_length"), e[s] == null && (e[s] = e[i]));
    }), Object.freeze(e);
  }
  encode(e, t) {
    return Mg(e, this.coders, t);
  }
  decode(e) {
    return e.coerce(this.name, Ig(e, this.coders));
  }
}
const dl = new H(Wo), wM = new RegExp(/^bytes([0-9]*)$/), _M = new RegExp(/^(u?int)([0-9]*)$/);
class jg {
  constructor(e) {
    ie(this, "coerceFunc", e || null);
  }
  _getCoder(e) {
    switch (e.baseType) {
      case "address":
        return new WT(e.name);
      case "bool":
        return new $T(e.name);
      case "string":
        return new yM(e.name);
      case "bytes":
        return new GT(e.name);
      case "array":
        return new VT(this._getCoder(e.arrayChildren), e.arrayLength, e.name);
      case "tuple":
        return new ul((e.components || []).map((n) => this._getCoder(n)), e.name);
      case "":
        return new YT(e.name);
    }
    let t = e.type.match(_M);
    if (t) {
      let n = parseInt(t[2] || "256");
      return (n === 0 || n > 256 || n % 8 !== 0) && dl.throwArgumentError("invalid " + t[1] + " bit length", "param", e), new eM(n / 8, t[1] === "int", e.name);
    }
    if (t = e.type.match(wM), t) {
      let n = parseInt(t[1]);
      return (n === 0 || n > 32) && dl.throwArgumentError("invalid bytes length", "param", e), new KT(n, e.name);
    }
    return dl.throwArgumentError("invalid type", "type", e.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(e, t) {
    return new $l(e, this._getWordSize(), this.coerceFunc, t);
  }
  _getWriter() {
    return new _d(this._getWordSize());
  }
  getDefaultValue(e) {
    const t = e.map((i) => this._getCoder(gr.from(i)));
    return new ul(t, "_").defaultValue();
  }
  encode(e, t) {
    e.length !== t.length && dl.throwError("types/values length mismatch", H.errors.INVALID_ARGUMENT, {
      count: { types: e.length, values: t.length },
      value: { types: e, values: t }
    });
    const n = e.map((a) => this._getCoder(gr.from(a))), i = new ul(n, "_"), s = this._getWriter();
    return i.encode(s, t), s.data;
  }
  decode(e, t, n) {
    const i = e.map((a) => this._getCoder(gr.from(a)));
    return new ul(i, "_").decode(this._getReader(ve(t), n));
  }
}
const Ug = new jg();
function cs(r) {
  return Nt(tr(r));
}
const zg = "hash/5.7.0";
function Tf(r) {
  r = atob(r);
  const e = [];
  for (let t = 0; t < r.length; t++)
    e.push(r.charCodeAt(t));
  return ve(e);
}
function Mf(r) {
  r = ve(r);
  let e = "";
  for (let t = 0; t < r.length; t++)
    e += String.fromCharCode(r[t]);
  return btoa(e);
}
const EM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Tf,
  encode: Mf
}, Symbol.toStringTag, { value: "Module" }));
function Wg(r, e) {
  e == null && (e = 1);
  const t = [], n = t.forEach, i = function(s, a) {
    n.call(s, function(o) {
      a > 0 && Array.isArray(o) ? i(o, a - 1) : t.push(o);
    });
  };
  return i(r, e), t;
}
function AM(r) {
  const e = {};
  for (let t = 0; t < r.length; t++) {
    const n = r[t];
    e[n[0]] = n[1];
  }
  return e;
}
function SM(r) {
  let e = 0;
  function t() {
    return r[e++] << 8 | r[e++];
  }
  let n = t(), i = 1, s = [0, 1];
  for (let k = 1; k < n; k++)
    s.push(i += t());
  let a = t(), o = e;
  e += a;
  let l = 0, c = 0;
  function u() {
    return l == 0 && (c = c << 8 | r[e++], l = 8), c >> --l & 1;
  }
  const f = 31, p = Math.pow(2, f), x = p >>> 1, T = x >> 1, v = p - 1;
  let w = 0;
  for (let k = 0; k < f; k++)
    w = w << 1 | u();
  let E = [], C = 0, P = p;
  for (; ; ) {
    let k = Math.floor(((w - C + 1) * i - 1) / P), K = 0, Z = n;
    for (; Z - K > 1; ) {
      let ye = K + Z >>> 1;
      k < s[ye] ? Z = ye : K = ye;
    }
    if (K == 0)
      break;
    E.push(K);
    let ne = C + Math.floor(P * s[K] / i), le = C + Math.floor(P * s[K + 1] / i) - 1;
    for (; !((ne ^ le) & x); )
      w = w << 1 & v | u(), ne = ne << 1 & v, le = le << 1 & v | 1;
    for (; ne & ~le & T; )
      w = w & x | w << 1 & v >>> 1 | u(), ne = ne << 1 ^ x, le = (le ^ x) << 1 | x | 1;
    C = ne, P = 1 + le - ne;
  }
  let F = n - 4;
  return E.map((k) => {
    switch (k - F) {
      case 3:
        return F + 65792 + (r[o++] << 16 | r[o++] << 8 | r[o++]);
      case 2:
        return F + 256 + (r[o++] << 8 | r[o++]);
      case 1:
        return F + r[o++];
      default:
        return k - 1;
    }
  });
}
function TM(r) {
  let e = 0;
  return () => r[e++];
}
function MM(r) {
  return TM(SM(r));
}
function IM(r) {
  return r & 1 ? ~r >> 1 : r >> 1;
}
function CM(r, e) {
  let t = Array(r);
  for (let n = 0; n < r; n++)
    t[n] = 1 + e();
  return t;
}
function t1(r, e) {
  let t = Array(r);
  for (let n = 0, i = -1; n < r; n++)
    t[n] = i += 1 + e();
  return t;
}
function PM(r, e) {
  let t = Array(r);
  for (let n = 0, i = 0; n < r; n++)
    t[n] = i += IM(e());
  return t;
}
function Kl(r, e) {
  let t = t1(r(), r), n = r(), i = t1(n, r), s = CM(n, r);
  for (let a = 0; a < n; a++)
    for (let o = 0; o < s[a]; o++)
      t.push(i[a] + o);
  return e ? t.map((a) => e[a]) : t;
}
function kM(r) {
  let e = [];
  for (; ; ) {
    let t = r();
    if (t == 0)
      break;
    e.push(NM(t, r));
  }
  for (; ; ) {
    let t = r() - 1;
    if (t < 0)
      break;
    e.push(RM(t, r));
  }
  return AM(Wg(e));
}
function OM(r) {
  let e = [];
  for (; ; ) {
    let t = r();
    if (t == 0)
      break;
    e.push(t);
  }
  return e;
}
function Hg(r, e, t) {
  let n = Array(r).fill(void 0).map(() => []);
  for (let i = 0; i < e; i++)
    PM(r, t).forEach((s, a) => n[a].push(s));
  return n;
}
function NM(r, e) {
  let t = 1 + e(), n = e(), i = OM(e), s = Hg(i.length, 1 + r, e);
  return Wg(s.map((a, o) => {
    const l = a[0], c = a.slice(1);
    return Array(i[o]).fill(void 0).map((u, f) => {
      let p = f * n;
      return [l + f * t, c.map((x) => x + p)];
    });
  }));
}
function RM(r, e) {
  let t = 1 + e();
  return Hg(t, 1 + r, e).map((i) => [i[0], i.slice(1)]);
}
function LM(r) {
  let e = Kl(r).sort((n, i) => n - i);
  return t();
  function t() {
    let n = [];
    for (; ; ) {
      let c = Kl(r, e);
      if (c.length == 0)
        break;
      n.push({ set: new Set(c), node: t() });
    }
    n.sort((c, u) => u.set.size - c.set.size);
    let i = r(), s = i % 3;
    i = i / 3 | 0;
    let a = !!(i & 1);
    i >>= 1;
    let o = i == 1, l = i == 2;
    return { branches: n, valid: s, fe0f: a, save: o, check: l };
  }
}
function DM() {
  return MM(Tf("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"));
}
const yc = DM(), FM = new Set(Kl(yc)), BM = new Set(Kl(yc)), jM = kM(yc), UM = LM(yc), r1 = 45, n1 = 95;
function Vg(r) {
  return Gl(r);
}
function zM(r) {
  return r.filter((e) => e != 65039);
}
function $g(r) {
  for (let e of r.split(".")) {
    let t = Vg(e);
    try {
      for (let n = t.lastIndexOf(n1) - 1; n >= 0; n--)
        if (t[n] !== n1)
          throw new Error("underscore only allowed at start");
      if (t.length >= 4 && t.every((n) => n < 128) && t[2] === r1 && t[3] === r1)
        throw new Error("invalid label extension");
    } catch (n) {
      throw new Error(`Invalid label "${e}": ${n.message}`);
    }
  }
  return r;
}
function WM(r) {
  return $g(HM(r, zM));
}
function HM(r, e) {
  let t = Vg(r).reverse(), n = [];
  for (; t.length; ) {
    let i = $M(t);
    if (i) {
      n.push(...e(i));
      continue;
    }
    let s = t.pop();
    if (FM.has(s)) {
      n.push(s);
      continue;
    }
    if (BM.has(s))
      continue;
    let a = jM[s];
    if (a) {
      n.push(...a);
      continue;
    }
    throw new Error(`Disallowed codepoint: 0x${s.toString(16).toUpperCase()}`);
  }
  return $g(VM(String.fromCodePoint(...n)));
}
function VM(r) {
  return r.normalize("NFC");
}
function $M(r, e) {
  var t;
  let n = UM, i, s, a = [], o = r.length;
  for (e && (e.length = 0); o; ) {
    let l = r[--o];
    if (n = (t = n.branches.find((c) => c.set.has(l))) === null || t === void 0 ? void 0 : t.node, !n)
      break;
    if (n.save)
      s = l;
    else if (n.check && l === s)
      break;
    a.push(l), n.fe0f && (a.push(65039), o > 0 && r[o - 1] == 65039 && o--), n.valid && (i = a.slice(), n.valid == 2 && i.splice(1, 1), e && e.push(...r.slice(o).reverse()), r.length = o);
  }
  return i;
}
const GM = new H(zg), Gg = new Uint8Array(32);
Gg.fill(0);
function i1(r) {
  if (r.length === 0)
    throw new Error("invalid ENS name; empty component");
  return r;
}
function If(r) {
  const e = tr(WM(r)), t = [];
  if (r.length === 0)
    return t;
  let n = 0;
  for (let i = 0; i < e.length; i++)
    e[i] === 46 && (t.push(i1(e.slice(n, i))), n = i + 1);
  if (n >= e.length)
    throw new Error("invalid ENS name; empty component");
  return t.push(i1(e.slice(n))), t;
}
function KM(r) {
  try {
    return If(r).length !== 0;
  } catch {
  }
  return !1;
}
function xo(r) {
  typeof r != "string" && GM.throwArgumentError("invalid ENS name; not a string", "name", r);
  let e = Gg;
  const t = If(r);
  for (; t.length; )
    e = Nt(Lt([e, Nt(t.pop())]));
  return we(e);
}
function Kg(r) {
  return we(Lt(If(r).map((e) => {
    if (e.length > 63)
      throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
    const t = new Uint8Array(e.length + 1);
    return t.set(e, 1), t[0] = t.length - 1, t;
  }))) + "00";
}
const YM = `Ethereum Signed Message:
`;
function Cf(r) {
  return typeof r == "string" && (r = tr(r)), Nt(Lt([
    tr(YM),
    tr(String(r.length)),
    r
  ]));
}
var qM = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Gt = new H(zg), Yg = new Uint8Array(32);
Yg.fill(0);
const ZM = be.from(-1), qg = be.from(0), Zg = be.from(1), JM = be.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function XM(r) {
  const e = ve(r), t = e.length % 32;
  return t ? Kr([e, Yg.slice(t)]) : we(e);
}
const QM = Dt(Zg.toHexString(), 32), eI = Dt(qg.toHexString(), 32), s1 = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
}, pu = [
  "name",
  "version",
  "chainId",
  "verifyingContract",
  "salt"
];
function a1(r) {
  return function(e) {
    return typeof e != "string" && Gt.throwArgumentError(`invalid domain value for ${JSON.stringify(r)}`, `domain.${r}`, e), e;
  };
}
const tI = {
  name: a1("name"),
  version: a1("version"),
  chainId: function(r) {
    try {
      return be.from(r).toString();
    } catch {
    }
    return Gt.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", r);
  },
  verifyingContract: function(r) {
    try {
      return kt(r).toLowerCase();
    } catch {
    }
    return Gt.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", r);
  },
  salt: function(r) {
    try {
      const e = ve(r);
      if (e.length !== 32)
        throw new Error("bad length");
      return we(e);
    } catch {
    }
    return Gt.throwArgumentError('invalid domain value "salt"', "domain.salt", r);
  }
};
function mu(r) {
  {
    const e = r.match(/^(u?)int(\d*)$/);
    if (e) {
      const t = e[1] === "", n = parseInt(e[2] || "256");
      (n % 8 !== 0 || n > 256 || e[2] && e[2] !== String(n)) && Gt.throwArgumentError("invalid numeric width", "type", r);
      const i = JM.mask(t ? n - 1 : n), s = t ? i.add(Zg).mul(ZM) : qg;
      return function(a) {
        const o = be.from(a);
        return (o.lt(s) || o.gt(i)) && Gt.throwArgumentError(`value out-of-bounds for ${r}`, "value", a), Dt(o.toTwos(256).toHexString(), 32);
      };
    }
  }
  {
    const e = r.match(/^bytes(\d+)$/);
    if (e) {
      const t = parseInt(e[1]);
      return (t === 0 || t > 32 || e[1] !== String(t)) && Gt.throwArgumentError("invalid bytes width", "type", r), function(n) {
        return ve(n).length !== t && Gt.throwArgumentError(`invalid length for ${r}`, "value", n), XM(n);
      };
    }
  }
  switch (r) {
    case "address":
      return function(e) {
        return Dt(kt(e), 32);
      };
    case "bool":
      return function(e) {
        return e ? QM : eI;
      };
    case "bytes":
      return function(e) {
        return Nt(e);
      };
    case "string":
      return function(e) {
        return cs(e);
      };
  }
  return null;
}
function o1(r, e) {
  return `${r}(${e.map(({ name: t, type: n }) => n + " " + t).join(",")})`;
}
class Pr {
  constructor(e) {
    ie(this, "types", Object.freeze(Zr(e))), ie(this, "_encoderCache", {}), ie(this, "_types", {});
    const t = {}, n = {}, i = {};
    Object.keys(e).forEach((o) => {
      t[o] = {}, n[o] = [], i[o] = {};
    });
    for (const o in e) {
      const l = {};
      e[o].forEach((c) => {
        l[c.name] && Gt.throwArgumentError(`duplicate variable name ${JSON.stringify(c.name)} in ${JSON.stringify(o)}`, "types", e), l[c.name] = !0;
        const u = c.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
        u === o && Gt.throwArgumentError(`circular type reference to ${JSON.stringify(u)}`, "types", e), !mu(u) && (n[u] || Gt.throwArgumentError(`unknown type ${JSON.stringify(u)}`, "types", e), n[u].push(o), t[o][u] = !0);
      });
    }
    const s = Object.keys(n).filter((o) => n[o].length === 0);
    s.length === 0 ? Gt.throwArgumentError("missing primary type", "types", e) : s.length > 1 && Gt.throwArgumentError(`ambiguous primary types or unused types: ${s.map((o) => JSON.stringify(o)).join(", ")}`, "types", e), ie(this, "primaryType", s[0]);
    function a(o, l) {
      l[o] && Gt.throwArgumentError(`circular type reference to ${JSON.stringify(o)}`, "types", e), l[o] = !0, Object.keys(t[o]).forEach((c) => {
        n[c] && (a(c, l), Object.keys(l).forEach((u) => {
          i[u][c] = !0;
        }));
      }), delete l[o];
    }
    a(this.primaryType, {});
    for (const o in i) {
      const l = Object.keys(i[o]);
      l.sort(), this._types[o] = o1(o, e[o]) + l.map((c) => o1(c, e[c])).join("");
    }
  }
  getEncoder(e) {
    let t = this._encoderCache[e];
    return t || (t = this._encoderCache[e] = this._getEncoder(e)), t;
  }
  _getEncoder(e) {
    {
      const i = mu(e);
      if (i)
        return i;
    }
    const t = e.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (t) {
      const i = t[1], s = this.getEncoder(i), a = parseInt(t[3]);
      return (o) => {
        a >= 0 && o.length !== a && Gt.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", o);
        let l = o.map(s);
        return this._types[i] && (l = l.map(Nt)), Nt(Kr(l));
      };
    }
    const n = this.types[e];
    if (n) {
      const i = cs(this._types[e]);
      return (s) => {
        const a = n.map(({ name: o, type: l }) => {
          const c = this.getEncoder(l)(s[o]);
          return this._types[l] ? Nt(c) : c;
        });
        return a.unshift(i), Kr(a);
      };
    }
    return Gt.throwArgumentError(`unknown type: ${e}`, "type", e);
  }
  encodeType(e) {
    const t = this._types[e];
    return t || Gt.throwArgumentError(`unknown type: ${JSON.stringify(e)}`, "name", e), t;
  }
  encodeData(e, t) {
    return this.getEncoder(e)(t);
  }
  hashStruct(e, t) {
    return Nt(this.encodeData(e, t));
  }
  encode(e) {
    return this.encodeData(this.primaryType, e);
  }
  hash(e) {
    return this.hashStruct(this.primaryType, e);
  }
  _visit(e, t, n) {
    if (mu(e))
      return n(e, t);
    const i = e.match(/^(.*)(\x5b(\d*)\x5d)$/);
    if (i) {
      const a = i[1], o = parseInt(i[3]);
      return o >= 0 && t.length !== o && Gt.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", t), t.map((l) => this._visit(a, l, n));
    }
    const s = this.types[e];
    return s ? s.reduce((a, { name: o, type: l }) => (a[o] = this._visit(l, t[o], n), a), {}) : Gt.throwArgumentError(`unknown type: ${e}`, "type", e);
  }
  visit(e, t) {
    return this._visit(this.primaryType, e, t);
  }
  static from(e) {
    return new Pr(e);
  }
  static getPrimaryType(e) {
    return Pr.from(e).primaryType;
  }
  static hashStruct(e, t, n) {
    return Pr.from(t).hashStruct(e, n);
  }
  static hashDomain(e) {
    const t = [];
    for (const n in e) {
      const i = s1[n];
      i || Gt.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(n)}`, "domain", e), t.push({ name: n, type: i });
    }
    return t.sort((n, i) => pu.indexOf(n.name) - pu.indexOf(i.name)), Pr.hashStruct("EIP712Domain", { EIP712Domain: t }, e);
  }
  static encode(e, t, n) {
    return Kr([
      "0x1901",
      Pr.hashDomain(e),
      Pr.from(t).hash(n)
    ]);
  }
  static hash(e, t, n) {
    return Nt(Pr.encode(e, t, n));
  }
  // Replaces all address types with ENS names with their looked up address
  static resolveNames(e, t, n, i) {
    return qM(this, void 0, void 0, function* () {
      e = Bt(e);
      const s = {};
      e.verifyingContract && !Ye(e.verifyingContract, 20) && (s[e.verifyingContract] = "0x");
      const a = Pr.from(t);
      a.visit(n, (o, l) => (o === "address" && !Ye(l, 20) && (s[l] = "0x"), l));
      for (const o in s)
        s[o] = yield i(o);
      return e.verifyingContract && s[e.verifyingContract] && (e.verifyingContract = s[e.verifyingContract]), n = a.visit(n, (o, l) => o === "address" && s[l] ? s[l] : l), { domain: e, value: n };
    });
  }
  static getPayload(e, t, n) {
    Pr.hashDomain(e);
    const i = {}, s = [];
    pu.forEach((l) => {
      const c = e[l];
      c != null && (i[l] = tI[l](c), s.push({ name: l, type: s1[l] }));
    });
    const a = Pr.from(t), o = Bt(t);
    return o.EIP712Domain ? Gt.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", t) : o.EIP712Domain = s, a.encode(n), {
      types: o,
      domain: i,
      primaryType: a.primaryType,
      message: a.visit(n, (l, c) => {
        if (l.match(/^bytes(\d*)/))
          return we(ve(c));
        if (l.match(/^u?int/))
          return be.from(c).toString();
        switch (l) {
          case "address":
            return c.toLowerCase();
          case "bool":
            return !!c;
          case "string":
            return typeof c != "string" && Gt.throwArgumentError("invalid string", "value", c), c;
        }
        return Gt.throwArgumentError("unsupported type", "type", l);
      })
    };
  }
}
const $t = new H(Wo);
class Jg extends $s {
}
class Xg extends $s {
}
class rI extends $s {
}
class Yl extends $s {
  static isIndexed(e) {
    return !!(e && e._isIndexed);
  }
}
const nI = {
  "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: !0 },
  "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function l1(r, e) {
  const t = new Error(`deferred error during ABI decoding triggered accessing ${r}`);
  return t.error = e, t;
}
class Ad {
  constructor(e) {
    let t = [];
    typeof e == "string" ? t = JSON.parse(e) : t = e, ie(this, "fragments", t.map((n) => fi.from(n)).filter((n) => n != null)), ie(this, "_abiCoder", kr(new.target, "getAbiCoder")()), ie(this, "functions", {}), ie(this, "errors", {}), ie(this, "events", {}), ie(this, "structs", {}), this.fragments.forEach((n) => {
      let i = null;
      switch (n.type) {
        case "constructor":
          if (this.deploy) {
            $t.warn("duplicate definition - constructor");
            return;
          }
          ie(this, "deploy", n);
          return;
        case "function":
          i = this.functions;
          break;
        case "event":
          i = this.events;
          break;
        case "error":
          i = this.errors;
          break;
        default:
          return;
      }
      let s = n.format();
      if (i[s]) {
        $t.warn("duplicate definition - " + s);
        return;
      }
      i[s] = n;
    }), this.deploy || ie(this, "deploy", Vn.from({
      payable: !1,
      type: "constructor"
    })), ie(this, "_isInterface", !0);
  }
  format(e) {
    e || (e = xt.full), e === xt.sighash && $t.throwArgumentError("interface does not support formatting sighash", "format", e);
    const t = this.fragments.map((n) => n.format(e));
    return e === xt.json ? JSON.stringify(t.map((n) => JSON.parse(n))) : t;
  }
  // Sub-classes can override these to handle other blockchains
  static getAbiCoder() {
    return Ug;
  }
  static getAddress(e) {
    return kt(e);
  }
  static getSighash(e) {
    return Qt(cs(e.format()), 0, 4);
  }
  static getEventTopic(e) {
    return cs(e.format());
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getFunction(e) {
    if (Ye(e)) {
      for (const n in this.functions)
        if (e === this.getSighash(n))
          return this.functions[n];
      $t.throwArgumentError("no matching function", "sighash", e);
    }
    if (e.indexOf("(") === -1) {
      const n = e.trim(), i = Object.keys(this.functions).filter((s) => s.split(
        "("
        /* fix:) */
      )[0] === n);
      return i.length === 0 ? $t.throwArgumentError("no matching function", "name", n) : i.length > 1 && $t.throwArgumentError("multiple matching functions", "name", n), this.functions[i[0]];
    }
    const t = this.functions[$n.fromString(e).format()];
    return t || $t.throwArgumentError("no matching function", "signature", e), t;
  }
  // Find an event definition by any means necessary (unless it is ambiguous)
  getEvent(e) {
    if (Ye(e)) {
      const n = e.toLowerCase();
      for (const i in this.events)
        if (n === this.getEventTopic(i))
          return this.events[i];
      $t.throwArgumentError("no matching event", "topichash", n);
    }
    if (e.indexOf("(") === -1) {
      const n = e.trim(), i = Object.keys(this.events).filter((s) => s.split(
        "("
        /* fix:) */
      )[0] === n);
      return i.length === 0 ? $t.throwArgumentError("no matching event", "name", n) : i.length > 1 && $t.throwArgumentError("multiple matching events", "name", n), this.events[i[0]];
    }
    const t = this.events[di.fromString(e).format()];
    return t || $t.throwArgumentError("no matching event", "signature", e), t;
  }
  // Find a function definition by any means necessary (unless it is ambiguous)
  getError(e) {
    if (Ye(e)) {
      const n = kr(this.constructor, "getSighash");
      for (const i in this.errors) {
        const s = this.errors[i];
        if (e === n(s))
          return this.errors[i];
      }
      $t.throwArgumentError("no matching error", "sighash", e);
    }
    if (e.indexOf("(") === -1) {
      const n = e.trim(), i = Object.keys(this.errors).filter((s) => s.split(
        "("
        /* fix:) */
      )[0] === n);
      return i.length === 0 ? $t.throwArgumentError("no matching error", "name", n) : i.length > 1 && $t.throwArgumentError("multiple matching errors", "name", n), this.errors[i[0]];
    }
    const t = this.errors[$n.fromString(e).format()];
    return t || $t.throwArgumentError("no matching error", "signature", e), t;
  }
  // Get the sighash (the bytes4 selector) used by Solidity to identify a function
  getSighash(e) {
    if (typeof e == "string")
      try {
        e = this.getFunction(e);
      } catch (t) {
        try {
          e = this.getError(e);
        } catch {
          throw t;
        }
      }
    return kr(this.constructor, "getSighash")(e);
  }
  // Get the topic (the bytes32 hash) used by Solidity to identify an event
  getEventTopic(e) {
    return typeof e == "string" && (e = this.getEvent(e)), kr(this.constructor, "getEventTopic")(e);
  }
  _decodeParams(e, t) {
    return this._abiCoder.decode(e, t);
  }
  _encodeParams(e, t) {
    return this._abiCoder.encode(e, t);
  }
  encodeDeploy(e) {
    return this._encodeParams(this.deploy.inputs, e || []);
  }
  decodeErrorResult(e, t) {
    typeof e == "string" && (e = this.getError(e));
    const n = ve(t);
    return we(n.slice(0, 4)) !== this.getSighash(e) && $t.throwArgumentError(`data signature does not match error ${e.name}.`, "data", we(n)), this._decodeParams(e.inputs, n.slice(4));
  }
  encodeErrorResult(e, t) {
    return typeof e == "string" && (e = this.getError(e)), we(Lt([
      this.getSighash(e),
      this._encodeParams(e.inputs, t || [])
    ]));
  }
  // Decode the data for a function call (e.g. tx.data)
  decodeFunctionData(e, t) {
    typeof e == "string" && (e = this.getFunction(e));
    const n = ve(t);
    return we(n.slice(0, 4)) !== this.getSighash(e) && $t.throwArgumentError(`data signature does not match function ${e.name}.`, "data", we(n)), this._decodeParams(e.inputs, n.slice(4));
  }
  // Encode the data for a function call (e.g. tx.data)
  encodeFunctionData(e, t) {
    return typeof e == "string" && (e = this.getFunction(e)), we(Lt([
      this.getSighash(e),
      this._encodeParams(e.inputs, t || [])
    ]));
  }
  // Decode the result from a function call (e.g. from eth_call)
  decodeFunctionResult(e, t) {
    typeof e == "string" && (e = this.getFunction(e));
    let n = ve(t), i = null, s = "", a = null, o = null, l = null;
    switch (n.length % this._abiCoder._getWordSize()) {
      case 0:
        try {
          return this._abiCoder.decode(e.outputs, n);
        } catch {
        }
        break;
      case 4: {
        const c = we(n.slice(0, 4)), u = nI[c];
        if (u)
          a = this._abiCoder.decode(u.inputs, n.slice(4)), o = u.name, l = u.signature, u.reason && (i = a[0]), o === "Error" ? s = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(a[0])}` : o === "Panic" && (s = `; VM Exception while processing transaction: reverted with panic code ${a[0]}`);
        else
          try {
            const f = this.getError(c);
            a = this._abiCoder.decode(f.inputs, n.slice(4)), o = f.name, l = f.format();
          } catch {
          }
        break;
      }
    }
    return $t.throwError("call revert exception" + s, H.errors.CALL_EXCEPTION, {
      method: e.format(),
      data: we(t),
      errorArgs: a,
      errorName: o,
      errorSignature: l,
      reason: i
    });
  }
  // Encode the result for a function call (e.g. for eth_call)
  encodeFunctionResult(e, t) {
    return typeof e == "string" && (e = this.getFunction(e)), we(this._abiCoder.encode(e.outputs, t || []));
  }
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(e, t) {
    typeof e == "string" && (e = this.getEvent(e)), t.length > e.inputs.length && $t.throwError("too many arguments for " + e.format(), H.errors.UNEXPECTED_ARGUMENT, {
      argument: "values",
      value: t
    });
    let n = [];
    e.anonymous || n.push(this.getEventTopic(e));
    const i = (s, a) => s.type === "string" ? cs(a) : s.type === "bytes" ? Nt(we(a)) : (s.type === "bool" && typeof a == "boolean" && (a = a ? "0x01" : "0x00"), s.type.match(/^u?int/) && (a = be.from(a).toHexString()), s.type === "address" && this._abiCoder.encode(["address"], [a]), Dt(we(a), 32));
    for (t.forEach((s, a) => {
      let o = e.inputs[a];
      if (!o.indexed) {
        s != null && $t.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + o.name, s);
        return;
      }
      s == null ? n.push(null) : o.baseType === "array" || o.baseType === "tuple" ? $t.throwArgumentError("filtering with tuples or arrays not supported", "contract." + o.name, s) : Array.isArray(s) ? n.push(s.map((l) => i(o, l))) : n.push(i(o, s));
    }); n.length && n[n.length - 1] === null; )
      n.pop();
    return n;
  }
  encodeEventLog(e, t) {
    typeof e == "string" && (e = this.getEvent(e));
    const n = [], i = [], s = [];
    return e.anonymous || n.push(this.getEventTopic(e)), t.length !== e.inputs.length && $t.throwArgumentError("event arguments/values mismatch", "values", t), e.inputs.forEach((a, o) => {
      const l = t[o];
      if (a.indexed)
        if (a.type === "string")
          n.push(cs(l));
        else if (a.type === "bytes")
          n.push(Nt(l));
        else {
          if (a.baseType === "tuple" || a.baseType === "array")
            throw new Error("not implemented");
          n.push(this._abiCoder.encode([a.type], [l]));
        }
      else
        i.push(a), s.push(l);
    }), {
      data: this._abiCoder.encode(i, s),
      topics: n
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(e, t, n) {
    if (typeof e == "string" && (e = this.getEvent(e)), n != null && !e.anonymous) {
      let p = this.getEventTopic(e);
      (!Ye(n[0], 32) || n[0].toLowerCase() !== p) && $t.throwError("fragment/topic mismatch", H.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: p, value: n[0] }), n = n.slice(1);
    }
    let i = [], s = [], a = [];
    e.inputs.forEach((p, x) => {
      p.indexed ? p.type === "string" || p.type === "bytes" || p.baseType === "tuple" || p.baseType === "array" ? (i.push(gr.fromObject({ type: "bytes32", name: p.name })), a.push(!0)) : (i.push(p), a.push(!1)) : (s.push(p), a.push(!1));
    });
    let o = n != null ? this._abiCoder.decode(i, Lt(n)) : null, l = this._abiCoder.decode(s, t, !0), c = [], u = 0, f = 0;
    e.inputs.forEach((p, x) => {
      if (p.indexed)
        if (o == null)
          c[x] = new Yl({ _isIndexed: !0, hash: null });
        else if (a[x])
          c[x] = new Yl({ _isIndexed: !0, hash: o[f++] });
        else
          try {
            c[x] = o[f++];
          } catch (T) {
            c[x] = T;
          }
      else
        try {
          c[x] = l[u++];
        } catch (T) {
          c[x] = T;
        }
      if (p.name && c[p.name] == null) {
        const T = c[x];
        T instanceof Error ? Object.defineProperty(c, p.name, {
          enumerable: !0,
          get: () => {
            throw l1(`property ${JSON.stringify(p.name)}`, T);
          }
        }) : c[p.name] = T;
      }
    });
    for (let p = 0; p < c.length; p++) {
      const x = c[p];
      x instanceof Error && Object.defineProperty(c, p, {
        enumerable: !0,
        get: () => {
          throw l1(`index ${p}`, x);
        }
      });
    }
    return Object.freeze(c);
  }
  // Given a transaction, find the matching function fragment (if any) and
  // determine all its properties and call parameters
  parseTransaction(e) {
    let t = this.getFunction(e.data.substring(0, 10).toLowerCase());
    return t ? new Xg({
      args: this._abiCoder.decode(t.inputs, "0x" + e.data.substring(10)),
      functionFragment: t,
      name: t.name,
      signature: t.format(),
      sighash: this.getSighash(t),
      value: be.from(e.value || "0")
    }) : null;
  }
  // @TODO
  //parseCallResult(data: BytesLike): ??
  // Given an event log, find the matching event fragment (if any) and
  // determine all its properties and values
  parseLog(e) {
    let t = this.getEvent(e.topics[0]);
    return !t || t.anonymous ? null : new Jg({
      eventFragment: t,
      name: t.name,
      signature: t.format(),
      topic: this.getEventTopic(t),
      args: this.decodeEventLog(t, e.data, e.topics)
    });
  }
  parseError(e) {
    const t = we(e);
    let n = this.getError(t.substring(0, 10).toLowerCase());
    return n ? new rI({
      args: this._abiCoder.decode(n.inputs, "0x" + t.substring(10)),
      errorFragment: n,
      name: n.name,
      signature: n.format(),
      sighash: this.getSighash(n)
    }) : null;
  }
  /*
  static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
      if (Interface.isInterface(value)) {
          return value;
      }
      if (typeof(value) === "string") {
          return new Interface(JSON.parse(value));
      }
      return new Interface(value);
  }
  */
  static isInterface(e) {
    return !!(e && e._isInterface);
  }
}
const iI = "abstract-provider/5.7.0";
var sI = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const aI = new H(iI);
class oI extends $s {
  static isForkEvent(e) {
    return !!(e && e._isForkEvent);
  }
}
class Ks {
  constructor() {
    aI.checkAbstract(new.target, Ks), ie(this, "_isProvider", !0);
  }
  getFeeData() {
    return sI(this, void 0, void 0, function* () {
      const { block: e, gasPrice: t } = yield qt({
        block: this.getBlock("latest"),
        gasPrice: this.getGasPrice().catch((a) => null)
      });
      let n = null, i = null, s = null;
      return e && e.baseFeePerGas && (n = e.baseFeePerGas, s = be.from("1500000000"), i = e.baseFeePerGas.mul(2).add(s)), { lastBaseFeePerGas: n, maxFeePerGas: i, maxPriorityFeePerGas: s, gasPrice: t };
    });
  }
  // Alias for "on"
  addListener(e, t) {
    return this.on(e, t);
  }
  // Alias for "off"
  removeListener(e, t) {
    return this.off(e, t);
  }
  static isProvider(e) {
    return !!(e && e._isProvider);
  }
}
const lI = "abstract-signer/5.7.0";
var Un = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const In = new H(lI), cI = [
  "accessList",
  "ccipReadEnabled",
  "chainId",
  "customData",
  "data",
  "from",
  "gasLimit",
  "gasPrice",
  "maxFeePerGas",
  "maxPriorityFeePerGas",
  "nonce",
  "to",
  "type",
  "value"
], uI = [
  H.errors.INSUFFICIENT_FUNDS,
  H.errors.NONCE_EXPIRED,
  H.errors.REPLACEMENT_UNDERPRICED
];
class Vi {
  ///////////////////
  // Sub-classes MUST call super
  constructor() {
    In.checkAbstract(new.target, Vi), ie(this, "_isSigner", !0);
  }
  ///////////////////
  // Sub-classes MAY override these
  getBalance(e) {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("getBalance"), yield this.provider.getBalance(this.getAddress(), e);
    });
  }
  getTransactionCount(e) {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("getTransactionCount"), yield this.provider.getTransactionCount(this.getAddress(), e);
    });
  }
  // Populates "from" if unspecified, and estimates the gas for the transaction
  estimateGas(e) {
    return Un(this, void 0, void 0, function* () {
      this._checkProvider("estimateGas");
      const t = yield qt(this.checkTransaction(e));
      return yield this.provider.estimateGas(t);
    });
  }
  // Populates "from" if unspecified, and calls with the transaction
  call(e, t) {
    return Un(this, void 0, void 0, function* () {
      this._checkProvider("call");
      const n = yield qt(this.checkTransaction(e));
      return yield this.provider.call(n, t);
    });
  }
  // Populates all fields in a transaction, signs it and sends it to the network
  sendTransaction(e) {
    return Un(this, void 0, void 0, function* () {
      this._checkProvider("sendTransaction");
      const t = yield this.populateTransaction(e), n = yield this.signTransaction(t);
      return yield this.provider.sendTransaction(n);
    });
  }
  getChainId() {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("getChainId"), (yield this.provider.getNetwork()).chainId;
    });
  }
  getGasPrice() {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("getGasPrice"), yield this.provider.getGasPrice();
    });
  }
  getFeeData() {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("getFeeData"), yield this.provider.getFeeData();
    });
  }
  resolveName(e) {
    return Un(this, void 0, void 0, function* () {
      return this._checkProvider("resolveName"), yield this.provider.resolveName(e);
    });
  }
  // Checks a transaction does not contain invalid keys and if
  // no "from" is provided, populates it.
  // - does NOT require a provider
  // - adds "from" is not present
  // - returns a COPY (safe to mutate the result)
  // By default called from: (overriding these prevents it)
  //   - call
  //   - estimateGas
  //   - populateTransaction (and therefor sendTransaction)
  checkTransaction(e) {
    for (const n in e)
      cI.indexOf(n) === -1 && In.throwArgumentError("invalid transaction key: " + n, "transaction", e);
    const t = Bt(e);
    return t.from == null ? t.from = this.getAddress() : t.from = Promise.all([
      Promise.resolve(t.from),
      this.getAddress()
    ]).then((n) => (n[0].toLowerCase() !== n[1].toLowerCase() && In.throwArgumentError("from address mismatch", "transaction", e), n[0])), t;
  }
  // Populates ALL keys for a transaction and checks that "from" matches
  // this Signer. Should be used by sendTransaction but NOT by signTransaction.
  // By default called from: (overriding these prevents it)
  //   - sendTransaction
  //
  // Notes:
  //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
  populateTransaction(e) {
    return Un(this, void 0, void 0, function* () {
      const t = yield qt(this.checkTransaction(e));
      t.to != null && (t.to = Promise.resolve(t.to).then((i) => Un(this, void 0, void 0, function* () {
        if (i == null)
          return null;
        const s = yield this.resolveName(i);
        return s == null && In.throwArgumentError("provided ENS name resolves to null", "tx.to", i), s;
      })), t.to.catch((i) => {
      }));
      const n = t.maxFeePerGas != null || t.maxPriorityFeePerGas != null;
      if (t.gasPrice != null && (t.type === 2 || n) ? In.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", e) : (t.type === 0 || t.type === 1) && n && In.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", e), (t.type === 2 || t.type == null) && t.maxFeePerGas != null && t.maxPriorityFeePerGas != null)
        t.type = 2;
      else if (t.type === 0 || t.type === 1)
        t.gasPrice == null && (t.gasPrice = this.getGasPrice());
      else {
        const i = yield this.getFeeData();
        if (t.type == null)
          if (i.maxFeePerGas != null && i.maxPriorityFeePerGas != null)
            if (t.type = 2, t.gasPrice != null) {
              const s = t.gasPrice;
              delete t.gasPrice, t.maxFeePerGas = s, t.maxPriorityFeePerGas = s;
            } else
              t.maxFeePerGas == null && (t.maxFeePerGas = i.maxFeePerGas), t.maxPriorityFeePerGas == null && (t.maxPriorityFeePerGas = i.maxPriorityFeePerGas);
          else
            i.gasPrice != null ? (n && In.throwError("network does not support EIP-1559", H.errors.UNSUPPORTED_OPERATION, {
              operation: "populateTransaction"
            }), t.gasPrice == null && (t.gasPrice = i.gasPrice), t.type = 0) : In.throwError("failed to get consistent fee data", H.errors.UNSUPPORTED_OPERATION, {
              operation: "signer.getFeeData"
            });
        else
          t.type === 2 && (t.maxFeePerGas == null && (t.maxFeePerGas = i.maxFeePerGas), t.maxPriorityFeePerGas == null && (t.maxPriorityFeePerGas = i.maxPriorityFeePerGas));
      }
      return t.nonce == null && (t.nonce = this.getTransactionCount("pending")), t.gasLimit == null && (t.gasLimit = this.estimateGas(t).catch((i) => {
        if (uI.indexOf(i.code) >= 0)
          throw i;
        return In.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", H.errors.UNPREDICTABLE_GAS_LIMIT, {
          error: i,
          tx: t
        });
      })), t.chainId == null ? t.chainId = this.getChainId() : t.chainId = Promise.all([
        Promise.resolve(t.chainId),
        this.getChainId()
      ]).then((i) => (i[1] !== 0 && i[0] !== i[1] && In.throwArgumentError("chainId address mismatch", "transaction", e), i[0])), yield qt(t);
    });
  }
  ///////////////////
  // Sub-classes SHOULD leave these alone
  _checkProvider(e) {
    this.provider || In.throwError("missing provider", H.errors.UNSUPPORTED_OPERATION, {
      operation: e || "_checkProvider"
    });
  }
  static isSigner(e) {
    return !!(e && e._isSigner);
  }
}
class Ho extends Vi {
  constructor(e, t) {
    super(), ie(this, "address", e), ie(this, "provider", t || null);
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  _fail(e, t) {
    return Promise.resolve().then(() => {
      In.throwError(e, H.errors.UNSUPPORTED_OPERATION, { operation: t });
    });
  }
  signMessage(e) {
    return this._fail("VoidSigner cannot sign messages", "signMessage");
  }
  signTransaction(e) {
    return this._fail("VoidSigner cannot sign transactions", "signTransaction");
  }
  _signTypedData(e, t, n) {
    return this._fail("VoidSigner cannot sign typed data", "signTypedData");
  }
  connect(e) {
    return new Ho(this.address, e);
  }
}
var Qg = {}, ot = {}, Vo = e2;
function e2(r, e) {
  if (!r)
    throw new Error(e || "Assertion failed");
}
e2.equal = function(e, t, n) {
  if (e != t)
    throw new Error(n || "Assertion failed: " + e + " != " + t);
};
var Sd = { exports: {} };
typeof Object.create == "function" ? Sd.exports = function(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Sd.exports = function(e, t) {
  if (t) {
    e.super_ = t;
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var dI = Sd.exports, fI = Vo, hI = dI;
ot.inherits = hI;
function pI(r, e) {
  return (r.charCodeAt(e) & 64512) !== 55296 || e < 0 || e + 1 >= r.length ? !1 : (r.charCodeAt(e + 1) & 64512) === 56320;
}
function mI(r, e) {
  if (Array.isArray(r))
    return r.slice();
  if (!r)
    return [];
  var t = [];
  if (typeof r == "string")
    if (e) {
      if (e === "hex")
        for (r = r.replace(/[^a-z0-9]+/ig, ""), r.length % 2 !== 0 && (r = "0" + r), i = 0; i < r.length; i += 2)
          t.push(parseInt(r[i] + r[i + 1], 16));
    } else
      for (var n = 0, i = 0; i < r.length; i++) {
        var s = r.charCodeAt(i);
        s < 128 ? t[n++] = s : s < 2048 ? (t[n++] = s >> 6 | 192, t[n++] = s & 63 | 128) : pI(r, i) ? (s = 65536 + ((s & 1023) << 10) + (r.charCodeAt(++i) & 1023), t[n++] = s >> 18 | 240, t[n++] = s >> 12 & 63 | 128, t[n++] = s >> 6 & 63 | 128, t[n++] = s & 63 | 128) : (t[n++] = s >> 12 | 224, t[n++] = s >> 6 & 63 | 128, t[n++] = s & 63 | 128);
      }
  else
    for (i = 0; i < r.length; i++)
      t[i] = r[i] | 0;
  return t;
}
ot.toArray = mI;
function gI(r) {
  for (var e = "", t = 0; t < r.length; t++)
    e += r2(r[t].toString(16));
  return e;
}
ot.toHex = gI;
function t2(r) {
  var e = r >>> 24 | r >>> 8 & 65280 | r << 8 & 16711680 | (r & 255) << 24;
  return e >>> 0;
}
ot.htonl = t2;
function xI(r, e) {
  for (var t = "", n = 0; n < r.length; n++) {
    var i = r[n];
    e === "little" && (i = t2(i)), t += n2(i.toString(16));
  }
  return t;
}
ot.toHex32 = xI;
function r2(r) {
  return r.length === 1 ? "0" + r : r;
}
ot.zero2 = r2;
function n2(r) {
  return r.length === 7 ? "0" + r : r.length === 6 ? "00" + r : r.length === 5 ? "000" + r : r.length === 4 ? "0000" + r : r.length === 3 ? "00000" + r : r.length === 2 ? "000000" + r : r.length === 1 ? "0000000" + r : r;
}
ot.zero8 = n2;
function bI(r, e, t, n) {
  var i = t - e;
  fI(i % 4 === 0);
  for (var s = new Array(i / 4), a = 0, o = e; a < s.length; a++, o += 4) {
    var l;
    n === "big" ? l = r[o] << 24 | r[o + 1] << 16 | r[o + 2] << 8 | r[o + 3] : l = r[o + 3] << 24 | r[o + 2] << 16 | r[o + 1] << 8 | r[o], s[a] = l >>> 0;
  }
  return s;
}
ot.join32 = bI;
function vI(r, e) {
  for (var t = new Array(r.length * 4), n = 0, i = 0; n < r.length; n++, i += 4) {
    var s = r[n];
    e === "big" ? (t[i] = s >>> 24, t[i + 1] = s >>> 16 & 255, t[i + 2] = s >>> 8 & 255, t[i + 3] = s & 255) : (t[i + 3] = s >>> 24, t[i + 2] = s >>> 16 & 255, t[i + 1] = s >>> 8 & 255, t[i] = s & 255);
  }
  return t;
}
ot.split32 = vI;
function yI(r, e) {
  return r >>> e | r << 32 - e;
}
ot.rotr32 = yI;
function wI(r, e) {
  return r << e | r >>> 32 - e;
}
ot.rotl32 = wI;
function _I(r, e) {
  return r + e >>> 0;
}
ot.sum32 = _I;
function EI(r, e, t) {
  return r + e + t >>> 0;
}
ot.sum32_3 = EI;
function AI(r, e, t, n) {
  return r + e + t + n >>> 0;
}
ot.sum32_4 = AI;
function SI(r, e, t, n, i) {
  return r + e + t + n + i >>> 0;
}
ot.sum32_5 = SI;
function TI(r, e, t, n) {
  var i = r[e], s = r[e + 1], a = n + s >>> 0, o = (a < n ? 1 : 0) + t + i;
  r[e] = o >>> 0, r[e + 1] = a;
}
ot.sum64 = TI;
function MI(r, e, t, n) {
  var i = e + n >>> 0, s = (i < e ? 1 : 0) + r + t;
  return s >>> 0;
}
ot.sum64_hi = MI;
function II(r, e, t, n) {
  var i = e + n;
  return i >>> 0;
}
ot.sum64_lo = II;
function CI(r, e, t, n, i, s, a, o) {
  var l = 0, c = e;
  c = c + n >>> 0, l += c < e ? 1 : 0, c = c + s >>> 0, l += c < s ? 1 : 0, c = c + o >>> 0, l += c < o ? 1 : 0;
  var u = r + t + i + a + l;
  return u >>> 0;
}
ot.sum64_4_hi = CI;
function PI(r, e, t, n, i, s, a, o) {
  var l = e + n + s + o;
  return l >>> 0;
}
ot.sum64_4_lo = PI;
function kI(r, e, t, n, i, s, a, o, l, c) {
  var u = 0, f = e;
  f = f + n >>> 0, u += f < e ? 1 : 0, f = f + s >>> 0, u += f < s ? 1 : 0, f = f + o >>> 0, u += f < o ? 1 : 0, f = f + c >>> 0, u += f < c ? 1 : 0;
  var p = r + t + i + a + l + u;
  return p >>> 0;
}
ot.sum64_5_hi = kI;
function OI(r, e, t, n, i, s, a, o, l, c) {
  var u = e + n + s + o + c;
  return u >>> 0;
}
ot.sum64_5_lo = OI;
function NI(r, e, t) {
  var n = e << 32 - t | r >>> t;
  return n >>> 0;
}
ot.rotr64_hi = NI;
function RI(r, e, t) {
  var n = r << 32 - t | e >>> t;
  return n >>> 0;
}
ot.rotr64_lo = RI;
function LI(r, e, t) {
  return r >>> t;
}
ot.shr64_hi = LI;
function DI(r, e, t) {
  var n = r << 32 - t | e >>> t;
  return n >>> 0;
}
ot.shr64_lo = DI;
var Ba = {}, c1 = ot, FI = Vo;
function wc() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
Ba.BlockHash = wc;
wc.prototype.update = function(e, t) {
  if (e = c1.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
    e = this.pending;
    var n = e.length % this._delta8;
    this.pending = e.slice(e.length - n, e.length), this.pending.length === 0 && (this.pending = null), e = c1.join32(e, 0, e.length - n, this.endian);
    for (var i = 0; i < e.length; i += this._delta32)
      this._update(e, i, i + this._delta32);
  }
  return this;
};
wc.prototype.digest = function(e) {
  return this.update(this._pad()), FI(this.pending === null), this._digest(e);
};
wc.prototype._pad = function() {
  var e = this.pendingTotal, t = this._delta8, n = t - (e + this.padLength) % t, i = new Array(n + this.padLength);
  i[0] = 128;
  for (var s = 1; s < n; s++)
    i[s] = 0;
  if (e <<= 3, this.endian === "big") {
    for (var a = 8; a < this.padLength; a++)
      i[s++] = 0;
    i[s++] = 0, i[s++] = 0, i[s++] = 0, i[s++] = 0, i[s++] = e >>> 24 & 255, i[s++] = e >>> 16 & 255, i[s++] = e >>> 8 & 255, i[s++] = e & 255;
  } else
    for (i[s++] = e & 255, i[s++] = e >>> 8 & 255, i[s++] = e >>> 16 & 255, i[s++] = e >>> 24 & 255, i[s++] = 0, i[s++] = 0, i[s++] = 0, i[s++] = 0, a = 8; a < this.padLength; a++)
      i[s++] = 0;
  return i;
};
var ja = {}, Ai = {}, BI = ot, gi = BI.rotr32;
function jI(r, e, t, n) {
  if (r === 0)
    return i2(e, t, n);
  if (r === 1 || r === 3)
    return a2(e, t, n);
  if (r === 2)
    return s2(e, t, n);
}
Ai.ft_1 = jI;
function i2(r, e, t) {
  return r & e ^ ~r & t;
}
Ai.ch32 = i2;
function s2(r, e, t) {
  return r & e ^ r & t ^ e & t;
}
Ai.maj32 = s2;
function a2(r, e, t) {
  return r ^ e ^ t;
}
Ai.p32 = a2;
function UI(r) {
  return gi(r, 2) ^ gi(r, 13) ^ gi(r, 22);
}
Ai.s0_256 = UI;
function zI(r) {
  return gi(r, 6) ^ gi(r, 11) ^ gi(r, 25);
}
Ai.s1_256 = zI;
function WI(r) {
  return gi(r, 7) ^ gi(r, 18) ^ r >>> 3;
}
Ai.g0_256 = WI;
function HI(r) {
  return gi(r, 17) ^ gi(r, 19) ^ r >>> 10;
}
Ai.g1_256 = HI;
var ka = ot, VI = Ba, $I = Ai, gu = ka.rotl32, qa = ka.sum32, GI = ka.sum32_5, KI = $I.ft_1, o2 = VI.BlockHash, YI = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function wi() {
  if (!(this instanceof wi))
    return new wi();
  o2.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
ka.inherits(wi, o2);
var qI = wi;
wi.blockSize = 512;
wi.outSize = 160;
wi.hmacStrength = 80;
wi.padLength = 64;
wi.prototype._update = function(e, t) {
  for (var n = this.W, i = 0; i < 16; i++)
    n[i] = e[t + i];
  for (; i < n.length; i++)
    n[i] = gu(n[i - 3] ^ n[i - 8] ^ n[i - 14] ^ n[i - 16], 1);
  var s = this.h[0], a = this.h[1], o = this.h[2], l = this.h[3], c = this.h[4];
  for (i = 0; i < n.length; i++) {
    var u = ~~(i / 20), f = GI(gu(s, 5), KI(u, a, o, l), c, n[i], YI[u]);
    c = l, l = o, o = gu(a, 30), a = s, s = f;
  }
  this.h[0] = qa(this.h[0], s), this.h[1] = qa(this.h[1], a), this.h[2] = qa(this.h[2], o), this.h[3] = qa(this.h[3], l), this.h[4] = qa(this.h[4], c);
};
wi.prototype._digest = function(e) {
  return e === "hex" ? ka.toHex32(this.h, "big") : ka.split32(this.h, "big");
};
var Oa = ot, ZI = Ba, Ua = Ai, JI = Vo, zn = Oa.sum32, XI = Oa.sum32_4, QI = Oa.sum32_5, eC = Ua.ch32, tC = Ua.maj32, rC = Ua.s0_256, nC = Ua.s1_256, iC = Ua.g0_256, sC = Ua.g1_256, l2 = ZI.BlockHash, aC = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function _i() {
  if (!(this instanceof _i))
    return new _i();
  l2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = aC, this.W = new Array(64);
}
Oa.inherits(_i, l2);
var c2 = _i;
_i.blockSize = 512;
_i.outSize = 256;
_i.hmacStrength = 192;
_i.padLength = 64;
_i.prototype._update = function(e, t) {
  for (var n = this.W, i = 0; i < 16; i++)
    n[i] = e[t + i];
  for (; i < n.length; i++)
    n[i] = XI(sC(n[i - 2]), n[i - 7], iC(n[i - 15]), n[i - 16]);
  var s = this.h[0], a = this.h[1], o = this.h[2], l = this.h[3], c = this.h[4], u = this.h[5], f = this.h[6], p = this.h[7];
  for (JI(this.k.length === n.length), i = 0; i < n.length; i++) {
    var x = QI(p, nC(c), eC(c, u, f), this.k[i], n[i]), T = zn(rC(s), tC(s, a, o));
    p = f, f = u, u = c, c = zn(l, x), l = o, o = a, a = s, s = zn(x, T);
  }
  this.h[0] = zn(this.h[0], s), this.h[1] = zn(this.h[1], a), this.h[2] = zn(this.h[2], o), this.h[3] = zn(this.h[3], l), this.h[4] = zn(this.h[4], c), this.h[5] = zn(this.h[5], u), this.h[6] = zn(this.h[6], f), this.h[7] = zn(this.h[7], p);
};
_i.prototype._digest = function(e) {
  return e === "hex" ? Oa.toHex32(this.h, "big") : Oa.split32(this.h, "big");
};
var Td = ot, u2 = c2;
function Bi() {
  if (!(this instanceof Bi))
    return new Bi();
  u2.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
Td.inherits(Bi, u2);
var oC = Bi;
Bi.blockSize = 512;
Bi.outSize = 224;
Bi.hmacStrength = 192;
Bi.padLength = 64;
Bi.prototype._digest = function(e) {
  return e === "hex" ? Td.toHex32(this.h.slice(0, 7), "big") : Td.split32(this.h.slice(0, 7), "big");
};
var ln = ot, lC = Ba, cC = Vo, xi = ln.rotr64_hi, bi = ln.rotr64_lo, d2 = ln.shr64_hi, f2 = ln.shr64_lo, ts = ln.sum64, xu = ln.sum64_hi, bu = ln.sum64_lo, uC = ln.sum64_4_hi, dC = ln.sum64_4_lo, fC = ln.sum64_5_hi, hC = ln.sum64_5_lo, h2 = lC.BlockHash, pC = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function qn() {
  if (!(this instanceof qn))
    return new qn();
  h2.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = pC, this.W = new Array(160);
}
ln.inherits(qn, h2);
var p2 = qn;
qn.blockSize = 1024;
qn.outSize = 512;
qn.hmacStrength = 192;
qn.padLength = 128;
qn.prototype._prepareBlock = function(e, t) {
  for (var n = this.W, i = 0; i < 32; i++)
    n[i] = e[t + i];
  for (; i < n.length; i += 2) {
    var s = SC(n[i - 4], n[i - 3]), a = TC(n[i - 4], n[i - 3]), o = n[i - 14], l = n[i - 13], c = EC(n[i - 30], n[i - 29]), u = AC(n[i - 30], n[i - 29]), f = n[i - 32], p = n[i - 31];
    n[i] = uC(
      s,
      a,
      o,
      l,
      c,
      u,
      f,
      p
    ), n[i + 1] = dC(
      s,
      a,
      o,
      l,
      c,
      u,
      f,
      p
    );
  }
};
qn.prototype._update = function(e, t) {
  this._prepareBlock(e, t);
  var n = this.W, i = this.h[0], s = this.h[1], a = this.h[2], o = this.h[3], l = this.h[4], c = this.h[5], u = this.h[6], f = this.h[7], p = this.h[8], x = this.h[9], T = this.h[10], v = this.h[11], w = this.h[12], E = this.h[13], C = this.h[14], P = this.h[15];
  cC(this.k.length === n.length);
  for (var F = 0; F < n.length; F += 2) {
    var k = C, K = P, Z = wC(p, x), ne = _C(p, x), le = mC(p, x, T, v, w), ye = gC(p, x, T, v, w, E), ge = this.k[F], _e = this.k[F + 1], L = n[F], d = n[F + 1], b = fC(
      k,
      K,
      Z,
      ne,
      le,
      ye,
      ge,
      _e,
      L,
      d
    ), S = hC(
      k,
      K,
      Z,
      ne,
      le,
      ye,
      ge,
      _e,
      L,
      d
    );
    k = vC(i, s), K = yC(i, s), Z = xC(i, s, a, o, l), ne = bC(i, s, a, o, l, c);
    var R = xu(k, K, Z, ne), D = bu(k, K, Z, ne);
    C = w, P = E, w = T, E = v, T = p, v = x, p = xu(u, f, b, S), x = bu(f, f, b, S), u = l, f = c, l = a, c = o, a = i, o = s, i = xu(b, S, R, D), s = bu(b, S, R, D);
  }
  ts(this.h, 0, i, s), ts(this.h, 2, a, o), ts(this.h, 4, l, c), ts(this.h, 6, u, f), ts(this.h, 8, p, x), ts(this.h, 10, T, v), ts(this.h, 12, w, E), ts(this.h, 14, C, P);
};
qn.prototype._digest = function(e) {
  return e === "hex" ? ln.toHex32(this.h, "big") : ln.split32(this.h, "big");
};
function mC(r, e, t, n, i) {
  var s = r & t ^ ~r & i;
  return s < 0 && (s += 4294967296), s;
}
function gC(r, e, t, n, i, s) {
  var a = e & n ^ ~e & s;
  return a < 0 && (a += 4294967296), a;
}
function xC(r, e, t, n, i) {
  var s = r & t ^ r & i ^ t & i;
  return s < 0 && (s += 4294967296), s;
}
function bC(r, e, t, n, i, s) {
  var a = e & n ^ e & s ^ n & s;
  return a < 0 && (a += 4294967296), a;
}
function vC(r, e) {
  var t = xi(r, e, 28), n = xi(e, r, 2), i = xi(e, r, 7), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function yC(r, e) {
  var t = bi(r, e, 28), n = bi(e, r, 2), i = bi(e, r, 7), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function wC(r, e) {
  var t = xi(r, e, 14), n = xi(r, e, 18), i = xi(e, r, 9), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function _C(r, e) {
  var t = bi(r, e, 14), n = bi(r, e, 18), i = bi(e, r, 9), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function EC(r, e) {
  var t = xi(r, e, 1), n = xi(r, e, 8), i = d2(r, e, 7), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function AC(r, e) {
  var t = bi(r, e, 1), n = bi(r, e, 8), i = f2(r, e, 7), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function SC(r, e) {
  var t = xi(r, e, 19), n = xi(e, r, 29), i = d2(r, e, 6), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
function TC(r, e) {
  var t = bi(r, e, 19), n = bi(e, r, 29), i = f2(r, e, 6), s = t ^ n ^ i;
  return s < 0 && (s += 4294967296), s;
}
var Md = ot, m2 = p2;
function ji() {
  if (!(this instanceof ji))
    return new ji();
  m2.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
Md.inherits(ji, m2);
var MC = ji;
ji.blockSize = 1024;
ji.outSize = 384;
ji.hmacStrength = 192;
ji.padLength = 128;
ji.prototype._digest = function(e) {
  return e === "hex" ? Md.toHex32(this.h.slice(0, 12), "big") : Md.split32(this.h.slice(0, 12), "big");
};
ja.sha1 = qI;
ja.sha224 = oC;
ja.sha256 = c2;
ja.sha384 = MC;
ja.sha512 = p2;
var g2 = {}, Bs = ot, IC = Ba, fl = Bs.rotl32, u1 = Bs.sum32, Za = Bs.sum32_3, d1 = Bs.sum32_4, x2 = IC.BlockHash;
function Ei() {
  if (!(this instanceof Ei))
    return new Ei();
  x2.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
Bs.inherits(Ei, x2);
g2.ripemd160 = Ei;
Ei.blockSize = 512;
Ei.outSize = 160;
Ei.hmacStrength = 192;
Ei.padLength = 64;
Ei.prototype._update = function(e, t) {
  for (var n = this.h[0], i = this.h[1], s = this.h[2], a = this.h[3], o = this.h[4], l = n, c = i, u = s, f = a, p = o, x = 0; x < 80; x++) {
    var T = u1(
      fl(
        d1(n, f1(x, i, s, a), e[kC[x] + t], CC(x)),
        NC[x]
      ),
      o
    );
    n = o, o = a, a = fl(s, 10), s = i, i = T, T = u1(
      fl(
        d1(l, f1(79 - x, c, u, f), e[OC[x] + t], PC(x)),
        RC[x]
      ),
      p
    ), l = p, p = f, f = fl(u, 10), u = c, c = T;
  }
  T = Za(this.h[1], s, f), this.h[1] = Za(this.h[2], a, p), this.h[2] = Za(this.h[3], o, l), this.h[3] = Za(this.h[4], n, c), this.h[4] = Za(this.h[0], i, u), this.h[0] = T;
};
Ei.prototype._digest = function(e) {
  return e === "hex" ? Bs.toHex32(this.h, "little") : Bs.split32(this.h, "little");
};
function f1(r, e, t, n) {
  return r <= 15 ? e ^ t ^ n : r <= 31 ? e & t | ~e & n : r <= 47 ? (e | ~t) ^ n : r <= 63 ? e & n | t & ~n : e ^ (t | ~n);
}
function CC(r) {
  return r <= 15 ? 0 : r <= 31 ? 1518500249 : r <= 47 ? 1859775393 : r <= 63 ? 2400959708 : 2840853838;
}
function PC(r) {
  return r <= 15 ? 1352829926 : r <= 31 ? 1548603684 : r <= 47 ? 1836072691 : r <= 63 ? 2053994217 : 0;
}
var kC = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], OC = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], NC = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], RC = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], LC = ot, DC = Vo;
function Na(r, e, t) {
  if (!(this instanceof Na))
    return new Na(r, e, t);
  this.Hash = r, this.blockSize = r.blockSize / 8, this.outSize = r.outSize / 8, this.inner = null, this.outer = null, this._init(LC.toArray(e, t));
}
var FC = Na;
Na.prototype._init = function(e) {
  e.length > this.blockSize && (e = new this.Hash().update(e).digest()), DC(e.length <= this.blockSize);
  for (var t = e.length; t < this.blockSize; t++)
    e.push(0);
  for (t = 0; t < e.length; t++)
    e[t] ^= 54;
  for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++)
    e[t] ^= 106;
  this.outer = new this.Hash().update(e);
};
Na.prototype.update = function(e, t) {
  return this.inner.update(e, t), this;
};
Na.prototype.digest = function(e) {
  return this.outer.update(this.inner.digest()), this.outer.digest(e);
};
(function(r) {
  var e = r;
  e.utils = ot, e.common = Ba, e.sha = ja, e.ripemd = g2, e.hmac = FC, e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
})(Qg);
const rn = /* @__PURE__ */ zi(Qg);
function za(r, e, t) {
  return t = {
    path: e,
    exports: {},
    require: function(n, i) {
      return BC(n, i ?? t.path);
    }
  }, r(t, t.exports), t.exports;
}
function BC() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var Pf = b2;
function b2(r, e) {
  if (!r)
    throw new Error(e || "Assertion failed");
}
b2.equal = function(e, t, n) {
  if (e != t)
    throw new Error(n || "Assertion failed: " + e + " != " + t);
};
var Gn = za(function(r, e) {
  var t = e;
  function n(a, o) {
    if (Array.isArray(a))
      return a.slice();
    if (!a)
      return [];
    var l = [];
    if (typeof a != "string") {
      for (var c = 0; c < a.length; c++)
        l[c] = a[c] | 0;
      return l;
    }
    if (o === "hex") {
      a = a.replace(/[^a-z0-9]+/ig, ""), a.length % 2 !== 0 && (a = "0" + a);
      for (var c = 0; c < a.length; c += 2)
        l.push(parseInt(a[c] + a[c + 1], 16));
    } else
      for (var c = 0; c < a.length; c++) {
        var u = a.charCodeAt(c), f = u >> 8, p = u & 255;
        f ? l.push(f, p) : l.push(p);
      }
    return l;
  }
  t.toArray = n;
  function i(a) {
    return a.length === 1 ? "0" + a : a;
  }
  t.zero2 = i;
  function s(a) {
    for (var o = "", l = 0; l < a.length; l++)
      o += i(a[l].toString(16));
    return o;
  }
  t.toHex = s, t.encode = function(o, l) {
    return l === "hex" ? s(o) : o;
  };
}), _n = za(function(r, e) {
  var t = e;
  t.assert = Pf, t.toArray = Gn.toArray, t.zero2 = Gn.zero2, t.toHex = Gn.toHex, t.encode = Gn.encode;
  function n(l, c, u) {
    var f = new Array(Math.max(l.bitLength(), u) + 1);
    f.fill(0);
    for (var p = 1 << c + 1, x = l.clone(), T = 0; T < f.length; T++) {
      var v, w = x.andln(p - 1);
      x.isOdd() ? (w > (p >> 1) - 1 ? v = (p >> 1) - w : v = w, x.isubn(v)) : v = 0, f[T] = v, x.iushrn(1);
    }
    return f;
  }
  t.getNAF = n;
  function i(l, c) {
    var u = [
      [],
      []
    ];
    l = l.clone(), c = c.clone();
    for (var f = 0, p = 0, x; l.cmpn(-f) > 0 || c.cmpn(-p) > 0; ) {
      var T = l.andln(3) + f & 3, v = c.andln(3) + p & 3;
      T === 3 && (T = -1), v === 3 && (v = -1);
      var w;
      T & 1 ? (x = l.andln(7) + f & 7, (x === 3 || x === 5) && v === 2 ? w = -T : w = T) : w = 0, u[0].push(w);
      var E;
      v & 1 ? (x = c.andln(7) + p & 7, (x === 3 || x === 5) && T === 2 ? E = -v : E = v) : E = 0, u[1].push(E), 2 * f === w + 1 && (f = 1 - f), 2 * p === E + 1 && (p = 1 - p), l.iushrn(1), c.iushrn(1);
    }
    return u;
  }
  t.getJSF = i;
  function s(l, c, u) {
    var f = "_" + c;
    l.prototype[c] = function() {
      return this[f] !== void 0 ? this[f] : this[f] = u.call(this);
    };
  }
  t.cachedProperty = s;
  function a(l) {
    return typeof l == "string" ? t.toArray(l, "hex") : l;
  }
  t.parseBytes = a;
  function o(l) {
    return new $e(l, "hex", "le");
  }
  t.intFromLE = o;
}), ql = _n.getNAF, jC = _n.getJSF, Zl = _n.assert;
function xs(r, e) {
  this.type = r, this.p = new $e(e.p, 16), this.red = e.prime ? $e.red(e.prime) : $e.mont(this.p), this.zero = new $e(0).toRed(this.red), this.one = new $e(1).toRed(this.red), this.two = new $e(2).toRed(this.red), this.n = e.n && new $e(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var t = this.n && this.p.div(this.n);
  !t || t.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var Ys = xs;
xs.prototype.point = function() {
  throw new Error("Not implemented");
};
xs.prototype.validate = function() {
  throw new Error("Not implemented");
};
xs.prototype._fixedNafMul = function(e, t) {
  Zl(e.precomputed);
  var n = e._getDoubles(), i = ql(t, 1, this._bitLength), s = (1 << n.step + 1) - (n.step % 2 === 0 ? 2 : 1);
  s /= 3;
  var a = [], o, l;
  for (o = 0; o < i.length; o += n.step) {
    l = 0;
    for (var c = o + n.step - 1; c >= o; c--)
      l = (l << 1) + i[c];
    a.push(l);
  }
  for (var u = this.jpoint(null, null, null), f = this.jpoint(null, null, null), p = s; p > 0; p--) {
    for (o = 0; o < a.length; o++)
      l = a[o], l === p ? f = f.mixedAdd(n.points[o]) : l === -p && (f = f.mixedAdd(n.points[o].neg()));
    u = u.add(f);
  }
  return u.toP();
};
xs.prototype._wnafMul = function(e, t) {
  var n = 4, i = e._getNAFPoints(n);
  n = i.wnd;
  for (var s = i.points, a = ql(t, n, this._bitLength), o = this.jpoint(null, null, null), l = a.length - 1; l >= 0; l--) {
    for (var c = 0; l >= 0 && a[l] === 0; l--)
      c++;
    if (l >= 0 && c++, o = o.dblp(c), l < 0)
      break;
    var u = a[l];
    Zl(u !== 0), e.type === "affine" ? u > 0 ? o = o.mixedAdd(s[u - 1 >> 1]) : o = o.mixedAdd(s[-u - 1 >> 1].neg()) : u > 0 ? o = o.add(s[u - 1 >> 1]) : o = o.add(s[-u - 1 >> 1].neg());
  }
  return e.type === "affine" ? o.toP() : o;
};
xs.prototype._wnafMulAdd = function(e, t, n, i, s) {
  var a = this._wnafT1, o = this._wnafT2, l = this._wnafT3, c = 0, u, f, p;
  for (u = 0; u < i; u++) {
    p = t[u];
    var x = p._getNAFPoints(e);
    a[u] = x.wnd, o[u] = x.points;
  }
  for (u = i - 1; u >= 1; u -= 2) {
    var T = u - 1, v = u;
    if (a[T] !== 1 || a[v] !== 1) {
      l[T] = ql(n[T], a[T], this._bitLength), l[v] = ql(n[v], a[v], this._bitLength), c = Math.max(l[T].length, c), c = Math.max(l[v].length, c);
      continue;
    }
    var w = [
      t[T],
      /* 1 */
      null,
      /* 3 */
      null,
      /* 5 */
      t[v]
      /* 7 */
    ];
    t[T].y.cmp(t[v].y) === 0 ? (w[1] = t[T].add(t[v]), w[2] = t[T].toJ().mixedAdd(t[v].neg())) : t[T].y.cmp(t[v].y.redNeg()) === 0 ? (w[1] = t[T].toJ().mixedAdd(t[v]), w[2] = t[T].add(t[v].neg())) : (w[1] = t[T].toJ().mixedAdd(t[v]), w[2] = t[T].toJ().mixedAdd(t[v].neg()));
    var E = [
      -3,
      /* -1 -1 */
      -1,
      /* -1 0 */
      -5,
      /* -1 1 */
      -7,
      /* 0 -1 */
      0,
      /* 0 0 */
      7,
      /* 0 1 */
      5,
      /* 1 -1 */
      1,
      /* 1 0 */
      3
      /* 1 1 */
    ], C = jC(n[T], n[v]);
    for (c = Math.max(C[0].length, c), l[T] = new Array(c), l[v] = new Array(c), f = 0; f < c; f++) {
      var P = C[0][f] | 0, F = C[1][f] | 0;
      l[T][f] = E[(P + 1) * 3 + (F + 1)], l[v][f] = 0, o[T] = w;
    }
  }
  var k = this.jpoint(null, null, null), K = this._wnafT4;
  for (u = c; u >= 0; u--) {
    for (var Z = 0; u >= 0; ) {
      var ne = !0;
      for (f = 0; f < i; f++)
        K[f] = l[f][u] | 0, K[f] !== 0 && (ne = !1);
      if (!ne)
        break;
      Z++, u--;
    }
    if (u >= 0 && Z++, k = k.dblp(Z), u < 0)
      break;
    for (f = 0; f < i; f++) {
      var le = K[f];
      le !== 0 && (le > 0 ? p = o[f][le - 1 >> 1] : le < 0 && (p = o[f][-le - 1 >> 1].neg()), p.type === "affine" ? k = k.mixedAdd(p) : k = k.add(p));
    }
  }
  for (u = 0; u < i; u++)
    o[u] = null;
  return s ? k : k.toP();
};
function Ln(r, e) {
  this.curve = r, this.type = e, this.precomputed = null;
}
xs.BasePoint = Ln;
Ln.prototype.eq = function() {
  throw new Error("Not implemented");
};
Ln.prototype.validate = function() {
  return this.curve.validate(this);
};
xs.prototype.decodePoint = function(e, t) {
  e = _n.toArray(e, t);
  var n = this.p.byteLength();
  if ((e[0] === 4 || e[0] === 6 || e[0] === 7) && e.length - 1 === 2 * n) {
    e[0] === 6 ? Zl(e[e.length - 1] % 2 === 0) : e[0] === 7 && Zl(e[e.length - 1] % 2 === 1);
    var i = this.point(
      e.slice(1, 1 + n),
      e.slice(1 + n, 1 + 2 * n)
    );
    return i;
  } else if ((e[0] === 2 || e[0] === 3) && e.length - 1 === n)
    return this.pointFromX(e.slice(1, 1 + n), e[0] === 3);
  throw new Error("Unknown point format");
};
Ln.prototype.encodeCompressed = function(e) {
  return this.encode(e, !0);
};
Ln.prototype._encode = function(e) {
  var t = this.curve.p.byteLength(), n = this.getX().toArray("be", t);
  return e ? [this.getY().isEven() ? 2 : 3].concat(n) : [4].concat(n, this.getY().toArray("be", t));
};
Ln.prototype.encode = function(e, t) {
  return _n.encode(this._encode(t), e);
};
Ln.prototype.precompute = function(e) {
  if (this.precomputed)
    return this;
  var t = {
    doubles: null,
    naf: null,
    beta: null
  };
  return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
};
Ln.prototype._hasDoubles = function(e) {
  if (!this.precomputed)
    return !1;
  var t = this.precomputed.doubles;
  return t ? t.points.length >= Math.ceil((e.bitLength() + 1) / t.step) : !1;
};
Ln.prototype._getDoubles = function(e, t) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var n = [this], i = this, s = 0; s < t; s += e) {
    for (var a = 0; a < e; a++)
      i = i.dbl();
    n.push(i);
  }
  return {
    step: e,
    points: n
  };
};
Ln.prototype._getNAFPoints = function(e) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var t = [this], n = (1 << e) - 1, i = n === 1 ? null : this.dbl(), s = 1; s < n; s++)
    t[s] = t[s - 1].add(i);
  return {
    wnd: e,
    points: t
  };
};
Ln.prototype._getBeta = function() {
  return null;
};
Ln.prototype.dblp = function(e) {
  for (var t = this, n = 0; n < e; n++)
    t = t.dbl();
  return t;
};
var kf = za(function(r) {
  typeof Object.create == "function" ? r.exports = function(t, n) {
    n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : r.exports = function(t, n) {
    if (n) {
      t.super_ = n;
      var i = function() {
      };
      i.prototype = n.prototype, t.prototype = new i(), t.prototype.constructor = t;
    }
  };
}), UC = _n.assert;
function Dn(r) {
  Ys.call(this, "short", r), this.a = new $e(r.a, 16).toRed(this.red), this.b = new $e(r.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(r), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
kf(Dn, Ys);
var zC = Dn;
Dn.prototype._getEndomorphism = function(e) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var t, n;
    if (e.beta)
      t = new $e(e.beta, 16).toRed(this.red);
    else {
      var i = this._getEndoRoots(this.p);
      t = i[0].cmp(i[1]) < 0 ? i[0] : i[1], t = t.toRed(this.red);
    }
    if (e.lambda)
      n = new $e(e.lambda, 16);
    else {
      var s = this._getEndoRoots(this.n);
      this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) === 0 ? n = s[0] : (n = s[1], UC(this.g.mul(n).x.cmp(this.g.x.redMul(t)) === 0));
    }
    var a;
    return e.basis ? a = e.basis.map(function(o) {
      return {
        a: new $e(o.a, 16),
        b: new $e(o.b, 16)
      };
    }) : a = this._getEndoBasis(n), {
      beta: t,
      lambda: n,
      basis: a
    };
  }
};
Dn.prototype._getEndoRoots = function(e) {
  var t = e === this.p ? this.red : $e.mont(e), n = new $e(2).toRed(t).redInvm(), i = n.redNeg(), s = new $e(3).toRed(t).redNeg().redSqrt().redMul(n), a = i.redAdd(s).fromRed(), o = i.redSub(s).fromRed();
  return [a, o];
};
Dn.prototype._getEndoBasis = function(e) {
  for (var t = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), n = e, i = this.n.clone(), s = new $e(1), a = new $e(0), o = new $e(0), l = new $e(1), c, u, f, p, x, T, v, w = 0, E, C; n.cmpn(0) !== 0; ) {
    var P = i.div(n);
    E = i.sub(P.mul(n)), C = o.sub(P.mul(s));
    var F = l.sub(P.mul(a));
    if (!f && E.cmp(t) < 0)
      c = v.neg(), u = s, f = E.neg(), p = C;
    else if (f && ++w === 2)
      break;
    v = E, i = n, n = E, o = s, s = C, l = a, a = F;
  }
  x = E.neg(), T = C;
  var k = f.sqr().add(p.sqr()), K = x.sqr().add(T.sqr());
  return K.cmp(k) >= 0 && (x = c, T = u), f.negative && (f = f.neg(), p = p.neg()), x.negative && (x = x.neg(), T = T.neg()), [
    { a: f, b: p },
    { a: x, b: T }
  ];
};
Dn.prototype._endoSplit = function(e) {
  var t = this.endo.basis, n = t[0], i = t[1], s = i.b.mul(e).divRound(this.n), a = n.b.neg().mul(e).divRound(this.n), o = s.mul(n.a), l = a.mul(i.a), c = s.mul(n.b), u = a.mul(i.b), f = e.sub(o).sub(l), p = c.add(u).neg();
  return { k1: f, k2: p };
};
Dn.prototype.pointFromX = function(e, t) {
  e = new $e(e, 16), e.red || (e = e.toRed(this.red));
  var n = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), i = n.redSqrt();
  if (i.redSqr().redSub(n).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var s = i.fromRed().isOdd();
  return (t && !s || !t && s) && (i = i.redNeg()), this.point(e, i);
};
Dn.prototype.validate = function(e) {
  if (e.inf)
    return !0;
  var t = e.x, n = e.y, i = this.a.redMul(t), s = t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);
  return n.redSqr().redISub(s).cmpn(0) === 0;
};
Dn.prototype._endoWnafMulAdd = function(e, t, n) {
  for (var i = this._endoWnafT1, s = this._endoWnafT2, a = 0; a < e.length; a++) {
    var o = this._endoSplit(t[a]), l = e[a], c = l._getBeta();
    o.k1.negative && (o.k1.ineg(), l = l.neg(!0)), o.k2.negative && (o.k2.ineg(), c = c.neg(!0)), i[a * 2] = l, i[a * 2 + 1] = c, s[a * 2] = o.k1, s[a * 2 + 1] = o.k2;
  }
  for (var u = this._wnafMulAdd(1, i, s, a * 2, n), f = 0; f < a * 2; f++)
    i[f] = null, s[f] = null;
  return u;
};
function Ar(r, e, t, n) {
  Ys.BasePoint.call(this, r, "affine"), e === null && t === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new $e(e, 16), this.y = new $e(t, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
kf(Ar, Ys.BasePoint);
Dn.prototype.point = function(e, t, n) {
  return new Ar(this, e, t, n);
};
Dn.prototype.pointFromJSON = function(e, t) {
  return Ar.fromJSON(this, e, t);
};
Ar.prototype._getBeta = function() {
  if (this.curve.endo) {
    var e = this.precomputed;
    if (e && e.beta)
      return e.beta;
    var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (e) {
      var n = this.curve, i = function(s) {
        return n.point(s.x.redMul(n.endo.beta), s.y);
      };
      e.beta = t, t.precomputed = {
        beta: null,
        naf: e.naf && {
          wnd: e.naf.wnd,
          points: e.naf.points.map(i)
        },
        doubles: e.doubles && {
          step: e.doubles.step,
          points: e.doubles.points.map(i)
        }
      };
    }
    return t;
  }
};
Ar.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Ar.fromJSON = function(e, t, n) {
  typeof t == "string" && (t = JSON.parse(t));
  var i = e.point(t[0], t[1], n);
  if (!t[2])
    return i;
  function s(o) {
    return e.point(o[0], o[1], n);
  }
  var a = t[2];
  return i.precomputed = {
    beta: null,
    doubles: a.doubles && {
      step: a.doubles.step,
      points: [i].concat(a.doubles.points.map(s))
    },
    naf: a.naf && {
      wnd: a.naf.wnd,
      points: [i].concat(a.naf.points.map(s))
    }
  }, i;
};
Ar.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Ar.prototype.isInfinity = function() {
  return this.inf;
};
Ar.prototype.add = function(e) {
  if (this.inf)
    return e;
  if (e.inf)
    return this;
  if (this.eq(e))
    return this.dbl();
  if (this.neg().eq(e))
    return this.curve.point(null, null);
  if (this.x.cmp(e.x) === 0)
    return this.curve.point(null, null);
  var t = this.y.redSub(e.y);
  t.cmpn(0) !== 0 && (t = t.redMul(this.x.redSub(e.x).redInvm()));
  var n = t.redSqr().redISub(this.x).redISub(e.x), i = t.redMul(this.x.redSub(n)).redISub(this.y);
  return this.curve.point(n, i);
};
Ar.prototype.dbl = function() {
  if (this.inf)
    return this;
  var e = this.y.redAdd(this.y);
  if (e.cmpn(0) === 0)
    return this.curve.point(null, null);
  var t = this.curve.a, n = this.x.redSqr(), i = e.redInvm(), s = n.redAdd(n).redIAdd(n).redIAdd(t).redMul(i), a = s.redSqr().redISub(this.x.redAdd(this.x)), o = s.redMul(this.x.redSub(a)).redISub(this.y);
  return this.curve.point(a, o);
};
Ar.prototype.getX = function() {
  return this.x.fromRed();
};
Ar.prototype.getY = function() {
  return this.y.fromRed();
};
Ar.prototype.mul = function(e) {
  return e = new $e(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
};
Ar.prototype.mulAdd = function(e, t, n) {
  var i = [this, t], s = [e, n];
  return this.curve.endo ? this.curve._endoWnafMulAdd(i, s) : this.curve._wnafMulAdd(1, i, s, 2);
};
Ar.prototype.jmulAdd = function(e, t, n) {
  var i = [this, t], s = [e, n];
  return this.curve.endo ? this.curve._endoWnafMulAdd(i, s, !0) : this.curve._wnafMulAdd(1, i, s, 2, !0);
};
Ar.prototype.eq = function(e) {
  return this === e || this.inf === e.inf && (this.inf || this.x.cmp(e.x) === 0 && this.y.cmp(e.y) === 0);
};
Ar.prototype.neg = function(e) {
  if (this.inf)
    return this;
  var t = this.curve.point(this.x, this.y.redNeg());
  if (e && this.precomputed) {
    var n = this.precomputed, i = function(s) {
      return s.neg();
    };
    t.precomputed = {
      naf: n.naf && {
        wnd: n.naf.wnd,
        points: n.naf.points.map(i)
      },
      doubles: n.doubles && {
        step: n.doubles.step,
        points: n.doubles.points.map(i)
      }
    };
  }
  return t;
};
Ar.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var e = this.curve.jpoint(this.x, this.y, this.curve.one);
  return e;
};
function Rr(r, e, t, n) {
  Ys.BasePoint.call(this, r, "jacobian"), e === null && t === null && n === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new $e(0)) : (this.x = new $e(e, 16), this.y = new $e(t, 16), this.z = new $e(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
kf(Rr, Ys.BasePoint);
Dn.prototype.jpoint = function(e, t, n) {
  return new Rr(this, e, t, n);
};
Rr.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var e = this.z.redInvm(), t = e.redSqr(), n = this.x.redMul(t), i = this.y.redMul(t).redMul(e);
  return this.curve.point(n, i);
};
Rr.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
Rr.prototype.add = function(e) {
  if (this.isInfinity())
    return e;
  if (e.isInfinity())
    return this;
  var t = e.z.redSqr(), n = this.z.redSqr(), i = this.x.redMul(t), s = e.x.redMul(n), a = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(n.redMul(this.z)), l = i.redSub(s), c = a.redSub(o);
  if (l.cmpn(0) === 0)
    return c.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var u = l.redSqr(), f = u.redMul(l), p = i.redMul(u), x = c.redSqr().redIAdd(f).redISub(p).redISub(p), T = c.redMul(p.redISub(x)).redISub(a.redMul(f)), v = this.z.redMul(e.z).redMul(l);
  return this.curve.jpoint(x, T, v);
};
Rr.prototype.mixedAdd = function(e) {
  if (this.isInfinity())
    return e.toJ();
  if (e.isInfinity())
    return this;
  var t = this.z.redSqr(), n = this.x, i = e.x.redMul(t), s = this.y, a = e.y.redMul(t).redMul(this.z), o = n.redSub(i), l = s.redSub(a);
  if (o.cmpn(0) === 0)
    return l.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var c = o.redSqr(), u = c.redMul(o), f = n.redMul(c), p = l.redSqr().redIAdd(u).redISub(f).redISub(f), x = l.redMul(f.redISub(p)).redISub(s.redMul(u)), T = this.z.redMul(o);
  return this.curve.jpoint(p, x, T);
};
Rr.prototype.dblp = function(e) {
  if (e === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!e)
    return this.dbl();
  var t;
  if (this.curve.zeroA || this.curve.threeA) {
    var n = this;
    for (t = 0; t < e; t++)
      n = n.dbl();
    return n;
  }
  var i = this.curve.a, s = this.curve.tinv, a = this.x, o = this.y, l = this.z, c = l.redSqr().redSqr(), u = o.redAdd(o);
  for (t = 0; t < e; t++) {
    var f = a.redSqr(), p = u.redSqr(), x = p.redSqr(), T = f.redAdd(f).redIAdd(f).redIAdd(i.redMul(c)), v = a.redMul(p), w = T.redSqr().redISub(v.redAdd(v)), E = v.redISub(w), C = T.redMul(E);
    C = C.redIAdd(C).redISub(x);
    var P = u.redMul(l);
    t + 1 < e && (c = c.redMul(x)), a = w, l = P, u = C;
  }
  return this.curve.jpoint(a, u.redMul(s), l);
};
Rr.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
Rr.prototype._zeroDbl = function() {
  var e, t, n;
  if (this.zOne) {
    var i = this.x.redSqr(), s = this.y.redSqr(), a = s.redSqr(), o = this.x.redAdd(s).redSqr().redISub(i).redISub(a);
    o = o.redIAdd(o);
    var l = i.redAdd(i).redIAdd(i), c = l.redSqr().redISub(o).redISub(o), u = a.redIAdd(a);
    u = u.redIAdd(u), u = u.redIAdd(u), e = c, t = l.redMul(o.redISub(c)).redISub(u), n = this.y.redAdd(this.y);
  } else {
    var f = this.x.redSqr(), p = this.y.redSqr(), x = p.redSqr(), T = this.x.redAdd(p).redSqr().redISub(f).redISub(x);
    T = T.redIAdd(T);
    var v = f.redAdd(f).redIAdd(f), w = v.redSqr(), E = x.redIAdd(x);
    E = E.redIAdd(E), E = E.redIAdd(E), e = w.redISub(T).redISub(T), t = v.redMul(T.redISub(e)).redISub(E), n = this.y.redMul(this.z), n = n.redIAdd(n);
  }
  return this.curve.jpoint(e, t, n);
};
Rr.prototype._threeDbl = function() {
  var e, t, n;
  if (this.zOne) {
    var i = this.x.redSqr(), s = this.y.redSqr(), a = s.redSqr(), o = this.x.redAdd(s).redSqr().redISub(i).redISub(a);
    o = o.redIAdd(o);
    var l = i.redAdd(i).redIAdd(i).redIAdd(this.curve.a), c = l.redSqr().redISub(o).redISub(o);
    e = c;
    var u = a.redIAdd(a);
    u = u.redIAdd(u), u = u.redIAdd(u), t = l.redMul(o.redISub(c)).redISub(u), n = this.y.redAdd(this.y);
  } else {
    var f = this.z.redSqr(), p = this.y.redSqr(), x = this.x.redMul(p), T = this.x.redSub(f).redMul(this.x.redAdd(f));
    T = T.redAdd(T).redIAdd(T);
    var v = x.redIAdd(x);
    v = v.redIAdd(v);
    var w = v.redAdd(v);
    e = T.redSqr().redISub(w), n = this.y.redAdd(this.z).redSqr().redISub(p).redISub(f);
    var E = p.redSqr();
    E = E.redIAdd(E), E = E.redIAdd(E), E = E.redIAdd(E), t = T.redMul(v.redISub(e)).redISub(E);
  }
  return this.curve.jpoint(e, t, n);
};
Rr.prototype._dbl = function() {
  var e = this.curve.a, t = this.x, n = this.y, i = this.z, s = i.redSqr().redSqr(), a = t.redSqr(), o = n.redSqr(), l = a.redAdd(a).redIAdd(a).redIAdd(e.redMul(s)), c = t.redAdd(t);
  c = c.redIAdd(c);
  var u = c.redMul(o), f = l.redSqr().redISub(u.redAdd(u)), p = u.redISub(f), x = o.redSqr();
  x = x.redIAdd(x), x = x.redIAdd(x), x = x.redIAdd(x);
  var T = l.redMul(p).redISub(x), v = n.redAdd(n).redMul(i);
  return this.curve.jpoint(f, T, v);
};
Rr.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var e = this.x.redSqr(), t = this.y.redSqr(), n = this.z.redSqr(), i = t.redSqr(), s = e.redAdd(e).redIAdd(e), a = s.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(i);
  o = o.redIAdd(o), o = o.redAdd(o).redIAdd(o), o = o.redISub(a);
  var l = o.redSqr(), c = i.redIAdd(i);
  c = c.redIAdd(c), c = c.redIAdd(c), c = c.redIAdd(c);
  var u = s.redIAdd(o).redSqr().redISub(a).redISub(l).redISub(c), f = t.redMul(u);
  f = f.redIAdd(f), f = f.redIAdd(f);
  var p = this.x.redMul(l).redISub(f);
  p = p.redIAdd(p), p = p.redIAdd(p);
  var x = this.y.redMul(u.redMul(c.redISub(u)).redISub(o.redMul(l)));
  x = x.redIAdd(x), x = x.redIAdd(x), x = x.redIAdd(x);
  var T = this.z.redAdd(o).redSqr().redISub(n).redISub(l);
  return this.curve.jpoint(p, x, T);
};
Rr.prototype.mul = function(e, t) {
  return e = new $e(e, t), this.curve._wnafMul(this, e);
};
Rr.prototype.eq = function(e) {
  if (e.type === "affine")
    return this.eq(e.toJ());
  if (this === e)
    return !0;
  var t = this.z.redSqr(), n = e.z.redSqr();
  if (this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0) !== 0)
    return !1;
  var i = t.redMul(this.z), s = n.redMul(e.z);
  return this.y.redMul(s).redISub(e.y.redMul(i)).cmpn(0) === 0;
};
Rr.prototype.eqXToP = function(e) {
  var t = this.z.redSqr(), n = e.toRed(this.curve.red).redMul(t);
  if (this.x.cmp(n) === 0)
    return !0;
  for (var i = e.clone(), s = this.curve.redN.redMul(t); ; ) {
    if (i.iadd(this.curve.n), i.cmp(this.curve.p) >= 0)
      return !1;
    if (n.redIAdd(s), this.x.cmp(n) === 0)
      return !0;
  }
};
Rr.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
Rr.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var Cl = za(function(r, e) {
  var t = e;
  t.base = Ys, t.short = zC, t.mont = /*RicMoo:ethers:require(./mont)*/
  null, t.edwards = /*RicMoo:ethers:require(./edwards)*/
  null;
}), Pl = za(function(r, e) {
  var t = e, n = _n.assert;
  function i(o) {
    o.type === "short" ? this.curve = new Cl.short(o) : o.type === "edwards" ? this.curve = new Cl.edwards(o) : this.curve = new Cl.mont(o), this.g = this.curve.g, this.n = this.curve.n, this.hash = o.hash, n(this.g.validate(), "Invalid curve"), n(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  t.PresetCurve = i;
  function s(o, l) {
    Object.defineProperty(t, o, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var c = new i(l);
        return Object.defineProperty(t, o, {
          configurable: !0,
          enumerable: !0,
          value: c
        }), c;
      }
    });
  }
  s("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: rn.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), s("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: rn.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), s("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: rn.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), s("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: rn.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), s("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: rn.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), s("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: rn.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), s("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: rn.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      // 4/5
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var a;
  try {
    a = /*RicMoo:ethers:require(./precomputed/secp256k1)*/
    null.crash();
  } catch {
    a = void 0;
  }
  s("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: rn.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      a
    ]
  });
});
function hs(r) {
  if (!(this instanceof hs))
    return new hs(r);
  this.hash = r.hash, this.predResist = !!r.predResist, this.outLen = this.hash.outSize, this.minEntropy = r.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var e = Gn.toArray(r.entropy, r.entropyEnc || "hex"), t = Gn.toArray(r.nonce, r.nonceEnc || "hex"), n = Gn.toArray(r.pers, r.persEnc || "hex");
  Pf(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(e, t, n);
}
var v2 = hs;
hs.prototype._init = function(e, t, n) {
  var i = e.concat(t).concat(n);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var s = 0; s < this.V.length; s++)
    this.K[s] = 0, this.V[s] = 1;
  this._update(i), this._reseed = 1, this.reseedInterval = 281474976710656;
};
hs.prototype._hmac = function() {
  return new rn.hmac(this.hash, this.K);
};
hs.prototype._update = function(e) {
  var t = this._hmac().update(this.V).update([0]);
  e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
};
hs.prototype.reseed = function(e, t, n, i) {
  typeof t != "string" && (i = n, n = t, t = null), e = Gn.toArray(e, t), n = Gn.toArray(n, i), Pf(
    e.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(e.concat(n || [])), this._reseed = 1;
};
hs.prototype.generate = function(e, t, n, i) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof t != "string" && (i = n, n = t, t = null), n && (n = Gn.toArray(n, i || "hex"), this._update(n));
  for (var s = []; s.length < e; )
    this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
  var a = s.slice(0, e);
  return this._update(n), this._reseed++, Gn.encode(a, t);
};
var Id = _n.assert;
function Wr(r, e) {
  this.ec = r, this.priv = null, this.pub = null, e.priv && this._importPrivate(e.priv, e.privEnc), e.pub && this._importPublic(e.pub, e.pubEnc);
}
var Of = Wr;
Wr.fromPublic = function(e, t, n) {
  return t instanceof Wr ? t : new Wr(e, {
    pub: t,
    pubEnc: n
  });
};
Wr.fromPrivate = function(e, t, n) {
  return t instanceof Wr ? t : new Wr(e, {
    priv: t,
    privEnc: n
  });
};
Wr.prototype.validate = function() {
  var e = this.getPublic();
  return e.isInfinity() ? { result: !1, reason: "Invalid public key" } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
Wr.prototype.getPublic = function(e, t) {
  return typeof e == "string" && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
};
Wr.prototype.getPrivate = function(e) {
  return e === "hex" ? this.priv.toString(16, 2) : this.priv;
};
Wr.prototype._importPrivate = function(e, t) {
  this.priv = new $e(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
Wr.prototype._importPublic = function(e, t) {
  if (e.x || e.y) {
    this.ec.curve.type === "mont" ? Id(e.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && Id(e.x && e.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(e.x, e.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(e, t);
};
Wr.prototype.derive = function(e) {
  return e.validate() || Id(e.validate(), "public point not validated"), e.mul(this.priv).getX();
};
Wr.prototype.sign = function(e, t, n) {
  return this.ec.sign(e, this, t, n);
};
Wr.prototype.verify = function(e, t) {
  return this.ec.verify(e, t, this);
};
Wr.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var WC = _n.assert;
function _c(r, e) {
  if (r instanceof _c)
    return r;
  this._importDER(r, e) || (WC(r.r && r.s, "Signature without r or s"), this.r = new $e(r.r, 16), this.s = new $e(r.s, 16), r.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = r.recoveryParam);
}
var Ec = _c;
function HC() {
  this.place = 0;
}
function vu(r, e) {
  var t = r[e.place++];
  if (!(t & 128))
    return t;
  var n = t & 15;
  if (n === 0 || n > 4)
    return !1;
  for (var i = 0, s = 0, a = e.place; s < n; s++, a++)
    i <<= 8, i |= r[a], i >>>= 0;
  return i <= 127 ? !1 : (e.place = a, i);
}
function h1(r) {
  for (var e = 0, t = r.length - 1; !r[e] && !(r[e + 1] & 128) && e < t; )
    e++;
  return e === 0 ? r : r.slice(e);
}
_c.prototype._importDER = function(e, t) {
  e = _n.toArray(e, t);
  var n = new HC();
  if (e[n.place++] !== 48)
    return !1;
  var i = vu(e, n);
  if (i === !1 || i + n.place !== e.length || e[n.place++] !== 2)
    return !1;
  var s = vu(e, n);
  if (s === !1)
    return !1;
  var a = e.slice(n.place, s + n.place);
  if (n.place += s, e[n.place++] !== 2)
    return !1;
  var o = vu(e, n);
  if (o === !1 || e.length !== o + n.place)
    return !1;
  var l = e.slice(n.place, o + n.place);
  if (a[0] === 0)
    if (a[1] & 128)
      a = a.slice(1);
    else
      return !1;
  if (l[0] === 0)
    if (l[1] & 128)
      l = l.slice(1);
    else
      return !1;
  return this.r = new $e(a), this.s = new $e(l), this.recoveryParam = null, !0;
};
function yu(r, e) {
  if (e < 128) {
    r.push(e);
    return;
  }
  var t = 1 + (Math.log(e) / Math.LN2 >>> 3);
  for (r.push(t | 128); --t; )
    r.push(e >>> (t << 3) & 255);
  r.push(e);
}
_c.prototype.toDER = function(e) {
  var t = this.r.toArray(), n = this.s.toArray();
  for (t[0] & 128 && (t = [0].concat(t)), n[0] & 128 && (n = [0].concat(n)), t = h1(t), n = h1(n); !n[0] && !(n[1] & 128); )
    n = n.slice(1);
  var i = [2];
  yu(i, t.length), i = i.concat(t), i.push(2), yu(i, n.length);
  var s = i.concat(n), a = [48];
  return yu(a, s.length), a = a.concat(s), _n.encode(a, e);
};
var VC = (
  /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }
), y2 = _n.assert;
function Rn(r) {
  if (!(this instanceof Rn))
    return new Rn(r);
  typeof r == "string" && (y2(
    Object.prototype.hasOwnProperty.call(Pl, r),
    "Unknown curve " + r
  ), r = Pl[r]), r instanceof Pl.PresetCurve && (r = { curve: r }), this.curve = r.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = r.curve.g, this.g.precompute(r.curve.n.bitLength() + 1), this.hash = r.hash || r.curve.hash;
}
var $C = Rn;
Rn.prototype.keyPair = function(e) {
  return new Of(this, e);
};
Rn.prototype.keyFromPrivate = function(e, t) {
  return Of.fromPrivate(this, e, t);
};
Rn.prototype.keyFromPublic = function(e, t) {
  return Of.fromPublic(this, e, t);
};
Rn.prototype.genKeyPair = function(e) {
  e || (e = {});
  for (var t = new v2({
    hash: this.hash,
    pers: e.pers,
    persEnc: e.persEnc || "utf8",
    entropy: e.entropy || VC(this.hash.hmacStrength),
    entropyEnc: e.entropy && e.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), n = this.n.byteLength(), i = this.n.sub(new $e(2)); ; ) {
    var s = new $e(t.generate(n));
    if (!(s.cmp(i) > 0))
      return s.iaddn(1), this.keyFromPrivate(s);
  }
};
Rn.prototype._truncateToN = function(e, t) {
  var n = e.byteLength() * 8 - this.n.bitLength();
  return n > 0 && (e = e.ushrn(n)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
};
Rn.prototype.sign = function(e, t, n, i) {
  typeof n == "object" && (i = n, n = null), i || (i = {}), t = this.keyFromPrivate(t, n), e = this._truncateToN(new $e(e, 16));
  for (var s = this.n.byteLength(), a = t.getPrivate().toArray("be", s), o = e.toArray("be", s), l = new v2({
    hash: this.hash,
    entropy: a,
    nonce: o,
    pers: i.pers,
    persEnc: i.persEnc || "utf8"
  }), c = this.n.sub(new $e(1)), u = 0; ; u++) {
    var f = i.k ? i.k(u) : new $e(l.generate(this.n.byteLength()));
    if (f = this._truncateToN(f, !0), !(f.cmpn(1) <= 0 || f.cmp(c) >= 0)) {
      var p = this.g.mul(f);
      if (!p.isInfinity()) {
        var x = p.getX(), T = x.umod(this.n);
        if (T.cmpn(0) !== 0) {
          var v = f.invm(this.n).mul(T.mul(t.getPrivate()).iadd(e));
          if (v = v.umod(this.n), v.cmpn(0) !== 0) {
            var w = (p.getY().isOdd() ? 1 : 0) | (x.cmp(T) !== 0 ? 2 : 0);
            return i.canonical && v.cmp(this.nh) > 0 && (v = this.n.sub(v), w ^= 1), new Ec({ r: T, s: v, recoveryParam: w });
          }
        }
      }
    }
  }
};
Rn.prototype.verify = function(e, t, n, i) {
  e = this._truncateToN(new $e(e, 16)), n = this.keyFromPublic(n, i), t = new Ec(t, "hex");
  var s = t.r, a = t.s;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0 || a.cmpn(1) < 0 || a.cmp(this.n) >= 0)
    return !1;
  var o = a.invm(this.n), l = o.mul(e).umod(this.n), c = o.mul(s).umod(this.n), u;
  return this.curve._maxwellTrick ? (u = this.g.jmulAdd(l, n.getPublic(), c), u.isInfinity() ? !1 : u.eqXToP(s)) : (u = this.g.mulAdd(l, n.getPublic(), c), u.isInfinity() ? !1 : u.getX().umod(this.n).cmp(s) === 0);
};
Rn.prototype.recoverPubKey = function(r, e, t, n) {
  y2((3 & t) === t, "The recovery param is more than two bits"), e = new Ec(e, n);
  var i = this.n, s = new $e(r), a = e.r, o = e.s, l = t & 1, c = t >> 1;
  if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && c)
    throw new Error("Unable to find sencond key candinate");
  c ? a = this.curve.pointFromX(a.add(this.curve.n), l) : a = this.curve.pointFromX(a, l);
  var u = e.r.invm(i), f = i.sub(s).mul(u).umod(i), p = o.mul(u).umod(i);
  return this.g.mulAdd(f, a, p);
};
Rn.prototype.getKeyRecoveryParam = function(r, e, t, n) {
  if (e = new Ec(e, n), e.recoveryParam !== null)
    return e.recoveryParam;
  for (var i = 0; i < 4; i++) {
    var s;
    try {
      s = this.recoverPubKey(r, e, i);
    } catch {
      continue;
    }
    if (s.eq(t))
      return i;
  }
  throw new Error("Unable to find valid recovery factor");
};
var GC = za(function(r, e) {
  var t = e;
  t.version = "6.5.4", t.utils = _n, t.rand = /*RicMoo:ethers:require(brorand)*/
  function() {
    throw new Error("unsupported");
  }, t.curve = Cl, t.curves = Pl, t.ec = $C, t.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/
  null;
}), KC = GC.ec;
const YC = "signing-key/5.7.0", Cd = new H(YC);
let wu = null;
function ui() {
  return wu || (wu = new KC("secp256k1")), wu;
}
class Ns {
  constructor(e) {
    ie(this, "curve", "secp256k1"), ie(this, "privateKey", we(e)), vi(this.privateKey) !== 32 && Cd.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
    const t = ui().keyFromPrivate(ve(this.privateKey));
    ie(this, "publicKey", "0x" + t.getPublic(!1, "hex")), ie(this, "compressedPublicKey", "0x" + t.getPublic(!0, "hex")), ie(this, "_isSigningKey", !0);
  }
  _addPoint(e) {
    const t = ui().keyFromPublic(ve(this.publicKey)), n = ui().keyFromPublic(ve(e));
    return "0x" + t.pub.add(n.pub).encodeCompressed("hex");
  }
  signDigest(e) {
    const t = ui().keyFromPrivate(ve(this.privateKey)), n = ve(e);
    n.length !== 32 && Cd.throwArgumentError("bad digest length", "digest", e);
    const i = t.sign(n, { canonical: !0 });
    return Vs({
      recoveryParam: i.recoveryParam,
      r: Dt("0x" + i.r.toString(16), 32),
      s: Dt("0x" + i.s.toString(16), 32)
    });
  }
  computeSharedSecret(e) {
    const t = ui().keyFromPrivate(ve(this.privateKey)), n = ui().keyFromPublic(ve(Nf(e)));
    return Dt("0x" + t.derive(n.getPublic()).toString(16), 32);
  }
  static isSigningKey(e) {
    return !!(e && e._isSigningKey);
  }
}
function w2(r, e) {
  const t = Vs(e), n = { r: ve(t.r), s: ve(t.s) };
  return "0x" + ui().recoverPubKey(ve(r), n, t.recoveryParam).encode("hex", !1);
}
function Nf(r, e) {
  const t = ve(r);
  if (t.length === 32) {
    const n = new Ns(t);
    return e ? "0x" + ui().keyFromPrivate(t).getPublic(!0, "hex") : n.publicKey;
  } else {
    if (t.length === 33)
      return e ? we(t) : "0x" + ui().keyFromPublic(t).getPublic(!1, "hex");
    if (t.length === 65)
      return e ? "0x" + ui().keyFromPublic(t).getPublic(!0, "hex") : we(t);
  }
  return Cd.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
const qC = "transactions/5.7.0", zr = new H(qC);
var Pd;
(function(r) {
  r[r.legacy = 0] = "legacy", r[r.eip2930 = 1] = "eip2930", r[r.eip1559 = 2] = "eip1559";
})(Pd || (Pd = {}));
function Rf(r) {
  return r === "0x" ? null : kt(r);
}
function Br(r) {
  return r === "0x" ? wf : be.from(r);
}
const ZC = [
  { name: "nonce", maxLength: 32, numeric: !0 },
  { name: "gasPrice", maxLength: 32, numeric: !0 },
  { name: "gasLimit", maxLength: 32, numeric: !0 },
  { name: "to", length: 20 },
  { name: "value", maxLength: 32, numeric: !0 },
  { name: "data" }
], JC = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  type: !0,
  value: !0
};
function ds(r) {
  const e = Nf(r);
  return kt(Qt(Nt(Qt(e, 1)), 12));
}
function $o(r, e) {
  return ds(w2(ve(r), e));
}
function gn(r, e) {
  const t = mi(be.from(r).toHexString());
  return t.length > 32 && zr.throwArgumentError("invalid length for " + e, "transaction:" + e, r), t;
}
function _u(r, e) {
  return {
    address: kt(r),
    storageKeys: (e || []).map((t, n) => (vi(t) !== 32 && zr.throwArgumentError("invalid access list storageKey", `accessList[${r}:${n}]`, t), t.toLowerCase()))
  };
}
function bs(r) {
  if (Array.isArray(r))
    return r.map((t, n) => Array.isArray(t) ? (t.length > 2 && zr.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${n}]`, t), _u(t[0], t[1])) : _u(t.address, t.storageKeys));
  const e = Object.keys(r).map((t) => {
    const n = r[t].reduce((i, s) => (i[s] = !0, i), {});
    return _u(t, Object.keys(n).sort());
  });
  return e.sort((t, n) => t.address.localeCompare(n.address)), e;
}
function _2(r) {
  return bs(r).map((e) => [e.address, e.storageKeys]);
}
function E2(r, e) {
  if (r.gasPrice != null) {
    const n = be.from(r.gasPrice), i = be.from(r.maxFeePerGas || 0);
    n.eq(i) || zr.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
      gasPrice: n,
      maxFeePerGas: i
    });
  }
  const t = [
    gn(r.chainId || 0, "chainId"),
    gn(r.nonce || 0, "nonce"),
    gn(r.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
    gn(r.maxFeePerGas || 0, "maxFeePerGas"),
    gn(r.gasLimit || 0, "gasLimit"),
    r.to != null ? kt(r.to) : "0x",
    gn(r.value || 0, "value"),
    r.data || "0x",
    _2(r.accessList || [])
  ];
  if (e) {
    const n = Vs(e);
    t.push(gn(n.recoveryParam, "recoveryParam")), t.push(mi(n.r)), t.push(mi(n.s));
  }
  return Kr(["0x02", Fs(t)]);
}
function A2(r, e) {
  const t = [
    gn(r.chainId || 0, "chainId"),
    gn(r.nonce || 0, "nonce"),
    gn(r.gasPrice || 0, "gasPrice"),
    gn(r.gasLimit || 0, "gasLimit"),
    r.to != null ? kt(r.to) : "0x",
    gn(r.value || 0, "value"),
    r.data || "0x",
    _2(r.accessList || [])
  ];
  if (e) {
    const n = Vs(e);
    t.push(gn(n.recoveryParam, "recoveryParam")), t.push(mi(n.r)), t.push(mi(n.s));
  }
  return Kr(["0x01", Fs(t)]);
}
function XC(r, e) {
  bf(r, JC);
  const t = [];
  ZC.forEach(function(a) {
    let o = r[a.name] || [];
    const l = {};
    a.numeric && (l.hexPad = "left"), o = ve(we(o, l)), a.length && o.length !== a.length && o.length > 0 && zr.throwArgumentError("invalid length for " + a.name, "transaction:" + a.name, o), a.maxLength && (o = mi(o), o.length > a.maxLength && zr.throwArgumentError("invalid length for " + a.name, "transaction:" + a.name, o)), t.push(we(o));
  });
  let n = 0;
  if (r.chainId != null ? (n = r.chainId, typeof n != "number" && zr.throwArgumentError("invalid transaction.chainId", "transaction", r)) : e && !Uo(e) && e.v > 28 && (n = Math.floor((e.v - 35) / 2)), n !== 0 && (t.push(we(n)), t.push("0x"), t.push("0x")), !e)
    return Fs(t);
  const i = Vs(e);
  let s = 27 + i.recoveryParam;
  return n !== 0 ? (t.pop(), t.pop(), t.pop(), s += n * 2 + 8, i.v > 28 && i.v !== s && zr.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", e)) : i.v !== s && zr.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", e), t.push(we(s)), t.push(mi(ve(i.r))), t.push(mi(ve(i.s))), Fs(t);
}
function kd(r, e) {
  if (r.type == null || r.type === 0)
    return r.accessList != null && zr.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", r), XC(r, e);
  switch (r.type) {
    case 1:
      return A2(r, e);
    case 2:
      return E2(r, e);
  }
  return zr.throwError(`unsupported transaction type: ${r.type}`, H.errors.UNSUPPORTED_OPERATION, {
    operation: "serializeTransaction",
    transactionType: r.type
  });
}
function S2(r, e, t) {
  try {
    const n = Br(e[0]).toNumber();
    if (n !== 0 && n !== 1)
      throw new Error("bad recid");
    r.v = n;
  } catch {
    zr.throwArgumentError("invalid v for transaction type: 1", "v", e[0]);
  }
  r.r = Dt(e[1], 32), r.s = Dt(e[2], 32);
  try {
    const n = Nt(t(r));
    r.from = $o(n, { r: r.r, s: r.s, recoveryParam: r.v });
  } catch {
  }
}
function QC(r) {
  const e = bc(r.slice(1));
  e.length !== 9 && e.length !== 12 && zr.throwArgumentError("invalid component count for transaction type: 2", "payload", we(r));
  const t = Br(e[2]), n = Br(e[3]), i = {
    type: 2,
    chainId: Br(e[0]).toNumber(),
    nonce: Br(e[1]).toNumber(),
    maxPriorityFeePerGas: t,
    maxFeePerGas: n,
    gasPrice: null,
    gasLimit: Br(e[4]),
    to: Rf(e[5]),
    value: Br(e[6]),
    data: e[7],
    accessList: bs(e[8])
  };
  return e.length === 9 || (i.hash = Nt(r), S2(i, e.slice(9), E2)), i;
}
function eP(r) {
  const e = bc(r.slice(1));
  e.length !== 8 && e.length !== 11 && zr.throwArgumentError("invalid component count for transaction type: 1", "payload", we(r));
  const t = {
    type: 1,
    chainId: Br(e[0]).toNumber(),
    nonce: Br(e[1]).toNumber(),
    gasPrice: Br(e[2]),
    gasLimit: Br(e[3]),
    to: Rf(e[4]),
    value: Br(e[5]),
    data: e[6],
    accessList: bs(e[7])
  };
  return e.length === 8 || (t.hash = Nt(r), S2(t, e.slice(8), A2)), t;
}
function tP(r) {
  const e = bc(r);
  e.length !== 9 && e.length !== 6 && zr.throwArgumentError("invalid raw transaction", "rawTransaction", r);
  const t = {
    nonce: Br(e[0]).toNumber(),
    gasPrice: Br(e[1]),
    gasLimit: Br(e[2]),
    to: Rf(e[3]),
    value: Br(e[4]),
    data: e[5],
    chainId: 0
  };
  if (e.length === 6)
    return t;
  try {
    t.v = be.from(e[6]).toNumber();
  } catch {
    return t;
  }
  if (t.r = Dt(e[7], 32), t.s = Dt(e[8], 32), be.from(t.r).isZero() && be.from(t.s).isZero())
    t.chainId = t.v, t.v = 0;
  else {
    t.chainId = Math.floor((t.v - 35) / 2), t.chainId < 0 && (t.chainId = 0);
    let n = t.v - 27;
    const i = e.slice(0, 6);
    t.chainId !== 0 && (i.push(we(t.chainId)), i.push("0x"), i.push("0x"), n -= t.chainId * 2 + 8);
    const s = Nt(Fs(i));
    try {
      t.from = $o(s, { r: we(t.r), s: we(t.s), recoveryParam: n });
    } catch {
    }
    t.hash = Nt(r);
  }
  return t.type = null, t;
}
function T2(r) {
  const e = ve(r);
  if (e[0] > 127)
    return tP(e);
  switch (e[0]) {
    case 1:
      return eP(e);
    case 2:
      return QC(e);
  }
  return zr.throwError(`unsupported transaction type: ${e[0]}`, H.errors.UNSUPPORTED_OPERATION, {
    operation: "parseTransaction",
    transactionType: e[0]
  });
}
const rP = "contracts/5.7.0";
var ps = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Ot = new H(rP), nP = {
  chainId: !0,
  data: !0,
  from: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0,
  customData: !0,
  ccipReadEnabled: !0
};
function Jl(r, e) {
  return ps(this, void 0, void 0, function* () {
    const t = yield e;
    typeof t != "string" && Ot.throwArgumentError("invalid address or ENS name", "name", t);
    try {
      return kt(t);
    } catch {
    }
    r || Ot.throwError("a provider or signer is needed to resolve ENS names", H.errors.UNSUPPORTED_OPERATION, {
      operation: "resolveName"
    });
    const n = yield r.resolveName(t);
    return n == null && Ot.throwArgumentError("resolver or addr is not configured for ENS name", "name", t), n;
  });
}
function bo(r, e, t) {
  return ps(this, void 0, void 0, function* () {
    return Array.isArray(t) ? yield Promise.all(t.map((n, i) => bo(r, Array.isArray(e) ? e[i] : e[n.name], n))) : t.type === "address" ? yield Jl(r, e) : t.type === "tuple" ? yield bo(r, e, t.components) : t.baseType === "array" ? Array.isArray(e) ? yield Promise.all(e.map((n) => bo(r, n, t.arrayChildren))) : Promise.reject(Ot.makeError("invalid value for array", H.errors.INVALID_ARGUMENT, {
      argument: "value",
      value: e
    })) : e;
  });
}
function Ac(r, e, t) {
  return ps(this, void 0, void 0, function* () {
    let n = {};
    t.length === e.inputs.length + 1 && typeof t[t.length - 1] == "object" && (n = Bt(t.pop())), Ot.checkArgumentCount(t.length, e.inputs.length, "passed to contract"), r.signer ? n.from ? n.from = qt({
      override: Jl(r.signer, n.from),
      signer: r.signer.getAddress()
    }).then((c) => ps(this, void 0, void 0, function* () {
      return kt(c.signer) !== c.override && Ot.throwError("Contract with a Signer cannot override from", H.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.from"
      }), c.override;
    })) : n.from = r.signer.getAddress() : n.from && (n.from = Jl(r.provider, n.from));
    const i = yield qt({
      args: bo(r.signer || r.provider, t, e.inputs),
      address: r.resolvedAddress,
      overrides: qt(n) || {}
    }), s = r.interface.encodeFunctionData(e, i.args), a = {
      data: s,
      to: i.address
    }, o = i.overrides;
    if (o.nonce != null && (a.nonce = be.from(o.nonce).toNumber()), o.gasLimit != null && (a.gasLimit = be.from(o.gasLimit)), o.gasPrice != null && (a.gasPrice = be.from(o.gasPrice)), o.maxFeePerGas != null && (a.maxFeePerGas = be.from(o.maxFeePerGas)), o.maxPriorityFeePerGas != null && (a.maxPriorityFeePerGas = be.from(o.maxPriorityFeePerGas)), o.from != null && (a.from = o.from), o.type != null && (a.type = o.type), o.accessList != null && (a.accessList = bs(o.accessList)), a.gasLimit == null && e.gas != null) {
      let c = 21e3;
      const u = ve(s);
      for (let f = 0; f < u.length; f++)
        c += 4, u[f] && (c += 64);
      a.gasLimit = be.from(e.gas).add(c);
    }
    if (o.value) {
      const c = be.from(o.value);
      !c.isZero() && !e.payable && Ot.throwError("non-payable method cannot override value", H.errors.UNSUPPORTED_OPERATION, {
        operation: "overrides.value",
        value: n.value
      }), a.value = c;
    }
    o.customData && (a.customData = Bt(o.customData)), o.ccipReadEnabled && (a.ccipReadEnabled = !!o.ccipReadEnabled), delete n.nonce, delete n.gasLimit, delete n.gasPrice, delete n.from, delete n.value, delete n.type, delete n.accessList, delete n.maxFeePerGas, delete n.maxPriorityFeePerGas, delete n.customData, delete n.ccipReadEnabled;
    const l = Object.keys(n).filter((c) => n[c] != null);
    return l.length && Ot.throwError(`cannot override ${l.map((c) => JSON.stringify(c)).join(",")}`, H.errors.UNSUPPORTED_OPERATION, {
      operation: "overrides",
      overrides: l
    }), a;
  });
}
function iP(r, e) {
  return function(...t) {
    return Ac(r, e, t);
  };
}
function sP(r, e) {
  const t = r.signer || r.provider;
  return function(...n) {
    return ps(this, void 0, void 0, function* () {
      t || Ot.throwError("estimate require a provider or signer", H.errors.UNSUPPORTED_OPERATION, {
        operation: "estimateGas"
      });
      const i = yield Ac(r, e, n);
      return yield t.estimateGas(i);
    });
  };
}
function M2(r, e) {
  const t = e.wait.bind(e);
  e.wait = (n) => t(n).then((i) => (i.events = i.logs.map((s) => {
    let a = Zr(s), o = null;
    try {
      o = r.interface.parseLog(s);
    } catch {
    }
    return o && (a.args = o.args, a.decode = (l, c) => r.interface.decodeEventLog(o.eventFragment, l, c), a.event = o.name, a.eventSignature = o.signature), a.removeListener = () => r.provider, a.getBlock = () => r.provider.getBlock(i.blockHash), a.getTransaction = () => r.provider.getTransaction(i.transactionHash), a.getTransactionReceipt = () => Promise.resolve(i), a;
  }), i));
}
function I2(r, e, t) {
  const n = r.signer || r.provider;
  return function(...i) {
    return ps(this, void 0, void 0, function* () {
      let s;
      if (i.length === e.inputs.length + 1 && typeof i[i.length - 1] == "object") {
        const l = Bt(i.pop());
        l.blockTag != null && (s = yield l.blockTag), delete l.blockTag, i.push(l);
      }
      r.deployTransaction != null && (yield r._deployed(s));
      const a = yield Ac(r, e, i), o = yield n.call(a, s);
      try {
        let l = r.interface.decodeFunctionResult(e, o);
        return t && e.outputs.length === 1 && (l = l[0]), l;
      } catch (l) {
        throw l.code === H.errors.CALL_EXCEPTION && (l.address = r.address, l.args = i, l.transaction = a), l;
      }
    });
  };
}
function aP(r, e) {
  return function(...t) {
    return ps(this, void 0, void 0, function* () {
      r.signer || Ot.throwError("sending a transaction requires a signer", H.errors.UNSUPPORTED_OPERATION, {
        operation: "sendTransaction"
      }), r.deployTransaction != null && (yield r._deployed());
      const n = yield Ac(r, e, t), i = yield r.signer.sendTransaction(n);
      return M2(r, i), i;
    });
  };
}
function p1(r, e, t) {
  return e.constant ? I2(r, e, t) : aP(r, e);
}
function C2(r) {
  return r.address && (r.topics == null || r.topics.length === 0) ? "*" : (r.address || "*") + "@" + (r.topics ? r.topics.map((e) => Array.isArray(e) ? e.join("|") : e).join(":") : "");
}
class Oo {
  constructor(e, t) {
    ie(this, "tag", e), ie(this, "filter", t), this._listeners = [];
  }
  addListener(e, t) {
    this._listeners.push({ listener: e, once: t });
  }
  removeListener(e) {
    let t = !1;
    this._listeners = this._listeners.filter((n) => t || n.listener !== e ? !0 : (t = !0, !1));
  }
  removeAllListeners() {
    this._listeners = [];
  }
  listeners() {
    return this._listeners.map((e) => e.listener);
  }
  listenerCount() {
    return this._listeners.length;
  }
  run(e) {
    const t = this.listenerCount();
    return this._listeners = this._listeners.filter((n) => {
      const i = e.slice();
      return setTimeout(() => {
        n.listener.apply(this, i);
      }, 0), !n.once;
    }), t;
  }
  prepareEvent(e) {
  }
  // Returns the array that will be applied to an emit
  getEmit(e) {
    return [e];
  }
}
class oP extends Oo {
  constructor() {
    super("error", null);
  }
}
class m1 extends Oo {
  constructor(e, t, n, i) {
    const s = {
      address: e
    };
    let a = t.getEventTopic(n);
    i ? (a !== i[0] && Ot.throwArgumentError("topic mismatch", "topics", i), s.topics = i.slice()) : s.topics = [a], super(C2(s), s), ie(this, "address", e), ie(this, "interface", t), ie(this, "fragment", n);
  }
  prepareEvent(e) {
    super.prepareEvent(e), e.event = this.fragment.name, e.eventSignature = this.fragment.format(), e.decode = (t, n) => this.interface.decodeEventLog(this.fragment, t, n);
    try {
      e.args = this.interface.decodeEventLog(this.fragment, e.data, e.topics);
    } catch (t) {
      e.args = null, e.decodeError = t;
    }
  }
  getEmit(e) {
    const t = _g(e.args);
    if (t.length)
      throw t[0].error;
    const n = (e.args || []).slice();
    return n.push(e), n;
  }
}
class g1 extends Oo {
  constructor(e, t) {
    super("*", { address: e }), ie(this, "address", e), ie(this, "interface", t);
  }
  prepareEvent(e) {
    super.prepareEvent(e);
    try {
      const t = this.interface.parseLog(e);
      e.event = t.name, e.eventSignature = t.signature, e.decode = (n, i) => this.interface.decodeEventLog(t.eventFragment, n, i), e.args = t.args;
    } catch {
    }
  }
}
class Lf {
  constructor(e, t, n) {
    ie(this, "interface", kr(new.target, "getInterface")(t)), n == null ? (ie(this, "provider", null), ie(this, "signer", null)) : Vi.isSigner(n) ? (ie(this, "provider", n.provider || null), ie(this, "signer", n)) : Ks.isProvider(n) ? (ie(this, "provider", n), ie(this, "signer", null)) : Ot.throwArgumentError("invalid signer or provider", "signerOrProvider", n), ie(this, "callStatic", {}), ie(this, "estimateGas", {}), ie(this, "functions", {}), ie(this, "populateTransaction", {}), ie(this, "filters", {});
    {
      const a = {};
      Object.keys(this.interface.events).forEach((o) => {
        const l = this.interface.events[o];
        ie(this.filters, o, (...c) => ({
          address: this.address,
          topics: this.interface.encodeFilterTopics(l, c)
        })), a[l.name] || (a[l.name] = []), a[l.name].push(o);
      }), Object.keys(a).forEach((o) => {
        const l = a[o];
        l.length === 1 ? ie(this.filters, o, this.filters[l[0]]) : Ot.warn(`Duplicate definition of ${o} (${l.join(", ")})`);
      });
    }
    if (ie(this, "_runningEvents", {}), ie(this, "_wrappedEmits", {}), e == null && Ot.throwArgumentError("invalid contract address or ENS name", "addressOrName", e), ie(this, "address", e), this.provider)
      ie(this, "resolvedAddress", Jl(this.provider, e));
    else
      try {
        ie(this, "resolvedAddress", Promise.resolve(kt(e)));
      } catch {
        Ot.throwError("provider is required to use ENS name as contract address", H.errors.UNSUPPORTED_OPERATION, {
          operation: "new Contract"
        });
      }
    this.resolvedAddress.catch((a) => {
    });
    const i = {}, s = {};
    Object.keys(this.interface.functions).forEach((a) => {
      const o = this.interface.functions[a];
      if (s[a]) {
        Ot.warn(`Duplicate ABI entry for ${JSON.stringify(a)}`);
        return;
      }
      s[a] = !0;
      {
        const l = o.name;
        i[`%${l}`] || (i[`%${l}`] = []), i[`%${l}`].push(a);
      }
      this[a] == null && ie(this, a, p1(this, o, !0)), this.functions[a] == null && ie(this.functions, a, p1(this, o, !1)), this.callStatic[a] == null && ie(this.callStatic, a, I2(this, o, !0)), this.populateTransaction[a] == null && ie(this.populateTransaction, a, iP(this, o)), this.estimateGas[a] == null && ie(this.estimateGas, a, sP(this, o));
    }), Object.keys(i).forEach((a) => {
      const o = i[a];
      if (o.length > 1)
        return;
      a = a.substring(1);
      const l = o[0];
      try {
        this[a] == null && ie(this, a, this[l]);
      } catch {
      }
      this.functions[a] == null && ie(this.functions, a, this.functions[l]), this.callStatic[a] == null && ie(this.callStatic, a, this.callStatic[l]), this.populateTransaction[a] == null && ie(this.populateTransaction, a, this.populateTransaction[l]), this.estimateGas[a] == null && ie(this.estimateGas, a, this.estimateGas[l]);
    });
  }
  static getContractAddress(e) {
    return vc(e);
  }
  static getInterface(e) {
    return Ad.isInterface(e) ? e : new Ad(e);
  }
  // @TODO: Allow timeout?
  deployed() {
    return this._deployed();
  }
  _deployed(e) {
    return this._deployedPromise || (this.deployTransaction ? this._deployedPromise = this.deployTransaction.wait().then(() => this) : this._deployedPromise = this.provider.getCode(this.address, e).then((t) => (t === "0x" && Ot.throwError("contract not deployed", H.errors.UNSUPPORTED_OPERATION, {
      contractAddress: this.address,
      operation: "getDeployed"
    }), this))), this._deployedPromise;
  }
  // @TODO:
  // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
  // @TODO:
  // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
  fallback(e) {
    this.signer || Ot.throwError("sending a transactions require a signer", H.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
    const t = Bt(e || {});
    return ["from", "to"].forEach(function(n) {
      t[n] != null && Ot.throwError("cannot override " + n, H.errors.UNSUPPORTED_OPERATION, { operation: n });
    }), t.to = this.resolvedAddress, this.deployed().then(() => this.signer.sendTransaction(t));
  }
  // Reconnect to a different signer or provider
  connect(e) {
    typeof e == "string" && (e = new Ho(e, this.provider));
    const t = new this.constructor(this.address, this.interface, e);
    return this.deployTransaction && ie(t, "deployTransaction", this.deployTransaction), t;
  }
  // Re-attach to a different on-chain instance of this contract
  attach(e) {
    return new this.constructor(e, this.interface, this.signer || this.provider);
  }
  static isIndexed(e) {
    return Yl.isIndexed(e);
  }
  _normalizeRunningEvent(e) {
    return this._runningEvents[e.tag] ? this._runningEvents[e.tag] : e;
  }
  _getRunningEvent(e) {
    if (typeof e == "string") {
      if (e === "error")
        return this._normalizeRunningEvent(new oP());
      if (e === "event")
        return this._normalizeRunningEvent(new Oo("event", null));
      if (e === "*")
        return this._normalizeRunningEvent(new g1(this.address, this.interface));
      const t = this.interface.getEvent(e);
      return this._normalizeRunningEvent(new m1(this.address, this.interface, t));
    }
    if (e.topics && e.topics.length > 0) {
      try {
        const n = e.topics[0];
        if (typeof n != "string")
          throw new Error("invalid topic");
        const i = this.interface.getEvent(n);
        return this._normalizeRunningEvent(new m1(this.address, this.interface, i, e.topics));
      } catch {
      }
      const t = {
        address: this.address,
        topics: e.topics
      };
      return this._normalizeRunningEvent(new Oo(C2(t), t));
    }
    return this._normalizeRunningEvent(new g1(this.address, this.interface));
  }
  _checkRunningEvents(e) {
    if (e.listenerCount() === 0) {
      delete this._runningEvents[e.tag];
      const t = this._wrappedEmits[e.tag];
      t && e.filter && (this.provider.off(e.filter, t), delete this._wrappedEmits[e.tag]);
    }
  }
  // Subclasses can override this to gracefully recover
  // from parse errors if they wish
  _wrapEvent(e, t, n) {
    const i = Zr(t);
    return i.removeListener = () => {
      n && (e.removeListener(n), this._checkRunningEvents(e));
    }, i.getBlock = () => this.provider.getBlock(t.blockHash), i.getTransaction = () => this.provider.getTransaction(t.transactionHash), i.getTransactionReceipt = () => this.provider.getTransactionReceipt(t.transactionHash), e.prepareEvent(i), i;
  }
  _addEventListener(e, t, n) {
    if (this.provider || Ot.throwError("events require a provider or a signer with a provider", H.errors.UNSUPPORTED_OPERATION, { operation: "once" }), e.addListener(t, n), this._runningEvents[e.tag] = e, !this._wrappedEmits[e.tag]) {
      const i = (s) => {
        let a = this._wrapEvent(e, s, t);
        if (a.decodeError == null)
          try {
            const o = e.getEmit(a);
            this.emit(e.filter, ...o);
          } catch (o) {
            a.decodeError = o.error;
          }
        e.filter != null && this.emit("event", a), a.decodeError != null && this.emit("error", a.decodeError, a);
      };
      this._wrappedEmits[e.tag] = i, e.filter != null && this.provider.on(e.filter, i);
    }
  }
  queryFilter(e, t, n) {
    const i = this._getRunningEvent(e), s = Bt(i.filter);
    return typeof t == "string" && Ye(t, 32) ? (n != null && Ot.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", n), s.blockHash = t) : (s.fromBlock = t ?? 0, s.toBlock = n ?? "latest"), this.provider.getLogs(s).then((a) => a.map((o) => this._wrapEvent(i, o, null)));
  }
  on(e, t) {
    return this._addEventListener(this._getRunningEvent(e), t, !1), this;
  }
  once(e, t) {
    return this._addEventListener(this._getRunningEvent(e), t, !0), this;
  }
  emit(e, ...t) {
    if (!this.provider)
      return !1;
    const n = this._getRunningEvent(e), i = n.run(t) > 0;
    return this._checkRunningEvents(n), i;
  }
  listenerCount(e) {
    return this.provider ? e == null ? Object.keys(this._runningEvents).reduce((t, n) => t + this._runningEvents[n].listenerCount(), 0) : this._getRunningEvent(e).listenerCount() : 0;
  }
  listeners(e) {
    if (!this.provider)
      return [];
    if (e == null) {
      const t = [];
      for (let n in this._runningEvents)
        this._runningEvents[n].listeners().forEach((i) => {
          t.push(i);
        });
      return t;
    }
    return this._getRunningEvent(e).listeners();
  }
  removeAllListeners(e) {
    if (!this.provider)
      return this;
    if (e == null) {
      for (const n in this._runningEvents) {
        const i = this._runningEvents[n];
        i.removeAllListeners(), this._checkRunningEvents(i);
      }
      return this;
    }
    const t = this._getRunningEvent(e);
    return t.removeAllListeners(), this._checkRunningEvents(t), this;
  }
  off(e, t) {
    if (!this.provider)
      return this;
    const n = this._getRunningEvent(e);
    return n.removeListener(t), this._checkRunningEvents(n), this;
  }
  removeListener(e, t) {
    return this.off(e, t);
  }
}
class Xl extends Lf {
}
class P2 {
  constructor(e, t, n) {
    let i = null;
    typeof t == "string" ? i = t : gs(t) ? i = we(t) : t && typeof t.object == "string" ? i = t.object : i = "!", i.substring(0, 2) !== "0x" && (i = "0x" + i), (!Ye(i) || i.length % 2) && Ot.throwArgumentError("invalid bytecode", "bytecode", t), n && !Vi.isSigner(n) && Ot.throwArgumentError("invalid signer", "signer", n), ie(this, "bytecode", i), ie(this, "interface", kr(new.target, "getInterface")(e)), ie(this, "signer", n || null);
  }
  // @TODO: Future; rename to populateTransaction?
  getDeployTransaction(...e) {
    let t = {};
    if (e.length === this.interface.deploy.inputs.length + 1 && typeof e[e.length - 1] == "object") {
      t = Bt(e.pop());
      for (const n in t)
        if (!nP[n])
          throw new Error("unknown transaction override " + n);
    }
    return ["data", "from", "to"].forEach((n) => {
      t[n] != null && Ot.throwError("cannot override " + n, H.errors.UNSUPPORTED_OPERATION, { operation: n });
    }), t.value && !be.from(t.value).isZero() && !this.interface.deploy.payable && Ot.throwError("non-payable constructor cannot override value", H.errors.UNSUPPORTED_OPERATION, {
      operation: "overrides.value",
      value: t.value
    }), Ot.checkArgumentCount(e.length, this.interface.deploy.inputs.length, " in Contract constructor"), t.data = we(Lt([
      this.bytecode,
      this.interface.encodeDeploy(e)
    ])), t;
  }
  deploy(...e) {
    return ps(this, void 0, void 0, function* () {
      let t = {};
      e.length === this.interface.deploy.inputs.length + 1 && (t = e.pop()), Ot.checkArgumentCount(e.length, this.interface.deploy.inputs.length, " in Contract constructor");
      const n = yield bo(this.signer, e, this.interface.deploy.inputs);
      n.push(t);
      const i = this.getDeployTransaction(...n), s = yield this.signer.sendTransaction(i), a = kr(this.constructor, "getContractAddress")(s), o = kr(this.constructor, "getContract")(a, this.interface, this.signer);
      return M2(o, s), ie(o, "deployTransaction", s), o;
    });
  }
  attach(e) {
    return this.constructor.getContract(e, this.interface, this.signer);
  }
  connect(e) {
    return new this.constructor(this.interface, this.bytecode, e);
  }
  static fromSolidity(e, t) {
    e == null && Ot.throwError("missing compiler output", H.errors.MISSING_ARGUMENT, { argument: "compilerOutput" }), typeof e == "string" && (e = JSON.parse(e));
    const n = e.abi;
    let i = null;
    return e.bytecode ? i = e.bytecode : e.evm && e.evm.bytecode && (i = e.evm.bytecode), new this(n, i, t);
  }
  static getInterface(e) {
    return Xl.getInterface(e);
  }
  static getContractAddress(e) {
    return vc(e);
  }
  static getContract(e, t, n) {
    return new Xl(e, t, n);
  }
}
class k2 {
  constructor(e) {
    ie(this, "alphabet", e), ie(this, "base", e.length), ie(this, "_alphabetMap", {}), ie(this, "_leader", e.charAt(0));
    for (let t = 0; t < e.length; t++)
      this._alphabetMap[e.charAt(t)] = t;
  }
  encode(e) {
    let t = ve(e);
    if (t.length === 0)
      return "";
    let n = [0];
    for (let s = 0; s < t.length; ++s) {
      let a = t[s];
      for (let o = 0; o < n.length; ++o)
        a += n[o] << 8, n[o] = a % this.base, a = a / this.base | 0;
      for (; a > 0; )
        n.push(a % this.base), a = a / this.base | 0;
    }
    let i = "";
    for (let s = 0; t[s] === 0 && s < t.length - 1; ++s)
      i += this._leader;
    for (let s = n.length - 1; s >= 0; --s)
      i += this.alphabet[n[s]];
    return i;
  }
  decode(e) {
    if (typeof e != "string")
      throw new TypeError("Expected String");
    let t = [];
    if (e.length === 0)
      return new Uint8Array(t);
    t.push(0);
    for (let n = 0; n < e.length; n++) {
      let i = this._alphabetMap[e[n]];
      if (i === void 0)
        throw new Error("Non-base" + this.base + " character");
      let s = i;
      for (let a = 0; a < t.length; ++a)
        s += t[a] * this.base, t[a] = s & 255, s >>= 8;
      for (; s > 0; )
        t.push(s & 255), s >>= 8;
    }
    for (let n = 0; e[n] === this._leader && n < e.length - 1; ++n)
      t.push(0);
    return ve(new Uint8Array(t.reverse()));
  }
}
new k2("abcdefghijklmnopqrstuvwxyz234567");
const Ra = new k2("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
var La;
(function(r) {
  r.sha256 = "sha256", r.sha512 = "sha512";
})(La || (La = {}));
const lP = "sha2/5.7.0", cP = new H(lP);
function O2(r) {
  return "0x" + rn.ripemd160().update(ve(r)).digest("hex");
}
function Ui(r) {
  return "0x" + rn.sha256().update(ve(r)).digest("hex");
}
function uP(r) {
  return "0x" + rn.sha512().update(ve(r)).digest("hex");
}
function No(r, e, t) {
  return La[r] || cP.throwError("unsupported algorithm " + r, H.errors.UNSUPPORTED_OPERATION, {
    operation: "hmac",
    algorithm: r
  }), "0x" + rn.hmac(rn[r], ve(e)).update(ve(t)).digest("hex");
}
function Df(r, e, t, n, i) {
  r = ve(r), e = ve(e);
  let s, a = 1;
  const o = new Uint8Array(n), l = new Uint8Array(e.length + 4);
  l.set(e);
  let c, u;
  for (let f = 1; f <= a; f++) {
    l[e.length] = f >> 24 & 255, l[e.length + 1] = f >> 16 & 255, l[e.length + 2] = f >> 8 & 255, l[e.length + 3] = f & 255;
    let p = ve(No(i, r, l));
    s || (s = p.length, u = new Uint8Array(s), a = Math.ceil(n / s), c = n - (a - 1) * s), u.set(p);
    for (let v = 1; v < t; v++) {
      p = ve(No(i, r, p));
      for (let w = 0; w < s; w++)
        u[w] ^= p[w];
    }
    const x = (f - 1) * s, T = f === a ? c : s;
    o.set(ve(u).slice(0, T), x);
  }
  return we(o);
}
const dP = "wordlists/5.7.0", fP = new H(dP);
class qs {
  constructor(e) {
    fP.checkAbstract(new.target, qs), ie(this, "locale", e);
  }
  // Subclasses may override this
  split(e) {
    return e.toLowerCase().split(/ +/g);
  }
  // Subclasses may override this
  join(e) {
    return e.join(" ");
  }
  static check(e) {
    const t = [];
    for (let n = 0; n < 2048; n++) {
      const i = e.getWord(n);
      if (n !== e.getWordIndex(i))
        return "0x";
      t.push(i);
    }
    return cs(t.join(`
`) + `
`);
  }
  static register(e, t) {
    t || (t = e.locale);
  }
}
const hP = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let vo = null;
function x1(r) {
  if (vo == null && (vo = hP.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" "), qs.check(r) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60"))
    throw vo = null, new Error("BIP39 Wordlist for en (English) FAILED");
}
class pP extends qs {
  constructor() {
    super("en");
  }
  getWord(e) {
    return x1(this), vo[e];
  }
  getWordIndex(e) {
    return x1(this), vo.indexOf(e);
  }
}
const N2 = new pP();
qs.register(N2);
const Ql = {
  en: N2
}, mP = "hdnode/5.7.0", Ro = new H(mP), gP = be.from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), xP = tr("Bitcoin seed"), da = 2147483648;
function R2(r) {
  return (1 << r) - 1 << 8 - r;
}
function bP(r) {
  return (1 << r) - 1;
}
function hl(r) {
  return Dt(we(r), 32);
}
function b1(r) {
  return Ra.encode(Lt([r, Qt(Ui(Ui(r)), 0, 4)]));
}
function Ff(r) {
  if (r == null)
    return Ql.en;
  if (typeof r == "string") {
    const e = Ql[r];
    return e == null && Ro.throwArgumentError("unknown locale", "wordlist", r), e;
  }
  return r;
}
const ia = {}, Da = "m/44'/60'/0'/0/0";
class xn {
  /**
   *  This constructor should not be called directly.
   *
   *  Please use:
   *   - fromMnemonic
   *   - fromSeed
   */
  constructor(e, t, n, i, s, a, o, l) {
    if (e !== ia)
      throw new Error("HDNode constructor cannot be called directly");
    if (t) {
      const c = new Ns(t);
      ie(this, "privateKey", c.privateKey), ie(this, "publicKey", c.compressedPublicKey);
    } else
      ie(this, "privateKey", null), ie(this, "publicKey", we(n));
    ie(this, "parentFingerprint", i), ie(this, "fingerprint", Qt(O2(Ui(this.publicKey)), 0, 4)), ie(this, "address", ds(this.publicKey)), ie(this, "chainCode", s), ie(this, "index", a), ie(this, "depth", o), l == null ? (ie(this, "mnemonic", null), ie(this, "path", null)) : typeof l == "string" ? (ie(this, "mnemonic", null), ie(this, "path", l)) : (ie(this, "mnemonic", l), ie(this, "path", l.path));
  }
  get extendedKey() {
    if (this.depth >= 256)
      throw new Error("Depth too large!");
    return b1(Lt([
      this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
      we(this.depth),
      this.parentFingerprint,
      Dt(we(this.index), 4),
      this.chainCode,
      this.privateKey != null ? Lt(["0x00", this.privateKey]) : this.publicKey
    ]));
  }
  neuter() {
    return new xn(ia, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
  }
  _derive(e) {
    if (e > 4294967295)
      throw new Error("invalid index - " + String(e));
    let t = this.path;
    t && (t += "/" + (e & ~da));
    const n = new Uint8Array(37);
    if (e & da) {
      if (!this.privateKey)
        throw new Error("cannot derive child of neutered node");
      n.set(ve(this.privateKey), 1), t && (t += "'");
    } else
      n.set(ve(this.publicKey));
    for (let f = 24; f >= 0; f -= 8)
      n[33 + (f >> 3)] = e >> 24 - f & 255;
    const i = ve(No(La.sha512, this.chainCode, n)), s = i.slice(0, 32), a = i.slice(32);
    let o = null, l = null;
    this.privateKey ? o = hl(be.from(s).add(this.privateKey).mod(gP)) : l = new Ns(we(s))._addPoint(this.publicKey);
    let c = t;
    const u = this.mnemonic;
    return u && (c = Object.freeze({
      phrase: u.phrase,
      path: t,
      locale: u.locale || "en"
    })), new xn(ia, o, l, this.fingerprint, hl(a), e, this.depth + 1, c);
  }
  derivePath(e) {
    const t = e.split("/");
    if (t.length === 0 || t[0] === "m" && this.depth !== 0)
      throw new Error("invalid path - " + e);
    t[0] === "m" && t.shift();
    let n = this;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (s.match(/^[0-9]+'$/)) {
        const a = parseInt(s.substring(0, s.length - 1));
        if (a >= da)
          throw new Error("invalid path index - " + s);
        n = n._derive(da + a);
      } else if (s.match(/^[0-9]+$/)) {
        const a = parseInt(s);
        if (a >= da)
          throw new Error("invalid path index - " + s);
        n = n._derive(a);
      } else
        throw new Error("invalid path component - " + s);
    }
    return n;
  }
  static _fromSeed(e, t) {
    const n = ve(e);
    if (n.length < 16 || n.length > 64)
      throw new Error("invalid seed");
    const i = ve(No(La.sha512, xP, n));
    return new xn(ia, hl(i.slice(0, 32)), null, "0x00000000", hl(i.slice(32)), 0, 0, t);
  }
  static fromMnemonic(e, t, n) {
    return n = Ff(n), e = Tc(Sc(e, n), n), xn._fromSeed(L2(e, t), {
      phrase: e,
      path: "m",
      locale: n.locale
    });
  }
  static fromSeed(e) {
    return xn._fromSeed(e, null);
  }
  static fromExtendedKey(e) {
    const t = Ra.decode(e);
    (t.length !== 82 || b1(t.slice(0, 78)) !== e) && Ro.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    const n = t[4], i = we(t.slice(5, 9)), s = parseInt(we(t.slice(9, 13)).substring(2), 16), a = we(t.slice(13, 45)), o = t.slice(45, 78);
    switch (we(t.slice(0, 4))) {
      case "0x0488b21e":
      case "0x043587cf":
        return new xn(ia, null, we(o), i, a, s, n, null);
      case "0x0488ade4":
      case "0x04358394 ":
        if (o[0] !== 0)
          break;
        return new xn(ia, we(o.slice(1)), null, i, a, s, n, null);
    }
    return Ro.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
  }
}
function L2(r, e) {
  e || (e = "");
  const t = tr("mnemonic" + e, yi.NFKD);
  return Df(tr(r, yi.NFKD), t, 2048, 64, "sha512");
}
function Sc(r, e) {
  e = Ff(e), Ro.checkNormalize();
  const t = e.split(r);
  if (t.length % 3 !== 0)
    throw new Error("invalid mnemonic");
  const n = ve(new Uint8Array(Math.ceil(11 * t.length / 8)));
  let i = 0;
  for (let c = 0; c < t.length; c++) {
    let u = e.getWordIndex(t[c].normalize("NFKD"));
    if (u === -1)
      throw new Error("invalid mnemonic");
    for (let f = 0; f < 11; f++)
      u & 1 << 10 - f && (n[i >> 3] |= 1 << 7 - i % 8), i++;
  }
  const s = 32 * t.length / 3, a = t.length / 3, o = R2(a);
  if ((ve(Ui(n.slice(0, s / 8)))[0] & o) !== (n[n.length - 1] & o))
    throw new Error("invalid checksum");
  return we(n.slice(0, s / 8));
}
function Tc(r, e) {
  if (e = Ff(e), r = ve(r), r.length % 4 !== 0 || r.length < 16 || r.length > 32)
    throw new Error("invalid entropy");
  const t = [0];
  let n = 11;
  for (let a = 0; a < r.length; a++)
    n > 8 ? (t[t.length - 1] <<= 8, t[t.length - 1] |= r[a], n -= 8) : (t[t.length - 1] <<= n, t[t.length - 1] |= r[a] >> 8 - n, t.push(r[a] & bP(8 - n)), n += 3);
  const i = r.length / 4, s = ve(Ui(r))[0] & R2(i);
  return t[t.length - 1] <<= i, t[t.length - 1] |= s >> 8 - i, e.join(t.map((a) => e.getWord(a)));
}
function vP(r, e) {
  try {
    return Sc(r, e), !0;
  } catch {
  }
  return !1;
}
function yP(r) {
  return (typeof r != "number" || r < 0 || r >= da || r % 1) && Ro.throwArgumentError("invalid account index", "index", r), `m/44'/60'/${r}'/0/0`;
}
const wP = "random/5.7.0", Od = new H(wP);
function _P() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}
const v1 = _P();
let kl = v1.crypto || v1.msCrypto;
(!kl || !kl.getRandomValues) && (Od.warn("WARNING: Missing strong random number source"), kl = {
  getRandomValues: function(r) {
    return Od.throwError("no secure random source avaialble", H.errors.UNSUPPORTED_OPERATION, {
      operation: "crypto.getRandomValues"
    });
  }
});
function ga(r) {
  (r <= 0 || r > 1024 || r % 1 || r != r) && Od.throwArgumentError("invalid length", "length", r);
  const e = new Uint8Array(r);
  return kl.getRandomValues(e), ve(e);
}
function D2(r) {
  r = r.slice();
  for (let e = r.length - 1; e > 0; e--) {
    const t = Math.floor(Math.random() * (e + 1)), n = r[e];
    r[e] = r[t], r[t] = n;
  }
  return r;
}
var F2 = { exports: {} };
(function(r, e) {
  (function(t) {
    function n(y) {
      return parseInt(y) === y;
    }
    function i(y) {
      if (!n(y.length))
        return !1;
      for (var h = 0; h < y.length; h++)
        if (!n(y[h]) || y[h] < 0 || y[h] > 255)
          return !1;
      return !0;
    }
    function s(y, h) {
      if (y.buffer && ArrayBuffer.isView(y) && y.name === "Uint8Array")
        return h && (y.slice ? y = y.slice() : y = Array.prototype.slice.call(y)), y;
      if (Array.isArray(y)) {
        if (!i(y))
          throw new Error("Array contains invalid value: " + y);
        return new Uint8Array(y);
      }
      if (n(y.length) && i(y))
        return new Uint8Array(y);
      throw new Error("unsupported array-like object");
    }
    function a(y) {
      return new Uint8Array(y);
    }
    function o(y, h, I, V, g) {
      (V != null || g != null) && (y.slice ? y = y.slice(V, g) : y = Array.prototype.slice.call(y, V, g)), h.set(y, I);
    }
    var l = function() {
      function y(I) {
        var V = [], g = 0;
        for (I = encodeURI(I); g < I.length; ) {
          var G = I.charCodeAt(g++);
          G === 37 ? (V.push(parseInt(I.substr(g, 2), 16)), g += 2) : V.push(G);
        }
        return s(V);
      }
      function h(I) {
        for (var V = [], g = 0; g < I.length; ) {
          var G = I[g];
          G < 128 ? (V.push(String.fromCharCode(G)), g++) : G > 191 && G < 224 ? (V.push(String.fromCharCode((G & 31) << 6 | I[g + 1] & 63)), g += 2) : (V.push(String.fromCharCode((G & 15) << 12 | (I[g + 1] & 63) << 6 | I[g + 2] & 63)), g += 3);
        }
        return V.join("");
      }
      return {
        toBytes: y,
        fromBytes: h
      };
    }(), c = function() {
      function y(V) {
        for (var g = [], G = 0; G < V.length; G += 2)
          g.push(parseInt(V.substr(G, 2), 16));
        return g;
      }
      var h = "0123456789abcdef";
      function I(V) {
        for (var g = [], G = 0; G < V.length; G++) {
          var Q = V[G];
          g.push(h[(Q & 240) >> 4] + h[Q & 15]);
        }
        return g.join("");
      }
      return {
        toBytes: y,
        fromBytes: I
      };
    }(), u = { 16: 10, 24: 12, 32: 14 }, f = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145], p = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22], x = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125], T = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986], v = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766], w = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126], E = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436], C = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890], P = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935], F = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600], k = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480], K = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795], Z = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855], ne = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150], le = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];
    function ye(y) {
      for (var h = [], I = 0; I < y.length; I += 4)
        h.push(
          y[I] << 24 | y[I + 1] << 16 | y[I + 2] << 8 | y[I + 3]
        );
      return h;
    }
    var ge = function(y) {
      if (!(this instanceof ge))
        throw Error("AES must be instanitated with `new`");
      Object.defineProperty(this, "key", {
        value: s(y, !0)
      }), this._prepare();
    };
    ge.prototype._prepare = function() {
      var y = u[this.key.length];
      if (y == null)
        throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
      this._Ke = [], this._Kd = [];
      for (var h = 0; h <= y; h++)
        this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
      for (var I = (y + 1) * 4, V = this.key.length / 4, g = ye(this.key), G, h = 0; h < V; h++)
        G = h >> 2, this._Ke[G][h % 4] = g[h], this._Kd[y - G][h % 4] = g[h];
      for (var Q = 0, J = V, X; J < I; ) {
        if (X = g[V - 1], g[0] ^= p[X >> 16 & 255] << 24 ^ p[X >> 8 & 255] << 16 ^ p[X & 255] << 8 ^ p[X >> 24 & 255] ^ f[Q] << 24, Q += 1, V != 8)
          for (var h = 1; h < V; h++)
            g[h] ^= g[h - 1];
        else {
          for (var h = 1; h < V / 2; h++)
            g[h] ^= g[h - 1];
          X = g[V / 2 - 1], g[V / 2] ^= p[X & 255] ^ p[X >> 8 & 255] << 8 ^ p[X >> 16 & 255] << 16 ^ p[X >> 24 & 255] << 24;
          for (var h = V / 2 + 1; h < V; h++)
            g[h] ^= g[h - 1];
        }
        for (var h = 0, pe, ce; h < V && J < I; )
          pe = J >> 2, ce = J % 4, this._Ke[pe][ce] = g[h], this._Kd[y - pe][ce] = g[h++], J++;
      }
      for (var pe = 1; pe < y; pe++)
        for (var ce = 0; ce < 4; ce++)
          X = this._Kd[pe][ce], this._Kd[pe][ce] = K[X >> 24 & 255] ^ Z[X >> 16 & 255] ^ ne[X >> 8 & 255] ^ le[X & 255];
    }, ge.prototype.encrypt = function(y) {
      if (y.length != 16)
        throw new Error("invalid plaintext size (must be 16 bytes)");
      for (var h = this._Ke.length - 1, I = [0, 0, 0, 0], V = ye(y), g = 0; g < 4; g++)
        V[g] ^= this._Ke[0][g];
      for (var G = 1; G < h; G++) {
        for (var g = 0; g < 4; g++)
          I[g] = T[V[g] >> 24 & 255] ^ v[V[(g + 1) % 4] >> 16 & 255] ^ w[V[(g + 2) % 4] >> 8 & 255] ^ E[V[(g + 3) % 4] & 255] ^ this._Ke[G][g];
        V = I.slice();
      }
      for (var Q = a(16), J, g = 0; g < 4; g++)
        J = this._Ke[h][g], Q[4 * g] = (p[V[g] >> 24 & 255] ^ J >> 24) & 255, Q[4 * g + 1] = (p[V[(g + 1) % 4] >> 16 & 255] ^ J >> 16) & 255, Q[4 * g + 2] = (p[V[(g + 2) % 4] >> 8 & 255] ^ J >> 8) & 255, Q[4 * g + 3] = (p[V[(g + 3) % 4] & 255] ^ J) & 255;
      return Q;
    }, ge.prototype.decrypt = function(y) {
      if (y.length != 16)
        throw new Error("invalid ciphertext size (must be 16 bytes)");
      for (var h = this._Kd.length - 1, I = [0, 0, 0, 0], V = ye(y), g = 0; g < 4; g++)
        V[g] ^= this._Kd[0][g];
      for (var G = 1; G < h; G++) {
        for (var g = 0; g < 4; g++)
          I[g] = C[V[g] >> 24 & 255] ^ P[V[(g + 3) % 4] >> 16 & 255] ^ F[V[(g + 2) % 4] >> 8 & 255] ^ k[V[(g + 1) % 4] & 255] ^ this._Kd[G][g];
        V = I.slice();
      }
      for (var Q = a(16), J, g = 0; g < 4; g++)
        J = this._Kd[h][g], Q[4 * g] = (x[V[g] >> 24 & 255] ^ J >> 24) & 255, Q[4 * g + 1] = (x[V[(g + 3) % 4] >> 16 & 255] ^ J >> 16) & 255, Q[4 * g + 2] = (x[V[(g + 2) % 4] >> 8 & 255] ^ J >> 8) & 255, Q[4 * g + 3] = (x[V[(g + 1) % 4] & 255] ^ J) & 255;
      return Q;
    };
    var _e = function(y) {
      if (!(this instanceof _e))
        throw Error("AES must be instanitated with `new`");
      this.description = "Electronic Code Block", this.name = "ecb", this._aes = new ge(y);
    };
    _e.prototype.encrypt = function(y) {
      if (y = s(y), y.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var h = a(y.length), I = a(16), V = 0; V < y.length; V += 16)
        o(y, I, 0, V, V + 16), I = this._aes.encrypt(I), o(I, h, V);
      return h;
    }, _e.prototype.decrypt = function(y) {
      if (y = s(y), y.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var h = a(y.length), I = a(16), V = 0; V < y.length; V += 16)
        o(y, I, 0, V, V + 16), I = this._aes.decrypt(I), o(I, h, V);
      return h;
    };
    var L = function(y, h) {
      if (!(this instanceof L))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Block Chaining", this.name = "cbc", !h)
        h = a(16);
      else if (h.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastCipherblock = s(h, !0), this._aes = new ge(y);
    };
    L.prototype.encrypt = function(y) {
      if (y = s(y), y.length % 16 !== 0)
        throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
      for (var h = a(y.length), I = a(16), V = 0; V < y.length; V += 16) {
        o(y, I, 0, V, V + 16);
        for (var g = 0; g < 16; g++)
          I[g] ^= this._lastCipherblock[g];
        this._lastCipherblock = this._aes.encrypt(I), o(this._lastCipherblock, h, V);
      }
      return h;
    }, L.prototype.decrypt = function(y) {
      if (y = s(y), y.length % 16 !== 0)
        throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
      for (var h = a(y.length), I = a(16), V = 0; V < y.length; V += 16) {
        o(y, I, 0, V, V + 16), I = this._aes.decrypt(I);
        for (var g = 0; g < 16; g++)
          h[V + g] = I[g] ^ this._lastCipherblock[g];
        o(y, this._lastCipherblock, 0, V, V + 16);
      }
      return h;
    };
    var d = function(y, h, I) {
      if (!(this instanceof d))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Cipher Feedback", this.name = "cfb", !h)
        h = a(16);
      else if (h.length != 16)
        throw new Error("invalid initialation vector size (must be 16 size)");
      I || (I = 1), this.segmentSize = I, this._shiftRegister = s(h, !0), this._aes = new ge(y);
    };
    d.prototype.encrypt = function(y) {
      if (y.length % this.segmentSize != 0)
        throw new Error("invalid plaintext size (must be segmentSize bytes)");
      for (var h = s(y, !0), I, V = 0; V < h.length; V += this.segmentSize) {
        I = this._aes.encrypt(this._shiftRegister);
        for (var g = 0; g < this.segmentSize; g++)
          h[V + g] ^= I[g];
        o(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), o(h, this._shiftRegister, 16 - this.segmentSize, V, V + this.segmentSize);
      }
      return h;
    }, d.prototype.decrypt = function(y) {
      if (y.length % this.segmentSize != 0)
        throw new Error("invalid ciphertext size (must be segmentSize bytes)");
      for (var h = s(y, !0), I, V = 0; V < h.length; V += this.segmentSize) {
        I = this._aes.encrypt(this._shiftRegister);
        for (var g = 0; g < this.segmentSize; g++)
          h[V + g] ^= I[g];
        o(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), o(y, this._shiftRegister, 16 - this.segmentSize, V, V + this.segmentSize);
      }
      return h;
    };
    var b = function(y, h) {
      if (!(this instanceof b))
        throw Error("AES must be instanitated with `new`");
      if (this.description = "Output Feedback", this.name = "ofb", !h)
        h = a(16);
      else if (h.length != 16)
        throw new Error("invalid initialation vector size (must be 16 bytes)");
      this._lastPrecipher = s(h, !0), this._lastPrecipherIndex = 16, this._aes = new ge(y);
    };
    b.prototype.encrypt = function(y) {
      for (var h = s(y, !0), I = 0; I < h.length; I++)
        this._lastPrecipherIndex === 16 && (this._lastPrecipher = this._aes.encrypt(this._lastPrecipher), this._lastPrecipherIndex = 0), h[I] ^= this._lastPrecipher[this._lastPrecipherIndex++];
      return h;
    }, b.prototype.decrypt = b.prototype.encrypt;
    var S = function(y) {
      if (!(this instanceof S))
        throw Error("Counter must be instanitated with `new`");
      y !== 0 && !y && (y = 1), typeof y == "number" ? (this._counter = a(16), this.setValue(y)) : this.setBytes(y);
    };
    S.prototype.setValue = function(y) {
      if (typeof y != "number" || parseInt(y) != y)
        throw new Error("invalid counter value (must be an integer)");
      for (var h = 15; h >= 0; --h)
        this._counter[h] = y % 256, y = y >> 8;
    }, S.prototype.setBytes = function(y) {
      if (y = s(y, !0), y.length != 16)
        throw new Error("invalid counter bytes size (must be 16 bytes)");
      this._counter = y;
    }, S.prototype.increment = function() {
      for (var y = 15; y >= 0; y--)
        if (this._counter[y] === 255)
          this._counter[y] = 0;
        else {
          this._counter[y]++;
          break;
        }
    };
    var R = function(y, h) {
      if (!(this instanceof R))
        throw Error("AES must be instanitated with `new`");
      this.description = "Counter", this.name = "ctr", h instanceof S || (h = new S(h)), this._counter = h, this._remainingCounter = null, this._remainingCounterIndex = 16, this._aes = new ge(y);
    };
    R.prototype.encrypt = function(y) {
      for (var h = s(y, !0), I = 0; I < h.length; I++)
        this._remainingCounterIndex === 16 && (this._remainingCounter = this._aes.encrypt(this._counter._counter), this._remainingCounterIndex = 0, this._counter.increment()), h[I] ^= this._remainingCounter[this._remainingCounterIndex++];
      return h;
    }, R.prototype.decrypt = R.prototype.encrypt;
    function D(y) {
      y = s(y, !0);
      var h = 16 - y.length % 16, I = a(y.length + h);
      o(y, I);
      for (var V = y.length; V < I.length; V++)
        I[V] = h;
      return I;
    }
    function z(y) {
      if (y = s(y, !0), y.length < 16)
        throw new Error("PKCS#7 invalid length");
      var h = y[y.length - 1];
      if (h > 16)
        throw new Error("PKCS#7 padding byte out of range");
      for (var I = y.length - h, V = 0; V < h; V++)
        if (y[I + V] !== h)
          throw new Error("PKCS#7 invalid padding byte");
      var g = a(I);
      return o(y, g, 0, 0, I), g;
    }
    var q = {
      AES: ge,
      Counter: S,
      ModeOfOperation: {
        ecb: _e,
        cbc: L,
        cfb: d,
        ofb: b,
        ctr: R
      },
      utils: {
        hex: c,
        utf8: l
      },
      padding: {
        pkcs7: {
          pad: D,
          strip: z
        }
      },
      _arrayTest: {
        coerceArray: s,
        createArray: a,
        copyArray: o
      }
    };
    r.exports = q;
  })();
})(F2);
var EP = F2.exports;
const hi = /* @__PURE__ */ zi(EP), B2 = "json-wallets/5.7.0";
function Rs(r) {
  return typeof r == "string" && r.substring(0, 2) !== "0x" && (r = "0x" + r), ve(r);
}
function Ja(r, e) {
  for (r = String(r); r.length < e; )
    r = "0" + r;
  return r;
}
function Bf(r) {
  return typeof r == "string" ? tr(r, yi.NFKC) : ve(r);
}
function Xt(r, e) {
  let t = r;
  const n = e.toLowerCase().split("/");
  for (let i = 0; i < n.length; i++) {
    let s = null;
    for (const a in t)
      if (a.toLowerCase() === n[i]) {
        s = t[a];
        break;
      }
    if (s === null)
      return null;
    t = s;
  }
  return t;
}
function AP(r) {
  const e = ve(r);
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const t = we(e);
  return [
    t.substring(2, 10),
    t.substring(10, 14),
    t.substring(14, 18),
    t.substring(18, 22),
    t.substring(22, 34)
  ].join("-");
}
const SP = new H(B2);
class TP extends $s {
  isCrowdsaleAccount(e) {
    return !!(e && e._isCrowdsaleAccount);
  }
}
function j2(r, e) {
  const t = JSON.parse(r);
  e = Bf(e);
  const n = kt(Xt(t, "ethaddr")), i = Rs(Xt(t, "encseed"));
  (!i || i.length % 16 !== 0) && SP.throwArgumentError("invalid encseed", "json", r);
  const s = ve(Df(e, e, 2e3, 32, "sha256")).slice(0, 16), a = i.slice(0, 16), o = i.slice(16), l = new hi.ModeOfOperation.cbc(s, a), c = hi.padding.pkcs7.strip(ve(l.decrypt(o)));
  let u = "";
  for (let x = 0; x < c.length; x++)
    u += String.fromCharCode(c[x]);
  const f = tr(u), p = Nt(f);
  return new TP({
    _isCrowdsaleAccount: !0,
    address: n,
    privateKey: p
  });
}
function jf(r) {
  let e = null;
  try {
    e = JSON.parse(r);
  } catch {
    return !1;
  }
  return e.encseed && e.ethaddr;
}
function Uf(r) {
  let e = null;
  try {
    e = JSON.parse(r);
  } catch {
    return !1;
  }
  return !(!e.version || parseInt(e.version) !== e.version || parseInt(e.version) !== 3);
}
function MP(r) {
  if (jf(r))
    try {
      return kt(JSON.parse(r).ethaddr);
    } catch {
      return null;
    }
  if (Uf(r))
    try {
      return kt(JSON.parse(r).address);
    } catch {
      return null;
    }
  return null;
}
var U2 = { exports: {} };
(function(r, e) {
  (function(t) {
    function i(v) {
      const w = new Uint32Array([
        1116352408,
        1899447441,
        3049323471,
        3921009573,
        961987163,
        1508970993,
        2453635748,
        2870763221,
        3624381080,
        310598401,
        607225278,
        1426881987,
        1925078388,
        2162078206,
        2614888103,
        3248222580,
        3835390401,
        4022224774,
        264347078,
        604807628,
        770255983,
        1249150122,
        1555081692,
        1996064986,
        2554220882,
        2821834349,
        2952996808,
        3210313671,
        3336571891,
        3584528711,
        113926993,
        338241895,
        666307205,
        773529912,
        1294757372,
        1396182291,
        1695183700,
        1986661051,
        2177026350,
        2456956037,
        2730485921,
        2820302411,
        3259730800,
        3345764771,
        3516065817,
        3600352804,
        4094571909,
        275423344,
        430227734,
        506948616,
        659060556,
        883997877,
        958139571,
        1322822218,
        1537002063,
        1747873779,
        1955562222,
        2024104815,
        2227730452,
        2361852424,
        2428436474,
        2756734187,
        3204031479,
        3329325298
      ]);
      let E = 1779033703, C = 3144134277, P = 1013904242, F = 2773480762, k = 1359893119, K = 2600822924, Z = 528734635, ne = 1541459225;
      const le = new Uint32Array(64);
      function ye(R) {
        let D = 0, z = R.length;
        for (; z >= 64; ) {
          let q = E, y = C, h = P, I = F, V = k, g = K, G = Z, Q = ne, J, X, pe, ce, ue;
          for (X = 0; X < 16; X++)
            pe = D + X * 4, le[X] = (R[pe] & 255) << 24 | (R[pe + 1] & 255) << 16 | (R[pe + 2] & 255) << 8 | R[pe + 3] & 255;
          for (X = 16; X < 64; X++)
            J = le[X - 2], ce = (J >>> 17 | J << 32 - 17) ^ (J >>> 19 | J << 32 - 19) ^ J >>> 10, J = le[X - 15], ue = (J >>> 7 | J << 32 - 7) ^ (J >>> 18 | J << 32 - 18) ^ J >>> 3, le[X] = (ce + le[X - 7] | 0) + (ue + le[X - 16] | 0) | 0;
          for (X = 0; X < 64; X++)
            ce = (((V >>> 6 | V << 32 - 6) ^ (V >>> 11 | V << 32 - 11) ^ (V >>> 25 | V << 32 - 25)) + (V & g ^ ~V & G) | 0) + (Q + (w[X] + le[X] | 0) | 0) | 0, ue = ((q >>> 2 | q << 32 - 2) ^ (q >>> 13 | q << 32 - 13) ^ (q >>> 22 | q << 32 - 22)) + (q & y ^ q & h ^ y & h) | 0, Q = G, G = g, g = V, V = I + ce | 0, I = h, h = y, y = q, q = ce + ue | 0;
          E = E + q | 0, C = C + y | 0, P = P + h | 0, F = F + I | 0, k = k + V | 0, K = K + g | 0, Z = Z + G | 0, ne = ne + Q | 0, D += 64, z -= 64;
        }
      }
      ye(v);
      let ge, _e = v.length % 64, L = v.length / 536870912 | 0, d = v.length << 3, b = _e < 56 ? 56 : 120, S = v.slice(v.length - _e, v.length);
      for (S.push(128), ge = _e + 1; ge < b; ge++)
        S.push(0);
      return S.push(L >>> 24 & 255), S.push(L >>> 16 & 255), S.push(L >>> 8 & 255), S.push(L >>> 0 & 255), S.push(d >>> 24 & 255), S.push(d >>> 16 & 255), S.push(d >>> 8 & 255), S.push(d >>> 0 & 255), ye(S), [
        E >>> 24 & 255,
        E >>> 16 & 255,
        E >>> 8 & 255,
        E >>> 0 & 255,
        C >>> 24 & 255,
        C >>> 16 & 255,
        C >>> 8 & 255,
        C >>> 0 & 255,
        P >>> 24 & 255,
        P >>> 16 & 255,
        P >>> 8 & 255,
        P >>> 0 & 255,
        F >>> 24 & 255,
        F >>> 16 & 255,
        F >>> 8 & 255,
        F >>> 0 & 255,
        k >>> 24 & 255,
        k >>> 16 & 255,
        k >>> 8 & 255,
        k >>> 0 & 255,
        K >>> 24 & 255,
        K >>> 16 & 255,
        K >>> 8 & 255,
        K >>> 0 & 255,
        Z >>> 24 & 255,
        Z >>> 16 & 255,
        Z >>> 8 & 255,
        Z >>> 0 & 255,
        ne >>> 24 & 255,
        ne >>> 16 & 255,
        ne >>> 8 & 255,
        ne >>> 0 & 255
      ];
    }
    function s(v, w, E) {
      v = v.length <= 64 ? v : i(v);
      const C = 64 + w.length + 4, P = new Array(C), F = new Array(64);
      let k, K = [];
      for (k = 0; k < 64; k++)
        P[k] = 54;
      for (k = 0; k < v.length; k++)
        P[k] ^= v[k];
      for (k = 0; k < w.length; k++)
        P[64 + k] = w[k];
      for (k = C - 4; k < C; k++)
        P[k] = 0;
      for (k = 0; k < 64; k++)
        F[k] = 92;
      for (k = 0; k < v.length; k++)
        F[k] ^= v[k];
      function Z() {
        for (let ne = C - 1; ne >= C - 4; ne--) {
          if (P[ne]++, P[ne] <= 255)
            return;
          P[ne] = 0;
        }
      }
      for (; E >= 32; )
        Z(), K = K.concat(i(F.concat(i(P)))), E -= 32;
      return E > 0 && (Z(), K = K.concat(i(F.concat(i(P))).slice(0, E))), K;
    }
    function a(v, w, E, C, P) {
      let F;
      for (u(v, (2 * E - 1) * 16, P, 0, 16), F = 0; F < 2 * E; F++)
        c(v, F * 16, P, 16), l(P, C), u(P, 0, v, w + F * 16, 16);
      for (F = 0; F < E; F++)
        u(v, w + F * 2 * 16, v, F * 16, 16);
      for (F = 0; F < E; F++)
        u(v, w + (F * 2 + 1) * 16, v, (F + E) * 16, 16);
    }
    function o(v, w) {
      return v << w | v >>> 32 - w;
    }
    function l(v, w) {
      u(v, 0, w, 0, 16);
      for (let E = 8; E > 0; E -= 2)
        w[4] ^= o(w[0] + w[12], 7), w[8] ^= o(w[4] + w[0], 9), w[12] ^= o(w[8] + w[4], 13), w[0] ^= o(w[12] + w[8], 18), w[9] ^= o(w[5] + w[1], 7), w[13] ^= o(w[9] + w[5], 9), w[1] ^= o(w[13] + w[9], 13), w[5] ^= o(w[1] + w[13], 18), w[14] ^= o(w[10] + w[6], 7), w[2] ^= o(w[14] + w[10], 9), w[6] ^= o(w[2] + w[14], 13), w[10] ^= o(w[6] + w[2], 18), w[3] ^= o(w[15] + w[11], 7), w[7] ^= o(w[3] + w[15], 9), w[11] ^= o(w[7] + w[3], 13), w[15] ^= o(w[11] + w[7], 18), w[1] ^= o(w[0] + w[3], 7), w[2] ^= o(w[1] + w[0], 9), w[3] ^= o(w[2] + w[1], 13), w[0] ^= o(w[3] + w[2], 18), w[6] ^= o(w[5] + w[4], 7), w[7] ^= o(w[6] + w[5], 9), w[4] ^= o(w[7] + w[6], 13), w[5] ^= o(w[4] + w[7], 18), w[11] ^= o(w[10] + w[9], 7), w[8] ^= o(w[11] + w[10], 9), w[9] ^= o(w[8] + w[11], 13), w[10] ^= o(w[9] + w[8], 18), w[12] ^= o(w[15] + w[14], 7), w[13] ^= o(w[12] + w[15], 9), w[14] ^= o(w[13] + w[12], 13), w[15] ^= o(w[14] + w[13], 18);
      for (let E = 0; E < 16; ++E)
        v[E] += w[E];
    }
    function c(v, w, E, C) {
      for (let P = 0; P < C; P++)
        E[P] ^= v[w + P];
    }
    function u(v, w, E, C, P) {
      for (; P--; )
        E[C++] = v[w++];
    }
    function f(v) {
      if (!v || typeof v.length != "number")
        return !1;
      for (let w = 0; w < v.length; w++) {
        const E = v[w];
        if (typeof E != "number" || E % 1 || E < 0 || E >= 256)
          return !1;
      }
      return !0;
    }
    function p(v, w) {
      if (typeof v != "number" || v % 1)
        throw new Error("invalid " + w);
      return v;
    }
    function x(v, w, E, C, P, F, k) {
      if (E = p(E, "N"), C = p(C, "r"), P = p(P, "p"), F = p(F, "dkLen"), E === 0 || E & E - 1)
        throw new Error("N must be power of 2");
      if (E > 2147483647 / 128 / C)
        throw new Error("N too large");
      if (C > 2147483647 / 128 / P)
        throw new Error("r too large");
      if (!f(v))
        throw new Error("password must be an array or buffer");
      if (v = Array.prototype.slice.call(v), !f(w))
        throw new Error("salt must be an array or buffer");
      w = Array.prototype.slice.call(w);
      let K = s(v, w, P * 128 * C);
      const Z = new Uint32Array(P * 32 * C);
      for (let V = 0; V < Z.length; V++) {
        const g = V * 4;
        Z[V] = (K[g + 3] & 255) << 24 | (K[g + 2] & 255) << 16 | (K[g + 1] & 255) << 8 | (K[g + 0] & 255) << 0;
      }
      const ne = new Uint32Array(64 * C), le = new Uint32Array(32 * C * E), ye = 32 * C, ge = new Uint32Array(16), _e = new Uint32Array(16), L = P * E * 2;
      let d = 0, b = null, S = !1, R = 0, D = 0, z, q;
      const y = k ? parseInt(1e3 / C) : 4294967295, h = typeof setImmediate < "u" ? setImmediate : setTimeout, I = function() {
        if (S)
          return k(new Error("cancelled"), d / L);
        let V;
        switch (R) {
          case 0:
            q = D * 32 * C, u(Z, q, ne, 0, ye), R = 1, z = 0;
          case 1:
            V = E - z, V > y && (V = y);
            for (let G = 0; G < V; G++)
              u(ne, 0, le, (z + G) * ye, ye), a(ne, ye, C, ge, _e);
            if (z += V, d += V, k) {
              const G = parseInt(1e3 * d / L);
              if (G !== b) {
                if (S = k(null, d / L), S)
                  break;
                b = G;
              }
            }
            if (z < E)
              break;
            z = 0, R = 2;
          case 2:
            V = E - z, V > y && (V = y);
            for (let G = 0; G < V; G++) {
              const Q = (2 * C - 1) * 16, J = ne[Q] & E - 1;
              c(le, J * ye, ne, ye), a(ne, ye, C, ge, _e);
            }
            if (z += V, d += V, k) {
              const G = parseInt(1e3 * d / L);
              if (G !== b) {
                if (S = k(null, d / L), S)
                  break;
                b = G;
              }
            }
            if (z < E)
              break;
            if (u(ne, 0, Z, q, ye), D++, D < P) {
              R = 0;
              break;
            }
            K = [];
            for (let G = 0; G < Z.length; G++)
              K.push(Z[G] >> 0 & 255), K.push(Z[G] >> 8 & 255), K.push(Z[G] >> 16 & 255), K.push(Z[G] >> 24 & 255);
            const g = s(v, K, F);
            return k && k(null, 1, g), g;
        }
        k && h(I);
      };
      if (!k)
        for (; ; ) {
          const V = I();
          if (V != null)
            return V;
        }
      I();
    }
    const T = {
      scrypt: function(v, w, E, C, P, F, k) {
        return new Promise(function(K, Z) {
          let ne = 0;
          k && k(0), x(v, w, E, C, P, F, function(le, ye, ge) {
            if (le)
              Z(le);
            else if (ge)
              k && ne !== 1 && k(1), K(new Uint8Array(ge));
            else if (k && ye !== ne)
              return ne = ye, k(ye);
          });
        });
      },
      syncScrypt: function(v, w, E, C, P, F) {
        return new Uint8Array(x(v, w, E, C, P, F));
      }
    };
    r.exports = T;
  })();
})(U2);
var IP = U2.exports;
const zf = /* @__PURE__ */ zi(IP);
var CP = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Nd = new H(B2);
function y1(r) {
  return r != null && r.mnemonic && r.mnemonic.phrase;
}
class PP extends $s {
  isKeystoreAccount(e) {
    return !!(e && e._isKeystoreAccount);
  }
}
function kP(r, e, t) {
  if (Xt(r, "crypto/cipher") === "aes-128-ctr") {
    const i = Rs(Xt(r, "crypto/cipherparams/iv")), s = new hi.Counter(i), a = new hi.ModeOfOperation.ctr(e, s);
    return ve(a.decrypt(t));
  }
  return null;
}
function z2(r, e) {
  const t = Rs(Xt(r, "crypto/ciphertext"));
  if (we(Nt(Lt([e.slice(16, 32), t]))).substring(2) !== Xt(r, "crypto/mac").toLowerCase())
    throw new Error("invalid password");
  const i = kP(r, e.slice(0, 16), t);
  i || Nd.throwError("unsupported cipher", H.errors.UNSUPPORTED_OPERATION, {
    operation: "decrypt"
  });
  const s = e.slice(32, 64), a = ds(i);
  if (r.address) {
    let l = r.address.toLowerCase();
    if (l.substring(0, 2) !== "0x" && (l = "0x" + l), kt(l) !== a)
      throw new Error("address mismatch");
  }
  const o = {
    _isKeystoreAccount: !0,
    address: a,
    privateKey: we(i)
  };
  if (Xt(r, "x-ethers/version") === "0.1") {
    const l = Rs(Xt(r, "x-ethers/mnemonicCiphertext")), c = Rs(Xt(r, "x-ethers/mnemonicCounter")), u = new hi.Counter(c), f = new hi.ModeOfOperation.ctr(s, u), p = Xt(r, "x-ethers/path") || Da, x = Xt(r, "x-ethers/locale") || "en", T = ve(f.decrypt(l));
    try {
      const v = Tc(T, x), w = xn.fromMnemonic(v, null, x).derivePath(p);
      if (w.privateKey != o.privateKey)
        throw new Error("mnemonic mismatch");
      o.mnemonic = w.mnemonic;
    } catch (v) {
      if (v.code !== H.errors.INVALID_ARGUMENT || v.argument !== "wordlist")
        throw v;
    }
  }
  return new PP(o);
}
function W2(r, e, t, n, i) {
  return ve(Df(r, e, t, n, i));
}
function OP(r, e, t, n, i) {
  return Promise.resolve(W2(r, e, t, n, i));
}
function H2(r, e, t, n, i) {
  const s = Bf(e), a = Xt(r, "crypto/kdf");
  if (a && typeof a == "string") {
    const o = function(l, c) {
      return Nd.throwArgumentError("invalid key-derivation function parameters", l, c);
    };
    if (a.toLowerCase() === "scrypt") {
      const l = Rs(Xt(r, "crypto/kdfparams/salt")), c = parseInt(Xt(r, "crypto/kdfparams/n")), u = parseInt(Xt(r, "crypto/kdfparams/r")), f = parseInt(Xt(r, "crypto/kdfparams/p"));
      (!c || !u || !f) && o("kdf", a), c & c - 1 && o("N", c);
      const p = parseInt(Xt(r, "crypto/kdfparams/dklen"));
      return p !== 32 && o("dklen", p), n(s, l, c, u, f, 64, i);
    } else if (a.toLowerCase() === "pbkdf2") {
      const l = Rs(Xt(r, "crypto/kdfparams/salt"));
      let c = null;
      const u = Xt(r, "crypto/kdfparams/prf");
      u === "hmac-sha256" ? c = "sha256" : u === "hmac-sha512" ? c = "sha512" : o("prf", u);
      const f = parseInt(Xt(r, "crypto/kdfparams/c")), p = parseInt(Xt(r, "crypto/kdfparams/dklen"));
      return p !== 32 && o("dklen", p), t(s, l, f, p, c);
    }
  }
  return Nd.throwArgumentError("unsupported key-derivation function", "kdf", a);
}
function NP(r, e) {
  const t = JSON.parse(r), n = H2(t, e, W2, zf.syncScrypt);
  return z2(t, n);
}
function RP(r, e, t) {
  return CP(this, void 0, void 0, function* () {
    const n = JSON.parse(r), i = yield H2(n, e, OP, zf.scrypt, t);
    return z2(n, i);
  });
}
function LP(r, e, t, n) {
  try {
    if (kt(r.address) !== ds(r.privateKey))
      throw new Error("address/privateKey mismatch");
    if (y1(r)) {
      const w = r.mnemonic;
      if (xn.fromMnemonic(w.phrase, null, w.locale).derivePath(w.path || Da).privateKey != r.privateKey)
        throw new Error("mnemonic mismatch");
    }
  } catch (w) {
    return Promise.reject(w);
  }
  typeof t == "function" && !n && (n = t, t = {}), t || (t = {});
  const i = ve(r.privateKey), s = Bf(e);
  let a = null, o = null, l = null;
  if (y1(r)) {
    const w = r.mnemonic;
    a = ve(Sc(w.phrase, w.locale || "en")), o = w.path || Da, l = w.locale || "en";
  }
  let c = t.client;
  c || (c = "ethers.js");
  let u = null;
  t.salt ? u = ve(t.salt) : u = ga(32);
  let f = null;
  if (t.iv) {
    if (f = ve(t.iv), f.length !== 16)
      throw new Error("invalid iv");
  } else
    f = ga(16);
  let p = null;
  if (t.uuid) {
    if (p = ve(t.uuid), p.length !== 16)
      throw new Error("invalid uuid");
  } else
    p = ga(16);
  let x = 1 << 17, T = 8, v = 1;
  return t.scrypt && (t.scrypt.N && (x = t.scrypt.N), t.scrypt.r && (T = t.scrypt.r), t.scrypt.p && (v = t.scrypt.p)), zf.scrypt(s, u, x, T, v, 64, n).then((w) => {
    w = ve(w);
    const E = w.slice(0, 16), C = w.slice(16, 32), P = w.slice(32, 64), F = new hi.Counter(f), k = new hi.ModeOfOperation.ctr(E, F), K = ve(k.encrypt(i)), Z = Nt(Lt([C, K])), ne = {
      address: r.address.substring(2).toLowerCase(),
      id: AP(p),
      version: 3,
      crypto: {
        cipher: "aes-128-ctr",
        cipherparams: {
          iv: we(f).substring(2)
        },
        ciphertext: we(K).substring(2),
        kdf: "scrypt",
        kdfparams: {
          salt: we(u).substring(2),
          n: x,
          dklen: 32,
          p: v,
          r: T
        },
        mac: Z.substring(2)
      }
    };
    if (a) {
      const le = ga(16), ye = new hi.Counter(le), ge = new hi.ModeOfOperation.ctr(P, ye), _e = ve(ge.encrypt(a)), L = /* @__PURE__ */ new Date(), d = L.getUTCFullYear() + "-" + Ja(L.getUTCMonth() + 1, 2) + "-" + Ja(L.getUTCDate(), 2) + "T" + Ja(L.getUTCHours(), 2) + "-" + Ja(L.getUTCMinutes(), 2) + "-" + Ja(L.getUTCSeconds(), 2) + ".0Z";
      ne["x-ethers"] = {
        client: c,
        gethFilename: "UTC--" + d + "--" + ne.address,
        mnemonicCounter: we(le).substring(2),
        mnemonicCiphertext: we(_e).substring(2),
        path: o,
        locale: l,
        version: "0.1"
      };
    }
    return JSON.stringify(ne);
  });
}
function DP(r, e, t) {
  if (jf(r)) {
    t && t(0);
    const n = j2(r, e);
    return t && t(1), Promise.resolve(n);
  }
  return Uf(r) ? RP(r, e, t) : Promise.reject(new Error("invalid JSON wallet"));
}
function FP(r, e) {
  if (jf(r))
    return j2(r, e);
  if (Uf(r))
    return NP(r, e);
  throw new Error("invalid JSON wallet");
}
const BP = "wallet/5.7.0";
var w1 = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const sa = new H(BP);
function jP(r) {
  return r != null && Ye(r.privateKey, 32) && r.address != null;
}
function UP(r) {
  const e = r.mnemonic;
  return e && e.phrase;
}
class ss extends Vi {
  constructor(e, t) {
    if (super(), jP(e)) {
      const n = new Ns(e.privateKey);
      if (ie(this, "_signingKey", () => n), ie(this, "address", ds(this.publicKey)), this.address !== kt(e.address) && sa.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]"), UP(e)) {
        const i = e.mnemonic;
        ie(this, "_mnemonic", () => ({
          phrase: i.phrase,
          path: i.path || Da,
          locale: i.locale || "en"
        }));
        const s = this.mnemonic, a = xn.fromMnemonic(s.phrase, null, s.locale).derivePath(s.path);
        ds(a.privateKey) !== this.address && sa.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
      } else
        ie(this, "_mnemonic", () => null);
    } else {
      if (Ns.isSigningKey(e))
        e.curve !== "secp256k1" && sa.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]"), ie(this, "_signingKey", () => e);
      else {
        typeof e == "string" && e.match(/^[0-9a-f]*$/i) && e.length === 64 && (e = "0x" + e);
        const n = new Ns(e);
        ie(this, "_signingKey", () => n);
      }
      ie(this, "_mnemonic", () => null), ie(this, "address", ds(this.publicKey));
    }
    t && !Ks.isProvider(t) && sa.throwArgumentError("invalid provider", "provider", t), ie(this, "provider", t || null);
  }
  get mnemonic() {
    return this._mnemonic();
  }
  get privateKey() {
    return this._signingKey().privateKey;
  }
  get publicKey() {
    return this._signingKey().publicKey;
  }
  getAddress() {
    return Promise.resolve(this.address);
  }
  connect(e) {
    return new ss(this, e);
  }
  signTransaction(e) {
    return qt(e).then((t) => {
      t.from != null && (kt(t.from) !== this.address && sa.throwArgumentError("transaction from address mismatch", "transaction.from", e.from), delete t.from);
      const n = this._signingKey().signDigest(Nt(kd(t)));
      return kd(t, n);
    });
  }
  signMessage(e) {
    return w1(this, void 0, void 0, function* () {
      return wd(this._signingKey().signDigest(Cf(e)));
    });
  }
  _signTypedData(e, t, n) {
    return w1(this, void 0, void 0, function* () {
      const i = yield Pr.resolveNames(e, t, n, (s) => (this.provider == null && sa.throwError("cannot resolve ENS names without a provider", H.errors.UNSUPPORTED_OPERATION, {
        operation: "resolveName",
        value: s
      }), this.provider.resolveName(s)));
      return wd(this._signingKey().signDigest(Pr.hash(i.domain, t, i.value)));
    });
  }
  encrypt(e, t, n) {
    if (typeof t == "function" && !n && (n = t, t = {}), n && typeof n != "function")
      throw new Error("invalid callback");
    return t || (t = {}), LP(this, e, t, n);
  }
  /**
   *  Static methods to create Wallet instances.
   */
  static createRandom(e) {
    let t = ga(16);
    e || (e = {}), e.extraEntropy && (t = ve(Qt(Nt(Lt([t, e.extraEntropy])), 0, 16)));
    const n = Tc(t, e.locale);
    return ss.fromMnemonic(n, e.path, e.locale);
  }
  static fromEncryptedJson(e, t, n) {
    return DP(e, t, n).then((i) => new ss(i));
  }
  static fromEncryptedJsonSync(e, t) {
    return new ss(FP(e, t));
  }
  static fromMnemonic(e, t, n) {
    return t || (t = Da), new ss(xn.fromMnemonic(e, null, n).derivePath(t));
  }
}
function zP(r, e) {
  return $o(Cf(r), e);
}
function WP(r, e, t, n) {
  return $o(Pr.hash(r, e, t), n);
}
const HP = "networks/5.7.1", _1 = new H(HP);
function VP(r) {
  return r && typeof r.renetwork == "function";
}
function Ni(r) {
  const e = function(t, n) {
    n == null && (n = {});
    const i = [];
    if (t.InfuraProvider && n.infura !== "-")
      try {
        i.push(new t.InfuraProvider(r, n.infura));
      } catch {
      }
    if (t.EtherscanProvider && n.etherscan !== "-")
      try {
        i.push(new t.EtherscanProvider(r, n.etherscan));
      } catch {
      }
    if (t.AlchemyProvider && n.alchemy !== "-")
      try {
        i.push(new t.AlchemyProvider(r, n.alchemy));
      } catch {
      }
    if (t.PocketProvider && n.pocket !== "-") {
      const s = ["goerli", "ropsten", "rinkeby", "sepolia"];
      try {
        const a = new t.PocketProvider(r, n.pocket);
        a.network && s.indexOf(a.network.name) === -1 && i.push(a);
      } catch {
      }
    }
    if (t.CloudflareProvider && n.cloudflare !== "-")
      try {
        i.push(new t.CloudflareProvider(r));
      } catch {
      }
    if (t.AnkrProvider && n.ankr !== "-")
      try {
        const s = ["ropsten"], a = new t.AnkrProvider(r, n.ankr);
        a.network && s.indexOf(a.network.name) === -1 && i.push(a);
      } catch {
      }
    if (i.length === 0)
      return null;
    if (t.FallbackProvider) {
      let s = 1;
      return n.quorum != null ? s = n.quorum : r === "homestead" && (s = 2), new t.FallbackProvider(i, s);
    }
    return i[0];
  };
  return e.renetwork = function(t) {
    return Ni(t);
  }, e;
}
function ec(r, e) {
  const t = function(n, i) {
    return n.JsonRpcProvider ? new n.JsonRpcProvider(r, e) : null;
  };
  return t.renetwork = function(n) {
    return ec(r, n);
  }, t;
}
const E1 = {
  chainId: 1,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "homestead",
  _defaultProvider: Ni("homestead")
}, A1 = {
  chainId: 3,
  ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
  name: "ropsten",
  _defaultProvider: Ni("ropsten")
}, S1 = {
  chainId: 63,
  name: "classicMordor",
  _defaultProvider: ec("https://www.ethercluster.com/mordor", "classicMordor")
}, pl = {
  unspecified: { chainId: 0, name: "unspecified" },
  homestead: E1,
  mainnet: E1,
  morden: { chainId: 2, name: "morden" },
  ropsten: A1,
  testnet: A1,
  rinkeby: {
    chainId: 4,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "rinkeby",
    _defaultProvider: Ni("rinkeby")
  },
  kovan: {
    chainId: 42,
    name: "kovan",
    _defaultProvider: Ni("kovan")
  },
  goerli: {
    chainId: 5,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "goerli",
    _defaultProvider: Ni("goerli")
  },
  kintsugi: { chainId: 1337702, name: "kintsugi" },
  sepolia: {
    chainId: 11155111,
    name: "sepolia",
    _defaultProvider: Ni("sepolia")
  },
  // ETC (See: #351)
  classic: {
    chainId: 61,
    name: "classic",
    _defaultProvider: ec("https://www.ethercluster.com/etc", "classic")
  },
  classicMorden: { chainId: 62, name: "classicMorden" },
  classicMordor: S1,
  classicTestnet: S1,
  classicKotti: {
    chainId: 6,
    name: "classicKotti",
    _defaultProvider: ec("https://www.ethercluster.com/kotti", "classicKotti")
  },
  xdai: { chainId: 100, name: "xdai" },
  matic: {
    chainId: 137,
    name: "matic",
    _defaultProvider: Ni("matic")
  },
  maticmum: { chainId: 80001, name: "maticmum" },
  optimism: {
    chainId: 10,
    name: "optimism",
    _defaultProvider: Ni("optimism")
  },
  "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
  "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
  arbitrum: { chainId: 42161, name: "arbitrum" },
  "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
  "arbitrum-goerli": { chainId: 421613, name: "arbitrum-goerli" },
  bnb: { chainId: 56, name: "bnb" },
  bnbt: { chainId: 97, name: "bnbt" }
};
function Wf(r) {
  if (r == null)
    return null;
  if (typeof r == "number") {
    for (const n in pl) {
      const i = pl[n];
      if (i.chainId === r)
        return {
          name: i.name,
          chainId: i.chainId,
          ensAddress: i.ensAddress || null,
          _defaultProvider: i._defaultProvider || null
        };
    }
    return {
      chainId: r,
      name: "unknown"
    };
  }
  if (typeof r == "string") {
    const n = pl[r];
    return n == null ? null : {
      name: n.name,
      chainId: n.chainId,
      ensAddress: n.ensAddress,
      _defaultProvider: n._defaultProvider || null
    };
  }
  const e = pl[r.name];
  if (!e)
    return typeof r.chainId != "number" && _1.throwArgumentError("invalid network chainId", "network", r), r;
  r.chainId !== 0 && r.chainId !== e.chainId && _1.throwArgumentError("network chainId mismatch", "network", r);
  let t = r._defaultProvider || null;
  return t == null && e._defaultProvider && (VP(e._defaultProvider) ? t = e._defaultProvider.renetwork(r) : t = e._defaultProvider), {
    name: r.name,
    chainId: e.chainId,
    ensAddress: r.ensAddress || e.ensAddress || null,
    _defaultProvider: t
  };
}
const $P = "web/5.7.1";
var GP = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
function KP(r, e) {
  return GP(this, void 0, void 0, function* () {
    e == null && (e = {});
    const t = {
      method: e.method || "GET",
      headers: e.headers || {},
      body: e.body || void 0
    };
    if (e.skipFetchSetup !== !0 && (t.mode = "cors", t.cache = "no-cache", t.credentials = "same-origin", t.redirect = "follow", t.referrer = "client"), e.fetchOptions != null) {
      const a = e.fetchOptions;
      a.mode && (t.mode = a.mode), a.cache && (t.cache = a.cache), a.credentials && (t.credentials = a.credentials), a.redirect && (t.redirect = a.redirect), a.referrer && (t.referrer = a.referrer);
    }
    const n = yield fetch(r, t), i = yield n.arrayBuffer(), s = {};
    return n.headers.forEach ? n.headers.forEach((a, o) => {
      s[o.toLowerCase()] = a;
    }) : n.headers.keys().forEach((a) => {
      s[a.toLowerCase()] = n.headers.get(a);
    }), {
      headers: s,
      statusCode: n.status,
      statusMessage: n.statusText,
      body: ve(new Uint8Array(i))
    };
  });
}
var YP = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Wn = new H($P);
function T1(r) {
  return new Promise((e) => {
    setTimeout(e, r);
  });
}
function rs(r, e) {
  if (r == null)
    return null;
  if (typeof r == "string")
    return r;
  if (Uo(r)) {
    if (e && (e.split("/")[0] === "text" || e.split(";")[0].trim() === "application/json"))
      try {
        return Gs(r);
      } catch {
      }
    return we(r);
  }
  return r;
}
function qP(r) {
  return tr(r.replace(/%([0-9a-f][0-9a-f])/gi, (e, t) => String.fromCharCode(parseInt(t, 16))));
}
function V2(r, e, t) {
  const n = typeof r == "object" && r.throttleLimit != null ? r.throttleLimit : 12;
  Wn.assertArgument(n > 0 && n % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", n);
  const i = typeof r == "object" ? r.throttleCallback : null, s = typeof r == "object" && typeof r.throttleSlotInterval == "number" ? r.throttleSlotInterval : 100;
  Wn.assertArgument(s > 0 && s % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", s);
  const a = typeof r == "object" ? !!r.errorPassThrough : !1, o = {};
  let l = null;
  const c = {
    method: "GET"
  };
  let u = !1, f = 2 * 60 * 1e3;
  if (typeof r == "string")
    l = r;
  else if (typeof r == "object") {
    if ((r == null || r.url == null) && Wn.throwArgumentError("missing URL", "connection.url", r), l = r.url, typeof r.timeout == "number" && r.timeout > 0 && (f = r.timeout), r.headers)
      for (const E in r.headers)
        o[E.toLowerCase()] = { key: E, value: String(r.headers[E]) }, ["if-none-match", "if-modified-since"].indexOf(E.toLowerCase()) >= 0 && (u = !0);
    if (c.allowGzip = !!r.allowGzip, r.user != null && r.password != null) {
      l.substring(0, 6) !== "https:" && r.allowInsecureAuthentication !== !0 && Wn.throwError("basic authentication requires a secure https url", H.errors.INVALID_ARGUMENT, { argument: "url", url: l, user: r.user, password: "[REDACTED]" });
      const E = r.user + ":" + r.password;
      o.authorization = {
        key: "Authorization",
        value: "Basic " + Mf(tr(E))
      };
    }
    r.skipFetchSetup != null && (c.skipFetchSetup = !!r.skipFetchSetup), r.fetchOptions != null && (c.fetchOptions = Bt(r.fetchOptions));
  }
  const p = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i"), x = l ? l.match(p) : null;
  if (x)
    try {
      const E = {
        statusCode: 200,
        statusMessage: "OK",
        headers: { "content-type": x[1] || "text/plain" },
        body: x[2] ? Tf(x[3]) : qP(x[3])
      };
      let C = E.body;
      return t && (C = t(E.body, E)), Promise.resolve(C);
    } catch (E) {
      Wn.throwError("processing response error", H.errors.SERVER_ERROR, {
        body: rs(x[1], x[2]),
        error: E,
        requestBody: null,
        requestMethod: "GET",
        url: l
      });
    }
  e && (c.method = "POST", c.body = e, o["content-type"] == null && (o["content-type"] = { key: "Content-Type", value: "application/octet-stream" }), o["content-length"] == null && (o["content-length"] = { key: "Content-Length", value: String(e.length) }));
  const T = {};
  Object.keys(o).forEach((E) => {
    const C = o[E];
    T[C.key] = C.value;
  }), c.headers = T;
  const v = function() {
    let E = null;
    return { promise: new Promise(function(F, k) {
      f && (E = setTimeout(() => {
        E != null && (E = null, k(Wn.makeError("timeout", H.errors.TIMEOUT, {
          requestBody: rs(c.body, T["content-type"]),
          requestMethod: c.method,
          timeout: f,
          url: l
        })));
      }, f));
    }), cancel: function() {
      E != null && (clearTimeout(E), E = null);
    } };
  }(), w = function() {
    return YP(this, void 0, void 0, function* () {
      for (let E = 0; E < n; E++) {
        let C = null;
        try {
          if (C = yield KP(l, c), E < n) {
            if (C.statusCode === 301 || C.statusCode === 302) {
              const F = C.headers.location || "";
              if (c.method === "GET" && F.match(/^https:/)) {
                l = C.headers.location;
                continue;
              }
            } else if (C.statusCode === 429) {
              let F = !0;
              if (i && (F = yield i(E, l)), F) {
                let k = 0;
                const K = C.headers["retry-after"];
                typeof K == "string" && K.match(/^[1-9][0-9]*$/) ? k = parseInt(K) * 1e3 : k = s * parseInt(String(Math.random() * Math.pow(2, E))), yield T1(k);
                continue;
              }
            }
          }
        } catch (F) {
          C = F.response, C == null && (v.cancel(), Wn.throwError("missing response", H.errors.SERVER_ERROR, {
            requestBody: rs(c.body, T["content-type"]),
            requestMethod: c.method,
            serverError: F,
            url: l
          }));
        }
        let P = C.body;
        if (u && C.statusCode === 304 ? P = null : !a && (C.statusCode < 200 || C.statusCode >= 300) && (v.cancel(), Wn.throwError("bad response", H.errors.SERVER_ERROR, {
          status: C.statusCode,
          headers: C.headers,
          body: rs(P, C.headers ? C.headers["content-type"] : null),
          requestBody: rs(c.body, T["content-type"]),
          requestMethod: c.method,
          url: l
        })), t)
          try {
            const F = yield t(P, C);
            return v.cancel(), F;
          } catch (F) {
            if (F.throttleRetry && E < n) {
              let k = !0;
              if (i && (k = yield i(E, l)), k) {
                const K = s * parseInt(String(Math.random() * Math.pow(2, E)));
                yield T1(K);
                continue;
              }
            }
            v.cancel(), Wn.throwError("processing response error", H.errors.SERVER_ERROR, {
              body: rs(P, C.headers ? C.headers["content-type"] : null),
              error: F,
              requestBody: rs(c.body, T["content-type"]),
              requestMethod: c.method,
              url: l
            });
          }
        return v.cancel(), P;
      }
      return Wn.throwError("failed response", H.errors.SERVER_ERROR, {
        requestBody: rs(c.body, T["content-type"]),
        requestMethod: c.method,
        url: l
      });
    });
  }();
  return Promise.race([v.promise, w]);
}
function Wa(r, e, t) {
  let n = (s, a) => {
    let o = null;
    if (s != null)
      try {
        o = JSON.parse(Gs(s));
      } catch (l) {
        Wn.throwError("invalid JSON", H.errors.SERVER_ERROR, {
          body: s,
          error: l
        });
      }
    return t && (o = t(o, a)), o;
  }, i = null;
  if (e != null) {
    i = tr(e);
    const s = typeof r == "string" ? { url: r } : Bt(r);
    s.headers ? Object.keys(s.headers).filter((o) => o.toLowerCase() === "content-type").length !== 0 || (s.headers = Bt(s.headers), s.headers["content-type"] = "application/json") : s.headers = { "content-type": "application/json" }, r = s;
  }
  return V2(r, i, n);
}
function Ps(r, e) {
  return e || (e = {}), e = Bt(e), e.floor == null && (e.floor = 0), e.ceiling == null && (e.ceiling = 1e4), e.interval == null && (e.interval = 250), new Promise(function(t, n) {
    let i = null, s = !1;
    const a = () => s ? !1 : (s = !0, i && clearTimeout(i), !0);
    e.timeout && (i = setTimeout(() => {
      a() && n(new Error("timeout"));
    }, e.timeout));
    const o = e.retryLimit;
    let l = 0;
    function c() {
      return r().then(function(u) {
        if (u !== void 0)
          a() && t(u);
        else if (e.oncePoll)
          e.oncePoll.once("poll", c);
        else if (e.onceBlock)
          e.onceBlock.once("block", c);
        else if (!s) {
          if (l++, l > o) {
            a() && n(new Error("retry limit reached"));
            return;
          }
          let f = e.interval * parseInt(String(Math.random() * Math.pow(2, l)));
          f < e.floor && (f = e.floor), f > e.ceiling && (f = e.ceiling), setTimeout(c, f);
        }
        return null;
      }, function(u) {
        a() && n(u);
      });
    }
    c();
  });
}
var tc = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Rd = {};
for (var ml = 0; ml < tc.length; ml++) {
  var Eu = tc.charAt(ml);
  if (Rd[Eu] !== void 0)
    throw new TypeError(Eu + " is ambiguous");
  Rd[Eu] = ml;
}
function _a(r) {
  var e = r >> 25;
  return (r & 33554431) << 5 ^ -(e >> 0 & 1) & 996825010 ^ -(e >> 1 & 1) & 642813549 ^ -(e >> 2 & 1) & 513874426 ^ -(e >> 3 & 1) & 1027748829 ^ -(e >> 4 & 1) & 705979059;
}
function $2(r) {
  for (var e = 1, t = 0; t < r.length; ++t) {
    var n = r.charCodeAt(t);
    if (n < 33 || n > 126)
      return "Invalid prefix (" + r + ")";
    e = _a(e) ^ n >> 5;
  }
  for (e = _a(e), t = 0; t < r.length; ++t) {
    var i = r.charCodeAt(t);
    e = _a(e) ^ i & 31;
  }
  return e;
}
function ZP(r, e, t) {
  if (t = t || 90, r.length + 7 + e.length > t)
    throw new TypeError("Exceeds length limit");
  r = r.toLowerCase();
  var n = $2(r);
  if (typeof n == "string")
    throw new Error(n);
  for (var i = r + "1", s = 0; s < e.length; ++s) {
    var a = e[s];
    if (a >> 5)
      throw new Error("Non 5-bit word");
    n = _a(n) ^ a, i += tc.charAt(a);
  }
  for (s = 0; s < 6; ++s)
    n = _a(n);
  for (n ^= 1, s = 0; s < 6; ++s) {
    var o = n >> (5 - s) * 5 & 31;
    i += tc.charAt(o);
  }
  return i;
}
function G2(r, e) {
  if (e = e || 90, r.length < 8)
    return r + " too short";
  if (r.length > e)
    return "Exceeds length limit";
  var t = r.toLowerCase(), n = r.toUpperCase();
  if (r !== t && r !== n)
    return "Mixed-case string " + r;
  r = t;
  var i = r.lastIndexOf("1");
  if (i === -1)
    return "No separator character for " + r;
  if (i === 0)
    return "Missing prefix for " + r;
  var s = r.slice(0, i), a = r.slice(i + 1);
  if (a.length < 6)
    return "Data too short";
  var o = $2(s);
  if (typeof o == "string")
    return o;
  for (var l = [], c = 0; c < a.length; ++c) {
    var u = a.charAt(c), f = Rd[u];
    if (f === void 0)
      return "Unknown character " + u;
    o = _a(o) ^ f, !(c + 6 >= a.length) && l.push(f);
  }
  return o !== 1 ? "Invalid checksum for " + r : { prefix: s, words: l };
}
function JP() {
  var r = G2.apply(null, arguments);
  if (typeof r == "object")
    return r;
}
function XP(r) {
  var e = G2.apply(null, arguments);
  if (typeof e == "object")
    return e;
  throw new Error(e);
}
function Mc(r, e, t, n) {
  for (var i = 0, s = 0, a = (1 << t) - 1, o = [], l = 0; l < r.length; ++l)
    for (i = i << e | r[l], s += e; s >= t; )
      s -= t, o.push(i >> s & a);
  if (n)
    s > 0 && o.push(i << t - s & a);
  else {
    if (s >= e)
      return "Excess padding";
    if (i << t - s & a)
      return "Non-zero padding";
  }
  return o;
}
function QP(r) {
  var e = Mc(r, 8, 5, !0);
  if (Array.isArray(e))
    return e;
}
function ek(r) {
  var e = Mc(r, 8, 5, !0);
  if (Array.isArray(e))
    return e;
  throw new Error(e);
}
function tk(r) {
  var e = Mc(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
}
function rk(r) {
  var e = Mc(r, 5, 8, !1);
  if (Array.isArray(e))
    return e;
  throw new Error(e);
}
var nk = {
  decodeUnsafe: JP,
  decode: XP,
  encode: ZP,
  toWordsUnsafe: QP,
  toWords: ek,
  fromWordsUnsafe: tk,
  fromWords: rk
};
const M1 = /* @__PURE__ */ zi(nk), Hr = "providers/5.7.2", Xa = new H(Hr);
class Ce {
  constructor() {
    this.formats = this.getDefaultFormats();
  }
  getDefaultFormats() {
    const e = {}, t = this.address.bind(this), n = this.bigNumber.bind(this), i = this.blockTag.bind(this), s = this.data.bind(this), a = this.hash.bind(this), o = this.hex.bind(this), l = this.number.bind(this), c = this.type.bind(this), u = (f) => this.data(f, !0);
    return e.transaction = {
      hash: a,
      type: c,
      accessList: Ce.allowNull(this.accessList.bind(this), null),
      blockHash: Ce.allowNull(a, null),
      blockNumber: Ce.allowNull(l, null),
      transactionIndex: Ce.allowNull(l, null),
      confirmations: Ce.allowNull(l, null),
      from: t,
      // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
      // must be set
      gasPrice: Ce.allowNull(n),
      maxPriorityFeePerGas: Ce.allowNull(n),
      maxFeePerGas: Ce.allowNull(n),
      gasLimit: n,
      to: Ce.allowNull(t, null),
      value: n,
      nonce: l,
      data: s,
      r: Ce.allowNull(this.uint256),
      s: Ce.allowNull(this.uint256),
      v: Ce.allowNull(l),
      creates: Ce.allowNull(t, null),
      raw: Ce.allowNull(s)
    }, e.transactionRequest = {
      from: Ce.allowNull(t),
      nonce: Ce.allowNull(l),
      gasLimit: Ce.allowNull(n),
      gasPrice: Ce.allowNull(n),
      maxPriorityFeePerGas: Ce.allowNull(n),
      maxFeePerGas: Ce.allowNull(n),
      to: Ce.allowNull(t),
      value: Ce.allowNull(n),
      data: Ce.allowNull(u),
      type: Ce.allowNull(l),
      accessList: Ce.allowNull(this.accessList.bind(this), null)
    }, e.receiptLog = {
      transactionIndex: l,
      blockNumber: l,
      transactionHash: a,
      address: t,
      topics: Ce.arrayOf(a),
      data: s,
      logIndex: l,
      blockHash: a
    }, e.receipt = {
      to: Ce.allowNull(this.address, null),
      from: Ce.allowNull(this.address, null),
      contractAddress: Ce.allowNull(t, null),
      transactionIndex: l,
      // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
      root: Ce.allowNull(o),
      gasUsed: n,
      logsBloom: Ce.allowNull(s),
      blockHash: a,
      transactionHash: a,
      logs: Ce.arrayOf(this.receiptLog.bind(this)),
      blockNumber: l,
      confirmations: Ce.allowNull(l, null),
      cumulativeGasUsed: n,
      effectiveGasPrice: Ce.allowNull(n),
      status: Ce.allowNull(l),
      type: c
    }, e.block = {
      hash: Ce.allowNull(a),
      parentHash: a,
      number: l,
      timestamp: l,
      nonce: Ce.allowNull(o),
      difficulty: this.difficulty.bind(this),
      gasLimit: n,
      gasUsed: n,
      miner: Ce.allowNull(t),
      extraData: s,
      transactions: Ce.allowNull(Ce.arrayOf(a)),
      baseFeePerGas: Ce.allowNull(n)
    }, e.blockWithTransactions = Bt(e.block), e.blockWithTransactions.transactions = Ce.allowNull(Ce.arrayOf(this.transactionResponse.bind(this))), e.filter = {
      fromBlock: Ce.allowNull(i, void 0),
      toBlock: Ce.allowNull(i, void 0),
      blockHash: Ce.allowNull(a, void 0),
      address: Ce.allowNull(t, void 0),
      topics: Ce.allowNull(this.topics.bind(this), void 0)
    }, e.filterLog = {
      blockNumber: Ce.allowNull(l),
      blockHash: Ce.allowNull(a),
      transactionIndex: l,
      removed: Ce.allowNull(this.boolean.bind(this)),
      address: t,
      data: Ce.allowFalsish(s, "0x"),
      topics: Ce.arrayOf(a),
      transactionHash: a,
      logIndex: l
    }, e;
  }
  accessList(e) {
    return bs(e || []);
  }
  // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
  // Strict! Used on input.
  number(e) {
    return e === "0x" ? 0 : be.from(e).toNumber();
  }
  type(e) {
    return e === "0x" || e == null ? 0 : be.from(e).toNumber();
  }
  // Strict! Used on input.
  bigNumber(e) {
    return be.from(e);
  }
  // Requires a boolean, "true" or  "false"; returns a boolean
  boolean(e) {
    if (typeof e == "boolean")
      return e;
    if (typeof e == "string") {
      if (e = e.toLowerCase(), e === "true")
        return !0;
      if (e === "false")
        return !1;
    }
    throw new Error("invalid boolean - " + e);
  }
  hex(e, t) {
    return typeof e == "string" && (!t && e.substring(0, 2) !== "0x" && (e = "0x" + e), Ye(e)) ? e.toLowerCase() : Xa.throwArgumentError("invalid hash", "value", e);
  }
  data(e, t) {
    const n = this.hex(e, t);
    if (n.length % 2 !== 0)
      throw new Error("invalid data; odd-length - " + e);
    return n;
  }
  // Requires an address
  // Strict! Used on input.
  address(e) {
    return kt(e);
  }
  callAddress(e) {
    if (!Ye(e, 32))
      return null;
    const t = kt(Qt(e, 12));
    return t === Pg ? null : t;
  }
  contractAddress(e) {
    return vc(e);
  }
  // Strict! Used on input.
  blockTag(e) {
    if (e == null)
      return "latest";
    if (e === "earliest")
      return "0x0";
    switch (e) {
      case "earliest":
        return "0x0";
      case "latest":
      case "pending":
      case "safe":
      case "finalized":
        return e;
    }
    if (typeof e == "number" || Ye(e))
      return zo(e);
    throw new Error("invalid blockTag");
  }
  // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
  hash(e, t) {
    const n = this.hex(e, t);
    return vi(n) !== 32 ? Xa.throwArgumentError("invalid hash", "value", e) : n;
  }
  // Returns the difficulty as a number, or if too large (i.e. PoA network) null
  difficulty(e) {
    if (e == null)
      return null;
    const t = be.from(e);
    try {
      return t.toNumber();
    } catch {
    }
    return null;
  }
  uint256(e) {
    if (!Ye(e))
      throw new Error("invalid uint256");
    return Dt(e, 32);
  }
  _block(e, t) {
    e.author != null && e.miner == null && (e.miner = e.author);
    const n = e._difficulty != null ? e._difficulty : e.difficulty, i = Ce.check(t, e);
    return i._difficulty = n == null ? null : be.from(n), i;
  }
  block(e) {
    return this._block(e, this.formats.block);
  }
  blockWithTransactions(e) {
    return this._block(e, this.formats.blockWithTransactions);
  }
  // Strict! Used on input.
  transactionRequest(e) {
    return Ce.check(this.formats.transactionRequest, e);
  }
  transactionResponse(e) {
    e.gas != null && e.gasLimit == null && (e.gasLimit = e.gas), e.to && be.from(e.to).isZero() && (e.to = "0x0000000000000000000000000000000000000000"), e.input != null && e.data == null && (e.data = e.input), e.to == null && e.creates == null && (e.creates = this.contractAddress(e)), (e.type === 1 || e.type === 2) && e.accessList == null && (e.accessList = []);
    const t = Ce.check(this.formats.transaction, e);
    if (e.chainId != null) {
      let n = e.chainId;
      Ye(n) && (n = be.from(n).toNumber()), t.chainId = n;
    } else {
      let n = e.networkId;
      n == null && t.v == null && (n = e.chainId), Ye(n) && (n = be.from(n).toNumber()), typeof n != "number" && t.v != null && (n = (t.v - 35) / 2, n < 0 && (n = 0), n = parseInt(n)), typeof n != "number" && (n = 0), t.chainId = n;
    }
    return t.blockHash && t.blockHash.replace(/0/g, "") === "x" && (t.blockHash = null), t;
  }
  transaction(e) {
    return T2(e);
  }
  receiptLog(e) {
    return Ce.check(this.formats.receiptLog, e);
  }
  receipt(e) {
    const t = Ce.check(this.formats.receipt, e);
    if (t.root != null)
      if (t.root.length <= 4) {
        const n = be.from(t.root).toNumber();
        n === 0 || n === 1 ? (t.status != null && t.status !== n && Xa.throwArgumentError("alt-root-status/status mismatch", "value", { root: t.root, status: t.status }), t.status = n, delete t.root) : Xa.throwArgumentError("invalid alt-root-status", "value.root", t.root);
      } else
        t.root.length !== 66 && Xa.throwArgumentError("invalid root hash", "value.root", t.root);
    return t.status != null && (t.byzantium = !0), t;
  }
  topics(e) {
    return Array.isArray(e) ? e.map((t) => this.topics(t)) : e != null ? this.hash(e, !0) : null;
  }
  filter(e) {
    return Ce.check(this.formats.filter, e);
  }
  filterLog(e) {
    return Ce.check(this.formats.filterLog, e);
  }
  static check(e, t) {
    const n = {};
    for (const i in e)
      try {
        const s = e[i](t[i]);
        s !== void 0 && (n[i] = s);
      } catch (s) {
        throw s.checkKey = i, s.checkValue = t[i], s;
      }
    return n;
  }
  // if value is null-ish, nullValue is returned
  static allowNull(e, t) {
    return function(n) {
      return n == null ? t : e(n);
    };
  }
  // If value is false-ish, replaceValue is returned
  static allowFalsish(e, t) {
    return function(n) {
      return n ? e(n) : t;
    };
  }
  // Requires an Array satisfying check
  static arrayOf(e) {
    return function(t) {
      if (!Array.isArray(t))
        throw new Error("not an array");
      const n = [];
      return t.forEach(function(i) {
        n.push(e(i));
      }), n;
    };
  }
}
function K2(r) {
  return r && typeof r.isCommunityResource == "function";
}
function Ld(r) {
  return K2(r) && r.isCommunityResource();
}
let I1 = !1;
function Go() {
  I1 || (I1 = !0, console.log("========= NOTICE ========="), console.log("Request-Rate Exceeded  (this message will not be repeated)"), console.log(""), console.log("The default API keys for each service are provided as a highly-throttled,"), console.log("community resource for low-traffic projects and early prototyping."), console.log(""), console.log("While your application will continue to function, we highly recommended"), console.log("signing up for your own API keys to improve performance, increase your"), console.log("request rate/limit and enable other perks, such as metrics and advanced APIs."), console.log(""), console.log("For more details: https://docs.ethers.io/api-keys/"), console.log("=========================="));
}
var He = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const et = new H(Hr), ik = 10;
function C1(r) {
  return r == null ? "null" : (vi(r) !== 32 && et.throwArgumentError("invalid topic", "topic", r), r.toLowerCase());
}
function P1(r) {
  for (r = r.slice(); r.length > 0 && r[r.length - 1] == null; )
    r.pop();
  return r.map((e) => {
    if (Array.isArray(e)) {
      const t = {};
      e.forEach((i) => {
        t[C1(i)] = !0;
      });
      const n = Object.keys(t);
      return n.sort(), n.join("|");
    } else
      return C1(e);
  }).join("&");
}
function sk(r) {
  return r === "" ? [] : r.split(/&/g).map((e) => {
    if (e === "")
      return [];
    const t = e.split("|").map((n) => n === "null" ? null : n);
    return t.length === 1 ? t[0] : t;
  });
}
function aa(r) {
  if (typeof r == "string") {
    if (r = r.toLowerCase(), vi(r) === 32)
      return "tx:" + r;
    if (r.indexOf(":") === -1)
      return r;
  } else {
    if (Array.isArray(r))
      return "filter:*:" + P1(r);
    if (oI.isForkEvent(r))
      throw et.warn("not implemented"), new Error("not implemented");
    if (r && typeof r == "object")
      return "filter:" + (r.address || "*") + ":" + P1(r.topics || []);
  }
  throw new Error("invalid event - " + r);
}
function Qa() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function k1(r) {
  return new Promise((e) => {
    setTimeout(e, r);
  });
}
const ak = ["block", "network", "pending", "poll"];
let ok = class {
  constructor(e, t, n) {
    ie(this, "tag", e), ie(this, "listener", t), ie(this, "once", n), this._lastBlockNumber = -2, this._inflight = !1;
  }
  get event() {
    switch (this.type) {
      case "tx":
        return this.hash;
      case "filter":
        return this.filter;
    }
    return this.tag;
  }
  get type() {
    return this.tag.split(":")[0];
  }
  get hash() {
    const e = this.tag.split(":");
    return e[0] !== "tx" ? null : e[1];
  }
  get filter() {
    const e = this.tag.split(":");
    if (e[0] !== "filter")
      return null;
    const t = e[1], n = sk(e[2]), i = {};
    return n.length > 0 && (i.topics = n), t && t !== "*" && (i.address = t), i;
  }
  pollable() {
    return this.tag.indexOf(":") >= 0 || ak.indexOf(this.tag) >= 0;
  }
};
const lk = {
  0: { symbol: "btc", p2pkh: 0, p2sh: 5, prefix: "bc" },
  2: { symbol: "ltc", p2pkh: 48, p2sh: 50, prefix: "ltc" },
  3: { symbol: "doge", p2pkh: 30, p2sh: 22 },
  60: { symbol: "eth", ilk: "eth" },
  61: { symbol: "etc", ilk: "eth" },
  700: { symbol: "xdai", ilk: "eth" }
};
function Au(r) {
  return Dt(be.from(r).toHexString(), 32);
}
function O1(r) {
  return Ra.encode(Lt([r, Qt(Ui(Ui(r)), 0, 4)]));
}
const Y2 = new RegExp("^(ipfs)://(.*)$", "i"), N1 = [
  new RegExp("^(https)://(.*)$", "i"),
  new RegExp("^(data):(.*)$", "i"),
  Y2,
  new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function Ol(r, e) {
  try {
    return Gs(Lo(r, e));
  } catch {
  }
  return null;
}
function Lo(r, e) {
  if (r === "0x")
    return null;
  const t = be.from(Qt(r, e, e + 32)).toNumber(), n = be.from(Qt(r, t, t + 32)).toNumber();
  return Qt(r, t + 32, t + 32 + n);
}
function Su(r) {
  return r.match(/^ipfs:\/\/ipfs\//i) ? r = r.substring(12) : r.match(/^ipfs:\/\//i) ? r = r.substring(7) : et.throwArgumentError("unsupported IPFS format", "link", r), `https://gateway.ipfs.io/ipfs/${r}`;
}
function R1(r) {
  const e = ve(r);
  if (e.length > 32)
    throw new Error("internal; should not happen");
  const t = new Uint8Array(32);
  return t.set(e, 32 - e.length), t;
}
function ck(r) {
  if (r.length % 32 === 0)
    return r;
  const e = new Uint8Array(Math.ceil(r.length / 32) * 32);
  return e.set(r), e;
}
function q2(r) {
  const e = [];
  let t = 0;
  for (let n = 0; n < r.length; n++)
    e.push(null), t += 32;
  for (let n = 0; n < r.length; n++) {
    const i = ve(r[n]);
    e[n] = R1(t), e.push(R1(i.length)), e.push(ck(i)), t += 32 + Math.ceil(i.length / 32) * 32;
  }
  return Kr(e);
}
class Dd {
  // The resolvedAddress is only for creating a ReverseLookup resolver
  constructor(e, t, n, i) {
    ie(this, "provider", e), ie(this, "name", n), ie(this, "address", e.formatter.address(t)), ie(this, "_resolvedAddress", i);
  }
  supportsWildcard() {
    return this._supportsEip2544 || (this._supportsEip2544 = this.provider.call({
      to: this.address,
      data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
    }).then((e) => be.from(e).eq(1)).catch((e) => {
      if (e.code === H.errors.CALL_EXCEPTION)
        return !1;
      throw this._supportsEip2544 = null, e;
    })), this._supportsEip2544;
  }
  _fetch(e, t) {
    return He(this, void 0, void 0, function* () {
      const n = {
        to: this.address,
        ccipReadEnabled: !0,
        data: Kr([e, xo(this.name), t || "0x"])
      };
      let i = !1;
      (yield this.supportsWildcard()) && (i = !0, n.data = Kr(["0x9061b923", q2([Kg(this.name), n.data])]));
      try {
        let s = yield this.provider.call(n);
        return ve(s).length % 32 === 4 && et.throwError("resolver threw error", H.errors.CALL_EXCEPTION, {
          transaction: n,
          data: s
        }), i && (s = Lo(s, 0)), s;
      } catch (s) {
        if (s.code === H.errors.CALL_EXCEPTION)
          return null;
        throw s;
      }
    });
  }
  _fetchBytes(e, t) {
    return He(this, void 0, void 0, function* () {
      const n = yield this._fetch(e, t);
      return n != null ? Lo(n, 0) : null;
    });
  }
  _getAddress(e, t) {
    const n = lk[String(e)];
    if (n == null && et.throwError(`unsupported coin type: ${e}`, H.errors.UNSUPPORTED_OPERATION, {
      operation: `getAddress(${e})`
    }), n.ilk === "eth")
      return this.provider.formatter.address(t);
    const i = ve(t);
    if (n.p2pkh != null) {
      const s = t.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
      if (s) {
        const a = parseInt(s[1], 16);
        if (s[2].length === a * 2 && a >= 1 && a <= 75)
          return O1(Lt([[n.p2pkh], "0x" + s[2]]));
      }
    }
    if (n.p2sh != null) {
      const s = t.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
      if (s) {
        const a = parseInt(s[1], 16);
        if (s[2].length === a * 2 && a >= 1 && a <= 75)
          return O1(Lt([[n.p2sh], "0x" + s[2]]));
      }
    }
    if (n.prefix != null) {
      const s = i[1];
      let a = i[0];
      if (a === 0 ? s !== 20 && s !== 32 && (a = -1) : a = -1, a >= 0 && i.length === 2 + s && s >= 1 && s <= 75) {
        const o = M1.toWords(i.slice(2));
        return o.unshift(a), M1.encode(n.prefix, o);
      }
    }
    return null;
  }
  getAddress(e) {
    return He(this, void 0, void 0, function* () {
      if (e == null && (e = 60), e === 60)
        try {
          const i = yield this._fetch("0x3b3b57de");
          return i === "0x" || i === _f ? null : this.provider.formatter.callAddress(i);
        } catch (i) {
          if (i.code === H.errors.CALL_EXCEPTION)
            return null;
          throw i;
        }
      const t = yield this._fetchBytes("0xf1cb7e06", Au(e));
      if (t == null || t === "0x")
        return null;
      const n = this._getAddress(e, t);
      return n == null && et.throwError("invalid or unsupported coin data", H.errors.UNSUPPORTED_OPERATION, {
        operation: `getAddress(${e})`,
        coinType: e,
        data: t
      }), n;
    });
  }
  getAvatar() {
    return He(this, void 0, void 0, function* () {
      const e = [{ type: "name", content: this.name }];
      try {
        const t = yield this.getText("avatar");
        if (t == null)
          return null;
        for (let n = 0; n < N1.length; n++) {
          const i = t.match(N1[n]);
          if (i == null)
            continue;
          const s = i[1].toLowerCase();
          switch (s) {
            case "https":
              return e.push({ type: "url", content: t }), { linkage: e, url: t };
            case "data":
              return e.push({ type: "data", content: t }), { linkage: e, url: t };
            case "ipfs":
              return e.push({ type: "ipfs", content: t }), { linkage: e, url: Su(t) };
            case "erc721":
            case "erc1155": {
              const a = s === "erc721" ? "0xc87b56dd" : "0x0e89341c";
              e.push({ type: s, content: t });
              const o = this._resolvedAddress || (yield this.getAddress()), l = (i[2] || "").split("/");
              if (l.length !== 2)
                return null;
              const c = yield this.provider.formatter.address(l[0]), u = Dt(be.from(l[1]).toHexString(), 32);
              if (s === "erc721") {
                const v = this.provider.formatter.callAddress(yield this.provider.call({
                  to: c,
                  data: Kr(["0x6352211e", u])
                }));
                if (o !== v)
                  return null;
                e.push({ type: "owner", content: v });
              } else if (s === "erc1155") {
                const v = be.from(yield this.provider.call({
                  to: c,
                  data: Kr(["0x00fdd58e", Dt(o, 32), u])
                }));
                if (v.isZero())
                  return null;
                e.push({ type: "balance", content: v.toString() });
              }
              const f = {
                to: this.provider.formatter.address(l[0]),
                data: Kr([a, u])
              };
              let p = Ol(yield this.provider.call(f), 0);
              if (p == null)
                return null;
              e.push({ type: "metadata-url-base", content: p }), s === "erc1155" && (p = p.replace("{id}", u.substring(2)), e.push({ type: "metadata-url-expanded", content: p })), p.match(/^ipfs:/i) && (p = Su(p)), e.push({ type: "metadata-url", content: p });
              const x = yield Wa(p);
              if (!x)
                return null;
              e.push({ type: "metadata", content: JSON.stringify(x) });
              let T = x.image;
              if (typeof T != "string")
                return null;
              if (!T.match(/^(https:\/\/|data:)/i)) {
                if (T.match(Y2) == null)
                  return null;
                e.push({ type: "url-ipfs", content: T }), T = Su(T);
              }
              return e.push({ type: "url", content: T }), { linkage: e, url: T };
            }
          }
        }
      } catch {
      }
      return null;
    });
  }
  getContentHash() {
    return He(this, void 0, void 0, function* () {
      const e = yield this._fetchBytes("0xbc1c58d1");
      if (e == null || e === "0x")
        return null;
      const t = e.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (t) {
        const a = parseInt(t[3], 16);
        if (t[4].length === a * 2)
          return "ipfs://" + Ra.encode("0x" + t[1]);
      }
      const n = e.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
      if (n) {
        const a = parseInt(n[3], 16);
        if (n[4].length === a * 2)
          return "ipns://" + Ra.encode("0x" + n[1]);
      }
      const i = e.match(/^0xe40101fa011b20([0-9a-f]*)$/);
      if (i && i[1].length === 32 * 2)
        return "bzz://" + i[1];
      const s = e.match(/^0x90b2c605([0-9a-f]*)$/);
      if (s && s[1].length === 34 * 2) {
        const a = { "=": "", "+": "-", "/": "_" };
        return "sia://" + Mf("0x" + s[1]).replace(/[=+\/]/g, (l) => a[l]);
      }
      return et.throwError("invalid or unsupported content hash data", H.errors.UNSUPPORTED_OPERATION, {
        operation: "getContentHash()",
        data: e
      });
    });
  }
  getText(e) {
    return He(this, void 0, void 0, function* () {
      let t = tr(e);
      t = Lt([Au(64), Au(t.length), t]), t.length % 32 !== 0 && (t = Lt([t, Dt("0x", 32 - e.length % 32)]));
      const n = yield this._fetchBytes("0x59d1d43c", we(t));
      return n == null || n === "0x" ? null : Gs(n);
    });
  }
}
let Tu = null, uk = 1;
class Ic extends Ks {
  /**
   *  ready
   *
   *  A Promise<Network> that resolves only once the provider is ready.
   *
   *  Sub-classes that call the super with a network without a chainId
   *  MUST set this. Standard named networks have a known chainId.
   *
   */
  constructor(e) {
    if (super(), this._events = [], this._emitted = { block: -2 }, this.disableCcipRead = !1, this.formatter = new.target.getFormatter(), ie(this, "anyNetwork", e === "any"), this.anyNetwork && (e = this.detectNetwork()), e instanceof Promise)
      this._networkPromise = e, e.catch((t) => {
      }), this._ready().catch((t) => {
      });
    else {
      const t = kr(new.target, "getNetwork")(e);
      t ? (ie(this, "_network", t), this.emit("network", t, null)) : et.throwArgumentError("invalid network", "network", e);
    }
    this._maxInternalBlockNumber = -1024, this._lastBlockNumber = -2, this._maxFilterBlockRange = 10, this._pollingInterval = 4e3, this._fastQueryDate = 0;
  }
  _ready() {
    return He(this, void 0, void 0, function* () {
      if (this._network == null) {
        let e = null;
        if (this._networkPromise)
          try {
            e = yield this._networkPromise;
          } catch {
          }
        e == null && (e = yield this.detectNetwork()), e || et.throwError("no network detected", H.errors.UNKNOWN_ERROR, {}), this._network == null && (this.anyNetwork ? this._network = e : ie(this, "_network", e), this.emit("network", e, null));
      }
      return this._network;
    });
  }
  // This will always return the most recently established network.
  // For "any", this can change (a "network" event is emitted before
  // any change is reflected); otherwise this cannot change
  get ready() {
    return Ps(() => this._ready().then((e) => e, (e) => {
      if (!(e.code === H.errors.NETWORK_ERROR && e.event === "noNetwork"))
        throw e;
    }));
  }
  // @TODO: Remove this and just create a singleton formatter
  static getFormatter() {
    return Tu == null && (Tu = new Ce()), Tu;
  }
  // @TODO: Remove this and just use getNetwork
  static getNetwork(e) {
    return Wf(e ?? "homestead");
  }
  ccipReadFetch(e, t, n) {
    return He(this, void 0, void 0, function* () {
      if (this.disableCcipRead || n.length === 0)
        return null;
      const i = e.to.toLowerCase(), s = t.toLowerCase(), a = [];
      for (let o = 0; o < n.length; o++) {
        const l = n[o], c = l.replace("{sender}", i).replace("{data}", s), u = l.indexOf("{data}") >= 0 ? null : JSON.stringify({ data: s, sender: i }), f = yield Wa({ url: c, errorPassThrough: !0 }, u, (x, T) => (x.status = T.statusCode, x));
        if (f.data)
          return f.data;
        const p = f.message || "unknown error";
        if (f.status >= 400 && f.status < 500)
          return et.throwError(`response not found during CCIP fetch: ${p}`, H.errors.SERVER_ERROR, { url: l, errorMessage: p });
        a.push(p);
      }
      return et.throwError(`error encountered during CCIP fetch: ${a.map((o) => JSON.stringify(o)).join(", ")}`, H.errors.SERVER_ERROR, {
        urls: n,
        errorMessages: a
      });
    });
  }
  // Fetches the blockNumber, but will reuse any result that is less
  // than maxAge old or has been requested since the last request
  _getInternalBlockNumber(e) {
    return He(this, void 0, void 0, function* () {
      if (yield this._ready(), e > 0)
        for (; this._internalBlockNumber; ) {
          const i = this._internalBlockNumber;
          try {
            const s = yield i;
            if (Qa() - s.respTime <= e)
              return s.blockNumber;
            break;
          } catch {
            if (this._internalBlockNumber === i)
              break;
          }
        }
      const t = Qa(), n = qt({
        blockNumber: this.perform("getBlockNumber", {}),
        networkError: this.getNetwork().then((i) => null, (i) => i)
      }).then(({ blockNumber: i, networkError: s }) => {
        if (s)
          throw this._internalBlockNumber === n && (this._internalBlockNumber = null), s;
        const a = Qa();
        return i = be.from(i).toNumber(), i < this._maxInternalBlockNumber && (i = this._maxInternalBlockNumber), this._maxInternalBlockNumber = i, this._setFastBlockNumber(i), { blockNumber: i, reqTime: t, respTime: a };
      });
      return this._internalBlockNumber = n, n.catch((i) => {
        this._internalBlockNumber === n && (this._internalBlockNumber = null);
      }), (yield n).blockNumber;
    });
  }
  poll() {
    return He(this, void 0, void 0, function* () {
      const e = uk++, t = [];
      let n = null;
      try {
        n = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
      } catch (i) {
        this.emit("error", i);
        return;
      }
      if (this._setFastBlockNumber(n), this.emit("poll", e, n), n === this._lastBlockNumber) {
        this.emit("didPoll", e);
        return;
      }
      if (this._emitted.block === -2 && (this._emitted.block = n - 1), Math.abs(this._emitted.block - n) > 1e3)
        et.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${n})`), this.emit("error", et.makeError("network block skew detected", H.errors.NETWORK_ERROR, {
          blockNumber: n,
          event: "blockSkew",
          previousBlockNumber: this._emitted.block
        })), this.emit("block", n);
      else
        for (let i = this._emitted.block + 1; i <= n; i++)
          this.emit("block", i);
      this._emitted.block !== n && (this._emitted.block = n, Object.keys(this._emitted).forEach((i) => {
        if (i === "block")
          return;
        const s = this._emitted[i];
        s !== "pending" && n - s > 12 && delete this._emitted[i];
      })), this._lastBlockNumber === -2 && (this._lastBlockNumber = n - 1), this._events.forEach((i) => {
        switch (i.type) {
          case "tx": {
            const s = i.hash;
            let a = this.getTransactionReceipt(s).then((o) => (!o || o.blockNumber == null || (this._emitted["t:" + s] = o.blockNumber, this.emit(s, o)), null)).catch((o) => {
              this.emit("error", o);
            });
            t.push(a);
            break;
          }
          case "filter": {
            if (!i._inflight) {
              i._inflight = !0, i._lastBlockNumber === -2 && (i._lastBlockNumber = n - 1);
              const s = i.filter;
              s.fromBlock = i._lastBlockNumber + 1, s.toBlock = n;
              const a = s.toBlock - this._maxFilterBlockRange;
              a > s.fromBlock && (s.fromBlock = a), s.fromBlock < 0 && (s.fromBlock = 0);
              const o = this.getLogs(s).then((l) => {
                i._inflight = !1, l.length !== 0 && l.forEach((c) => {
                  c.blockNumber > i._lastBlockNumber && (i._lastBlockNumber = c.blockNumber), this._emitted["b:" + c.blockHash] = c.blockNumber, this._emitted["t:" + c.transactionHash] = c.blockNumber, this.emit(s, c);
                });
              }).catch((l) => {
                this.emit("error", l), i._inflight = !1;
              });
              t.push(o);
            }
            break;
          }
        }
      }), this._lastBlockNumber = n, Promise.all(t).then(() => {
        this.emit("didPoll", e);
      }).catch((i) => {
        this.emit("error", i);
      });
    });
  }
  // Deprecated; do not use this
  resetEventsBlock(e) {
    this._lastBlockNumber = e - 1, this.polling && this.poll();
  }
  get network() {
    return this._network;
  }
  // This method should query the network if the underlying network
  // can change, such as when connected to a JSON-RPC backend
  detectNetwork() {
    return He(this, void 0, void 0, function* () {
      return et.throwError("provider does not support network detection", H.errors.UNSUPPORTED_OPERATION, {
        operation: "provider.detectNetwork"
      });
    });
  }
  getNetwork() {
    return He(this, void 0, void 0, function* () {
      const e = yield this._ready(), t = yield this.detectNetwork();
      if (e.chainId !== t.chainId) {
        if (this.anyNetwork)
          return this._network = t, this._lastBlockNumber = -2, this._fastBlockNumber = null, this._fastBlockNumberPromise = null, this._fastQueryDate = 0, this._emitted.block = -2, this._maxInternalBlockNumber = -1024, this._internalBlockNumber = null, this.emit("network", t, e), yield k1(0), this._network;
        const n = et.makeError("underlying network changed", H.errors.NETWORK_ERROR, {
          event: "changed",
          network: e,
          detectedNetwork: t
        });
        throw this.emit("error", n), n;
      }
      return e;
    });
  }
  get blockNumber() {
    return this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((e) => {
      this._setFastBlockNumber(e);
    }, (e) => {
    }), this._fastBlockNumber != null ? this._fastBlockNumber : -1;
  }
  get polling() {
    return this._poller != null;
  }
  set polling(e) {
    e && !this._poller ? (this._poller = setInterval(() => {
      this.poll();
    }, this.pollingInterval), this._bootstrapPoll || (this._bootstrapPoll = setTimeout(() => {
      this.poll(), this._bootstrapPoll = setTimeout(() => {
        this._poller || this.poll(), this._bootstrapPoll = null;
      }, this.pollingInterval);
    }, 0))) : !e && this._poller && (clearInterval(this._poller), this._poller = null);
  }
  get pollingInterval() {
    return this._pollingInterval;
  }
  set pollingInterval(e) {
    if (typeof e != "number" || e <= 0 || parseInt(String(e)) != e)
      throw new Error("invalid polling interval");
    this._pollingInterval = e, this._poller && (clearInterval(this._poller), this._poller = setInterval(() => {
      this.poll();
    }, this._pollingInterval));
  }
  _getFastBlockNumber() {
    const e = Qa();
    return e - this._fastQueryDate > 2 * this._pollingInterval && (this._fastQueryDate = e, this._fastBlockNumberPromise = this.getBlockNumber().then((t) => ((this._fastBlockNumber == null || t > this._fastBlockNumber) && (this._fastBlockNumber = t), this._fastBlockNumber))), this._fastBlockNumberPromise;
  }
  _setFastBlockNumber(e) {
    this._fastBlockNumber != null && e < this._fastBlockNumber || (this._fastQueryDate = Qa(), (this._fastBlockNumber == null || e > this._fastBlockNumber) && (this._fastBlockNumber = e, this._fastBlockNumberPromise = Promise.resolve(e)));
  }
  waitForTransaction(e, t, n) {
    return He(this, void 0, void 0, function* () {
      return this._waitForTransaction(e, t ?? 1, n || 0, null);
    });
  }
  _waitForTransaction(e, t, n, i) {
    return He(this, void 0, void 0, function* () {
      const s = yield this.getTransactionReceipt(e);
      return (s ? s.confirmations : 0) >= t ? s : new Promise((a, o) => {
        const l = [];
        let c = !1;
        const u = function() {
          return c ? !0 : (c = !0, l.forEach((p) => {
            p();
          }), !1);
        }, f = (p) => {
          p.confirmations < t || u() || a(p);
        };
        if (this.on(e, f), l.push(() => {
          this.removeListener(e, f);
        }), i) {
          let p = i.startBlock, x = null;
          const T = (v) => He(this, void 0, void 0, function* () {
            c || (yield k1(1e3), this.getTransactionCount(i.from).then((w) => He(this, void 0, void 0, function* () {
              if (!c) {
                if (w <= i.nonce)
                  p = v;
                else {
                  {
                    const E = yield this.getTransaction(e);
                    if (E && E.blockNumber != null)
                      return;
                  }
                  for (x == null && (x = p - 3, x < i.startBlock && (x = i.startBlock)); x <= v; ) {
                    if (c)
                      return;
                    const E = yield this.getBlockWithTransactions(x);
                    for (let C = 0; C < E.transactions.length; C++) {
                      const P = E.transactions[C];
                      if (P.hash === e)
                        return;
                      if (P.from === i.from && P.nonce === i.nonce) {
                        if (c)
                          return;
                        const F = yield this.waitForTransaction(P.hash, t);
                        if (u())
                          return;
                        let k = "replaced";
                        P.data === i.data && P.to === i.to && P.value.eq(i.value) ? k = "repriced" : P.data === "0x" && P.from === P.to && P.value.isZero() && (k = "cancelled"), o(et.makeError("transaction was replaced", H.errors.TRANSACTION_REPLACED, {
                          cancelled: k === "replaced" || k === "cancelled",
                          reason: k,
                          replacement: this._wrapTransaction(P),
                          hash: e,
                          receipt: F
                        }));
                        return;
                      }
                    }
                    x++;
                  }
                }
                c || this.once("block", T);
              }
            }), (w) => {
              c || this.once("block", T);
            }));
          });
          if (c)
            return;
          this.once("block", T), l.push(() => {
            this.removeListener("block", T);
          });
        }
        if (typeof n == "number" && n > 0) {
          const p = setTimeout(() => {
            u() || o(et.makeError("timeout exceeded", H.errors.TIMEOUT, { timeout: n }));
          }, n);
          p.unref && p.unref(), l.push(() => {
            clearTimeout(p);
          });
        }
      });
    });
  }
  getBlockNumber() {
    return He(this, void 0, void 0, function* () {
      return this._getInternalBlockNumber(0);
    });
  }
  getGasPrice() {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const e = yield this.perform("getGasPrice", {});
      try {
        return be.from(e);
      } catch (t) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "getGasPrice",
          result: e,
          error: t
        });
      }
    });
  }
  getBalance(e, t) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield qt({
        address: this._getAddress(e),
        blockTag: this._getBlockTag(t)
      }), i = yield this.perform("getBalance", n);
      try {
        return be.from(i);
      } catch (s) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "getBalance",
          params: n,
          result: i,
          error: s
        });
      }
    });
  }
  getTransactionCount(e, t) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield qt({
        address: this._getAddress(e),
        blockTag: this._getBlockTag(t)
      }), i = yield this.perform("getTransactionCount", n);
      try {
        return be.from(i).toNumber();
      } catch (s) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "getTransactionCount",
          params: n,
          result: i,
          error: s
        });
      }
    });
  }
  getCode(e, t) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield qt({
        address: this._getAddress(e),
        blockTag: this._getBlockTag(t)
      }), i = yield this.perform("getCode", n);
      try {
        return we(i);
      } catch (s) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "getCode",
          params: n,
          result: i,
          error: s
        });
      }
    });
  }
  getStorageAt(e, t, n) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const i = yield qt({
        address: this._getAddress(e),
        blockTag: this._getBlockTag(n),
        position: Promise.resolve(t).then((a) => zo(a))
      }), s = yield this.perform("getStorageAt", i);
      try {
        return we(s);
      } catch (a) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "getStorageAt",
          params: i,
          result: s,
          error: a
        });
      }
    });
  }
  // This should be called by any subclass wrapping a TransactionResponse
  _wrapTransaction(e, t, n) {
    if (t != null && vi(t) !== 32)
      throw new Error("invalid response - sendTransaction");
    const i = e;
    return t != null && e.hash !== t && et.throwError("Transaction hash mismatch from Provider.sendTransaction.", H.errors.UNKNOWN_ERROR, { expectedHash: e.hash, returnedHash: t }), i.wait = (s, a) => He(this, void 0, void 0, function* () {
      s == null && (s = 1), a == null && (a = 0);
      let o;
      s !== 0 && n != null && (o = {
        data: e.data,
        from: e.from,
        nonce: e.nonce,
        to: e.to,
        value: e.value,
        startBlock: n
      });
      const l = yield this._waitForTransaction(e.hash, s, a, o);
      return l == null && s === 0 ? null : (this._emitted["t:" + e.hash] = l.blockNumber, l.status === 0 && et.throwError("transaction failed", H.errors.CALL_EXCEPTION, {
        transactionHash: e.hash,
        transaction: e,
        receipt: l
      }), l);
    }), i;
  }
  sendTransaction(e) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const t = yield Promise.resolve(e).then((s) => we(s)), n = this.formatter.transaction(e);
      n.confirmations == null && (n.confirmations = 0);
      const i = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
      try {
        const s = yield this.perform("sendTransaction", { signedTransaction: t });
        return this._wrapTransaction(n, s, i);
      } catch (s) {
        throw s.transaction = n, s.transactionHash = n.hash, s;
      }
    });
  }
  _getTransactionRequest(e) {
    return He(this, void 0, void 0, function* () {
      const t = yield e, n = {};
      return ["from", "to"].forEach((i) => {
        t[i] != null && (n[i] = Promise.resolve(t[i]).then((s) => s ? this._getAddress(s) : null));
      }), ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((i) => {
        t[i] != null && (n[i] = Promise.resolve(t[i]).then((s) => s ? be.from(s) : null));
      }), ["type"].forEach((i) => {
        t[i] != null && (n[i] = Promise.resolve(t[i]).then((s) => s ?? null));
      }), t.accessList && (n.accessList = this.formatter.accessList(t.accessList)), ["data"].forEach((i) => {
        t[i] != null && (n[i] = Promise.resolve(t[i]).then((s) => s ? we(s) : null));
      }), this.formatter.transactionRequest(yield qt(n));
    });
  }
  _getFilter(e) {
    return He(this, void 0, void 0, function* () {
      e = yield e;
      const t = {};
      return e.address != null && (t.address = this._getAddress(e.address)), ["blockHash", "topics"].forEach((n) => {
        e[n] != null && (t[n] = e[n]);
      }), ["fromBlock", "toBlock"].forEach((n) => {
        e[n] != null && (t[n] = this._getBlockTag(e[n]));
      }), this.formatter.filter(yield qt(t));
    });
  }
  _call(e, t, n) {
    return He(this, void 0, void 0, function* () {
      n >= ik && et.throwError("CCIP read exceeded maximum redirections", H.errors.SERVER_ERROR, {
        redirects: n,
        transaction: e
      });
      const i = e.to, s = yield this.perform("call", { transaction: e, blockTag: t });
      if (n >= 0 && t === "latest" && i != null && s.substring(0, 10) === "0x556f1830" && vi(s) % 32 === 4)
        try {
          const a = Qt(s, 4), o = Qt(a, 0, 32);
          be.from(o).eq(i) || et.throwError("CCIP Read sender did not match", H.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: e,
            data: s
          });
          const l = [], c = be.from(Qt(a, 32, 64)).toNumber(), u = be.from(Qt(a, c, c + 32)).toNumber(), f = Qt(a, c + 32);
          for (let E = 0; E < u; E++) {
            const C = Ol(f, E * 32);
            C == null && et.throwError("CCIP Read contained corrupt URL string", H.errors.CALL_EXCEPTION, {
              name: "OffchainLookup",
              signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
              transaction: e,
              data: s
            }), l.push(C);
          }
          const p = Lo(a, 64);
          be.from(Qt(a, 100, 128)).isZero() || et.throwError("CCIP Read callback selector included junk", H.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: e,
            data: s
          });
          const x = Qt(a, 96, 100), T = Lo(a, 128), v = yield this.ccipReadFetch(e, p, l);
          v == null && et.throwError("CCIP Read disabled or provided no URLs", H.errors.CALL_EXCEPTION, {
            name: "OffchainLookup",
            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
            transaction: e,
            data: s
          });
          const w = {
            to: i,
            data: Kr([x, q2([v, T])])
          };
          return this._call(w, t, n + 1);
        } catch (a) {
          if (a.code === H.errors.SERVER_ERROR)
            throw a;
        }
      try {
        return we(s);
      } catch (a) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "call",
          params: { transaction: e, blockTag: t },
          result: s,
          error: a
        });
      }
    });
  }
  call(e, t) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const n = yield qt({
        transaction: this._getTransactionRequest(e),
        blockTag: this._getBlockTag(t),
        ccipReadEnabled: Promise.resolve(e.ccipReadEnabled)
      });
      return this._call(n.transaction, n.blockTag, n.ccipReadEnabled ? 0 : -1);
    });
  }
  estimateGas(e) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const t = yield qt({
        transaction: this._getTransactionRequest(e)
      }), n = yield this.perform("estimateGas", t);
      try {
        return be.from(n);
      } catch (i) {
        return et.throwError("bad result from backend", H.errors.SERVER_ERROR, {
          method: "estimateGas",
          params: t,
          result: n,
          error: i
        });
      }
    });
  }
  _getAddress(e) {
    return He(this, void 0, void 0, function* () {
      e = yield e, typeof e != "string" && et.throwArgumentError("invalid address or ENS name", "name", e);
      const t = yield this.resolveName(e);
      return t == null && et.throwError("ENS name not configured", H.errors.UNSUPPORTED_OPERATION, {
        operation: `resolveName(${JSON.stringify(e)})`
      }), t;
    });
  }
  _getBlock(e, t) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork(), e = yield e;
      let n = -128;
      const i = {
        includeTransactions: !!t
      };
      if (Ye(e, 32))
        i.blockHash = e;
      else
        try {
          i.blockTag = yield this._getBlockTag(e), Ye(i.blockTag) && (n = parseInt(i.blockTag.substring(2), 16));
        } catch {
          et.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", e);
        }
      return Ps(() => He(this, void 0, void 0, function* () {
        const s = yield this.perform("getBlock", i);
        if (s == null)
          return i.blockHash != null && this._emitted["b:" + i.blockHash] == null || i.blockTag != null && n > this._emitted.block ? null : void 0;
        if (t) {
          let a = null;
          for (let l = 0; l < s.transactions.length; l++) {
            const c = s.transactions[l];
            if (c.blockNumber == null)
              c.confirmations = 0;
            else if (c.confirmations == null) {
              a == null && (a = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval));
              let u = a - c.blockNumber + 1;
              u <= 0 && (u = 1), c.confirmations = u;
            }
          }
          const o = this.formatter.blockWithTransactions(s);
          return o.transactions = o.transactions.map((l) => this._wrapTransaction(l)), o;
        }
        return this.formatter.block(s);
      }), { oncePoll: this });
    });
  }
  getBlock(e) {
    return this._getBlock(e, !1);
  }
  getBlockWithTransactions(e) {
    return this._getBlock(e, !0);
  }
  getTransaction(e) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork(), e = yield e;
      const t = { transactionHash: this.formatter.hash(e, !0) };
      return Ps(() => He(this, void 0, void 0, function* () {
        const n = yield this.perform("getTransaction", t);
        if (n == null)
          return this._emitted["t:" + e] == null ? null : void 0;
        const i = this.formatter.transactionResponse(n);
        if (i.blockNumber == null)
          i.confirmations = 0;
        else if (i.confirmations == null) {
          let a = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - i.blockNumber + 1;
          a <= 0 && (a = 1), i.confirmations = a;
        }
        return this._wrapTransaction(i);
      }), { oncePoll: this });
    });
  }
  getTransactionReceipt(e) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork(), e = yield e;
      const t = { transactionHash: this.formatter.hash(e, !0) };
      return Ps(() => He(this, void 0, void 0, function* () {
        const n = yield this.perform("getTransactionReceipt", t);
        if (n == null)
          return this._emitted["t:" + e] == null ? null : void 0;
        if (n.blockHash == null)
          return;
        const i = this.formatter.receipt(n);
        if (i.blockNumber == null)
          i.confirmations = 0;
        else if (i.confirmations == null) {
          let a = (yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval)) - i.blockNumber + 1;
          a <= 0 && (a = 1), i.confirmations = a;
        }
        return i;
      }), { oncePoll: this });
    });
  }
  getLogs(e) {
    return He(this, void 0, void 0, function* () {
      yield this.getNetwork();
      const t = yield qt({ filter: this._getFilter(e) }), n = yield this.perform("getLogs", t);
      return n.forEach((i) => {
        i.removed == null && (i.removed = !1);
      }), Ce.arrayOf(this.formatter.filterLog.bind(this.formatter))(n);
    });
  }
  getEtherPrice() {
    return He(this, void 0, void 0, function* () {
      return yield this.getNetwork(), this.perform("getEtherPrice", {});
    });
  }
  _getBlockTag(e) {
    return He(this, void 0, void 0, function* () {
      if (e = yield e, typeof e == "number" && e < 0) {
        e % 1 && et.throwArgumentError("invalid BlockTag", "blockTag", e);
        let t = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
        return t += e, t < 0 && (t = 0), this.formatter.blockTag(t);
      }
      return this.formatter.blockTag(e);
    });
  }
  getResolver(e) {
    return He(this, void 0, void 0, function* () {
      let t = e;
      for (; ; ) {
        if (t === "" || t === "." || e !== "eth" && t === "eth")
          return null;
        const n = yield this._getResolver(t, "getResolver");
        if (n != null) {
          const i = new Dd(this, n, e);
          return t !== e && !(yield i.supportsWildcard()) ? null : i;
        }
        t = t.split(".").slice(1).join(".");
      }
    });
  }
  _getResolver(e, t) {
    return He(this, void 0, void 0, function* () {
      t == null && (t = "ENS");
      const n = yield this.getNetwork();
      n.ensAddress || et.throwError("network does not support ENS", H.errors.UNSUPPORTED_OPERATION, { operation: t, network: n.name });
      try {
        const i = yield this.call({
          to: n.ensAddress,
          data: "0x0178b8bf" + xo(e).substring(2)
        });
        return this.formatter.callAddress(i);
      } catch {
      }
      return null;
    });
  }
  resolveName(e) {
    return He(this, void 0, void 0, function* () {
      e = yield e;
      try {
        return Promise.resolve(this.formatter.address(e));
      } catch (n) {
        if (Ye(e))
          throw n;
      }
      typeof e != "string" && et.throwArgumentError("invalid ENS name", "name", e);
      const t = yield this.getResolver(e);
      return t ? yield t.getAddress() : null;
    });
  }
  lookupAddress(e) {
    return He(this, void 0, void 0, function* () {
      e = yield e, e = this.formatter.address(e);
      const t = e.substring(2).toLowerCase() + ".addr.reverse", n = yield this._getResolver(t, "lookupAddress");
      if (n == null)
        return null;
      const i = Ol(yield this.call({
        to: n,
        data: "0x691f3431" + xo(t).substring(2)
      }), 0);
      return (yield this.resolveName(i)) != e ? null : i;
    });
  }
  getAvatar(e) {
    return He(this, void 0, void 0, function* () {
      let t = null;
      if (Ye(e)) {
        const s = this.formatter.address(e).substring(2).toLowerCase() + ".addr.reverse", a = yield this._getResolver(s, "getAvatar");
        if (!a)
          return null;
        t = new Dd(this, a, s);
        try {
          const o = yield t.getAvatar();
          if (o)
            return o.url;
        } catch (o) {
          if (o.code !== H.errors.CALL_EXCEPTION)
            throw o;
        }
        try {
          const o = Ol(yield this.call({
            to: a,
            data: "0x691f3431" + xo(s).substring(2)
          }), 0);
          t = yield this.getResolver(o);
        } catch (o) {
          if (o.code !== H.errors.CALL_EXCEPTION)
            throw o;
          return null;
        }
      } else if (t = yield this.getResolver(e), !t)
        return null;
      const n = yield t.getAvatar();
      return n == null ? null : n.url;
    });
  }
  perform(e, t) {
    return et.throwError(e + " not implemented", H.errors.NOT_IMPLEMENTED, { operation: e });
  }
  _startEvent(e) {
    this.polling = this._events.filter((t) => t.pollable()).length > 0;
  }
  _stopEvent(e) {
    this.polling = this._events.filter((t) => t.pollable()).length > 0;
  }
  _addEventListener(e, t, n) {
    const i = new ok(aa(e), t, n);
    return this._events.push(i), this._startEvent(i), this;
  }
  on(e, t) {
    return this._addEventListener(e, t, !1);
  }
  once(e, t) {
    return this._addEventListener(e, t, !0);
  }
  emit(e, ...t) {
    let n = !1, i = [], s = aa(e);
    return this._events = this._events.filter((a) => a.tag !== s ? !0 : (setTimeout(() => {
      a.listener.apply(this, t);
    }, 0), n = !0, a.once ? (i.push(a), !1) : !0)), i.forEach((a) => {
      this._stopEvent(a);
    }), n;
  }
  listenerCount(e) {
    if (!e)
      return this._events.length;
    let t = aa(e);
    return this._events.filter((n) => n.tag === t).length;
  }
  listeners(e) {
    if (e == null)
      return this._events.map((n) => n.listener);
    let t = aa(e);
    return this._events.filter((n) => n.tag === t).map((n) => n.listener);
  }
  off(e, t) {
    if (t == null)
      return this.removeAllListeners(e);
    const n = [];
    let i = !1, s = aa(e);
    return this._events = this._events.filter((a) => a.tag !== s || a.listener != t || i ? !0 : (i = !0, n.push(a), !1)), n.forEach((a) => {
      this._stopEvent(a);
    }), this;
  }
  removeAllListeners(e) {
    let t = [];
    if (e == null)
      t = this._events, this._events = [];
    else {
      const n = aa(e);
      this._events = this._events.filter((i) => i.tag !== n ? !0 : (t.push(i), !1));
    }
    return t.forEach((n) => {
      this._stopEvent(n);
    }), this;
  }
}
var ki = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const lr = new H(Hr), dk = ["call", "estimateGas"];
function yo(r, e) {
  if (r == null)
    return null;
  if (typeof r.message == "string" && r.message.match("reverted")) {
    const t = Ye(r.data) ? r.data : null;
    if (!e || t)
      return { message: r.message, data: t };
  }
  if (typeof r == "object") {
    for (const t in r) {
      const n = yo(r[t], e);
      if (n)
        return n;
    }
    return null;
  }
  if (typeof r == "string")
    try {
      return yo(JSON.parse(r), e);
    } catch {
    }
  return null;
}
function Z2(r, e, t) {
  const n = t.transaction || t.signedTransaction;
  if (r === "call") {
    const s = yo(e, !0);
    if (s)
      return s.data;
    lr.throwError("missing revert data in call exception; Transaction reverted without a reason string", H.errors.CALL_EXCEPTION, {
      data: "0x",
      transaction: n,
      error: e
    });
  }
  if (r === "estimateGas") {
    let s = yo(e.body, !1);
    s == null && (s = yo(e, !1)), s && lr.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", H.errors.UNPREDICTABLE_GAS_LIMIT, {
      reason: s.message,
      method: r,
      transaction: n,
      error: e
    });
  }
  let i = e.message;
  throw e.code === H.errors.SERVER_ERROR && e.error && typeof e.error.message == "string" ? i = e.error.message : typeof e.body == "string" ? i = e.body : typeof e.responseText == "string" && (i = e.responseText), i = (i || "").toLowerCase(), i.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i) && lr.throwError("insufficient funds for intrinsic transaction cost", H.errors.INSUFFICIENT_FUNDS, {
    error: e,
    method: r,
    transaction: n
  }), i.match(/nonce (is )?too low/i) && lr.throwError("nonce has already been used", H.errors.NONCE_EXPIRED, {
    error: e,
    method: r,
    transaction: n
  }), i.match(/replacement transaction underpriced|transaction gas price.*too low/i) && lr.throwError("replacement fee too low", H.errors.REPLACEMENT_UNDERPRICED, {
    error: e,
    method: r,
    transaction: n
  }), i.match(/only replay-protected/i) && lr.throwError("legacy pre-eip-155 transactions not supported", H.errors.UNSUPPORTED_OPERATION, {
    error: e,
    method: r,
    transaction: n
  }), dk.indexOf(r) >= 0 && i.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/) && lr.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", H.errors.UNPREDICTABLE_GAS_LIMIT, {
    error: e,
    method: r,
    transaction: n
  }), e;
}
function L1(r) {
  return new Promise(function(e) {
    setTimeout(e, r);
  });
}
function fk(r) {
  if (r.error) {
    const e = new Error(r.error.message);
    throw e.code = r.error.code, e.data = r.error.data, e;
  }
  return r.result;
}
function eo(r) {
  return r && r.toLowerCase();
}
const Fd = {};
class Hf extends Vi {
  constructor(e, t, n) {
    if (super(), e !== Fd)
      throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
    ie(this, "provider", t), n == null && (n = 0), typeof n == "string" ? (ie(this, "_address", this.provider.formatter.address(n)), ie(this, "_index", null)) : typeof n == "number" ? (ie(this, "_index", n), ie(this, "_address", null)) : lr.throwArgumentError("invalid address or index", "addressOrIndex", n);
  }
  connect(e) {
    return lr.throwError("cannot alter JSON-RPC Signer connection", H.errors.UNSUPPORTED_OPERATION, {
      operation: "connect"
    });
  }
  connectUnchecked() {
    return new hk(Fd, this.provider, this._address || this._index);
  }
  getAddress() {
    return this._address ? Promise.resolve(this._address) : this.provider.send("eth_accounts", []).then((e) => (e.length <= this._index && lr.throwError("unknown account #" + this._index, H.errors.UNSUPPORTED_OPERATION, {
      operation: "getAddress"
    }), this.provider.formatter.address(e[this._index])));
  }
  sendUncheckedTransaction(e) {
    e = Bt(e);
    const t = this.getAddress().then((n) => (n && (n = n.toLowerCase()), n));
    if (e.gasLimit == null) {
      const n = Bt(e);
      n.from = t, e.gasLimit = this.provider.estimateGas(n);
    }
    return e.to != null && (e.to = Promise.resolve(e.to).then((n) => ki(this, void 0, void 0, function* () {
      if (n == null)
        return null;
      const i = yield this.provider.resolveName(n);
      return i == null && lr.throwArgumentError("provided ENS name resolves to null", "tx.to", n), i;
    }))), qt({
      tx: qt(e),
      sender: t
    }).then(({ tx: n, sender: i }) => {
      n.from != null ? n.from.toLowerCase() !== i && lr.throwArgumentError("from address mismatch", "transaction", e) : n.from = i;
      const s = this.provider.constructor.hexlifyTransaction(n, { from: !0 });
      return this.provider.send("eth_sendTransaction", [s]).then((a) => a, (a) => (typeof a.message == "string" && a.message.match(/user denied/i) && lr.throwError("user rejected transaction", H.errors.ACTION_REJECTED, {
        action: "sendTransaction",
        transaction: n
      }), Z2("sendTransaction", a, s)));
    });
  }
  signTransaction(e) {
    return lr.throwError("signing transactions is unsupported", H.errors.UNSUPPORTED_OPERATION, {
      operation: "signTransaction"
    });
  }
  sendTransaction(e) {
    return ki(this, void 0, void 0, function* () {
      const t = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval), n = yield this.sendUncheckedTransaction(e);
      try {
        return yield Ps(() => ki(this, void 0, void 0, function* () {
          const i = yield this.provider.getTransaction(n);
          if (i !== null)
            return this.provider._wrapTransaction(i, n, t);
        }), { oncePoll: this.provider });
      } catch (i) {
        throw i.transactionHash = n, i;
      }
    });
  }
  signMessage(e) {
    return ki(this, void 0, void 0, function* () {
      const t = typeof e == "string" ? tr(e) : e, n = yield this.getAddress();
      try {
        return yield this.provider.send("personal_sign", [we(t), n.toLowerCase()]);
      } catch (i) {
        throw typeof i.message == "string" && i.message.match(/user denied/i) && lr.throwError("user rejected signing", H.errors.ACTION_REJECTED, {
          action: "signMessage",
          from: n,
          messageData: e
        }), i;
      }
    });
  }
  _legacySignMessage(e) {
    return ki(this, void 0, void 0, function* () {
      const t = typeof e == "string" ? tr(e) : e, n = yield this.getAddress();
      try {
        return yield this.provider.send("eth_sign", [n.toLowerCase(), we(t)]);
      } catch (i) {
        throw typeof i.message == "string" && i.message.match(/user denied/i) && lr.throwError("user rejected signing", H.errors.ACTION_REJECTED, {
          action: "_legacySignMessage",
          from: n,
          messageData: e
        }), i;
      }
    });
  }
  _signTypedData(e, t, n) {
    return ki(this, void 0, void 0, function* () {
      const i = yield Pr.resolveNames(e, t, n, (a) => this.provider.resolveName(a)), s = yield this.getAddress();
      try {
        return yield this.provider.send("eth_signTypedData_v4", [
          s.toLowerCase(),
          JSON.stringify(Pr.getPayload(i.domain, t, i.value))
        ]);
      } catch (a) {
        throw typeof a.message == "string" && a.message.match(/user denied/i) && lr.throwError("user rejected signing", H.errors.ACTION_REJECTED, {
          action: "_signTypedData",
          from: s,
          messageData: { domain: i.domain, types: t, value: i.value }
        }), a;
      }
    });
  }
  unlock(e) {
    return ki(this, void 0, void 0, function* () {
      const t = this.provider, n = yield this.getAddress();
      return t.send("personal_unlockAccount", [n.toLowerCase(), e, null]);
    });
  }
}
class hk extends Hf {
  sendTransaction(e) {
    return this.sendUncheckedTransaction(e).then((t) => ({
      hash: t,
      nonce: null,
      gasLimit: null,
      gasPrice: null,
      data: null,
      value: null,
      chainId: null,
      confirmations: 0,
      from: null,
      wait: (n) => this.provider.waitForTransaction(t, n)
    }));
  }
}
const pk = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0
};
class js extends Ic {
  constructor(e, t) {
    let n = t;
    n == null && (n = new Promise((i, s) => {
      setTimeout(() => {
        this.detectNetwork().then((a) => {
          i(a);
        }, (a) => {
          s(a);
        });
      }, 0);
    })), super(n), e || (e = kr(this.constructor, "defaultUrl")()), typeof e == "string" ? ie(this, "connection", Object.freeze({
      url: e
    })) : ie(this, "connection", Object.freeze(Bt(e))), this._nextId = 42;
  }
  get _cache() {
    return this._eventLoopCache == null && (this._eventLoopCache = {}), this._eventLoopCache;
  }
  static defaultUrl() {
    return "http://localhost:8545";
  }
  detectNetwork() {
    return this._cache.detectNetwork || (this._cache.detectNetwork = this._uncachedDetectNetwork(), setTimeout(() => {
      this._cache.detectNetwork = null;
    }, 0)), this._cache.detectNetwork;
  }
  _uncachedDetectNetwork() {
    return ki(this, void 0, void 0, function* () {
      yield L1(0);
      let e = null;
      try {
        e = yield this.send("eth_chainId", []);
      } catch {
        try {
          e = yield this.send("net_version", []);
        } catch {
        }
      }
      if (e != null) {
        const t = kr(this.constructor, "getNetwork");
        try {
          return t(be.from(e).toNumber());
        } catch (n) {
          return lr.throwError("could not detect network", H.errors.NETWORK_ERROR, {
            chainId: e,
            event: "invalidNetwork",
            serverError: n
          });
        }
      }
      return lr.throwError("could not detect network", H.errors.NETWORK_ERROR, {
        event: "noNetwork"
      });
    });
  }
  getSigner(e) {
    return new Hf(Fd, this, e);
  }
  getUncheckedSigner(e) {
    return this.getSigner(e).connectUnchecked();
  }
  listAccounts() {
    return this.send("eth_accounts", []).then((e) => e.map((t) => this.formatter.address(t)));
  }
  send(e, t) {
    const n = {
      method: e,
      params: t,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    this.emit("debug", {
      action: "request",
      request: Zr(n),
      provider: this
    });
    const i = ["eth_chainId", "eth_blockNumber"].indexOf(e) >= 0;
    if (i && this._cache[e])
      return this._cache[e];
    const s = Wa(this.connection, JSON.stringify(n), fk).then((a) => (this.emit("debug", {
      action: "response",
      request: n,
      response: a,
      provider: this
    }), a), (a) => {
      throw this.emit("debug", {
        action: "response",
        error: a,
        request: n,
        provider: this
      }), a;
    });
    return i && (this._cache[e] = s, setTimeout(() => {
      this._cache[e] = null;
    }, 0)), s;
  }
  prepareRequest(e, t) {
    switch (e) {
      case "getBlockNumber":
        return ["eth_blockNumber", []];
      case "getGasPrice":
        return ["eth_gasPrice", []];
      case "getBalance":
        return ["eth_getBalance", [eo(t.address), t.blockTag]];
      case "getTransactionCount":
        return ["eth_getTransactionCount", [eo(t.address), t.blockTag]];
      case "getCode":
        return ["eth_getCode", [eo(t.address), t.blockTag]];
      case "getStorageAt":
        return ["eth_getStorageAt", [eo(t.address), Dt(t.position, 32), t.blockTag]];
      case "sendTransaction":
        return ["eth_sendRawTransaction", [t.signedTransaction]];
      case "getBlock":
        return t.blockTag ? ["eth_getBlockByNumber", [t.blockTag, !!t.includeTransactions]] : t.blockHash ? ["eth_getBlockByHash", [t.blockHash, !!t.includeTransactions]] : null;
      case "getTransaction":
        return ["eth_getTransactionByHash", [t.transactionHash]];
      case "getTransactionReceipt":
        return ["eth_getTransactionReceipt", [t.transactionHash]];
      case "call":
        return ["eth_call", [kr(this.constructor, "hexlifyTransaction")(t.transaction, { from: !0 }), t.blockTag]];
      case "estimateGas":
        return ["eth_estimateGas", [kr(this.constructor, "hexlifyTransaction")(t.transaction, { from: !0 })]];
      case "getLogs":
        return t.filter && t.filter.address != null && (t.filter.address = eo(t.filter.address)), ["eth_getLogs", [t.filter]];
    }
    return null;
  }
  perform(e, t) {
    return ki(this, void 0, void 0, function* () {
      if (e === "call" || e === "estimateGas") {
        const i = t.transaction;
        if (i && i.type != null && be.from(i.type).isZero() && i.maxFeePerGas == null && i.maxPriorityFeePerGas == null) {
          const s = yield this.getFeeData();
          s.maxFeePerGas == null && s.maxPriorityFeePerGas == null && (t = Bt(t), t.transaction = Bt(i), delete t.transaction.type);
        }
      }
      const n = this.prepareRequest(e, t);
      n == null && lr.throwError(e + " not implemented", H.errors.NOT_IMPLEMENTED, { operation: e });
      try {
        return yield this.send(n[0], n[1]);
      } catch (i) {
        return Z2(e, i, t);
      }
    });
  }
  _startEvent(e) {
    e.tag === "pending" && this._startPending(), super._startEvent(e);
  }
  _startPending() {
    if (this._pendingFilter != null)
      return;
    const e = this, t = this.send("eth_newPendingTransactionFilter", []);
    this._pendingFilter = t, t.then(function(n) {
      function i() {
        e.send("eth_getFilterChanges", [n]).then(function(s) {
          if (e._pendingFilter != t)
            return null;
          let a = Promise.resolve();
          return s.forEach(function(o) {
            e._emitted["t:" + o.toLowerCase()] = "pending", a = a.then(function() {
              return e.getTransaction(o).then(function(l) {
                return e.emit("pending", l), null;
              });
            });
          }), a.then(function() {
            return L1(1e3);
          });
        }).then(function() {
          if (e._pendingFilter != t) {
            e.send("eth_uninstallFilter", [n]);
            return;
          }
          return setTimeout(function() {
            i();
          }, 0), null;
        }).catch((s) => {
        });
      }
      return i(), n;
    }).catch((n) => {
    });
  }
  _stopEvent(e) {
    e.tag === "pending" && this.listenerCount("pending") === 0 && (this._pendingFilter = null), super._stopEvent(e);
  }
  // Convert an ethers.js transaction into a JSON-RPC transaction
  //  - gasLimit => gas
  //  - All values hexlified
  //  - All numeric values zero-striped
  //  - All addresses are lowercased
  // NOTE: This allows a TransactionRequest, but all values should be resolved
  //       before this is called
  // @TODO: This will likely be removed in future versions and prepareRequest
  //        will be the preferred method for this.
  static hexlifyTransaction(e, t) {
    const n = Bt(pk);
    if (t)
      for (const s in t)
        t[s] && (n[s] = !0);
    bf(e, n);
    const i = {};
    return ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function(s) {
      if (e[s] == null)
        return;
      const a = zo(be.from(e[s]));
      s === "gasLimit" && (s = "gas"), i[s] = a;
    }), ["from", "to", "data"].forEach(function(s) {
      e[s] != null && (i[s] = we(e[s]));
    }), e.accessList && (i.accessList = bs(e.accessList)), i;
  }
}
let wo = null;
try {
  if (wo = WebSocket, wo == null)
    throw new Error("inject please");
} catch {
  const e = new H(Hr);
  wo = function() {
    e.throwError("WebSockets not supported in this environment", H.errors.UNSUPPORTED_OPERATION, {
      operation: "new WebSocket()"
    });
  };
}
var Mu = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const gl = new H(Hr);
let mk = 1;
class Cc extends js {
  constructor(e, t) {
    t === "any" && gl.throwError("WebSocketProvider does not support 'any' network yet", H.errors.UNSUPPORTED_OPERATION, {
      operation: "network:any"
    }), typeof e == "string" ? super(e, t) : super("_websocket", t), this._pollingInterval = -1, this._wsReady = !1, typeof e == "string" ? ie(this, "_websocket", new wo(this.connection.url)) : ie(this, "_websocket", e), ie(this, "_requests", {}), ie(this, "_subs", {}), ie(this, "_subIds", {}), ie(this, "_detectNetwork", super.detectNetwork()), this.websocket.onopen = () => {
      this._wsReady = !0, Object.keys(this._requests).forEach((i) => {
        this.websocket.send(this._requests[i].payload);
      });
    }, this.websocket.onmessage = (i) => {
      const s = i.data, a = JSON.parse(s);
      if (a.id != null) {
        const o = String(a.id), l = this._requests[o];
        if (delete this._requests[o], a.result !== void 0)
          l.callback(null, a.result), this.emit("debug", {
            action: "response",
            request: JSON.parse(l.payload),
            response: a.result,
            provider: this
          });
        else {
          let c = null;
          a.error ? (c = new Error(a.error.message || "unknown error"), ie(c, "code", a.error.code || null), ie(c, "response", s)) : c = new Error("unknown error"), l.callback(c, void 0), this.emit("debug", {
            action: "response",
            error: c,
            request: JSON.parse(l.payload),
            provider: this
          });
        }
      } else if (a.method === "eth_subscription") {
        const o = this._subs[a.params.subscription];
        o && o.processFunc(a.params.result);
      } else
        console.warn("this should not happen");
    };
    const n = setInterval(() => {
      this.emit("poll");
    }, 1e3);
    n.unref && n.unref();
  }
  // Cannot narrow the type of _websocket, as that is not backwards compatible
  // so we add a getter and let the WebSocket be a public API.
  get websocket() {
    return this._websocket;
  }
  detectNetwork() {
    return this._detectNetwork;
  }
  get pollingInterval() {
    return 0;
  }
  resetEventsBlock(e) {
    gl.throwError("cannot reset events block on WebSocketProvider", H.errors.UNSUPPORTED_OPERATION, {
      operation: "resetEventBlock"
    });
  }
  set pollingInterval(e) {
    gl.throwError("cannot set polling interval on WebSocketProvider", H.errors.UNSUPPORTED_OPERATION, {
      operation: "setPollingInterval"
    });
  }
  poll() {
    return Mu(this, void 0, void 0, function* () {
      return null;
    });
  }
  set polling(e) {
    e && gl.throwError("cannot set polling on WebSocketProvider", H.errors.UNSUPPORTED_OPERATION, {
      operation: "setPolling"
    });
  }
  send(e, t) {
    const n = mk++;
    return new Promise((i, s) => {
      function a(l, c) {
        return l ? s(l) : i(c);
      }
      const o = JSON.stringify({
        method: e,
        params: t,
        id: n,
        jsonrpc: "2.0"
      });
      this.emit("debug", {
        action: "request",
        request: JSON.parse(o),
        provider: this
      }), this._requests[String(n)] = { callback: a, payload: o }, this._wsReady && this.websocket.send(o);
    });
  }
  static defaultUrl() {
    return "ws://localhost:8546";
  }
  _subscribe(e, t, n) {
    return Mu(this, void 0, void 0, function* () {
      let i = this._subIds[e];
      i == null && (i = Promise.all(t).then((a) => this.send("eth_subscribe", a)), this._subIds[e] = i);
      const s = yield i;
      this._subs[s] = { tag: e, processFunc: n };
    });
  }
  _startEvent(e) {
    switch (e.type) {
      case "block":
        this._subscribe("block", ["newHeads"], (t) => {
          const n = be.from(t.number).toNumber();
          this._emitted.block = n, this.emit("block", n);
        });
        break;
      case "pending":
        this._subscribe("pending", ["newPendingTransactions"], (t) => {
          this.emit("pending", t);
        });
        break;
      case "filter":
        this._subscribe(e.tag, ["logs", this._getFilter(e.filter)], (t) => {
          t.removed == null && (t.removed = !1), this.emit(e.filter, this.formatter.filterLog(t));
        });
        break;
      case "tx": {
        const t = (n) => {
          const i = n.hash;
          this.getTransactionReceipt(i).then((s) => {
            s && this.emit(i, s);
          });
        };
        t(e), this._subscribe("tx", ["newHeads"], (n) => {
          this._events.filter((i) => i.type === "tx").forEach(t);
        });
        break;
      }
      case "debug":
      case "poll":
      case "willPoll":
      case "didPoll":
      case "error":
        break;
      default:
        console.log("unhandled:", e);
        break;
    }
  }
  _stopEvent(e) {
    let t = e.tag;
    if (e.type === "tx") {
      if (this._events.filter((i) => i.type === "tx").length)
        return;
      t = "tx";
    } else if (this.listenerCount(e.event))
      return;
    const n = this._subIds[t];
    n && (delete this._subIds[t], n.then((i) => {
      this._subs[i] && (delete this._subs[i], this.send("eth_unsubscribe", [i]));
    }));
  }
  destroy() {
    return Mu(this, void 0, void 0, function* () {
      this.websocket.readyState === wo.CONNECTING && (yield new Promise((e) => {
        this.websocket.onopen = function() {
          e(!0);
        }, this.websocket.onerror = function() {
          e(!1);
        };
      })), this.websocket.close(1e3);
    });
  }
}
var gk = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const io = new H(Hr);
class J2 extends js {
  detectNetwork() {
    const e = Object.create(null, {
      detectNetwork: { get: () => super.detectNetwork }
    });
    return gk(this, void 0, void 0, function* () {
      let t = this.network;
      return t == null && (t = yield e.detectNetwork.call(this), t || io.throwError("no network detected", H.errors.UNKNOWN_ERROR, {}), this._network == null && (ie(this, "_network", t), this.emit("network", t, null))), t;
    });
  }
}
class $i extends J2 {
  constructor(e, t) {
    io.checkAbstract(new.target, $i), e = kr(new.target, "getNetwork")(e), t = kr(new.target, "getApiKey")(t);
    const n = kr(new.target, "getUrl")(e, t);
    super(n, e), typeof t == "string" ? ie(this, "apiKey", t) : t != null && Object.keys(t).forEach((i) => {
      ie(this, i, t[i]);
    });
  }
  _startPending() {
    io.warn("WARNING: API provider does not support pending filters");
  }
  isCommunityResource() {
    return !1;
  }
  getSigner(e) {
    return io.throwError("API provider does not support signing", H.errors.UNSUPPORTED_OPERATION, { operation: "getSigner" });
  }
  listAccounts() {
    return Promise.resolve([]);
  }
  // Return a defaultApiKey if null, otherwise validate the API key
  static getApiKey(e) {
    return e;
  }
  // Returns the url or connection for the given network and API key. The
  // API key will have been sanitized by the getApiKey first, so any validation
  // or transformations can be done there.
  static getUrl(e, t) {
    return io.throwError("not implemented; sub-classes must override getUrl", H.errors.NOT_IMPLEMENTED, {
      operation: "getUrl"
    });
  }
}
const D1 = new H(Hr), Nl = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class X2 extends Cc {
  constructor(e, t) {
    const n = new Vf(e, t), i = n.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
    super(i, n.network), ie(this, "apiKey", n.apiKey);
  }
  isCommunityResource() {
    return this.apiKey === Nl;
  }
}
class Vf extends $i {
  static getWebSocketProvider(e, t) {
    return new X2(e, t);
  }
  static getApiKey(e) {
    return e == null ? Nl : (e && typeof e != "string" && D1.throwArgumentError("invalid apiKey", "apiKey", e), e);
  }
  static getUrl(e, t) {
    let n = null;
    switch (e.name) {
      case "homestead":
        n = "eth-mainnet.alchemyapi.io/v2/";
        break;
      case "goerli":
        n = "eth-goerli.g.alchemy.com/v2/";
        break;
      case "matic":
        n = "polygon-mainnet.g.alchemy.com/v2/";
        break;
      case "maticmum":
        n = "polygon-mumbai.g.alchemy.com/v2/";
        break;
      case "arbitrum":
        n = "arb-mainnet.g.alchemy.com/v2/";
        break;
      case "arbitrum-goerli":
        n = "arb-goerli.g.alchemy.com/v2/";
        break;
      case "optimism":
        n = "opt-mainnet.g.alchemy.com/v2/";
        break;
      case "optimism-goerli":
        n = "opt-goerli.g.alchemy.com/v2/";
        break;
      default:
        D1.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return {
      allowGzip: !0,
      url: "https://" + n + t,
      throttleCallback: (i, s) => (t === Nl && Go(), Promise.resolve(!0))
    };
  }
  isCommunityResource() {
    return this.apiKey === Nl;
  }
}
const xk = new H(Hr), xl = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function bk(r) {
  switch (r) {
    case "homestead":
      return "rpc.ankr.com/eth/";
    case "ropsten":
      return "rpc.ankr.com/eth_ropsten/";
    case "rinkeby":
      return "rpc.ankr.com/eth_rinkeby/";
    case "goerli":
      return "rpc.ankr.com/eth_goerli/";
    case "matic":
      return "rpc.ankr.com/polygon/";
    case "arbitrum":
      return "rpc.ankr.com/arbitrum/";
  }
  return xk.throwArgumentError("unsupported network", "name", r);
}
class Q2 extends $i {
  isCommunityResource() {
    return this.apiKey === xl;
  }
  static getApiKey(e) {
    return e ?? xl;
  }
  static getUrl(e, t) {
    t == null && (t = xl);
    const n = {
      allowGzip: !0,
      url: "https://" + bk(e.name) + t,
      throttleCallback: (i, s) => (t.apiKey === xl && Go(), Promise.resolve(!0))
    };
    return t.projectSecret != null && (n.user = "", n.password = t.projectSecret), n;
  }
}
var vk = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const F1 = new H(Hr);
class ex extends $i {
  static getApiKey(e) {
    return e != null && F1.throwArgumentError("apiKey not supported for cloudflare", "apiKey", e), null;
  }
  static getUrl(e, t) {
    let n = null;
    switch (e.name) {
      case "homestead":
        n = "https://cloudflare-eth.com/";
        break;
      default:
        F1.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return n;
  }
  perform(e, t) {
    const n = Object.create(null, {
      perform: { get: () => super.perform }
    });
    return vk(this, void 0, void 0, function* () {
      return e === "getBlockNumber" ? (yield n.perform.call(this, "getBlock", { blockTag: "latest" })).number : n.perform.call(this, e, t);
    });
  }
}
var bl = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const as = new H(Hr);
function B1(r) {
  const e = {};
  for (let t in r) {
    if (r[t] == null)
      continue;
    let n = r[t];
    t === "type" && n === 0 || ({ type: !0, gasLimit: !0, gasPrice: !0, maxFeePerGs: !0, maxPriorityFeePerGas: !0, nonce: !0, value: !0 }[t] ? n = zo(we(n)) : t === "accessList" ? n = "[" + bs(n).map((i) => `{address:"${i.address}",storageKeys:["${i.storageKeys.join('","')}"]}`).join(",") + "]" : n = we(n), e[t] = n);
  }
  return e;
}
function yk(r) {
  if (r.status == 0 && (r.message === "No records found" || r.message === "No transactions found"))
    return r.result;
  if (r.status != 1 || typeof r.message != "string" || !r.message.match(/^OK/)) {
    const e = new Error("invalid response");
    throw e.result = JSON.stringify(r), (r.result || "").toLowerCase().indexOf("rate limit") >= 0 && (e.throttleRetry = !0), e;
  }
  return r.result;
}
function j1(r) {
  if (r && r.status == 0 && r.message == "NOTOK" && (r.result || "").toLowerCase().indexOf("rate limit") >= 0) {
    const e = new Error("throttled response");
    throw e.result = JSON.stringify(r), e.throttleRetry = !0, e;
  }
  if (r.jsonrpc != "2.0") {
    const e = new Error("invalid response");
    throw e.result = JSON.stringify(r), e;
  }
  if (r.error) {
    const e = new Error(r.error.message || "unknown error");
    throw r.error.code && (e.code = r.error.code), r.error.data && (e.data = r.error.data), e;
  }
  return r.result;
}
function U1(r) {
  if (r === "pending")
    throw new Error("pending not supported");
  return r === "latest" ? r : parseInt(r.substring(2), 16);
}
function Iu(r, e, t) {
  if (r === "call" && e.code === H.errors.SERVER_ERROR) {
    const i = e.error;
    if (i && (i.message.match(/reverted/i) || i.message.match(/VM execution error/i))) {
      let s = i.data;
      if (s && (s = "0x" + s.replace(/^.*0x/i, "")), Ye(s))
        return s;
      as.throwError("missing revert data in call exception", H.errors.CALL_EXCEPTION, {
        error: e,
        data: "0x"
      });
    }
  }
  let n = e.message;
  throw e.code === H.errors.SERVER_ERROR && (e.error && typeof e.error.message == "string" ? n = e.error.message : typeof e.body == "string" ? n = e.body : typeof e.responseText == "string" && (n = e.responseText)), n = (n || "").toLowerCase(), n.match(/insufficient funds/) && as.throwError("insufficient funds for intrinsic transaction cost", H.errors.INSUFFICIENT_FUNDS, {
    error: e,
    method: r,
    transaction: t
  }), n.match(/same hash was already imported|transaction nonce is too low|nonce too low/) && as.throwError("nonce has already been used", H.errors.NONCE_EXPIRED, {
    error: e,
    method: r,
    transaction: t
  }), n.match(/another transaction with same nonce/) && as.throwError("replacement fee too low", H.errors.REPLACEMENT_UNDERPRICED, {
    error: e,
    method: r,
    transaction: t
  }), n.match(/execution failed due to an exception|execution reverted/) && as.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", H.errors.UNPREDICTABLE_GAS_LIMIT, {
    error: e,
    method: r,
    transaction: t
  }), e;
}
class tx extends Ic {
  constructor(e, t) {
    super(e), ie(this, "baseUrl", this.getBaseUrl()), ie(this, "apiKey", t || null);
  }
  getBaseUrl() {
    switch (this.network ? this.network.name : "invalid") {
      case "homestead":
        return "https://api.etherscan.io";
      case "goerli":
        return "https://api-goerli.etherscan.io";
      case "sepolia":
        return "https://api-sepolia.etherscan.io";
      case "matic":
        return "https://api.polygonscan.com";
      case "maticmum":
        return "https://api-testnet.polygonscan.com";
      case "arbitrum":
        return "https://api.arbiscan.io";
      case "arbitrum-goerli":
        return "https://api-goerli.arbiscan.io";
      case "optimism":
        return "https://api-optimistic.etherscan.io";
      case "optimism-goerli":
        return "https://api-goerli-optimistic.etherscan.io";
    }
    return as.throwArgumentError("unsupported network", "network", this.network.name);
  }
  getUrl(e, t) {
    const n = Object.keys(t).reduce((s, a) => {
      const o = t[a];
      return o != null && (s += `&${a}=${o}`), s;
    }, ""), i = this.apiKey ? `&apikey=${this.apiKey}` : "";
    return `${this.baseUrl}/api?module=${e}${n}${i}`;
  }
  getPostUrl() {
    return `${this.baseUrl}/api`;
  }
  getPostData(e, t) {
    return t.module = e, t.apikey = this.apiKey, t;
  }
  fetch(e, t, n) {
    return bl(this, void 0, void 0, function* () {
      const i = n ? this.getPostUrl() : this.getUrl(e, t), s = n ? this.getPostData(e, t) : null, a = e === "proxy" ? j1 : yk;
      this.emit("debug", {
        action: "request",
        request: i,
        provider: this
      });
      const o = {
        url: i,
        throttleSlotInterval: 1e3,
        throttleCallback: (u, f) => (this.isCommunityResource() && Go(), Promise.resolve(!0))
      };
      let l = null;
      s && (o.headers = { "content-type": "application/x-www-form-urlencoded; charset=UTF-8" }, l = Object.keys(s).map((u) => `${u}=${s[u]}`).join("&"));
      const c = yield Wa(o, l, a || j1);
      return this.emit("debug", {
        action: "response",
        request: i,
        response: Zr(c),
        provider: this
      }), c;
    });
  }
  detectNetwork() {
    return bl(this, void 0, void 0, function* () {
      return this.network;
    });
  }
  perform(e, t) {
    const n = Object.create(null, {
      perform: { get: () => super.perform }
    });
    return bl(this, void 0, void 0, function* () {
      switch (e) {
        case "getBlockNumber":
          return this.fetch("proxy", { action: "eth_blockNumber" });
        case "getGasPrice":
          return this.fetch("proxy", { action: "eth_gasPrice" });
        case "getBalance":
          return this.fetch("account", {
            action: "balance",
            address: t.address,
            tag: t.blockTag
          });
        case "getTransactionCount":
          return this.fetch("proxy", {
            action: "eth_getTransactionCount",
            address: t.address,
            tag: t.blockTag
          });
        case "getCode":
          return this.fetch("proxy", {
            action: "eth_getCode",
            address: t.address,
            tag: t.blockTag
          });
        case "getStorageAt":
          return this.fetch("proxy", {
            action: "eth_getStorageAt",
            address: t.address,
            position: t.position,
            tag: t.blockTag
          });
        case "sendTransaction":
          return this.fetch("proxy", {
            action: "eth_sendRawTransaction",
            hex: t.signedTransaction
          }, !0).catch((i) => Iu("sendTransaction", i, t.signedTransaction));
        case "getBlock":
          if (t.blockTag)
            return this.fetch("proxy", {
              action: "eth_getBlockByNumber",
              tag: t.blockTag,
              boolean: t.includeTransactions ? "true" : "false"
            });
          throw new Error("getBlock by blockHash not implemented");
        case "getTransaction":
          return this.fetch("proxy", {
            action: "eth_getTransactionByHash",
            txhash: t.transactionHash
          });
        case "getTransactionReceipt":
          return this.fetch("proxy", {
            action: "eth_getTransactionReceipt",
            txhash: t.transactionHash
          });
        case "call": {
          if (t.blockTag !== "latest")
            throw new Error("EtherscanProvider does not support blockTag for call");
          const i = B1(t.transaction);
          i.module = "proxy", i.action = "eth_call";
          try {
            return yield this.fetch("proxy", i, !0);
          } catch (s) {
            return Iu("call", s, t.transaction);
          }
        }
        case "estimateGas": {
          const i = B1(t.transaction);
          i.module = "proxy", i.action = "eth_estimateGas";
          try {
            return yield this.fetch("proxy", i, !0);
          } catch (s) {
            return Iu("estimateGas", s, t.transaction);
          }
        }
        case "getLogs": {
          const i = { action: "getLogs" };
          if (t.filter.fromBlock && (i.fromBlock = U1(t.filter.fromBlock)), t.filter.toBlock && (i.toBlock = U1(t.filter.toBlock)), t.filter.address && (i.address = t.filter.address), t.filter.topics && t.filter.topics.length > 0 && (t.filter.topics.length > 1 && as.throwError("unsupported topic count", H.errors.UNSUPPORTED_OPERATION, { topics: t.filter.topics }), t.filter.topics.length === 1)) {
            const o = t.filter.topics[0];
            (typeof o != "string" || o.length !== 66) && as.throwError("unsupported topic format", H.errors.UNSUPPORTED_OPERATION, { topic0: o }), i.topic0 = o;
          }
          const s = yield this.fetch("logs", i);
          let a = {};
          for (let o = 0; o < s.length; o++) {
            const l = s[o];
            if (l.blockHash == null) {
              if (a[l.blockNumber] == null) {
                const c = yield this.getBlock(l.blockNumber);
                c && (a[l.blockNumber] = c.hash);
              }
              l.blockHash = a[l.blockNumber];
            }
          }
          return s;
        }
        case "getEtherPrice":
          return this.network.name !== "homestead" ? 0 : parseFloat((yield this.fetch("stats", { action: "ethprice" })).ethusd);
      }
      return n.perform.call(this, e, t);
    });
  }
  // Note: The `page` page parameter only allows pagination within the
  //       10,000 window available without a page and offset parameter
  //       Error: Result window is too large, PageNo x Offset size must
  //              be less than or equal to 10000
  getHistory(e, t, n) {
    return bl(this, void 0, void 0, function* () {
      const i = {
        action: "txlist",
        address: yield this.resolveName(e),
        startblock: t ?? 0,
        endblock: n ?? 99999999,
        sort: "asc"
      };
      return (yield this.fetch("account", i)).map((a) => {
        ["contractAddress", "to"].forEach(function(l) {
          a[l] == "" && delete a[l];
        }), a.creates == null && a.contractAddress != null && (a.creates = a.contractAddress);
        const o = this.formatter.transactionResponse(a);
        return a.timeStamp && (o.timestamp = parseInt(a.timeStamp)), o;
      });
    });
  }
  isCommunityResource() {
    return this.apiKey == null;
  }
}
var rc = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(a) {
      a(s);
    });
  }
  return new (t || (t = Promise))(function(s, a) {
    function o(u) {
      try {
        c(n.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      u.done ? s(u.value) : i(u.value).then(o, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Is = new H(Hr);
function vl() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function z1(r) {
  let e = null;
  for (let t = 0; t < r.length; t++) {
    const n = r[t];
    if (n == null)
      return null;
    e ? e.name === n.name && e.chainId === n.chainId && (e.ensAddress === n.ensAddress || e.ensAddress == null && n.ensAddress == null) || Is.throwArgumentError("provider mismatch", "networks", r) : e = n;
  }
  return e;
}
function W1(r, e) {
  r = r.slice().sort();
  const t = Math.floor(r.length / 2);
  if (r.length % 2)
    return r[t];
  const n = r[t - 1], i = r[t];
  return e != null && Math.abs(n - i) > e ? null : (n + i) / 2;
}
function xa(r) {
  if (r === null)
    return "null";
  if (typeof r == "number" || typeof r == "boolean")
    return JSON.stringify(r);
  if (typeof r == "string")
    return r;
  if (be.isBigNumber(r))
    return r.toString();
  if (Array.isArray(r))
    return JSON.stringify(r.map((e) => xa(e)));
  if (typeof r == "object") {
    const e = Object.keys(r);
    return e.sort(), "{" + e.map((t) => {
      let n = r[t];
      return typeof n == "function" ? n = "[function]" : n = xa(n), JSON.stringify(t) + ":" + n;
    }).join(",") + "}";
  }
  throw new Error("unknown value type: " + typeof r);
}
let wk = 1;
function H1(r) {
  let e = null, t = null, n = new Promise((a) => {
    e = function() {
      t && (clearTimeout(t), t = null), a();
    }, t = setTimeout(e, r);
  });
  const i = (a) => (n = n.then(a), n);
  function s() {
    return n;
  }
  return { cancel: e, getPromise: s, wait: i };
}
const _k = [
  H.errors.CALL_EXCEPTION,
  H.errors.INSUFFICIENT_FUNDS,
  H.errors.NONCE_EXPIRED,
  H.errors.REPLACEMENT_UNDERPRICED,
  H.errors.UNPREDICTABLE_GAS_LIMIT
], Ek = [
  "address",
  "args",
  "errorArgs",
  "errorSignature",
  "method",
  "transaction"
];
function yl(r, e) {
  const t = {
    weight: r.weight
  };
  return Object.defineProperty(t, "provider", { get: () => r.provider }), r.start && (t.start = r.start), e && (t.duration = e - r.start), r.done && (r.error ? t.error = r.error : t.result = r.result || null), t;
}
function Ak(r, e) {
  return function(t) {
    const n = {};
    t.forEach((s) => {
      const a = r(s.result);
      n[a] || (n[a] = { count: 0, result: s.result }), n[a].count++;
    });
    const i = Object.keys(n);
    for (let s = 0; s < i.length; s++) {
      const a = n[i[s]];
      if (a.count >= e)
        return a.result;
    }
  };
}
function Sk(r, e, t) {
  let n = xa;
  switch (e) {
    case "getBlockNumber":
      return function(i) {
        const s = i.map((o) => o.result);
        let a = W1(i.map((o) => o.result), 2);
        if (a != null)
          return a = Math.ceil(a), s.indexOf(a + 1) >= 0 && a++, a >= r._highestBlockNumber && (r._highestBlockNumber = a), r._highestBlockNumber;
      };
    case "getGasPrice":
      return function(i) {
        const s = i.map((a) => a.result);
        return s.sort(), s[Math.floor(s.length / 2)];
      };
    case "getEtherPrice":
      return function(i) {
        return W1(i.map((s) => s.result));
      };
    case "getBalance":
    case "getTransactionCount":
    case "getCode":
    case "getStorageAt":
    case "call":
    case "estimateGas":
    case "getLogs":
      break;
    case "getTransaction":
    case "getTransactionReceipt":
      n = function(i) {
        return i == null ? null : (i = Bt(i), i.confirmations = -1, xa(i));
      };
      break;
    case "getBlock":
      t.includeTransactions ? n = function(i) {
        return i == null ? null : (i = Bt(i), i.transactions = i.transactions.map((s) => (s = Bt(s), s.confirmations = -1, s)), xa(i));
      } : n = function(i) {
        return i == null ? null : xa(i);
      };
      break;
    default:
      throw new Error("unknown method: " + e);
  }
  return Ak(n, r.quorum);
}
function to(r, e) {
  return rc(this, void 0, void 0, function* () {
    const t = r.provider;
    return t.blockNumber != null && t.blockNumber >= e || e === -1 ? t : Ps(() => new Promise((n, i) => {
      setTimeout(function() {
        return t.blockNumber >= e ? n(t) : r.cancelled ? n(null) : n(void 0);
      }, 0);
    }), { oncePoll: t });
  });
}
function Tk(r, e, t, n) {
  return rc(this, void 0, void 0, function* () {
    let i = r.provider;
    switch (t) {
      case "getBlockNumber":
      case "getGasPrice":
        return i[t]();
      case "getEtherPrice":
        if (i.getEtherPrice)
          return i.getEtherPrice();
        break;
      case "getBalance":
      case "getTransactionCount":
      case "getCode":
        return n.blockTag && Ye(n.blockTag) && (i = yield to(r, e)), i[t](n.address, n.blockTag || "latest");
      case "getStorageAt":
        return n.blockTag && Ye(n.blockTag) && (i = yield to(r, e)), i.getStorageAt(n.address, n.position, n.blockTag || "latest");
      case "getBlock":
        return n.blockTag && Ye(n.blockTag) && (i = yield to(r, e)), i[n.includeTransactions ? "getBlockWithTransactions" : "getBlock"](n.blockTag || n.blockHash);
      case "call":
      case "estimateGas":
        return n.blockTag && Ye(n.blockTag) && (i = yield to(r, e)), t === "call" && n.blockTag ? i[t](n.transaction, n.blockTag) : i[t](n.transaction);
      case "getTransaction":
      case "getTransactionReceipt":
        return i[t](n.transactionHash);
      case "getLogs": {
        let s = n.filter;
        return (s.fromBlock && Ye(s.fromBlock) || s.toBlock && Ye(s.toBlock)) && (i = yield to(r, e)), i.getLogs(s);
      }
    }
    return Is.throwError("unknown method error", H.errors.UNKNOWN_ERROR, {
      method: t,
      params: n
    });
  });
}
class rx extends Ic {
  constructor(e, t) {
    e.length === 0 && Is.throwArgumentError("missing providers", "providers", e);
    const n = e.map((a, o) => {
      if (Ks.isProvider(a)) {
        const u = Ld(a) ? 2e3 : 750;
        return Object.freeze({ provider: a, weight: 1, stallTimeout: u, priority: 1 });
      }
      const l = Bt(a);
      l.priority == null && (l.priority = 1), l.stallTimeout == null && (l.stallTimeout = Ld(a) ? 2e3 : 750), l.weight == null && (l.weight = 1);
      const c = l.weight;
      return (c % 1 || c > 512 || c < 1) && Is.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${o}].weight`, c), Object.freeze(l);
    }), i = n.reduce((a, o) => a + o.weight, 0);
    t == null ? t = i / 2 : t > i && Is.throwArgumentError("quorum will always fail; larger than total weight", "quorum", t);
    let s = z1(n.map((a) => a.provider.network));
    s == null && (s = new Promise((a, o) => {
      setTimeout(() => {
        this.detectNetwork().then(a, o);
      }, 0);
    })), super(s), ie(this, "providerConfigs", Object.freeze(n)), ie(this, "quorum", t), this._highestBlockNumber = -1;
  }
  detectNetwork() {
    return rc(this, void 0, void 0, function* () {
      const e = yield Promise.all(this.providerConfigs.map((t) => t.provider.getNetwork()));
      return z1(e);
    });
  }
  perform(e, t) {
    return rc(this, void 0, void 0, function* () {
      if (e === "sendTransaction") {
        const l = yield Promise.all(this.providerConfigs.map((c) => c.provider.sendTransaction(t.signedTransaction).then((u) => u.hash, (u) => u)));
        for (let c = 0; c < l.length; c++) {
          const u = l[c];
          if (typeof u == "string")
            return u;
        }
        throw l[0];
      }
      this._highestBlockNumber === -1 && e !== "getBlockNumber" && (yield this.getBlockNumber());
      const n = Sk(this, e, t), i = D2(this.providerConfigs.map(Bt));
      i.sort((l, c) => l.priority - c.priority);
      const s = this._highestBlockNumber;
      let a = 0, o = !0;
      for (; ; ) {
        const l = vl();
        let c = i.filter((x) => x.runner && l - x.start < x.stallTimeout).reduce((x, T) => x + T.weight, 0);
        for (; c < this.quorum && a < i.length; ) {
          const x = i[a++], T = wk++;
          x.start = vl(), x.staller = H1(x.stallTimeout), x.staller.wait(() => {
            x.staller = null;
          }), x.runner = Tk(x, s, e, t).then((v) => {
            x.done = !0, x.result = v, this.listenerCount("debug") && this.emit("debug", {
              action: "request",
              rid: T,
              backend: yl(x, vl()),
              request: { method: e, params: Zr(t) },
              provider: this
            });
          }, (v) => {
            x.done = !0, x.error = v, this.listenerCount("debug") && this.emit("debug", {
              action: "request",
              rid: T,
              backend: yl(x, vl()),
              request: { method: e, params: Zr(t) },
              provider: this
            });
          }), this.listenerCount("debug") && this.emit("debug", {
            action: "request",
            rid: T,
            backend: yl(x, null),
            request: { method: e, params: Zr(t) },
            provider: this
          }), c += x.weight;
        }
        const u = [];
        i.forEach((x) => {
          x.done || !x.runner || (u.push(x.runner), x.staller && u.push(x.staller.getPromise()));
        }), u.length && (yield Promise.race(u));
        const f = i.filter((x) => x.done && x.error == null);
        if (f.length >= this.quorum) {
          const x = n(f);
          if (x !== void 0)
            return i.forEach((T) => {
              T.staller && T.staller.cancel(), T.cancelled = !0;
            }), x;
          o || (yield H1(100).getPromise()), o = !1;
        }
        const p = i.reduce((x, T) => {
          if (!T.done || T.error == null)
            return x;
          const v = T.error.code;
          return _k.indexOf(v) >= 0 && (x[v] || (x[v] = { error: T.error, weight: 0 }), x[v].weight += T.weight), x;
        }, {});
        if (Object.keys(p).forEach((x) => {
          const T = p[x];
          if (T.weight < this.quorum)
            return;
          i.forEach((E) => {
            E.staller && E.staller.cancel(), E.cancelled = !0;
          });
          const v = T.error, w = {};
          Ek.forEach((E) => {
            v[E] != null && (w[E] = v[E]);
          }), Is.throwError(v.reason || v.message, x, w);
        }), i.filter((x) => !x.done).length === 0)
          break;
      }
      return i.forEach((l) => {
        l.staller && l.staller.cancel(), l.cancelled = !0;
      }), Is.throwError("failed to meet quorum", H.errors.SERVER_ERROR, {
        method: e,
        params: t,
        //results: configs.map((c) => c.result),
        //errors: configs.map((c) => c.error),
        results: i.map((l) => yl(l)),
        provider: this
      });
    });
  }
}
const nx = null, Rl = new H(Hr), so = "84842078b09946638c03157f83405213";
class ix extends Cc {
  constructor(e, t) {
    const n = new $f(e, t), i = n.connection;
    i.password && Rl.throwError("INFURA WebSocket project secrets unsupported", H.errors.UNSUPPORTED_OPERATION, {
      operation: "InfuraProvider.getWebSocketProvider()"
    });
    const s = i.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
    super(s, e), ie(this, "apiKey", n.projectId), ie(this, "projectId", n.projectId), ie(this, "projectSecret", n.projectSecret);
  }
  isCommunityResource() {
    return this.projectId === so;
  }
}
class $f extends $i {
  static getWebSocketProvider(e, t) {
    return new ix(e, t);
  }
  static getApiKey(e) {
    const t = {
      apiKey: so,
      projectId: so,
      projectSecret: null
    };
    return e == null || (typeof e == "string" ? t.projectId = e : e.projectSecret != null ? (Rl.assertArgument(typeof e.projectId == "string", "projectSecret requires a projectId", "projectId", e.projectId), Rl.assertArgument(typeof e.projectSecret == "string", "invalid projectSecret", "projectSecret", "[REDACTED]"), t.projectId = e.projectId, t.projectSecret = e.projectSecret) : e.projectId && (t.projectId = e.projectId), t.apiKey = t.projectId), t;
  }
  static getUrl(e, t) {
    let n = null;
    switch (e ? e.name : "unknown") {
      case "homestead":
        n = "mainnet.infura.io";
        break;
      case "goerli":
        n = "goerli.infura.io";
        break;
      case "sepolia":
        n = "sepolia.infura.io";
        break;
      case "matic":
        n = "polygon-mainnet.infura.io";
        break;
      case "maticmum":
        n = "polygon-mumbai.infura.io";
        break;
      case "optimism":
        n = "optimism-mainnet.infura.io";
        break;
      case "optimism-goerli":
        n = "optimism-goerli.infura.io";
        break;
      case "arbitrum":
        n = "arbitrum-mainnet.infura.io";
        break;
      case "arbitrum-goerli":
        n = "arbitrum-goerli.infura.io";
        break;
      default:
        Rl.throwError("unsupported network", H.errors.INVALID_ARGUMENT, {
          argument: "network",
          value: e
        });
    }
    const i = {
      allowGzip: !0,
      url: "https://" + n + "/v3/" + t.projectId,
      throttleCallback: (s, a) => (t.projectId === so && Go(), Promise.resolve(!0))
    };
    return t.projectSecret != null && (i.user = "", i.password = t.projectSecret), i;
  }
  isCommunityResource() {
    return this.projectId === so;
  }
}
class Mk extends js {
  send(e, t) {
    const n = {
      method: e,
      params: t,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    this._pendingBatch == null && (this._pendingBatch = []);
    const i = { request: n, resolve: null, reject: null }, s = new Promise((a, o) => {
      i.resolve = a, i.reject = o;
    });
    return this._pendingBatch.push(i), this._pendingBatchAggregator || (this._pendingBatchAggregator = setTimeout(() => {
      const a = this._pendingBatch;
      this._pendingBatch = null, this._pendingBatchAggregator = null;
      const o = a.map((l) => l.request);
      return this.emit("debug", {
        action: "requestBatch",
        request: Zr(o),
        provider: this
      }), Wa(this.connection, JSON.stringify(o)).then((l) => {
        this.emit("debug", {
          action: "response",
          request: o,
          response: l,
          provider: this
        }), a.forEach((c, u) => {
          const f = l[u];
          if (f.error) {
            const p = new Error(f.error.message);
            p.code = f.error.code, p.data = f.error.data, c.reject(p);
          } else
            c.resolve(f.result);
        });
      }, (l) => {
        this.emit("debug", {
          action: "response",
          error: l,
          request: o,
          provider: this
        }), a.forEach((c) => {
          c.reject(l);
        });
      });
    }, 10)), s;
  }
}
const Cu = new H(Hr), Ik = "ETHERS_JS_SHARED";
class sx extends $i {
  static getApiKey(e) {
    return e && typeof e != "string" && Cu.throwArgumentError("invalid apiKey", "apiKey", e), e || Ik;
  }
  static getUrl(e, t) {
    Cu.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
    let n = null;
    switch (e.name) {
      case "homestead":
        n = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
        break;
      case "ropsten":
        n = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
        break;
      case "rinkeby":
        n = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
        break;
      case "goerli":
        n = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
        break;
      case "kovan":
        n = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
        break;
      default:
        Cu.throwArgumentError("unsupported network", "network", arguments[0]);
    }
    return n + "?apiKey=" + t;
  }
}
const V1 = new H(Hr), $1 = "62e1ad51b37b8e00394bda3b";
class ax extends $i {
  static getApiKey(e) {
    const t = {
      applicationId: null,
      loadBalancer: !0,
      applicationSecretKey: null
    };
    return e == null ? t.applicationId = $1 : typeof e == "string" ? t.applicationId = e : e.applicationSecretKey != null ? (t.applicationId = e.applicationId, t.applicationSecretKey = e.applicationSecretKey) : e.applicationId ? t.applicationId = e.applicationId : V1.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", e), t;
  }
  static getUrl(e, t) {
    let n = null;
    switch (e ? e.name : "unknown") {
      case "goerli":
        n = "eth-goerli.gateway.pokt.network";
        break;
      case "homestead":
        n = "eth-mainnet.gateway.pokt.network";
        break;
      case "kovan":
        n = "poa-kovan.gateway.pokt.network";
        break;
      case "matic":
        n = "poly-mainnet.gateway.pokt.network";
        break;
      case "maticmum":
        n = "polygon-mumbai-rpc.gateway.pokt.network";
        break;
      case "rinkeby":
        n = "eth-rinkeby.gateway.pokt.network";
        break;
      case "ropsten":
        n = "eth-ropsten.gateway.pokt.network";
        break;
      default:
        V1.throwError("unsupported network", H.errors.INVALID_ARGUMENT, {
          argument: "network",
          value: e
        });
    }
    const i = `https://${n}/v1/lb/${t.applicationId}`, s = { headers: {}, url: i };
    return t.applicationSecretKey != null && (s.user = "", s.password = t.applicationSecretKey), s;
  }
  isCommunityResource() {
    return this.applicationId === $1;
  }
}
const G1 = new H(Hr);
let Ck = 1;
function K1(r, e) {
  const t = "Web3LegacyFetcher";
  return function(n, i) {
    const s = {
      method: n,
      params: i,
      id: Ck++,
      jsonrpc: "2.0"
    };
    return new Promise((a, o) => {
      this.emit("debug", {
        action: "request",
        fetcher: t,
        request: Zr(s),
        provider: this
      }), e(s, (l, c) => {
        if (l)
          return this.emit("debug", {
            action: "response",
            fetcher: t,
            error: l,
            request: s,
            provider: this
          }), o(l);
        if (this.emit("debug", {
          action: "response",
          fetcher: t,
          request: s,
          response: c,
          provider: this
        }), c.error) {
          const u = new Error(c.error.message);
          return u.code = c.error.code, u.data = c.error.data, o(u);
        }
        a(c.result);
      });
    });
  };
}
function Pk(r) {
  return function(e, t) {
    t == null && (t = []);
    const n = { method: e, params: t };
    return this.emit("debug", {
      action: "request",
      fetcher: "Eip1193Fetcher",
      request: Zr(n),
      provider: this
    }), r.request(n).then((i) => (this.emit("debug", {
      action: "response",
      fetcher: "Eip1193Fetcher",
      request: n,
      response: i,
      provider: this
    }), i), (i) => {
      throw this.emit("debug", {
        action: "response",
        fetcher: "Eip1193Fetcher",
        request: n,
        error: i,
        provider: this
      }), i;
    });
  };
}
class ox extends js {
  constructor(e, t) {
    e == null && G1.throwArgumentError("missing provider", "provider", e);
    let n = null, i = null, s = null;
    typeof e == "function" ? (n = "unknown:", i = e) : (n = e.host || e.path || "", !n && e.isMetaMask && (n = "metamask"), s = e, e.request ? (n === "" && (n = "eip-1193:"), i = Pk(e)) : e.sendAsync ? i = K1(e, e.sendAsync.bind(e)) : e.send ? i = K1(e, e.send.bind(e)) : G1.throwArgumentError("unsupported provider", "provider", e), n || (n = "unknown:")), super(n, t), ie(this, "jsonRpcFetchFunc", i), ie(this, "provider", s);
  }
  send(e, t) {
    return this.jsonRpcFetchFunc(e, t);
  }
}
const Y1 = new H(Hr);
function Gf(r, e) {
  if (r == null && (r = "homestead"), typeof r == "string") {
    const n = r.match(/^(ws|http)s?:/i);
    if (n)
      switch (n[1].toLowerCase()) {
        case "http":
        case "https":
          return new js(r);
        case "ws":
        case "wss":
          return new Cc(r);
        default:
          Y1.throwArgumentError("unsupported URL scheme", "network", r);
      }
  }
  const t = Wf(r);
  return (!t || !t._defaultProvider) && Y1.throwError("unsupported getDefaultProvider network", H.errors.NETWORK_ERROR, {
    operation: "getDefaultProvider",
    network: r
  }), t._defaultProvider({
    FallbackProvider: rx,
    AlchemyProvider: Vf,
    AnkrProvider: Q2,
    CloudflareProvider: ex,
    EtherscanProvider: tx,
    InfuraProvider: $f,
    JsonRpcProvider: js,
    NodesmithProvider: sx,
    PocketProvider: ax,
    Web3Provider: ox,
    IpcProvider: nx
  }, e);
}
const lx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlchemyProvider: Vf,
  AlchemyWebSocketProvider: X2,
  AnkrProvider: Q2,
  BaseProvider: Ic,
  CloudflareProvider: ex,
  EtherscanProvider: tx,
  FallbackProvider: rx,
  Formatter: Ce,
  InfuraProvider: $f,
  InfuraWebSocketProvider: ix,
  IpcProvider: nx,
  JsonRpcBatchProvider: Mk,
  JsonRpcProvider: js,
  JsonRpcSigner: Hf,
  NodesmithProvider: sx,
  PocketProvider: ax,
  Provider: Ks,
  Resolver: Dd,
  StaticJsonRpcProvider: J2,
  UrlJsonRpcProvider: $i,
  Web3Provider: ox,
  WebSocketProvider: Cc,
  getDefaultProvider: Gf,
  getNetwork: Wf,
  isCommunityResourcable: K2,
  isCommunityResource: Ld,
  showThrottleMessage: Go
}, Symbol.toStringTag, { value: "Module" })), kk = "solidity/5.7.0", Ok = new RegExp("^bytes([0-9]+)$"), Nk = new RegExp("^(u?int)([0-9]*)$"), Rk = new RegExp("^(.*)\\[([0-9]*)\\]$"), Lk = "0000000000000000000000000000000000000000000000000000000000000000", fa = new H(kk);
function cx(r, e, t) {
  switch (r) {
    case "address":
      return t ? po(e, 32) : ve(e);
    case "string":
      return tr(e);
    case "bytes":
      return ve(e);
    case "bool":
      return e = e ? "0x01" : "0x00", t ? po(e, 32) : ve(e);
  }
  let n = r.match(Nk);
  if (n) {
    let i = parseInt(n[2] || "256");
    return (n[2] && String(i) !== n[2] || i % 8 !== 0 || i === 0 || i > 256) && fa.throwArgumentError("invalid number type", "type", r), t && (i = 256), e = be.from(e).toTwos(i), po(e, i / 8);
  }
  if (n = r.match(Ok), n) {
    const i = parseInt(n[1]);
    return (String(i) !== n[1] || i === 0 || i > 32) && fa.throwArgumentError("invalid bytes type", "type", r), ve(e).byteLength !== i && fa.throwArgumentError(`invalid value for ${r}`, "value", e), t ? ve((e + Lk).substring(0, 66)) : e;
  }
  if (n = r.match(Rk), n && Array.isArray(e)) {
    const i = n[1];
    parseInt(n[2] || String(e.length)) != e.length && fa.throwArgumentError(`invalid array length for ${r}`, "value", e);
    const a = [];
    return e.forEach(function(o) {
      a.push(cx(i, o, !0));
    }), Lt(a);
  }
  return fa.throwArgumentError("invalid type", "type", r);
}
function Kf(r, e) {
  r.length != e.length && fa.throwArgumentError("wrong number of values; expected ${ types.length }", "values", e);
  const t = [];
  return r.forEach(function(n, i) {
    t.push(cx(n, e[i]));
  }), we(Lt(t));
}
function Dk(r, e) {
  return Nt(Kf(r, e));
}
function Fk(r, e) {
  return Ui(Kf(r, e));
}
const Bk = "units/5.7.0", ux = new H(Bk), dx = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function jk(r) {
  const e = String(r).split(".");
  (e.length > 2 || !e[0].match(/^-?[0-9]*$/) || e[1] && !e[1].match(/^[0-9]*$/) || r === "." || r === "-.") && ux.throwArgumentError("invalid value", "value", r);
  let t = e[0], n = "";
  for (t.substring(0, 1) === "-" && (n = "-", t = t.substring(1)); t.substring(0, 1) === "0"; )
    t = t.substring(1);
  t === "" && (t = "0");
  let i = "";
  for (e.length === 2 && (i = "." + (e[1] || "0")); i.length > 2 && i[i.length - 1] === "0"; )
    i = i.substring(0, i.length - 1);
  const s = [];
  for (; t.length; )
    if (t.length <= 3) {
      s.unshift(t);
      break;
    } else {
      const a = t.length - 3;
      s.unshift(t.substring(a)), t = t.substring(0, a);
    }
  return n + s.join(",") + i;
}
function fx(r, e) {
  if (typeof e == "string") {
    const t = dx.indexOf(e);
    t !== -1 && (e = 3 * t);
  }
  return Ml(r, e ?? 18);
}
function hx(r, e) {
  if (typeof r != "string" && ux.throwArgumentError("value must be a string", "value", r), typeof e == "string") {
    const t = dx.indexOf(e);
    t !== -1 && (e = 3 * t);
  }
  return oi(r, e ?? 18);
}
function Uk(r) {
  return fx(r, 18);
}
function zk(r) {
  return hx(r, 18);
}
const px = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbiCoder: jg,
  ConstructorFragment: Vn,
  ErrorFragment: Ri,
  EventFragment: di,
  FormatTypes: xt,
  Fragment: fi,
  FunctionFragment: $n,
  HDNode: xn,
  Indexed: Yl,
  Interface: Ad,
  LogDescription: Jg,
  Logger: H,
  ParamType: gr,
  RLP: LT,
  SigningKey: Ns,
  get SupportedAlgorithm() {
    return La;
  },
  TransactionDescription: Xg,
  get TransactionTypes() {
    return Pd;
  },
  get UnicodeNormalizationForm() {
    return yi;
  },
  Utf8ErrorFuncs: Fg,
  get Utf8ErrorReason() {
    return sn;
  },
  _TypedDataEncoder: Pr,
  _fetchData: V2,
  _toEscapedUtf8String: iM,
  accessListify: bs,
  arrayify: ve,
  base58: Ra,
  base64: EM,
  checkProperties: bf,
  checkResultErrors: _g,
  commify: jk,
  computeAddress: ds,
  computeHmac: No,
  computePublicKey: Nf,
  concat: Lt,
  deepCopy: Zr,
  defaultAbiCoder: Ug,
  defaultPath: Da,
  defineReadOnly: ie,
  dnsEncode: Kg,
  entropyToMnemonic: Tc,
  fetchJson: Wa,
  formatBytes32String: sM,
  formatEther: Uk,
  formatUnits: fx,
  getAccountPath: yP,
  getAddress: kt,
  getContractAddress: vc,
  getCreate2Address: zT,
  getIcapAddress: UT,
  getJsonWalletAddress: MP,
  getStatic: kr,
  hashMessage: Cf,
  hexConcat: Kr,
  hexDataLength: vi,
  hexDataSlice: Qt,
  hexStripZeros: hg,
  hexValue: zo,
  hexZeroPad: Dt,
  hexlify: we,
  id: cs,
  isAddress: jT,
  isBytes: gs,
  isBytesLike: Uo,
  isHexString: Ye,
  isValidMnemonic: vP,
  isValidName: KM,
  joinSignature: wd,
  keccak256: Nt,
  mnemonicToEntropy: Sc,
  mnemonicToSeed: L2,
  namehash: xo,
  nameprep: vM,
  parseBytes32String: aM,
  parseEther: zk,
  parseTransaction: T2,
  parseUnits: hx,
  poll: Ps,
  randomBytes: ga,
  recoverAddress: $o,
  recoverPublicKey: w2,
  resolveProperties: qt,
  ripemd160: O2,
  serializeTransaction: kd,
  sha256: Ui,
  sha512: uP,
  shallowCopy: Bt,
  shuffled: D2,
  solidityKeccak256: Dk,
  solidityPack: Kf,
  soliditySha256: Fk,
  splitSignature: Vs,
  stripZeros: mi,
  toUtf8Bytes: tr,
  toUtf8CodePoints: Gl,
  toUtf8String: Gs,
  verifyMessage: zP,
  verifyTypedData: WP,
  zeroPad: po
}, Symbol.toStringTag, { value: "Module" })), Yf = "ethers/5.7.2", mx = new H(Yf), gx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseContract: Lf,
  BigNumber: be,
  Contract: Xl,
  ContractFactory: P2,
  FixedNumber: mr,
  Signer: Vi,
  VoidSigner: Ho,
  Wallet: ss,
  Wordlist: qs,
  constants: Rg,
  get errors() {
    return mn;
  },
  getDefaultProvider: Gf,
  logger: mx,
  providers: lx,
  utils: px,
  version: Yf,
  wordlists: Ql
}, Symbol.toStringTag, { value: "Module" }));
try {
  const r = window;
  r._ethers == null && (r._ethers = gx);
} catch {
}
const Wk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseContract: Lf,
  BigNumber: be,
  Contract: Xl,
  ContractFactory: P2,
  FixedNumber: mr,
  Signer: Vi,
  VoidSigner: Ho,
  Wallet: ss,
  Wordlist: qs,
  constants: Rg,
  get errors() {
    return mn;
  },
  ethers: gx,
  getDefaultProvider: Gf,
  logger: mx,
  providers: lx,
  utils: px,
  version: Yf,
  wordlists: Ql
}, Symbol.toStringTag, { value: "Module" }));
export {
  tO as CurrencyFilter,
  Qk as Customizer,
  Xk as locales,
  eO as store
};
(function(){"use strict";try{if(typeof document!="undefined"){var a=document.createElement("style");a.id="scoops",a.appendChild(document.createTextNode('.spinner{animation:rotate 2s linear infinite;z-index:2}.spinner .path{stroke:#9eaa98;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}body{--vc-clr-primary: #000;--vc-clr-secondary: #090f207f;--vc-clr-white: #ffffff;--vc-icn-width: 1.2em;--vc-nav-width: 30px;--vc-nav-height: 30px;--vc-nav-border-radius: 0;--vc-nav-color: var(--vc-clr-primary);--vc-nav-color-hover: var(--vc-clr-secondary);--vc-nav-background: transparent;--vc-pgn-width: 12px;--vc-pgn-height: 4px;--vc-pgn-margin: 4px;--vc-pgn-border-radius: 0;--vc-pgn-background-color: var(--vc-clr-secondary);--vc-pgn-active-color: var(--vc-clr-primary)}.carousel__prev,.carousel__next{box-sizing:content-box;background:var(--vc-nav-background);border-radius:var(--vc-nav-border-radius);width:var(--vc-nav-width);height:var(--vc-nav-height);text-align:center;font-size:var(--vc-nav-height);padding:0;color:var(--vc-nav-color);display:flex;justify-content:center;align-items:center;position:absolute;border:0;cursor:pointer;margin:0 10px;top:50%;transform:translateY(-50%)}.carousel__prev:hover,.carousel__next:hover{color:var(--vc-nav-color-hover)}.carousel__next--disabled,.carousel__prev--disabled{cursor:not-allowed;opacity:.5}.carousel__prev{left:0}.carousel__next{right:0}.carousel--rtl .carousel__prev{left:auto;right:0}.carousel--rtl .carousel__next{right:auto;left:0}.carousel{position:relative;text-align:center;box-sizing:border-box;touch-action:pan-y;overscroll-behavior:none}.carousel.is-dragging{touch-action:none}.carousel *{box-sizing:border-box}.carousel__track{display:flex;padding:0!important;position:relative}.carousel__viewport{overflow:hidden}.carousel__sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.carousel__icon{width:var(--vc-icn-width);height:var(--vc-icn-width);fill:currentColor}.carousel__pagination{display:flex;justify-content:center;list-style:none;line-height:0;margin:10px 0 0}.carousel__pagination-button{display:block;border:0;margin:0;cursor:pointer;padding:var(--vc-pgn-margin);background:transparent}.carousel__pagination-button:after{display:block;content:"";width:var(--vc-pgn-width);height:var(--vc-pgn-height);border-radius:var(--vc-pgn-border-radius);background-color:var(--vc-pgn-background-color)}.carousel__pagination-button:hover:after,.carousel__pagination-button--active:after{background-color:var(--vc-pgn-active-color)}.carousel__slide{scroll-snap-stop:auto;flex-shrink:0;margin:0;position:relative;display:flex;justify-content:center;align-items:center;transform:translateZ(0)}.frame-spinner{animation:rotate 2s linear infinite}.frame-spinner .path{stroke:#9eaa98;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}svg path{transition:d .3s ease-in-out}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}[data-shadow][data-v-1b1b42df]{box-shadow:inset 0 0 1vw #00000080;transform:translateZ(-7px)}[data-background][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99)}[data-frame-top-inner][data-v-1b1b42df]{transform:rotateX(-90deg);transform-origin:50% 0%;box-shadow:inset 0 -3vw 4vw -3vw #0000004d,inset 0 -.7vw 1vw -1.2vw #0009}[data-frame-right-inner][data-v-1b1b42df]{transform:rotateY(-90deg);transform-origin:100% 50%;box-shadow:inset 3vw 0 4vw -3vw #0000004d,inset 7px 0 1vw -1.2vw #0009}[data-frame-bottom-inner][data-v-1b1b42df]{transform:rotateX(90deg);transform-origin:50% 100%;box-shadow:inset 0 3vw 4vw -3vw #0000004d,inset 0 7px 1vw -1.2vw #0009}[data-frame-left-inner][data-v-1b1b42df]{transform:rotateY(90deg);transform-origin:0% 50%;box-shadow:inset -3vw 0 4vw -3vw #0000004d,inset -.7vw 0 1vw -1.2vw #0009}[data-mat-top][data-v-1b1b42df]{transform:rotateX(-90deg) translateY(3px);transform-origin:50% 0%;background:white;box-shadow:inset 0 -.2vw 1vw #0000004d;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-mat-right][data-v-1b1b42df]{transform:rotateY(-90deg) translate(-3px);transform-origin:100% 50%;background:white;box-shadow:inset .2vw 0 1vw #0003;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,0))}[data-mat-bottom][data-v-1b1b42df]{transform:rotateX(90deg) translateY(-3px);transform-origin:50% 100%;background:white;box-shadow:inset 0 .2vw 1vw #0003;background-image:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0))}[data-mat-left][data-v-1b1b42df]{transform:rotateY(90deg) translate(3px);transform-origin:0% 50%;background:white;box-shadow:inset -.2vw 0 1vw #0000001a;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,0))}[data-edge-top][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translateY(-100%) rotateX(90deg);transform-origin:50% 100%}[data-edge-right][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translate(100%) rotateY(90deg);transform-origin:0% 50%}[data-edge-bottom][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translateY(100%) rotateX(-90deg);transform-origin:50% 0%}[data-edge-left][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translate(-100%) rotateY(-90deg);transform-origin:100% 50%}[data-frame-top-outer][data-v-1b1b42df]{transform:rotateX(90deg);transform-origin:50% 100%;box-shadow:inset 0 3vw 4vw -3vw #0000004d,inset 0 .7vw 1vw -1.2vw #0009;background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,0))}[data-frame-right-outer][data-v-1b1b42df]{transform:rotateY(90deg);transform-origin:0% 50%;box-shadow:inset -3vw 0 4vw -3vw #0000004d,inset -.7vw 0 1vw -1.2vw #0009;background-image:linear-gradient(-90deg,rgba(0,0,0,.2),rgba(0,0,0,0)),linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-frame-bottom-outer][data-v-1b1b42df]{transform:rotateX(-90deg);transform-origin:50% 0%;box-shadow:inset 0 -3vw 4vw -3vw #0000004d,inset 0 -.7vw 1vw -1.2vw #0009;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.2)),linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}[data-frame-left-outer][data-v-1b1b42df]{transform:rotateY(-90deg);transform-origin:100% 50%;box-shadow:inset 3vw 0 4vw -3vw #0000004d,inset .7vw 0 1vw -1.2vw #0009;background-image:linear-gradient(90deg,rgba(0,0,0,.2),rgba(0,0,0,0)),linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-mat][data-v-1b1b42df]{transform:translateZ(-3px)}')),document.head.appendChild(a)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
